(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 22888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./da.json": [
		14395,
		4395
	],
	"./de.json": [
		75789,
		5789
	],
	"./en-US.json": [
		59754,
		9754
	],
	"./es.json": [
		48670,
		8670
	],
	"./fr.json": [
		5597,
		5597
	],
	"./it.json": [
		54275,
		4275
	],
	"./nl.json": [
		8894,
		8894
	],
	"./no.json": [
		62961,
		2961
	],
	"./pl.json": [
		28370,
		8370
	],
	"./sv.json": [
		67304,
		7304
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 22888;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 25362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dd": function() { return /* binding */ useModal; }
/* harmony export */ });
/* unused harmony exports reducer, show, hide, remove, create, register, unregister, Provider, ModalDef, antdModal, antdModalV5, antdDrawer, antdDrawerV5, muiDialog, muiDialogV5, bootstrapDialog */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* *********************************************************
 * Copyright 2021 eBay Inc.

 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
*********************************************************** */
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @module NiceModal
 * */

var symModalId = Symbol('NiceModalId');
var initialState = {};
var NiceModalContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialState);
var NiceModalIdContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var MODAL_REGISTRY = {};
var ALREADY_MOUNTED = {};
var uidSeed = 0;
var dispatch = function () {
    throw new Error('No dispatch method detected, did you embed your app with NiceModal.Provider?');
};
var getUid = function () { return "_nice_modal_" + uidSeed++; };
// Modal reducer used in useReducer hook.
var reducer = function (state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'nice-modal/show': {
            var _d = action.payload, modalId = _d.modalId, args = _d.args;
            return __assign(__assign({}, state), (_a = {}, _a[modalId] = __assign(__assign({}, state[modalId]), { id: modalId, args: args, 
                // If modal is not mounted, mount it first then make it visible.
                // There is logic inside HOC wrapper to make it visible after its first mount.
                // This mechanism ensures the entering transition.
                visible: !!ALREADY_MOUNTED[modalId], delayVisible: !ALREADY_MOUNTED[modalId] }), _a));
        }
        case 'nice-modal/hide': {
            var modalId = action.payload.modalId;
            if (!state[modalId])
                return state;
            return __assign(__assign({}, state), (_b = {}, _b[modalId] = __assign(__assign({}, state[modalId]), { visible: false }), _b));
        }
        case 'nice-modal/remove': {
            var modalId = action.payload.modalId;
            var newState = __assign({}, state);
            delete newState[modalId];
            return newState;
        }
        case 'nice-modal/set-flags': {
            var _e = action.payload, modalId = _e.modalId, flags = _e.flags;
            return __assign(__assign({}, state), (_c = {}, _c[modalId] = __assign(__assign({}, state[modalId]), flags), _c));
        }
        default:
            return state;
    }
};
// action creator to show a modal
function showModal(modalId, args) {
    return {
        type: 'nice-modal/show',
        payload: {
            modalId: modalId,
            args: args,
        },
    };
}
// action creator to set flags of a modal
function setModalFlags(modalId, flags) {
    return {
        type: 'nice-modal/set-flags',
        payload: {
            modalId: modalId,
            flags: flags,
        },
    };
}
// action creator to hide a modal
function hideModal(modalId) {
    return {
        type: 'nice-modal/hide',
        payload: {
            modalId: modalId,
        },
    };
}
// action creator to remove a modal
function removeModal(modalId) {
    return {
        type: 'nice-modal/remove',
        payload: {
            modalId: modalId,
        },
    };
}
var modalCallbacks = {};
var hideModalCallbacks = {};
var getModalId = function (modal) {
    if (typeof modal === 'string')
        return modal;
    if (!modal[symModalId]) {
        modal[symModalId] = getUid();
    }
    return modal[symModalId];
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function show(modal, args) {
    var modalId = getModalId(modal);
    if (typeof modal !== 'string' && !MODAL_REGISTRY[modalId]) {
        register(modalId, modal);
    }
    dispatch(showModal(modalId, args));
    if (!modalCallbacks[modalId]) {
        // `!` tell ts that theResolve will be written before it is used
        var theResolve_1;
        // `!` tell ts that theResolve will be written before it is used
        var theReject_1;
        var promise = new Promise(function (resolve, reject) {
            theResolve_1 = resolve;
            theReject_1 = reject;
        });
        modalCallbacks[modalId] = {
            resolve: theResolve_1,
            reject: theReject_1,
            promise: promise,
        };
    }
    return modalCallbacks[modalId].promise;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function hide(modal) {
    var modalId = getModalId(modal);
    dispatch(hideModal(modalId));
    // Should also delete the callback for modal.resolve #35
    delete modalCallbacks[modalId];
    if (!hideModalCallbacks[modalId]) {
        // `!` tell ts that theResolve will be written before it is used
        var theResolve_2;
        // `!` tell ts that theResolve will be written before it is used
        var theReject_2;
        var promise = new Promise(function (resolve, reject) {
            theResolve_2 = resolve;
            theReject_2 = reject;
        });
        hideModalCallbacks[modalId] = {
            resolve: theResolve_2,
            reject: theReject_2,
            promise: promise,
        };
    }
    return hideModalCallbacks[modalId].promise;
}
var remove = function (modalId) {
    dispatch(removeModal(modalId));
    delete modalCallbacks[modalId];
    delete hideModalCallbacks[modalId];
};
var setFlags = function (modalId, flags) {
    dispatch(setModalFlags(modalId, flags));
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useModal(modal, args) {
    var modals = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(NiceModalContext);
    var contextModalId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(NiceModalIdContext);
    var modalId = null;
    var isUseComponent = modal && typeof modal !== 'string';
    if (!modal) {
        modalId = contextModalId;
    }
    else {
        modalId = getModalId(modal);
    }
    // Only if contextModalId doesn't exist
    if (!modalId)
        throw new Error('No modal id found in NiceModal.useModal.');
    var mid = modalId;
    // If use a component directly, register it.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (isUseComponent && !MODAL_REGISTRY[mid]) {
            register(mid, modal, args);
        }
    }, [isUseComponent, mid, modal, args]);
    var modalInfo = modals[mid];
    var showCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (args) { return show(mid, args); }, [mid]);
    var hideCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { return hide(mid); }, [mid]);
    var removeCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { return remove(mid); }, [mid]);
    var resolveCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (args) {
        var _a;
        (_a = modalCallbacks[mid]) === null || _a === void 0 ? void 0 : _a.resolve(args);
        delete modalCallbacks[mid];
    }, [mid]);
    var rejectCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (args) {
        var _a;
        (_a = modalCallbacks[mid]) === null || _a === void 0 ? void 0 : _a.reject(args);
        delete modalCallbacks[mid];
    }, [mid]);
    var resolveHide = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (args) {
        var _a;
        (_a = hideModalCallbacks[mid]) === null || _a === void 0 ? void 0 : _a.resolve(args);
        delete hideModalCallbacks[mid];
    }, [mid]);
    return {
        id: mid,
        args: modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.args,
        visible: !!(modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.visible),
        keepMounted: !!(modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.keepMounted),
        show: showCallback,
        hide: hideCallback,
        remove: removeCallback,
        resolve: resolveCallback,
        reject: rejectCallback,
        resolveHide: resolveHide,
    };
}
var create = function (Comp) {
    return function (_a) {
        var _b;
        var defaultVisible = _a.defaultVisible, keepMounted = _a.keepMounted, id = _a.id, props = __rest(_a, ["defaultVisible", "keepMounted", "id"]);
        var _c = useModal(id), args = _c.args, show = _c.show;
        // If there's modal state, then should mount it.
        var modals = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(NiceModalContext);
        var shouldMount = !!modals[id];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
            // If defaultVisible, show it after mounted.
            if (defaultVisible) {
                show();
            }
            ALREADY_MOUNTED[id] = true;
            return function () {
                delete ALREADY_MOUNTED[id];
            };
        }, [id, show, defaultVisible]);
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
            if (keepMounted)
                setFlags(id, { keepMounted: true });
        }, [id, keepMounted]);
        var delayVisible = (_b = modals[id]) === null || _b === void 0 ? void 0 : _b.delayVisible;
        // If modal.show is called
        //  1. If modal was mounted, should make it visible directly
        //  2. If modal has not been mounted, should mount it first, then make it visible
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
            if (delayVisible) {
                // delayVisible: false => true, it means the modal.show() is called, should show it.
                show(args);
            }
        }, [delayVisible, args, show]);
        if (!shouldMount)
            return null;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(NiceModalIdContext.Provider, { value: id },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(Comp, __assign({}, props, args))));
    };
};
// All registered modals will be rendered in modal placeholder
var register = function (id, comp, props) {
    if (!MODAL_REGISTRY[id]) {
        MODAL_REGISTRY[id] = { comp: comp, props: props };
    }
    else {
        MODAL_REGISTRY[id].props = props;
    }
};
/**
 * Unregister a modal.
 * @param id - The id of the modal.
 */
var unregister = function (id) {
    delete MODAL_REGISTRY[id];
};
// The placeholder component is used to auto render modals when call modal.show()
// When modal.show() is called, it means there've been modal info
var NiceModalPlaceholder = function () {
    var modals = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(NiceModalContext);
    var visibleModalIds = Object.keys(modals).filter(function (id) { return !!modals[id]; });
    visibleModalIds.forEach(function (id) {
        if (!MODAL_REGISTRY[id] && !ALREADY_MOUNTED[id]) {
            console.warn("No modal found for id: " + id + ". Please check the id or if it is registered or declared via JSX.");
            return;
        }
    });
    var toRender = visibleModalIds
        .filter(function (id) { return MODAL_REGISTRY[id]; })
        .map(function (id) { return (__assign({ id: id }, MODAL_REGISTRY[id])); });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, toRender.map(function (t) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.comp, __assign({ key: t.id, id: t.id }, t.props))); })));
};
var InnerContextProvider = function (_a) {
    var children = _a.children;
    var arr = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, initialState);
    var modals = arr[0];
    dispatch = arr[1];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(NiceModalContext.Provider, { value: modals },
        children,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(NiceModalPlaceholder, null)));
};
var Provider = function (_a) {
    var children = _a.children, givenDispatch = _a.dispatch, givenModals = _a.modals;
    if (!givenDispatch || !givenModals) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(InnerContextProvider, null, children);
    }
    dispatch = givenDispatch;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(NiceModalContext.Provider, { value: givenModals },
        children,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(NiceModalPlaceholder, null)));
};
/**
 * Declarative way to register a modal.
 * @param id - The id of the modal.
 * @param component - The modal Component.
 * @returns
 */
var ModalDef = function (_a) {
    var id = _a.id, component = _a.component;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        register(id, component);
        return function () {
            unregister(id);
        };
    }, [id, component]);
    return null;
};
var antdModal = function (modal) {
    return {
        visible: modal.visible,
        onOk: function () { return modal.hide(); },
        onCancel: function () { return modal.hide(); },
        afterClose: function () {
            // Need to resolve before remove
            modal.resolveHide();
            if (!modal.keepMounted)
                modal.remove();
        },
    };
};
var antdModalV5 = function (modal) {
    var _a = antdModal(modal), onOk = _a.onOk, onCancel = _a.onCancel, afterClose = _a.afterClose;
    return {
        open: modal.visible,
        onOk: onOk,
        onCancel: onCancel,
        afterClose: afterClose,
    };
};
var antdDrawer = function (modal) {
    return {
        visible: modal.visible,
        onClose: function () { return modal.hide(); },
        afterVisibleChange: function (v) {
            if (!v) {
                modal.resolveHide();
            }
            !v && !modal.keepMounted && modal.remove();
        },
    };
};
var antdDrawerV5 = function (modal) {
    var _a = antdDrawer(modal), onClose = _a.onClose, afterOpenChange = _a.afterVisibleChange;
    return {
        open: modal.visible,
        onClose: onClose,
        afterOpenChange: afterOpenChange,
    };
};
var muiDialog = function (modal) {
    return {
        open: modal.visible,
        onClose: function () { return modal.hide(); },
        onExited: function () {
            modal.resolveHide();
            !modal.keepMounted && modal.remove();
        },
    };
};
var muiDialogV5 = function (modal) {
    return {
        open: modal.visible,
        onClose: function () { return modal.hide(); },
        TransitionProps: {
            onExited: function () {
                modal.resolveHide();
                !modal.keepMounted && modal.remove();
            },
        },
    };
};
var bootstrapDialog = function (modal) {
    return {
        show: modal.visible,
        onHide: function () { return modal.hide(); },
        onExited: function () {
            modal.resolveHide();
            !modal.keepMounted && modal.remove();
        },
    };
};
var NiceModal = {
    Provider: Provider,
    ModalDef: ModalDef,
    NiceModalContext: NiceModalContext,
    create: create,
    register: register,
    show: show,
    hide: hide,
    remove: remove,
    useModal: useModal,
    reducer: reducer,
    antdModal: antdModal,
    antdDrawer: antdDrawer,
    muiDialog: muiDialog,
    bootstrapDialog: bootstrapDialog,
};
/* harmony default export */ __webpack_exports__["ZP"] = (NiceModal);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 45042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 25687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony exports getMagnitude, repeat, setInternalSlot, setMultiInternalSlots, getInternalSlot, getMultiInternalSlots, isLiteralPart, defineProperty, UNICODE_EXTENSION_SEQUENCE_REGEX */
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') {
        return s.repeat(times);
    }
    var arr = new Array(times);
    for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
    }
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) {
        map.set(pl, Object.create(null));
    }
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
    }
    var slots = map.get(pl);
    if (!slots) {
        throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    }
    return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}


/***/ }),

/***/ 95957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ strategies; },
/* harmony export */   "H": function() { return /* binding */ memoize; }
/* harmony export */ });
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};


/***/ }),

/***/ 56096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wD": function() { return /* reexport */ TYPE; },
  "VG": function() { return /* reexport */ isArgumentElement; },
  "rp": function() { return /* reexport */ isDateElement; },
  "Ii": function() { return /* reexport */ isDateTimeSkeleton; },
  "O4": function() { return /* reexport */ isLiteralElement; },
  "uf": function() { return /* reexport */ isNumberElement; },
  "Wh": function() { return /* reexport */ isNumberSkeleton; },
  "Jo": function() { return /* reexport */ isPluralElement; },
  "yx": function() { return /* reexport */ isPoundElement; },
  "Wi": function() { return /* reexport */ isSelectElement; },
  "HI": function() { return /* reexport */ isTagElement; },
  "pe": function() { return /* reexport */ isTimeElement; },
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: SKELETON_TYPE, _Parser, createLiteralElement, createNumberElement

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var parser_Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0,tslib_es6.__assign)({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = (0,tslib_es6.__assign)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new parser_Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}

// only for testing
var _Parser = (/* unused pure expression or super */ null && (Parser));


/***/ }),

/***/ 88222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ MissingTranslationError; },
/* harmony export */   "OV": function() { return /* binding */ InvalidConfigError; },
/* harmony export */   "Qe": function() { return /* binding */ IntlFormatError; },
/* harmony export */   "X9": function() { return /* binding */ MessageFormatError; },
/* harmony export */   "gb": function() { return /* binding */ MissingDataError; },
/* harmony export */   "wI": function() { return /* binding */ UnsupportedFormatterError; }
/* harmony export */ });
/* unused harmony exports IntlErrorCode, IntlError */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception
            ? exception instanceof Error
                ? exception
                : new Error(String(exception))
            : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
            // @ts-ignore just so we don't need to declare dep on @types/node
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));

var UnsupportedFormatterError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));

var InvalidConfigError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));

var MissingDataError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));

var IntlFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}(IntlError));

var MessageFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError));

var MissingTranslationError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage
            ? "default message (".concat(typeof descriptor.defaultMessage === 'string'
                ? descriptor.defaultMessage
                : descriptor.defaultMessage
                    .map(function (e) { var _a; return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e); })
                    .join(), ")")
            : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));



/***/ }),

/***/ 82644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ filterProps; },
/* harmony export */   "Sn": function() { return /* binding */ createIntlCache; },
/* harmony export */   "TB": function() { return /* binding */ getNamedFormat; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "ax": function() { return /* binding */ createFormatters; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var intl_messageformat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16284);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95957);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88222);




function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return allowlist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var defaultWarnHandler = function (warning) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .memoize */ .H)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getNumberFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .memoize */ .H)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getPluralRules = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .memoize */ .H)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .memoize */ .H)(function (message, locales, overrideFormats, opts) {
            return new intl_messageformat__WEBPACK_IMPORTED_MODULE_2__/* .IntlMessageFormat */ .C(message, locales, overrideFormats, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({ formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                } }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getRelativeTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .memoize */ .H)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .memoize */ .H)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getDisplayNames: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .memoize */ .H)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new _error__WEBPACK_IMPORTED_MODULE_3__/* .UnsupportedFormatterError */ .wI("No ".concat(type, " format named: ").concat(name)));
}


/***/ }),

/***/ 50385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ PrismicRichText_PrismicRichText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@prismicio/richtext/dist/composeSerializers.js
const composeSerializers = (...serializers) => {
  return (...args) => {
    for (let i = 0; i < serializers.length; i++) {
      const serializer = serializers[i];
      if (serializer) {
        const res = serializer(...args);
        if (res != null) {
          return res;
        }
      }
    }
  };
};

//# sourceMappingURL=composeSerializers.js.map

// EXTERNAL MODULE: ./node_modules/@prismicio/types/dist/value/richText.js
var richText = __webpack_require__(32716);
;// CONCATENATED MODULE: ./node_modules/@prismicio/richtext/dist/types.js

const RichTextReversedNodeType = {
  [richText/* RichTextNodeType.listItem */.M.listItem]: "listItem",
  [richText/* RichTextNodeType.oListItem */.M.oListItem]: "oListItem",
  [richText/* RichTextNodeType.list */.M.list]: "list",
  [richText/* RichTextNodeType.oList */.M.oList]: "oList"
};

//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/richtext/dist/wrapMapSerializer.js

const wrapMapSerializer = (mapSerializer) => {
  return (type, node, text, children, key) => {
    const tagSerializer = mapSerializer[RichTextReversedNodeType[type] || type];
    if (tagSerializer) {
      return tagSerializer({
        // @ts-expect-error cannot type check here
        type,
        // @ts-expect-error cannot type check here
        node,
        // @ts-expect-error cannot type check here
        text,
        // @ts-expect-error cannot type check here
        children,
        // @ts-expect-error cannot type check here
        key
      });
    }
  };
};

//# sourceMappingURL=wrapMapSerializer.js.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@prismicio/richtext/dist/asTree.js

const uuid = () => {
  return (++uuid.i).toString();
};
uuid.i = 0;
const asTree = (nodes) => {
  const preparedNodes = prepareNodes(nodes);
  const children = [];
  for (let i = 0; i < preparedNodes.length; i++) {
    children.push(nodeToTreeNode(preparedNodes[i]));
  }
  return {
    key: uuid(),
    children
  };
};
const createTreeNode = (node, children = []) => {
  return {
    key: uuid(),
    type: node.type,
    text: "text" in node ? node.text : void 0,
    node,
    children
  };
};
const createTextTreeNode = (text) => {
  return createTreeNode({
    type: richText/* RichTextNodeType.span */.M.span,
    text,
    spans: []
  });
};
const prepareNodes = (nodes) => {
  const mutNodes = nodes.slice(0);
  for (let i = 0; i < mutNodes.length; i++) {
    const node = mutNodes[i];
    if (node.type === richText/* RichTextNodeType.listItem */.M.listItem || node.type === richText/* RichTextNodeType.oListItem */.M.oListItem) {
      const items = [
        node
      ];
      while (mutNodes[i + 1] && mutNodes[i + 1].type === node.type) {
        items.push(mutNodes[i + 1]);
        mutNodes.splice(i, 1);
      }
      if (node.type === richText/* RichTextNodeType.listItem */.M.listItem) {
        mutNodes[i] = {
          type: richText/* RichTextNodeType.list */.M.list,
          items
        };
      } else {
        mutNodes[i] = {
          type: richText/* RichTextNodeType.oList */.M.oList,
          items
        };
      }
    }
  }
  return mutNodes;
};
const nodeToTreeNode = (node) => {
  if ("text" in node) {
    return createTreeNode(node, textNodeSpansToTreeNodeChildren(node.spans, node));
  }
  if ("items" in node) {
    const children = [];
    for (let i = 0; i < node.items.length; i++) {
      children.push(nodeToTreeNode(node.items[i]));
    }
    return createTreeNode(node, children);
  }
  return createTreeNode(node);
};
const textNodeSpansToTreeNodeChildren = (spans, node, parentSpan) => {
  if (!spans.length) {
    return [createTextTreeNode(node.text)];
  }
  const mutSpans = spans.slice(0);
  mutSpans.sort((a, b) => a.start - b.start || b.end - a.end);
  const children = [];
  for (let i = 0; i < mutSpans.length; i++) {
    const span = mutSpans[i];
    const parentSpanStart = parentSpan && parentSpan.start || 0;
    const spanStart = span.start - parentSpanStart;
    const spanEnd = span.end - parentSpanStart;
    const text = node.text.slice(spanStart, spanEnd);
    const childSpans = [];
    for (let j = i; j < mutSpans.length; j++) {
      const siblingSpan = mutSpans[j];
      if (siblingSpan !== span) {
        if (siblingSpan.start >= span.start && siblingSpan.end <= span.end) {
          childSpans.push(siblingSpan);
          mutSpans.splice(j, 1);
          j--;
        } else if (siblingSpan.start < span.end && siblingSpan.end > span.start) {
          childSpans.push({
            ...siblingSpan,
            end: span.end
          });
          mutSpans[j] = {
            ...siblingSpan,
            start: span.end
          };
        }
      }
    }
    if (i === 0 && spanStart > 0) {
      children.push(createTextTreeNode(node.text.slice(0, spanStart)));
    }
    const spanWithText = { ...span, text };
    children.push(createTreeNode(spanWithText, textNodeSpansToTreeNodeChildren(childSpans, {
      ...node,
      text
    }, span)));
    if (spanEnd < node.text.length) {
      children.push(createTextTreeNode(node.text.slice(spanEnd, mutSpans[i + 1] ? mutSpans[i + 1].start - parentSpanStart : void 0)));
    }
  }
  return children;
};

//# sourceMappingURL=asTree.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/richtext/dist/serialize.js

const serialize = (richTextField, serializer) => {
  return serializeTreeNodes(asTree(richTextField).children, serializer);
};
const serializeTreeNodes = (nodes, serializer) => {
  const serializedTreeNodes = [];
  for (let i = 0; i < nodes.length; i++) {
    const treeNode = nodes[i];
    const serializedTreeNode = serializer(treeNode.type, treeNode.node, treeNode.text, serializeTreeNodes(treeNode.children, serializer), treeNode.key);
    if (serializedTreeNode != null) {
      serializedTreeNodes.push(serializedTreeNode);
    }
  }
  return serializedTreeNodes;
};

//# sourceMappingURL=serialize.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/lib/isInternalURL.js
const isInternalURL = (url) => {
  const isInternal = /^(\/(?!\/)|#)/.test(url);
  const isSpecialLink = !isInternal && !/^https?:\/\//.test(url);
  return isInternal && !isSpecialLink;
};

//# sourceMappingURL=isInternalURL.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/types/value/link.js
const LinkType = {
  Any: "Any",
  Document: "Document",
  Media: "Media",
  Web: "Web"
};

//# sourceMappingURL=link.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/helpers/documentToLinkField.js

const documentToLinkField = (prismicDocument) => {
  var _a;
  return {
    link_type: LinkType.Document,
    id: prismicDocument.id,
    uid: prismicDocument.uid || void 0,
    type: prismicDocument.type,
    tags: prismicDocument.tags,
    lang: prismicDocument.lang,
    url: prismicDocument.url == null ? void 0 : prismicDocument.url,
    slug: (_a = prismicDocument.slugs) == null ? void 0 : _a[0],
    // The REST API does not include a `data` property if the data
    // object is empty.
    //
    // A presence check for `prismicDocument.data` is done to
    // support partial documents. While `documentToLinkField` is
    // not typed to accept partial documents, passing a partial
    // document can happen in untyped projects.
    ...prismicDocument.data && Object.keys(prismicDocument.data).length > 0 ? { data: prismicDocument.data } : {}
  };
};

//# sourceMappingURL=documentToLinkField.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/helpers/asLink.js


const asLink = (linkFieldOrDocument, ...configObjectOrTuple) => {
  if (!linkFieldOrDocument) {
    return null;
  }
  const linkField = (
    // prettier-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
    // TODO: Remove the `prettier-ignore` comment when this bug is fixed.
    "link_type" in linkFieldOrDocument ? linkFieldOrDocument : documentToLinkField(linkFieldOrDocument)
  );
  const [configObjectOrLinkResolver] = configObjectOrTuple;
  let config;
  if (typeof configObjectOrLinkResolver === "function" || configObjectOrLinkResolver == null) {
    config = {
      linkResolver: configObjectOrLinkResolver
    };
  } else {
    config = { ...configObjectOrLinkResolver };
  }
  switch (linkField.link_type) {
    case LinkType.Media:
    case LinkType.Web:
      return "url" in linkField ? linkField.url : null;
    case LinkType.Document: {
      if ("id" in linkField && config.linkResolver) {
        const resolvedURL = config.linkResolver(linkField);
        if (resolvedURL != null) {
          return resolvedURL;
        }
      }
      if ("url" in linkField && linkField.url) {
        return linkField.url;
      }
      return null;
    }
    case LinkType.Any:
    default:
      return null;
  }
};

//# sourceMappingURL=asLink.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/helpers/isFilled.js
const isNonNullish = (input) => {
  return input != null;
};
const isFilled_richText = (field) => {
  if (!isNonNullish(field)) {
    return false;
  } else if (field.length === 1 && "text" in field[0]) {
    return !!field[0].text;
  } else {
    return !!field.length;
  }
};
const imageThumbnail = (thumbnail) => {
  return isNonNullish(thumbnail) && !!thumbnail.url;
};
const isFilled_link = (field) => {
  return isNonNullish(field) && ("id" in field || "url" in field);
};

//# sourceMappingURL=isFilled.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/helpers/asLinkAttrs.js



const asLinkAttrs = (linkFieldOrDocument, config = {}) => {
  if (linkFieldOrDocument && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
  ("link_type" in linkFieldOrDocument ? isFilled_link(linkFieldOrDocument) : linkFieldOrDocument)) {
    const target = (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
      "target" in linkFieldOrDocument ? linkFieldOrDocument.target : void 0
    );
    const rawHref = asLink(linkFieldOrDocument, config.linkResolver);
    const href = rawHref == null ? void 0 : rawHref;
    const isExternal = typeof href === "string" ? !isInternalURL(href) : false;
    const rel = config.rel ? config.rel({ href, isExternal, target }) : isExternal ? "noreferrer" : void 0;
    return {
      href,
      target,
      rel: rel == null ? void 0 : rel
    };
  }
  return {};
};

//# sourceMappingURL=asLinkAttrs.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/lib/isInternalURL.js
const isInternalURL_isInternalURL = (url) => {
  const isInternal = /^(\/(?!\/)|#)/.test(url);
  const isSpecialLink = !isInternal && !/^https?:\/\//.test(url);
  return isInternal && !isSpecialLink;
};

//# sourceMappingURL=isInternalURL.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/react-server/PrismicLink.js
/* provided dependency */ var process = __webpack_require__(83454);






const defaultComponent = "a";
const PrismicLink = react.forwardRef(function PrismicLink2({ field, document: doc, linkResolver, internalComponent, externalComponent, ...restProps }, ref) {
  if (typeof process !== "undefined" && "production" === "development") {}
  const { href: computedHref, rel: computedRel, ...attrs } = asLinkAttrs(field ?? doc, {
    linkResolver,
    rel: typeof restProps.rel === "function" ? restProps.rel : void 0
  });
  let rel = computedRel;
  if ("rel" in restProps && typeof restProps.rel !== "function") {
    rel = restProps.rel;
  }
  const href = ("href" in restProps ? restProps.href : computedHref) || "";
  const InternalComponent = internalComponent || defaultComponent;
  const ExternalComponent = externalComponent || defaultComponent;
  const Component = href && isInternalURL_isInternalURL(href) ? InternalComponent : ExternalComponent;
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Component, { ref, ...attrs, ...restProps, href, rel });
});

//# sourceMappingURL=PrismicLink.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/react-server/PrismicRichText.js
/* provided dependency */ var PrismicRichText_process = __webpack_require__(83454);






const createDefaultSerializer = (args) => wrapMapSerializer({
  heading1: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h1", { children }, key),
  heading2: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h2", { children }, key),
  heading3: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h3", { children }, key),
  heading4: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h4", { children }, key),
  heading5: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h5", { children }, key),
  heading6: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h6", { children }, key),
  paragraph: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("p", { children }, key),
  preformatted: ({ node, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("pre", { children: node.text }, key),
  strong: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("strong", { children }, key),
  em: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("em", { children }, key),
  listItem: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("li", { children }, key),
  oListItem: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("li", { children }, key),
  list: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("ul", { children }, key),
  oList: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("ol", { children }, key),
  image: ({ node, key }) => {
    const img = /* @__PURE__ */ (0,jsx_runtime.jsx)("img", { src: node.url, alt: node.alt ?? void 0, "data-copyright": node.copyright ? node.copyright : void 0 });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("p", { className: "block-img", children: node.linkTo ? /* @__PURE__ */ (0,jsx_runtime.jsx)(PrismicLink, { linkResolver: args.linkResolver, internalComponent: args.internalLinkComponent, externalComponent: args.externalLinkComponent, field: node.linkTo, children: img }) : img }, key);
  },
  embed: ({ node, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("div", { "data-oembed": node.oembed.embed_url, "data-oembed-type": node.oembed.type, "data-oembed-provider": node.oembed.provider_name, dangerouslySetInnerHTML: { __html: node.oembed.html ?? "" } }, key),
  hyperlink: ({ node, children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)(PrismicLink, { field: node.data, linkResolver: args.linkResolver, internalComponent: args.internalLinkComponent, externalComponent: args.externalLinkComponent, children }, key),
  label: ({ node, children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { className: node.data.label, children }, key),
  span: ({ text, key }) => {
    const result = [];
    let i = 0;
    for (const line of text.split("\n")) {
      if (i > 0) {
        result.push(/* @__PURE__ */ (0,jsx_runtime.jsx)("br", {}, `${i}__break`));
      }
      result.push(/* @__PURE__ */ (0,jsx_runtime.jsx)(react.Fragment, { children: line }, `${i}__line`));
      i++;
    }
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(react.Fragment, { children: result }, key);
  }
});
function PrismicRichText({ linkResolver, field, fallback, components, externalLinkComponent, internalLinkComponent, ...restProps }) {
  return react.useMemo(() => {
    if (typeof PrismicRichText_process !== "undefined" && "production" === "development") {}
    if (isFilled_richText(field)) {
      const serializer = composeSerializers(typeof components === "object" ? wrapMapSerializer(components) : components, createDefaultSerializer({
        linkResolver,
        internalLinkComponent,
        externalLinkComponent
      }));
      const serialized = serialize(field, (type, node, text, children, key) => {
        const result = serializer(type, node, text, children, key);
        if (react.isValidElement(result) && result.key == null) {
          return react.cloneElement(result, { key });
        } else {
          return result;
        }
      });
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: serialized });
    } else {
      return fallback != null ? /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: fallback }) : null;
    }
  }, [
    field,
    internalLinkComponent,
    externalLinkComponent,
    components,
    linkResolver,
    fallback
  ]);
}

//# sourceMappingURL=PrismicRichText.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/PrismicProvider.js


const PrismicContext = react.createContext({});
const PrismicProvider = ({ client, linkResolver, richTextComponents, internalLinkComponent, externalLinkComponent, children }) => {
  const value = React.useMemo(() => ({
    client,
    linkResolver,
    richTextComponents,
    internalLinkComponent,
    externalLinkComponent
  }), [
    client,
    linkResolver,
    richTextComponents,
    internalLinkComponent,
    externalLinkComponent
  ]);
  return /* @__PURE__ */ jsx(PrismicContext.Provider, { value, children });
};

//# sourceMappingURL=PrismicProvider.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/usePrismicContext.js


const usePrismicContext = () => {
  return react.useContext(PrismicContext) || {};
};

//# sourceMappingURL=usePrismicContext.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js




const PrismicRichText_PrismicRichText = function PrismicRichText2({ components, ...restProps }) {
  const context = usePrismicContext();
  const serializer = composeSerializers(typeof components === "object" ? wrapMapSerializer(components) : components, typeof context.richTextComponents === "object" ? wrapMapSerializer(context.richTextComponents) : context.richTextComponents);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(PrismicRichText, { components: serializer, internalLinkComponent: context.internalLinkComponent, externalLinkComponent: context.externalLinkComponent, ...restProps });
};

//# sourceMappingURL=PrismicRichText.js.map


/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 70413:
/***/ (function(module) {

"use strict";


/**
 * Used to mark a
 * [React Native `File` substitute]{@link ReactNativeFileSubstitute}
 * in an object tree for [`extractFiles`]{@link extractFiles}. It’s too risky to
 * assume all objects with `uri`, `type` and `name` properties are files to
 * extract.
 * @kind class
 * @name ReactNativeFile
 * @param {ReactNativeFileSubstitute} file A [React Native](https://reactnative.dev) [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File) substitute.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { ReactNativeFile } from 'extract-files';
 * ```
 *
 * ```js
 * import ReactNativeFile from 'extract-files/public/ReactNativeFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { ReactNativeFile } = require('extract-files');
 * ```
 *
 * ```js
 * const ReactNativeFile = require('extract-files/public/ReactNativeFile.js');
 * ```
 * @example <caption>An extractable file in [React Native](https://reactnative.dev).</caption>
 * ```js
 * const file = new ReactNativeFile({
 *   uri: uriFromCameraRoll,
 *   name: 'a.jpg',
 *   type: 'image/jpeg',
 * });
 * ```
 */
module.exports = class ReactNativeFile {
  constructor({ uri, name, type }) {
    this.uri = uri;
    this.name = name;
    this.type = type;
  }
};


/***/ }),

/***/ 7202:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const defaultIsExtractableFile = __webpack_require__(19314);

/**
 * Clones a value, recursively extracting
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob) and
 * [`ReactNativeFile`]{@link ReactNativeFile} instances with their
 * [object paths]{@link ObjectPath}, replacing them with `null`.
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/Filelist) instances
 * are treated as [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File)
 * instance arrays.
 * @kind function
 * @name extractFiles
 * @param {*} value Value (typically an object tree) to extract files from.
 * @param {ObjectPath} [path=''] Prefix for object paths for extracted files.
 * @param {ExtractableFileMatcher} [isExtractableFile=isExtractableFile] The function used to identify extractable files.
 * @returns {ExtractFilesResult} Result.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { extractFiles } from 'extract-files';
 * ```
 *
 * ```js
 * import extractFiles from 'extract-files/public/extractFiles.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { extractFiles } = require('extract-files');
 * ```
 *
 * ```js
 * const extractFiles = require('extract-files/public/extractFiles.js');
 * ```
 * @example <caption>Extract files from an object.</caption>
 * For the following:
 *
 * ```js
 * const file1 = new File(['1'], '1.txt', { type: 'text/plain' });
 * const file2 = new File(['2'], '2.txt', { type: 'text/plain' });
 * const value = {
 *   a: file1,
 *   b: [file1, file2],
 * };
 *
 * const { clone, files } = extractFiles(value, 'prefix');
 * ```
 *
 * `value` remains the same.
 *
 * `clone` is:
 *
 * ```json
 * {
 *   "a": null,
 *   "b": [null, null]
 * }
 * ```
 *
 * `files` is a [`Map`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map) instance containing:
 *
 * | Key     | Value                        |
 * | :------ | :--------------------------- |
 * | `file1` | `['prefix.a', 'prefix.b.0']` |
 * | `file2` | `['prefix.b.1']`             |
 */
module.exports = function extractFiles(
  value,
  path = '',
  isExtractableFile = defaultIsExtractableFile
) {
  // Map of extracted files and their object paths within the input value.
  const files = new Map();

  // Map of arrays and objects recursed within the input value and their clones,
  // for reusing clones of values that are referenced multiple times within the
  // input value.
  const clones = new Map();

  /**
   * Recursively clones the value, extracting files.
   * @kind function
   * @name extractFiles~recurse
   * @param {*} value Value to extract files from.
   * @param {ObjectPath} path Prefix for object paths for extracted files.
   * @param {Set} recursed Recursed arrays and objects for avoiding infinite recursion of circular references within the input value.
   * @returns {*} Clone of the value with files replaced with `null`.
   * @ignore
   */
  function recurse(value, path, recursed) {
    let clone = value;

    if (isExtractableFile(value)) {
      clone = null;

      const filePaths = files.get(value);

      filePaths ? filePaths.push(path) : files.set(value, [path]);
    } else {
      const isList =
        Array.isArray(value) ||
        (typeof FileList !== 'undefined' && value instanceof FileList);
      const isObject = value && value.constructor === Object;

      if (isList || isObject) {
        const hasClone = clones.has(value);

        if (hasClone) clone = clones.get(value);
        else {
          clone = isList ? [] : {};

          clones.set(value, clone);
        }

        if (!recursed.has(value)) {
          const pathPrefix = path ? `${path}.` : '';
          const recursedDeeper = new Set(recursed).add(value);

          if (isList) {
            let index = 0;

            for (const item of value) {
              const itemClone = recurse(
                item,
                pathPrefix + index++,
                recursedDeeper
              );

              if (!hasClone) clone.push(itemClone);
            }
          } else
            for (const key in value) {
              const propertyClone = recurse(
                value[key],
                pathPrefix + key,
                recursedDeeper
              );

              if (!hasClone) clone[key] = propertyClone;
            }
        }
      }
    }

    return clone;
  }

  return {
    clone: recurse(value, path, new Set()),
    files,
  };
};


/***/ }),

/***/ 19314:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ReactNativeFile = __webpack_require__(70413);

/**
 * Checks if a value is an [extractable file]{@link ExtractableFile}.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an [extractable file]{@link ExtractableFile}.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from 'extract-files';
 * ```
 *
 * ```js
 * import isExtractableFile from 'extract-files/public/isExtractableFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require('extract-files');
 * ```
 *
 * ```js
 * const isExtractableFile = require('extract-files/public/isExtractableFile.js');
 * ```
 */
module.exports = function isExtractableFile(value) {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};


/***/ }),

/***/ 89776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { ApolloLink, Observable } = __webpack_require__(42451);
const {
  createSignalIfSupported,
  fallbackHttpConfig,
  parseAndCheckHttpResponse,
  rewriteURIForGET,
  selectHttpOptionsAndBody,
  selectURI,
  serializeFetchParameter,
} = __webpack_require__(85645);
const extractFiles = __webpack_require__(7202);
const formDataAppendFile = __webpack_require__(20463);
const isExtractableFile = __webpack_require__(38212);

/**
 * Creates a
 * [terminating Apollo Link](https://apollographql.com/docs/react/api/link/introduction/#the-terminating-link)
 * for [Apollo Client](https://apollographql.com/docs/react) that fetches a
 * [GraphQL multipart request](https://github.com/jaydenseric/graphql-multipart-request-spec)
 * if the GraphQL variables contain files (by default
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/FileList),
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob), or
 * [`ReactNativeFile`](#class-reactnativefile) instances), or else fetches a
 * regular
 * [GraphQL POST or GET request](https://apollographql.com/docs/apollo-server/requests)
 * (depending on the config and GraphQL operation).
 *
 * Some of the options are similar to the
 * [`createHttpLink` options](https://apollographql.com/docs/react/api/link/apollo-link-http/#httplink-constructor-options).
 * @see [GraphQL multipart request spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
 * @kind function
 * @name createUploadLink
 * @param {object} options Options.
 * @param {string} [options.uri="/graphql"] GraphQL endpoint URI.
 * @param {boolean} [options.useGETForQueries] Should GET be used to fetch queries, if there are no files to upload.
 * @param {ExtractableFileMatcher} [options.isExtractableFile=isExtractableFile] Customizes how files are matched in the GraphQL operation for extraction.
 * @param {class} [options.FormData] [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) implementation to use, defaulting to the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) global.
 * @param {FormDataFileAppender} [options.formDataAppendFile=formDataAppendFile] Customizes how extracted files are appended to the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) instance.
 * @param {Function} [options.fetch] [`fetch`](https://fetch.spec.whatwg.org) implementation to use, defaulting to the [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) global.
 * @param {FetchOptions} [options.fetchOptions] [`fetch` options]{@link FetchOptions}; overridden by upload requirements.
 * @param {string} [options.credentials] Overrides `options.fetchOptions.credentials`.
 * @param {object} [options.headers] Merges with and overrides `options.fetchOptions.headers`.
 * @param {boolean} [options.includeExtensions=false] Toggles sending `extensions` fields to the GraphQL server.
 * @returns {ApolloLink} A [terminating Apollo Link](https://apollographql.com/docs/react/api/link/introduction/#the-terminating-link).
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { createUploadLink } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import createUploadLink from "apollo-upload-client/public/createUploadLink.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { createUploadLink } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const createUploadLink = require("apollo-upload-client/public/createUploadLink.js");
 * ```
 * @example <caption>A basic Apollo Client setup.</caption>
 * ```js
 * import { ApolloClient, InMemoryCache } from "@apollo/client";
 * import createUploadLink from "apollo-upload-client/public/createUploadLink.js";
 *
 * const client = new ApolloClient({
 *   cache: new InMemoryCache(),
 *   link: createUploadLink(),
 * });
 * ```
 */
module.exports = function createUploadLink({
  uri: fetchUri = "/graphql",
  useGETForQueries,
  isExtractableFile: customIsExtractableFile = isExtractableFile,
  FormData: CustomFormData,
  formDataAppendFile: customFormDataAppendFile = formDataAppendFile,
  fetch: customFetch,
  fetchOptions,
  credentials,
  headers,
  includeExtensions,
} = {}) {
  const linkConfig = {
    http: { includeExtensions },
    options: fetchOptions,
    credentials,
    headers,
  };

  return new ApolloLink((operation) => {
    const context = operation.getContext();
    const {
      // Apollo Studio client awareness `name` and `version` can be configured
      // via `ApolloClient` constructor options:
      // https://apollographql.com/docs/studio/client-awareness/#using-apollo-server-and-apollo-client
      clientAwareness: { name, version } = {},
      headers,
    } = context;

    const contextConfig = {
      http: context.http,
      options: context.fetchOptions,
      credentials: context.credentials,
      headers: {
        // Client awareness headers can be overridden by context `headers`.
        ...(name && { "apollographql-client-name": name }),
        ...(version && { "apollographql-client-version": version }),
        ...headers,
      },
    };

    const { options, body } = selectHttpOptionsAndBody(
      operation,
      fallbackHttpConfig,
      linkConfig,
      contextConfig
    );

    const { clone, files } = extractFiles(body, "", customIsExtractableFile);

    let uri = selectURI(operation, fetchUri);

    if (files.size) {
      // Automatically set by `fetch` when the `body` is a `FormData` instance.
      delete options.headers["content-type"];

      // GraphQL multipart request spec:
      // https://github.com/jaydenseric/graphql-multipart-request-spec

      const RuntimeFormData = CustomFormData || FormData;

      const form = new RuntimeFormData();

      form.append("operations", serializeFetchParameter(clone, "Payload"));

      const map = {};
      let i = 0;
      files.forEach((paths) => {
        map[++i] = paths;
      });
      form.append("map", JSON.stringify(map));

      i = 0;
      files.forEach((paths, file) => {
        customFormDataAppendFile(form, ++i, file);
      });

      options.body = form;
    } else {
      if (
        useGETForQueries &&
        // If the operation contains some mutations GET shouldn’t be used.
        !operation.query.definitions.some(
          (definition) =>
            definition.kind === "OperationDefinition" &&
            definition.operation === "mutation"
        )
      )
        options.method = "GET";

      if (options.method === "GET") {
        const { newURI, parseError } = rewriteURIForGET(uri, body);
        if (parseError)
          // Apollo’s `HttpLink` uses `fromError` for this, but it’s not
          // exported from `@apollo/client/link/http`.
          return new Observable((observer) => {
            observer.error(parseError);
          });
        uri = newURI;
      } else options.body = serializeFetchParameter(clone, "Payload");
    }

    const { controller } = createSignalIfSupported();

    if (controller) {
      if (options.signal)
        // Respect the user configured abort controller signal.
        options.signal.aborted
          ? // Signal already aborted, so immediately abort.
            controller.abort()
          : // Signal not already aborted, so setup a listener to abort when it
            // does.
            options.signal.addEventListener(
              "abort",
              () => {
                controller.abort();
              },
              {
                // Prevent a memory leak if the user configured abort controller
                // is long lasting, or controls multiple things.
                once: true,
              }
            );

      options.signal = controller.signal;
    }

    const runtimeFetch = customFetch || fetch;

    return new Observable((observer) => {
      // Used to track if the observable is being cleaned up.
      let cleaningUp;

      runtimeFetch(uri, options)
        .then((response) => {
          // Forward the response on the context.
          operation.setContext({ response });
          return response;
        })
        .then(parseAndCheckHttpResponse(operation))
        .then((result) => {
          observer.next(result);
          observer.complete();
        })
        .catch((error) => {
          // If the observable is being cleaned up, there is no need to call
          // next or error because there are no more subscribers. An error after
          // cleanup begins is likely from the cleanup function aborting the
          // fetch.
          if (!cleaningUp) {
            // For errors such as an invalid fetch URI there will be no GraphQL
            // result with errors or data to forward.
            if (error.result && error.result.errors && error.result.data)
              observer.next(error.result);

            observer.error(error);
          }
        });

      // Cleanup function.
      return () => {
        cleaningUp = true;

        // Abort fetch. It’s ok to signal an abort even when not fetching.
        if (controller) controller.abort();
      };
    });
  });
};


/***/ }),

/***/ 20463:
/***/ (function(module) {

"use strict";


/**
 * The default implementation for [`createUploadLink`]{@link createUploadLink}
 * `options.formDataAppendFile` that uses the standard
 * [`FormData.append`](https://developer.mozilla.org/en-US/docs/Web/API/FormData/append)
 * method.
 * @kind function
 * @name formDataAppendFile
 * @type {FormDataFileAppender}
 * @param {FormData} formData [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) instance to append the specified file to.
 * @param {string} fieldName Field name for the file.
 * @param {*} file File to append.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { formDataAppendFile } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import formDataAppendFile from "apollo-upload-client/public/formDataAppendFile.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { formDataAppendFile } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const formDataAppendFile = require("apollo-upload-client/public/formDataAppendFile.js");
 * ```
 */
module.exports = function formDataAppendFile(formData, fieldName, file) {
  formData.append(fieldName, file, file.name);
};


/***/ }),

/***/ 38212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/**
 * The default implementation for [`createUploadLink`]{@link createUploadLink}
 * `options.isExtractableFile`.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an extractable file.
 * @see [`extract-files` `isExtractableFile` docs](https://github.com/jaydenseric/extract-files#function-isextractablefile).
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import isExtractableFile from "apollo-upload-client/public/isExtractableFile.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const isExtractableFile = require("apollo-upload-client/public/isExtractableFile.js");
 * ```
 */
module.exports = __webpack_require__(19314);


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 37811:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */
var PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g // eslint-disable-line no-control-regex
var TEXT_REGEXP = /^[\u000b\u0020-\u007e\u0080-\u00ff]+$/ // eslint-disable-line no-control-regex
var TOKEN_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/

/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */
var QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g // eslint-disable-line no-control-regex

/**
 * RegExp to match chars that must be quoted-pair in RFC 7230 sec 3.2.6
 */
var QUOTE_REGEXP = /([\\"])/g

/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */
var TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/

/**
 * Module exports.
 * @public
 */

__webpack_unused_export__ = format
exports.Q = parse

/**
 * Format object to media type.
 *
 * @param {object} obj
 * @return {string}
 * @public
 */

function format (obj) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('argument obj is required')
  }

  var parameters = obj.parameters
  var type = obj.type

  if (!type || !TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid type')
  }

  var string = type

  // append parameters
  if (parameters && typeof parameters === 'object') {
    var param
    var params = Object.keys(parameters).sort()

    for (var i = 0; i < params.length; i++) {
      param = params[i]

      if (!TOKEN_REGEXP.test(param)) {
        throw new TypeError('invalid parameter name')
      }

      string += '; ' + param + '=' + qstring(parameters[param])
    }
  }

  return string
}

/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */

function parse (string) {
  if (!string) {
    throw new TypeError('argument string is required')
  }

  // support req/res-like objects as argument
  var header = typeof string === 'object'
    ? getcontenttype(string)
    : string

  if (typeof header !== 'string') {
    throw new TypeError('argument string is required to be a string')
  }

  var index = header.indexOf(';')
  var type = index !== -1
    ? header.slice(0, index).trim()
    : header.trim()

  if (!TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid media type')
  }

  var obj = new ContentType(type.toLowerCase())

  // parse parameters
  if (index !== -1) {
    var key
    var match
    var value

    PARAM_REGEXP.lastIndex = index

    while ((match = PARAM_REGEXP.exec(header))) {
      if (match.index !== index) {
        throw new TypeError('invalid parameter format')
      }

      index += match[0].length
      key = match[1].toLowerCase()
      value = match[2]

      if (value.charCodeAt(0) === 0x22 /* " */) {
        // remove quotes
        value = value.slice(1, -1)

        // remove escapes
        if (value.indexOf('\\') !== -1) {
          value = value.replace(QESC_REGEXP, '$1')
        }
      }

      obj.parameters[key] = value
    }

    if (index !== header.length) {
      throw new TypeError('invalid parameter format')
    }
  }

  return obj
}

/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */

function getcontenttype (obj) {
  var header

  if (typeof obj.getHeader === 'function') {
    // res-like
    header = obj.getHeader('content-type')
  } else if (typeof obj.headers === 'object') {
    // req-like
    header = obj.headers && obj.headers['content-type']
  }

  if (typeof header !== 'string') {
    throw new TypeError('content-type header is missing from object')
  }

  return header
}

/**
 * Quote a string if necessary.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function qstring (val) {
  var str = String(val)

  // no need to quote tokens
  if (TOKEN_REGEXP.test(str)) {
    return str
  }

  if (str.length > 0 && !TEXT_REGEXP.test(str)) {
    throw new TypeError('invalid parameter value')
  }

  return '"' + str.replace(QUOTE_REGEXP, '\\$1') + '"'
}

/**
 * Class to represent a content type.
 * @private
 */
function ContentType (type) {
  this.parameters = Object.create(null)
  this.type = type
}


/***/ }),

/***/ 22865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ lib; },
  "J9": function() { return /* binding */ disableExperimentalFragmentVariables; },
  "_t": function() { return /* binding */ disableFragmentWarnings; },
  "wO": function() { return /* binding */ enableExperimentalFragmentVariables; },
  "Ps": function() { return /* binding */ gql; },
  "HW": function() { return /* binding */ resetCaches; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}

// EXTERNAL MODULE: ./node_modules/graphql/polyfills/symbols.mjs
var symbols = __webpack_require__(99763);
;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs
function GraphQLError_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { GraphQLError_typeof = function _typeof(obj) { return typeof obj; }; } else { GraphQLError_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return GraphQLError_typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (GraphQLError_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message);
    _this.name = 'GraphQLError';
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.

    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined);
    var nodeLocations = [];

    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;

      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;

      if (loc != null) {
        nodeLocations.push(loc);
      }
    }

    nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.

    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function (loc) {
      return loc.start;
    });
    _this.locations = positions && source ? positions.map(function (pos) {
      return getLocation(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function (loc) {
      return getLocation(loc.source, loc.start);
    });
    _this.path = path !== null && path !== void 0 ? path : undefined;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;

    if (extensions == null && isObjectLike(originalExtensions)) {
      _this.extensions = _objectSpread({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    } // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
    // This ensures that the simplest possible GraphQL service adheres to the spec.


    Object.defineProperties(_assertThisInitialized(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: symbols/* SYMBOL_TO_STRING_TAG */.YF,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/graphql/language/ast.mjs + 2 modules
var ast = __webpack_require__(29749);
;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

// EXTERNAL MODULE: ./node_modules/graphql/language/source.mjs + 2 modules
var language_source = __webpack_require__(56887);
;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs




/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return kind === tokenKind_TokenKind.BANG || kind === tokenKind_TokenKind.DOLLAR || kind === tokenKind_TokenKind.AMP || kind === tokenKind_TokenKind.PAREN_L || kind === tokenKind_TokenKind.PAREN_R || kind === tokenKind_TokenKind.SPREAD || kind === tokenKind_TokenKind.COLON || kind === tokenKind_TokenKind.EQUALS || kind === tokenKind_TokenKind.AT || kind === tokenKind_TokenKind.BRACKET_L || kind === tokenKind_TokenKind.BRACKET_R || kind === tokenKind_TokenKind.BRACE_L || kind === tokenKind_TokenKind.PIPE || kind === tokenKind_TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? tokenKind_TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new ast/* Token */.WU(tokenKind_TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new ast/* Token */.WU(tokenKind_TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new ast/* Token */.WU(tokenKind_TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new ast/* Token */.WU(tokenKind_TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new ast/* Token */.WU(tokenKind_TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new ast/* Token */.WU(tokenKind_TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new ast/* Token */.WU(tokenKind_TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new ast/* Token */.WU(tokenKind_TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new ast/* Token */.WU(tokenKind_TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new ast/* Token */.WU(tokenKind_TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw syntaxError(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new ast/* Token */.WU(tokenKind_TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new ast/* Token */.WU(tokenKind_TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new ast/* Token */.WU(isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new ast/* Token */.WU(tokenKind_TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new ast/* Token */.WU(tokenKind_TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0,blockString/* dedentBlockStringValue */.W7)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new ast/* Token */.WU(tokenKind_TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = (0,language_source/* isSource */.T)(source) ? source : new language_source/* Source */.H(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(tokenKind_TokenKind.NAME);
    return {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(tokenKind_TokenKind.SOF, this.parseDefinition, tokenKind_TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(tokenKind_TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseVariableDefinition, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(tokenKind_TokenKind.BRACE_L, this.parseSelection, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(tokenKind_TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: kinds/* Kind.NULL */.h.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case tokenKind_TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);
    return {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(tokenKind_TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.AMP) || this.peek(tokenKind_TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(tokenKind_TokenKind.BRACE_L) && this._lexer.lookahead().kind === tokenKind_TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseFieldDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseInputValueDef, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseEnumValueDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseInputValueDef, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new ast/* Location */.Ye(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? "\"".concat(kind, "\"") : kind;
}

;// CONCATENATED MODULE: ./node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 65822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printError = printError;
exports.GraphQLError = void 0;

var _isObjectLike = _interopRequireDefault(__webpack_require__(25690));

var _symbols = __webpack_require__(93098);

var _location = __webpack_require__(39016);

var _printLocation = __webpack_require__(38038);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */
var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message);
    _this.name = 'GraphQLError';
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.

    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined);
    var nodeLocations = [];

    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;

      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;

      if (loc != null) {
        nodeLocations.push(loc);
      }
    }

    nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.

    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function (loc) {
      return loc.start;
    });
    _this.locations = positions && source ? positions.map(function (pos) {
      return (0, _location.getLocation)(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function (loc) {
      return (0, _location.getLocation)(loc.source, loc.start);
    });
    _this.path = path !== null && path !== void 0 ? path : undefined;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;

    if (extensions == null && (0, _isObjectLike.default)(originalExtensions)) {
      _this.extensions = _objectSpread({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    } // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
    // This ensures that the simplest possible GraphQL service adheres to the spec.


    Object.defineProperties(_assertThisInitialized(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: _symbols.SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.GraphQLError = GraphQLError;

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];

      if (node.loc) {
        output += '\n\n' + (0, _printLocation.printLocation)(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += '\n\n' + (0, _printLocation.printSourceLocation)(error.source, location);
    }
  }

  return output;
}


/***/ }),

/***/ 50338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.syntaxError = syntaxError;

var _GraphQLError = __webpack_require__(65822);

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
function syntaxError(source, position, description) {
  return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}


/***/ }),

/***/ 50972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = defineInspect;

var _invariant = _interopRequireDefault(__webpack_require__(7706));

var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(18554));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */
function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || (0, _invariant.default)(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (_nodejsCustomInspectSymbol.default) {
    classObject.prototype[_nodejsCustomInspectSymbol.default] = fn;
  }
}


/***/ }),

/***/ 67242:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = devAssert;

function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 8002:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = inspect;

var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(18554));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol.default)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 85752:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _inspect = _interopRequireDefault(__webpack_require__(8002));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var _default =  true ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
0;

exports["default"] = _default;


/***/ }),

/***/ 7706:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = invariant;

function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}


/***/ }),

/***/ 25690:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isObjectLike;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}


/***/ }),

/***/ 18554:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var _default = nodejsCustomInspectSymbol;
exports["default"] = _default;


/***/ }),

/***/ 91807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isNode = isNode;
exports.Token = exports.Location = void 0;

var _defineInspect = _interopRequireDefault(__webpack_require__(50972));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.


exports.Location = Location;
(0, _defineInspect.default)(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.


exports.Token = Token;
(0, _defineInspect.default)(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */


/***/ }),

/***/ 70849:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.dedentBlockStringValue = dedentBlockStringValue;
exports.getBlockStringIndentation = getBlockStringIndentation;
exports.printBlockString = printBlockString;

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */


function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),

/***/ 78333:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DirectiveLocation = void 0;

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

exports.DirectiveLocation = DirectiveLocation;


/***/ }),

/***/ 12178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _source.Source;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _location.getLocation;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _printLocation.printLocation;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _printLocation.printSourceLocation;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _kinds.Kind;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _tokenKind.TokenKind;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _lexer.Lexer;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _parser.parse;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _parser.parseValue;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _parser.parseType;
  }
});
Object.defineProperty(exports, "S0", ({
  enumerable: true,
  get: function get() {
    return _printer.print;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _visitor.visit;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _visitor.visitInParallel;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _visitor.getVisitFn;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _visitor.BREAK;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _ast.Location;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _ast.Token;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isDefinitionNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isExecutableDefinitionNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isSelectionNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isValueNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isTypeNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isTypeSystemDefinitionNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isTypeDefinitionNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isTypeSystemExtensionNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _predicates.isTypeExtensionNode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _directiveLocation.DirectiveLocation;
  }
});

var _source = __webpack_require__(12412);

var _location = __webpack_require__(39016);

var _printLocation = __webpack_require__(38038);

var _kinds = __webpack_require__(2828);

var _tokenKind = __webpack_require__(23175);

var _lexer = __webpack_require__(54274);

var _parser = __webpack_require__(88370);

var _printer = __webpack_require__(23033);

var _visitor = __webpack_require__(80285);

var _ast = __webpack_require__(91807);

var _predicates = __webpack_require__(11352);

var _directiveLocation = __webpack_require__(78333);


/***/ }),

/***/ 2828:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Kind = void 0;

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

exports.Kind = Kind;


/***/ }),

/***/ 54274:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isPunctuatorTokenKind = isPunctuatorTokenKind;
exports.Lexer = void 0;

var _syntaxError = __webpack_require__(50338);

var _ast = __webpack_require__(91807);

var _tokenKind = __webpack_require__(23175);

var _blockString = __webpack_require__(70849);

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new _ast.Token(_tokenKind.TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== _tokenKind.TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === _tokenKind.TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */


exports.Lexer = Lexer;

function isPunctuatorTokenKind(kind) {
  return kind === _tokenKind.TokenKind.BANG || kind === _tokenKind.TokenKind.DOLLAR || kind === _tokenKind.TokenKind.AMP || kind === _tokenKind.TokenKind.PAREN_L || kind === _tokenKind.TokenKind.PAREN_R || kind === _tokenKind.TokenKind.SPREAD || kind === _tokenKind.TokenKind.COLON || kind === _tokenKind.TokenKind.EQUALS || kind === _tokenKind.TokenKind.AT || kind === _tokenKind.TokenKind.BRACKET_L || kind === _tokenKind.TokenKind.BRACKET_R || kind === _tokenKind.TokenKind.BRACE_L || kind === _tokenKind.TokenKind.PIPE || kind === _tokenKind.TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? _tokenKind.TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new _ast.Token(_tokenKind.TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new _ast.Token(_tokenKind.TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new _ast.Token(_tokenKind.TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new _ast.Token(_tokenKind.TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new _ast.Token(_tokenKind.TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new _ast.Token(_tokenKind.TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new _ast.Token(_tokenKind.TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new _ast.Token(_tokenKind.TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new _ast.Token(_tokenKind.TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new _ast.Token(_tokenKind.TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new _ast.Token(_tokenKind.TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new _ast.Token(_tokenKind.TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new _ast.Token(_tokenKind.TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new _ast.Token(_tokenKind.TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw (0, _syntaxError.syntaxError)(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new _ast.Token(_tokenKind.TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new _ast.Token(_tokenKind.TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new _ast.Token(isFloat ? _tokenKind.TokenKind.FLOAT : _tokenKind.TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new _ast.Token(_tokenKind.TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw (0, _syntaxError.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new _ast.Token(_tokenKind.TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockString.dedentBlockStringValue)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw (0, _syntaxError.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new _ast.Token(_tokenKind.TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


/***/ }),

/***/ 39016:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getLocation = getLocation;

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}


/***/ }),

/***/ 88370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.parse = parse;
exports.parseValue = parseValue;
exports.parseType = parseType;
exports.Parser = void 0;

var _syntaxError = __webpack_require__(50338);

var _kinds = __webpack_require__(2828);

var _ast = __webpack_require__(91807);

var _tokenKind = __webpack_require__(23175);

var _source = __webpack_require__(12412);

var _directiveLocation = __webpack_require__(78333);

var _lexer = __webpack_require__(54274);

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */


function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(_tokenKind.TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(_tokenKind.TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */


function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(_tokenKind.TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(_tokenKind.TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */


var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = (0, _source.isSource)(source) ? source : new _source.Source(source);
    this._lexer = new _lexer.Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(_tokenKind.TokenKind.NAME);
    return {
      kind: _kinds.Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.DOCUMENT,
      definitions: this.many(_tokenKind.TokenKind.SOF, this.parseDefinition, _tokenKind.TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(_tokenKind.TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
      return {
        kind: _kinds.Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(_tokenKind.TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: _kinds.Kind.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(_tokenKind.TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseVariableDefinition, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(_tokenKind.TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.DOLLAR);
    return {
      kind: _kinds.Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.SELECTION_SET,
      selections: this.many(_tokenKind.TokenKind.BRACE_L, this.parseSelection, _tokenKind.TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(_tokenKind.TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(_tokenKind.TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: _kinds.Kind.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(_tokenKind.TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, item, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    return {
      kind: _kinds.Kind.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(_tokenKind.TokenKind.NAME)) {
      return {
        kind: _kinds.Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: _kinds.Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: _kinds.Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: _kinds.Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case _tokenKind.TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case _tokenKind.TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case _tokenKind.TokenKind.INT:
        this._lexer.advance();

        return {
          kind: _kinds.Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case _tokenKind.TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: _kinds.Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case _tokenKind.TokenKind.STRING:
      case _tokenKind.TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case _tokenKind.TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: _kinds.Kind.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: _kinds.Kind.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: _kinds.Kind.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: _kinds.Kind.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case _tokenKind.TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: _kinds.Kind.STRING,
      value: token.value,
      block: token.kind === _tokenKind.TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: _kinds.Kind.LIST,
      values: this.any(_tokenKind.TokenKind.BRACKET_L, item, _tokenKind.TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: _kinds.Kind.OBJECT,
      fields: this.any(_tokenKind.TokenKind.BRACE_L, item, _tokenKind.TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    return {
      kind: _kinds.Kind.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(_tokenKind.TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.AT);
    return {
      kind: _kinds.Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(_tokenKind.TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(_tokenKind.TokenKind.BRACKET_R);
      type = {
        kind: _kinds.Kind.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(_tokenKind.TokenKind.BANG)) {
      return {
        kind: _kinds.Kind.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(_tokenKind.TokenKind.STRING) || this.peek(_tokenKind.TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);
    return {
      kind: _kinds.Kind.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(_tokenKind.TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(_tokenKind.TokenKind.AMP) || this.peek(_tokenKind.TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(_tokenKind.TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(_tokenKind.TokenKind.BRACE_L) && this._lexer.lookahead().kind === _tokenKind.TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseFieldDefinition, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseInputValueDef, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(_tokenKind.TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: _kinds.Kind.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(_tokenKind.TokenKind.EQUALS) ? this.delimitedMany(_tokenKind.TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseEnumValueDefinition, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseInputValueDef, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(_tokenKind.TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: _kinds.Kind.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(_tokenKind.TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (_directiveLocation.DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new _ast.Location(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */


exports.Parser = Parser;

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return (0, _lexer.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}


/***/ }),

/***/ 11352:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isDefinitionNode = isDefinitionNode;
exports.isExecutableDefinitionNode = isExecutableDefinitionNode;
exports.isSelectionNode = isSelectionNode;
exports.isValueNode = isValueNode;
exports.isTypeNode = isTypeNode;
exports.isTypeSystemDefinitionNode = isTypeSystemDefinitionNode;
exports.isTypeDefinitionNode = isTypeDefinitionNode;
exports.isTypeSystemExtensionNode = isTypeSystemExtensionNode;
exports.isTypeExtensionNode = isTypeExtensionNode;

var _kinds = __webpack_require__(2828);

function isDefinitionNode(node) {
  return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}

function isExecutableDefinitionNode(node) {
  return node.kind === _kinds.Kind.OPERATION_DEFINITION || node.kind === _kinds.Kind.FRAGMENT_DEFINITION;
}

function isSelectionNode(node) {
  return node.kind === _kinds.Kind.FIELD || node.kind === _kinds.Kind.FRAGMENT_SPREAD || node.kind === _kinds.Kind.INLINE_FRAGMENT;
}

function isValueNode(node) {
  return node.kind === _kinds.Kind.VARIABLE || node.kind === _kinds.Kind.INT || node.kind === _kinds.Kind.FLOAT || node.kind === _kinds.Kind.STRING || node.kind === _kinds.Kind.BOOLEAN || node.kind === _kinds.Kind.NULL || node.kind === _kinds.Kind.ENUM || node.kind === _kinds.Kind.LIST || node.kind === _kinds.Kind.OBJECT;
}

function isTypeNode(node) {
  return node.kind === _kinds.Kind.NAMED_TYPE || node.kind === _kinds.Kind.LIST_TYPE || node.kind === _kinds.Kind.NON_NULL_TYPE;
}

function isTypeSystemDefinitionNode(node) {
  return node.kind === _kinds.Kind.SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === _kinds.Kind.DIRECTIVE_DEFINITION;
}

function isTypeDefinitionNode(node) {
  return node.kind === _kinds.Kind.SCALAR_TYPE_DEFINITION || node.kind === _kinds.Kind.OBJECT_TYPE_DEFINITION || node.kind === _kinds.Kind.INTERFACE_TYPE_DEFINITION || node.kind === _kinds.Kind.UNION_TYPE_DEFINITION || node.kind === _kinds.Kind.ENUM_TYPE_DEFINITION || node.kind === _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION;
}

function isTypeSystemExtensionNode(node) {
  return node.kind === _kinds.Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}

function isTypeExtensionNode(node) {
  return node.kind === _kinds.Kind.SCALAR_TYPE_EXTENSION || node.kind === _kinds.Kind.OBJECT_TYPE_EXTENSION || node.kind === _kinds.Kind.INTERFACE_TYPE_EXTENSION || node.kind === _kinds.Kind.UNION_TYPE_EXTENSION || node.kind === _kinds.Kind.ENUM_TYPE_EXTENSION || node.kind === _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION;
}


/***/ }),

/***/ 38038:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printLocation = printLocation;
exports.printSourceLocation = printSourceLocation;

var _location = __webpack_require__(39016);

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(location.source, (0, _location.getLocation)(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */


function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}


/***/ }),

/***/ 23033:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.print = print;

var _visitor = __webpack_require__(80285);

var _blockString = __webpack_require__(70849);

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return (0, _visitor.visit)(ast, {
    leave: printDocASTReducer
  });
}

var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap('', alias, ': ') + name;
    var argsLine = prefix + wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0, _blockString.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}


/***/ }),

/***/ 12412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isSource = isSource;
exports.Source = void 0;

var _symbols = __webpack_require__(93098);

var _inspect = _interopRequireDefault(__webpack_require__(8002));

var _devAssert = _interopRequireDefault(__webpack_require__(67242));

var _instanceOf = _interopRequireDefault(__webpack_require__(85752));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || (0, _devAssert.default)(0, "Body must be a string. Received: ".concat((0, _inspect.default)(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || (0, _devAssert.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || (0, _devAssert.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  _createClass(Source, [{
    key: _symbols.SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */


exports.Source = Source;

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return (0, _instanceOf.default)(source, Source);
}


/***/ }),

/***/ 23175:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TokenKind = void 0;

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

exports.TokenKind = TokenKind;


/***/ }),

/***/ 80285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.visit = visit;
exports.visitInParallel = visitInParallel;
exports.getVisitFn = getVisitFn;
exports.BREAK = exports.QueryDocumentKeys = void 0;

var _inspect = _interopRequireDefault(__webpack_require__(8002));

var _ast = __webpack_require__(91807);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
exports.QueryDocumentKeys = QueryDocumentKeys;
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

exports.BREAK = BREAK;

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!(0, _ast.isNode)(node)) {
        throw new Error("Invalid AST Node: ".concat((0, _inspect.default)(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if ((0, _ast.isNode)(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */


function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */


function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}


/***/ }),

/***/ 93098:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SYMBOL_TO_STRING_TAG = exports.SYMBOL_ASYNC_ITERATOR = exports.SYMBOL_ITERATOR = void 0;
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

exports.SYMBOL_ITERATOR = SYMBOL_ITERATOR;
var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

exports.SYMBOL_ASYNC_ITERATOR = SYMBOL_ASYNC_ITERATOR;
var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';
exports.SYMBOL_TO_STRING_TAG = SYMBOL_TO_STRING_TAG;


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 16284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IntlMessageFormat; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56096);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95957);
/* harmony import */ var _formatters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61092);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .memoize */ .H)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getDateTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .memoize */ .H)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .memoize */ .H)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== _formatters__WEBPACK_IMPORTED_MODULE_3__/* .PART_TYPE.literal */ .du.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return (0,_formatters__WEBPACK_IMPORTED_MODULE_3__/* .formatToParts */ .FK)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            var _a;
            return ({
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
                    Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(_a, ["formatters"]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, parseOpts), { locale: this.resolvedLocale }));
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
            return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .parse */ .Qc;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());


/***/ }),

/***/ 11050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ InvalidValueError; },
/* harmony export */   "HR": function() { return /* binding */ MissingValueError; },
/* harmony export */   "YR": function() { return /* binding */ InvalidValueTypeError; },
/* harmony export */   "jK": function() { return /* binding */ ErrorCode; },
/* harmony export */   "u_": function() { return /* binding */ FormatError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));



/***/ }),

/***/ 61092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ formatToParts; },
/* harmony export */   "Gt": function() { return /* binding */ isFormatXMLElementFn; },
/* harmony export */   "du": function() { return /* binding */ PART_TYPE; }
/* harmony export */ });
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56096);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11050);


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPoundElement */ .yx)(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .MissingValueError */ .HR(varName, originalMessage);
        }
        var value = values[varName];
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isArgumentElement */ .VG)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateElement */ .rp)(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTimeElement */ .pe)(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberElement */ .uf)(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberSkeleton */ .Wh)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTagElement */ .HI)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueTypeError */ .YR(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isSelectElement */ .Wi)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPluralElement */ .Jo)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .FormatError */ .u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", _error__WEBPACK_IMPORTED_MODULE_1__/* .ErrorCode.MISSING_INTL_API */ .jK.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 44286:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    baseIsEqual = __webpack_require__(90939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 67206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(91573),
    baseMatchesProperty = __webpack_require__(16432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(39601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 91573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(42634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939),
    get = __webpack_require__(27361),
    hasIn = __webpack_require__(79095),
    isKey = __webpack_require__(15403),
    isStrictComparable = __webpack_require__(89162),
    matchesStrictComparable = __webpack_require__(42634),
    toKey = __webpack_require__(40327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 63012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSet = __webpack_require__(10611),
    castPath = __webpack_require__(71811);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 40371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 79152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 10611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    castPath = __webpack_require__(71811),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 40180:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 98805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(40180),
    hasUnicode = __webpack_require__(62689),
    stringToArray = __webpack_require__(83140),
    toString = __webpack_require__(79833);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(89162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(65776),
    isLength = __webpack_require__(41780),
    toKey = __webpack_require__(40327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 62689:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 89162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 42634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 83140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(44286),
    hasUnicode = __webpack_require__(62689),
    unicodeToArray = __webpack_require__(676);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 676:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 79095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 35937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseIteratee = __webpack_require__(67206),
    basePickBy = __webpack_require__(63012),
    getAllKeysIn = __webpack_require__(46904);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),

/***/ 39601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371),
    basePropertyDeep = __webpack_require__(79152),
    isKey = __webpack_require__(15403),
    toKey = __webpack_require__(40327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 11700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(98805);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 18633:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
__exportStar(__webpack_require__(72510), exports);
__exportStar(__webpack_require__(95670), exports);
__exportStar(__webpack_require__(27092), exports);
__exportStar(__webpack_require__(9742), exports);
__exportStar(__webpack_require__(37229), exports);
__exportStar(__webpack_require__(58216), exports);
var withTranslateRoutes_1 = __webpack_require__(72510);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return withTranslateRoutes_1.withTranslateRoutes; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 73966:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
__exportStar(__webpack_require__(95670), exports);
var link_1 = __webpack_require__(95670);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return link_1.Link; } }));
//# sourceMappingURL=link.js.map

/***/ }),

/***/ 65719:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getLocalePathFromPaths = void 0;
var ntrData_1 = __webpack_require__(32654);
var getFallbackLngs = function (lng) {
    var fallbackLng = ((0, ntrData_1.getNtrData)() || {}).fallbackLng;
    if (!fallbackLng) {
        return undefined;
    }
    if (typeof fallbackLng === 'string') {
        return [fallbackLng];
    }
    return Array.isArray(fallbackLng) ? fallbackLng : fallbackLng[lng];
};
/**
 * Get the locale path part from a route segment `paths` property and a locale.
 *
 * Ex:
 * ```
 * getPathFromPaths({ default: 'here', fr: 'ici', es: 'aqui' }, 'fr') // 'ici'
 *
 * // If no fallbackLng is defined:
 * getPathFromPaths({ default: 'here', fr: 'ici', es: 'aqui' }, 'pt') // 'here'
 * // If ntrData.fallbackLng.pt === ['es', 'fr'], then:
 * getPathFromPaths({ default: 'here', fr: 'ici', es: 'aqui' }, 'pt') // 'aqui'
 * ```
 */
var getLocalePathFromPaths = function (_a) {
    var e_1, _b;
    var paths = _a.paths, locale = _a.locale;
    if (paths[locale]) {
        return paths[locale];
    }
    var fallbackLngs = getFallbackLngs(locale);
    if (fallbackLngs) {
        try {
            for (var fallbackLngs_1 = __values(fallbackLngs), fallbackLngs_1_1 = fallbackLngs_1.next(); !fallbackLngs_1_1.done; fallbackLngs_1_1 = fallbackLngs_1.next()) {
                var l = fallbackLngs_1_1.value;
                if (paths[l]) {
                    return paths[l];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (fallbackLngs_1_1 && !fallbackLngs_1_1.done && (_b = fallbackLngs_1.return)) _b.call(fallbackLngs_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return paths.default;
};
exports.getLocalePathFromPaths = getLocalePathFromPaths;
//# sourceMappingURL=getPathFromPaths.js.map

/***/ }),

/***/ 33477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.enhanceNextRouter = void 0;
var querystring_1 = __webpack_require__(17673);
var ntrData_1 = __webpack_require__(32654);
var withNtrPrefix_1 = __webpack_require__(30270);
var getLocale_1 = __webpack_require__(75711);
var translatePushReplaceArgs_1 = __webpack_require__(27778);
var urlToFileUrl_1 = __webpack_require__(58216);
var logWithTrace = function (from, details) {
    console.groupCollapsed(withNtrPrefix_1.ntrMessagePrefix + from, details);
    console.trace('Stringified:\n', JSON.stringify(details, null, 4));
    console.groupEnd();
};
var enhancePushReplace = function (router, fnName) {
    return function (url, as, options) {
        var translatedArgs = (0, translatePushReplaceArgs_1.translatePushReplaceArgs)({ router: router, url: url, as: as, locale: options === null || options === void 0 ? void 0 : options.locale });
        if ((0, ntrData_1.getNtrData)().debug) {
            logWithTrace("router.".concat(fnName), {
                original: {
                    url: url,
                    as: as,
                    options: options,
                },
                translated: translatedArgs,
            });
        }
        return router[fnName](translatedArgs.url, translatedArgs.as, __assign(__assign({}, options), { locale: translatedArgs.locale }));
    };
};
var enhancePrefetch = function (router) {
    return function (inputUrl, asPath, options) {
        var locale = (0, getLocale_1.getLocale)(router, options === null || options === void 0 ? void 0 : options.locale);
        var parsedInputUrl = (0, urlToFileUrl_1.urlToFileUrl)(inputUrl, locale);
        if ((0, ntrData_1.getNtrData)().debug === 'withPrefetch') {
            logWithTrace('router.prefetch', { inputUrl: inputUrl, asPath: asPath, options: options, parsedInputUrl: parsedInputUrl, locale: locale });
        }
        return router.prefetch(parsedInputUrl
            ? (parsedInputUrl.pathname || '/') +
                (parsedInputUrl.query &&
                    "?".concat(typeof parsedInputUrl.query === 'string' ? parsedInputUrl.query : (0, querystring_1.stringify)(parsedInputUrl.query)))
            : inputUrl, asPath, options);
    };
};
var enhanceNextRouter = function (router) {
    if ('router' in router) {
        return new Proxy(router, {
            get: function (target, p) {
                if (p === 'push' || p === 'replace') {
                    return enhancePushReplace(target, p);
                }
                if (p === 'prefetch') {
                    return enhancePrefetch(target);
                }
                return target[p];
            },
        });
    }
    return __assign(__assign({}, router), { push: enhancePushReplace(router, 'push'), replace: enhancePushReplace(router, 'replace'), prefetch: enhancePrefetch(router) });
};
exports.enhanceNextRouter = enhanceNextRouter;
//# sourceMappingURL=enhanceNextRouter.js.map

/***/ }),

/***/ 44141:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fileUrlToFileUrlObject = void 0;
var ntrData_1 = __webpack_require__(32654);
var regex_1 = __webpack_require__(71224);
var parseUrl_1 = __webpack_require__(38690);
/**
 * Recursively get path file UrlObject from a route branch
 */
var getFileUrlObject = function (_a) {
    var e_1, _b, _c;
    var _d, _e;
    var routeBranch = _a.routeBranch, pathParts = _a.pathParts;
    if (pathParts.length === 0) {
        var optionalMatchAllChild = (_d = routeBranch.children) === null || _d === void 0 ? void 0 : _d.find(function (child) {
            return regex_1.optionalMatchAllFilepathPartRegex.test(child.name);
        });
        if (optionalMatchAllChild) {
            return { pathname: "/".concat(routeBranch.name, "/").concat(optionalMatchAllChild.name), query: {} };
        }
        return { pathname: "/".concat(routeBranch.name), query: {} };
    }
    var _f = __read(pathParts), nextPathPart = _f[0], remainingPathParts = _f.slice(1);
    // Next parts path: looking for the child corresponding to nextPathPart:
    // if nextPathPart does not match any child name and a dynamic child is found,
    // we will consider that nextPathPart is a value given to the dynamic child
    var matchingChild = undefined;
    try {
        for (var _g = __values(routeBranch.children || []), _h = _g.next(); !_h.done; _h = _g.next()) {
            var child = _h.value;
            if (
            // child.children must be coherent with remaining path parts is case a file and and folder share the same name
            remainingPathParts.length === 0 ||
                ((_e = child.children) === null || _e === void 0 ? void 0 : _e.length)) {
                if (child.name === nextPathPart) {
                    matchingChild = child;
                    break;
                }
                else if (
                // If nextPathPart already have a dynamic syntax, it must match the name, no need to go further
                !regex_1.anyDynamicFilepathPartRegex.test(nextPathPart) &&
                    // If the current child is dynamic and...
                    regex_1.anyDynamicFilepathPartRegex.test(child.name) &&
                    // ...there is no matching child found for now, or...
                    (!matchingChild ||
                        // ...the matchingChild has a sread syntax and the new one has not (priority)
                        (regex_1.spreadFilepathPartRegex.test(matchingChild.name) && regex_1.dynamicFilepathPartsRegex.test(child.name)))) {
                    matchingChild = child;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (matchingChild) {
        /** If we found an exact match, no need to add query */
        var isExactMatch = matchingChild.name === nextPathPart;
        var dynamicPathPartKey = (0, regex_1.getDynamicPathPartKey)(matchingChild.name);
        var _j = getFileUrlObject({
            routeBranch: matchingChild,
            pathParts: remainingPathParts,
        }), nextPathname = _j.pathname, nextQuery = _j.query;
        var pathname = "".concat(routeBranch.name ? "/".concat(routeBranch.name) : '').concat(nextPathname);
        var query = isExactMatch || !dynamicPathPartKey
            ? nextQuery
            : __assign((_c = {}, _c[dynamicPathPartKey] = regex_1.spreadFilepathPartRegex.test(matchingChild.name) ? pathParts : nextPathPart, _c), nextQuery);
        return { pathname: pathname, query: query };
    }
    throw new Error("No \"/".concat(pathParts.join('/'), "\" page found in /").concat(routeBranch.name, " folder."));
};
/**
 * Get the file UrlObject matching a string file url
 *
 * Ex: Given `/[dynamic]/path` is an existing file path,
 *
 * `/value/path?foo=bar` => { pathname: `/[dynamic]/path`, query: { dynamic: 'value', foo: 'bar' } }
 *
 * @throws if the fileUrl input does not match any page
 */
var fileUrlToFileUrlObject = function (fileUrl) {
    var _a = (0, parseUrl_1.parseUrl)(fileUrl), rawPathname = _a.pathname, initialQuery = _a.query, rest = __rest(_a, ["pathname", "query"]);
    var routesTree = (0, ntrData_1.getNtrData)().routesTree;
    if (!routesTree.children) {
        throw new Error('No page found. You probably need to add the pageDirectory option in your translateRoutes config.');
    }
    var _b = getFileUrlObject({
        pathParts: (rawPathname || '/').split('/').filter(Boolean),
        routeBranch: routesTree,
    }), pathname = _b.pathname, query = _b.query;
    return __assign({ pathname: pathname, query: __assign(__assign({}, query), initialQuery) }, rest);
};
exports.fileUrlToFileUrlObject = fileUrlToFileUrlObject;
//# sourceMappingURL=fileUrlToFileUrlObject.js.map

/***/ }),

/***/ 37229:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fileUrlToUrl = exports.getTranslatedPathPattern = void 0;
var normalize_trailing_slash_1 = __webpack_require__(82392);
var path_to_regexp_1 = __webpack_require__(51068);
var url_1 = __webpack_require__(11987);
var getPathFromPaths_1 = __webpack_require__(65719);
var ntrData_1 = __webpack_require__(32654);
var regex_1 = __webpack_require__(71224);
var withNtrPrefix_1 = __webpack_require__(30270);
var fileUrlToFileUrlObject_1 = __webpack_require__(44141);
/**
 * Get pattern from route branch paths property in the specified locale,
 * or, if it does not exist, the default path.
 */
var getPatternFromRoutePaths = function (routeBranch, locale) {
    var pattern = (0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: routeBranch.paths, locale: locale });
    return regex_1.ignoreSegmentPathRegex.test(pattern) ? '' : pattern;
};
/** Add `/` prefix only if `pattern` is not an empty string and does not already have it */
var addSlashPrefix = function (path) { return (path === '' || path.startsWith('/') ? path : "/".concat(path)); };
/** Get the translated path of a route branch (handling ignored path parts, index, match all, etc.) */
var getTranslatedPathPart = function (_a) {
    var _b;
    var routeBranch = _a.routeBranch, locale = _a.locale, isLastPathPart = _a.isLastPathPart;
    var pattern = getPatternFromRoutePaths(routeBranch, locale);
    if (isLastPathPart) {
        if ((_b = routeBranch.children) === null || _b === void 0 ? void 0 : _b.length) {
            var silentChild = routeBranch.children.find(function (child) { var _a; return !((_a = child.children) === null || _a === void 0 ? void 0 : _a.length) && (child.name === 'index' || regex_1.optionalMatchAllFilepathPartRegex.test(child.name)); });
            if (!silentChild) {
                throw new Error("No index file found in \"".concat(routeBranch.name, "\" folder."));
            }
            var indexChildPattern = getPatternFromRoutePaths(silentChild, locale);
            if (indexChildPattern && indexChildPattern !== 'index') {
                pattern = pattern + addSlashPrefix(indexChildPattern);
            }
        }
        else if (pattern === 'index' && routeBranch.name === 'index') {
            pattern = '';
        }
    }
    return addSlashPrefix(pattern);
};
/**
 * Recursively get translated path (path-to-regexp syntax) given:
 * - a route branch
 * - file path parts
 * - a locale
 *
 * Ex: Given `/[dynamic]/path` is an existing file path:
 *
 * `/[dynamic]/path` => `/:dynamic/path`
 */
var getTranslatedPathPattern = function (_a) {
    var _b;
    var routeBranch = _a.routeBranch, pathParts = _a.pathParts, locale = _a.locale;
    var isLastPathPart = pathParts.length === 0;
    /** Current part path pattern */
    var currentTranslatedPathPart = getTranslatedPathPart({ routeBranch: routeBranch, locale: locale, isLastPathPart: isLastPathPart });
    if (isLastPathPart) {
        return currentTranslatedPathPart;
    }
    var _c = __read(pathParts), nextFilePathPart = _c[0], remainingFilePathParts = _c.slice(1);
    // Next parts path patterns: looking for the child corresponding to nextPathPart:
    // if nextPathPart does not match any child name and a dynamic child is found,
    // we will consider that nextPathPart is a value given to the dynamic child
    var matchingChild = (_b = routeBranch.children) === null || _b === void 0 ? void 0 : _b.find(function (child) { return child.name === nextFilePathPart; });
    if (!matchingChild) {
        throw new Error("".concat(nextFilePathPart, " not found in ").concat(routeBranch.name || 'pages'));
    }
    var remainingTranslatedPath = (0, exports.getTranslatedPathPattern)({
        routeBranch: matchingChild,
        pathParts: remainingFilePathParts,
        locale: locale,
    });
    return currentTranslatedPathPart + remainingTranslatedPath;
};
exports.getTranslatedPathPattern = getTranslatedPathPattern;
/**
 * Translate Next file url into translated string url
 *
 * @param url Next default file url
 * @param locale The target locale
 * @param option.throwOnError (Default to true) Throw if the input url does not match any page
 *
 * @returns The url string or undefined if no page matched and option.throwOnError is set to false
 * @throws If and the input url does not match any page and option.throwOnError in not set to false
 */
var fileUrlToUrl = function (url, locale, _a) {
    var e_1, _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.throwOnError, throwOnError = _d === void 0 ? true : _d;
    try {
        var _e = (0, fileUrlToFileUrlObject_1.fileUrlToFileUrlObject)(url), pathname = _e.pathname, query = _e.query, hash = _e.hash;
        var _f = (0, ntrData_1.getNtrData)(), routesTree = _f.routesTree, defaultLocale = _f.defaultLocale;
        var pathParts = (pathname || '/')
            .replace(/^\/|\/$/g, '')
            .split('/')
            .filter(Boolean);
        var pathPattern = (0, exports.getTranslatedPathPattern)({ routeBranch: routesTree, pathParts: pathParts, locale: locale });
        var newPathname = (0, normalize_trailing_slash_1.normalizePathTrailingSlash)((0, path_to_regexp_1.compile)(pathPattern)(query));
        try {
            for (var _g = __values((0, path_to_regexp_1.parse)(pathPattern)), _h = _g.next(); !_h.done; _h = _g.next()) {
                var patternToken = _h.value;
                if (typeof patternToken === 'object' && patternToken.name) {
                    delete query[patternToken.name];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return "".concat(locale !== defaultLocale ? "/".concat(locale) : '').concat((0, url_1.format)({
            pathname: newPathname,
            query: query,
            hash: hash,
        }));
    }
    catch (cause) {
        if (throwOnError) {
            throw new Error(withNtrPrefix_1.ntrMessagePrefix + "No page found for the following file url: ".concat(url.toString()), { cause: cause });
        }
        return undefined;
    }
};
exports.fileUrlToUrl = fileUrlToUrl;
//# sourceMappingURL=fileUrlToUrl.js.map

/***/ }),

/***/ 75711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getLocale = void 0;
var ntrData_1 = __webpack_require__(32654);
var getLocale = function (_a, explicitLocale) {
    var locale = _a.locale, defaultLocale = _a.defaultLocale, locales = _a.locales;
    return explicitLocale || locale || defaultLocale || (locales === null || locales === void 0 ? void 0 : locales[0]) || (0, ntrData_1.getNtrData)().defaultLocale || (0, ntrData_1.getNtrData)().locales[0];
};
exports.getLocale = getLocale;
//# sourceMappingURL=getLocale.js.map

/***/ }),

/***/ 95670:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Link = void 0;
var link_1 = __importDefault(__webpack_require__(41664));
var router_1 = __webpack_require__(11163);
var react_1 = __importDefault(__webpack_require__(67294));
var translatePushReplaceArgs_1 = __webpack_require__(27778);
/**
 * Link component that handle route translations
 */
exports.Link = react_1.default.forwardRef(function (_a, ref) {
    var href = _a.href, as = _a.as, locale = _a.locale, props = __rest(_a, ["href", "as", "locale"]);
    var router = (0, router_1.useRouter)();
    var translatedArgs = (0, translatePushReplaceArgs_1.translatePushReplaceArgs)({ router: router, url: href, as: as, locale: locale });
    return (react_1.default.createElement(link_1.default, __assign({ ref: ref, href: translatedArgs.url, as: translatedArgs.as, locale: translatedArgs.locale }, props)));
});
exports["default"] = exports.Link;
//# sourceMappingURL=link.js.map

/***/ }),

/***/ 38690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseUrl = void 0;
var querystring_1 = __webpack_require__(17673);
var url_1 = __webpack_require__(11987);
/** Parse an url and its query to object */
var parseUrl = function (url) {
    return typeof url === 'string' || url instanceof URL
        ? (0, url_1.parse)(url.toString(), true)
        : __assign(__assign({}, url), { query: typeof url.query === 'string' ? (0, querystring_1.parse)(url.query) : url.query });
};
exports.parseUrl = parseUrl;
//# sourceMappingURL=parseUrl.js.map

/***/ }),

/***/ 73713:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.removeLangPrefix = void 0;
var getPathFromPaths_1 = __webpack_require__(65719);
var ntrData_1 = __webpack_require__(32654);
function removeLangPrefix(pathname, toArray, givenLocale) {
    var _a;
    var pathParts = pathname.split('/').filter(Boolean);
    var _b = (0, ntrData_1.getNtrData)(), routesTree = _b.routesTree, defaultLocale = _b.defaultLocale, locales = _b.locales;
    var getLangRoot = function (lang) { return (0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: routesTree.paths, locale: lang }); };
    var defaultLocaleRoot = defaultLocale && getLangRoot(defaultLocale);
    var hasLangPrefix = givenLocale ? pathParts[0] === givenLocale : locales.includes(pathParts[0]);
    var hasDefaultLocalePrefix = !hasLangPrefix && !!defaultLocaleRoot && pathParts[0] === defaultLocaleRoot;
    var hasGivenLocalePrefix = givenLocale ? pathParts[hasLangPrefix ? 1 : 0] === getLangRoot(givenLocale) : false;
    if (!hasLangPrefix && !hasDefaultLocalePrefix && !hasGivenLocalePrefix) {
        return toArray ? pathParts : pathname;
    }
    var locale = givenLocale || hasLangPrefix ? pathParts[0] : defaultLocale;
    var localeRootParts = (locale || hasGivenLocalePrefix) && ((_a = getLangRoot(locale)) === null || _a === void 0 ? void 0 : _a.split('/'));
    var nbPathPartsToRemove = (hasLangPrefix ? 1 : 0) +
        (localeRootParts && (!hasLangPrefix || pathParts[1] === localeRootParts[0]) ? localeRootParts.length : 0);
    return toArray ? pathParts.slice(nbPathPartsToRemove) : "/".concat(pathParts.slice(nbPathPartsToRemove).join('/'));
}
exports.removeLangPrefix = removeLangPrefix;
//# sourceMappingURL=removeLangPrefix.js.map

/***/ }),

/***/ 27092:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var router_1 = __importDefault(__webpack_require__(90387));
var enhanceNextRouter_1 = __webpack_require__(33477);
__exportStar(__webpack_require__(90387), exports);
exports["default"] = (0, enhanceNextRouter_1.enhanceNextRouter)(router_1.default);
//# sourceMappingURL=router.js.map

/***/ }),

/***/ 27778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.translatePushReplaceArgs = void 0;
var ntrData_1 = __webpack_require__(32654);
var fileUrlToFileUrlObject_1 = __webpack_require__(44141);
var fileUrlToUrl_1 = __webpack_require__(37229);
var getLocale_1 = __webpack_require__(75711);
var removeLangPrefix_1 = __webpack_require__(73713);
var urlToFileUrl_1 = __webpack_require__(58216);
var translatePushReplaceArgs = function (_a) {
    var router = _a.router, url = _a.url, as = _a.as, locale = _a.locale;
    if (as) {
        return { url: url, as: as, locale: locale };
    }
    var newLocale = (0, getLocale_1.getLocale)(router, locale);
    var locales = router.locales || (0, ntrData_1.getNtrData)().locales;
    var unprefixedUrl = typeof url === 'string' ? (0, removeLangPrefix_1.removeLangPrefix)(url) : url;
    var urlLocale = typeof url === 'string' && unprefixedUrl !== url ? url.split('/')[1] : undefined;
    // propLocale === false if opted-out of automatically handling the locale prefixing
    // Cf. https://nextjs.org/docs/advanced-features/i18n-routing#transition-between-locales
    if (locale === false && urlLocale && locales.includes(urlLocale)) {
        newLocale = urlLocale;
    }
    /**
     * url can be:
     * - an external url
     * - a correct file url
     * - a wrong file url (not matching any page)
     * - a correct translated url
     * - a wrong translated url
     */
    try {
        /**
         * We need the parsedUrl to be in Next UrlObject synthax, otherwise there is conflicts with the as prop
         * See: https://github.com/hozana/next-translate-routes/issues/54
         */
        var parsedUrl = void 0;
        var translatedUrl = (0, fileUrlToUrl_1.fileUrlToUrl)(unprefixedUrl, newLocale, { throwOnError: false });
        if (translatedUrl) {
            // url is a correct file url
            parsedUrl = (0, fileUrlToFileUrlObject_1.fileUrlToFileUrlObject)(unprefixedUrl);
        }
        else {
            // url is not a correct file url
            parsedUrl = (0, urlToFileUrl_1.urlToFileUrl)(unprefixedUrl, urlLocale || newLocale);
            if (parsedUrl) {
                translatedUrl = (0, fileUrlToUrl_1.fileUrlToUrl)(parsedUrl, newLocale);
                // If fileUrlToUrl did not throw, url is a correct translated url
            }
        }
        return { url: parsedUrl || url, as: translatedUrl, locale: newLocale };
    }
    catch (error) {
        // url seems to be either a wrong file url or an external url:
        // do not bring changes if no translation is found
        return { url: url, locale: locale };
    }
};
exports.translatePushReplaceArgs = translatePushReplaceArgs;
//# sourceMappingURL=translatePushReplaceArgs.js.map

/***/ }),

/***/ 9742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.translateUrl = exports.translatePath = void 0;
var normalize_trailing_slash_1 = __webpack_require__(82392);
var path_to_regexp_1 = __webpack_require__(51068);
var url_1 = __webpack_require__(11987);
var getPathFromPaths_1 = __webpack_require__(65719);
var ntrData_1 = __webpack_require__(32654);
var regex_1 = __webpack_require__(71224);
var parseUrl_1 = __webpack_require__(38690);
var removeLangPrefix_1 = __webpack_require__(73713);
/** Get children + (grand)children of children whose path must be ignord (path === '.' or path === `.(${pathRegex})`) */
var getAllCandidates = function (lang, children) {
    return children
        ? children.reduce(function (acc, child) {
            var path = (0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: child.paths, locale: lang });
            return __spreadArray(__spreadArray([], __read(acc), false), __read((path === '' ? getAllCandidates(lang, child.children) : [child])), false);
        }, [])
        : [];
};
/**
 * Recursively translate paths from file path, and extract parameters
 */
var translatePathParts = function (_a) {
    var _b, _c;
    var locale = _a.locale, pathParts = _a.pathParts, routeBranch = _a.routeBranch, query = _a.query;
    var children = routeBranch.children;
    if (!Array.isArray(pathParts)) {
        throw new Error('Wrong pathParts argument in translatePathParts');
    }
    if (pathParts.length === 0) {
        return { translatedPathParts: [], augmentedQuery: query };
    }
    var pathPart = pathParts[0];
    var nextPathParts = pathParts.slice(1);
    if (!pathPart) {
        return translatePathParts({ locale: locale, pathParts: nextPathParts, routeBranch: routeBranch, query: query });
    }
    var candidates = getAllCandidates(locale, children).filter(function (child) {
        return pathParts.length === 1 // Last path part
            ? !child.children ||
                child.children.some(function (grandChild) { return grandChild.name === 'index' || /\[\[\.{0,3}\w+\]\]/.exec(grandChild.name); })
            : !!child.children || /\[\[?\.{3}\w+\]?\]/.exec(child.name);
    });
    var currentQuery = query;
    /**
     * If defined: pathPart is a route segment name that should be translated.
     * If dynamic, the value should already be contained in the query.
     */
    var childRouteBranch = candidates.find(function (_a) {
        var name = _a.name;
        return pathPart === name;
    });
    if (!childRouteBranch) {
        // If not defined: pathPart is either a dynamic value either a wrong path.
        childRouteBranch = candidates.find(function (candidate) { return (0, regex_1.getDynamicPathPartKey)(candidate.name); });
        if (childRouteBranch) {
            // Single dynamic route segment value => store it in the query
            currentQuery = __assign(__assign({}, currentQuery), (_b = {}, _b[childRouteBranch.name.replace(/\[|\]|\./g, '')] = pathPart, _b));
        }
        else {
            childRouteBranch = candidates.find(function (candidate) { return (0, regex_1.getSpreadFilepathPartKey)(candidate.name); });
            if (childRouteBranch) {
                // Catch all route => store it in the query, then return the current data.
                currentQuery = __assign(__assign({}, currentQuery), (_c = {}, _c[childRouteBranch.name.replace(/\[|\]|\./g, '')] = pathParts, _c));
                return {
                    translatedPathParts: [(0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: childRouteBranch.paths, locale: locale })],
                    augmentedQuery: currentQuery,
                };
            }
            // No route match => return the remaining path as is
            return { translatedPathParts: pathParts, augmentedQuery: query };
        }
    }
    // Get the descendants translated path parts and query values
    var _d = (childRouteBranch === null || childRouteBranch === void 0 ? void 0 : childRouteBranch.children)
        ? translatePathParts({ locale: locale, pathParts: nextPathParts, routeBranch: childRouteBranch, query: currentQuery })
        : { augmentedQuery: currentQuery, translatedPathParts: [] }, augmentedQuery = _d.augmentedQuery, nextTranslatedPathsParts = _d.translatedPathParts;
    var translatedPathPart = (0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: childRouteBranch.paths, locale: locale });
    return {
        translatedPathParts: __spreadArray(__spreadArray([], __read((regex_1.ignoreSegmentPathRegex.test(translatedPathPart) ? [] : [translatedPathPart])), false), __read((nextTranslatedPathsParts || [])), false),
        augmentedQuery: augmentedQuery,
    };
};
function translatePath(url, locale, _a) {
    var _b = _a === void 0 ? {} : _a, format = _b.format;
    var routesTree = (0, ntrData_1.getNtrData)().routesTree;
    var returnFormat = format || typeof url;
    var urlObject = (0, parseUrl_1.parseUrl)(url);
    var pathname = urlObject.pathname, query = urlObject.query, hash = urlObject.hash;
    if (!pathname || !locale) {
        return returnFormat === 'object' ? url : (0, url_1.format)(url);
    }
    var pathParts = (0, removeLangPrefix_1.removeLangPrefix)(pathname, true);
    var _c = translatePathParts({
        locale: locale,
        pathParts: pathParts,
        query: query,
        routeBranch: routesTree,
    }), translatedPathParts = _c.translatedPathParts, _d = _c.augmentedQuery, augmentedQuery = _d === void 0 ? {} : _d;
    var path = translatedPathParts.join('/');
    var compiledPath = (0, path_to_regexp_1.compile)(path, { validate: false })(augmentedQuery);
    var paramNames = (0, path_to_regexp_1.parse)(path).filter(function (token) { return typeof token === 'object'; }).map(function (token) { return token.name; });
    var remainingQuery = Object.keys(augmentedQuery).reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (paramNames.includes(key)
            ? {}
            : (_a = {}, _a[key] = (typeof query === 'object' && (query === null || query === void 0 ? void 0 : query[key])) || augmentedQuery[key], _a))));
    }, {});
    var translatedPathname = "".concat(routesTree.paths[locale] ? "/".concat(routesTree.paths[locale]) : '', "/").concat(compiledPath);
    var translatedUrlObject = __assign(__assign({}, urlObject), { hash: hash, pathname: translatedPathname, query: remainingQuery });
    return returnFormat === 'object' ? translatedUrlObject : (0, url_1.format)(translatedUrlObject);
}
exports.translatePath = translatePath;
/**
 * Translate url into locale
 *
 * Will soon be deprecated in favor of fileUrlToUrl and urlToFileUrl
 *
 * @param url string url or UrlObject
 * @param locale string
 * @param options (optional)
 * @param options.format `'string'` or `'object'`
 * @return string if `options.format === 'string'`,
 * UrlObject if `options.format === 'object'`,
 * same type as url if options.format is not defined
 */
exports.translateUrl = (function (url, locale, options) {
    var defaultLocale = (0, ntrData_1.getNtrData)().defaultLocale;
    // Handle external urls
    var parsedUrl = typeof url === 'string' ? (0, url_1.parse)(url) : url;
    if (parsedUrl.host) {
        if (typeof window === 'undefined' || parsedUrl.host !== (0, url_1.parse)(window.location.href).host) {
            return url;
        }
    }
    var translatedPath = translatePath(url, locale, options);
    if (typeof translatedPath === 'object') {
        return translatedPath;
    }
    var prefix = locale === defaultLocale || (options === null || options === void 0 ? void 0 : options.withoutLangPrefix) ? '' : "/".concat(locale);
    return (0, normalize_trailing_slash_1.normalizePathTrailingSlash)(prefix + translatedPath);
});
//# sourceMappingURL=translateUrl.js.map

/***/ }),

/***/ 58216:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.urlToFileUrl = exports.parsePathParts = void 0;
var path_to_regexp_1 = __webpack_require__(51068);
var getPathFromPaths_1 = __webpack_require__(65719);
var ntrData_1 = __webpack_require__(32654);
var regex_1 = __webpack_require__(71224);
var parseUrl_1 = __webpack_require__(38690);
var removeLangPrefix_1 = __webpack_require__(73713);
var MATCH_TYPE;
(function (MATCH_TYPE) {
    MATCH_TYPE["STATIC"] = "static";
    MATCH_TYPE["DYNAMIC"] = "dynamic";
    MATCH_TYPE["MATCHALL"] = "match-all";
})(MATCH_TYPE || (MATCH_TYPE = {}));
var getEndFilepathParts = function (_a, locale) {
    var e_1, _b, _c;
    var _d;
    var _e = _a.children, children = _e === void 0 ? [] : _e;
    try {
        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var child = children_1_1.value;
            var path = (0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: child.paths, locale: locale });
            if (path === 'index') {
                return { parsedPathParts: [], additionalQuery: {}, firstMatchType: MATCH_TYPE.STATIC };
            }
            if (regex_1.ignoreSegmentPathRegex.test(path) && ((_d = child.children) === null || _d === void 0 ? void 0 : _d.length)) {
                var descendantResult = getEndFilepathParts(child, locale);
                if (descendantResult) {
                    return __assign(__assign({}, descendantResult), { parsedPathParts: __spreadArray([child.name], __read(descendantResult.parsedPathParts), false) });
                }
            }
            var optionalMatchAllToken = (0, path_to_regexp_1.parse)(path).find(function (ptrToken) { return typeof ptrToken === 'object' && ptrToken.modifier === '*'; });
            if (optionalMatchAllToken) {
                return {
                    parsedPathParts: [child.name],
                    additionalQuery: (_c = {}, _c[optionalMatchAllToken.name] = [], _c),
                    firstMatchType: MATCH_TYPE.MATCHALL,
                };
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (children_1_1 && !children_1_1.done && (_b = children_1.return)) _b.call(children_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return undefined;
};
/**
 * Recursively parse paths to identify the matching file path, and extract the parameters
 *
 * We must do this taking care of the priorities:
 * 1. static match among the current route branch children
 * 2. static match among among the descendants of a child that is path-ignored
 * 3. dynamic match among the current route branch children
 * 4. dynamic match among among the descendants of a child that is path-ignored
 * 5. match all match among the current route branch children
 * 6. match all match among among the descendants of a child that is path-ignored
 */
var parsePathParts = function (_a) {
    var e_2, _b, e_3, _c;
    var locale = _a.locale, _d = _a.pathParts, pathParts = _d === void 0 ? [] : _d, routeBranch = _a.routeBranch;
    var children = routeBranch.children;
    // If there is no path parts left to parse
    if (pathParts.length === 0) {
        if (!(children === null || children === void 0 ? void 0 : children.length)) {
            // The current routeBranch have no children, this is a match
            return { parsedPathParts: [], additionalQuery: {}, firstMatchType: MATCH_TYPE.STATIC };
        }
        return getEndFilepathParts(routeBranch, locale);
    }
    var currentPathPart = pathParts[0];
    var nextPathParts = pathParts.slice(1);
    // Ignore empty path parts
    if (!currentPathPart) {
        return (0, exports.parsePathParts)({ locale: locale, pathParts: nextPathParts, routeBranch: routeBranch });
    }
    // We are looking for the route matching the current path part among ther routeBranch children
    // It can be a static path part, or a dynamic path part (`[slug]` or `[...path]` for exemple)
    if (!(children === null || children === void 0 ? void 0 : children.length)) {
        // No match possible
        return undefined;
    }
    // 1. Lets first look for static matches among the current children
    /** We will store here candidates that does not match statically */
    var delayedCandidates = [];
    var matchAllCandidate = undefined;
    try {
        for (var children_2 = __values(children), children_2_1 = children_2.next(); !children_2_1.done; children_2_1 = children_2.next()) {
            var candidate = children_2_1.value;
            var path = (0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: candidate.paths, locale: locale });
            // Does the candidate statically match?
            if (path === currentPathPart) {
                // It does! But does its children match too?
                var childrenParsedPathParts = (0, exports.parsePathParts)({ locale: locale, pathParts: nextPathParts, routeBranch: candidate });
                if (childrenParsedPathParts) {
                    // They do! Let's return the result immediately
                    return __assign(__assign({}, childrenParsedPathParts), { parsedPathParts: __spreadArray([candidate.name], __read(childrenParsedPathParts.parsedPathParts), false), firstMatchType: MATCH_TYPE.STATIC });
                }
            }
            var isAnyDynamicPathPattern = regex_1.anyDynamicPathPatternPartRegex.test(path);
            var isIgnorePathPattern = regex_1.ignoreSegmentPathRegex.test(path);
            // Does the candidate path is static even if it does not match?
            if (!isAnyDynamicPathPattern && !isIgnorePathPattern) {
                // This candidate is static and does not match the currentPathPart: no need to check further
                continue;
            }
            // So this candidate is not static
            // Let's classify it to use it later and first look for a static match (priority):
            // is it path-ignored, dynamic, or match-all?
            if (isIgnorePathPattern) {
                // It is path-ignored, let's unshift (hight priority) it among the delayedCandidates
                delayedCandidates.unshift({ candidate: candidate, isPathIgnored: true });
                continue;
            }
            else if ((0, path_to_regexp_1.parse)(path).some(function (ptrToken) { return typeof ptrToken === 'object' && ['+', '*'].includes(ptrToken.modifier); })) {
                // It is a match-all path: let's store it alone (there can be only one)
                matchAllCandidate = candidate;
            }
            else {
                // It is a dynamic path, let's push (low priority) it among the delayedCandidates
                delayedCandidates.push({ candidate: candidate, isPathIgnored: false });
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (children_2_1 && !children_2_1.done && (_b = children_2.return)) _b.call(children_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    // Now we know that there is no static match among these children
    // 2. & 3.Let's take care of these delayed candidates
    /**
     * We will store here the non static matches from path-ignored candidates
     * to handle them if there is not dynamic match among the current children
     */
    var pathIgnoredResults = {};
    try {
        for (var delayedCandidates_1 = __values(delayedCandidates), delayedCandidates_1_1 = delayedCandidates_1.next(); !delayedCandidates_1_1.done; delayedCandidates_1_1 = delayedCandidates_1.next()) {
            var _e = delayedCandidates_1_1.value, candidate = _e.candidate, isPathIgnored = _e.isPathIgnored;
            if (isPathIgnored) {
                // 2. Let's look among the descendants of this path-ignored candidate
                var rawResult = (0, exports.parsePathParts)({
                    locale: locale,
                    routeBranch: candidate,
                    pathParts: pathParts,
                });
                if (rawResult) {
                    // Found a match
                    var result = __assign(__assign({}, rawResult), { parsedPathParts: __spreadArray([candidate.name], __read(rawResult.parsedPathParts), false) });
                    if (rawResult.firstMatchType === MATCH_TYPE.STATIC) {
                        // Static match: that's it, let's take this one
                        return result;
                    }
                    else {
                        // Let's store it for now, we will use it if we don't find something better
                        pathIgnoredResults[rawResult.firstMatchType] = result;
                    }
                }
            }
            else {
                // 3. If we are here, it means that we did not find any static match, even among path-ignored candidates descendants,
                // because we sorted the candidates in the delayedCandidates array: first the path-ignored candidates, then the dynamic ones.
                var path = (0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: candidate.paths, locale: locale });
                var match = (0, path_to_regexp_1.match)(path)(currentPathPart);
                if (match) {
                    // It matches! But does its children match too?
                    var childrenParsedPathParts = (0, exports.parsePathParts)({ locale: locale, pathParts: nextPathParts, routeBranch: candidate });
                    if (childrenParsedPathParts) {
                        // They do! Let's return the result immediately
                        return {
                            parsedPathParts: __spreadArray([candidate.name], __read(childrenParsedPathParts.parsedPathParts), false),
                            additionalQuery: __assign(__assign({}, childrenParsedPathParts.additionalQuery), match.params),
                            firstMatchType: MATCH_TYPE.DYNAMIC,
                        };
                    }
                }
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (delayedCandidates_1_1 && !delayedCandidates_1_1.done && (_c = delayedCandidates_1.return)) _c.call(delayedCandidates_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    // 4. Do we have a dynamic match stored in the pathIgnoredMatches?
    if (pathIgnoredResults[MATCH_TYPE.DYNAMIC]) {
        // Yes, let's return it
        return pathIgnoredResults[MATCH_TYPE.DYNAMIC];
    }
    // 5. Do we have a matchAllCandidate stored?
    if (matchAllCandidate) {
        // Yes.
        var path = (0, getPathFromPaths_1.getLocalePathFromPaths)({ paths: matchAllCandidate.paths, locale: locale });
        var match = (0, path_to_regexp_1.match)('/' + path)('/' + pathParts.join('/'));
        if (match) {
            // It matches! And it does not have children (or should not).
            return {
                parsedPathParts: [matchAllCandidate.name],
                additionalQuery: match.params,
                firstMatchType: MATCH_TYPE.MATCHALL,
            };
        }
    }
    // 6. Do we have a match all match stored in the pathIgnoredMatches?
    if (pathIgnoredResults[MATCH_TYPE.DYNAMIC]) {
        // Yes, let's return it
        return pathIgnoredResults[MATCH_TYPE.DYNAMIC];
    }
    // Still there? No match then.
    return undefined;
};
exports.parsePathParts = parsePathParts;
/**
 * Parse a translated url to get the corresponding file url (UrlObject)
 *
 * Ex: `urlToFileUrl('/fr/mon/url/de/france', 'fr')` => `{ pathname: '/my/url/from/[country], query: { country: 'france' } }`
 *
 * @param url The url to parse: can be a string, an URL or an UrlObject
 * @param locale (optional) The locale corresponding to the url translation.
 * If omitted, urlToFileUrl will look for the locale in the first path part.
 * If it does not match a locale, urlToFileUrl will use the default locale.
 *
 * @returns The file path based, Next.js format, url in UrlObject format
 * if the url successfully matched a file path, and undefined otherwise
 */
var urlToFileUrl = function (url, locale) {
    var _a = (0, ntrData_1.getNtrData)(), routesTree = _a.routesTree, defaultLocale = _a.defaultLocale, locales = _a.locales;
    var _b = (0, parseUrl_1.parseUrl)(url), pathname = _b.pathname, query = _b.query, hash = _b.hash;
    if (pathname && regex_1.anyDynamicFilepathPartsRegex.exec(pathname)) {
        // The given url seems to already be a fileUrl, return it as is.
        // Not sure if we should return undefined instead. Or throw?
        return { pathname: pathname, query: query, hash: hash };
    }
    var result = (0, exports.parsePathParts)({
        locale: locale || defaultLocale || locales[0],
        routeBranch: routesTree,
        pathParts: (0, removeLangPrefix_1.removeLangPrefix)(pathname || '/', true, locale),
    });
    if (result) {
        var parsedPathParts = result.parsedPathParts, additionalQuery = result.additionalQuery;
        return __assign({ pathname: "/".concat(parsedPathParts.join('/')), query: __assign(__assign({}, query), additionalQuery) }, (hash && { hash: hash }));
    }
    return undefined;
};
exports.urlToFileUrl = urlToFileUrl;
//# sourceMappingURL=urlToFileUrl.js.map

/***/ }),

/***/ 72510:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withTranslateRoutes = void 0;
var router_context_1 = __webpack_require__(63462);
var router_1 = __webpack_require__(11163);
var react_1 = __importStar(__webpack_require__(67294));
var ntrData_1 = __webpack_require__(32654);
var withNtrPrefix_1 = __webpack_require__(30270);
var enhanceNextRouter_1 = __webpack_require__(33477);
/**
 * Must wrap the App component in `pages/_app`.
 * This HOC will make the route push, replace, and refetch functions able to translate routes.
 */
var withTranslateRoutes = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // ntrData argument is added as a argument by webpack next-translate-routes/loader, and can also be added manually
    var _a = args.reduce(function (acc, arg) {
        if (typeof arg === 'function') {
            return __assign(__assign({}, acc), { AppComponent: arg });
        }
        return __assign(__assign({}, acc), { ntrData: __assign(__assign({}, acc.ntrData), arg) });
    }, {}), ntrData = _a.ntrData, AppComponent = _a.AppComponent;
    if (!AppComponent) {
        throw new Error(withNtrPrefix_1.ntrMessagePrefix + 'No wrapped App component in withTranslateRoutes');
    }
    if (!ntrData) {
        throw new Error(withNtrPrefix_1.ntrMessagePrefix +
            'No translate routes data found. next-translate-routes plugin is probably missing from next.config.js');
    }
    (0, ntrData_1.setNtrData)(ntrData);
    if (ntrData.debug && typeof window !== 'undefined') {
        console.log(withNtrPrefix_1.ntrMessagePrefix + 'withTranslateRoutes. NTR data:', ntrData);
    }
    var WithTranslateRoutesApp = function (props) {
        var nextRouter = (0, router_1.useRouter)();
        var enhancedRouter = (0, react_1.useMemo)(function () { return (nextRouter ? (0, enhanceNextRouter_1.enhanceNextRouter)(nextRouter) : props.router); }, [nextRouter, props.router]);
        if (nextRouter && !nextRouter.locale) {
            var fallbackLocale = ntrData.defaultLocale || ntrData.locales[0];
            nextRouter.locale = fallbackLocale;
            console.error(withNtrPrefix_1.ntrMessagePrefix + "No locale prop in Router: fallback to ".concat(fallbackLocale, "."));
        }
        return (react_1.default.createElement(router_context_1.RouterContext.Provider, { value: enhancedRouter },
            react_1.default.createElement(AppComponent, __assign({}, props))));
    };
    WithTranslateRoutesApp.getInitialProps = 'getInitialProps' in AppComponent ? AppComponent.getInitialProps : undefined;
    return WithTranslateRoutesApp;
};
exports.withTranslateRoutes = withTranslateRoutes;
//# sourceMappingURL=withTranslateRoutes.js.map

/***/ }),

/***/ 56827:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
__exportStar(__webpack_require__(27092), exports);
var router_1 = __webpack_require__(27092);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(router_1).default; } }));
//# sourceMappingURL=router.js.map

/***/ }),

/***/ 32654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getNtrData = exports.setNtrData = void 0;
var setNtrData = function (ntrData) {
    if (typeof window === 'undefined') {
        __webpack_require__.g.__NEXT_TRANSLATE_ROUTES_DATA = ntrData;
    }
    else {
        window.__NEXT_TRANSLATE_ROUTES_DATA = ntrData;
    }
};
exports.setNtrData = setNtrData;
var getNtrData = function () {
    return (typeof window === 'undefined'
        ? __webpack_require__.g.__NEXT_TRANSLATE_ROUTES_DATA
        : window.__NEXT_TRANSLATE_ROUTES_DATA);
};
exports.getNtrData = getNtrData;
//# sourceMappingURL=ntrData.js.map

/***/ }),

/***/ 71224:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dynamicFilepathPartsRegex = exports.getDynamicPathPartKey = exports.dynamicFilepathPartRegex = exports.getSpreadFilepathPartKey = exports.spreadFilepathPartRegex = exports.matchAllFilepathPartsRegex = exports.optionalMatchAllFilepathPartRegex = exports.anyDynamicPathPatternPartRegex = exports.anyDynamicFilepathPartsRegex = exports.anyDynamicFilepathPartRegex = exports.ignoreSegmentPathRegex = void 0;
/**
 * A segment can be ignored by setting its path to `"."` in _routes.json.
 * It can be done for some lang only and not others.
 *
 * ⚠️ It can cause troubles with the **redirections**.
 *
 * Ex: given the `/a/[b]/[c]` and `/a/[b]/[c]/d` file paths where `[b]` is ignored and the b param is merged with the c param: `:b-:c`.
 * `/a/:b/:c` => `/a/:b-:c` and `/a/:b/:c/d` => `/a/:b-:c/d`
 * Then `/a/bb/11` will be redirected to `/a/bb-11` and `/a/bb/11/d` to `/a/bb-11/d` and that is fine.
 * But then `/a/bb-11/d` will match `/a/:b-:c` and be redirected to `/a/bb-11-d` and that is not fine!
 *
 * To handle this case, one can add a path-to-regex pattern to the default ignore token. Ex: `.(\\d+)`, or `.(\[\^-\]+)`, or `.(\what|ever\)`.
 * This path-to-regex pattern will be added after the segment name in the redirect.
 * `/a/:b(\[\^-\]+)/:c` => `/a/:b-:c` and `/a/:b(\[\^-\]+)/:c/d` => `/a/:b-:c/d`
 * Then `/a/bb-11/d` will no more match `/a/[b]/[c]` (`/a/:b(\[\^-\]+)/:c`).
 *
 * ⚠️ This is only handled in default paths (i.e. `"/": ".(\\d+)"` or `"/": { "default": ".(\\d+)" }`), not in lang-specific paths.
 *
 * #ignorePattern
 */
exports.ignoreSegmentPathRegex = /^\.(\(.+\))?$/;
/**
 * Ex: `[slug]` or `[...pathParts]` or `[[...pathParts]]`
 */
exports.anyDynamicFilepathPartRegex = /^\[\[?(?:\.{3})?([^/[\]?#]+)\]?\]$/;
/**
 * Match all dynamic parts: `[slug]` and `[...pathParts]` and `[[...pathParts]]`
 */
exports.anyDynamicFilepathPartsRegex = /\[\[?(?:\.{3})?([^/[\]?#]+)\]?\]/g;
/**
 * Ex: `:slug` or `:pathParts*` or `:pathParts+` or `foo-:bar`
 */
exports.anyDynamicPathPatternPartRegex = /(?:^|[^\\]):[\d\w]+/;
/**
 * Ex: `[[...pathParts]]`
 */
exports.optionalMatchAllFilepathPartRegex = /^\[\[\.{3}([^/[\]?#]+)\]\]$/;
/**
 * Match all `[...pathParts]` parts but not `[[...pathParts]]` parts
 */
exports.matchAllFilepathPartsRegex = /\[\.{3}([^/[\]?#]+)\]/g;
/**
 * A "spread path part" is either a match-all path part (`[...pathParts]`),
 * either an optional match all path part (`[[...pathParts]]`)
 */
exports.spreadFilepathPartRegex = /^\[\[?\.{3}([^/[\]?#]+)\]?\]$/;
/** Ex: `'[...pathParts]'` => `'pathParts'` and `'[[...pathParts]]'` => `pathParts` but `'[slug]'` => `null` and `'pathPart'` => `null` */
var getSpreadFilepathPartKey = function (pathPart) { var _a; return ((_a = exports.spreadFilepathPartRegex.exec(pathPart)) === null || _a === void 0 ? void 0 : _a[1]) || null; };
exports.getSpreadFilepathPartKey = getSpreadFilepathPartKey;
/**
 * Ex: `[slug]` and neither `[...pathParts]` nor `[[...pathParts]]`
 */
exports.dynamicFilepathPartRegex = /^\[(?!\.{3})([^/[\]?#]*)\]$/;
/** Ex: `'[slug]'` => `'slug'` but `'[...pathParts]'` => `null` and '`pathPart'` => `null` */
var getDynamicPathPartKey = function (pathPart) { var _a; return ((_a = exports.dynamicFilepathPartRegex.exec(pathPart)) === null || _a === void 0 ? void 0 : _a[1]) || null; };
exports.getDynamicPathPartKey = getDynamicPathPartKey;
/**
 * Match all `[slug]` parts but neither `[...pathParts]` parts nor `[[...pathParts]]` parts
 */
exports.dynamicFilepathPartsRegex = /\[(?!\.{3})([^/[\]?#]*)\]/g;
//# sourceMappingURL=regex.js.map

/***/ }),

/***/ 30270:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ntrMessagePrefix = void 0;
exports.ntrMessagePrefix = '[next-translate-routes] - ';
//# sourceMappingURL=withNtrPrefix.js.map

/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(45263);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/index.js
var next_translate_routes = __webpack_require__(18633);
// EXTERNAL MODULE: ./src/@next/components/organisms/Toastr/index.ts + 4 modules
var Toastr = __webpack_require__(96231);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(48964);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(85317);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js



var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    return (react.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
        __DEV__ ? (0,globals/* invariant */.kG)(context.client, 'ApolloProvider was not passed a client instance. Make ' +
            'sure you pass in your client via the "client" prop.') : (0,globals/* invariant */.kG)(context.client, 29);
        return (react.createElement(ApolloContext.Provider, { value: context }, children));
    }));
};
//# sourceMappingURL=ApolloProvider.js.map
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(48702);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 8 modules
var ApolloClient = __webpack_require__(65075);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(55598);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/utils/fromError.js
var fromError = __webpack_require__(16261);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js + 1 modules
var selectHttpOptionsAndBody = __webpack_require__(58995);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/checkFetcher.js
var checkFetcher = __webpack_require__(23178);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/selectURI.js
var selectURI = __webpack_require__(11037);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/serializeFetchParameter.js
var serializeFetchParameter = __webpack_require__(15049);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/createSignalIfSupported.js
var createSignalIfSupported = __webpack_require__(77388);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js + 6 modules
var parseAndCheckHttpResponse = __webpack_require__(93227);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/batch/batching.js


var OperationBatcher = (function () {
    function OperationBatcher(_a) {
        var batchDebounce = _a.batchDebounce, batchInterval = _a.batchInterval, batchMax = _a.batchMax, batchHandler = _a.batchHandler, batchKey = _a.batchKey;
        this.batchesByKey = new Map();
        this.scheduledBatchTimerByKey = new Map();
        this.batchDebounce = batchDebounce;
        this.batchInterval = batchInterval;
        this.batchMax = batchMax || 0;
        this.batchHandler = batchHandler;
        this.batchKey = batchKey || (function () { return ''; });
    }
    OperationBatcher.prototype.enqueueRequest = function (request) {
        var _this = this;
        var requestCopy = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, request), { next: [], error: [], complete: [], subscribers: new Set() });
        var key = this.batchKey(request.operation);
        if (!requestCopy.observable) {
            requestCopy.observable = new zen_observable_ts_module/* Observable */.y(function (observer) {
                var batch = _this.batchesByKey.get(key);
                if (!batch)
                    _this.batchesByKey.set(key, batch = new Set());
                var isFirstEnqueuedRequest = batch.size === 0;
                var isFirstSubscriber = requestCopy.subscribers.size === 0;
                requestCopy.subscribers.add(observer);
                if (isFirstSubscriber) {
                    batch.add(requestCopy);
                }
                if (observer.next) {
                    requestCopy.next.push(observer.next.bind(observer));
                }
                if (observer.error) {
                    requestCopy.error.push(observer.error.bind(observer));
                }
                if (observer.complete) {
                    requestCopy.complete.push(observer.complete.bind(observer));
                }
                if (isFirstEnqueuedRequest || _this.batchDebounce) {
                    _this.scheduleQueueConsumption(key);
                }
                if (batch.size === _this.batchMax) {
                    _this.consumeQueue(key);
                }
                return function () {
                    var _a;
                    if (requestCopy.subscribers.delete(observer) &&
                        requestCopy.subscribers.size < 1) {
                        if (batch.delete(requestCopy) && batch.size < 1) {
                            _this.consumeQueue(key);
                            (_a = batch.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
                        }
                    }
                };
            });
        }
        return requestCopy.observable;
    };
    OperationBatcher.prototype.consumeQueue = function (key) {
        if (key === void 0) { key = ''; }
        var batch = this.batchesByKey.get(key);
        this.batchesByKey.delete(key);
        if (!batch || !batch.size) {
            return;
        }
        var operations = [];
        var forwards = [];
        var observables = [];
        var nexts = [];
        var errors = [];
        var completes = [];
        batch.forEach(function (request) {
            operations.push(request.operation);
            forwards.push(request.forward);
            observables.push(request.observable);
            nexts.push(request.next);
            errors.push(request.error);
            completes.push(request.complete);
        });
        var batchedObservable = this.batchHandler(operations, forwards) || zen_observable_ts_module/* Observable.of */.y.of();
        var onError = function (error) {
            errors.forEach(function (rejecters) {
                if (rejecters) {
                    rejecters.forEach(function (e) { return e(error); });
                }
            });
        };
        batch.subscription = batchedObservable.subscribe({
            next: function (results) {
                if (!Array.isArray(results)) {
                    results = [results];
                }
                if (nexts.length !== results.length) {
                    var error = new Error("server returned results with length ".concat(results.length, ", expected length of ").concat(nexts.length));
                    error.result = results;
                    return onError(error);
                }
                results.forEach(function (result, index) {
                    if (nexts[index]) {
                        nexts[index].forEach(function (next) { return next(result); });
                    }
                });
            },
            error: onError,
            complete: function () {
                completes.forEach(function (complete) {
                    if (complete) {
                        complete.forEach(function (c) { return c(); });
                    }
                });
            },
        });
        return observables;
    };
    OperationBatcher.prototype.scheduleQueueConsumption = function (key) {
        var _this = this;
        clearTimeout(this.scheduledBatchTimerByKey.get(key));
        this.scheduledBatchTimerByKey.set(key, setTimeout(function () {
            _this.consumeQueue(key);
            _this.scheduledBatchTimerByKey.delete(key);
        }, this.batchInterval));
    };
    return OperationBatcher;
}());

//# sourceMappingURL=batching.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/batch/batchLink.js




var BatchLink = (function (_super) {
    (0,tslib_es6.__extends)(BatchLink, _super);
    function BatchLink(fetchParams) {
        var _this = _super.call(this) || this;
        var _a = fetchParams || {}, batchDebounce = _a.batchDebounce, _b = _a.batchInterval, batchInterval = _b === void 0 ? 10 : _b, _c = _a.batchMax, batchMax = _c === void 0 ? 0 : _c, _d = _a.batchHandler, batchHandler = _d === void 0 ? function () { return null; } : _d, _e = _a.batchKey, batchKey = _e === void 0 ? function () { return ''; } : _e;
        _this.batcher = new OperationBatcher({
            batchDebounce: batchDebounce,
            batchInterval: batchInterval,
            batchMax: batchMax,
            batchHandler: batchHandler,
            batchKey: batchKey,
        });
        if (fetchParams.batchHandler.length <= 1) {
            _this.request = function (operation) { return _this.batcher.enqueueRequest({ operation: operation }); };
        }
        return _this;
    }
    BatchLink.prototype.request = function (operation, forward) {
        return this.batcher.enqueueRequest({
            operation: operation,
            forward: forward,
        });
    };
    return BatchLink;
}(ApolloLink/* ApolloLink */.i));

//# sourceMappingURL=batchLink.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/batch-http/batchHttpLink.js






var BatchHttpLink = (function (_super) {
    (0,tslib_es6.__extends)(BatchHttpLink, _super);
    function BatchHttpLink(fetchParams) {
        var _this = _super.call(this) || this;
        var _a = fetchParams || {}, _b = _a.uri, uri = _b === void 0 ? '/graphql' : _b, fetcher = _a.fetch, _c = _a.print, print = _c === void 0 ? selectHttpOptionsAndBody/* defaultPrinter */.sb : _c, includeExtensions = _a.includeExtensions, preserveHeaderCase = _a.preserveHeaderCase, batchInterval = _a.batchInterval, batchDebounce = _a.batchDebounce, batchMax = _a.batchMax, batchKey = _a.batchKey, requestOptions = (0,tslib_es6.__rest)(_a, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "batchInterval", "batchDebounce", "batchMax", "batchKey"]);
        (0,checkFetcher/* checkFetcher */.U)(fetcher);
        if (!fetcher) {
            fetcher = fetch;
        }
        var linkConfig = {
            http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers,
        };
        _this.batchDebounce = batchDebounce;
        _this.batchInterval = batchInterval || 10;
        _this.batchMax = batchMax || 10;
        var batchHandler = function (operations) {
            var chosenURI = (0,selectURI/* selectURI */.r)(operations[0], uri);
            var context = operations[0].getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) {
                    clientAwarenessHeaders['apollographql-client-name'] = name_1;
                }
                if (version) {
                    clientAwarenessHeaders['apollographql-client-version'] = version;
                }
            }
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, clientAwarenessHeaders), context.headers),
            };
            var optsAndBody = operations.map(function (operation) {
                return (0,selectHttpOptionsAndBody/* selectHttpOptionsAndBodyInternal */.ve)(operation, print, selectHttpOptionsAndBody/* fallbackHttpConfig */.SC, linkConfig, contextConfig);
            });
            var loadedBody = optsAndBody.map(function (_a) {
                var body = _a.body;
                return body;
            });
            var options = optsAndBody[0].options;
            if (options.method === 'GET') {
                return (0,fromError/* fromError */.Q)(new Error('apollo-link-batch-http does not support GET requests'));
            }
            try {
                options.body = (0,serializeFetchParameter/* serializeFetchParameter */.g)(loadedBody, 'Payload');
            }
            catch (parseError) {
                return (0,fromError/* fromError */.Q)(parseError);
            }
            var controller;
            if (!options.signal) {
                var _b = (0,createSignalIfSupported/* createSignalIfSupported */.$)(), _controller = _b.controller, signal = _b.signal;
                controller = _controller;
                if (controller)
                    options.signal = signal;
            }
            return new zen_observable_ts_module/* Observable */.y(function (observer) {
                fetcher(chosenURI, options)
                    .then(function (response) {
                    operations.forEach(function (operation) { return operation.setContext({ response: response }); });
                    return response;
                })
                    .then((0,parseAndCheckHttpResponse/* parseAndCheckHttpResponse */.dO)(operations))
                    .then(function (result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                })
                    .catch(function (err) {
                    if (err.name === 'AbortError')
                        return;
                    if (err.result && err.result.errors && err.result.data) {
                        observer.next(err.result);
                    }
                    observer.error(err);
                });
                return function () {
                    if (controller)
                        controller.abort();
                };
            });
        };
        batchKey =
            batchKey ||
                (function (operation) {
                    var context = operation.getContext();
                    var contextConfig = {
                        http: context.http,
                        options: context.fetchOptions,
                        credentials: context.credentials,
                        headers: context.headers,
                    };
                    return (0,selectURI/* selectURI */.r)(operation, uri) + JSON.stringify(contextConfig);
                });
        _this.batcher = new BatchLink({
            batchDebounce: _this.batchDebounce,
            batchInterval: _this.batchInterval,
            batchMax: _this.batchMax,
            batchKey: batchKey,
            batchHandler: batchHandler,
        });
        return _this;
    }
    BatchHttpLink.prototype.request = function (operation) {
        return this.batcher.request(operation);
    };
    return BatchHttpLink;
}(ApolloLink/* ApolloLink */.i));

//# sourceMappingURL=batchHttpLink.js.map
// EXTERNAL MODULE: ./node_modules/apollo-upload-client/public/createUploadLink.js
var createUploadLink = __webpack_require__(89776);
var createUploadLink_default = /*#__PURE__*/__webpack_require__.n(createUploadLink);
;// CONCATENATED MODULE: ./node_modules/is-plain-obj/index.js
function isPlainObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

;// CONCATENATED MODULE: ./node_modules/extract-files/extractFiles.mjs
// @ts-check

// @deno-types="is-plain-obj/index.d.ts"


/** @typedef {import("./isExtractableFile.mjs").default} isExtractableFile */

/**
 * Recursively extracts files and their {@link ObjectPath object paths} within a
 * value, replacing them with `null` in a deep clone without mutating the
 * original value.
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/Filelist)
 * instances are treated as
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File) instance
 * arrays.
 * @template Extractable Extractable file type.
 * @param {unknown} value Value to extract files from. Typically an object tree.
 * @param {(value: unknown) => value is Extractable} isExtractable Matches
 *   extractable files. Typically {@linkcode isExtractableFile}.
 * @param {ObjectPath} [path] Prefix for object paths for extracted files.
 *   Defaults to `""`.
 * @returns {Extraction<Extractable>} Extraction result.
 * @example
 * Extracting files from an object.
 *
 * For the following:
 *
 * ```js
 * import extractFiles from "extract-files/extractFiles.mjs";
 * import isExtractableFile from "extract-files/isExtractableFile.mjs";
 *
 * const file1 = new File(["1"], "1.txt", { type: "text/plain" });
 * const file2 = new File(["2"], "2.txt", { type: "text/plain" });
 * const value = {
 *   a: file1,
 *   b: [file1, file2],
 * };
 *
 * const { clone, files } = extractFiles(value, isExtractableFile, "prefix");
 * ```
 *
 * `value` remains the same.
 *
 * `clone` is:
 *
 * ```json
 * {
 *   "a": null,
 *   "b": [null, null]
 * }
 * ```
 *
 * `files` is a
 * [`Map`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map)
 * instance containing:
 *
 * | Key     | Value                        |
 * | :------ | :--------------------------- |
 * | `file1` | `["prefix.a", "prefix.b.0"]` |
 * | `file2` | `["prefix.b.1"]`             |
 */
function extractFiles(value, isExtractable, path = "") {
  if (!arguments.length) throw new TypeError("Argument 1 `value` is required.");

  if (typeof isExtractable !== "function")
    throw new TypeError("Argument 2 `isExtractable` must be a function.");

  if (typeof path !== "string")
    throw new TypeError("Argument 3 `path` must be a string.");

  /**
   * Deeply clonable value.
   * @typedef {Array<unknown> | FileList | {
   *   [key: PropertyKey]: unknown
   * }} Cloneable
   */

  /**
   * Clone of a {@link Cloneable deeply cloneable value}.
   * @typedef {Exclude<Cloneable, FileList>} Clone
   */

  /**
   * Map of values recursed within the input value and their clones, for reusing
   * clones of values that are referenced multiple times within the input value.
   * @type {Map<Cloneable, Clone>}
   */
  const clones = new Map();

  /**
   * Extracted files and their object paths within the input value.
   * @type {Extraction<Extractable>["files"]}
   */
  const files = new Map();

  /**
   * Recursively clones the value, extracting files.
   * @param {unknown} value Value to extract files from.
   * @param {ObjectPath} path Prefix for object paths for extracted files.
   * @param {Set<Cloneable>} recursed Recursed values for avoiding infinite
   *   recursion of circular references within the input value.
   * @returns {unknown} Clone of the value with files replaced with `null`.
   */
  function recurse(value, path, recursed) {
    if (isExtractable(value)) {
      const filePaths = files.get(value);

      filePaths ? filePaths.push(path) : files.set(value, [path]);

      return null;
    }

    const valueIsList =
      Array.isArray(value) ||
      (typeof FileList !== "undefined" && value instanceof FileList);
    const valueIsPlainObject = isPlainObject(value);

    if (valueIsList || valueIsPlainObject) {
      let clone = clones.get(value);

      const uncloned = !clone;

      if (uncloned) {
        clone = valueIsList
          ? []
          : // Replicate if the plain object is an `Object` instance.
          value instanceof /** @type {any} */ (Object)
          ? {}
          : Object.create(null);

        clones.set(value, /** @type {Clone} */ (clone));
      }

      if (!recursed.has(value)) {
        const pathPrefix = path ? `${path}.` : "";
        const recursedDeeper = new Set(recursed).add(value);

        if (valueIsList) {
          let index = 0;

          for (const item of value) {
            const itemClone = recurse(
              item,
              pathPrefix + index++,
              recursedDeeper
            );

            if (uncloned) /** @type {Array<unknown>} */ (clone).push(itemClone);
          }
        } else
          for (const key in value) {
            const propertyClone = recurse(
              value[key],
              pathPrefix + key,
              recursedDeeper
            );

            if (uncloned)
              /** @type {{ [key: PropertyKey]: unknown }} */ (clone)[key] =
                propertyClone;
          }
      }

      return clone;
    }

    return value;
  }

  return {
    clone: recurse(value, path, new Set()),
    files,
  };
}

/**
 * An extraction result.
 * @template [Extractable=unknown] Extractable file type.
 * @typedef {object} Extraction
 * @prop {unknown} clone Clone of the original value with extracted files
 *   recursively replaced with `null`.
 * @prop {Map<Extractable, Array<ObjectPath>>} files Extracted files and their
 *   object paths within the original value.
 */

/**
 * String notation for the path to a node in an object tree.
 * @typedef {string} ObjectPath
 * @see [`object-path` on npm](https://npm.im/object-path).
 * @example
 * An object path for object property `a`, array index `0`, object property `b`:
 *
 * ```
 * a.0.b
 * ```
 */

;// CONCATENATED MODULE: ./node_modules/extract-files/isExtractableFile.mjs
// @ts-check

/**
 * Checks if a value is an {@link ExtractableFile extractable file}.
 * @param {unknown} value Value to check.
 * @returns {value is ExtractableFile} Is the value an
 *   {@link ExtractableFile extractable file}.
 */
function isExtractableFile(value) {
  return (
    (typeof File !== "undefined" && value instanceof File) ||
    (typeof Blob !== "undefined" && value instanceof Blob)
  );
}

/**
 * An extractable file.
 * @typedef {File | Blob} ExtractableFile
 */

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(182);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/policies/pagination.js



function concatPagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        merge: function (existing, incoming) {
            return existing ? __spreadArray(__spreadArray([], existing, true), incoming, true) : incoming;
        },
    };
}
function offsetLimitPagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        merge: function (existing, incoming, _a) {
            var args = _a.args;
            var merged = existing ? existing.slice(0) : [];
            if (incoming) {
                if (args) {
                    var _b = args.offset, offset = _b === void 0 ? 0 : _b;
                    for (var i = 0; i < incoming.length; ++i) {
                        merged[offset + i] = incoming[i];
                    }
                }
                else {
                    merged.push.apply(merged, incoming);
                }
            }
            return merged;
        },
    };
}
function relayStylePagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        read: function (existing, _a) {
            var canRead = _a.canRead, readField = _a.readField;
            if (!existing)
                return existing;
            var edges = [];
            var firstEdgeCursor = "";
            var lastEdgeCursor = "";
            existing.edges.forEach(function (edge) {
                if (canRead(readField("node", edge))) {
                    edges.push(edge);
                    if (edge.cursor) {
                        firstEdgeCursor = firstEdgeCursor || edge.cursor || "";
                        lastEdgeCursor = edge.cursor || lastEdgeCursor;
                    }
                }
            });
            if (edges.length > 1 && firstEdgeCursor === lastEdgeCursor) {
                firstEdgeCursor = "";
            }
            var _b = existing.pageInfo || {}, startCursor = _b.startCursor, endCursor = _b.endCursor;
            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, getExtras(existing)), { edges: edges, pageInfo: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, existing.pageInfo), { startCursor: startCursor || firstEdgeCursor, endCursor: endCursor || lastEdgeCursor }) });
        },
        merge: function (existing, incoming, _a) {
            var args = _a.args, isReference = _a.isReference, readField = _a.readField;
            if (!existing) {
                existing = makeEmptyData();
            }
            if (!incoming) {
                return existing;
            }
            var incomingEdges = incoming.edges ? incoming.edges.map(function (edge) {
                if (isReference(edge = (0,tslib_es6.__assign)({}, edge))) {
                    edge.cursor = readField("cursor", edge);
                }
                return edge;
            }) : [];
            if (incoming.pageInfo) {
                var pageInfo_1 = incoming.pageInfo;
                var startCursor = pageInfo_1.startCursor, endCursor = pageInfo_1.endCursor;
                var firstEdge = incomingEdges[0];
                var lastEdge = incomingEdges[incomingEdges.length - 1];
                if (firstEdge && startCursor) {
                    firstEdge.cursor = startCursor;
                }
                if (lastEdge && endCursor) {
                    lastEdge.cursor = endCursor;
                }
                var firstCursor = firstEdge && firstEdge.cursor;
                if (firstCursor && !startCursor) {
                    incoming = (0,mergeDeep/* mergeDeep */.Ee)(incoming, {
                        pageInfo: {
                            startCursor: firstCursor,
                        },
                    });
                }
                var lastCursor = lastEdge && lastEdge.cursor;
                if (lastCursor && !endCursor) {
                    incoming = (0,mergeDeep/* mergeDeep */.Ee)(incoming, {
                        pageInfo: {
                            endCursor: lastCursor,
                        },
                    });
                }
            }
            var prefix = existing.edges;
            var suffix = [];
            if (args && args.after) {
                var index = prefix.findIndex(function (edge) { return edge.cursor === args.after; });
                if (index >= 0) {
                    prefix = prefix.slice(0, index + 1);
                }
            }
            else if (args && args.before) {
                var index = prefix.findIndex(function (edge) { return edge.cursor === args.before; });
                suffix = index < 0 ? prefix : prefix.slice(index);
                prefix = [];
            }
            else if (incoming.edges) {
                prefix = [];
            }
            var edges = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], prefix, true), incomingEdges, true), suffix, true);
            var pageInfo = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, incoming.pageInfo), existing.pageInfo);
            if (incoming.pageInfo) {
                var _b = incoming.pageInfo, hasPreviousPage = _b.hasPreviousPage, hasNextPage = _b.hasNextPage, startCursor = _b.startCursor, endCursor = _b.endCursor, extras = (0,tslib_es6.__rest)(_b, ["hasPreviousPage", "hasNextPage", "startCursor", "endCursor"]);
                Object.assign(pageInfo, extras);
                if (!prefix.length) {
                    if (void 0 !== hasPreviousPage)
                        pageInfo.hasPreviousPage = hasPreviousPage;
                    if (void 0 !== startCursor)
                        pageInfo.startCursor = startCursor;
                }
                if (!suffix.length) {
                    if (void 0 !== hasNextPage)
                        pageInfo.hasNextPage = hasNextPage;
                    if (void 0 !== endCursor)
                        pageInfo.endCursor = endCursor;
                }
            }
            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, getExtras(existing)), getExtras(incoming)), { edges: edges, pageInfo: pageInfo });
        },
    };
}
var getExtras = function (obj) { return (0,tslib_es6.__rest)(obj, notExtras); };
var notExtras = ["edges", "pageInfo"];
function makeEmptyData() {
    return {
        edges: [],
        pageInfo: {
            hasPreviousPage: false,
            hasNextPage: true,
            startCursor: "",
            endCursor: "",
        },
    };
}
//# sourceMappingURL=pagination.js.map
;// CONCATENATED MODULE: ./src/@sdk/auth/typePolicies.ts

var typePolicies = {
    User: {
        fields: {
            orders: relayStylePagination()
        }
    },
    Query: {
        fields: {
            products: relayStylePagination([
                "filter",
                "sortBy"
            ]),
            reviews: relayStylePagination()
        }
    }
};
/* harmony default export */ var auth_typePolicies = ((/* unused pure expression or super */ null && (typePolicies)));

;// CONCATENATED MODULE: ./src/@sdk/auth/useAuthenticatedApolloClient.ts








var uploadAndBatchHTTPLink = function(opts) {
    return ApolloLink/* ApolloLink.split */.i.split(function(operation) {
        return extractFiles(operation, isExtractableFile).files.size > 0;
    }, createUploadLink_default()(opts), new BatchHttpLink(opts));
};
var useAuthenticatedApolloClient = function(fetchWithAuth) {
    var httpLink = uploadAndBatchHTTPLink({
        uri: constants/* API_URI */.G9,
        fetch: fetchWithAuth
    });
    var apolloClient = (0,react.useMemo)(function() {
        return new ApolloClient/* ApolloClient */.f({
            link: httpLink,
            cache: new inMemoryCache/* InMemoryCache */.h({
                typePolicies: typePolicies
            })
        });
    }, []);
    return {
        apolloClient: apolloClient,
        resetClient: function() {
            return apolloClient.resetStore();
        }
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(66128);
;// CONCATENATED MODULE: ./src/@sdk/auth/SaleorAuthStorageHandler.ts
/* eslint-disable class-methods-use-this */ /* auth state when user signs in / out */ 
var STORAGE_AUTH_EVENT_KEY = "saleor_auth_change";
var STORAGE_AUTH_STATE_KEY = "saleor_auth_state";
var REFRESH_TOKEN_KEY = "saleor_auth_refresh_token";
var SaleorAuthStorageHandler = function SaleorAuthStorageHandler(storage) {
    "use strict";
    var _this = this;
    (0,_class_call_check/* default */.Z)(this, SaleorAuthStorageHandler);
    this.handleStorageChange = function(event) {
        var oldValue = event.oldValue, newValue = event.newValue, type = event.type, key = event.key;
        if (oldValue === newValue || type !== "storage" || key !== STORAGE_AUTH_STATE_KEY) {
            return;
        }
        _this.sendAuthStateEvent(newValue);
    };
    this.cleanup = function() {
        window.removeEventListener("storage", _this.handleStorageChange);
    };
    /* auth state */ this.sendAuthStateEvent = function(authState) {
        var event = new CustomEvent(STORAGE_AUTH_EVENT_KEY, {
            detail: {
                authState: authState
            }
        });
        window.dispatchEvent(event);
    };
    this.getAuthState = function() {
        return _this.storage.getItem(STORAGE_AUTH_STATE_KEY) || "signedOut";
    };
    this.setAuthState = function(authState) {
        _this.storage.setItem(STORAGE_AUTH_STATE_KEY, authState);
        _this.sendAuthStateEvent(authState);
    };
    /* refresh token */ this.getRefreshToken = function() {
        return _this.storage.getItem(REFRESH_TOKEN_KEY) || null;
    };
    this.setRefreshToken = function(token) {
        _this.storage.setItem(REFRESH_TOKEN_KEY, token);
    };
    /* performed on logout */ this.clearAuthStorage = function() {
        _this.setAuthState("signedOut");
        _this.storage.removeItem(REFRESH_TOKEN_KEY);
    };
    this.storage = storage;
    window.addEventListener("storage", this.handleStorageChange);
};

// EXTERNAL MODULE: ./node_modules/graphql/language/index.js
var language = __webpack_require__(12178);
;// CONCATENATED MODULE: ./src/@sdk/auth/utils.ts
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];

var MILLI_MULTIPLYER = 1000;
var TOKEN_GRACE_PERIOD = 2000;
// returns timestamp
var getTokenExpiry = function(token) {
    var tokenParts = token.split(".");
    var decodedTokenData = Buffer.from(tokenParts[1] || "", "base64").toString();
    var parsedTokenData = JSON.parse(decodedTokenData);
    // because api returns seconds, but Date.now() works in millis
    return parsedTokenData.exp * MILLI_MULTIPLYER || 0;
};
var isExpiredToken = function(token) {
    return(// we'll assume a generous time of 2 seconds for api to
    // process our request
    getTokenExpiry(token) - TOKEN_GRACE_PERIOD <= Date.now());
};
// query here is document node but because of graphql-tag using
// a different version of graphql and pnpm overrides not working
// https://github.com/pnpm/pnpm/issues/4097
// we're gonna do this instead
var getRequestData = function(query, variables) {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            query: (0,language/* print */.S0)(query),
            variables: variables
        })
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 9 modules
var lib = __webpack_require__(22865);
;// CONCATENATED MODULE: ./src/@sdk/auth/mutations.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment AccountErrorFragment on AccountError {\n    code\n    field\n    message\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  mutation refreshToken($refreshToken: String!) {\n    tokenRefresh(refreshToken: $refreshToken) {\n      token\n      errors: accountErrors {\n        ...AccountErrorFragment\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  mutation tokenCreate($email: String!, $password: String!) {\n    tokenCreate(email: $email, password: $password) {\n      token\n      refreshToken\n      user {\n        email\n        firstName\n        lastName\n      }\n      errors: accountErrors {\n        ...AccountErrorFragment\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation passwordReset($email: String!, $password: String!, $token: String!) {\n    setPassword(email: $email, password: $password, token: $token) {\n      token\n      refreshToken\n      errors {\n        message\n        field\n        code\n      }\n      errors {\n        field\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var accountErrorFragment = (0,lib/* default */.ZP)(_templateObject());
var TOKEN_REFRESH = (0,lib/* default */.ZP)(_templateObject1(), accountErrorFragment);
var TOKEN_CREATE = (0,lib/* default */.ZP)(_templateObject2(), accountErrorFragment);
var PASSWORD_RESET = (0,lib/* default */.ZP)(_templateObject3());

;// CONCATENATED MODULE: ./src/@sdk/auth/SaleorAuthClient.ts









var SaleorAuthClient = function SaleorAuthClient(param) {
    "use strict";
    var saleorApiUrl = param.saleorApiUrl, storage = param.storage, onAuthRefresh = param.onAuthRefresh;
    var _this = this;
    (0,_class_call_check/* default */.Z)(this, SaleorAuthClient);
    this.accessToken = null;
    this.tokenRefreshPromise = null;
    this.cleanup = function() {
        var ref;
        (ref = _this.storageHandler) === null || ref === void 0 ? void 0 : ref.cleanup();
    };
    this.runAuthorizedRequest = function(input, init) {
        // technically we run this only when token is there
        // but just to make typescript happy
        if (!_this.accessToken) {
            return fetch(input, init);
        }
        var headers = (init === null || init === void 0 ? void 0 : init.headers) || {};
        return fetch(input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, init), {
            headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
                Authorization: "JWT ".concat(_this.accessToken)
            })
        }));
    };
    var _this1 = this;
    this.handleRequestWithTokenRefresh = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(input, init) {
            var ref, _obj, ref1, refreshToken, _obj1, ref2, ref3, response, res, graphqlErrors, _data, _tokenRefresh, errors, token, ref4;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        refreshToken = (ref = _this1.storageHandler) === null || ref === void 0 ? void 0 : ref.getRefreshToken();
                        (0,invariant/* default */.ZP)(refreshToken, "Missing refresh token in token refresh handler");
                        // the refresh already finished, proceed as normal
                        if (_this1.accessToken) {
                            return [
                                2,
                                _this1.fetchWithAuth(input, init)
                            ];
                        }
                        (ref1 = (_obj = _this1).onAuthRefresh) === null || ref1 === void 0 ? void 0 : ref1.call(_obj, true);
                        if (!_this1.tokenRefreshPromise) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this1.tokenRefreshPromise
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.clone().json()
                        ];
                    case 2:
                        res = _state.sent();
                        graphqlErrors = res.errors, _data = res.data, _tokenRefresh = _data.tokenRefresh, errors = _tokenRefresh.errors, token = _tokenRefresh.token;
                        (ref2 = (_obj1 = _this1).onAuthRefresh) === null || ref2 === void 0 ? void 0 : ref2.call(_obj1, false);
                        if (errors.length || (graphqlErrors === null || graphqlErrors === void 0 ? void 0 : graphqlErrors.length) || !token) {
                            ;
                            _this1.tokenRefreshPromise = null;
                            (ref4 = _this1.storageHandler) === null || ref4 === void 0 ? void 0 : ref4.clearAuthStorage();
                            return [
                                2,
                                fetch(input, init)
                            ];
                        }
                        (ref3 = _this1.storageHandler) === null || ref3 === void 0 ? void 0 : ref3.setAuthState("signedIn");
                        _this1.accessToken = token;
                        _this1.tokenRefreshPromise = null;
                        return [
                            2,
                            _this1.runAuthorizedRequest(input, init)
                        ];
                    case 3:
                        // this is the first failed request, initialize refresh
                        _this1.tokenRefreshPromise = fetch(_this1.saleorApiUrl, getRequestData(TOKEN_REFRESH, {
                            refreshToken: refreshToken
                        }));
                        return [
                            2,
                            _this1.fetchWithAuth(input, init)
                        ];
                }
            });
        });
        return function(input, init) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this2 = this;
    this.handleSignIn = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
            var ref, readResponse, responseData, errors, token, refreshToken, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        readResponse = _state.sent();
                        responseData = "tokenCreate" in readResponse.data ? readResponse.data.tokenCreate : readResponse.data.setPassword;
                        if (!responseData) {
                            return [
                                2,
                                readResponse
                            ];
                        }
                        errors = responseData.errors, token = responseData.token, refreshToken = responseData.refreshToken;
                        if (!token || errors.length) {
                            ;
                            (ref1 = _this2.storageHandler) === null || ref1 === void 0 ? void 0 : ref1.setAuthState("signedOut");
                            return [
                                2,
                                readResponse
                            ];
                        }
                        if (token) {
                            _this2.accessToken = token;
                        }
                        if (refreshToken) {
                            ;
                            (ref2 = _this2.storageHandler) === null || ref2 === void 0 ? void 0 : ref2.setRefreshToken(refreshToken);
                        }
                        (ref = _this2.storageHandler) === null || ref === void 0 ? void 0 : ref.setAuthState("signedIn");
                        return [
                            2,
                            readResponse
                        ];
                }
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this3 = this;
    this.fetchWithAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(input, init) {
            var ref, refreshToken;
            return (0,tslib_es6.__generator)(this, function(_state) {
                refreshToken = (ref = _this3.storageHandler) === null || ref === void 0 ? void 0 : ref.getRefreshToken();
                // access token is fine, add it to the request and proceed
                if (_this3.accessToken && !isExpiredToken(_this3.accessToken)) {
                    return [
                        2,
                        _this3.runAuthorizedRequest(input, init)
                    ];
                }
                // refresh token exists, try to authenticate if possible
                if (refreshToken) {
                    return [
                        2,
                        _this3.handleRequestWithTokenRefresh(input, init)
                    ];
                }
                // any regular mutation, no previous sign in, proceed
                return [
                    2,
                    fetch(input, init)
                ];
            });
        });
        return function(input, init) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this4 = this;
    this.resetPassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(variables) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(_this4.saleorApiUrl, getRequestData(PASSWORD_RESET, variables))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            _this4.handleSignIn(response)
                        ];
                }
            });
        });
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this5 = this;
    this.signIn = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(variables) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(_this5.saleorApiUrl, getRequestData(TOKEN_CREATE, variables))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            _this5.handleSignIn(response)
                        ];
                }
            });
        });
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    this.signOut = function() {
        var ref;
        _this.accessToken = null;
        (ref = _this.storageHandler) === null || ref === void 0 ? void 0 : ref.clearAuthStorage();
    };
    this.storageHandler = storage ? new SaleorAuthStorageHandler(storage) : null;
    this.onAuthRefresh = onAuthRefresh;
    this.saleorApiUrl = saleorApiUrl;
};

// EXTERNAL MODULE: ./src/@sdk/auth/SaleorAuthProvider.tsx
var SaleorAuthProvider = __webpack_require__(27941);
;// CONCATENATED MODULE: ./src/@sdk/auth/useSaleorAuthClient.ts


/**
 * This hook should be used only once per application.
 * @see Use {@link useSaleorAuthContext} for accessing the auth state.
 */ var useSaleorAuthClient = function(param) {
    var saleorApiUrl = param.saleorApiUrl, storage = param.storage, onAuthRefresh = param.onAuthRefresh;
    var ref = (0,react.useState)(false), isAuthenticating = ref[0], setIsAuthenticating = ref[1];
    var saleorAuthClient = (0,react.useMemo)(function() {
        return new SaleorAuthClient({
            storage: storage,
            saleorApiUrl: saleorApiUrl,
            onAuthRefresh: function(value) {
                setIsAuthenticating(value);
                onAuthRefresh === null || onAuthRefresh === void 0 ? void 0 : onAuthRefresh(value);
            }
        });
    }, [
        storage,
        saleorApiUrl,
        onAuthRefresh
    ]);
    (0,react.useEffect)(function() {
        return function() {
            saleorAuthClient.cleanup();
        };
    }, []);
    return {
        saleorAuthClient: saleorAuthClient,
        isAuthenticating: isAuthenticating
    };
};

;// CONCATENATED MODULE: ./src/@sdk/auth/useAuthChange.ts


// used to handle client cache invalidation on login / logout and when
// token refreshin fails
var useAuthChange = function(param) {
    var onSignedOut = param.onSignedOut, onSignedIn = param.onSignedIn;
    var handleAuthChange = function(event) {
        var isCustomAuthEvent = (event === null || event === void 0 ? void 0 : event.type) === STORAGE_AUTH_EVENT_KEY;
        if (!isCustomAuthEvent) {
            return;
        }
        var authState = event.detail.authState;
        if (authState === "signedIn") {
            onSignedIn === null || onSignedIn === void 0 ? void 0 : onSignedIn();
        } else if (authState === "signedOut") {
            onSignedOut === null || onSignedOut === void 0 ? void 0 : onSignedOut();
        }
    };
    (0,react.useEffect)(function() {
        if (false) {}
        // for current window
        window.addEventListener(STORAGE_AUTH_EVENT_KEY, handleAuthChange);
        return function() {
            window.removeEventListener(STORAGE_AUTH_EVENT_KEY, handleAuthChange);
        };
    }, []);
};

;// CONCATENATED MODULE: ./src/@sdk/auth/index.ts






// EXTERNAL MODULE: ./src/@sdk/providers/CheckoutProvider.tsx
var CheckoutProvider = __webpack_require__(45327);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(74806);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/utils.js
var utils = __webpack_require__(680);
// EXTERNAL MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/utils.js
var lib_utils = __webpack_require__(25687);
// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/core.js
var core = __webpack_require__(16284);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/error.js
var error = __webpack_require__(88222);
// EXTERNAL MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js + 9 modules
var icu_messageformat_parser_lib = __webpack_require__(56096);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/message.js





function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = (0,tslib_es6.__assign)({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = core/* IntlMessageFormat.formats */.C.formats;
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
var formatMessage = function (_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0,lib_utils/* invariant */.kG)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = 
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === icu_messageformat_parser_lib/* TYPE.literal */.wD.literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
            return message;
        }
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new error/* MissingTranslationError */.$6(messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new error/* MessageFormatError */.X9("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0,tslib_es6.__assign)({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new error/* MessageFormatError */.X9("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new error/* MessageFormatError */.X9("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
};

// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/utils.js
var src_utils = __webpack_require__(82644);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/number.js


var NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        (0,src_utils/* getNamedFormat */.TB)(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting number.', config.locale, e));
    }
    return [];
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/error.js
var src_error = __webpack_require__(11050);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/relativeTime.js



var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function relativeTime_getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && (0,src_utils/* getNamedFormat */.TB)(formats, 'relative', format, onError)) || {};
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new src_error/* FormatError */.u_("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    try {
        return relativeTime_getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/dateTime.js



var DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits',
];
function dateTime_getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (timeZone && { timeZone: timeZone })), (format && (0,src_utils/* getNamedFormat */.TB)(formats, type, format, onError)));
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting date.', config.locale, e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting time.', config.locale, e));
    }
    return [];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/plural.js



var PLURAL_FORMAT_OPTIONS = ['type'];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new src_error/* FormatError */.u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting plural.', locale, e));
    }
    return 'other';
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/list.js




var LIST_FORMAT_OPTIONS = [
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) { options = {}; }
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
            all.push(val);
        }
        else if (typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += val;
        }
        else {
            all.push(val);
        }
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new src_error/* FormatError */.u_("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions)
            .formatToParts(serializedValues)
            .map(function (part) {
            return part.type === 'literal'
                ? part
                : (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, part), { value: richValues_1[part.value] || part.value });
        });
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/displayName.js



var DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new src_error/* FormatError */.u_("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting display name.', locale, e));
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/create-intl.js










function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn &&
        config.defaultRichTextElements &&
        messagesContainString(config.messages || {})) {
        config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl(config, cache) {
    var formatters = (0,src_utils/* createFormatters */.ax)(cache);
    var resolvedConfig = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, src_utils/* DEFAULT_INTL_CONFIG */.Z0), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new error/* InvalidConfigError */.OV("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    verifyConfigMessages(resolvedConfig);
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, resolvedConfig), { formatters: formatters, formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), 
        // @ts-expect-error TODO: will get to this later
        formatMessage: formatMessage.bind(null, resolvedConfig, formatters), 
        // @ts-expect-error TODO: will get to this later
        $t: formatMessage.bind(null, resolvedConfig, formatters), formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/formatters.js
var formatters = __webpack_require__(61092);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/provider.js
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */






function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = (0,formatters/* isFormatXMLElementFn */.Gt)(v)
            ? (0,utils/* assignUniqueKeysToParts */.dt)(v)
            : v;
        return acc;
    }, {});
}
var provider_formatMessage = function (config, formatters, descriptor, rawValues) {
    var rest = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
    }
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = formatMessage.apply(void 0, (0,tslib_es6.__spreadArray)([config,
        formatters,
        descriptor,
        values], rest, false));
    if (Array.isArray(chunks)) {
        return react.Children.toArray(chunks);
    }
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var provider_createIntl = function (_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0,tslib_es6.__rest)(_a, ["defaultRichTextElements"]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = createIntl((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, utils/* DEFAULT_INTL_CONFIG */.Z0), config), { defaultRichTextElements: defaultRichTextElements }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements,
    };
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, coreIntl), { 
        // @ts-expect-error fix this
        formatMessage: provider_formatMessage.bind(null, resolvedConfig, coreIntl.formatters), 
        // @ts-expect-error fix this
        $t: provider_formatMessage.bind(null, resolvedConfig, coreIntl.formatters) });
};
var IntlProvider = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0,src_utils/* createIntlCache */.Sn)();
        _this.state = {
            cache: _this.cache,
            intl: provider_createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props),
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0,utils/* shallowEqual */.wU)(prevConfig, config)) {
            return {
                intl: provider_createIntl(config, cache),
                prevConfig: config,
            };
        }
        return null;
    };
    IntlProvider.prototype.render = function () {
        (0,utils/* invariantIntlContext */.lq)(this.state.intl);
        return react.createElement(injectIntl/* Provider */.zt, { value: this.state.intl }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = utils/* DEFAULT_INTL_CONFIG */.Z0;
    return IntlProvider;
}(react.PureComponent));
/* harmony default export */ var provider = (IntlProvider);

;// CONCATENATED MODULE: ./src/@next/components/containers/Locale/Locale.tsx







var LOCALE_CACHE = {};
var localeData = {
    // Default language
    en: undefined,
    da: "da",
    de: "de",
    es: "es",
    fr: "fr",
    it: "it",
    nl: "nl",
    no: "no",
    pl: "pl",
    sv: "sv"
};
var importMessages = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(locale) {
        var filename, localeJson;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filename = localeData[locale];
                    localeJson = LOCALE_CACHE[locale];
                    if (!(!localeJson && filename !== undefined)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        __webpack_require__(22888)("./".concat(filename, ".json"))
                    ];
                case 1:
                    localeJson = _state.sent();
                    LOCALE_CACHE[locale] = localeJson;
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        localeJson
                    ];
            }
        });
    });
    return function importMessages(locale) {
        return _ref.apply(this, arguments);
    };
}();
var LocaleProvider = function(param) {
    var children = param.children;
    var ref = (0,router.useRouter)(), locale = ref.locale, defaultLocale = ref.defaultLocale;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(undefined), 2), msgs = ref1[0], setMsgs = ref1[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                importMessages(locale)
                            ];
                        case 1:
                            data = _state.sent();
                            setMsgs(data);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(provider, {
        defaultLocale: defaultLocale,
        locale: locale,
        messages: msgs,
        children: children
    }, locale);
};


;// CONCATENATED MODULE: ./src/@next/components/containers/Locale/index.ts


// EXTERNAL MODULE: ./src/@next/hooks/index.ts + 10 modules
var hooks = __webpack_require__(40918);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/@next/components/molecules/CardHeader/index.ts
var CardHeader = __webpack_require__(27080);
// EXTERNAL MODULE: ./src/@next/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(98720);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@next/components/atoms/Checkbox/index.ts + 2 modules
var Checkbox = __webpack_require__(73881);
// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./src/@next/components/molecules/TextField/index.ts + 2 modules
var TextField = __webpack_require__(80648);
// EXTERNAL MODULE: ./src/@next/utils/misc.ts
var misc = __webpack_require__(96896);
// EXTERNAL MODULE: ./src/@next/utils/errors.ts
var utils_errors = __webpack_require__(29521);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
;// CONCATENATED MODULE: ./src/@next/components/molecules/SubscribeForm/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .input {\n    margin: 0 auto ",
        " auto;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: ",
        " auto;\n  "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin: calc(",
        " * 2) auto;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin: 0 auto;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  span {\n    top: 3px;\n    font-weight: 500;\n    position: relative;\n    margin-left: 7px;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-size: ",
        ";\n    &::after {\n      content: '';\n      display: block;\n      height: 1px;\n      width: 100%;\n      background-color: ",
        ";\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject(), function(props) {
    return props.theme.spacing.spacer;
});
var Text = globalStyles/* styled.p */.zo.p(styles_templateObject1(), function(props) {
    return props.theme.spacing.spacer;
});
var styles_Error = globalStyles/* styled.span */.zo.span(styles_templateObject2());
var SubmitButton = globalStyles/* styled.div */.zo.div(_templateObject4(), function(props) {
    return props.theme.spacing.spacer;
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject3(), function(props) {
    return props.theme.spacing.spacer;
}));
var styles_Checkbox = globalStyles/* styled.div */.zo.div(_templateObject6(), function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject5()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/SubscribeForm/SubscribeForm.tsx
// import './scss/index.scss';

















var showSuccessNotification = function(onSuccess, data) {
    // @analitics
    // TODO: track subscription request
    if (onSuccess) {
        onSuccess(data);
    }
};
var SubscribeForm = function(param) {
    var onSuccess = param.onSuccess;
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isConditionChecked = ref[0], setConditionChecked = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), graphqlErrors = ref1[0], setgraphqlErrors = ref1[1];
    var ref2 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            email: ""
        }
    }), control = ref2.control, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, handleSubmit = ref2.handleSubmit;
    var handleOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("/api/subscribeUser", {
                                body: JSON.stringify({
                                    email: values.email,
                                    locale: locale
                                }),
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                method: "POST"
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!(response.status !== 201)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        error = _state.sent();
                        setgraphqlErrors([
                            {
                                message: error.error
                            }
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setgraphqlErrors([]);
                        showSuccessNotification(onSuccess);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var fieldErrors = (0,utils_errors/* groupErrorsByFields */.g)((0,misc/* maybe */.wY)(function() {
        return graphqlErrors;
    }, []), "email");
    var nonFieldErrors = fieldErrors[utils_errors/* NON_FIELD_ERROR */.O];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "subscription-form",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit(handleOnSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Error, {
                    className: "form-error",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                        errors: nonFieldErrors
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: "email",
                    control: control,
                    rules: {
                        pattern: {
                            message: intl.formatMessage(src_intl/* validationCommonMsg.invalidEmail */.a4.invalidEmail),
                            value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                        },
                        required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                    },
                    render: function(param) {
                        var field = param.field;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                            label: intl.formatMessage(src_intl/* commonMessages.shortEmail */.i4.shortEmail),
                            autoComplete: "email",
                            type: "email",
                            errors: errors.email ? [
                                {
                                    message: errors.email.message
                                }
                            ] :  false || (fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.email)
                        }, field));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Checkbox, {
                    className: "subscribe__checkbox",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                            name: "conditions",
                            checked: isConditionChecked,
                            onChange: function() {
                                setConditionChecked(!isConditionChecked);
                            },
                            children: intl.formatMessage({
                                defaultMessage: "I have read",
                                id: "pupJlG"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "login__checkbox__text",
                            children: intl.formatMessage({
                                defaultMessage: "Terms and Conditions",
                                id: "6qF/vN"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                    className: "subscribe__content__button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        fullWidth: true,
                        type: "submit",
                        disabled: !isConditionChecked || isSubmitting,
                        children: isSubmitting ? intl.formatMessage(src_intl/* commonMessages.loading */.i4.loading) : intl.formatMessage(src_intl/* commonMessages.subscribe */.i4.subscribe)
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/SubscribeForm/index.ts


// EXTERNAL MODULE: ./src/images/mail-send.svg
var mail_send = __webpack_require__(97278);
// EXTERNAL MODULE: ./src/images/sign-in.svg
var sign_in = __webpack_require__(79378);
;// CONCATENATED MODULE: ./src/@next/components/overlays/Subscribe/styles.ts

function Subscribe_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // margin-top: 140px;\n    margin-top: 40px;\n  "
    ]);
    Subscribe_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Subscribe_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n  "
    ]);
    Subscribe_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Subscribe_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 40rem;\n  max-width: 100vw;\n  ",
        "\n  ",
        "\n"
    ]);
    Subscribe_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Subscribe_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Subscribe_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1em;\n  padding: ",
        ";\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: ",
        ";\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Modal = globalStyles/* styled.div */.zo.div(Subscribe_styles_templateObject2(), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(Subscribe_styles_templateObject()), globalStyles/* media.smallestScreen */.BC.smallestScreen(Subscribe_styles_templateObject1()));
var styles_Wrapper = globalStyles/* styled.div */.zo.div(Subscribe_styles_templateObject3());
var styles_Text = globalStyles/* styled.p */.zo.p(styles_templateObject4(), function(param) {
    var spacing = param.theme.spacing;
    return "1rem ".concat(spacing.gutter, " 1.8rem ").concat(spacing.gutter);
});
var Content = globalStyles/* styled.div */.zo.div(styles_templateObject6(), function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " calc(").concat(spacing.spacer, " * 5)");
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject5(), function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " calc(").concat(spacing.spacer, " * 2)");
}));

;// CONCATENATED MODULE: ./src/@next/components/overlays/Subscribe/Subscribe.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ 










var Subscribe = function() {
    var modal = (0,esm/* useModal */.dd)();
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), success = ref[0], setSuccess = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: modal.visible,
        hide: modal.remove,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
            children: success ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                        divider: true,
                        formImage: mail_send,
                        onHide: modal.remove,
                        children: intl.formatMessage(src_intl/* commonMessages.success */.i4.success)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                        children: intl.formatMessage({
                            defaultMessage: "The gift code is knocking at your door! Just open your e-mail!",
                            id: "2W3yUq"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                        divider: true,
                        formImage: sign_in,
                        onHide: modal.remove,
                        children: intl.formatMessage({
                            defaultMessage: "Inspiration, special offers and more Sign up and get a 50€ gift before it’s gone",
                            id: "ehmbMu"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeForm, {
                            onSuccess: function() {
                                return setSuccess(true);
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Subscribe_Subscribe = (esm/* default.create */.ZP.create(Subscribe));

;// CONCATENATED MODULE: ./src/@next/components/overlays/Subscribe/index.tsx


// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/router.js
var next_translate_routes_router = __webpack_require__(56827);
// EXTERNAL MODULE: ./src/@prismic/context.tsx
var context = __webpack_require__(47233);
// EXTERNAL MODULE: ./src/@prismic/gqlTypes/prismicHooks.tsx
var prismicHooks = __webpack_require__(41490);
// EXTERNAL MODULE: ./src/@next/components/containers/ErrorBoundary/index.ts + 1 modules
var ErrorBoundary = __webpack_require__(82229);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./src/@next/utils/regions.ts + 1 modules
var regions = __webpack_require__(8044);
// EXTERNAL MODULE: ./src/@next/components/containers/ShopProvider/context.ts
var ShopProvider_context = __webpack_require__(1366);
;// CONCATENATED MODULE: ./src/@next/components/containers/ShopProvider/index.tsx








var ShopProvider = function(param) {
    var children = param.children;
    var locale = (0,router.useRouter)().locale;
    var data = (0,generatedHooks/* useGetShopQuery */.uu)({
        variables: (0,_object_spread/* default */.Z)({}, (0,regions/* localeToSaleorQuery */.KK)(locale))
    }).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopProvider_context/* ShopContext.Provider */.Iw.Provider, {
        value: (0,misc/* maybe */.wY)(function() {
            return data.shop;
        }, ShopProvider_context/* defaultContext */.Of),
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
;// CONCATENATED MODULE: ./src/images/email.svg
var email_namespaceObject = __webpack_require__.p + "static/images/email.svg";
;// CONCATENATED MODULE: ./src/images/phone.svg
var phone_namespaceObject = __webpack_require__.p + "static/images/phone.svg";
;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsNav/styles.ts

function ContactsNav_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    ContactsNav_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactsNav_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 16px;\n      max-height: 16px;\n    "
    ]);
    ContactsNav_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactsNav_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-right: 10px;\n    "
    ]);
    ContactsNav_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContactsNav_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  img {\n    display: block;\n    margin-right: 15px;\n    width: auto;\n    height: auto;\n    max-width: 20px;\n    max-height: 20px;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    ContactsNav_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContactsNav_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    height: 2px;\n    background-color: ",
        ";\n  }\n"
    ]);
    ContactsNav_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var ContactsNav_styles_Wrapper = globalStyles/* styled.div */.zo.div(ContactsNav_styles_templateObject());
var Item = globalStyles/* styled.div */.zo.div(ContactsNav_styles_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(ContactsNav_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(ContactsNav_styles_templateObject2()));
var Link = globalStyles/* styled.a */.zo.a(ContactsNav_styles_templateObject4(), function(props) {
    return props.theme.colors.secondary;
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsNav/ContactsNav.tsx


// import Link from 'next-translate-routes/link';




var ContactsNav = function(param) {
    var contact = param.contact;
    var contactsList = contact === null || contact === void 0 ? void 0 : contact.filter(function(z) {
        return z.show_in_nav;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsNav_styles_Wrapper, {
        children: contactsList === null || contactsList === void 0 ? void 0 : contactsList.map(function(c, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                children: [
                    c.type === "phone" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: phone_namespaceObject,
                        width: "16px",
                        height: "16px",
                        alt: "phone"
                    }),
                    c.type === "email" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: email_namespaceObject,
                        width: "16px",
                        height: "16px",
                        alt: "email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        href: (0,prismic_config/* linkResolver */.kG)(c.link),
                        children: c.label
                    })
                ]
            }, "nav-contact-".concat(i));
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsNav/index.ts


// EXTERNAL MODULE: ./src/@next/components/templates/Container/Container.tsx
var Container = __webpack_require__(40080);
;// CONCATENATED MODULE: ./src/@next/components/molecules/TopBar/styles.ts

function TopBar_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 30px;\n  "
    ]);
    TopBar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopBar_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  position: absolute;\n  top: ",
        ";\n  left: 0;\n  right: 0;\n  transition: all 0.2s ease;\n  font-size: ",
        ";\n  display: flex;\n  width: 100%;\n  height: 40px;\n  ",
        "\n"
    ]);
    TopBar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopBar_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n  width: 100%;\n"
    ]);
    TopBar_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TopBar_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // display: flex;\n  // justify-content: center;\n"
    ]);
    TopBar_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TopBar_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    TopBar_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var TopBar_styles_Wrapper = (0,globalStyles/* styled */.zo)(Container/* ContainerFlex */.y1)(TopBar_styles_templateObject1(), function(props) {
    return props.theme.colors.secondaryDark;
}, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.hidden ? "-50px" : "0";
}, function(props) {
    return props.theme.typography.smallFontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(TopBar_styles_templateObject()));
var Row = globalStyles/* styled.div */.zo.div(TopBar_styles_templateObject2());
var Copyright = globalStyles/* styled.div */.zo.div(TopBar_styles_templateObject3());
var Contacts = globalStyles/* styled.div */.zo.div(TopBar_styles_templateObject4());

;// CONCATENATED MODULE: ./src/@next/components/molecules/TopBar/TopBar.tsx





var TopBar = function(param) {
    var message = param.message, contact = param.contact, isScrolled = param.isScrolled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_styles_Wrapper, {
        hidden: isScrolled,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright, {
                    children: message && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: message
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Contacts, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsNav, {
                        contact: contact
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/TopBar/index.ts


// EXTERNAL MODULE: ./src/@sdk/hook/useUser.ts
var useUser = __webpack_require__(7006);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/@next/components/overlays/Login/index.tsx + 12 modules
var Login = __webpack_require__(47489);
// EXTERNAL MODULE: ./src/@next/components/overlays/Cart/index.ts + 5 modules
var Cart = __webpack_require__(55646);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
;// CONCATENATED MODULE: ./src/images/close-black.svg
var close_black_namespaceObject = __webpack_require__.p + "static/images/close-black.svg";
// EXTERNAL MODULE: ./src/images/logo-mobile.svg
var logo_mobile = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/images/logo.svg
var logo = __webpack_require__(91937);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/images/cart.svg
var cart_namespaceObject = __webpack_require__.p + "static/images/cart.svg";
// EXTERNAL MODULE: ./src/images/heart.svg
var heart = __webpack_require__(25280);
;// CONCATENATED MODULE: ./src/images/user.svg
var user_namespaceObject = __webpack_require__.p + "static/images/user.svg";
;// CONCATENATED MODULE: ./src/images/userLogged.svg
var userLogged_namespaceObject = __webpack_require__.p + "static/images/userLogged.svg";
;// CONCATENATED MODULE: ./src/images/left.svg
var left_namespaceObject = __webpack_require__.p + "static/images/left.svg";
;// CONCATENATED MODULE: ./src/@next/components/organisms/MainMenu/NavIconButton.tsx




function NavIconButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% { transform: rotate(0); }\n  2% { transform: rotate(30deg); }\n  9% { transform: rotate(-28deg); }\n  10% { transform: rotate(34deg); }\n  14% { transform: rotate(-32deg); }\n  18% { transform: rotate(30deg); }\n  22% { transform: rotate(-28deg); }\n  26% { transform: rotate(26deg); }\n  30% { transform: rotate(-24deg); }\n  44% { transform: rotate(22deg); }\n  38% { transform: rotate(-20deg); }\n  42% { transform: rotate(18deg); }\n  46% { transform: rotate(-16deg); }\n  50% { transform: rotate(14deg); }\n  54% { transform: rotate(-12deg); }\n  59% { transform: rotate(10deg); }\n  62% { transform: rotate(-8deg); }\n  66% { transform: rotate(6deg); }\n  70% { transform: rotate(-4deg); }\n  74% { transform: rotate(2deg); }\n  78% { transform: rotate(-1deg); }\n  82% { transform: rotate(1deg); }\n  86% { transform: rotate(0); }\n  100% { transform: rotate(0); }\n"
    ]);
    NavIconButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavIconButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    svg {\n      width: auto;\n      height: auto;\n    }\n  "
    ]);
    NavIconButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavIconButton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 19px 15px;\n  "
    ]);
    NavIconButton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavIconButton_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 15px;\n  "
    ]);
    NavIconButton_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavIconButton_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 10px;\n  "
    ]);
    NavIconButton_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NavIconButton_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 19px;\n  cursor: pointer;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  svg * {\n    transition: 0.3s;\n  }\n  svg {\n    vertical-align: bottom;\n  }\n  &:before {\n    content: '';\n    display: block;\n    height: 2px;\n    width: 0;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: ",
        ";\n    transition: width 0.6s;\n  }\n  &:hover {\n    &:before {\n      width: 75%;\n    }\n  }\n"
    ]);
    NavIconButton_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NavIconButton_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 16px;\n    height: 16px;\n  "
    ]);
    NavIconButton_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: -3px;\n    right: 2px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: -2px;\n    right: -5px;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 2s 0s ease-in-out 1;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  background-color: #ca9c66;\n  color: #ffffff;\n  font-size: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}










var ring = (0,styled_components_browser_esm/* keyframes */.F4)(NavIconButton_templateObject());
var NavIconButton_Button = globalStyles/* styled.button */.zo.button(NavIconButton_templateObject5(), globalStyles/* media.largeScreen */.BC.largeScreen(NavIconButton_templateObject1()), globalStyles/* media.mediumScreen */.BC.mediumScreen(NavIconButton_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(NavIconButton_templateObject3()), globalStyles/* media.smallestScreen */.BC.smallestScreen(NavIconButton_templateObject4()), function(props) {
    return props.theme.colors.red;
});
var Counter = globalStyles/* styled.span */.zo.span(_templateObject10(), function(props) {
    return props.theme.typography.labelFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(NavIconButton_templateObject6()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject7()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject8()), function(props) {
    return props.animate && (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), ring);
});
var getIcon = function(iconName) {
    switch(iconName){
        case "user":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: user_namespaceObject
            });
        case "loggedin":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: userLogged_namespaceObject
            });
        case "cart":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: cart_namespaceObject
            });
        case "wishlist":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: heart
            });
        case "close":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: close_black_namespaceObject
            });
        case "arrow":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                src: left_namespaceObject
            });
        default:
            return iconName;
    }
};
function NavIconButton(_param) {
    var icon = _param.icon, counter = _param.counter, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "counter"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavIconButton_Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button"
    }, rest), {
        children: [
            getIcon(icon),
            !!counter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Counter, {
                animate: true,
                children: counter
            })
        ]
    }));
}
/* harmony default export */ var MainMenu_NavIconButton = (NavIconButton);

// EXTERNAL MODULE: ./src/@next/components/atoms/DropdownMenu/index.ts + 2 modules
var DropdownMenu = __webpack_require__(24433);
;// CONCATENATED MODULE: ./src/@next/components/organisms/MainMenu/UserMenu.tsx
// import { media, styled } from '@styles';
// import { keyframes, css } from 'styled-components';







function UserMenu() {
    var intl = (0,useIntl/* default */.Z)();
    var signOut = (0,SaleorAuthProvider/* useSaleorAuthContext */.e)().signOut;
    var handleSignOut = function() {
        var // @analitics
        ref;
        window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.identify("", {
            isLoggedIn: false
        });
        signOut();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu/* DropdownMenu */.h, {
        type: "hoverable",
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_NavIconButton, {
            icon: "loggedin",
            className: "main-menu__nav-link"
        }),
        items: [
            {
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.accountOrderHistory */.H.accountOrderHistory,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: intl.formatMessage({
                            defaultMessage: "My orders",
                            id: "cA7xQl"
                        })
                    })
                })
            },
            {
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.account */.H.account,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: intl.formatMessage({
                            defaultMessage: "Personal details",
                            id: "AEzWZu"
                        })
                    })
                })
            },
            {
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.accountAddressBook */.H.accountAddressBook,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: intl.formatMessage({
                            defaultMessage: "Billing & Shipping address",
                            id: "o/l1eB"
                        })
                    })
                })
            },
            {
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: intl.formatMessage({
                        defaultMessage: "Log Out",
                        id: "H0JBH6"
                    })
                }),
                onClick: handleSignOut
            }, 
        ]
    });
}
/* harmony default export */ var MainMenu_UserMenu = (UserMenu);

// EXTERNAL MODULE: ./src/@sdk/hook/useWishlist.ts
var useWishlist = __webpack_require__(9212);
;// CONCATENATED MODULE: ./src/@next/components/organisms/MainMenu/WishlistMenu.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */ 




var WishlistMenu = function(param) {
    var className = param.className;
    var ref = (0,useWishlist/* useWishlist */.E)(), wishlistItems = ref.items;
    var push = (0,router.useRouter)().push;
    var wishlistItemsQuantity = wishlistItems && (wishlistItems === null || wishlistItems === void 0 ? void 0 : wishlistItems.length) || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_NavIconButton, {
        icon: "wishlist",
        onClick: function() {
            return push(paths/* paths.wishlist */.H.wishlist);
        },
        counter: wishlistItemsQuantity,
        className: className
    });
};
/* harmony default export */ var MainMenu_WishlistMenu = (WishlistMenu);

;// CONCATENATED MODULE: ./src/images/email-nav-menu.svg
var email_nav_menu_namespaceObject = __webpack_require__.p + "static/images/email-nav-menu.svg";
;// CONCATENATED MODULE: ./src/images/phone-nav-menu.svg
var phone_nav_menu_namespaceObject = __webpack_require__.p + "static/images/phone-nav-menu.svg";
;// CONCATENATED MODULE: ./src/@next/components/organisms/MobileNav/NavContact.tsx

function NavContact_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 21px;\n    padding-right: 25px;\n    padding-bottom: 28px;\n  "
    ]);
    NavContact_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavContact_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 100px;\n  padding-right: 100px;\n  padding-bottom: 88px;\n  ",
        "\n"
    ]);
    NavContact_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavContact_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 10px;\n  "
    ]);
    NavContact_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavContact_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      align-items: flex-start;\n    "
    ]);
    NavContact_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavContact_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        line-height: 24px;\n        margin-left: 13px;\n      "
    ]);
    NavContact_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NavContact_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 18px;\n  ",
        "\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n  a {\n    display: flex;\n    align-items: flex-end;\n    ",
        "\n    span {\n      font-family: ",
        ";\n      font-size: ",
        ";\n      color: ",
        ";\n      line-height: 38px;\n      margin-left: 10px;\n      text-decoration: none;\n      position: relative;\n      ",
        "\n      &:after {\n        content: '';\n        display: inline-block;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        background-color: #9fbecc;\n        height: 2px;\n      }\n    }\n  }\n"
    ]);
    NavContact_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NavContact_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 30px;\n"
    ]);
    NavContact_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var ContactWrapper = globalStyles/* styled.ul */.zo.ul(NavContact_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(NavContact_templateObject()));
var ContactItem = globalStyles/* styled.li */.zo.li(NavContact_templateObject5(), globalStyles/* media.smallScreen */.BC.smallScreen(NavContact_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(NavContact_templateObject3()), function(props) {
    return props.theme.typography.baseFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.smallScreen */.BC.smallScreen(NavContact_templateObject4()));
var ContactIcon = (0,globalStyles/* styled */.zo)(react_svg_esm/* ReactSVG */.Q)(NavContact_templateObject6());
function NavContact(param) {
    var contact = param.contact;
    var email = contact.find(function(o) {
        return o.type === "email";
    });
    var phone = contact.find(function(o) {
        return o.type === "phone";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactWrapper, {
        children: [
            phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactItem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "tel:".concat(phone.label),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcon, {
                            src: phone_nav_menu_namespaceObject
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: phone.label
                        })
                    ]
                })
            }),
            email && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactItem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "mailto:".concat(email.label),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcon, {
                            src: email_nav_menu_namespaceObject
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: email.label
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var MobileNav_NavContact = (NavContact);

;// CONCATENATED MODULE: ./src/@next/components/organisms/MobileNav/NavPrismic.tsx

function NavPrismic_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 25px;\n    padding-right: 25px;\n    padding-bottom: 35px;\n  "
    ]);
    NavPrismic_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavPrismic_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 100px;\n  padding-right: 100px;\n  padding-bottom: 148px;\n  display: flex;\n  flex-wrap: wrap;\n  ",
        "\n"
    ]);
    NavPrismic_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavPrismic_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 20px;\n  "
    ]);
    NavPrismic_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavPrismic_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  margin-bottom: 12px;\n  ",
        "\n"
    ]);
    NavPrismic_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavPrismic_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 24px;\n  "
    ]);
    NavPrismic_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NavPrismic_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  align-items: center;\n  color: ",
        ";\n  font-family: ",
        ";\n  line-height: 2em;\n  font-size: ",
        ";\n  text-decoration: none;\n  text-transform: capitalize;\n  transition: 0.3s;\n  position: relative;\n  ",
        "\n  &.active {\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: -5px;\n      height: 2px;\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    NavPrismic_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var NavWrapper = globalStyles/* styled.ul */.zo.ul(NavPrismic_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(NavPrismic_templateObject()));
var NavItem = globalStyles/* styled.li */.zo.li(NavPrismic_templateObject3(), globalStyles/* media.smallScreen */.BC.smallScreen(NavPrismic_templateObject2()));
var NavLink = globalStyles/* styled.a */.zo.a(NavPrismic_templateObject5(), function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(NavPrismic_templateObject4()), function(props) {
    return props.theme.colors.red;
});
function NavPrismicItem(param) {
    var hideOverlay = param.hideOverlay, label = param.label, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: (0,prismic_config/* linkResolver */.kG)(link),
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    onClick: hideOverlay,
                    children: label
                })
            })
        })
    });
}
function NavPrismic(param) {
    var items = param.items, hideOverlay = param.hideOverlay;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavPrismicItem, {
                label: intl.formatMessage({
                    defaultMessage: "Home",
                    id: "ejEGdx"
                }),
                link: {
                    url: paths/* paths.home */.H.home
                },
                hideOverlay: hideOverlay
            }, "nav-prismic-home"),
            items && (items === null || items === void 0 ? void 0 : items.map(function(item, i) {
                var primary = item.primary;
                var label = primary.label, link = primary.link;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavPrismicItem, {
                    label: label,
                    link: link,
                    hideOverlay: hideOverlay
                }, "nav-prismic-".concat(i));
            }))
        ]
    });
}
/* harmony default export */ var MobileNav_NavPrismic = (NavPrismic);

// EXTERNAL MODULE: ./src/@next/utils/translations.ts
var translations = __webpack_require__(69665);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var utils_core = __webpack_require__(62823);
;// CONCATENATED MODULE: ./src/@next/components/atoms/NavLink/NavLink.tsx











var NavLink_NavLink = function(_param) {
    var item = _param.item, children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "item",
        "children",
        "className"
    ]);
    var url = item.url, category = item.category, collection = item.collection, page = item.page;
    var query = (0,router.useRouter)().query;
    var link = function(url, active) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            passHref: true,
            href: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                className: (0,clsx/* clsx */.W)(className, active && "active"),
                children: children
            }))
        });
    };
    if (url) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: url
        }, props), {
            className: (0,clsx/* clsx */.W)(className),
            children: (0,translations/* translate */.I)(item, "name")
        }));
    }
    if (category) {
        var id = (0,utils_core/* decodeKey */.Tn)(category.id, "Category");
        var slug = (0,utils_core/* slugify */.lV)((0,translations/* translate */.I)(category, "name"));
        return link((0,utils_core/* generatePath */.Gn)(paths/* paths.category */.H.category, {
            slug: slug,
            id: id
        }), id === query.id);
    }
    if (collection) {
        var id1 = (0,utils_core/* decodeKey */.Tn)(collection.id, "Collection");
        var slug1 = (0,utils_core/* slugify */.lV)((0,translations/* translate */.I)(collection, "name"));
        return link((0,utils_core/* generatePath */.Gn)(paths/* paths.collection */.H.collection, {
            slug: slug1,
            id: id1
        }), id1 === query.id);
    }
    if (page) {
        return link((0,utils_core/* generatePath */.Gn)(paths/* paths.page */.H.page, {
            slug: page.slug
        }), false);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: (0,clsx/* clsx */.W)(className),
        children: (0,translations/* translate */.I)(item, "name")
    }));
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/NavLink/index.ts


;// CONCATENATED MODULE: ./src/@next/components/organisms/MobileNav/styles.ts

function MobileNav_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f7f8;\n"
    ]);
    MobileNav_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileNav_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  // flex-direction: row;\n  align-items: center;\n  position: relative;\n  background-color: ",
        ";\n"
    ]);
    MobileNav_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MobileNav_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  height: 15px;\n  width: 15px;\n"
    ]);
    MobileNav_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MobileNav_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    MobileNav_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MobileNav_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block;\n    "
    ]);
    MobileNav_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MobileNav_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0rem auto 0rem auto;\n  .tablet {\n    ",
        "\n    img {\n      width: 72px;\n      height: auto;\n      display: block;\n    }\n  }\n  .mobile {\n    display: none;\n    ",
        "\n  }\n"
    ]);
    MobileNav_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function MobileNav_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    MobileNav_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: auto;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 60px;\n    padding-bottom: 60px;\n  "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 40px;\n    padding-bottom: 40px;\n  "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 90px;\n  padding-bottom: 60px;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 50vw;\n    width: 100%;\n    background-size: cover;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 150px;\n  height: 173px;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-color: ",
        ";\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 200%;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  transition: color 0.6s;\n  text-align: center;\n  text-transform: capitalize;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 14px;\n    padding-right: 14px;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      line-height: 64px;\n      margin-bottom: 17px;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      line-height: 120%;\n      margin-bottom: 0;\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-left: 57px;\n  padding-right: 30px;\n  ",
        "\n  }\n  .side-nav__menu-item-link {\n    color: ",
        ";\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 64px;\n    margin-bottom: 10px;\n    text-decoration: none;\n    text-transform: none;\n    transition: 0.3s;\n    position: relative;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 14px;\n    padding-right: 14px;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n      // padding-bottom: 14px;\n      flex-basis: calc(50% - 20px);\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding-bottom: 5px;\n  padding-left: 57px;\n  padding-right: 30px;\n  ",
        "\n  .side-nav__menu-item-link {\n    font-size: 0;\n    line-height: 1;\n    margin: 30px 10px 0 10px;\n    padding-left: 0;\n    padding-right: 0;\n    // padding-bottom: 16px;\n    font-size: 0;\n    line-height: 1;\n    text-align: center;\n    background-color: #f0e9eb;\n    ",
        "\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  }}\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 16px 0 10px;\n    margin: 0 25px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding-top: 80px;\n  padding-left: 64px;\n  padding-right: 100px;\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 35px 40px;\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 20px;\n  "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  top: 50px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #f6f7f8;\n  z-index: 3;\n  ",
        "\n  margin: 40px 40px 40px 84px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 18px 36px 18px 64px;\n  "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 16px 36px 20px 64px;\n    background-color: #ffffff;\n  "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    padding: 0;\n  "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 28px 299px 36px 143px;\n  flex-grow: 1;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 18px 64px 18px 36px;\n  "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 16px 64px 20px 36px;\n  "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 28px 143px 36px 299px;\n  background-color: #f6f7f8;\n  flex-basis: 50%;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 18px;\n  "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: auto;\n  "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 38px;\n  height: 80px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 13px;\n  "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 9px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: 300;\n  line-height: 100%;\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 280px;\n  "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 330px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 160%;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    border-radius: 50%;\n    margin-right: 12px;\n    border: 2px solid transparent;\n    transition: all 0.2s ease-in-out;\n  }\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 18px 0;\n  margin: 0 25px;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: 300;\n  line-height: 16px;\n  letter-spacing: -0.5px;\n  color: ",
        ";\n\n  &:not(:first-child) {\n    margin-left: 25px;\n  }\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 47px;\n    left: 33px;\n  "
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 50%;\n    left: 0;\n  "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  transform: translate(0, -50%);\n  ",
        "\n  ",
        "\n\n  img {\n    height: 10px;\n    width: 5px;\n  }\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 15px 24px;\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 27px;\n  text-align: center;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 160%;\n  color: ",
        ";\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}


var SideNav = globalStyles/* styled.div */.zo.div(MobileNav_styles_templateObject());
var Header = globalStyles/* styled.div */.zo.div(MobileNav_styles_templateObject1(), function(props) {
    return props.theme.colors.white;
});
var CloseImg = globalStyles/* styled.div */.zo.div(MobileNav_styles_templateObject2());
var HeadImg = globalStyles/* styled.div */.zo.div(MobileNav_styles_templateObject5(), globalStyles/* media.mediumScreen */.BC.mediumScreen(MobileNav_styles_templateObject3()), globalStyles/* media.mediumScreen */.BC.mediumScreen(MobileNav_styles_templateObject4()));
var styles_TopBar = globalStyles/* styled.div */.zo.div(MobileNav_styles_templateObject6());
var Body = globalStyles/* styled.div */.zo.div(styles_templateObject7());
var MenuItem = globalStyles/* styled.ul */.zo.ul(styles_templateObject10(), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject8()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject9()));
var NavItemImage = globalStyles/* styled.div */.zo.div(_templateObject12(), function(props) {
    return props.theme.colors.light;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject11()));
var NavItemTitle = globalStyles/* styled.span */.zo.span(_templateObject13(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
});
var arrowStyle = (0,styled_components_browser_esm/* css */.iv)(_templateObject17(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject14()), function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject15()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject16()));
var parentStyle = (0,styled_components_browser_esm/* css */.iv)(_templateObject20(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject18()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject19()));
var styles_NavItem = globalStyles/* styled.div */.zo.div(_templateObject23(), function(param) {
    var arrow = param.arrow;
    return arrow === true && (0,styled_components_browser_esm/* css */.iv)(_templateObject21(), arrowStyle);
}, function(param) {
    var arrow = param.arrow;
    return arrow === false && (0,styled_components_browser_esm/* css */.iv)(_templateObject22(), parentStyle);
});
var LocaleWrapper = globalStyles/* styled.div */.zo.div(_templateObject25(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject24()));
var LocaleContainer = globalStyles/* styled.div */.zo.div(_templateObject29(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject26()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject27()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject28()));
var LocaleRegion = globalStyles/* styled.div */.zo.div(_templateObject33(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject30()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject31()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject32()));
var LocaleLanguage = globalStyles/* styled.div */.zo.div(_templateObject36(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject34()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject35()));
var LocaleItemTop = globalStyles/* styled.div */.zo.div(_templateObject39(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject37()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject38()));
var LocaleItemTitle = globalStyles/* styled.h5 */.zo.h5(_templateObject41(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject40()));
var LocaleItemSubTitle = globalStyles/* styled.p */.zo.p(_templateObject43(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.spacing.spacer;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject42()));
var LocaleImage = globalStyles/* styled.div */.zo.div(_templateObject44());
var LocaleTabsHeader = globalStyles/* styled.div */.zo.div(_templateObject45());
var LocaleTabsButton = globalStyles/* styled.button */.zo.button(_templateObject46(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(param) {
    var active = param.active, theme = param.theme;
    return active ? theme.colors.baseFont : "rgba(44, 44, 44, 0.4)";
});
var LocaleTabsBackButton = globalStyles/* styled.button */.zo.button(_templateObject49(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject47()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject48()));
var LocaleTabsContent = globalStyles/* styled.div */.zo.div(_templateObject50());
var LocaleTabsDescription = globalStyles/* styled.div */.zo.div(_templateObject51(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/MobileNav/NavItem.tsx








var NavItemParent = function(_param) /*
  const imageUrl =
    item.collection?.backgroundImage?.url ||
    item.category?.backgroundImage?.url ||
    NoPhoto;
  const css = { width: '100%', height: '100%' };
  */ /*#__PURE__*/ {
    var children = _param.children, hideOverlay = _param.hideOverlay, arrow = _param.arrow, item = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "hideOverlay",
        "arrow"
    ]);
    return (0,jsx_runtime.jsx)(NavLink_NavLink, {
        item: item,
        onClick: hideOverlay,
        className: "side-nav__menu-item-link",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemTitle, {
            children: (0,translations/* translate */.I)(item, "name")
        })
    });
};
var NavItem_NavItem = function(_param) {
    var children = _param.children, hideOverlay = _param.hideOverlay, arrow = _param.arrow, item = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "hideOverlay",
        "arrow"
    ]);
    var content = children && children.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_NavItem, {
        arrow: false,
        children: children.map(function(subItem, i) {
            return subItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemParent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subItem), {
                hideOverlay: hideOverlay,
                arrow: false
            }), i);
        })
    }) : null;
    // const imageUrl =
    //   item.collection?.backgroundImage?.url ||
    //   item.category?.backgroundImage?.url ||
    //   NoPhoto;
    // const css = { maxWidth: '100%', height: 'auto' };
    // const css = { width: '100%', height: '100%' };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_NavItem, {
        arrow: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink_NavLink, {
                item: item,
                onClick: hideOverlay,
                className: "side-nav__menu-item-link",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemTitle, {
                    children: (0,translations/* translate */.I)(item, "name")
                })
            }),
            content
        ]
    });
};
/* harmony default export */ var MobileNav_NavItem = (NavItem_NavItem);

;// CONCATENATED MODULE: ./src/@next/components/molecules/LocalePicker/styles.ts

function LocalePicker_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-flow: column wrap;\n  align-items: flex-start !important;\n  max-height: 200px;\n"
    ]);
    LocalePicker_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocalePicker_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 16px;\n    "
    ]);
    LocalePicker_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocalePicker_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 24px;\n    "
    ]);
    LocalePicker_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocalePicker_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            right: -20px;\n          "
    ]);
    LocalePicker_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocalePicker_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n      position: relative;\n\n      &:after {\n        content: '';\n        display: 'block';\n        position: absolute;\n        height: 7px;\n        width: 10px;\n        right: -50px;\n        top: 0;\n        border-style: solid;\n        border-width: 2px;\n        border-color: transparent transparent ",
        "\n          ",
        ";\n        transform: translate(0, 50%) rotate(-50deg);\n        ",
        "\n      }\n\n      a {\n        color: ",
        ";\n      }\n    "
    ]);
    LocalePicker_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LocalePicker_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-basis: 20%;\n\n    margin-bottom: 20px;\n    ",
        "\n    ",
        "\n\n    a {\n      display: flex;\n      align-items: center;\n      font-family: ",
        ";\n      font-size: ",
        ";\n      line-height: 120%;\n      font-weight: 300;\n      color: rgba(44, 44, 44, 0.7);\n\n      img {\n        width: 20px;\n        height: 20px;\n        display: inline-block;\n        border-radius: 50%;\n        margin-right: 12px;\n        border: 2px solid transparent;\n        transition: all 0.2s ease-in-out;\n      }\n    }\n\n    &:hover {\n      img {\n        border: 2px solid #ecedee;\n        transition: all 0.2s ease-in-out;\n      }\n    }\n\n    ",
        "\n  "
    ]);
    LocalePicker_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function LocalePicker_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    LocalePicker_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var LocalePicker_styles_Wrapper = globalStyles/* styled.ul */.zo.ul(LocalePicker_styles_templateObject());
var styles_Item = globalStyles/* styled.li */.zo.li(LocalePicker_styles_templateObject6(), function(param) {
    var theme = param.theme, active = param.active;
    return (0,styled_components_browser_esm/* css */.iv)(LocalePicker_styles_templateObject5(), globalStyles/* media.largeScreen */.BC.largeScreen(LocalePicker_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(LocalePicker_styles_templateObject2()), theme.typography.thinFontFamily, function(props) {
        return props.theme.typography.smallFontSize;
    }, active && (0,styled_components_browser_esm/* css */.iv)(LocalePicker_styles_templateObject4(), theme.colors.red, theme.colors.red, globalStyles/* media.smallScreen */.BC.smallScreen(LocalePicker_styles_templateObject3()), theme.colors.baseFont));
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/LocalePicker/LocalePicker.tsx






function LocalePicker(param) {
    var onPicked = param.onPicked;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalePicker_styles_Wrapper, {
        children: regions/* LOCALES.map */.lE.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Item, {
                active: locale === item.slug,
                onClick: function() {
                    return onPicked();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.home */.H.home,
                    locale: item.slug,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.icon,
                                alt: ""
                            }),
                            item.name
                        ]
                    })
                })
            }, item.name);
        })
    });
}

;// CONCATENATED MODULE: ./src/@next/components/molecules/LocalePicker/index.ts


;// CONCATENATED MODULE: ./src/@next/components/molecules/RegionPicker/styles.ts

function RegionPicker_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-flow: column wrap;\n  align-items: flex-start !important;\n  max-height: 285px;\n"
    ]);
    RegionPicker_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegionPicker_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 14px;\n    "
    ]);
    RegionPicker_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RegionPicker_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 24px;\n    "
    ]);
    RegionPicker_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RegionPicker_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        line-height: 18px;\n      "
    ]);
    RegionPicker_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RegionPicker_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        line-height: 15px;\n      "
    ]);
    RegionPicker_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RegionPicker_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n      position: relative;\n\n      &:after {\n        content: '';\n        display: 'block';\n        position: absolute;\n        height: 7px;\n        width: 10px;\n        right: -50px;\n        top: 0;\n        border-style: solid;\n        border-width: 2px;\n        border-color: transparent transparent ",
        "\n          ",
        ";\n        transform: translate(0, 50%) rotate(-50deg);\n      }\n\n      a {\n        color: ",
        ";\n      }\n    "
    ]);
    RegionPicker_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RegionPicker_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-basis: 20%;\n\n    margin-bottom: 20px;\n    ",
        "\n    ",
        "\n\n    a {\n      display: flex;\n      align-items: center;\n      font-size: ",
        ";\n      font-family: ",
        ";\n      font-weight: 300;\n      line-height: 22px;\n      color: rgba(44, 44, 44, 0.7);\n\n      ",
        "\n\n      ",
        "\n\n      img {\n        max-width: 20px;\n        max-height: 20px;\n        display: inline-block;\n        border-radius: 50%;\n        margin-right: 12px;\n        border: 2px solid transparent;\n        transition: all 0.2s ease-in-out;\n      }\n    }\n\n    &:hover {\n      img {\n        border: 2px solid #ecedee;\n        transition: all 0.2s ease-in-out;\n      }\n    }\n\n    ",
        "\n  "
    ]);
    RegionPicker_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RegionPicker_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    RegionPicker_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var RegionPicker_styles_Wrapper = globalStyles/* styled.ul */.zo.ul(RegionPicker_styles_templateObject());
var RegionPicker_styles_Item = globalStyles/* styled.li */.zo.li(RegionPicker_styles_templateObject7(), function(param) {
    var theme = param.theme, active = param.active;
    return (0,styled_components_browser_esm/* css */.iv)(RegionPicker_styles_templateObject6(), globalStyles/* media.largeScreen */.BC.largeScreen(RegionPicker_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(RegionPicker_styles_templateObject2()), function(props) {
        return props.theme.typography.smallFontSize;
    }, function(props) {
        return props.theme.typography.thinFontFamily;
    }, globalStyles/* media.largeScreen */.BC.largeScreen(RegionPicker_styles_templateObject3()), globalStyles/* media.smallScreen */.BC.smallScreen(RegionPicker_styles_templateObject4()), active && (0,styled_components_browser_esm/* css */.iv)(RegionPicker_styles_templateObject5(), theme.colors.red, theme.colors.red, theme.colors.baseFont));
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/RegionPicker/RegionPicker.tsx





function getUrlHostMatch(url) {
    var host = window.location.host;
    // const { host: urlHost } = new URL(url | "");
    // FIXME: the regionpicker is failing
    var ref = new URL(url), urlHost = ref.host;
    return host === urlHost;
}
var RegionPicker = function() {
    var ref;
    var layout = (0,context/* usePrismicLayout */.E)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPicker_styles_Wrapper, {
        className: "locales__regions-list",
        children: layout === null || layout === void 0 ? void 0 : (ref = layout.regions) === null || ref === void 0 ? void 0 : ref.map(function(region, index) {
            var ref;
            var link = (0,prismic_config/* linkResolver */.kG)(region.link);
            var isRegionActive = getUrlHostMatch(link);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPicker_styles_Item, {
                active: isRegionActive,
                className: "locales__regions-list-item",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,prismic_config/* imageResolver */.gE)((ref = region.flag) === null || ref === void 0 ? void 0 : ref.url),
                            alt: "".concat(region.region_title, " flag")
                        }),
                        region.region_title
                    ]
                })
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/RegionPicker/index.ts


// EXTERNAL MODULE: ./src/@next/hooks/useMediaQuery/index.ts + 3 modules
var useMediaQuery = __webpack_require__(15996);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var globalStyles_constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/images/chevron-left.svg
var chevron_left_namespaceObject = __webpack_require__.p + "static/images/chevron-left.svg";
;// CONCATENATED MODULE: ./src/@next/components/organisms/MobileNav/types.ts
var TabTypes;
(function(TabTypes) {
    TabTypes[TabTypes["region"] = 0] = "region";
    TabTypes[TabTypes["language"] = 1] = "language";
})(TabTypes || (TabTypes = {}));

;// CONCATENATED MODULE: ./src/@next/components/organisms/MobileNav/NavLocales.tsx

















var NavLocales = function(param) {
    var hideOverlay = param.hideOverlay;
    var ref = (0,react.useState)(false), showLocalesMenu = ref[0], setShowLocalesMenu = ref[1];
    var ref1 = (0,react.useState)(TabTypes.region), currentTabPane = ref1[0], setCurrentTabPane = ref1[1];
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var layout = (0,context/* usePrismicLayout */.E)().layout;
    var user = (0,useUser/* useUser */.a)().user;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(globalStyles_constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref2[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleWrapper, {
        children: [
            !user && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    hideOverlay();
                    esm/* default.show */.ZP.show(Login/* LoginModal */._);
                },
                children: intl.formatMessage({
                    defaultMessage: "Log in to account",
                    id: "q+zDsQ"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    setShowLocalesMenu(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,regions/* localeToFlag */.j3)(locale),
                        alt: ""
                    })
                })
            }),
            isSmallScreen && showLocalesMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleTabsHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleTabsBackButton, {
                                type: "button",
                                onClick: function() {
                                    setShowLocalesMenu(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: chevron_left_namespaceObject,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleTabsButton, {
                                active: currentTabPane === TabTypes.region,
                                type: "button",
                                onClick: function() {
                                    return setCurrentTabPane(TabTypes.region);
                                },
                                children: intl.formatMessage({
                                    defaultMessage: "Region",
                                    id: "lnaWo/"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleTabsButton, {
                                active: currentTabPane === TabTypes.language,
                                type: "button",
                                onClick: function() {
                                    return setCurrentTabPane(TabTypes.language);
                                },
                                children: intl.formatMessage({
                                    defaultMessage: "Language",
                                    id: "y1Z3or"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleTabsContent, {
                        children: [
                            currentTabPane === TabTypes.region && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleTabsDescription, {
                                        children: layout === null || layout === void 0 ? void 0 : layout.region_description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPicker, {})
                                ]
                            }),
                            currentTabPane === TabTypes.language && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleTabsDescription, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalePicker, {
                                        onPicked: hideOverlay
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isSmallScreen && showLocalesMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "locales__close-btn",
                        type: "button",
                        onClick: function() {
                            setShowLocalesMenu(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_left_namespaceObject,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleRegion, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleItemTop, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleItemTitle, {
                                        children: layout === null || layout === void 0 ? void 0 : layout.region_title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleItemSubTitle, {
                                        children: layout === null || layout === void 0 ? void 0 : layout.region_description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPicker, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleLanguage, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleItemTop, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleItemTitle, {
                                        children: intl.formatMessage({
                                            defaultMessage: "Language",
                                            id: "y1Z3or"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleItemSubTitle, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalePicker, {
                                onPicked: hideOverlay
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/MobileNav/NavList.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */ 




















var NavList = function(param) {
    var hideOverlay = param.hideOverlay, items = param.items, contact = param.contact, prismicNav = param.prismicNav;
    var ref;
    var user = (0,useUser/* useUser */.a)().user;
    var checkout = (0,CheckoutProvider/* useCheckout */.Mg)().checkout;
    var cartItemsQuantity = (checkout === null || checkout === void 0 ? void 0 : (ref = checkout.lines) === null || ref === void 0 ? void 0 : ref.reduce(function(amount, line) {
        return line ? amount + line.quantity : amount;
    }, 0)) || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideNav, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                divider: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseImg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                            src: close_black_namespaceObject,
                            onClick: hideOverlay
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadImg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: paths/* paths.home */.H.home,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                onClick: hideOverlay,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                        src: logo,
                                        className: "tablet"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                        src: logo_mobile,
                                        className: "mobile"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_TopBar, {
                        children: [
                            user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_WishlistMenu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_NavIconButton, {
                                icon: "wishlist",
                                onClick: function() {
                                    return esm/* default.show */.ZP.show(Login/* LoginModal */._);
                                }
                            }),
                            user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_UserMenu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_NavIconButton, {
                                icon: "user",
                                onClick: function() {
                                    return esm/* default.show */.ZP.show(Login/* LoginModal */._);
                                },
                                className: "main-menu__nav-link"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_NavIconButton, {
                                icon: "cart",
                                onClick: function() {
                                    return esm/* default.show */.ZP.show(Cart/* CartModal */.k);
                                },
                                counter: cartItemsQuantity
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLocales, {
                        hideOverlay: hideOverlay
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                        children: items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav_NavItem, (0,_object_spread/* default */.Z)({
                                hideOverlay: hideOverlay
                            }, item), item.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav_NavPrismic, {
                        items: prismicNav,
                        hideOverlay: hideOverlay
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav_NavContact, {
                        contact: contact
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/MobileNav/index.ts


;// CONCATENATED MODULE: ./src/@next/components/overlays/SideNav/styles.ts

function SideNav_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // width: 515px;\n    padding: 35px 40px;\n  "
    ]);
    SideNav_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // width: 596px;\n  "
    ]);
    SideNav_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 20px;\n  "
    ]);
    SideNav_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // width: 792px;\n  width: 100%;\n  height: 100%;\n  max-width: 100vw;\n  padding: 40px 40px 40px 84px;\n  max-height: 100%;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    SideNav_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  flex: 0;\n"
    ]);
    SideNav_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    SideNav_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.1em;\n"
    ]);
    SideNav_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 30px;\n    height: 30px;\n    line-height: 32px;\n    margin-left: 10px;\n  "
    ]);
    SideNav_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 24px;\n    height: 24px;\n    line-height: 26px;\n  "
    ]);
    SideNav_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  display: inline-block;\n  width: 36px;\n  height: 36px;\n  line-height: 38px;\n  background-color: rgba(",
        ", 0.2);\n  border-radius: 50%;\n  color: ",
        ";\n  margin-left: 20px;\n  &.not-empty {\n    background-color: ",
        ";\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    SideNav_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SideNav_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  margin-right: 0;\n"
    ]);
    SideNav_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 270px;\n    width: 270px;\n    padding: 28px 42px 32px;\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 366px;\n  width: 366px;\n  background-color: ",
        ";\n  display: flex;\n  padding: 62px;\n  img {\n    mix-blend-mode: darken;\n    height: 100%;\n    margin: auto;\n  }\n  ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 270px;\n  "
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 15px;\n  "
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 29px;\n  width: 366px;\n  display: flex;\n  ",
        "\n  ",
        "\n  .cancel {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .button:last-child {\n    flex-grow: 1;\n    margin-left: 70px;\n  }\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20vh 0 5vh;\n  text-align: center;\n"
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 46px;\n  "
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n  "
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        max-width: 76px;\n      "
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 56px;\n      "
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        max-width: 30px;\n      "
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 22px;\n        transform: translateX(-10px);\n      "
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 70px;\n  ",
        "\n  ",
        "\n  img {\n    vertical-align: middle;\n    height: auto;\n    &:first-child {\n      ",
        "\n      ",
        "\n    }\n    &:last-child {\n      transform: translateX(-15px);\n      ",
        "\n      ",
        "\n    }\n  }\n"
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 26px;\n  "
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.1em;\n  margin-bottom: 35px;\n  ",
        "\n"
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 244px;\n    "
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function styles_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n    "
    ]);
    styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function styles_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  .button {\n    width: 384px;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    styles_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function styles_templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: auto;\n  background-color: ",
        ";\n  padding-top: ",
        ";\n"
    ]);
    styles_templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function styles_templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5em;\n  margin-bottom: 5px;\n"
    ]);
    styles_templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function styles_templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0.8;\n"
    ]);
    styles_templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function styles_templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 15px;\n    margin-top: 15px;\n    margin-bottom: 15px;\n  "
    ]);
    styles_templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function styles_templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  line-height: 1em;\n  padding-top: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border-top: 1px solid rgba(#000, 0.1);\n  ",
        "\n  .",
        " {\n    opacity: 1;\n    color: ",
        ";\n  }\n  .cart__footer__price-name {\n    opacity: 1;\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function styles_templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 1rem auto 1rem;\n  text-align: center;\n\n  button {\n    width: 100%;\n  }\n"
    ]);
    styles_templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}


var styles_Modal = globalStyles/* styled.div */.zo.div(SideNav_styles_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(SideNav_styles_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(SideNav_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(SideNav_styles_templateObject2()));
var styles_Header = globalStyles/* styled.div */.zo.div(SideNav_styles_templateObject4());
var HeaderText = globalStyles/* styled.div */.zo.div(SideNav_styles_templateObject5());
var HeaderTextTitle = globalStyles/* styled.span */.zo.span(SideNav_styles_templateObject6(), function(param) {
    var typography = param.theme.typography;
    return typography.thinFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.h4FontSize;
});
var HeaderTextItem = globalStyles/* styled.span */.zo.span(SideNav_styles_templateObject9(), function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, function(param) {
    var colors = param.theme.colors;
    return colors.white;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(SideNav_styles_templateObject7()), globalStyles/* media.smallScreen */.BC.smallScreen(SideNav_styles_templateObject8()));
var HeaderIcon = (0,globalStyles/* styled */.zo)(react_svg_esm/* ReactSVG */.Q)(SideNav_styles_templateObject10());
var styles_Content = globalStyles/* styled.div */.zo.div(styles_templateObject11());
var ProductImage = globalStyles/* styled.div */.zo.div(styles_templateObject13(), function(param) {
    var colors = param.theme.colors;
    return colors.redLight;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject12()));
var styles_Button = globalStyles/* styled.div */.zo.div(styles_templateObject16(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject14()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(styles_templateObject15()));
var Empty = globalStyles/* styled.div */.zo.div(styles_templateObject17());
var EmptyImage = globalStyles/* styled.div */.zo.div(styles_templateObject24(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject18()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject19()), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject20()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject21()), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject22()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject23()));
var EmptyText = globalStyles/* styled.p */.zo.p(styles_templateObject26(), function(param) {
    var typography = param.theme.typography;
    return typography.thinFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.h4FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject25()));
var EmptyAction = globalStyles/* styled.div */.zo.div(styles_templateObject29(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject27()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject28()));
var Footer = globalStyles/* styled.div */.zo.div(styles_templateObject30(), function(param) {
    var colors = param.theme.colors;
    return colors.white;
}, function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 2)");
});
var FooterPrice = globalStyles/* styled.div */.zo.div(styles_templateObject31(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
});
var FooterPriceName = globalStyles/* styled.span */.zo.span(styles_templateObject32());
var FooterPriceTotal = (0,globalStyles/* styled */.zo)(FooterPrice)(styles_templateObject34(), function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.red;
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject33()), FooterPriceName, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
});
var FooterButton = globalStyles/* styled.div */.zo.div(styles_templateObject35());

;// CONCATENATED MODULE: ./src/@next/components/overlays/SideNav/SideNav.tsx





// import cartImg from "images/cart.svg";
var SideNav_SideNav = function(param) {
    var items = param.items, contact = param.contact, prismicNav = param.prismicNav;
    var modal = (0,esm/* useModal */.dd)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "left",
        show: modal.visible,
        hide: modal.remove,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Modal, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavList, {
                items: items,
                contact: contact,
                prismicNav: prismicNav,
                hideOverlay: modal.remove
            })
        })
    });
};
/* harmony default export */ var overlays_SideNav_SideNav = (esm/* default.create */.ZP.create(SideNav_SideNav));

;// CONCATENATED MODULE: ./src/@next/components/overlays/SideNav/index.ts


// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(26273);
;// CONCATENATED MODULE: ./src/@next/components/molecules/NavOverlay/styles.ts

function NavOverlay_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  max-height: 100%;\n"
    ]);
    NavOverlay_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavOverlay_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    NavOverlay_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavOverlay_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  margin: 0 auto;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    NavOverlay_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavOverlay_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0px;\n  "
    ]);
    NavOverlay_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavOverlay_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  overflow-x: auto;\n  border-bottom: 1px solid #e0e0e0;\n  width: 100%;\n  transition: opacity 0.2s ease;\n  transition-delay: ",
        ";\n  opacity: ",
        ";\n  padding: 0px 30px 0px 30px;\n  ",
        "\n"
    ]);
    NavOverlay_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var opacity = {
    entered: 1,
    entering: 0,
    exited: 0,
    exiting: 0,
    unmounted: 0
};
var OverlayInner = globalStyles/* styled.div */.zo.div(NavOverlay_styles_templateObject());
var Lightbox = globalStyles/* styled.div */.zo.div(NavOverlay_styles_templateObject2(), function(props) {
    return props.theme.colors.white;
}, globalStyles/* media.xSmallScreen */.BC.xSmallScreen(NavOverlay_styles_templateObject1()));
Lightbox.displayName = "S.Lightbox";
var styles_Overlay = globalStyles/* styled.div */.zo.div(NavOverlay_styles_templateObject4(), function(param) {
    var open = param.open;
    return open ? 0 : ".4s";
}, function(param) {
    var state = param.state;
    return opacity[state];
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(NavOverlay_styles_templateObject3()));
styles_Overlay.displayName = "S.Overlay";

;// CONCATENATED MODULE: ./src/@next/components/molecules/NavOverlay/NavOverlay.tsx







var NavOverlay = function(param) {
    var children = param.children, _duration = param.duration, duration = _duration === void 0 ? 300 : _duration, show = param.show, target = param.target;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), mounted = ref1[0], setMounted = ref1[1];
    (0,react.useEffect)(function() {
        ref.current = target || document.getElementById("collection-root");
        setMounted(true);
    }, []);
    var animationProps = {
        open: show
    };
    return mounted && ref.current && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
        in: show,
        timeout: duration,
        unmountOnExit: true,
        children: function(state) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Overlay, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationProps), {
                state: state,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayInner, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationProps), {
                        state: state,
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        children: children
                    }))
                })
            }));
        }
    }), ref.current);
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/NavOverlay/index.ts


// EXTERNAL MODULE: ./src/images/no-photo.svg
var no_photo = __webpack_require__(83171);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./src/images/check.svg
var check = __webpack_require__(45809);
;// CONCATENATED MODULE: ./src/@next/components/molecules/NavDropdown/styles.ts

function NavDropdown_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    NavDropdown_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NavDropdown_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0 20px;\n  "
    ]);
    NavDropdown_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & li {\n      display: none;\n    }\n  "
    ]);
    NavDropdown_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  margin: 0 30px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  text-transform: capitalize;\n  ",
        "\n  ",
        "\n"
    ]);
    NavDropdown_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-top-color: ",
        ";\n      border-top-style: solid;\n      border-top-width: 1px;\n      background-color: #f6f7f8;\n      max-height: 400px;\n      opacity: 1;\n      overflow: visible;\n      transition: max-height 0.2s ease, opacity 0.6s ease;\n    "
    ]);
    NavDropdown_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 120px;\n    "
    ]);
    NavDropdown_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-bottom: 8px;\n      "
    ]);
    NavDropdown_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  left: 0;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 101;\n  display: flex;\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transition: max-height 0.2s ease, opacity 0.2s ease;\n  margin: auto;\n  ",
        "\n\n  li *,\n  ul * {\n    display: block;\n  }\n\n  > ul > li {\n    align-self: flex-start;\n    position: relative;\n    width: 140px;\n    ",
        "\n\n    // 2nd level name\n    > a {\n      font-size: ",
        "\n      position: relative;\n      text-transform: uppercase;\n      padding-bottom: 10px;\n      margin-bottom: 3px;\n      ",
        "\n    }\n    > ul > li:first-child {\n      position: relative;\n\n      &:before {\n        background-color: ",
        ";\n        content: '';\n        height: 1px;\n        left: 0;\n        position: absolute;\n        top: -3px;\n        width: 100%;\n      }\n    }\n\n    ul {\n      // 3rd+ level names\n      a {\n        font-size: ",
        ";\n        font-weight: normal;\n        padding: 6px 0;\n        text-transform: capitalize;\n      }\n\n      li > ul {\n        margin-left: 10px;\n      }\n    }\n  }\n"
    ]);
    NavDropdown_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem;\n  display: inline-flex;\n  justify-content: center;\n  gap: 1.5em;\n  width: 100%;\n"
    ]);
    NavDropdown_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 8px;\n    width: 120px;\n    height: 156px;\n  "
    ]);
    NavDropdown_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100px;\n    height: 130px;\n    margin-bottom: 13px;\n  "
    ]);
    NavDropdown_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 46px;\n      height: 46px;\n    "
    ]);
    NavDropdown_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 30px;\n      height: 30px;\n    "
    ]);
    NavDropdown_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 11px;\n      height: 8px;\n    "
    ]);
    NavDropdown_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 10px;\n      height: 7px;\n    "
    ]);
    NavDropdown_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 140px;\n  height: 182px;\n  margin-bottom: 10px;\n  background-position: center;\n  background-size: cover;\n  position: relative;\n  ",
        "\n  ",
        "\n  &::before {\n    content: '';\n    font-size: 30px;\n    border-radius: 50%;\n    width: 66px;\n    height: 66px;\n    ",
        "\n    ",
        "\n    z-index: 1;\n    opacity: 0;\n    bottom: 50%;\n    right: 50%;\n    position: absolute;\n    transform: translate(50%, 50%);\n  }\n  &::after {\n    content: '';\n    display: block;\n    width: 15px;\n    height: 11px;\n    ",
        "\n    ",
        "\n    background-image: url(",
        ");\n    background-size: cover;\n    background-repeat: no-repeat;\n    bottom: 50%;\n    right: 50%;\n    position: absolute;\n    transform: translate(50%, 50%);\n    z-index: 2;\n    opacity: 0;\n  }\n"
    ]);
    NavDropdown_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #2c2c2c;\n  opacity: 0;\n  transition: 0.3s;\n"
    ]);
    NavDropdown_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 18px;\n  "
    ]);
    NavDropdown_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 21px;\n  text-transform: capitalize;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  display: block;\n  ",
        "\n"
    ]);
    NavDropdown_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 30px;\n  padding: 9px 20px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  transition: all 0.25s ease;\n  white-space: nowrap;\n"
    ]);
    NavDropdown_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a {\n    transition: color 0.6s;\n    background-color: #f0e9eb;\n    &:hover {\n      color: ",
        ";\n      background-color: #ffffff;\n      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);\n      ",
        " {\n        &::before {\n          opacity: 0.2;\n          border: 2px solid #ffffff;\n        }\n        &::after {\n          opacity: 0.2;\n        }\n      }\n      ",
        " {\n        opacity: 0.6;\n      }\n    }\n    &.active {\n      background-color: #ffffff;\n      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);\n      ",
        " {\n        &::before {\n          opacity: 1;\n          background-color: #",
        ";\n        }\n        &::after {\n          opacity: 1;\n        }\n      }\n      ",
        " {\n        opacity: 0.6;\n      }\n      ",
        " {\n        color: ",
        ";\n      }\n      ",
        " {\n        color: ",
        ";\n        background-color: ",
        ";\n      }\n      &:hover {\n        ",
        "::before {\n          border: none;\n        }\n      }\n    }\n  }\n"
    ]);
    NavDropdown_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 8px;\n      padding-bottom: 8px;\n    "
    ]);
    NavDropdown_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 1em !important;\n  span {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    ",
        "\n  }\n"
    ]);
    NavDropdown_styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    NavDropdown_styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 18px 36px 18px 64px;\n  "
    ]);
    NavDropdown_styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 16px 36px 20px 64px;\n    background-color: #ffffff;\n  "
    ]);
    NavDropdown_styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    padding: 0;\n  "
    ]);
    NavDropdown_styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 28px 299px 36px 143px;\n  flex-grow: 1;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    NavDropdown_styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 18px 64px 18px 36px;\n  "
    ]);
    NavDropdown_styles_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 16px 64px 20px 36px;\n  "
    ]);
    NavDropdown_styles_templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 28px 143px 36px 299px;\n  background-color: #f6f7f8;\n  flex-basis: 50%;\n  ",
        "\n  ",
        "\n"
    ]);
    NavDropdown_styles_templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 18px;\n  "
    ]);
    NavDropdown_styles_templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: auto;\n  "
    ]);
    NavDropdown_styles_templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 38px;\n  height: 80px;\n  ",
        "\n  ",
        "\n"
    ]);
    NavDropdown_styles_templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function NavDropdown_styles_templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 13px;\n  "
    ]);
    NavDropdown_styles_templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function styles_templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 9px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: 300;\n  line-height: 100%;\n  ",
        "\n"
    ]);
    styles_templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function styles_templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 280px;\n  "
    ]);
    styles_templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function styles_templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 330px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 160%;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}



var DropdownWrapper = globalStyles/* styled.ul */.zo.ul(NavDropdown_styles_templateObject1(), globalStyles/* media.mediumScreen */.BC.mediumScreen(NavDropdown_styles_templateObject()));
var DropdownItem = globalStyles/* styled.li */.zo.li(NavDropdown_styles_templateObject4(), globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject2()), globalStyles/* media.mediumScreen */.BC.mediumScreen(NavDropdown_styles_templateObject3()));
var DropdownBody = globalStyles/* styled.li */.zo.li(NavDropdown_styles_templateObject8(), function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(NavDropdown_styles_templateObject5(), props.theme.colors.light);
}, globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject6()), function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject7()), function(props) {
    return props.theme.colors.primaryLight;
}, function(props) {
    return props.theme.typography.smallFontSize;
});
var Collection = globalStyles/* styled.ul */.zo.ul(NavDropdown_styles_templateObject9());
var styles_NavItemImage = globalStyles/* styled.div */.zo.div(NavDropdown_styles_templateObject16(), globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject10()), globalStyles/* media.smallScreen */.BC.smallScreen(NavDropdown_styles_templateObject11()), globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject12()), globalStyles/* media.smallScreen */.BC.smallScreen(NavDropdown_styles_templateObject13()), globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject14()), globalStyles/* media.smallScreen */.BC.smallScreen(NavDropdown_styles_templateObject15()), check);
var NavItemOverlay = (0,globalStyles/* styled */.zo)(styles_NavItemImage)(NavDropdown_styles_templateObject17());
var styles_NavItemTitle = globalStyles/* styled.span */.zo.span(NavDropdown_styles_templateObject19(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject18()));
var NavPillTitle = (0,globalStyles/* styled */.zo)(styles_NavItemTitle)(NavDropdown_styles_templateObject20());
var NavDropdown_styles_NavItem = globalStyles/* styled.li */.zo.li(NavDropdown_styles_templateObject21(), function(props) {
    return props.theme.colors.red;
}, styles_NavItemImage, NavItemOverlay, styles_NavItemImage, function(props) {
    return props.theme.colors.gold;
}, NavItemOverlay, styles_NavItemTitle, function(props) {
    return props.theme.colors.red;
}, NavPillTitle, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.colors.red;
}, styles_NavItemImage);
var StackedNavItem = globalStyles/* styled.li */.zo.li(NavDropdown_styles_templateObject23(), globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject22()));
var styles_LocaleWrapper = globalStyles/* styled.div */.zo.div(NavDropdown_styles_templateObject24());
var styles_LocaleRegion = globalStyles/* styled.div */.zo.div(NavDropdown_styles_templateObject28(), globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject25()), globalStyles/* media.mediumScreen */.BC.mediumScreen(NavDropdown_styles_templateObject26()), globalStyles/* media.smallScreen */.BC.smallScreen(NavDropdown_styles_templateObject27()));
var styles_LocaleLanguage = globalStyles/* styled.div */.zo.div(NavDropdown_styles_templateObject31(), globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject29()), globalStyles/* media.mediumScreen */.BC.mediumScreen(NavDropdown_styles_templateObject30()));
var styles_LocaleItemTop = globalStyles/* styled.div */.zo.div(NavDropdown_styles_templateObject34(), globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject32()), globalStyles/* media.mediumScreen */.BC.mediumScreen(NavDropdown_styles_templateObject33()));
var styles_LocaleItemTitle = globalStyles/* styled.h5 */.zo.h5(styles_templateObject36(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(NavDropdown_styles_templateObject35()));
var styles_LocaleItemSubTitle = globalStyles/* styled.p */.zo.p(styles_templateObject38(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.spacing.spacer;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject37()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/NavDropdown/SaleorNavItem.tsx








var SaleorNavItem = function(_param) {
    var children = _param.children, imageUrl = _param.imageUrl, isScrolled = _param.isScrolled, item = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "imageUrl",
        "isScrolled"
    ]);
    var content = children && children.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: children.map(function(subItem, i) {
            return subItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(SaleorNavItem, (0,_object_spread/* default */.Z)({}, subItem), i);
        })
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavDropdown_styles_NavItem, {
        isScrolled: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavLink_NavLink, {
                item: item,
                children: [
                    imageUrl && !isScrolled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_NavItemImage, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: imageUrl,
                                        width: "180",
                                        height: "240",
                                        alt: (0,translations/* translate */.I)(item, "name"),
                                        style: {
                                            maxWidth: "100%",
                                            height: "100%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemOverlay, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_NavItemTitle, {
                                children: (0,translations/* translate */.I)(item, "name")
                            })
                        ]
                    }),
                    isScrolled && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavPillTitle, {
                        children: (0,translations/* translate */.I)(item, "name")
                    })
                ]
            }),
            content
        ]
    });
};
/* harmony default export */ var NavDropdown_SaleorNavItem = (SaleorNavItem);

;// CONCATENATED MODULE: ./src/@next/components/molecules/NavDropdown/SaleorNavDropdown.tsx













var COLLECTIONS_WITH_PICTURE = 8;
var SaleorNavDropdown = function(props) {
    var ref, ref1;
    var onHideDropdown = props.onHideDropdown, onShowDropdown = props.onShowDropdown, showDropdown = props.showDropdown, children = props.children;
    var pathname = (0,router.useRouter)().pathname;
    var isCollectionPage = pathname.includes("collection");
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(globalStyles_constants/* mediumScreen */.M7, "px)")), 1), isMediumScreen = ref2[0];
    react.useEffect(function() {
        onHideDropdown();
    }, [
        isCollectionPage
    ]);
    var collections = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection, {
        children: [
            (ref = children === null || children === void 0 ? void 0 : children.slice(0, COLLECTIONS_WITH_PICTURE)) === null || ref === void 0 ? void 0 : ref.map(function(subItem, i) {
                var ref, ref1, ref2, ref3;
                return subItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown_SaleorNavItem, (0,_object_spread/* default */.Z)({
                    imageUrl: ((ref = subItem.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.backgroundImage) === null || ref1 === void 0 ? void 0 : ref1.url) || ((ref2 = subItem.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.backgroundImage) === null || ref3 === void 0 ? void 0 : ref3.url) || no_photo
                }, subItem), i);
            }),
            (children === null || children === void 0 ? void 0 : children.length) > COLLECTIONS_WITH_PICTURE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StackedNavItem, {
                children: (ref1 = children === null || children === void 0 ? void 0 : children.slice(COLLECTIONS_WITH_PICTURE, children === null || children === void 0 ? void 0 : children.length)) === null || ref1 === void 0 ? void 0 : ref1.map(function(subItem, i) {
                    return subItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown_styles_NavItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink_NavLink, {
                            item: subItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_NavItemTitle, {
                                children: (0,translations/* translate */.I)(subItem, "name")
                            })
                        })
                    });
                })
            })
        ]
    });
    var collectionsShrinked = /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection, {
        children: children === null || children === void 0 ? void 0 : children.map(function(subItem, i) {
            var ref, ref1, ref2, ref3;
            return subItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown_SaleorNavItem, (0,_object_spread/* default */.Z)({
                imageUrl: ((ref = subItem.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.backgroundImage) === null || ref1 === void 0 ? void 0 : ref1.url) || ((ref2 = subItem.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.backgroundImage) === null || ref3 === void 0 ? void 0 : ref3.url) || no_photo,
                isScrolled: true
            }, subItem), i);
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
        active: showDropdown,
        onMouseOver: onShowDropdown,
        onMouseLeave: onHideDropdown,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink_NavLink, {
                    className: "main-menu__nav-link",
                    item: props,
                    onClick: onHideDropdown
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownBody, {
                active: showDropdown,
                children: [
                    isCollectionPage && !isMediumScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavOverlay, {
                        show: true,
                        children: collectionsShrinked
                    }),
                    !isCollectionPage && collections
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/NavDropdown/PrismicNavItem.tsx



function PrismicNavItem(props) {
    var label = props.label, link /* , image, hideOverlay */  = props.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: (0,prismic_config/* linkResolver */.kG)(link),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "main-menu__nav-link",
            children: label
        })
    });
}

;// CONCATENATED MODULE: ./src/@next/components/molecules/NavDropdown/PrismicNavDropdown.tsx




var PrismicNavDropdown = function(props) {
    var onHideDropdown = props.onHideDropdown, onShowDropdown = props.onShowDropdown, showDropdown = props.showDropdown, subItems = props.fields, primary = props.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
        active: showDropdown,
        onMouseOver: onShowDropdown,
        onMouseLeave: onHideDropdown,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNavItem, {
                    label: primary.label,
                    link: primary.link
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownBody, {
                active: showDropdown,
                children: subItems === null || subItems === void 0 ? void 0 : subItems.map(function(subItem, i) {
                    return subItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNavItem, {
                        // hideOverlay={this.hideOverlayHandler}
                        // image={subItem.image}
                        link: subItem.link,
                        label: subItem.label
                    }, i);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/NavDropdown/LocaleDropdown.tsx











var LocaleDropdown = function(props) {
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var layout = (0,context/* usePrismicLayout */.E)().layout;
    var onHideDropdown = props.onHideDropdown, onShowDropdown = props.onShowDropdown, showDropdown = props.showDropdown;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(min-width: ".concat(globalStyles_constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref[0];
    return isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
        active: showDropdown,
        onMouseOver: onShowDropdown,
        onMouseLeave: onHideDropdown,
        onFocus: onShowDropdown,
        onBlur: onHideDropdown,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-menu__nav-link",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,regions/* localeToFlag */.j3)(locale),
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownBody, {
                active: showDropdown,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_LocaleWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_LocaleRegion, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_LocaleItemTop, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LocaleItemTitle, {
                                            children: layout === null || layout === void 0 ? void 0 : layout.region_title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LocaleItemSubTitle, {
                                            children: layout === null || layout === void 0 ? void 0 : layout.region_description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPicker, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_LocaleLanguage, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_LocaleItemTop, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LocaleItemTitle, {
                                            children: intl.formatMessage({
                                                defaultMessage: "Language",
                                                id: "y1Z3or"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LocaleItemSubTitle, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalePicker, {
                                    onPicked: onHideDropdown
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/NavDropdown/index.ts




;// CONCATENATED MODULE: ./src/images/hamburger-hover.svg
var hamburger_hover_namespaceObject = __webpack_require__.p + "static/images/hamburger-hover.svg";
;// CONCATENATED MODULE: ./src/images/hamburger.svg
var hamburger_namespaceObject = __webpack_require__.p + "static/images/hamburger.svg";
// EXTERNAL MODULE: ./src/@next/components/organisms/MainMenu/styles.ts
var styles = __webpack_require__(88681);
;// CONCATENATED MODULE: ./src/@next/components/organisms/MainMenu/MainMenu.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */ 


























var MainMenu = function(param) {
    var prismicNav = param.prismicNav, contact = param.contact, isScrolled = param.isScrolled;
    var ref, ref1;
    var user = (0,useUser/* useUser */.a)().user;
    var checkout = (0,CheckoutProvider/* useCheckout */.Mg)().checkout;
    var locale = (0,router.useRouter)().locale;
    var ref2 = (0,react.useState)(undefined), activeDropdown = ref2[0], setActiveDropdown = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(globalStyles_constants/* mediumScreen */.M7, "px)")), 1), isMediumScreen = ref3[0];
    var data = (0,generatedHooks/* useMainMenuQuery */.ck)({
        variables: (0,_object_spread/* default */.Z)({}, (0,regions/* localeToSaleorQuery */.KK)(locale))
    }).data;
    var items = (data === null || data === void 0 ? void 0 : (ref = data.menu) === null || ref === void 0 ? void 0 : ref.items) || [];
    var cartItemsQuantity = (checkout === null || checkout === void 0 ? void 0 : (ref1 = checkout.lines) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(amount, line) {
        return line ? amount + line.quantity : amount;
    }, 0)) || 0;
    var showDropdownHandler = function(itemId, hasSubNavigation) {
        if (hasSubNavigation) {
            setActiveDropdown(itemId);
        }
    };
    var hideDropdownHandler = function() {
        if (activeDropdown) {
            setActiveDropdown(undefined);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Nav */.JL, {
                as: "nav",
                id: "header",
                isScrolled: isScrolled,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LogoWrapper */.K7, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: paths/* paths.home */.H.home,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Logo */.TR, {
                                        src: logo,
                                        alt: "Reno"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Logo */.TR, {
                                        src: logo_mobile,
                                        width: "24px",
                                        height: "30px",
                                        alt: "Reno",
                                        mobile: true
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LeftMenu */.sk, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* NavWrapper */.br, {
                            children: [
                                isMediumScreen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Hamburger */.pr, {
                                    onClick: function() {
                                        return esm/* default.show */.ZP.show(overlays_SideNav_SideNav, {
                                            items: items,
                                            prismicNav: prismicNav,
                                            contact: contact
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                            src: hamburger_namespaceObject
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                            src: hamburger_hover_namespaceObject,
                                            className: "hamburger--hover"
                                        })
                                    ]
                                }),
                                items === null || items === void 0 ? void 0 : items.map(function(item) {
                                    var ref;
                                    var hasSubNavigation = !!(item === null || item === void 0 ? void 0 : (ref = item.children) === null || ref === void 0 ? void 0 : ref.length);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SaleorNavDropdown, (0,_object_spread/* default */.Z)({
                                        showDropdown: activeDropdown === item.id && hasSubNavigation,
                                        onShowDropdown: function() {
                                            return showDropdownHandler(item.id, hasSubNavigation);
                                        },
                                        onHideDropdown: hideDropdownHandler,
                                        isScrolled: true
                                    }, item), item === null || item === void 0 ? void 0 : item.id);
                                }),
                                prismicNav === null || prismicNav === void 0 ? void 0 : prismicNav.map(function(item, i) {
                                    var ref;
                                    var hasSubNavigation = !!(item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : ref.length);
                                    var itemId = "prismic-nav-".concat(i);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNavDropdown, (0,_object_spread/* default */.Z)({
                                        showDropdown: activeDropdown === itemId && hasSubNavigation,
                                        onShowDropdown: function() {
                                            return showDropdownHandler(itemId, hasSubNavigation);
                                        },
                                        onHideDropdown: hideDropdownHandler
                                    }, item), itemId);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* RightMenu */.gQ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* NavWrapper */.br, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleDropdown, {
                                    showDropdown: activeDropdown === "locales-nav",
                                    onShowDropdown: function() {
                                        return showDropdownHandler("locales-nav", true);
                                    },
                                    onHideDropdown: hideDropdownHandler
                                }, "locales-nav"),
                                user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_WishlistMenu, {
                                    className: "main-menu__nav-link"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_NavIconButton, {
                                    icon: "wishlist",
                                    onClick: function() {
                                        return esm/* default.show */.ZP.show(Login/* LoginModal */._);
                                    },
                                    className: "main-menu__nav-link"
                                }),
                                user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_UserMenu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_NavIconButton, {
                                    icon: "user",
                                    onClick: function() {
                                        return esm/* default.show */.ZP.show(Login/* LoginModal */._);
                                    },
                                    className: "main-menu__nav-link"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_NavIconButton, {
                                    icon: "cart",
                                    onClick: function() {
                                        return esm/* default.show */.ZP.show(Cart/* CartModal */.k);
                                    },
                                    counter: cartItemsQuantity,
                                    className: "main-menu__nav-link"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Collection */.FE, {
                id: "collection-root",
                isScrolled: true
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/MainMenu/index.ts


// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./src/@next/components/molecules/BottomBar/styles.ts

function BottomBar_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    BottomBar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BottomBar_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: ",
        ";\n  height: auto;\n  text-align: center;\n  p {\n    margin: 5px 0;\n  }\n  ",
        "\n"
    ]);
    BottomBar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var BottomBar_styles_Wrapper = globalStyles/* styled.div */.zo.div(BottomBar_styles_templateObject1(), function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(BottomBar_styles_templateObject()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/BottomBar/BottomBar.tsx





var BottomBar = function(param) {
    var copyright = param.copyright, terms = param.terms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomBar_styles_Wrapper, {
        children: [
            copyright && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                field: copyright
            }),
            terms && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                field: terms,
                linkResolver: prismic_config/* linkResolver */.kG
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/BottomBar/index.ts


;// CONCATENATED MODULE: ./src/images/footer-icons/facebook.svg
var facebook_namespaceObject = __webpack_require__.p + "static/images/facebook.svg";
;// CONCATENATED MODULE: ./src/images/footer-icons/instagram.svg
var instagram_namespaceObject = __webpack_require__.p + "static/images/instagram.svg";
;// CONCATENATED MODULE: ./src/images/footer-icons/pinterest.svg
var pinterest_namespaceObject = __webpack_require__.p + "static/images/pinterest.svg";
;// CONCATENATED MODULE: ./src/@next/components/molecules/SocialsNav/styles.ts

function SocialsNav_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n  "
    ]);
    SocialsNav_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SocialsNav_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 65px;\n  ",
        "\n"
    ]);
    SocialsNav_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SocialsNav_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 15px;\n"
    ]);
    SocialsNav_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var SocialsNav_styles_Wrapper = globalStyles/* styled.div */.zo.div(SocialsNav_styles_templateObject1(), globalStyles/* media.mediumScreen */.BC.mediumScreen(SocialsNav_styles_templateObject()));
var styles_Link = globalStyles/* styled.a */.zo.a(SocialsNav_styles_templateObject2());

;// CONCATENATED MODULE: ./src/@next/components/molecules/SocialsNav/SocialsNav.tsx







var SocialsNav = function(param) {
    var social = param.social;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(SocialsNav_styles_Wrapper, {
        children: social === null || social === void 0 ? void 0 : social.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Link, {
                href: (0,prismic_config/* linkResolver */.kG)(item.footer_social_link),
                target: "_blank",
                rel: "noreferrer",
                children: [
                    item.footer_social_type === "facebook" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: facebook_namespaceObject,
                        width: "38px",
                        height: "38px",
                        alt: item.footer_social_type || "social"
                    }),
                    item.footer_social_type === "instagram" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        width: "38px",
                        height: "38px",
                        src: instagram_namespaceObject,
                        alt: item.footer_social_type || "social"
                    }),
                    item.footer_social_type === "pinterest" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        width: "38px",
                        height: "38px",
                        src: pinterest_namespaceObject,
                        alt: item.footer_social_type || "social"
                    })
                ]
            }, "nav-social-".concat(i));
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/SocialsNav/index.ts


// EXTERNAL MODULE: ./src/core/config.ts + 15 modules
var config = __webpack_require__(42443);
;// CONCATENATED MODULE: ./src/@next/components/organisms/Footer/styles.ts

function Footer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    Footer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 60px;\n  "
    ]);
    Footer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 70px;\n  // padding-bottom: 25px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  ",
        "\n  a {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 2.4em;\n  }\n"
    ]);
    Footer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 20px 0;\n  "
    ]);
    Footer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px 0;\n  background-color: rgba(",
        ", 0.5);\n  ",
        "\n"
    ]);
    Footer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 20px;\n  "
    ]);
    Footer_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 10px;\n  "
    ]);
    Footer_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 2em;\n  margin-bottom: 25px;\n  color: #7796a4;\n  ",
        "\n  ",
        "\n  * {\n    font: inherit;\n  }\n"
    ]);
    Footer_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 5px;\n  "
    ]);
    Footer_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 2.4em;\n  ",
        "\n  * {\n    line-height: inherit;\n    font: inherit;\n  }\n"
    ]);
    Footer_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n  "
    ]);
    Footer_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 70px;\n  ",
        "\n"
    ]);
    Footer_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Footer_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 5px;\n  "
    ]);
    Footer_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n  ",
        "\n"
    ]);
    Footer_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function Footer_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n"
    ]);
    Footer_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var styles_Footer = globalStyles/* styled.footer */.zo.footer(Footer_styles_templateObject(), function(props) {
    return props.theme.colors.secondaryDark;
}, function(props) {
    return props.theme.colors.white;
});
var Footer_styles_Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(Footer_styles_templateObject2(), globalStyles/* media.smallScreen */.BC.smallScreen(Footer_styles_templateObject1()), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
});
var Bottom = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(Footer_styles_templateObject4(), function(props) {
    return props.theme.colors.secondary;
}, globalStyles/* media.largeScreen */.BC.largeScreen(Footer_styles_templateObject3()));
var Title = globalStyles/* styled.div */.zo.div(Footer_styles_templateObject7(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h5FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(Footer_styles_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(Footer_styles_templateObject6()));
var Footer_styles_Text = globalStyles/* styled.div */.zo.div(Footer_styles_templateObject9(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(Footer_styles_templateObject8()));
var NavGroup = globalStyles/* styled.div */.zo.div(Footer_styles_templateObject11(), globalStyles/* media.smallScreen */.BC.smallScreen(Footer_styles_templateObject10()));
var Nav = globalStyles/* styled.ul */.zo.ul(Footer_styles_templateObject12());
var Footer_styles_NavItem = globalStyles/* styled.li */.zo.li(Footer_styles_templateObject14(), globalStyles/* media.largeScreen */.BC.largeScreen(Footer_styles_templateObject13()));
var PaymentItem = globalStyles/* styled.div */.zo.div(Footer_styles_templateObject15());

;// CONCATENATED MODULE: ./src/@next/components/organisms/Footer/Footer.tsx












var Footer_Footer = function(param) {
    var title = param.title, contact = param.contact, text = param.text, social = param.social, navGroups = param.navGroups, copyright = param.copyright, terms = param.terms;
    var availablePaymentGateways = (0,react.useContext)(ShopProvider_context/* ShopContext */.Iw).availablePaymentGateways;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Footer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavGroup, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                    field: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_styles_Text, {
                                children: text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                    field: text
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsNav, {
                                contact: contact
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialsNav, {
                                social: social
                            })
                        ]
                    }, "NavGroup_contact"),
                    navGroups === null || navGroups === void 0 ? void 0 : navGroups.map(function(group, i) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(NavGroup, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: (ref = group.primary) === null || ref === void 0 ? void 0 : ref.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
                                    children: (ref1 = group.fields) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, ii) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_styles_NavItem, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (0,prismic_config/* linkResolver */.kG)(item.link),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: item.label
                                                })
                                            })
                                        }, "NavItem_".concat(ii));
                                    })
                                })
                            ]
                        }, "NavGroup_".concat(i));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavGroup, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    defaultMessage: "Payment we accept",
                                    id: "Tsyo0g"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
                                children: availablePaymentGateways.map(function(param, index) {
                                    var id = param.id, name = param.name;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_styles_NavItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentItem, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: config/* PROVIDERS */.aA[id].icon,
                                                    width: "20px",
                                                    height: "20px",
                                                    alt: ""
                                                }),
                                                config/* PROVIDERS */.aA[id].label
                                            ]
                                        })
                                    }, id);
                                })
                            })
                        ]
                    }, "payment-methods")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bottom, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBar, {
                    copyright: copyright,
                    terms: terms
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/Footer/index.ts


// EXTERNAL MODULE: ./src/images/contact-widget/whatsapp-widget.svg
var whatsapp_widget = __webpack_require__(76380);
;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsWidgetWhatsapp/styles.ts

function ContactsWidgetWhatsapp_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    bottom: 40px;\n    right: 30px;\n  "
    ]);
    ContactsWidgetWhatsapp_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactsWidgetWhatsapp_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 60px;\n  right: 50px;\n  z-index: ",
        ";\n  display: flex;\n  align-items: flex-end;\n  ",
        "\n"
    ]);
    ContactsWidgetWhatsapp_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactsWidgetWhatsapp_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n  "
    ]);
    ContactsWidgetWhatsapp_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContactsWidgetWhatsapp_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  display: ",
        ";\n  margin-bottom: 40px;\n  &:last-child {\n    margin-bottom: 0 !important;\n  }\n  ",
        "\n"
    ]);
    ContactsWidgetWhatsapp_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContactsWidgetWhatsapp_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 40px;\n      max-height: 40px;\n      width: auto;\n      height: auto;\n    "
    ]);
    ContactsWidgetWhatsapp_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ContactsWidgetWhatsapp_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 60px;\n  height: 60px;\n  flex: 0 0 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: ",
        ";\n  img {\n    display: block;\n    ",
        "\n  }\n"
    ]);
    ContactsWidgetWhatsapp_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ContactsWidgetWhatsapp_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  line-height: 1.5em;\n  fon-familyt: ",
        ";\n  font-size: ",
        ";\n  white-space: nowrap;\n  text-transform: capitalize;\n"
    ]);
    ContactsWidgetWhatsapp_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ContactsWidgetWhatsapp_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: none;\n  font-size: ",
        ";\n  opacity: 0.8;\n  margin-top: 5px;\n"
    ]);
    ContactsWidgetWhatsapp_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var ContactsWidgetWhatsapp_styles_Wrapper = globalStyles/* styled.div */.zo.div(ContactsWidgetWhatsapp_styles_templateObject1(), function(param) {
    var active = param.active;
    return active ? 100 : 95;
}, globalStyles/* media.largeScreen */.BC.largeScreen(ContactsWidgetWhatsapp_styles_templateObject()));
var handleIconType = function(icon) {
    switch(icon){
        case "messenger":
            return "#2f80ed";
        case "whatsapp":
            return "#40c351";
        case "help":
            return "#4f6e7c";
        default:
            return "#ca9c66";
    }
};
var LinkWrapper = globalStyles/* styled.a */.zo.a(ContactsWidgetWhatsapp_styles_templateObject3(), function(param) {
    var icon = param.icon;
    return !(icon === "help") ? "flex" : "none";
}, globalStyles/* media.largeScreen */.BC.largeScreen(ContactsWidgetWhatsapp_styles_templateObject2()));
var IconWrapper = globalStyles/* styled.div */.zo.div(ContactsWidgetWhatsapp_styles_templateObject5(), function(param) {
    var icon = param.icon;
    return handleIconType(icon);
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(ContactsWidgetWhatsapp_styles_templateObject4()));
var ContactsWidgetWhatsapp_styles_Text = globalStyles/* styled.div */.zo.div(ContactsWidgetWhatsapp_styles_templateObject6(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
});
var Hint = globalStyles/* styled.div */.zo.div(ContactsWidgetWhatsapp_styles_templateObject7(), function(props) {
    return props.theme.typography.smallFontSize;
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsWidgetWhatsapp/ContactsWidgetWhatsapp.tsx








function ContactsWidgetWhatsapp() {
    var layout = (0,context/* usePrismicLayout */.E)().layout;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useScrolled */.M4)(250, 600), 1), isScrolled = ref[0];
    var contact = layout === null || layout === void 0 ? void 0 : layout.contact.filter(function(c) {
        return c.type === "whatsapp";
    });
    return isScrolled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsWidgetWhatsapp_styles_Wrapper, {
        active: true,
        children: contact === null || contact === void 0 ? void 0 : contact.map(function(c, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                href: (0,prismic_config/* linkResolver */.kG)(c.link),
                icon: c.type,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                    icon: c.type,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: c.type === "whatsapp" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: whatsapp_widget,
                            alt: "whatsapp"
                        })
                    })
                })
            }, "contact-widget-".concat(i));
        })
    }) : null;
}

;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsWidgetWhatsapp/index.ts


// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
;// CONCATENATED MODULE: ./src/app/analytics.ts
/* eslint-disable */ 


var lastPath;
var pathnameMap = {
    "^/$": "homepage",
    "^/(inspirations|inspirationen|inspiracje)/$": "inspiration-main",
    "inspirations|inspirationen|inspiracje": "inspiration",
    "^/blog/$": "blog-main",
    "/blog/": "blog",
    "/product/": "product",
    "/c/": "collection",
    "/(avis|bewertungen|opinie)/": "review"
};
function remap(map, str) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(map)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (str.match(new RegExp(key, "i"))) return value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "other";
}
// export async function gtmAnalyticsInitialize() {
//   if (analyticsGTM) {
//     const TagManager = await import('react-gtm-module');
//     TagManager.initialize({ gtmId: analyticsGTM });
//   }
//   return 'other';
// }
/**
 * Sends analytics information about the pages visited.
 *
 * @param url (Dynamic) Path name as given by the react router.
 * @returns void
 */ function trackPage(url) {
    return _trackPage.apply(this, arguments);
}
function _trackPage() {
    _trackPage = (0,_async_to_generator/* default */.Z)(function(url) {
        var ref, splitted, path, contentGroup;
        return (0,tslib_es6.__generator)(this, function(_state) {
            splitted = url.split("?");
            path = splitted[0];
            contentGroup = remap(pathnameMap, path);
            // Debug
            // console.log('trackPage');
            // console.log({ url, path, lastPath, contentGroup });
            if (path === lastPath) return [
                2
            ];
            lastPath = path;
            if (window === null || window === void 0 ? void 0 : window.gtag) {
                window.gtag("set", "content_group", contentGroup);
            } else {
                window.dataLayer = window.dataLayer || [];
                window.gtag = window.gtag || function gt() {
                    // eslint-disable-next-line prefer-rest-params
                    window.dataLayer.push(arguments);
                };
                // window.gtag('js', new Date());
                window.gtag("set", "content_group", contentGroup);
            }
            window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.page({
                path: path
            });
            return [
                2
            ];
        });
    });
    return _trackPage.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/app/Notifications.tsx





// import { ServiceWorkerContext } from '@components/containers';
var Notifications = function() {
    var intl = (0,useIntl/* default */.Z)();
    var alert = (0,hooks/* useNotifier */.kC)();
    // const { updateAvailable } = React.useContext(ServiceWorkerContext);
    /* React.useEffect(() => {
    if (updateAvailable) {
      alert.show(
        {
          actionText: intl.formatMessage({
            defaultMessage: 'Refresh',
            id: 'rELDbB',
          }),
          content: intl.formatMessage({
            defaultMessage:
              'To update the application to the latest version, please refresh the page!',
            id: 'DClFoP',
          }),
          title: intl.formatMessage({
            defaultMessage: 'New version is available!',
            id: '5qDwFV',
          }),
        },
        {
          onClose: () => {
            window.location.reload();
          },
          timeout: 0,
          type: 'success',
        }
      );
    }
  }, [updateAvailable]); */ var authenticated = (0,useUser/* useUser */.a)().authenticated;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), prevAuthenticated = ref[0], setPrevAuthenticated = ref[1];
    react.useEffect(function() {
        if (prevAuthenticated !== undefined && authenticated !== undefined) {
            if (!prevAuthenticated && authenticated) {
                alert.show({
                    message: intl.formatMessage({
                        defaultMessage: "You are now logged in",
                        id: "jrEpw7"
                    }),
                    status: "success"
                });
            } else if (prevAuthenticated && !authenticated) {
                alert.show({
                    message: intl.formatMessage({
                        defaultMessage: "You are now logged out",
                        id: "/NZV5a"
                    }),
                    status: "success"
                });
            }
            setPrevAuthenticated(authenticated);
        } else if (authenticated !== undefined) {
            setPrevAuthenticated(authenticated);
        }
    }, [
        authenticated
    ]);
    return null;
};
/* harmony default export */ var app_Notifications = (Notifications);

;// CONCATENATED MODULE: ./src/app/App.tsx
/* eslint-disable react/jsx-no-constructed-context-values */ 











// import { ContactsWidget } from '@components/organisms/ContactsWidget';







var App = function(param) {
    var children = param.children;
    // const location = useLocation();
    var ref = (0,next_translate_routes_router.useRouter)(), events = ref.events, pathname = ref.pathname, asPath = ref.asPath, isReady = ref.isReady;
    // const { tokenRefreshing, tokenVerifying } = useAuth();
    // if (tokenRefreshing || tokenVerifying) {
    //  return <Loader />;
    // }
    var data = (0,prismicHooks/* usePrismicLayoutQuery */.JWf)({}).data;
    var isCheckout = pathname.includes("checkout");
    // const isThankYouPage = pathname.includes('order-finalized');
    var isCollectionPage = pathname.includes("collection");
    var isHomePage = pathname === "/";
    var hideMenu = isCheckout;
    var hideTopBar = !isHomePage;
    var layout = (0,react.useMemo)(function() {
        return data === null || data === void 0 ? void 0 : data.layout;
    }, [
        data === null || data === void 0 ? void 0 : data.layout
    ]);
    var ref1 = layout || {}, header_message = ref1.header_message, header_navigation = ref1.header_navigation, // header_navigation_all_types_image,
    footer_contact_title = ref1.footer_contact_title, footer_contact_text = ref1.footer_contact_text, footer_copyright = ref1.footer_copyright, footer_navigation = ref1.footer_navigation, footer_terms = ref1.footer_terms, footer_social = ref1.footer_social, contact = ref1.contact;
    (0,react.useEffect)(function() {
        if (isReady) {
            // console.log('page_view isReady');
            trackPage(asPath);
        }
    }, [
        isReady
    ]);
    (0,react.useEffect)(function() {
        var handleRouteChange = function(path, param) {
            var shallow = param.shallow;
            // console.log('page_view handleRouteChange');
            // console.log( `App is changing to ${path} ${ shallow ? 'with' : 'without'} shallow routing`);
            trackPage(path);
        };
        events.on("routeChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        events
    ]);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useScrolled */.M4)(isCollectionPage ? 250 : 350, 600), 1), isScrolled = ref2[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* PrismicLayoutContext.Provider */.U.Provider, {
            value: {
                layout: layout
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* default.Provider */.ZP.Provider, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBoundary/* ErrorBoundary */.S, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                children: !hideMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        !hideTopBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar, {
                                            contact: contact,
                                            message: header_message,
                                            isScrolled: isScrolled
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu, {
                                            prismicNav: header_navigation,
                                            contact: contact,
                                            isScrolled: isScrolled || hideTopBar
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx/* clsx */.W)("page-wrapper", {
                                    "no-margin": hideMenu,
                                    topbar: !hideTopBar
                                }),
                                children: children
                            }),
                            !hideMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsWidgetWhatsapp, {}),
                            !hideMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                                title: footer_contact_title,
                                contact: contact,
                                text: footer_contact_text,
                                social: footer_social,
                                navGroups: footer_navigation,
                                copyright: footer_copyright,
                                terms: footer_terms
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(app_Notifications, {})
                ]
            })
        })
    });
};
/* harmony default export */ var app_App = (App);

;// CONCATENATED MODULE: ./src/app/PreconnectManifest.tsx


var PreconnectManifest = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: constants/* apiUrl */.JW
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: constants/* mediaUri */.UW
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: constants/* analyticsDataPlaneUrl */.Oj
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: constants/* prismicUrl */.aX
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/app/PreloadedFonts.tsx

var PreloadedFonts = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/Inter-Regular.woff2",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/Inter-Regular.woff",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/Inter-Regular.ttf",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProBold.woff2",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProBold.woff",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProBold.ttf",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProLight.woff2",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProLight.woff",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProLight.ttf",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProRegular.woff2",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProRegular.woff",
                as: "font",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: "/fonts/SofiaProRegular.ttf",
                as: "font",
                crossOrigin: ""
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/app/index.ts




;// CONCATENATED MODULE: ./src/pages/_app.tsx
// import '../styles/globals.css';





















function _app_App(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var ref = (0,router.useRouter)(), asPath = ref.asPath, basePath = ref.basePath;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)("subscribeTimeout", null, {
        sync: true
    }), 2), subscribeTimeout = ref1[0], setSubscribeTimeout = ref1[1];
    var useSaleorAuthClientProps = useSaleorAuthClient({
        saleorApiUrl: constants/* apiUrl */.JW,
        storage:  true ? window.localStorage : 0
    });
    var saleorAuthClient = useSaleorAuthClientProps.saleorAuthClient;
    var ref2 = useAuthenticatedApolloClient(saleorAuthClient.fetchWithAuth), apolloClient = ref2.apolloClient, resetClient = ref2.resetClient;
    useAuthChange({
        onSignedOut: function() {
            return resetClient();
        },
        onSignedIn: function() {
            return apolloClient.refetchQueries({
                include: [
                    "UserDetails",
                    "Wishlist"
                ]
            });
        }
    });
    // show modal in 1 min after mounted
    (0,react.useEffect)(function() {
        if (constants/* subscribeNotification */.OE) {
            if (subscribeTimeout < Date.now()) {
                var timer = setTimeout(function() {
                    esm/* default.show */.ZP.show(Subscribe_Subscribe);
                }, 60000);
                // ensure the Modal is only show once 7 days
                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 7);
                setSubscribeTimeout(tomorrow.getTime());
                // clear timer if the component unmount
                return function() {
                    return clearTimeout(timer);
                };
            }
        }
    }, []);
    var icon180 = "".concat(basePath, "/apple-touch-icon.png");
    var icon32 = "".concat(basePath, "/favicon-32x32.png");
    var icon16 = "".concat(basePath, "/favicon-16x16.png");
    var icon = "".concat(basePath, "/favicon.png");
    var iconsafari = "".concat(basePath, "/safari-pinned-tab.svg");
    var manifest = "".concat(basePath, "/manifest.json");
    var path = asPath.split("?")[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreloadedFonts, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreconnectManifest, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: icon180
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: icon32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: icon16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        href: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: manifest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: iconsafari,
                        color: "#5bbad5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#da532c"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: globalStyles/* defaultTheme */.uH,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toastr/* ToastrProvider */.zN, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleProvider, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(globalStyles/* GlobalStyle */.ZL, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SaleorAuthProvider/* SaleorAuthProvider */.s, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useSaleorAuthClientProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider, {
                                    client: apolloClient,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutProvider/* CheckoutProvider */.oo, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(app_App, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps), path)
                                        })
                                    })
                                })
                            }))
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var _app = ((0,next_translate_routes.withTranslateRoutes)(JSON.parse('{"defaultLocale":"fr","locales":["fr"],"routesTree":{"name":"","paths":{"default":""},"children":[{"name":"account-confirm","paths":{"default":"account-confirm"}},{"name":"index","paths":{"default":"index"}},{"name":"order-finalized","paths":{"default":"order-finalized"}},{"name":"reset-password","paths":{"default":"reset-password"}},{"name":"wishlist","paths":{"default":"wishlist"}},{"name":"account","paths":{"default":"account"},"children":[{"name":"address-book","paths":{"default":"address-book"}},{"name":"index","paths":{"default":"index"}},{"name":"order-history","paths":{"default":"order-history"},"children":[{"name":"index","paths":{"default":"index"}},{"name":"[token]","paths":{"default":":token"}}]}]},{"name":"architect","paths":{"default":"architect","fr":"architecte","de":"architekt","pl":"architekt"},"children":[{"name":"index","paths":{"default":"index"}}]},{"name":"blog","paths":{"default":"blog"},"children":[{"name":"index","paths":{"default":"index"}},{"name":"[slug]","paths":{"default":":slug"}}]},{"name":"cart","paths":{"default":"cart"},"children":[{"name":"index","paths":{"default":"index"}},{"name":"redirect","paths":{"default":"redirect"},"children":[{"name":"[token]","paths":{"default":":token"}}]}]},{"name":"checkout","paths":{"default":"checkout"},"children":[{"name":"address","paths":{"default":"address"}},{"name":"index","paths":{"default":"index"}},{"name":"payment-confirm","paths":{"default":"payment-confirm"}},{"name":"payment","paths":{"default":"payment"}},{"name":"shipping","paths":{"default":"shipping"}}]},{"name":"collection","paths":{"default":"collection","en":"c/sliding-door","fr":"c/porte-coulissante","de":"c/schiebetuer","pl":"c/drzwi-przesuwne"},"children":[{"name":"[slug]","paths":{"default":":slug"},"children":[{"name":"[id]","paths":{"default":":id"}}]}]},{"name":"contacts","paths":{"default":"contacts","fr":"contactez-nous","de":"kontakt","pl":"kontakt"},"children":[{"name":"index","paths":{"default":"index"}}]},{"name":"inspirations","paths":{"default":"inspirations","de":"inspirationen","pl":"inspiracje"},"children":[{"name":"index","paths":{"default":"index"}},{"name":"[slug]","paths":{"default":":slug"}}]},{"name":"order-history","paths":{"default":"order-history"},"children":[{"name":"[token]","paths":{"default":":token"}}]},{"name":"page","paths":{"default":"page"},"children":[{"name":"[slug]","paths":{"default":":slug"}}]},{"name":"product","paths":{"default":"product"},"children":[{"name":"[slug]","paths":{"default":":slug"},"children":[{"name":"[id]","paths":{"default":":id"}}]}]},{"name":"reviews","paths":{"default":"reviews","fr":"avis","de":"bewertungen","pl":"opinie"},"children":[{"name":"index","paths":{"default":"index"}},{"name":"[slug]","paths":{"default":":slug"}}]},{"name":"server-sitemap-index.xml","paths":{"default":"server-sitemap-index.xml"},"children":[{"name":"index","paths":{"default":"index"}}]}]},"fallbackLng":{}}'), _app_App));


/***/ }),

/***/ 98461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageBlurSvg = __webpack_require__(42730);
var _imageConfig = __webpack_require__(99309);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, fill = _param.fill, style = _param.style, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "className",
        "quality",
        "width",
        "height",
        "fill",
        "style",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var loader = defaultLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var blurWidth;
    var blurHeight;
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        if (!staticImageData.height || !staticImageData.width) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurWidth = staticImageData.blurWidth;
        blurHeight = staticImageData.blurHeight;
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!fill) {
            if (!widthInt && !heightInt) {
                widthInt = staticImageData.width;
                heightInt = staticImageData.height;
            } else if (widthInt && !heightInt) {
                var ratio = widthInt / staticImageData.width;
                heightInt = Math.round(staticImageData.height * ratio);
            } else if (!widthInt && heightInt) {
                var ratio1 = heightInt / staticImageData.height;
                widthInt = Math.round(staticImageData.width * ratio1);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(false), 2), showAltText = ref1[0], setShowAltText = ref1[1];
    var qualityInt = getInt(quality);
    if (false) { var url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign(fill ? {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    } : {}, showAltText ? {} : {
        color: "transparent"
    }, style);
    var blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
        backgroundSize: imgStyle.objectFit || "cover",
        backgroundPosition: imgStyle.objectPosition || "50% 50%",
        backgroundRepeat: "no-repeat",
        backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
            widthInt: widthInt,
            heightInt: heightInt,
            blurWidth: blurWidth,
            blurHeight: blurHeight,
            blurDataURL: blurDataURL
        }), '")')
    } : {};
    if (false) {}
    var imgAttributes = generateImgAttrs({
        config: config,
        src: src,
        unoptimized: unoptimized,
        width: widthInt,
        quality: qualityInt,
        sizes: sizes,
        loader: loader
    });
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        fill: fill,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setShowAltText: setShowAltText
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
var configEnv = {"deviceSizes":[340,540,767,1279,1599,1919,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image/","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var allImgs = new Map();
var perfObserver;
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number" || typeof x === "undefined") {
        return x;
    }
    if (typeof x === "string" && /^[0-9]+$/.test(x)) {
        return parseInt(x, 10);
    }
    return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            onLoadingCompleteRef.current(img);
        }
        if (false) { var widthModified, heightModified, valid, position, widthViewportRatio; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, fill = _param.fill, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setShowAltText = _param.setShowAltText, onLoad = _param.onLoad, onError = _param.onError, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "fill",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setShowAltText",
        "onLoad",
        "onError"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        width: widthInt,
        height: heightInt,
        decoding: "async",
        "data-nimg": "future".concat(fill ? "-fill" : ""),
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            srcString,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete,
            onError, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            // if the real image fails to load, this will ensure "alt" is visible
            setShowAltText(true);
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })));
};
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 71210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(78875).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(38748).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 78875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(94317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 42730:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
    var widthInt = param.widthInt, heightInt = param.heightInt, blurWidth = param.blurWidth, blurHeight = param.blurHeight, blurDataURL = param.blurDataURL;
    var std = blurWidth && blurHeight ? "1" : "20";
    var svgWidth = blurWidth || widthInt;
    var svgHeight = blurHeight || heightInt;
    var feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map


/***/ }),

/***/ 45506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button_Button; },
  "Z": function() { return /* reexport */ Button_ButtonLink; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Button/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n    border: none;\n    &:hover,\n    &.hover {\n      background-color: ",
        ";\n      color: ",
        ";\n    }\n    &:active,\n    &.active,\n    &:active:focus {\n      background-color: ",
        ";\n    }\n    &:disabled,\n    &.disabled {\n      background-color: ",
        ";\n      &,\n      &:hover {\n        cursor: default;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // background-color: ",
        ";\n    color: ",
        ";\n    border: 1px solid ",
        ";\n    &:hover,\n    &.hover {\n      filter: brightness(0.9);\n    }\n    &:active,\n    &.active,\n    &:active:focus {\n      filter: brightness(0.8);\n    }\n    &:disabled {\n      filter: brightness(0.13);\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n    color: ",
        ";\n    border: none;\n    transform: none;\n    text-decoration: none;\n    &:hover,\n    &.hover {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: none;\n    box-shadow: none;\n    transition: ",
        ";\n    outline: none;\n    cursor: pointer;\n    border-radius: 4px;\n    padding: ",
        ";\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  text-transform: ",
        ";\n  letter-spacing: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var padding = {
    lg: "1.25rem 2.44em",
    md: "1rem 3rem",
    sm: "0.9rem 1rem"
};
var fontSize = function(fontSize, smallFontSize) {
    return {
        lg: fontSize,
        md: fontSize,
        sm: smallFontSize
    };
};
var fontFamily = function(baseFontFamily, boldFontFamily) {
    return {
        base: baseFontFamily,
        bold: boldFontFamily
    };
};
var filled = (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), function(param) {
    var color = param.color, theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.button.colors[color].background, theme.button.colors[color].color, theme.button.colors[color].hoverBackground, theme.button.colors[color].hoverColor, theme.button.colors[color].activeBackground, theme.colors.disabled);
});
var outline = (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), function(param) {
    var color = param.color, size = param.size, theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), theme.colors.white, theme.button.colors[color].background, theme.button.colors[color].background);
});
var ghost = (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), function(param) {
    var color = param.color, theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), color === "secondary" ? theme.link.secondary.color : theme.link.base.color, color === "secondary" ? theme.link.secondary.hoverColor : theme.link.base.hoverColor);
});
var appearances = {
    filled: filled,
    ghost: ghost,
    outline: outline
};
var ButtonStyle = (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), function(param) {
    var theme = param.theme, color = param.color, size = param.size, fullWidth = param.fullWidth, appearance = param.appearance;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), theme.button.animation.transition, padding[size], fullWidth ? "width:100%;" : "width:auto;", globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject6(), fullWidth ? "100%" : "88%"), appearance && appearances[appearance]);
});
var Button = globalStyles/* styled.button */.zo.button(_templateObject9(), ButtonStyle);
var ButtonLink = globalStyles/* styled.a */.zo.a(_templateObject10(), ButtonStyle);
var Text = globalStyles/* styled.span */.zo.span(_templateObject12(), function(param) {
    var size = param.size, _theme = param.theme, typography = _theme.button.typography;
    return fontSize(typography.fontSize, typography.smallFontSize)[size];
}, function(param) {
    var font = param.font, _theme = param.theme, typography = _theme.button.typography;
    return fontFamily(typography.baseFontFamily, typography.boldFontFamily)[font];
}, function(props) {
    return props.font === "bold" ? "uppercase" : undefined;
}, function(props) {
    return props.font === "bold" ? "1px" : undefined;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject11(), function(props) {
    return props.theme.button.typography.smallFontSize;
}));

;// CONCATENATED MODULE: ./src/@next/components/atoms/Button/Button.tsx






/**
 * The basic button
 */ var Button_Button = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "primary" : _color, _appearance = _param.appearance, appearance = _appearance === void 0 ? "filled" : _appearance, btnRef = _param.btnRef, children = _param.children, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _size = _param.size, size = _size === void 0 ? "md" : _size, _font = _param.font, font = _font === void 0 ? "bold" : _font, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "appearance",
        "btnRef",
        "children",
        "fullWidth",
        "size",
        "font"
    ]);
    return (0,jsx_runtime.jsx)(Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: color,
        fullWidth: fullWidth,
        size: size,
        appearance: appearance,
        ref: btnRef
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
            size: size,
            font: font,
            children: children
        })
    }));
};
/**
 * The basic button
 */ var Button_ButtonLink = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "primary" : _color, _appearance = _param.appearance, appearance = _appearance === void 0 ? "filled" : _appearance, children = _param.children, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _size = _param.size, size = _size === void 0 ? "md" : _size, _font = _param.font, font = _font === void 0 ? "bold" : _font, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "appearance",
        "children",
        "fullWidth",
        "size",
        "font"
    ]);
    return (0,jsx_runtime.jsx)(ButtonLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: color,
        fullWidth: fullWidth,
        size: size,
        appearance: appearance
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
            size: size,
            font: font,
            children: children
        })
    }));
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Button/index.ts



/***/ }),

/***/ 79052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ CartFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/@next/components/atoms/Loader/index.ts + 2 modules
var Loader = __webpack_require__(35582);
// EXTERNAL MODULE: ./src/@next/components/molecules/CartPromoCode/index.ts + 9 modules
var CartPromoCode = __webpack_require__(50594);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/CartFooter/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    grid-template-areas:\n      ". subtotalText subtotalPrice"\n      ',
        "\n      ",
        '\n      "totalText totalPrice";\n    grid-template-columns: 3.5fr 2fr;\n  '
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  font-size: ",
        ";\n  grid-template-areas:\n    'subtotalText subtotalPrice'\n    ",
        "\n    ",
        "\n    'totalText totalPrice';\n  grid-template-columns: 4fr 1.1fr;\n  ",
        "\n  border-bottom: 1px solid rgba(50, 50, 50, 0.1);\n  margin-top: auto;\n  padding-top: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5em;\n  margin-bottom: 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: subtotalText;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: subtotalPrice;\n  text-align: right;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: shippingText;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: shippingPrice;\n  text-align: right;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: discountText;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: discountPrice;\n  text-align: right;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 15px;\n    margin-top: 15px;\n    margin-bottom: 15px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: totalText;\n  color: ",
        ";\n  line-height: 1em;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border-top: 1px solid rgba(#000, 0.1);\n  font-size: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 15px;\n    margin-top: 15px;\n    margin-bottom: 15px;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: totalPrice;\n  font-weight: bold;\n  text-align: right;\n  color: ",
        ";\n  line-height: 1em;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border-top: 1px solid rgba(#000, 0.1);\n  font-size: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject1(), function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.showShipping && '"shippingText shippingPrice"';
}, function(props) {
    return props.showDiscount && '"discountText discountPrice"';
}, function(props) {
    return globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject(), props.showShipping && '"shippingText shippingPrice"', props.showDiscount && '"discountText discountPrice"');
}, function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 2)");
});
var Text = globalStyles/* styled.div */.zo.div(_templateObject2(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.labelFontSize;
});
var SubtotalText = (0,globalStyles/* styled */.zo)(Text)(_templateObject3());
var SubtotalPrice = (0,globalStyles/* styled */.zo)(Text)(_templateObject4());
var ShippingText = (0,globalStyles/* styled */.zo)(Text)(_templateObject5());
var ShippingPrice = (0,globalStyles/* styled */.zo)(Text)(_templateObject6());
var DiscountText = (0,globalStyles/* styled */.zo)(Text)(_templateObject7());
var DiscountPrice = (0,globalStyles/* styled */.zo)(Text)(_templateObject8());
var TotalText = globalStyles/* styled.div */.zo.div(_templateObject10(), function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject9()));
var TotalPrice = globalStyles/* styled.div */.zo.div(_templateObject12(), function(param) {
    var colors = param.theme.colors;
    return colors.red;
}, function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject11()));
var PromoCode = globalStyles/* styled.div */.zo.div(_templateObject13());

;// CONCATENATED MODULE: ./src/@next/components/atoms/CartFooter/CartFooter.tsx







/**
 * Cart footer to use with conjunction of cart rows
 */ var CartFooter = function(param) {
    var subtotalPrice = param.subtotalPrice, shippingPrice = param.shippingPrice, discountPrice = param.discountPrice, totalPrice = param.totalPrice;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), promoCodeLoading = ref[0], setPromoCodeLoading = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        showShipping: !!shippingPrice,
        showDiscount: !!discountPrice,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtotalText, {
                children: intl.formatMessage({
                    defaultMessage: "Subtotal",
                    id: "L8seEc"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtotalPrice, {
                children: subtotalPrice
            }),
            shippingPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingText, {
                        children: intl.formatMessage(src_intl/* commonMessages.shipping */.i4.shipping)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingPrice, {
                        children: shippingPrice
                    })
                ]
            }),
            discountPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountText, {
                        children: intl.formatMessage({
                            defaultMessage: "Promo Code",
                            id: "CyOkb5"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountPrice, {
                        children: promoCodeLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                            inline: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: discountPrice
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                children: intl.formatMessage({
                    defaultMessage: "Total",
                    id: "MJ2jZQ"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPrice, {
                children: promoCodeLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    primary: true,
                    inline: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: totalPrice
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoCode, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPromoCode/* CartPromoCode */.n, {
                    loading: promoCodeLoading,
                    setLoading: setPromoCodeLoading
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/@next/components/atoms/CartFooter/index.ts



/***/ }),

/***/ 73881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Checkbox/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1.25rem;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  margin-left: -4px;\n  font-family: Inter;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  padding-right: 0.5rem;\n  input[type='checkbox'] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 26px;\n    width: 26px;\n\n    span {\n      border: 1px solid ",
        ";\n      border-radius: 4px;\n      width: 20px;\n      height: 20px;\n      display: inline-block;\n    }\n\n    :focus {\n      border: none;\n      outline: none;\n    }\n  }\n\n  input:checked + div {\n    span {\n      background-color: ",
        ";\n      background-clip: content-box;\n      border-color: ",
        ";\n      &:after {\n        color: ",
        ";\n        content: '\\2713';\n        position: absolute;\n        top: 3px;\n        left: 5px;\n      }\n    }\n  }\n"
    ], [
        "\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  padding-right: 0.5rem;\n  input[type='checkbox'] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 26px;\n    width: 26px;\n\n    span {\n      border: 1px solid ",
        ";\n      border-radius: 4px;\n      width: 20px;\n      height: 20px;\n      display: inline-block;\n    }\n\n    :focus {\n      border: none;\n      outline: none;\n    }\n  }\n\n  input:checked + div {\n    span {\n      background-color: ",
        ";\n      background-clip: content-box;\n      border-color: ",
        ";\n      &:after {\n        color: ",
        ";\n        content: '\\\\2713';\n        position: absolute;\n        top: 3px;\n        left: 5px;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Checkbox = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.colors.graySemi;
});
var Label = globalStyles/* styled.label */.zo.label(_templateObject1(), function(props) {
    return props.theme.colors.dividerDark;
}, function(props) {
    return props.theme.button.colors[props.color].background;
}, function(props) {
    return props.theme.button.colors[props.color].background;
}, function(props) {
    return props.theme.button.colors[props.color].color;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Checkbox/Checkbox.tsx






var ENTER_KEY = 13;
var SPACE_KEY = 32;
var Checkbox_Checkbox = function(_param) {
    var name = _param.name, checked = _param.checked, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, children = _param.children, _color = _param.color, color = _color === void 0 ? "secondary" : _color, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "checked",
        "onChange",
        "children",
        "color",
        "className"
    ]);
    var ref = react.useRef(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Checkbox, {
        className: className,
        ref: ref,
        onClick: function(evt) {
            evt.preventDefault();
            onChange(evt);
            if (ref.current) {
                ref.current.blur();
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                color: color,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        tabIndex: -1,
                        type: "checkbox",
                        name: name,
                        checked: checked,
                        readOnly: true
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "button",
                        ref: ref,
                        tabIndex: 0,
                        onKeyDown: function(evt) {
                            if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
                                evt.preventDefault();
                                onChange(evt);
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    })
                ]
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Checkbox/index.ts



/***/ }),

/***/ 24433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ DropdownMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/hooks/index.ts + 10 modules
var hooks = __webpack_require__(40918);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/DropdownMenu/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 2.5rem;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 2;\n  right: -3rem;\n  left: auto;\n  // top: 3.8rem;\n  box-shadow: ",
        ";\n  background-color: ",
        ";\n  width: 18rem;\n  border-radius: 7px;\n  ",
        "\n  ul {\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 2rem;\n    align-items: flex-start;\n    li {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject());
var Content = globalStyles/* styled.div */.zo.div(_templateObject2(), function(props) {
    return props.theme.input.selectMenuShadow;
}, function(props) {
    return props.theme.colors.white;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject1()));

;// CONCATENATED MODULE: ./src/@next/components/atoms/DropdownMenu/DropdownMenu.tsx




var DropdownMenu = function(param) {
    var header = param.header, items = param.items, type = param.type;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var setElementRef = (0,hooks/* useHandlerWhenClickedOutside */.so)(function() {
        setVisible(false);
    }).setElementRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        ref: setElementRef(),
        onMouseEnter: function() {
            return type === "hoverable" && setVisible(true);
        },
        onMouseLeave: function() {
            return type === "hoverable" && setVisible(false);
        },
        onClick: function() {
            return type === "clickable" && setVisible(!visible);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: header
            }),
            visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: items.map(function(element, id) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            onClick: function() {
                                setVisible(false);
                                if (element === null || element === void 0 ? void 0 : element.onClick) {
                                    element.onClick();
                                }
                            },
                            children: element.content
                        }, id);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/DropdownMenu/index.ts



/***/ }),

/***/ 98615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* reexport */ ErrorMessage_ErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/ErrorMessage/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 !important;\n  color: #fe6e76 !important;\n  font-size: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var ErrorMessage = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.colors.error;
}, function(props) {
    return props.theme.input.labelFontSize;
});
var ErrorParagraph = globalStyles/* styled.p */.zo.p(_templateObject1(), function(props) {
    return props.theme.input.labelFontSize;
});
ErrorMessage.displayName = "S.ErrorMessage";

;// CONCATENATED MODULE: ./src/@next/components/atoms/ErrorMessage/ErrorMessage.tsx



var ErrorMessage_ErrorMessage = function(param) {
    var errors = param.errors;
    return errors && errors.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorParagraph, {
            children: errors[0].message
        })
    }) : null;
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts



/***/ }),

/***/ 31484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ Icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Icon/definitions.ts
var icons = {
    arrow_back: [
        {
            d: "M4.965 17.333h25.684c0.353 0 0.689-0.14 0.939-0.39s0.393-0.59 0.393-0.943-0.143-0.693-0.393-0.943c-0.25-0.25-0.586-0.39-0.939-0.39h-25.691l6.613-5.653c0.266-0.23 0.433-0.557 0.463-0.91 0.027-0.35-0.087-0.7-0.316-0.97-0.23-0.267-0.556-0.433-0.909-0.463-0.35-0.027-0.699 0.087-0.969 0.317l-9.354 8c-0.27 0.23-0.436 0.557-0.463 0.91-0.027 0.35 0.087 0.7 0.313 0.97 0.076 0.088 0.162 0.165 0.257 0.23l9.247 7.917c0.27 0.23 0.616 0.343 0.969 0.317s0.679-0.193 0.909-0.463c0.23-0.27 0.343-0.617 0.316-0.97s-0.193-0.68-0.463-0.91l-6.606-5.653z",
            fill: "#7D7D7D"
        }, 
    ],
    arrow_up: [
        {
            d: "M16.4951 8.31701L13.5055 11.6804L8.2503 7.00908L2.99512 11.6803L0.00547949 8.31701L8.2503 0.988281L16.4951 8.31701Z",
            fill: "#323232"
        }, 
    ],
    cart: [
        {
            d: "M23 9h1.992c0.125 0 0.248 0.015 0.368 0.043 0.172 0.037 0.34 0.090 0.502 0.155 0.393 0.158 0.758 0.373 1.090 0.633 0.31 0.238 0.583 0.52 0.808 0.84 0.077 0.113 0.142 0.232 0.195 0.357 0.025 0.060 0.043 0.12 0.055 0.182l0.995 16.907c0 0.033 0.005 0.067 0.007 0.103 0.003 0.015 0.003 0.033 0.003 0.050-0.003 0.163-0.045 0.323-0.123 0.467-0.122 0.243-0.287 0.457-0.487 0.64-0.215 0.2-0.46 0.363-0.727 0.48-0.197 0.090-0.41 0.137-0.627 0.143h-22.035c-0.223-0.005-0.442-0.055-0.645-0.145-0.28-0.117-0.535-0.28-0.76-0.482-0.205-0.18-0.375-0.395-0.502-0.635-0.078-0.143-0.12-0.297-0.123-0.457 0-0.017 0-0.035 0.002-0.053 0.005-0.037 0.007-0.073 0.010-0.11l0.995-16.92c0.040-0.26 0.123-0.512 0.243-0.748 0.147-0.29 0.338-0.557 0.565-0.79 0.2-0.21 0.435-0.383 0.692-0.512 0.17-0.088 0.357-0.137 0.548-0.148h2.96c0 0.274 0 0.697 0 1.268-0.598 0.346-1 0.992-1 1.732 0 1.104 0.896 2 2 2s2-0.896 2-2c0-0.74-0.402-1.386-1-1.732v-1.268h10v1.268c-0.598 0.346-1 0.992-1 1.732 0 1.104 0.896 2 2 2s2-0.896 2-2c0-0.74-0.403-1.386-1-1.732 0-0.254 0-0.677 0-1.268zM23 7c0-0.602 0-1.602 0-3 0-2.593-1.132-4-3.449-4s-4.728 0-7.086 0c-2.358 0-3.465 1.576-3.465 4.128 0 0.62 0 1.578 0 2.872h-2.999c-1.945 0.042-3.759 2.014-4 4l-1 17c-0.233 2.027 2.009 4 4 4h22c2.046 0.037 4.221-2.006 4-4l-1-17c-0.25-2-2.945-4-5-4h-2zM11 7v-2.872c0-0.003 0-0.005 0-0.005 0-0.225 0.012-0.447 0.037-0.67 0.023-0.18 0.057-0.357 0.105-0.532 0.053-0.208 0.145-0.402 0.275-0.572 0.080-0.098 0.182-0.172 0.297-0.223 0.090-0.038 0.185-0.067 0.283-0.085 0.152-0.027 0.305-0.040 0.457-0.040 0.002 0 0.005 0 0.010 0h7.085c0.005 0 0.007 0 0.010 0 0.16 0 0.317 0.013 0.475 0.038 0.103 0.018 0.203 0.045 0.3 0.085 0.105 0.040 0.2 0.105 0.277 0.19 0.115 0.147 0.198 0.315 0.245 0.498 0.047 0.167 0.083 0.337 0.103 0.51 0.027 0.225 0.040 0.447 0.040 0.672 0 0.002 0 0.005 0 0.007v3h-10z",
            fill: "#323232"
        }, 
    ],
    edit: [
        {
            d: "M23.1275 15.2343C23.3732 14.9886 23.3732 14.5791 23.1275 14.346L21.6533 12.8718C21.4202 12.6261 21.0107 12.6261 20.765 12.8718L19.6058 14.0247L21.9683 16.3872L23.1275 15.2343ZM11.9702 21.6666V24.0291H14.3327L21.3005 17.055L18.938 14.6925L11.9702 21.6666Z",
            fill: "#545555"
        }, 
    ],
    expand: [
        {
            d: "M15.667 11.333c1.283 0 2.333-1.050 2.333-2.333s-1.050-2.333-2.333-2.333c-1.283 0-2.333 1.050-2.333 2.333s1.050 2.333 2.333 2.333zM15.667 13.667c-1.283 0-2.333 1.050-2.333 2.333s1.050 2.333 2.333 2.333c1.283 0 2.333-1.050 2.333-2.333s-1.050-2.333-2.333-2.333zM15.667 20.667c-1.283 0-2.333 1.050-2.333 2.333s1.050 2.333 2.333 2.333c1.283 0 2.333-1.050 2.333-2.333s-1.050-2.333-2.333-2.333z",
            fill: "#323232"
        }, 
    ],
    filter: [
        {
            d: "M 14.25 18.679688 L 4.054688 2.261719 L 27.945312 2.261719 L 17.75 18.679688 L 17.75 24.902344 L 14.25 27.507812 Z M 12 19.324219 L 12 31.996094 L 20 26.039062 L 20 19.324219 L 31.996094 0.00390625 L 0.00390625 0.00390625 Z M 12 19.324219 ",
            fill: "#323232"
        }, 
    ],
    hamburger: [
        {
            d: "M2 5h28c1.104 0 2 0.896 2 2s-0.896 2-2 2h-28c-1.104 0-2-0.896-2-2s0.896-2 2-2z",
            fill: "#323232"
        },
        {
            d: "M2 14h28c1.104 0 2 0.896 2 2s-0.896 2-2 2h-28c-1.104 0-2-0.896-2-2s0.896-2 2-2z",
            fill: "#323232"
        },
        {
            d: "M2 23h28c1.104 0 2 0.896 2 2s-0.896 2-2 2h-28c-1.104 0-2-0.896-2-2s0.896-2 2-2z",
            fill: "#323232"
        }, 
    ],
    heart: [
        {
            d: "M2.05597 5.8182L7.15994 10.8023L12.2639 5.81819L12.2898 5.79614C12.8859 5.28839 13.2533 4.55408 13.2533 3.74089C13.2533 2.24945 12.0084 1 10.4222 1C9.70694 1 9.05975 1.25663 8.56419 1.67743C8.34581 1.86287 8.15742 2.07981 8.00622 2.32L7.15989 3.66441L6.31363 2.31995C6.1625 2.07984 5.97414 1.86295 5.75574 1.67752C5.26005 1.25667 4.61258 1 3.89728 1C2.31127 1 1.06665 2.24928 1.06665 3.74089C1.06665 4.55411 1.43403 5.28842 2.03009 5.79615L2.05597 5.8182ZM6.81034 11.8586L1.38164 6.55741C0.577115 5.8721 0.0666504 4.86575 0.0666504 3.74089C0.0666504 1.67482 1.78142 0 3.89728 0C4.85667 0 5.73192 0.345498 6.40295 0.915207C6.43274 0.940499 6.46212 0.96623 6.49109 0.992395C6.74933 1.22559 6.97476 1.49305 7.15994 1.78725C7.34515 1.49304 7.57057 1.22557 7.82878 0.992367C7.85775 0.9662 7.88713 0.940466 7.91692 0.915172C8.58782 0.345484 9.46281 0 10.4222 0C12.5381 0 14.2533 1.67482 14.2533 3.74089C14.2533 4.86575 13.7428 5.8721 12.9382 6.55741L7.50954 11.8586C7.41683 11.9491 7.29109 12 7.15994 12C7.02879 12 6.90305 11.9491 6.81034 11.8586Z",
            fill: "#323232"
        }, 
    ],
    heart_filled: [
        {
            d: "M8.03947 1.68919C7.18808 0.94893 6.07756 0.5 4.86029 0.5C2.1757 0.5 0 2.67621 0 5.3608C0 6.82241 0.647676 8.13003 1.66845 9.0205L8.55637 15.9087C8.67401 16.0263 8.83354 16.0924 8.99994 16.0924C9.16635 16.0924 9.32588 16.0263 9.44352 15.9087L16.3314 9.0205C17.3523 8.13003 18 6.82241 18 5.3608C18 2.67621 15.8237 0.5 13.1391 0.5C11.9218 0.5 10.8116 0.948911 9.96039 1.68915C9.58577 2.01492 9.26131 2.39711 8.99994 2.8223C8.73863 2.39713 8.41414 2.01495 8.03947 1.68919Z",
            fill: "#323232"
        }, 
    ],
    horizontal_line: [
        {
            d: "M0 13.818h32v4.364h-32v-4.364z",
            fill: "#323232"
        }, 
    ],
    plus: [
        {
            d: "M18 14v-12c0-1.104-0.896-2-2-2s-2 0.896-2 2v12h-12c-1.104 0-2 0.896-2 2s0.896 2 2 2h12v12c0 1.104 0.896 2 2 2s2-0.896 2-2v-12h12c1.104 0 2-0.896 2-2s-0.896-2-2-2h-12z",
            fill: "#21125E"
        }, 
    ],
    profile: [
        {
            d: "M29.643 26.969c0-2.906-3.326-6.953-7.349-7.969-0.998-0.3-1.822-1.53-1-2 2.012-1.047 3-5.817 3-9 0-5.108-3.909-8-7.857-8-3.95 0-8.143 2.891-8.143 8 0 3.336 1.016 7.997 2.955 9 0.758 0.437 0.113 1.727-1 2-3.954 1.010-7.894 5-7.894 7.969 0 0.726-0.356 3.023 0.644 4.031-0.031 0 2.996 1 13 1 10 0 13.003-0.999 13-1 1.004-0.996 0.644-3.305 0.644-4.031zM27.655 29.263c-0.545 0.103-1.093 0.187-1.645 0.252-1.285 0.155-2.575 0.265-3.867 0.333-2.045 0.107-4.095 0.157-6.143 0.153-2.045 0.005-4.087-0.045-6.127-0.153-1.295-0.065-2.585-0.175-3.87-0.33-0.555-0.065-1.107-0.15-1.655-0.253-0.015-0.085-0.025-0.172-0.032-0.257-0.015-0.17-0.022-0.34-0.020-0.512 0.003-0.298 0.013-0.595 0.032-0.893 0.015-0.203 0.025-0.405 0.027-0.61 0.003-0.203 0.032-0.405 0.093-0.6 0.085-0.287 0.2-0.565 0.345-0.828 0.178-0.33 0.38-0.645 0.607-0.942 0.26-0.34 0.54-0.663 0.84-0.965 0.645-0.65 1.365-1.22 2.147-1.695 0.383-0.235 0.78-0.44 1.19-0.62 0.377-0.165 0.768-0.3 1.165-0.405 0.758-0.19 1.438-0.603 1.955-1.185 0.248-0.275 0.45-0.585 0.603-0.923 0.175-0.385 0.27-0.803 0.277-1.225 0.008-0.46-0.105-0.915-0.325-1.32-0.245-0.44-0.607-0.802-1.050-1.042-0.057-0.030-0.11-0.070-0.152-0.12-0.133-0.145-0.248-0.305-0.345-0.475-0.148-0.257-0.277-0.522-0.385-0.797-0.135-0.337-0.252-0.678-0.352-1.025-0.227-0.795-0.395-1.602-0.502-2.42-0.113-0.8-0.168-1.605-0.17-2.41-0.002-0.468 0.045-0.933 0.143-1.388 0.088-0.405 0.217-0.8 0.39-1.178 0.325-0.702 0.795-1.333 1.377-1.843 0.582-0.513 1.258-0.913 1.988-1.18 0.717-0.268 1.48-0.405 2.247-0.407 0.745 0 1.485 0.135 2.18 0.403 0.693 0.26 1.325 0.65 1.867 1.15 0.555 0.515 0.998 1.14 1.298 1.835 0.165 0.383 0.29 0.782 0.372 1.192 0.093 0.465 0.138 0.94 0.138 1.413-0.005 0.783-0.060 1.565-0.168 2.34-0.107 0.818-0.275 1.627-0.502 2.42-0.1 0.352-0.22 0.697-0.355 1.040-0.113 0.28-0.243 0.552-0.395 0.815-0.1 0.177-0.223 0.345-0.36 0.497-0.050 0.055-0.108 0.1-0.173 0.135-0.425 0.23-0.78 0.573-1.027 0.985-0.24 0.412-0.365 0.885-0.358 1.362 0.010 0.447 0.12 0.887 0.323 1.287 0.157 0.32 0.363 0.615 0.605 0.878 0.505 0.557 1.155 0.963 1.875 1.175 0.407 0.103 0.803 0.237 1.183 0.41 0.385 0.173 0.755 0.375 1.11 0.605 0.715 0.465 1.365 1.022 1.93 1.663 0.267 0.297 0.513 0.615 0.737 0.95 0.2 0.297 0.377 0.612 0.533 0.937 0.127 0.272 0.23 0.555 0.305 0.845 0.055 0.213 0.085 0.433 0.085 0.653 0.005 0.21 0.013 0.417 0.030 0.625 0.020 0.292 0.030 0.592 0.033 0.892 0.002 0.17-0.005 0.34-0.020 0.51-0.008 0.083-0.018 0.163-0.030 0.245z",
            fill: "#323232"
        }, 
    ],
    search: [
        {
            d: "M25.992 24.578l5.712 5.712c0.187 0.187 0.293 0.443 0.293 0.707s-0.105 0.517-0.293 0.705c-0.187 0.187-0.443 0.295-0.707 0.295s-0.52-0.107-0.707-0.295l-5.712-5.71c-2.607 2.279-6.019 3.66-9.75 3.66-8.183 0-14.827-6.643-14.827-14.826s6.644-14.827 14.827-14.827c8.183 0 14.826 6.644 14.826 14.827 0 3.732-1.382 7.144-3.661 9.751zM24.113 23.673c1.068-1.123 1.927-2.429 2.534-3.855 0.665-1.58 1.007-3.275 1.007-4.99 0-0.002 0-0.003 0-0.003 0-1.712-0.343-3.41-1.007-4.987-0.647-1.525-1.583-2.91-2.753-4.077-1.17-1.173-2.555-2.105-4.077-2.752-1.58-0.667-3.275-1.010-4.99-1.008-1.715-0.002-3.41 0.34-4.99 1.008-1.523 0.647-2.908 1.58-4.077 2.752-1.17 1.167-2.105 2.553-2.75 4.075-0.667 1.58-1.010 3.277-1.010 4.992 0 1.713 0.343 3.41 1.010 4.99 0.645 1.523 1.58 2.908 2.75 4.078s2.555 2.105 4.077 2.75c1.58 0.667 3.275 1.010 4.988 1.007h0.003c0 0 0 0 0.002 0 1.713 0.003 3.41-0.34 4.988-1.007 1.427-0.605 2.733-1.464 3.855-2.531 0.047-0.094 0.109-0.181 0.185-0.256s0.163-0.138 0.256-0.185z",
            fill: "#323232"
        }, 
    ],
    select_arrow: [
        {
            d: "M16 29.856l-15.999-27.712h31.999l-15.999 27.712z",
            fill: "#21125E"
        }, 
    ],
    select_x: [
        {
            d: "M16 12.8l-12.8-12.8-3.2 3.2 12.8 12.8-12.8 12.8 3.2 3.2 12.8-12.8 12.8 12.8 3.2-3.2-12.8-12.8 12.8-12.8-3.2-3.2-12.8 12.8z",
            fill: "#21125E"
        }, 
    ],
    social_facebook: [
        {
            d: "M16 0c-8.822 0-16 7.178-16 16s7.178 16 16 16c8.822 0 16-7.178 16-16s-7.177-16-16-16zM19.979 16.563h-2.603c0 4.159 0 9.278 0 9.278h-3.857c0 0 0-5.070 0-9.278h-1.834v-3.279h1.834v-2.121c0-1.519 0.722-3.893 3.893-3.893l2.858 0.011v3.183c0 0-1.737 0-2.075 0s-0.818 0.169-0.818 0.893v1.927h2.939l-0.337 3.279z",
            fill: "#21125e"
        }, 
    ],
    social_instagram: [
        {
            d: "M16 32c-8.836 0-16-7.163-16-16s7.164-16 16-16c8.836 0 16 7.163 16 16s-7.164 16-16 16zM22.609 5.451h-13.307c-2.124 0-3.852 1.728-3.852 3.852v13.307c0 2.124 1.728 3.852 3.852 3.852h13.307c2.124 0 3.852-1.728 3.852-3.852v-13.307c0-2.123-1.728-3.852-3.852-3.852zM10.512 7.335c-1.752 0-3.177 1.425-3.177 3.177v10.976c0 1.752 1.425 3.177 3.177 3.177h10.976c1.752 0 3.177-1.425 3.177-3.177v-10.976c0-1.752-1.425-3.177-3.177-3.177h-10.976zM16 21.705c-3.145 0-5.705-2.559-5.705-5.705s2.559-5.705 5.705-5.705c3.146 0 5.705 2.559 5.705 5.705s-2.559 5.705-5.705 5.705zM21.888 11.475c-0.745 0-1.35-0.606-1.35-1.35 0-0.273 0.081-0.526 0.22-0.737 0.065-0.1 0.143-0.19 0.232-0.269 0.239-0.213 0.554-0.344 0.899-0.344 0.568 0 1.055 0.352 1.253 0.85 0.062 0.155 0.096 0.323 0.096 0.5 0 0.744-0.605 1.35-1.35 1.35zM12.705 15.999c0-1.815 1.479-3.293 3.295-3.293s3.294 1.478 3.294 3.293c0 1.817-1.477 3.295-3.294 3.295s-3.295-1.478-3.295-3.295z",
            fill: "#21125e"
        }, 
    ],
    social_twitter: [
        {
            d: "M16 0c-8.822 0-16 7.178-16 16s7.178 16 16 16c8.822 0 16-7.178 16-16s-7.177-16-16-16zM23.138 12.338c0.007 0.159 0.011 0.318 0.011 0.478 0 4.866-3.703 10.476-10.479 10.476-2.080 0-4.016-0.608-5.645-1.653 0.288 0.034 0.581 0.052 0.878 0.052 1.726 0 3.313-0.589 4.574-1.576-1.611-0.030-2.972-1.094-3.44-2.558 0.224 0.043 0.456 0.066 0.692 0.066 0.336 0 0.662-0.044 0.971-0.128-1.685-0.338-2.954-1.826-2.954-3.611 0-0.015 0-0.032 0.001-0.046 0.496 0.275 1.064 0.441 1.667 0.46-0.987-0.659-1.638-1.787-1.638-3.065 0-0.675 0.181-1.308 0.498-1.852 1.816 2.229 4.53 3.694 7.59 3.849-0.063-0.27-0.095-0.55-0.095-0.84 0-2.033 1.649-3.683 3.682-3.683 1.060 0 2.015 0.447 2.688 1.163 0.84-0.165 1.626-0.47 2.339-0.894-0.277 0.86-0.859 1.582-1.622 2.038 0.746-0.089 1.457-0.286 2.115-0.579-0.491 0.737-1.116 1.386-1.835 1.904z",
            fill: "#21125e"
        }, 
    ],
    social_youtube: [
        {
            d: "M13.084 19.507c2.401-1.245 4.781-2.479 7.183-3.724-2.409-1.257-4.788-2.498-7.183-3.747 0 2.499 0 4.973 0 7.471z",
            fill: "#21125e"
        },
        {
            d: "M16 0c-8.836 0-16 7.163-16 16s7.164 16 16 16 16-7.163 16-16c0-8.837-7.164-16-16-16zM26.902 21.341c-0.277 1.201-1.26 2.088-2.442 2.22-2.801 0.313-5.636 0.315-8.46 0.313-2.824 0.002-5.659 0-8.461-0.313-1.183-0.132-2.165-1.018-2.441-2.22-0.394-1.711-0.394-3.579-0.394-5.341s0.005-3.63 0.398-5.341c0.276-1.201 1.258-2.088 2.441-2.22 2.802-0.313 5.638-0.315 8.461-0.313 2.823-0.002 5.659 0 8.459 0.313 1.183 0.132 2.166 1.018 2.442 2.22 0.394 1.711 0.391 3.579 0.391 5.341s-0.001 3.63-0.395 5.341z",
            fill: "#21125e"
        }, 
    ],
    subcategories: [
        {
            d: "M29.856 16l-27.713 16v-32l27.713 16z",
            fill: "#323232"
        }, 
    ],
    tick: [
        {
            d: "M31.416 2.142l-19.195 29.858-11.638-12.414 2.889-2.709 8.164 8.708 16.448-25.586 3.331 2.142z",
            fill: "#13BEBB"
        }, 
    ],
    trash: [
        {
            d: "M28.496 5.327h-6.236v-1.017c0-1.818-1.479-3.297-3.297-3.297h-5.928c-1.818 0-3.297 1.479-3.297 3.297v1.017h-6.236c-0.462 0-0.832 0.37-0.832 0.832s0.37 0.832 0.832 0.832h1.504v19.546c0 2.452 1.996 4.449 4.449 4.449h13.088c2.452 0 4.449-1.997 4.449-4.449v-19.546h1.504c0.462 0 0.832-0.37 0.832-0.832s-0.37-0.832-0.832-0.832zM11.403 4.311c0-0.9 0.733-1.633 1.633-1.633h5.928c0.9 0 1.633 0.733 1.633 1.633v1.017h-9.194v-1.017zM25.329 26.537c0 1.534-1.251 2.785-2.785 2.785h-13.088c-1.534 0-2.785-1.251-2.785-2.785v-19.546h18.665v19.546h-0.006z M16 26.341c0.462 0 0.832-0.37 0.832-0.832v-14.702c0-0.462-0.37-0.832-0.832-0.832s-0.832 0.37-0.832 0.832v14.696c0 0.462 0.37 0.838 0.832 0.838z M10.571 25.423c0.462 0 0.832-0.37 0.832-0.832v-12.872c0-0.462-0.37-0.832-0.832-0.832s-0.832 0.37-0.832 0.832v12.872c0 0.462 0.376 0.832 0.832 0.832z M21.428 25.423c0.462 0 0.832-0.37 0.832-0.832v-12.872c0-0.462-0.37-0.832-0.832-0.832s-0.832 0.37-0.832 0.832v12.872c0 0.462 0.37 0.832 0.832 0.832z",
            fill: "#323232"
        }, 
    ],
    x: [
        {
            d: "M16 12.8l-12.8-12.8-3.2 3.2 12.8 12.8-12.8 12.8 3.2 3.2 12.8-12.8 12.8 12.8 3.2-3.2-12.8-12.8 12.8-12.8-3.2-3.2-12.8 12.8z",
            fill: "#c4c4c4"
        }, 
    ],
    x_dark: [
        {
            d: "M16 12.8l-12.8-12.8-3.2 3.2 12.8 12.8-12.8 12.8 3.2 3.2 12.8-12.8 12.8 12.8 3.2-3.2-12.8-12.8 12.8-12.8-3.2-3.2-12.8 12.8z",
            fill: "#323232"
        }, 
    ],
    x_light: [
        {
            d: "M16 12.8l-12.8-12.8-3.2 3.2 12.8 12.8-12.8 12.8 3.2 3.2 12.8-12.8 12.8 12.8 3.2-3.2-12.8-12.8 12.8-12.8-3.2-3.2-12.8 12.8z",
            fill: "#fff"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Icon/Icon.tsx



var getPathColor = function(color, index) {
    if (typeof color === "string") {
        return color;
    }
    return color[index] ? color[index] : "inherit";
};
var Icon = function(param) {
    var _size = param.size, size = _size === void 0 ? 32 : _size, color = param.color, name = param.name;
    var icon = icons[name];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        height: size,
        viewBox: "0 0 32 32",
        width: size,
        children: icon && icon.map(function(path, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: path.d,
                fill: color ? getPathColor(color, index) : path.fill
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Icon/index.ts



/***/ }),

/***/ 95111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* reexport */ Input_Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/@next/utils/styles.ts
var styles = __webpack_require__(71454);
;// CONCATENATED MODULE: ./src/images/eye-hide.svg
var eye_hide_namespaceObject = __webpack_require__.p + "static/images/eye-hide.svg";
;// CONCATENATED MODULE: ./src/images/eye-show.svg
var eye_show_namespaceObject = __webpack_require__.p + "static/images/eye-show.svg";
// EXTERNAL MODULE: ./src/@next/components/atoms/InputLabel/index.ts + 2 modules
var InputLabel = __webpack_require__(89524);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Input/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border: 1px solid #cfd7da;\n  color: ",
        ";\n  background-color: ",
        ";\n  outline: none;\n  transition: all 0.3s ease;\n  border-radius: 4px;\n  margin-top: ",
        ";\n  &:hover {\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  & > span {\n    cursor: pointer;\n    position: absolute;\n    top: 15px;\n    right: 15px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.75rem 1.25rem;\n  margin: 0;\n  border: none;\n  width: 100%;\n  font-size: ",
        ";\n  line-height: 1.6em;\n  outline: none;\n  background-color: transparent;\n  color: ",
        ";\n  font-family: ",
        ";\n  &::placeholder {\n    color: rgba(44, 44, 44, 0.3);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var getEdgeColor = function(param) {
    var active = param.active, error = param.error, disabled = param.disabled, theme = param.theme, hovered = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (disabled) {
        return theme.colors.disabled;
    }
    if (error) {
        return theme.colors.error;
    }
    if (hovered) {
        return theme.colors.secondary;
    }
    return active ? theme.colors.secondary : theme.colors.grayDark;
};
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return getEdgeColor(props);
}, function(props) {
    return props.whiteBg ? "#ffffff" : "transparent";
}, function(props) {
    return props.whiteBg ? "0" : "10px";
});
var Content = globalStyles/* styled.span */.zo.span(_templateObject1());
var InputWrapper = globalStyles/* styled.div */.zo.div(_templateObject2());
var Input = globalStyles/* styled.input */.zo.input(_templateObject3(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.typography.extraFontFamily;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Input/Input.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ 











var Input_Input = function(_param) {
    var onBlur = _param.onBlur, onFocus = _param.onFocus, _contentLeft = _param.contentLeft, contentLeft = _contentLeft === void 0 ? null : _contentLeft, _contentRight = _param.contentRight, contentRight = _contentRight === void 0 ? null : _contentRight, _error = _param.error, error = _error === void 0 ? false : _error, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, placeholder = _param.placeholder, label = _param.label, value = _param.value, onChange = _param.onChange, _maxLength = _param.maxLength, maxLength = _maxLength === void 0 ? 50 : _maxLength, type = _param.type, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onBlur",
        "onFocus",
        "contentLeft",
        "contentRight",
        "error",
        "disabled",
        "placeholder",
        "label",
        "value",
        "onChange",
        "maxLength",
        "type"
    ]);
    var elementRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), active = ref[0], setActive = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), securePassword = ref1[0], setSecurePassword = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState("transparent"), 2), labelBackground = ref2[0], setColor = ref2[1];
    react.useEffect(function() {
        if (elementRef) {
            var color = (0,styles/* getBackgroundColor */.d)(elementRef.current);
            setColor(color);
        }
    }, []);
    var handleFocus = react.useCallback(function(e) {
        setActive(true);
        if (onFocus) {
            onFocus(e);
        }
    }, [
        setActive,
        onFocus
    ]);
    var handleBlur = react.useCallback(function(e) {
        setActive(false);
        if (onBlur) {
            onBlur(e);
        }
    }, [
        setActive,
        onBlur
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        active: active,
        error: error,
        disabled: disabled,
        ref: elementRef,
        whiteBg: true,
        children: [
            contentLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: contentLeft
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        type: securePassword ? type : "text",
                        value: value,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        disabled: disabled,
                        onChange: onChange,
                        maxLength: maxLength,
                        placeholder: placeholder && !label ? placeholder : ""
                    })),
                    type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return setSecurePassword(!securePassword);
                        },
                        children: securePassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                            src: eye_hide_namespaceObject
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                            src: eye_show_namespaceObject
                        })
                    }),
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* InputLabel */.A, {
                        labelBackground: labelBackground,
                        active: active || !!value,
                        children: label
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Input/index.ts



/***/ }),

/***/ 89524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ InputLabel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/InputLabel/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: ",
        ";\n  padding: 0 ",
        "rem;\n  background-color: ",
        ";\n  font-size: ",
        ";\n  top: ",
        ";\n  transform: translateY(-50%);\n  font-family: ",
        ";\n  transition: all 0.3s ease, color 0s;\n  color: rgba(44, 44, 44, 0.3);\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Label = globalStyles/* styled.label */.zo.label(_templateObject(), function(props) {
    return props.active ? "0.5rem" : "1rem";
}, function(props) {
    return props.active ? 0.5 : 0;
}, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.active ? props.theme.input.labelFontSize : props.theme.typography.baseFontSize;
}, function(props) {
    return props.active ? 0 : "50%";
}, function(props) {
    return props.theme.typography.extraFontFamily;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/InputLabel/InputLabel.tsx



var InputLabel = function(param) {
    var children = param.children, active = param.active, labelBackground = param.labelBackground, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
        active: active,
        labelBackground: labelBackground,
        className: className,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/InputLabel/index.ts



/***/ }),

/***/ 35582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Loader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/@next/utils/styles.ts
var styles = __webpack_require__(71454);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Loader/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    left: 0;\n  }\n  12.5% {\n    left: 2em;\n  }\n  25% {\n    left: 4em;\n  }\n  37.5% {\n    left: 2em;\n  }\n  50% {\n    left: 0;\n  }\n  100% {\n    left: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    left: 2em;\n  }\n  12.5% {\n    left: 2em;\n  }\n  25% {\n    left: 4em;\n  }\n  37.5% {\n    left: 2em;\n  }\n  62.5% {\n    left: 2em;\n  }\n  75% {\n    left: 0;\n  }\n  87.5% {\n    left: 2em;\n  }\n  100% {\n    left: 2em;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    left: 4em;\n  }\n  50% {\n    left: 4em;\n  }\n  62.5% {\n    left: 2em;\n  }\n  75% {\n    left: 0;\n  }\n  87.5% {\n    left: 2em;\n  }\n  100% {\n    left: 4em;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  align-items: center;\n  width: 100%;\n  height: ",
        ";\n  padding: ",
        " 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 5em;\n  height: 1em;\n  margin: 0 auto;\n\n  span {\n    background-color: ",
        ";\n    width: 1em;\n    height: 1em;\n    border-radius: 1em;\n    position: absolute;\n\n    &:nth-child(1) {\n      left: 0;\n      animation: ",
        " 2s infinite;\n      animation-timing-function: linear;\n    }\n\n    &:nth-child(2) {\n      left: 2em;\n      animation: ",
        " 2s infinite;\n      animation-timing-function: linear;\n    }\n\n    &:nth-child(3) {\n      right: 0;\n      animation: ",
        " 2s infinite;\n      animation-timing-function: linear;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var firstItem = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var secondItem = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var thirdItem = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject3(), function(props) {
    return props.inline ? "inline" : "flex";
}, function(props) {
    return props.fullScreen ? "".concat((0,styles/* getContentWindowHeight */.z)(), "px") : "100%";
}, function(props) {
    return props.theme.spacing.spacer;
});
var Items = globalStyles/* styled.div */.zo.div(_templateObject4(), function(props) {
    return props.theme.button.colors[props.color].background;
}, firstItem, secondItem, thirdItem);

;// CONCATENATED MODULE: ./src/@next/components/atoms/Loader/Loader.tsx



var Loader = function(param) {
    var fullScreen = param.fullScreen, _primary = param.primary, primary = _primary === void 0 ? false : _primary, _inline = param.inline, inline = _inline === void 0 ? false : _inline;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        fullScreen: !!fullScreen,
        inline: inline,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Items, {
            color: primary ? "primary" : "secondary",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Loader/index.ts



/***/ }),

/***/ 92058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ Message; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/components/atoms/Icon/index.ts + 2 modules
var Icon = __webpack_require__(31484);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Message/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: min(100%, ",
        ");\n  padding: ",
        ";\n  background-color: ",
        ";\n  box-shadow: 0px 6px 15px 3px rgba(0, 0, 0, 0.25);\n  position: fixed;\n  bottom: ",
        ";\n  right: ",
        ";\n  border-left: 0.4rem solid;\n  border-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: ",
        ";\n  font-weight: ",
        ";\n  letter-spacing: ",
        ";\n  margin: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n\n  path {\n    transition: 0.3s;\n  }\n\n  &:hover {\n    path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  cursor: pointer;\n  font-size: ",
        ";\n  text-decoration: underline;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var borderColors = function(theme) {
    return {
        action: theme.colors.error,
        error: theme.colors.error,
        neutral: theme.colors.primaryDark,
        success: theme.colors.success
    };
};
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.message.width;
}, function(props) {
    return props.theme.message.padding;
}, function(props) {
    return props.theme.message.backgroundColor;
}, function(props) {
    return props.theme.spacing.spacer;
}, function(props) {
    return props.theme.spacing.spacer;
}, function(props) {
    return borderColors(props.theme)[props.status];
});
var TopWrapper = globalStyles/* styled.div */.zo.div(_templateObject1());
var Title = globalStyles/* styled.p */.zo.p(_templateObject2(), function(props) {
    return props.theme.message.titleTransform;
}, function(props) {
    return props.theme.message.titleWeight;
}, function(props) {
    return props.theme.message.letterSpacing;
}, function(props) {
    return props.theme.message.titleMargin;
});
var CloseButton = globalStyles/* styled.button */.zo.button(_templateObject3(), function(props) {
    return props.theme.colors.primary;
});
var Content = globalStyles/* styled.div */.zo.div(_templateObject4(), function(props) {
    return props.theme.message.contentMargin;
});
var ActionButton = globalStyles/* styled.button */.zo.button(_templateObject5(), function(props) {
    return props.theme.colors.secondary;
}, function(props) {
    return props.theme.typography.baseFontSize;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Message/Message.tsx




var Message = function(param) {
    var title = param.title, _status = param.status, status = _status === void 0 ? "neutral" : _status, children = param.children, onClick = param.onClick, actionText = param.actionText;
    var isAction = !!actionText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        status: status,
        "data-cy": "alert",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    isAction ? !children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton, {
                        onClick: onClick,
                        children: actionText
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                        onClick: onClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            name: "x",
                            size: 15
                        })
                    })
                ]
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: children
            }),
            children && isAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton, {
                onClick: onClick,
                style: {
                    marginTop: "1rem"
                },
                children: actionText
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Message/index.ts



/***/ }),

/***/ 82229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ ErrorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/components/containers/ErrorBoundary/ErrorBoundary.tsx
/* eslint-disable react/destructuring-assignment */ 




var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary() {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch() {
    // log the error to an error reporting service
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Something went wrong :-/"
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: this.props.children
        });
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);

;// CONCATENATED MODULE: ./src/@next/components/containers/ErrorBoundary/index.ts



/***/ }),

/***/ 61351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Money; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/@next/components/containers/Money/Money.tsx






var Money = function(_param) {
    var money = _param.money, defaultValue = _param.defaultValue, props = (0,_object_without_properties/* default */.Z)(_param, [
        "money",
        "defaultValue"
    ]);
    var locale = (0,router.useRouter)().locale;
    if (!money) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: defaultValue
        }));
    }
    if (money.currency && money.currency !== "") {
        var str = money.amount.toLocaleString(locale, {
            currency: money.currency,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            style: "currency"
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: str
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: money.amount.toString()
    }));
};
Money.displayName = "Money";
/* harmony default export */ var Money_Money = ((/* unused pure expression or super */ null && (Money)));

;// CONCATENATED MODULE: ./src/@next/components/containers/Money/index.ts



/***/ }),

/***/ 1366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iw": function() { return /* binding */ ShopContext; },
/* harmony export */   "Of": function() { return /* binding */ defaultContext; }
/* harmony export */ });
/* unused harmony export defaultCountry */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var defaultCountry = {
    __typename: "CountryDisplay",
    code: "US",
    country: "United States of America"
};
var defaultContext = {
    __typename: "Shop",
    countries: [],
    defaultCountry: defaultCountry,
    description: "",
    displayGrossPrices: true,
    geolocalization: {
        __typename: "Geolocalization",
        country: defaultCountry
    },
    availablePaymentGateways: [],
    name: ""
};
var ShopContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultContext);
ShopContext.displayName = "ShopContext";


/***/ }),

/***/ 31740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ TaxedMoney; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/components/containers/Money/index.ts + 1 modules
var Money = __webpack_require__(61351);
// EXTERNAL MODULE: ./src/@next/components/containers/ShopProvider/context.ts
var context = __webpack_require__(1366);
;// CONCATENATED MODULE: ./src/@next/components/containers/TaxedMoney/TaxedMoney.tsx







var TaxedMoney = function(_param) {
    var taxedMoney = _param.taxedMoney, defaultValue = _param.defaultValue, props = (0,_object_without_properties/* default */.Z)(_param, [
        "taxedMoney",
        "defaultValue"
    ]);
    var displayGrossPrices = react.useContext(context/* ShopContext */.Iw).displayGrossPrices;
    var money = taxedMoney ? displayGrossPrices ? taxedMoney.gross : taxedMoney.net : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Money/* Money */.W, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        money: money,
        defaultValue: defaultValue
    }));
};
TaxedMoney.displayName = "TaxedMoney";
/* harmony default export */ var TaxedMoney_TaxedMoney = ((/* unused pure expression or super */ null && (TaxedMoney)));

;// CONCATENATED MODULE: ./src/@next/components/containers/TaxedMoney/index.ts



/***/ }),

/***/ 37786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ CardHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98547);
/* harmony import */ var images_x_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63232);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71013);





var CardHeader = function(param) {
    var children = param.children, customIcon = param.customIcon, _divider = param.divider, divider = _divider === void 0 ? false : _divider, formImage = param.formImage, onHide = param.onHide, _textStyle = param.textStyle, textStyle = _textStyle === void 0 ? "title" : _textStyle, _titleSize = param.titleSize, titleSize = _titleSize === void 0 ? "lg" : _titleSize;
    var withCloseIcon = !!onHide && !customIcon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Header */ .h4, {
        divider: divider,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .CloseImg */ .Fl, {
                children: [
                    withCloseIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_svg__WEBPACK_IMPORTED_MODULE_2__/* .ReactSVG */ .Q, {
                        src: images_x_svg__WEBPACK_IMPORTED_MODULE_3__,
                        onClick: onHide
                    }),
                    customIcon
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .HeadImg */ .mW, {
                children: formImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_svg__WEBPACK_IMPORTED_MODULE_2__/* .ReactSVG */ .Q, {
                    src: formImage
                })
            }),
            textStyle === "title" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
                size: titleSize,
                children: children
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Paragraph */ .nv, {
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 27080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* reexport safe */ _CardHeader__WEBPACK_IMPORTED_MODULE_0__.O; }
/* harmony export */ });
/* harmony import */ var _CardHeader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37786);



/***/ }),

/***/ 71013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Fl": function() { return /* binding */ CloseImg; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "mW": function() { return /* binding */ HeadImg; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23042);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n   // display: none;\n   margin: auto;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 1rem auto 2rem auto;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  margin: 0;\n  width: 70%;\n  text-align: center;\n  line-height: 1em;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  padding-right: 0.6rem;\n  margin: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Header = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject(), function(props) {
    return "1.1rem ".concat(props.theme.spacing.gutter);
});
var CloseImg = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject1());
var HeadImg = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject3(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.xSmallScreen */ .BC.xSmallScreen(_templateObject2()));
var Title = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.h4 */ .zo.h4(_templateObject5(), function(param) {
    var size = param.size, typography = param.theme.typography;
    return size === "lg" ? typography.h3FontSize : typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.xSmallScreen */ .BC.xSmallScreen(_templateObject4(), function(param) {
    var size = param.size, typography = param.theme.typography;
    return size === "lg" ? "20px" : typography.baseFontSize;
}));
var Paragraph = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .zo.p(_templateObject6(), function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.lightFont;
});


/***/ }),

/***/ 78160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ProductListItemAttributes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90512);
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11700);
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86896);
/* harmony import */ var _intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72110);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86810);







var ProductListItemAttributes = function(param) {
    var _alwaysShowAll = param.alwaysShowAll, alwaysShowAll = _alwaysShowAll === void 0 ? false : _alwaysShowAll, _withBlockDisplayedAttributes = param.withBlockDisplayedAttributes, withBlockDisplayedAttributes = _withBlockDisplayedAttributes === void 0 ? false : _withBlockDisplayedAttributes, attributes = param.attributes;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showAllAttr = ref[0], showAllAttrHandler = ref[1];
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .DetailsVariantWrapper */ .fI, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* .clsx */ .W)({
            attr: withBlockDisplayedAttributes,
            show: showAllAttr || alwaysShowAll
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .DetailsVariant */ .OL, {
                children: attributes.map(function(item, itemI) {
                    var attributeName = lodash_upperFirst__WEBPACK_IMPORTED_MODULE_1___default()(item.translatedName || item.name).replace("-", " ");
                    var attributeValue = item.values.map(function(value) {
                        return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_1___default()((value.translatedName || value.name).replace(attributeName.toLowerCase(), "").replace("-", " ").trim());
                    }).join(", ");
                    if (attributeName === "Height" || attributeName === "Width") {
                        attributeValue = "".concat(attributeValue.slice(0, attributeValue.length - 1), " cm");
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .DetailsVariantItem */ .RM, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .ItemHint */ .h5, {
                                children: [
                                    attributeName,
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: attributeValue
                            }),
                            " "
                        ]
                    }, itemI);
                })
            }),
            !alwaysShowAll && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .DetailsVariantMoreButton */ .Z4, {
                onClick: function(e) {
                    e.stopPropagation();
                    showAllAttrHandler(!showAllAttr);
                },
                type: "button",
                children: showAllAttr ? intl.formatMessage(_intl__WEBPACK_IMPORTED_MODULE_3__/* .commonMessages.less */ .i4.less) : intl.formatMessage(_intl__WEBPACK_IMPORTED_MODULE_3__/* .commonMessages.more */ .i4.more)
            })
        ]
    });
};


/***/ }),

/***/ 55831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ CartProductList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/components/containers/ErrorBoundary/index.ts + 1 modules
var ErrorBoundary = __webpack_require__(82229);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/@next/utils/translations.ts
var translations = __webpack_require__(69665);
// EXTERNAL MODULE: ./src/@next/components/containers/TaxedMoney/index.ts + 1 modules
var TaxedMoney = __webpack_require__(31740);
// EXTERNAL MODULE: ./src/@next/components/atoms/Loader/index.ts + 2 modules
var Loader = __webpack_require__(35582);
// EXTERNAL MODULE: ./src/@next/components/molecules/EstimatedShipping/index.ts + 1 modules
var EstimatedShipping = __webpack_require__(99793);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./src/views/Product/utils/index.ts + 7 modules
var utils = __webpack_require__(18222);
// EXTERNAL MODULE: ./src/views/Product/types.ts
var types = __webpack_require__(43065);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@next/utils/regions.ts + 1 modules
var regions = __webpack_require__(8044);
;// CONCATENATED MODULE: ./src/images/edit.svg
var edit_namespaceObject = __webpack_require__.p + "static/images/edit.svg";
// EXTERNAL MODULE: ./src/images/garbage.svg
var garbage = __webpack_require__(80345);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./src/@next/components/molecules/CartProductList/ProductListItemAttributes.tsx
var ProductListItemAttributes = __webpack_require__(78160);
// EXTERNAL MODULE: ./src/@sdk/providers/CheckoutProvider.tsx
var CheckoutProvider = __webpack_require__(45327);
// EXTERNAL MODULE: ./src/@next/components/molecules/QuantityInput/index.tsx + 4 modules
var QuantityInput = __webpack_require__(39117);
// EXTERNAL MODULE: ./src/@next/components/molecules/CartProductList/styles.ts
var styles = __webpack_require__(86810);
;// CONCATENATED MODULE: ./src/@next/components/molecules/CartProductList/ProductListItemQuantity.tsx





var ProductListItemQuantity = function(param) {
    var line = param.line;
    var updateItem = (0,CheckoutProvider/* useCheckout */.Mg)().updateItem;
    var quantityChange = (0,react.useCallback)(function(val) {
        updateItem(line.variant.id, Number(val), line.productAttributes);
    }, [
        updateItem,
        line
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Quantity */.h0, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityInput/* QuantityInput */.F, {
            quantity: line.quantity,
            maxQuantity: line.variant.quantityAvailable,
            disabled: false,
            onQuantityChange: quantityChange,
            hideErrors: !line.variant.id
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/CartProductList/ProductListItem.tsx






















var ProductListItem = function(param) {
    var line = param.line, remove = param.remove, _readonly = param.readonly, readonly = _readonly === void 0 ? false : _readonly;
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var product = line.variant.product;
    var isConfiguratorType = types/* CONFIGURATOR_PRODUCT_TYPES.includes */.d.includes(product.productType.slug);
    var ref = (0,generatedHooks/* useCartProductEstimatedShippingQuery */.Co)({
        variables: (0,_object_spread/* default */.Z)({
            id: line.variant.product.id
        }, (0,regions/* localeToSaleorQuery */.KK)(locale))
    }), data = ref.data, loading = ref.loading;
    var productAttributesWithData = line.productAttributes.map(function(item) {
        var ref;
        var valuesData = item.attribute.values.filter(function(value) {
            return item.values.includes(value.name);
        });
        return {
            id: item.attribute.id,
            name: item.attribute.name,
            slug: item.attribute.slug,
            translatedName: (ref = item.attribute.translation) === null || ref === void 0 ? void 0 : ref.name,
            values: valuesData === null || valuesData === void 0 ? void 0 : valuesData.map(function(value) {
                var ref;
                return {
                    name: value.name,
                    slug: value.slug,
                    translatedName: (ref = value.translation) === null || ref === void 0 ? void 0 : ref.name
                };
            })
        };
    }) || [];
    var variantAttributesWithData = line.variant.attributes.map(function(item) {
        var ref;
        return {
            id: item.attribute.id,
            name: item.attribute.name,
            slug: item.attribute.slug,
            translatedName: (ref = item.attribute.translation) === null || ref === void 0 ? void 0 : ref.name,
            values: item.values.map(function(value) {
                var ref;
                return {
                    name: value.name,
                    slug: value.slug,
                    translatedName: (ref = value.translation) === null || ref === void 0 ? void 0 : ref.name
                };
            })
        };
    }) || [];
    var allAttributes = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(productAttributesWithData).concat((0,_to_consumable_array/* default */.Z)(variantAttributesWithData));
    }, [
        productAttributesWithData,
        variantAttributesWithData
    ]);
    var editUrl = (0,react.useMemo)(function() {
        var attributes = allAttributes.reduce(function(acc, cur) {
            var value = cur.values && cur.values[0];
            acc[cur.slug] = value === null || value === void 0 ? void 0 : value.slug;
            return acc;
        }, {});
        return (0,utils/* generateProductUrlWithAttributes */.pT)(line.variant.product, attributes);
    }, [
        allAttributes,
        line.variant.product
    ]);
    var imageUrl = (0,react.useMemo)(function() {
        var attributes = allAttributes.reduce(function(acc, cur) {
            var value = cur.values && cur.values[0];
            acc[cur.slug] = value === null || value === void 0 ? void 0 : value.slug;
            return acc;
        }, {});
        return (0,utils/* generateProductImageWithAttributes */.mv)(line.variant.product, attributes);
    }, [
        allAttributes,
        line.variant.product
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {});
    }
    if (!data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "no data"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Item */.ck, {
        className: "cart__list__item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: editUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "cart__list__item-img",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: imageUrl,
                        alt: "product thumbnail",
                        width: "200",
                        loading: "lazy"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Details */.PO, {
                className: "cart__list__item__details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: editUrl,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ProductName */.rZ, {
                            className: "cart__list__item-name",
                            children: isConfiguratorType ? product.productType.name : (0,translations/* translate */.I)(product, "name")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemAttributes/* ProductListItemAttributes */._, {
                        attributes: allAttributes,
                        alwaysShowAll: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ProductQuantity */.K5, {
                        className: "cart__list__item-bottom",
                        children: [
                            !readonly && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemQuantity, {
                                line: line
                            }),
                            readonly && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* QuantityText */.Ds, {
                                className: "cart__list__item-shipping",
                                children: "".concat(intl.formatMessage(src_intl/* commonMessages.quantity */.i4.quantity), ": ").concat(line.quantity)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Summary */.ER, {
                children: [
                    !readonly && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Action */.aU, {
                        className: "cart__list__item-actions",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: editUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "cart__list__item-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: edit_namespaceObject,
                                        alt: "edit"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                src: garbage,
                                className: "cart__list__item-icon",
                                onClick: function() {
                                    return remove(line);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ProductPrice */.jF, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                            taxedMoney: line.totalPrice
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* EstimatedShipping */.$l, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EstimatedShipping/* EstimatedShipping */.$, {
                            productType: data.product.productType,
                            type: "short",
                            exact: true
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/CartProductList/CartProductList.tsx





var CartProductList = function(param) {
    var lines = param.lines, remove = param.remove, readonly = param.readonly;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* List */.aV, {
        children: lines.map(function(line) {
            var key = "".concat(line.variant.id).concat(line.productAttributes.map(function(attr) {
                return attr.attribute.id;
            }).join());
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* ErrorBoundary */.S, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItem, {
                    line: line,
                    remove: remove,
                    readonly: readonly
                })
            }, key);
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/CartProductList/index.ts



/***/ }),

/***/ 86810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ EstimatedShipping; },
/* harmony export */   "Ds": function() { return /* binding */ QuantityText; },
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "K5": function() { return /* binding */ ProductQuantity; },
/* harmony export */   "OL": function() { return /* binding */ DetailsVariant; },
/* harmony export */   "PO": function() { return /* binding */ Details; },
/* harmony export */   "RM": function() { return /* binding */ DetailsVariantItem; },
/* harmony export */   "Z4": function() { return /* binding */ DetailsVariantMoreButton; },
/* harmony export */   "aU": function() { return /* binding */ Action; },
/* harmony export */   "aV": function() { return /* binding */ List; },
/* harmony export */   "ck": function() { return /* binding */ Item; },
/* harmony export */   "fI": function() { return /* binding */ DetailsVariantWrapper; },
/* harmony export */   "h0": function() { return /* binding */ Quantity; },
/* harmony export */   "h5": function() { return /* binding */ ItemHint; },
/* harmony export */   "jF": function() { return /* binding */ ProductPrice; },
/* harmony export */   "rZ": function() { return /* binding */ ProductName; }
/* harmony export */ });
/* unused harmony exports ItemImage, ItemCategory, QuantityButton, QuantityInput, QuantityError */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23042);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100px;\n    height: 100px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 64px;\n    height: 64px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  flex-shrink: 0;\n  width: 148px;\n  height: 148px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  border-radius: 6px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-bottom: 6px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-bottom: 0;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: 8px;\n  line-height: 1em;\n  text-transform: uppercase;\n  display: inline-block;\n  ",
        "\n  ",
        "\n  * {\n    font: inherit;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6em;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6em;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 24px;\n      height: 24px;\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        transform: scale(0.6);\n      "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  opacity: 1;\n  transition: opacity 0.3s;\n  .cart__list__item-icon {\n    margin-left: 6px;\n    background-color: rgba(#ecedee, 0.6);\n    cursor: pointer;\n    transition: background-color 0.2s;\n    display: block;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ",
        "\n    svg,\n    img {\n      display: block;\n      ",
        "\n    }\n    path {\n      fill: #c4c4c5;\n    }\n    &:hover {\n      background-color: #ecedee;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 20px 0;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 30px 0;\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  align-content: stretch;\n  position: relative;\n  ",
        "\n  img {\n    max-width: 90%;\n    max-height: 90%;\n    // width: auto;\n    height: auto;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  input[type='number']::-webkit-inner-spin-button,\n  input[type='number']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25em;\n  opacity: 0.3;\n  transition: opacity 0.6s;\n  display: inline-block;\n  padding: 3px;\n  &:hover {\n    opacity: 0.6;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25em;\n  height: 1.25em;\n  padding: 0;\n  width: 50px;\n  text-align: center;\n  border: none;\n  background: transparent;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-top: 0;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 70%;\n  padding: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: uppercase;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6em;\n  color: ",
        ";\n  text-align: right;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6em;\n  text-align: right;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 150px;\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 90px;\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  width: 220px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.6em;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:not(:last-child) {\n    margin-right: 5px;\n    &:after {\n      content: '|';\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  &.show {\n    display: block;\n    ",
        " {\n      white-space: initial;\n      width: 100%;\n    }\n  }\n\n  &.attr.show {\n    ",
        " {\n      margin-bottom: 3px;\n      display: block;\n      text-align: left;\n    }\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 3px;\n  display: block;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  text-decoration: underline;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}

var List = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.ul */ .zo.ul(_templateObject());
var ItemImage = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject3(), function(param) {
    var colors = param.theme.colors;
    return colors.light;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject1()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject2()));
var ProductName = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.a */ .zo.a(_templateObject6(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h5FontSize;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject4()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject5()));
var ItemCategory = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .zo.p(_templateObject7(), function(param) {
    var colors = param.theme.colors;
    return colors.blueLight;
}, function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
});
var ItemHint = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .zo.span(_templateObject8(), function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
});
var ProductQuantity = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject9());
var QuantityText = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject10(), function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
});
var Action = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject13(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject11()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject12()));
var Item = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.li */ .zo.li(_templateObject15(), function(param) {
    var colors = param.theme.colors;
    return colors.light;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject14()));
var Quantity = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject16());
var QuantityButton = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.button */ .zo.button(_templateObject17(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
});
var QuantityInput = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.input */ .zo.input(_templateObject18(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
});
var QuantityError = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject19(), function(param) {
    var typography = param.theme.typography;
    return typography.labelFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.red;
});
var Details = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject21(), function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " 0 0 ").concat(spacing.spacer);
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject20()));
var Summary = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject22());
var ProductPrice = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .zo.p(_templateObject23(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.red;
});
var EstimatedShipping = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject24(), function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
});
var DetailsVariant = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject27(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.blueLight;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject25()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject26()));
var DetailsVariantItem = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .zo.span(_templateObject28(), function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
});
var DetailsVariantWrapper = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject29(), DetailsVariant, DetailsVariantItem);
var DetailsVariantMoreButton = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.button */ .zo.button(_templateObject30(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
});


/***/ }),

/***/ 50594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ CartPromoCode; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@next/hooks/usePrevious.ts
var usePrevious = __webpack_require__(87134);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/components/atoms/Icon/index.ts + 2 modules
var Icon = __webpack_require__(31484);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Chip/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  border: none;\n  transition: 0.3s;\n  outline: none;\n  border-radius: 2rem;\n  color: ",
        ";\n  width: ",
        "\n  display: inline-block;\n  cursor: default;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: inset 0px 0px 0px 3px\n    ",
        ";\n  border-left: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  margin-right: ",
        ";\n  vertical-align: middle;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  vertical-align: middle;\n  cursor: pointer;\n  border-radius: 1rem;\n\n  > svg > path {\n    fill: ",
        ";\n  }\n\n  &:hover {\n    background-color: ",
        ";\n    > svg > path {\n      fill: ",
        ";\n    }\n  }\n\n  &:active {\n    background-color: ",
        ";\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n\n    &,\n    &:hover {\n      cursor: default;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var padding = {
    md: "0.4rem 0.4rem 0.4rem 0.8rem",
    sm: "0.1rem"
};
var paddingCloseButton = {
    md: "0.4rem 0.4rem 0.3rem 0.4rem",
    sm: "0.1rem"
};
var fontSize = function(fontSize, smallFontSize) {
    return {
        md: fontSize,
        sm: smallFontSize
    };
};
var Primary = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.chip.colors[props.color].background;
}, function(props) {
    return padding[props.size];
}, function(props) {
    return props.theme.chip.colors[props.color].color;
}, function(props) {
    return props.fullWidth ? "100%" : "auto";
});
var Secondary = (0,globalStyles/* styled */.zo)(Primary)(_templateObject1(), function(props) {
    return props.theme.chip.colors.secondary.color;
}, function(props) {
    return props.theme.chip.colors.secondary.color;
}, function(props) {
    return props.theme.chip.colors.secondary.color;
});
var Text = globalStyles/* styled.span */.zo.span(_templateObject2(), function(param) {
    var size = param.size, _theme = param.theme, typography = _theme.chip.typography;
    return fontSize(typography.fontSize, typography.smallFontSize)[size];
}, function(props) {
    return props.theme.typography.boldFontWeight;
}, function(props) {
    return props.theme.typography.baseLineHeight;
}, function(props) {
    return paddingCloseButton[props.size];
});
var CloseButton = globalStyles/* styled.button */.zo.button(_templateObject3(), function(props) {
    return paddingCloseButton[props.size];
}, function(props) {
    return props.theme.chip.colors[props.color].color;
}, function(props) {
    return props.theme.chip.colors[props.color].hoverBackground;
}, function(props) {
    return props.theme.chip.colors[props.color].hoverColor;
}, function(props) {
    return props.theme.chip.colors[props.color].activeBackground;
}, function(props) {
    return props.theme.colors.disabled;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Chip/Chip.tsx







var Chip = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "primary" : _color, closeBtnRef = _param.closeBtnRef, children = _param.children, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _size = _param.size, size = _size === void 0 ? "md" : _size, _onClose = _param.onClose, onClose = _onClose === void 0 ? function() {
        return null;
    } : _onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "closeBtnRef",
        "children",
        "fullWidth",
        "size",
        "onClose"
    ]);
    var ChipWithTheme = color === "primary" ? Primary : Secondary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChipWithTheme, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: color,
        fullWidth: fullWidth,
        size: size
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                size: size,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                size: size,
                color: color,
                ref: closeBtnRef,
                onClick: onClose,
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    name: "x_light",
                    size: 16
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Chip/index.ts


// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./src/@next/components/atoms/Input/index.ts + 4 modules
var Input = __webpack_require__(95111);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./src/images/spinner.svg
var spinner_namespaceObject = __webpack_require__.p + "static/images/spinner.svg";
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
;// CONCATENATED MODULE: ./src/@next/components/organisms/DiscountForm/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 0.75rem;\n    "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  input {\n    padding: 1rem;\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  min-width: 110px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 140px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 167px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 107px;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.8rem 1rem;\n  height: 100%;\n  width: 196px;\n  background-color: ",
        ";\n  pointer-events: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n\n  > span {\n    display: flex;\n    align-items: center;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    font-weight: 500;\n    line-height: 100%;\n    color: #4f6e7c;\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  div {\n    padding: 0;\n    background-color: transparent;\n    color: ",
        ";\n\n    > span {\n      padding-bottom: 2px;\n      font-family: ",
        ";\n      font-size: ",
        ";\n      font-weight: 500;\n      line-height: 100%;\n      color: #4f6e7c;\n    }\n\n    button {\n      opacity: 0.2;\n      svg {\n        path {\n          fill: #2c2c2c;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  width: 100%;\n  max-width: 30px;\n  height: auto;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var DiscountForm = globalStyles/* styled.form */.zo.form(styles_templateObject(), function(props) {
    return props.theme.spacing.spacer;
});
var styles_Input = globalStyles/* styled.div */.zo.div(styles_templateObject1(), function(props) {
    return props.theme.spacing.spacer;
});
var InputWithButton = globalStyles/* styled.div */.zo.div(styles_templateObject2());
var InputWrapper = globalStyles/* styled.div */.zo.div(_templateObject4(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject3()));
var ButtonWrapper = globalStyles/* styled.div */.zo.div(_templateObject5());
var StyledButton = (0,globalStyles/* styled */.zo)(Button/* Button */.z)(_templateObject9(), function(props) {
    return props.active ? props.theme.colors.red : "#DADEE0";
}, function(props) {
    return props.active ? "all" : "none";
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject6()), globalStyles/* media.smMediumScreen */.BC.smMediumScreen(_templateObject7()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject8()));
var PromoCodeValue = globalStyles/* styled.div */.zo.div(_templateObject10(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
});
var ChipsWrapper = globalStyles/* styled.div */.zo.div(_templateObject11(), function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
});
var Spinner = globalStyles/* styled.img */.zo.img(_templateObject12(), function(props) {
    return props.cHidden ? "block" : "none";
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/DiscountForm/DiscountForm.tsx












var DiscountForm_DiscountForm = function(param) {
    var handleSubmitDiscount = param.handleSubmit, discount = param.discount, errors = param.errors, formId = param.formId, formRef = param.formRef, promoCodePending = param.promoCodePending, onClose = param.onClose;
    var intl = (0,useIntl/* default */.Z)();
    var promoCode = discount === null || discount === void 0 ? void 0 : discount.promoCode;
    var ref = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            formikPromoCode: ""
        }
    }), control = ref.control, handleSubmit = ref.handleSubmit, resetForm = ref.reset, watch = ref.watch;
    var handleOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (handleSubmitDiscount) {
                    handleSubmitDiscount({
                        promoCode: values.formikPromoCode
                    });
                    resetForm();
                }
                return [
                    2
                ];
            });
        });
        return function handleOnSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var hasErrors = !!(errors && errors.length);
    var formikPromoCode = watch("formikPromoCode");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountForm, {
        id: formId,
        ref: formRef,
        onSubmit: handleSubmit(handleOnSubmit),
        children: [
            !promoCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Input, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWithButton, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    name: "formikPromoCode",
                                    control: control,
                                    render: function(param) {
                                        var field = param.field;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, (0,_object_spread/* default */.Z)({
                                            "data-cy": "checkoutPaymentPromoCodeInput",
                                            error: hasErrors,
                                            label: intl.formatMessage({
                                                defaultMessage: "Enter promo code",
                                                id: "86RjOu"
                                            })
                                        }, field));
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
                                    type: "submit",
                                    "data-cy": "checkoutPaymentPromoCodeBtn",
                                    active: (formikPromoCode === null || formikPromoCode === void 0 ? void 0 : formikPromoCode.length) > 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
                                            src: spinner_namespaceObject,
                                            cHidden: promoCodePending,
                                            alt: ""
                                        }),
                                        !promoCodePending ? intl.formatMessage({
                                            defaultMessage: "Apply",
                                            id: "EWw/tK"
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                        errors: errors
                    })
                ]
            }),
            promoCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PromoCodeValue, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: intl.formatMessage({
                            defaultMessage: "Promo code:",
                            id: "KWRMF1"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipsWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                            onClose: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "data-cy": "checkoutPaymentPromoCodeChip",
                                children: promoCode
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/DiscountForm/index.ts


// EXTERNAL MODULE: ./src/@sdk/providers/CheckoutProvider.tsx
var CheckoutProvider = __webpack_require__(45327);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@next/utils/regions.ts + 1 modules
var regions = __webpack_require__(8044);
;// CONCATENATED MODULE: ./src/@next/components/molecules/CartPromoCode/styles.ts

function CartPromoCode_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 12px 0 12px;\n"
    ]);
    CartPromoCode_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartPromoCode_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6em;\n  text-decoration: underline;\n  transition: color 0.4s;\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    CartPromoCode_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var FooterLink = globalStyles/* styled.div */.zo.div(CartPromoCode_styles_templateObject());
var FooterLinkItem = globalStyles/* styled.a */.zo.a(CartPromoCode_styles_templateObject1(), function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.red;
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/CartPromoCode/CartPromoCode.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 













var CartPromoCode = function(param) {
    var setLoading = param.setLoading, loading = param.loading;
    var ref;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var locale = (ref = router.query.locale) === null || ref === void 0 ? void 0 : ref.toString();
    var checkout = (0,CheckoutProvider/* useCheckout */.Mg)().checkout;
    var ref1 = checkout || {}, subtotalPrice = ref1.subtotalPrice, voucherCode = ref1.voucherCode;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useAddCheckoutPromoCodeMutation */.oi)(), 2), addCheckoutPromoCodeMutation = ref2[0], ref3 = ref2[1], dataAdd = ref3.data, errorAdd = ref3.error;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useRemoveCheckoutPromoCodeMutation */.z0)(), 1), removeCheckoutPromoCodeMutation = ref4[0];
    var ref5 = (0,react.useState)(!!voucherCode), active = ref5[0], setActive = ref5[1];
    var ref6 = (0,react.useState)([]), promoCodeErrors = ref6[0], setPromoCodeErrors = ref6[1];
    var previousAddedVoucherCode = (0,usePrevious/* usePrevious */.D)(voucherCode);
    (0,react.useEffect)(function() {
        if (!previousAddedVoucherCode && voucherCode) {
            setActive(true);
        }
    }, [
        voucherCode,
        previousAddedVoucherCode
    ]);
    var addCheckoutPromoCode = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(promoCode) {
            var ref, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            addCheckoutPromoCodeMutation({
                                variables: (0,_object_spread/* default */.Z)({
                                    checkoutId: checkout === null || checkout === void 0 ? void 0 : checkout.id,
                                    promoCode: promoCode
                                }, (0,regions/* localeToSaleorQuery */.KK)(locale))
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (errorAdd === null || errorAdd === void 0 ? void 0 : (ref = errorAdd.graphQLErrors) === null || ref === void 0 ? void 0 : ref.length) {
                            setPromoCodeErrors(errorAdd === null || errorAdd === void 0 ? void 0 : errorAdd.graphQLErrors);
                        } else if (dataAdd === null || dataAdd === void 0 ? void 0 : (ref1 = dataAdd.checkoutAddPromoCode) === null || ref1 === void 0 ? void 0 : ref1.errors.length) {
                            ;
                            setPromoCodeErrors(dataAdd === null || dataAdd === void 0 ? void 0 : (ref2 = dataAdd.checkoutAddPromoCode) === null || ref2 === void 0 ? void 0 : ref2.errors);
                        } else {
                            setPromoCodeErrors([]);
                        }
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(promoCode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addCheckoutPromoCodeMutation,
        setLoading
    ]);
    var prevSubTotalPriceAmount = (0,usePrevious/* usePrevious */.D)(subtotalPrice === null || subtotalPrice === void 0 ? void 0 : subtotalPrice.gross.amount);
    var subtotalChanged = prevSubTotalPriceAmount !== (subtotalPrice === null || subtotalPrice === void 0 ? void 0 : subtotalPrice.gross.amount);
    (0,react.useEffect)(function() {
        // update promo code on cart items change
        if (subtotalChanged && voucherCode) {
            addCheckoutPromoCode(voucherCode);
        }
    }, [
        voucherCode,
        addCheckoutPromoCode,
        subtotalChanged
    ]);
    var handleAddPromoCode = (0,react.useCallback)(function(param) {
        var promoCode = param.promoCode;
        addCheckoutPromoCode(promoCode);
    }, [
        addCheckoutPromoCode
    ]);
    var handleRemovePromoCode = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    return [
                        4,
                        removeCheckoutPromoCodeMutation({
                            variables: (0,_object_spread/* default */.Z)({
                                checkoutId: checkout === null || checkout === void 0 ? void 0 : checkout.id,
                                promoCode: voucherCode
                            }, (0,regions/* localeToSaleorQuery */.KK)(locale))
                        })
                    ];
                case 1:
                    _state.sent();
                    setLoading(false);
                    setActive(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        voucherCode,
        removeCheckoutPromoCodeMutation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterLink, {
        children: [
            !active && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinkItem, {
                href: "",
                onClick: function(e) {
                    e.preventDefault();
                    setActive(function(s) {
                        return !s;
                    });
                },
                children: intl.formatMessage({
                    defaultMessage: "+ Add promo code",
                    id: "y/OnEQ"
                })
            }),
            active && /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountForm_DiscountForm, {
                promoCodePending: loading,
                errors: promoCodeErrors,
                onClose: handleRemovePromoCode,
                discount: {
                    promoCode: voucherCode
                },
                handleSubmit: handleAddPromoCode
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/CartPromoCode/index.ts



/***/ }),

/***/ 99793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ EstimatedShipping; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedTypes.tsx
var generatedTypes = __webpack_require__(52046);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
;// CONCATENATED MODULE: ./src/@next/components/molecules/EstimatedShipping/EstimatedShipping.tsx





var _obj;
var formatRelativeTimeUnits = (_obj = {}, (0,_define_property/* default */.Z)(_obj, generatedTypes/* ShippingDateTypeEnum.DAYS */.HI.DAYS, "days"), (0,_define_property/* default */.Z)(_obj, generatedTypes/* ShippingDateTypeEnum.WEEKS */.HI.WEEKS, "weeks"), _obj);
function EstimatedShipping(param) {
    var productType = param.productType, type = param.type, exact = param.exact;
    var intl = (0,useIntl/* default */.Z)();
    var shippingMax = productType.shippingMax, shippingMin = productType.shippingMin, shippingDateType = productType.shippingDateType, estimatedShipping = productType.estimatedShipping;
    var estimatedShippingDaysLeft = Math.ceil((Date.now() - Date.parse(estimatedShipping)) / (1000 * 60 * 60 * 24));
    var unit = formatRelativeTimeUnits[shippingDateType || generatedTypes/* ShippingDateTypeEnum.DAYS */.HI.DAYS];
    var translatedUnit = intl.formatMessage(src_intl/* commonMessages */.i4[unit]);
    var messages = {
        long: intl.formatMessage({
            defaultMessage: "Estimated shipping time",
            id: "RM/X/f"
        }),
        short: intl.formatMessage({
            defaultMessage: "Est. ship",
            id: "6hz7sj"
        })
    };
    var message = messages[type];
    if (exact && estimatedShipping) {
        /* tslint:disable:object-literal-sort-keys */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "".concat(message, " ").concat(intl.formatDate(estimatedShipping, {
                month: "short",
                day: "numeric"
            }))
        });
    /* tslint:enable:object-literal-sort-keys */ }
    if (shippingMax && shippingMin) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "".concat(message, " ").concat(intl.formatMessage(src_intl/* commonMessages.from */.i4.from), " ").concat(shippingMin, " ").concat(intl.formatMessage(src_intl/* commonMessages.to */.i4.to), " ").concat(shippingMax, " ").concat(translatedUnit)
        });
    }
    if (estimatedShipping) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "".concat(message, " ").concat(intl.formatRelativeTime(estimatedShippingDaysLeft, unit))
        });
    }
    return null;
}


;// CONCATENATED MODULE: ./src/@next/components/molecules/EstimatedShipping/index.ts



/***/ }),

/***/ 39117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ QuantityInput; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/NumberField/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    bottom: -8px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 50%;\n  transform: translateX(50%);\n  bottom: 0;\n  white-space: nowrap;\n  bottom: -6px;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Chrome, Safari, Edge, Opera */\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  /* Firefox */\n  -moz-appearance: textfield;\n  line-height: 27px;\n  width: 30px;\n  text-align: center;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  & {\n    border: none;\n  }\n  &:focus {\n    outline: none;\n  }\n  &:disabled {\n    background-color: transparent;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 20px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  width: 42px;\n  opacity: 0.5;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var NumberField = globalStyles/* styled.div */.zo.div(_templateObject());
var ErrorMessages = globalStyles/* styled.div */.zo.div(_templateObject2(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject1()));
var Input = globalStyles/* styled.input */.zo.input(_templateObject3(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
});
var Button = globalStyles/* styled.button */.zo.button(_templateObject5(), function(props) {
    return props.theme.typography.h5FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject4()));
var Middle = globalStyles/* styled.div */.zo.div(_templateObject6());

;// CONCATENATED MODULE: ./src/@next/components/molecules/NumberField/NumberField.tsx




var NumberField_NumberField = function(param) {
    var errors = param.errors, onChange = param.onChange, value = param.value, disabled = param.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NumberField, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                type: "button",
                onClick: (0,react.useCallback)(function() {
                    onChange(value - 1);
                }, [
                    onChange,
                    value
                ]),
                disabled: disabled,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "－"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Middle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                        onChange: function(e) {
                            return onChange(parseInt(e.target.value, 10));
                        },
                        type: "number",
                        value: value,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessages, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                            errors: errors
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                type: "button",
                onClick: (0,react.useCallback)(function() {
                    onChange(value + 1);
                }, [
                    onChange,
                    value
                ]),
                disabled: disabled,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "＋"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/NumberField/index.ts


// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
;// CONCATENATED MODULE: ./src/@next/components/molecules/QuantityInput/QuantityInput.tsx





var QuantityInput = function(param) {
    var disabled = param.disabled, quantity = param.quantity, maxQuantity = param.maxQuantity, onQuantityChange = param.onQuantityChange, hideErrors = param.hideErrors;
    var ref = (0,react.useState)(false), isTooMuch = ref[0], setIsTooMuch = ref[1];
    var intl = (0,useIntl/* default */.Z)();
    (0,react.useEffect)(function() {
        setIsTooMuch(!Number.isNaN(quantity) && quantity > maxQuantity);
    }, [
        quantity,
        maxQuantity
    ]);
    var handleQuantityChange = function(newQuantity) {
        if (newQuantity < 0) {
            return;
        }
        if (quantity !== newQuantity) {
            onQuantityChange(newQuantity);
        }
        setIsTooMuch(!Number.isNaN(newQuantity) && newQuantity > maxQuantity);
    };
    var quantityErrors = !hideErrors && isTooMuch ? [
        {
            message: intl.formatMessage(src_intl/* commonMessages.maxQtyIs */.i4.maxQtyIs, {
                maxQuantity: maxQuantity
            })
        }, 
    ] : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberField_NumberField, {
        value: quantity,
        disabled: disabled,
        onChange: handleQuantityChange,
        errors: quantityErrors
    });
};
QuantityInput.displayName = "QuantityInput";

;// CONCATENATED MODULE: ./src/@next/components/molecules/QuantityInput/index.tsx



/***/ }),

/***/ 80648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ TextField_TextField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./src/@next/components/atoms/Input/index.ts + 4 modules
var Input = __webpack_require__(95111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/TextField/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var TextField = globalStyles/* styled.div */.zo.div(_templateObject());
TextField.displayName = "S.TextField";
var HelpText = globalStyles/* styled.span */.zo.span(_templateObject1(), function(props) {
    return props.theme.input.labelColor;
}, function(props) {
    return props.theme.input.labelFontSize;
});
var ErrorMessages = globalStyles/* styled.div */.zo.div(_templateObject2());

;// CONCATENATED MODULE: ./src/@next/components/molecules/TextField/TextField.tsx








var TextField_TextField = function(_param) {
    var errors = _param.errors, helpText = _param.helpText, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "errors",
        "helpText"
    ]);
    var hasErrors = !!(errors && errors.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextField, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                error: hasErrors
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorMessages, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                        errors: errors
                    }),
                    helpText && /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpText, {
                        children: helpText
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/TextField/index.ts



/***/ }),

/***/ 88681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FE": function() { return /* binding */ Collection; },
/* harmony export */   "JL": function() { return /* binding */ Nav; },
/* harmony export */   "K7": function() { return /* binding */ LogoWrapper; },
/* harmony export */   "TR": function() { return /* binding */ Logo; },
/* harmony export */   "br": function() { return /* binding */ NavWrapper; },
/* harmony export */   "gQ": function() { return /* binding */ RightMenu; },
/* harmony export */   "pr": function() { return /* binding */ Hamburger; },
/* harmony export */   "sk": function() { return /* binding */ LeftMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23042);
/* harmony import */ var _components_templates_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95213);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-left: 0;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    top: ",
        ";\n    height: 60px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 10px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 10px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        height: 19px;\n        width: 19px;\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ",
        ";\n  font-size: ",
        ";\n  position: absolute;\n  top: ",
        ";\n  left: 0;\n  right: 0;\n  transition: all 0.2s ease;\n  height: 80px;\n  ",
        "\n  ",
        "\n  .main-menu__nav-link {\n    padding: 15px;\n    position: relative;\n    font-size: ",
        ";\n    line-height: 0.875rem;\n    white-space: nowrap;\n    ",
        "\n    ",
        "\n    img {\n      height: 22px;\n      width: 22px;\n      border-radius: 50%;\n      border: 2px solid transparent;\n      transition: all 0.2s ease-in-out;\n      ",
        "\n    }\n    &:before {\n      content: '';\n      display: block;\n      height: 2px;\n      width: 0;\n      position: absolute;\n      bottom: 0;\n      left: 50%;\n      transform: translateX(-50%);\n      background-color: ",
        ";\n      transition: width 0.6s;\n    }\n    &.active,\n    &:hover {\n      cursor: pointer;\n      &:before {\n        width: 75%;\n      }\n      img {\n        border: 2px solid #ecedee;\n        transition: all 0.2s ease-in-out;\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-left: 0;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    top: ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 10px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        height: 19px;\n        width: 19px;\n      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ",
        ";\n  // font-size: 1.125rem; // 18px\n  font-size: ",
        ";\n  position: absolute;\n  top: ",
        ";\n  left: 0;\n  right: 0;\n  transition: all 0.2s ease;\n  ",
        "\n  ",
        "\n  .main-menu__nav-link {\n    padding: 15px;\n    position: relative;\n    // font-size: 1.125rem;\n    font-size: ",
        ";\n    line-height: 0.875rem;\n    white-space: nowrap;\n    ",
        "\n    img {\n      height: 22px;\n      width: 22px;\n      border-radius: 50%;\n      border: 2px solid transparent;\n      transition: all 0.2s ease-in-out;\n      ",
        "\n    }\n    &:before {\n      content: '';\n      display: block;\n      height: 2px;\n      width: 0;\n      position: absolute;\n      bottom: 0;\n      left: 50%;\n      transform: translateX(-50%);\n      background-color: ",
        ";\n      transition: width 0.6s;\n    }\n    &.active,\n    &:hover {\n      cursor: pointer;\n      &:before {\n        width: 75%;\n      }\n      img {\n        border: 2px solid #ecedee;\n        transition: all 0.2s ease-in-out;\n      }\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    order: 1;\n    margin-right: auto;\n    padding: 10px 0;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-left: auto;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-width: 72px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: ",
        ";\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 116px;\n  height: auto;\n  display: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    order: 0;\n    flex: 1 1 25%;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    order: 2;\n    flex: 1 1 25%;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ul {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 28px;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 18px;\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      path {\n        fill: #ffffff;\n      }\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      transform: scale(0.8);\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n  padding: ",
        ";\n  ",
        "\n  ",
        "\n\n  .hamburger--hover {\n    display: none;\n  }\n\n  svg {\n    vertical-align: bottom;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}


var Nav = (0,_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_components_templates_Container__WEBPACK_IMPORTED_MODULE_2__/* .ContainerFlex */ .y1)(_templateObject5(), function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.isScrolled ? "0px" : "40px";
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject1(), function(props) {
    return props.isScrolled ? "0px" : "30px";
}), function(props) {
    return props.theme.typography.baseFontSize;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject2()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallestScreen */ .BC.smallestScreen(_templateObject3()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject4()), function(props) {
    return props.theme.colors.red;
});
var Collection = (0,_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_components_templates_Container__WEBPACK_IMPORTED_MODULE_2__/* .ContainerFlex */ .y1)(_templateObject10(), function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.isScrolled ? "80px" : "120px";
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject6()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject7(), function(props) {
    return props.isScrolled ? "60px" : "90px";
}), function(props) {
    return props.theme.typography.baseFontSize;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject8()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject9()), function(props) {
    return props.theme.colors.red;
});
var NavWrapper = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.ul */ .zo.ul(_templateObject11());
var LogoWrapper = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject14(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject12()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject13()));
var Logo = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.img */ .zo.img(_templateObject17(), function(props) {
    return props.mobile ? "none" : "block";
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject15()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject16(), function(props) {
    return props.mobile ? "block" : "none";
}));
var LeftMenu = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject19(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject18()));
var RightMenu = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject21(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject20()));
var Hamburger = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.li */ .zo.li(_templateObject26(), function(props) {
    return props.theme.colors.graySemi;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject22(), function(props) {
    return props.theme.colors.gold;
}), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject23()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject24()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject25()));


/***/ }),

/***/ 98720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Overlay_Overlay; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(26273);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
;// CONCATENATED MODULE: ./src/@next/components/organisms/Overlay/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n      transform: translateX(",
        ");\n    }\n    to {\n      transform: translateX(",
        ");\n    }"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        ": 0;\n        transform: translateX(",
        ");\n        animation: ",
        " 0.4s both;\n        animation-delay: ",
        ";\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  margin: 0 auto;\n  width: ",
        ";\n  // min-height: ",
        "px;\n  height: ",
        ";\n  background-color: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: fixed;\n  overflow-y: hidden;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n  top: 0;\n  z-index: 101;\n  transition: opacity 0.2s ease;\n  transition-delay: ",
        ";\n  background-color: ",
        ";\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  opacity: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var getTranslate = function(side) {
    return side === "left" ? "-100%" : "100%";
};
var slideAnimation = function(open, side) {
    var initialValue = open ? getTranslate(side) : 0;
    var endValue = open ? 0 : getTranslate(side);
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject(), initialValue, endValue);
};
var opacity = {
    entered: 1,
    entering: 0,
    exited: 0,
    exiting: 0,
    unmounted: 0
};
var justify = {
    bottom: "center",
    center: "center",
    fit: "center",
    left: "flex-start",
    right: "flex-end"
};
var lightboxHeight = {
    bottom: "85%",
    center: "auto",
    fit: "auto",
    left: "100vh",
    right: "100vh"
};
var lightboxWidth = function(width) {
    return {
        bottom: "100vw",
        center: "".concat(width, "px"),
        fit: "fit-content",
        left: "auto",
        right: "auto"
    };
};
var OverlayInner = globalStyles/* styled.div */.zo.div(_templateObject1());
var Lightbox = globalStyles/* styled.div */.zo.div(_templateObject4(), function(param) {
    var position = param.position, modal = param.theme.modal;
    return lightboxWidth(modal.modalWidth)[position];
}, function(props) {
    return props.theme.modal.modalMinHeight;
}, function(param) {
    var position = param.position;
    return lightboxHeight[position];
}, function(props) {
    return props.theme.colors.white;
}, function(param) {
    var open = param.open, position = param.position;
    if (position === "left" || position === "right") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), position, getTranslate(position), slideAnimation(open, position), open ? ".1s" : 0);
    }
}, globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject3()));
Lightbox.displayName = "S.Lightbox";
var Overlay = globalStyles/* styled.div */.zo.div(_templateObject5(), function(param) {
    var open = param.open;
    return open ? 0 : ".4s";
}, function(param) {
    var transparent = param.transparent, theme = param.theme;
    return transparent ? "" : theme.colors.overlay;
}, function(param) {
    var position = param.position;
    return position === "bottom" ? "flex-end" : "center";
}, function(param) {
    var position = param.position;
    return justify[position];
}, function(param) {
    var state = param.state;
    return opacity[state];
});
Overlay.displayName = "S.Overlay";

;// CONCATENATED MODULE: ./src/@next/components/organisms/Overlay/Overlay.tsx







var Overlay_Overlay = function(param) {
    var children = param.children, _duration = param.duration, duration = _duration === void 0 ? 300 : _duration, hide = param.hide, _position = param.position, position = _position === void 0 ? "center" : _position, show = param.show, _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent, target = param.target;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), mounted = ref1[0], setMounted = ref1[1];
    (0,react.useEffect)(function() {
        ref.current = target || document.getElementById("modal-root");
        setMounted(true);
    }, []);
    var animationProps = {
        open: show,
        position: position
    };
    return mounted && ref.current && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
        in: show,
        timeout: duration,
        unmountOnExit: true,
        children: function(state) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationProps), {
                state: state,
                transparent: transparent,
                onClick: hide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayInner, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationProps), {
                        state: state,
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        children: children
                    }))
                })
            }));
        }
    }), ref.current);
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/Overlay/index.ts



/***/ }),

/***/ 62671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tQ": function() { return /* reexport */ getLogicalPosition; },
  "cX": function() { return /* reexport */ isRightPosition; },
  "Br": function() { return /* reexport */ usePopoverPosition; }
});

// UNUSED EXPORTS: getPhysicalPosition, isTopPosition

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/components/organisms/Popoverlay/utils/positionHelper.ts
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */ var position1 = [
    "left",
    "right",
    "top",
    "bottom"
];
var position2 = [
    "start",
    "end"
];
var position3 = [
    "topRight",
    "topLeft",
    "bottomRight",
    "bottomLeft"
];
var position4 = [
    "topStart",
    "topEnd",
    "bottomStart",
    "bottomEnd"
];
function getPhysicalPosition(dir, position) {
    if (position1.includes(position) || position3.includes(position)) {
        return position;
    }
    switch(position){
        case "start":
            return dir === "rtl" ? "right" : "left";
        case "end":
            return dir === "rtl" ? "left" : "right";
        case "topStart":
            return dir === "rtl" ? "topRight" : "topLeft";
        case "topEnd":
            return dir === "rtl" ? "topLeft" : "topRight";
        case "bottomStart":
            return dir === "rtl" ? "bottomRight" : "bottomLeft";
        case "bottomEnd":
            return dir === "rtl" ? "bottomLeft" : "bottomRight";
    }
    return position;
}
function getLogicalPosition(dir, position) {
    if (position2.includes(position) || position4.includes(position)) {
        return position;
    }
    switch(position){
        case "right":
            return dir === "rtl" ? "start" : "end";
        case "left":
            return dir === "rtl" ? "end" : "start";
        case "topRight":
            return dir === "rtl" ? "topStart" : "topEnd";
        case "topLeft":
            return dir === "rtl" ? "topEnd" : "topStart";
        case "bottomRight":
            return dir === "rtl" ? "bottomStart" : "bottomEnd";
        case "bottomLeft":
            return dir === "rtl" ? "bottomEnd" : "bottomStart";
    }
    return position;
}
function isRightPosition(dir, position) {
    var physicalPosition = getPhysicalPosition(dir, position);
    return physicalPosition === "topRight" || physicalPosition === "bottomRight";
}
function isTopPosition(dir, position) {
    var physicalPosition = getLogicalPosition(dir, position);
    return physicalPosition === "topEnd" || physicalPosition === "topStart";
}

;// CONCATENATED MODULE: ./src/@next/components/organisms/Popoverlay/utils/popoverPosition.ts
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */ 




var getMaxPlacement = function(target, overlay) {
    var _Math;
    var positions = {
        top: target.top - overlay.height,
        bottom: window.innerHeight - target.bottom - overlay.height,
        left: target.left - overlay.width,
        right: window.innerWidth - target.right - overlay.width
    };
    var arr = Object.values(positions);
    var max = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(arr));
    return Object.keys(positions).find(function(key) {
        return positions[key] === max;
    });
};
var getPositionOfPlacement = function(placement, target, overlay) {
    var topBottom = {
        top: target.top + target.height / 2 - overlay.height / 2,
        bottom: window.innerHeight - (target.top + target.height / 2 + overlay.height / 2)
    };
    var leftRight = {
        left: target.left + (target.width / 2 - overlay.width / 2),
        right: window.innerWidth - (target.left + target.width / 2 + overlay.width / 2)
    };
    switch(placement){
        case "left":
            return (0,_object_spread/* default */.Z)({
                left: target.left - overlay.width
            }, topBottom);
        case "right":
            return (0,_object_spread/* default */.Z)({
                left: target.right
            }, topBottom);
        case "top":
            return (0,_object_spread/* default */.Z)({
                top: target.top - overlay.height
            }, leftRight);
        case "bottom":
            return (0,_object_spread/* default */.Z)({
                top: target.bottom
            }, leftRight);
    }
};
var getAdjustmentPlacement = function(placement, targetRef, overlayRef) {
    var key = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var ref, ref1;
    var target = (ref = targetRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
    var overlay = (ref1 = overlayRef.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect();
    if (target && overlay) {
        if (key > 4) {
            var maxPlacement = getMaxPlacement(target, overlay);
            var position = getPositionOfPlacement(maxPlacement, target, overlay);
            return {
                placement: maxPlacement,
                position: position
            };
        }
        var position1 = getPositionOfPlacement(placement, target, overlay);
        var _bottom;
        var topBottom = position1.top < 0 || ((_bottom = position1.bottom) !== null && _bottom !== void 0 ? _bottom : 0) < 0;
        var _right;
        var leftRight = position1.left < 0 || ((_right = position1.right) !== null && _right !== void 0 ? _right : 0) < 0;
        switch(placement){
            case "left":
                if (position1.left - 15 < 0 || topBottom) {
                    return getAdjustmentPlacement("top", targetRef, overlayRef, key + 1);
                }
                break;
            case "top":
                if (position1.top - 15 < 0 || leftRight) {
                    return getAdjustmentPlacement("right", targetRef, overlayRef, key + 1);
                }
                break;
            case "right":
                if (window.innerWidth - position1.left - 15 < overlay.width || topBottom) {
                    return getAdjustmentPlacement("bottom", targetRef, overlayRef, key + 1);
                }
                break;
            case "bottom":
                if (window.innerHeight - position1.top - 15 < overlay.height || leftRight) {
                    return getAdjustmentPlacement("left", targetRef, overlayRef, key + 1);
                }
                break;
        }
        return {
            placement: placement,
            position: position1
        };
    }
};
function usePopoverPosition(props, targetRef, overlayRef) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), position = ref[0], setPosition = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), show = ref1[0], setShow = ref1[1];
    var physicalPosition = getPhysicalPosition("ltr", props.placement);
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(physicalPosition), 2), placement = ref2[0], setPlacement = ref2[1];
    var onClickHandle = function() {
        setShow(false);
    };
    var positionHandle = function() {
        var data = getAdjustmentPlacement(physicalPosition, targetRef, overlayRef);
        if (data) {
            setPosition(data.position);
            setPlacement(data.placement);
        }
    };
    react.useEffect(function() {
        if (show) {
            positionHandle();
            window.addEventListener("resize", positionHandle);
            window.addEventListener("orientationchange", positionHandle);
            window.addEventListener("scroll", positionHandle);
            window.addEventListener("click", onClickHandle);
            if (props.eventListener) {
                var ref;
                (ref = document.querySelector(props.eventListener)) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", positionHandle);
            }
            return function() {
                window.removeEventListener("click", onClickHandle);
                window.removeEventListener("resize", positionHandle);
                window.removeEventListener("orientationchange", positionHandle);
                window.removeEventListener("scroll", positionHandle);
                if (props.eventListener) {
                    var ref;
                    (ref = document.querySelector(props.eventListener)) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", positionHandle);
                }
            };
        }
    }, [
        show,
        overlayRef.current
    ]);
    return {
        position: position,
        placement: placement,
        show: show,
        setShow: setShow,
        positionHandle: positionHandle
    };
}

;// CONCATENATED MODULE: ./src/@next/components/organisms/Popoverlay/utils/index.ts




/***/ }),

/***/ 96231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zH": function() { return /* reexport */ ToastrContext; },
  "zN": function() { return /* reexport */ ToastrProvider; }
});

// UNUSED EXPORTS: ToastrItem

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/components/organisms/Toastr/ToastrContext.tsx

var ToastrContext = /*#__PURE__*/ (0,react.createContext)(null);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/@next/components/atoms/Message/index.ts + 2 modules
var Message = __webpack_require__(92058);
// EXTERNAL MODULE: ./src/@next/components/organisms/Popoverlay/utils/index.ts + 2 modules
var utils = __webpack_require__(62671);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
;// CONCATENATED MODULE: ./src/@next/components/organisms/Toastr/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      cursor: pointer;\n\n      &:hover {\n        opacity: 1;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    width: 25rem;\n    margin: 0.5rem;\n    transition: all 150ms ease-out;\n    &&.animation {\n      transform: translateX(",
        "110%);\n      height: 0;\n      margin: 0;\n    }\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  position: absolute;\n  z-index: 1000;\n  ",
        "\n  .overlay-pane {\n    pointer-events: auto;\n    position: static;\n    box-sizing: border-box;\n    z-index: 1000;\n    display: flex;\n    max-width: 100%;\n    max-height: 100%;\n    flex-direction: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Toastr = globalStyles/* styled.div */.zo.div(_templateObject2(), function(param) {
    var theme = param.theme, status = param.status, destroyByClick = param.destroyByClick, hasIcon = param.hasIcon, isRight = param.isRight;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), !isRight && "-", destroyByClick && (0,styled_components_browser_esm/* css */.iv)(_templateObject()));
});
var ToastrContainer = globalStyles/* styled.div */.zo.div(_templateObject3(), function(param) {
    var position = param.position;
    switch(position){
        case "topStart":
            return "justify-content: flex-start;align-items: flex-start;";
        case "topEnd":
            return "justify-content: flex-end;align-items: flex-start;";
        case "bottomStart":
            return "justify-content: flex-start;align-items: flex-end;";
        case "bottomEnd":
            return "justify-content: flex-end;align-items: flex-end;";
    }
}, function(param) {
    var isTop = param.isTop;
    return isTop ? "column-reverse" : "column";
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/Toastr/ToastrItem.tsx








// import { ToastrIcon } from './ToastrIcon';

var ToastrItem = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), show = ref[0], setShow = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState("animation"), 2), animation = ref1[0], setAnimation = ref1[1];
    var destroyItem = function() {
        setAnimation("animation");
        setTimeout(function() {
            setShow(false);
        }, 100);
    };
    var onClick = function() {
        if (props.destroyByClick) {
            destroyItem();
        }
    };
    (0,react.useEffect)(function() {
        if ((props === null || props === void 0 ? void 0 : props.duration) && props.duration > 0) {
            setTimeout(function() {
                destroyItem();
            }, props.duration);
        }
        if (animation === "animation") {
            setTimeout(function() {
                setAnimation("");
            }, 10);
        }
    }, []);
    return show ? /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(Toastr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isRight: (0,utils/* isRightPosition */.cX)("ltr", props.position),
        className: animation,
        onClick: onClick
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* Message */.v, {
            status: props.status,
            title: props.title,
            onClick: onClick,
            children: props.message
        })
    })), document.getElementById("toastr".concat(props.position))) : null;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/@next/components/organisms/Toastr/ToastrProvider.tsx











var defaultProps = {
    position: "bottomRight",
    status: "neutral",
    duration: 3000,
    hasIcon: true,
    destroyByClick: true,
    preventDuplicates: false
};
var ToastrProvider = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var ref = (0,react.useState)([]), items = ref[0], setItems = ref[1];
    var ref1 = (0,react.useState)(false), createParents = ref1[0], setCreateParents = ref1[1];
    (0,react.useEffect)(function() {
        setCreateParents(true);
    }, []);
    var show = (0,react.useCallback)(function(_param) {
        var message = _param.message, title = _param.title, option = (0,_object_without_properties/* default */.Z)(_param, [
            "message",
            "title"
        ]);
        var options = (0,_object_spread/* default */.Z)({}, defaultProps, props, option);
        var newItems = (0,_to_consumable_array/* default */.Z)(items);
        var push = true;
        if (options.preventDuplicates) {
            push = !newItems.find(function(item) {
                return item.title === title && item.message === message;
            });
        }
        if (push) {
            options.position = (0,utils/* getLogicalPosition */.tQ)("ltr", options.position);
            newItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                title: title,
                message: message,
                icon: options.icons ? options.icons[options.status] : ""
            }));
            setItems(newItems);
        }
    }, [
        items
    ]);
    var contextValue = (0,react.useMemo)(function() {
        return {
            show: show
        };
    }, [
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastrContext.Provider, {
                value: contextValue,
                children: children
            }),
            createParents && [
                "topStart",
                "topEnd",
                "bottomStart",
                "bottomEnd"
            ].map(function(position) {
                return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastrContainer, {
                    position: position,
                    isTop: position === "topEnd" || position === "topStart",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overlay-pane",
                        id: "toastr".concat(position)
                    })
                }), document.getElementById("popover-root"));
            }),
            items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastrItem, (0,_object_spread/* default */.Z)({}, item), index);
            })
        ]
    });
};
ToastrProvider.displayName = "ToastrProvider";

;// CONCATENATED MODULE: ./src/@next/components/organisms/Toastr/index.ts





/***/ }),

/***/ 55646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ Cart_Cart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@next/components/atoms/CartFooter/index.ts + 2 modules
var CartFooter = __webpack_require__(79052);
// EXTERNAL MODULE: ./src/@next/components/molecules/CartProductList/index.ts + 4 modules
var CartProductList = __webpack_require__(55831);
// EXTERNAL MODULE: ./src/@next/components/containers/TaxedMoney/index.ts + 1 modules
var TaxedMoney = __webpack_require__(31740);
// EXTERNAL MODULE: ./src/@next/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(98720);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/@sdk/providers/CheckoutProvider.tsx
var CheckoutProvider = __webpack_require__(45327);
// EXTERNAL MODULE: ./src/images/x.svg
var x = __webpack_require__(63232);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/images/cart-red.svg
var cart_red_namespaceObject = __webpack_require__.p + "static/images/cart-red.svg";
;// CONCATENATED MODULE: ./src/images/sad-smile.svg
var sad_smile_namespaceObject = __webpack_require__.p + "static/images/sad-smile.svg";
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
;// CONCATENATED MODULE: ./src/@next/components/overlays/Cart/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 515px;\n    padding: 35px 40px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 596px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 20px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 792px;\n  height: 100%;\n  max-width: 100vw;\n  padding: 40px 40px 40px 84px;\n  max-height: 100%;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  display: flex;\n  flex: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.1em;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 30px;\n    height: 30px;\n    line-height: 32px;\n    margin-left: 10px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 24px;\n    height: 24px;\n    line-height: 26px;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  text-align: center;\n  display: inline-block;\n  width: 36px;\n  height: 36px;\n  line-height: 38px;\n  background-color: rgba(",
        ", 0.2);\n  border-radius: 50%;\n  color: ",
        ";\n  margin-left: 20px;\n  &.not-empty {\n    background-color: ",
        ";\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  margin-right: 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 270px;\n    width: 270px;\n    padding: 28px 42px 32px;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 366px;\n  width: 366px;\n  background-color: ",
        ";\n  display: flex;\n  padding: 62px;\n  img {\n    mix-blend-mode: darken;\n    height: 100%;\n    margin: auto;\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 270px;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 15px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 29px;\n  width: 366px;\n  display: flex;\n  ",
        "\n  ",
        "\n  .cancel {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .button:last-child {\n    flex-grow: 1;\n    margin-left: 70px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20vh 0 5vh;\n  text-align: center;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 46px;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        max-width: 76px;\n      "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 56px;\n      "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        max-width: 30px;\n      "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 22px;\n        transform: translateX(-10px);\n      "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 70px;\n  ",
        "\n  ",
        "\n  img {\n    vertical-align: middle;\n    height: auto;\n    &:first-child {\n      ",
        "\n      ",
        "\n    }\n    &:last-child {\n      transform: translateX(-15px);\n      ",
        "\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 26px;\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.1em;\n  margin-bottom: 35px;\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 244px;\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  .button {\n    width: 384px;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  button {\n    width: 100%;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}


var Modal = globalStyles/* styled.div */.zo.div(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var Header = globalStyles/* styled.div */.zo.div(_templateObject4());
var HeaderText = globalStyles/* styled.div */.zo.div(_templateObject5());
var HeaderTextTitle = globalStyles/* styled.span */.zo.span(_templateObject6(), function(param) {
    var typography = param.theme.typography;
    return typography.thinFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.h4FontSize;
});
var HeaderTextItem = globalStyles/* styled.span */.zo.span(_templateObject9(), function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, function(param) {
    var colors = param.theme.colors;
    return colors.white;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject7()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject8()));
var HeaderIcon = (0,globalStyles/* styled */.zo)(react_svg_esm/* ReactSVG */.Q)(_templateObject10());
var Content = globalStyles/* styled.div */.zo.div(_templateObject11());
var ProductImage = globalStyles/* styled.div */.zo.div(_templateObject13(), function(param) {
    var colors = param.theme.colors;
    return colors.redLight;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject12()));
var styles_Button = globalStyles/* styled.div */.zo.div(_templateObject16(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject14()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject15()));
var Empty = globalStyles/* styled.div */.zo.div(_templateObject17());
var EmptyImage = globalStyles/* styled.div */.zo.div(_templateObject24(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject18()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject19()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject20()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject21()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject22()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject23()));
var EmptyText = globalStyles/* styled.p */.zo.p(_templateObject26(), function(param) {
    var typography = param.theme.typography;
    return typography.thinFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.h4FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject25()));
var EmptyAction = globalStyles/* styled.div */.zo.div(_templateObject29(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject27()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject28()));
var FooterButton = globalStyles/* styled.div */.zo.div(_templateObject30());

;// CONCATENATED MODULE: ./src/@next/components/overlays/Cart/Empty.tsx









var Empty_Empty = function(param) {
    var overlayHide = param.overlayHide;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Empty, {
        className: "cart__empty",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyImage, {
                className: "cart__empty-img",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: sad_smile_namespaceObject,
                        alt: "Sad"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: cart_red_namespaceObject,
                        alt: "Cart is empty"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyText, {
                className: "cart__empty-text",
                children: intl.formatMessage({
                    defaultMessage: "Oops... Your cart is empty!",
                    id: "QY2p4z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyAction, {
                className: "cart__empty__action",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.home */.H.home,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "lg",
                            onClick: overlayHide,
                            className: "button",
                            children: intl.formatMessage({
                                defaultMessage: "shop now",
                                id: "MwnupR"
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Cart_Empty = (Empty_Empty);

;// CONCATENATED MODULE: ./src/@next/components/overlays/Cart/Cart.tsx













// import { CartUpsale } from "./CartUpsale";


var Cart = function() {
    var intl = (0,useIntl/* default */.Z)();
    var modal = (0,esm/* useModal */.dd)();
    var ref = (0,CheckoutProvider/* useCheckout */.Mg)(), checkout = ref.checkout, removeItem = ref.removeItem;
    var ref1 = checkout || {}, items = ref1.lines, subtotalPrice = ref1.subtotalPrice, shippingPrice = ref1.shippingPrice, discount = ref1.discount, totalPrice = ref1.totalPrice;
    var discountPrice = discount && {
        gross: discount,
        net: discount
    };
    var count = (items === null || items === void 0 ? void 0 : items.reduce(function(prevVal, currVal) {
        return prevVal + currVal.quantity;
    }, 0)) || 0;
    var removeProductItem = function(item) {
        var // @ analytics
        ref, ref1, ref2, ref3, ref4, ref5;
        window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.track("Product Removed", {
            name: (ref1 = item.variant) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.productType) === null || ref3 === void 0 ? void 0 : ref3.slug,
            product_id: (ref4 = item.variant) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.product) === null || ref5 === void 0 ? void 0 : ref5.slug,
            variant: item.variant.id
        });
        // @ graphql
        removeItem(item.variant.id, item.productAttributes);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "right",
        show: modal.visible,
        hide: modal.remove,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
            className: "cart",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                    className: "overlay__header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderText, {
                            className: "overlay__header-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTextTitle, {
                                    className: "overlay__header-text-title",
                                    children: intl.formatMessage({
                                        defaultMessage: "Shopping cart",
                                        id: "wjh10D"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTextItem, {
                                    className: (0,clsx/* clsx */.W)("overlay__header-text-items", {
                                        "not-empty": !!count
                                    }),
                                    children: count
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon, {
                            src: x,
                            onClick: modal.remove,
                            className: "overlay__header__close-icon"
                        })
                    ]
                }),
                (items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductList/* CartProductList */.E, {
                            lines: items,
                            remove: removeProductItem
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartFooter/* CartFooter */.T, {
                            subtotalPrice: /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                                "data-cy": "cartPageSubtotalPrice",
                                taxedMoney: subtotalPrice
                            }),
                            totalPrice: /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                                "data-cy": "cartPageTotalPrice",
                                taxedMoney: totalPrice
                            }),
                            shippingPrice: shippingPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                                "data-cy": "cartPageShippingPrice",
                                taxedMoney: shippingPrice
                            }),
                            discountPrice: discountPrice && discountPrice.gross.amount !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxedMoney/* TaxedMoney */.a, {
                                "data-cy": "cartPageShippingPrice",
                                taxedMoney: discountPrice
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterButton, {
                            className: "cart__button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: paths/* paths.checkout */.H.checkout,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        className: "button",
                                        size: "lg",
                                        onClick: modal.remove,
                                        children: intl.formatMessage({
                                            defaultMessage: "Go To Checkout",
                                            id: "YzFp2d"
                                        })
                                    })
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart_Empty, {
                    overlayHide: modal.remove
                })
            ]
        })
    });
};
/* harmony default export */ var Cart_Cart = (esm/* default.create */.ZP.create(Cart));

;// CONCATENATED MODULE: ./src/@next/components/overlays/Cart/index.ts



/***/ }),

/***/ 47489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ Login_Login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./src/@next/components/molecules/CardHeader/index.ts
var CardHeader = __webpack_require__(27080);
// EXTERNAL MODULE: ./src/@next/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(98720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./src/@next/components/molecules/TextField/index.ts + 2 modules
var TextField = __webpack_require__(80648);
// EXTERNAL MODULE: ./src/@sdk/auth/SaleorAuthProvider.tsx
var SaleorAuthProvider = __webpack_require__(27941);
// EXTERNAL MODULE: ./src/@next/utils/misc.ts
var misc = __webpack_require__(96896);
// EXTERNAL MODULE: ./src/@next/utils/errors.ts
var utils_errors = __webpack_require__(29521);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/LoginForm/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .input {\n    margin: 0 auto ",
        " auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: ",
        " auto;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin: calc(",
        " * 2) auto;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  ",
        ";\n  margin: ",
        ";\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    margin: 0 auto 1.25rem auto;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin: 0 auto;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: ",
        ";\n  span {\n    top: 3px;\n    position: relative;\n    margin-left: 7px;\n    color: ",
        ";\n    font-family: 'Inter';\n    &::after {\n      content: '';\n      display: block;\n      height: 1px;\n      width: 100%;\n      background-color: ",
        ";\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.spacing.spacer;
});
var Text = globalStyles/* styled.p */.zo.p(_templateObject1(), function(props) {
    return props.theme.spacing.spacer;
});
var Error = globalStyles/* styled.span */.zo.span(_templateObject2());
var SubmitButton = globalStyles/* styled.div */.zo.div(_templateObject4(), function(props) {
    return props.theme.spacing.spacer;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject3(), function(props) {
    return props.theme.spacing.spacer;
}));
var Reminder = globalStyles/* styled.div */.zo.div(_templateObject6(), function(param) {
    var colors = param.theme.colors;
    return colors.dividerDark;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 2) 0");
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject5(), function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " 0");
}));
var Checkbox = globalStyles/* styled.div */.zo.div(_templateObject9(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject7()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject8()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/LoginForm/LoginForm.tsx















var showSuccessNotification = function(onSuccess, user) {
    // @analitics
    if (user) {
        var ref;
        window === null || window === void 0 ? void 0 : (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.identify(user.id, {
            email: user.email,
            firstname: user.firstName,
            isLoggedIn: true,
            lastname: user.lastName
        });
    }
    if (onSuccess) {
        onSuccess();
    }
};
var LoginForm = function(param) {
    var onSuccess = param.onSuccess;
    var intl = (0,useIntl/* default */.Z)();
    var signIn = (0,SaleorAuthProvider/* useSaleorAuthContext */.e)().signIn;
    var ref = (0,react.useState)([]), graphqlErrors = ref[0], setGraphqlErrors = ref[1];
    var ref1 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            email: "",
            password: ""
        }
    }), control = ref1.control, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, handleSubmit = ref1.handleSubmit;
    var handleOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, ref1, data, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            signIn({
                                email: values.email,
                                password: values.password
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : (ref = data.tokenCreate) === null || ref === void 0 ? void 0 : ref.errors.length) {
                            ;
                            setGraphqlErrors(data === null || data === void 0 ? void 0 : (ref2 = data.tokenCreate) === null || ref2 === void 0 ? void 0 : ref2.errors);
                        } else if (data === null || data === void 0 ? void 0 : (ref1 = data.tokenCreate) === null || ref1 === void 0 ? void 0 : ref1.token) {
                            ;
                            setGraphqlErrors([]);
                            showSuccessNotification(onSuccess, data === null || data === void 0 ? void 0 : (ref3 = data.tokenCreate) === null || ref3 === void 0 ? void 0 : ref3.user);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var fieldErrors = (0,utils_errors/* groupErrorsByFields */.g)((0,misc/* maybe */.wY)(function() {
        return graphqlErrors;
    }, []), "email", "password");
    var nonFieldErrors = fieldErrors[utils_errors/* NON_FIELD_ERROR */.O];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "login-form",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit(handleOnSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                    className: "form-error",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                        errors: nonFieldErrors
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: "email",
                    control: control,
                    rules: {
                        pattern: {
                            message: intl.formatMessage(src_intl/* validationCommonMsg.invalidEmail */.a4.invalidEmail),
                            value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                        },
                        required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                    },
                    render: function(param) {
                        var field = param.field;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                            label: intl.formatMessage(src_intl/* commonMessages.shortEmail */.i4.shortEmail),
                            autoComplete: "email",
                            type: "email",
                            errors: errors.email ? [
                                {
                                    message: errors.email.message
                                }
                            ] :  false || (fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.email)
                        }, field));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: "password",
                    control: control,
                    rules: {
                        required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                    },
                    render: function(param) {
                        var field = param.field;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                            label: intl.formatMessage(src_intl/* commonMessages.password */.i4.password),
                            autoComplete: "password",
                            type: "password",
                            errors: errors.password ? [
                                {
                                    message: errors.password.message
                                }
                            ] :  false || (fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.password)
                        }, field));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                    className: "login-form__button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        fullWidth: true,
                        type: "submit",
                        disabled: isSubmitting,
                        children: isSubmitting ? intl.formatMessage(src_intl/* commonMessages.loading */.i4.loading) : intl.formatMessage(src_intl/* commonMessages.signIn */.i4.signIn)
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/LoginForm/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/@next/components/atoms/Checkbox/index.ts + 2 modules
var atoms_Checkbox = __webpack_require__(73881);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
;// CONCATENATED MODULE: ./src/@next/components/molecules/RegisterForm/RegisterForm.tsx


















var RegisterForm_showSuccessNotification = function(onSuccess, data) {
    // @analitics
    // TODO: track registration request
    if (onSuccess) {
        onSuccess(data);
    }
};
var RegisterForm = function(param) {
    var onSuccess = param.onSuccess;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isConditionChecked = ref[0], setConditionChecked = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), graphqlErrors = ref1[0], setGraphqlErrors = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useAccountRegisterMutation */.We)(), 2), accountRegisterMutation = ref2[0], ref3 = ref2[1], data = ref3.data, error = ref3.error;
    var ref4 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            email: "",
            password: ""
        }
    }), control = ref4.control, _formState = ref4.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, handleSubmit = ref4.handleSubmit;
    var handleOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, ref1, redirectUrl, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        redirectUrl = "".concat(window.location.origin).concat(paths/* paths.accountConfirm */.H.accountConfirm);
                        return [
                            4,
                            accountRegisterMutation({
                                variables: {
                                    email: values.email,
                                    password: values.password,
                                    redirectUrl: redirectUrl
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : ref.length) {
                            setGraphqlErrors(error === null || error === void 0 ? void 0 : error.graphQLErrors);
                        } else if (data === null || data === void 0 ? void 0 : (ref1 = data.accountRegister) === null || ref1 === void 0 ? void 0 : ref1.accountErrors.length) {
                            ;
                            setGraphqlErrors(data === null || data === void 0 ? void 0 : (ref2 = data.accountRegister) === null || ref2 === void 0 ? void 0 : ref2.accountErrors);
                        } else if (data === null || data === void 0 ? void 0 : data.accountRegister) {
                            setGraphqlErrors([]);
                            RegisterForm_showSuccessNotification(onSuccess, data === null || data === void 0 ? void 0 : data.accountRegister);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var fieldErrors = (0,utils_errors/* groupErrorsByFields */.g)((0,misc/* maybe */.wY)(function() {
        return graphqlErrors;
    }, []), "email", "password");
    var nonFieldErrors = fieldErrors[utils_errors/* NON_FIELD_ERROR */.O];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "registration-form",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit(handleOnSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                    className: "form-error",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                        errors: nonFieldErrors
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: "email",
                    control: control,
                    rules: {
                        pattern: {
                            message: intl.formatMessage(src_intl/* validationCommonMsg.invalidEmail */.a4.invalidEmail),
                            value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                        },
                        required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                    },
                    render: function(param) {
                        var field = param.field;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                            label: intl.formatMessage(src_intl/* commonMessages.shortEmail */.i4.shortEmail),
                            autoComplete: "email",
                            type: "email",
                            errors: errors.email ? [
                                {
                                    message: errors.email.message
                                }
                            ] :  false || (fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.email)
                        }, field));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: "password",
                    control: control,
                    rules: {
                        required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                    },
                    render: function(param) {
                        var field = param.field;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                            label: intl.formatMessage(src_intl/* commonMessages.password */.i4.password),
                            autoComplete: "password",
                            type: "password",
                            errors: errors.password ? [
                                {
                                    message: errors.password.message
                                }
                            ] :  false || (fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.password)
                        }, field));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Checkbox, {
                    className: "login__checkbox",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Checkbox/* Checkbox */.X, {
                            name: "conditions",
                            checked: isConditionChecked,
                            onChange: function() {
                                setConditionChecked(!isConditionChecked);
                            },
                            children: intl.formatMessage({
                                defaultMessage: "I have read",
                                id: "pupJlG"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "login__checkbox__text",
                            children: intl.formatMessage({
                                defaultMessage: "Terms and Conditions",
                                id: "6qF/vN"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                    className: "login__content__button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        fullWidth: true,
                        type: "submit",
                        disabled: !isConditionChecked || isSubmitting,
                        children: isSubmitting ? intl.formatMessage(src_intl/* commonMessages.loading */.i4.loading) : intl.formatMessage(src_intl/* commonMessages.register */.i4.register)
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/RegisterForm/index.ts


// EXTERNAL MODULE: ./src/images/sign-in.svg
var sign_in = __webpack_require__(79378);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
;// CONCATENATED MODULE: ./src/@next/components/molecules/PasswordForgottenForm/PasswordForgottenForm.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ 
















var PasswordForgottenForm_showSuccessNotification = function(onSuccess) {
    // @analitics
    // TODO: track password reset requet
    if (onSuccess) {
        onSuccess();
    }
};
var PasswordForgottenForm = function(param) {
    var onSuccess = param.onSuccess;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useResetPasswordRequestMutation */.IS)(), 2), resetPasswordRequestMutation = ref[0], ref1 = ref[1], data = ref1.data, error = ref1.error;
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), graphqlErrors = ref2[0], setGraphqlErrors = ref2[1];
    var ref3 = (0,index_esm/* useForm */.cI)(), control = ref3.control, _formState = ref3.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, handleSubmit = ref3.handleSubmit;
    var handleOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, ref1, redirectUrl, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        redirectUrl = "".concat(window.location.origin).concat(paths/* paths.passwordReset */.H.passwordReset);
                        return [
                            4,
                            resetPasswordRequestMutation({
                                variables: {
                                    email: values.email,
                                    redirectUrl: redirectUrl
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : ref.length) {
                            setGraphqlErrors(error === null || error === void 0 ? void 0 : error.graphQLErrors);
                        } else if (data === null || data === void 0 ? void 0 : (ref1 = data.requestPasswordReset) === null || ref1 === void 0 ? void 0 : ref1.accountErrors.length) {
                            ;
                            setGraphqlErrors(data === null || data === void 0 ? void 0 : (ref2 = data.requestPasswordReset) === null || ref2 === void 0 ? void 0 : ref2.accountErrors);
                        } else if (data === null || data === void 0 ? void 0 : data.requestPasswordReset) {
                            setGraphqlErrors([]);
                            PasswordForgottenForm_showSuccessNotification(onSuccess);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var fieldErrors = (0,utils_errors/* groupErrorsByFields */.g)((0,misc/* maybe */.wY)(function() {
        return graphqlErrors;
    }, []), "email");
    var nonFieldErrors = fieldErrors[utils_errors/* NON_FIELD_ERROR */.O];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "password-reset-form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                className: "password-reset-form__text",
                children: intl.formatMessage({
                    defaultMessage: "Please provide us your email address so we can share you a link to reset your password",
                    id: "v7NldV"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "password-reset-form__form",
                onSubmit: handleSubmit(handleOnSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                        className: "form-error",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                            errors: nonFieldErrors
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        name: "email",
                        control: control,
                        rules: {
                            pattern: {
                                message: intl.formatMessage(src_intl/* validationCommonMsg.invalidEmail */.a4.invalidEmail),
                                value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                            },
                            required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                        },
                        render: function(param) {
                            var field = param.field;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                                label: intl.formatMessage(src_intl/* commonMessages.shortEmail */.i4.shortEmail),
                                autoComplete: "email",
                                errors: errors.email ? [
                                    {
                                        message: errors.email.message
                                    }
                                ] : fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.email
                            }, field));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                        className: "password-reset-form__button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "submit",
                            disabled: isSubmitting,
                            fullWidth: true,
                            children: isSubmitting ? intl.formatMessage(src_intl/* commonMessages.loading */.i4.loading) : intl.formatMessage(src_intl/* commonMessages.send */.i4.send)
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/PasswordForgottenForm/index.ts


;// CONCATENATED MODULE: ./src/images/remember-password.svg
var remember_password_namespaceObject = __webpack_require__.p + "static/images/remember-password.svg";
// EXTERNAL MODULE: ./src/images/mail-send.svg
var mail_send = __webpack_require__(97278);
;// CONCATENATED MODULE: ./src/@next/components/overlays/Login/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // margin-top: 140px;\n    margin-top: 40px;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 40rem;\n  max-width: 100vw;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 20%;\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 20px;\n      width: 30%;\n    "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 0;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-bottom: ",
        ";\n  span {\n    width: 50%;\n    text-align: center;\n    position: relative;\n    padding: ",
        ";\n    color: ",
        ";\n    text-transform: capitalize;\n    cursor: pointer;\n    font-size: 30px;\n    &:first-of-type {\n      border-right: 1px solid ",
        ";\n    }\n\n    &:last-of-type {\n      border-left: 1px solid ",
        ";\n      &:after {\n        content: '';\n        display: block;\n        position: absolute;\n        top: 11px;\n        left: -3px;\n        width: 2px;\n        height: 35px;\n        background-color: ",
        ";\n      }\n    }\n\n    &.active-tab {\n      color: ",
        ";\n    }\n    ",
        "\n    ",
        "\n  }\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: ",
        ";\n  "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin:0;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  margin: ",
        ";\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    margin: 0 auto 1.25rem auto;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin: 0 auto;\n    font-size: 14px;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  span {\n    top: 3px;\n    font-weight: 500;\n    position: relative;\n    margin-left: 7px;\n    color: ",
        ";\n    font-family: 'Inter';\n    &::after {\n      content: '';\n      display: block;\n      height: 1px;\n      width: 100%;\n      background-color: ",
        ";\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 1rem;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &link {\n    color: ",
        ";\n    border-bottom: 1px solid ",
        ";\n    cursor: pointer;\n    font-family: ",
        " !important;\n    font-size: ",
        ";\n    margin-bottom: 2rem;\n    ",
        "\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}

var Modal = globalStyles/* styled.div */.zo.div(styles_templateObject2(), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(styles_templateObject()), globalStyles/* media.smallestScreen */.BC.smallestScreen(styles_templateObject1()));
var styles_Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject3());
var Tab = globalStyles/* styled.div */.zo.div(styles_templateObject7(), function(param) {
    var spacing = param.theme.spacing;
    return spacing.gutter;
}, function(param) {
    var spacing = param.theme.spacing;
    return spacing.gutter;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFontColorOpacityLight;
}, function(param) {
    var colors = param.theme.colors;
    return colors.white;
}, function(param) {
    var colors = param.theme.colors;
    return colors.white;
}, function(param) {
    var colors = param.theme.colors;
    return colors.light;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject4()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject6()));
var styles_Text = globalStyles/* styled.p */.zo.p(styles_templateObject8(), function(param) {
    var spacing = param.theme.spacing;
    return "1rem ".concat(spacing.gutter, " 1.8rem ").concat(spacing.gutter);
});
var Content = globalStyles/* styled.div */.zo.div(_templateObject10(), function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " calc(").concat(spacing.spacer, " * 5)");
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject9(), function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " calc(").concat(spacing.spacer, " * 2)");
}));
var styles_Button = globalStyles/* styled.div */.zo.div(_templateObject12(), function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 2) 0");
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject11()));
var styles_Reminder = globalStyles/* styled.div */.zo.div(_templateObject14(), function(param) {
    var colors = param.theme.colors;
    return colors.dividerDark;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 2) 0");
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject13(), function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " 0");
}));
var styles_Checkbox = globalStyles/* styled.div */.zo.div(_templateObject17(), function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject15()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject16()));
var Link = globalStyles/* styled.span */.zo.span(_templateObject19(), function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var theme = param.theme;
    return theme.typography.baseFontSize;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject18()));

;// CONCATENATED MODULE: ./src/@next/components/overlays/Login/PasswordForgotten.tsx













var PasswordForgotten = function() {
    var modal = (0,esm/* useModal */.dd)();
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), success = ref[0], setSuccess = ref[1];
    return success ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                divider: true,
                formImage: mail_send,
                onHide: modal.remove,
                children: intl.formatMessage(src_intl/* commonMessages.success */.i4.success)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                children: intl.formatMessage({
                    defaultMessage: "A link to change your password is knocking at your door! Just open your e-mail!",
                    id: "+QRFrd"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.home */.H.home,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "button",
                            onClick: modal.remove,
                            children: intl.formatMessage({
                                defaultMessage: "go to homepage",
                                id: "Oj28K/"
                            })
                        })
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                divider: true,
                formImage: remember_password_namespaceObject,
                onHide: modal.remove,
                children: intl.formatMessage({
                    defaultMessage: "Can’t remember your password?",
                    id: "lVAJQY"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordForgottenForm, {
                    onSuccess: function() {
                        return setSuccess(true);
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/images/account-created.svg
var account_created = __webpack_require__(21602);
;// CONCATENATED MODULE: ./src/@next/components/overlays/Login/RegisterConfirmation.tsx
// import './scss/index.scss';












var RegisterConfirmation = function(param) {
    var data = param.data;
    var intl = (0,useIntl/* default */.Z)();
    var modal = (0,esm/* useModal */.dd)();
    var title = data.requiresConfirmation ? intl.formatMessage(src_intl/* commonMessages.success */.i4.success) : intl.formatMessage(src_intl/* commonMessages.congratulations */.i4.congratulations);
    var image = data.requiresConfirmation ? mail_send : account_created;
    var text = data.requiresConfirmation ? intl.formatMessage({
        defaultMessage: "A link to confirm your email address is knocking at your door! Just one step to your account!",
        id: "eh0pHa"
    }) : intl.formatMessage({
        defaultMessage: "That’s one small step for a mankind - one giant leap for doorkind. Your account has now been created.",
        id: "YgRLgs"
    });
    var content = data.requiresConfirmation ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: paths/* paths.home */.H.home,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                fullWidth: true,
                type: "button",
                onClick: modal.remove,
                children: intl.formatMessage({
                    defaultMessage: "go to homepage",
                    id: "Oj28K/"
                })
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: paths/* paths.home */.H.home,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "button",
                        onClick: modal.remove,
                        children: intl.formatMessage({
                            defaultMessage: "go to homepage",
                            id: "Oj28K/"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: paths/* paths.account */.H.account,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        appearance: "outline",
                        type: "button",
                        onClick: modal.remove,
                        children: intl.formatMessage({
                            defaultMessage: "go to your account",
                            id: "tcCsSQ"
                        })
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                divider: true,
                formImage: image,
                onHide: modal.remove,
                children: title
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                children: text
            }),
            content && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: content
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/overlays/Login/Login.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ 












var Login = function(param) {
    var active = param.active;
    var modal = (0,esm/* useModal */.dd)();
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(active || "login"), activeTab = ref[0], setActiveTab = ref[1];
    var ref1 = (0,react.useState)({}), data = ref1[0], setData = ref1[1];
    var handleRegisterSuccess = function(data) {
        setData(data);
        setActiveTab("success");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: modal.visible,
        hide: modal.remove,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
            children: [
                activeTab === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterConfirmation, {
                    data: data
                }),
                activeTab === "forgotten" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordForgotten, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Reminder, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                onClick: function() {
                                    return setActiveTab("login");
                                },
                                children: intl.formatMessage({
                                    defaultMessage: "Back to Sign In",
                                    id: "zpY1ie"
                                })
                            })
                        })
                    ]
                }),
                (activeTab === "login" || activeTab === "register") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* CardHeader */.O, {
                            divider: true,
                            formImage: sign_in,
                            onHide: modal.remove,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab, {
                                className: "login__tabs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: function() {
                                            return setActiveTab("login");
                                        },
                                        className: activeTab === "login" ? "active-tab" : "",
                                        children: intl.formatMessage(src_intl/* commonMessages.signIn */.i4.signIn)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: function() {
                                            return setActiveTab("register");
                                        },
                                        className: activeTab === "register" ? "active-tab" : "",
                                        children: intl.formatMessage(src_intl/* commonMessages.register */.i4.register)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                            children: activeTab === "login" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {
                                        onSuccess: modal.remove
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Reminder, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                            onClick: function() {
                                                return setActiveTab("forgotten");
                                            },
                                            children: intl.formatMessage({
                                                defaultMessage: "Forgot your password ?",
                                                id: "LDPFW0"
                                            })
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {
                                onSuccess: handleRegisterSuccess
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Login_Login = (esm/* default.create */.ZP.create(Login));

;// CONCATENATED MODULE: ./src/@next/components/overlays/Login/index.tsx



/***/ }),

/***/ 40080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "y1": function() { return /* binding */ ContainerFlex; }
/* harmony export */ });
/* unused harmony export CartContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23042);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 85vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 90vw;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 80vw;\n  max-width: 1491px;\n  margin: 0 auto;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-left: 30px;\n    padding-right: 30px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-left: 24px;\n    padding-right: 24px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100vw;\n  padding-left: 60px;\n  padding-right: 60px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  max-width: 100vw;\n  padding: 0 ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var Container = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject2(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject1()));
var ContainerFlex = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject5(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject3()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject4()));
var CartContainer = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject7(), function(props) {
    return "".concat(props.theme.container.width, "px");
}, function(props) {
    return props.theme.spacing.spacer;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smMediumScreen */ .BC.smMediumScreen(_templateObject6()));


/***/ }),

/***/ 95213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W2": function() { return /* reexport safe */ _Container__WEBPACK_IMPORTED_MODULE_0__.W2; },
/* harmony export */   "y1": function() { return /* reexport safe */ _Container__WEBPACK_IMPORTED_MODULE_0__.y1; }
/* harmony export */ });
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40080);



/***/ }),

/***/ 38408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ baseFontColor; },
/* harmony export */   "CD": function() { return /* binding */ blueLightOpacitySemi; },
/* harmony export */   "Cy": function() { return /* binding */ redLight; },
/* harmony export */   "GH": function() { return /* binding */ blueLight; },
/* harmony export */   "Gl": function() { return /* binding */ baseFontFamily; },
/* harmony export */   "H8": function() { return /* binding */ fieldSpacer; },
/* harmony export */   "HA": function() { return /* binding */ baseLineHeight; },
/* harmony export */   "HM": function() { return /* binding */ h3FontSize; },
/* harmony export */   "Hj": function() { return /* binding */ smMediumScreen; },
/* harmony export */   "L": function() { return /* binding */ extraFontFamily; },
/* harmony export */   "M6": function() { return /* binding */ largeScreen; },
/* harmony export */   "M7": function() { return /* binding */ mediumScreen; },
/* harmony export */   "MA": function() { return /* binding */ gray; },
/* harmony export */   "NV": function() { return /* binding */ boldFontFamily; },
/* harmony export */   "NW": function() { return /* binding */ boldFontWeight; },
/* harmony export */   "OF": function() { return /* binding */ spacer; },
/* harmony export */   "Od": function() { return /* binding */ h1LineHeight; },
/* harmony export */   "Q6": function() { return /* binding */ red; },
/* harmony export */   "SB": function() { return /* binding */ graySemi; },
/* harmony export */   "Sn": function() { return /* binding */ black; },
/* harmony export */   "Uk": function() { return /* binding */ h4FontSize; },
/* harmony export */   "Vr": function() { return /* binding */ thinFontFamily; },
/* harmony export */   "XE": function() { return /* binding */ baseFontSize; },
/* harmony export */   "bD": function() { return /* binding */ extraBoldFontWeight; },
/* harmony export */   "e7": function() { return /* binding */ grayLight; },
/* harmony export */   "eD": function() { return /* binding */ h1FontSize; },
/* harmony export */   "fR": function() { return /* binding */ baseFontColorOpacityDark; },
/* harmony export */   "hU": function() { return /* binding */ grayDark; },
/* harmony export */   "hZ": function() { return /* binding */ xLargeScreen; },
/* harmony export */   "iN": function() { return /* binding */ blue; },
/* harmony export */   "im": function() { return /* binding */ smallestScreen; },
/* harmony export */   "ix": function() { return /* binding */ white; },
/* harmony export */   "kt": function() { return /* binding */ grayMedium; },
/* harmony export */   "lj": function() { return /* binding */ ultraBigFont; },
/* harmony export */   "n1": function() { return /* binding */ h5FontSize; },
/* harmony export */   "oD": function() { return /* binding */ smallFontSize; },
/* harmony export */   "p6": function() { return /* binding */ h2FontSize; },
/* harmony export */   "rS": function() { return /* binding */ theme; },
/* harmony export */   "tz": function() { return /* binding */ labelFontSize; },
/* harmony export */   "xC": function() { return /* binding */ smallScreen; },
/* harmony export */   "zk": function() { return /* binding */ xSmallScreen; }
/* harmony export */ });
/* unused harmony exports baseFontColorOpacityLight, baseFontColorTransparent, blueOverlay, blueOverlayDark, redHover, redActive, redLightExtra, blueDark, blueDarkActive, blueLightOpacityLight, borderGray, graySoft, green, rose, turquoise, turquoiseDark, turquoiseLight, turquoiseTransparent, tabelGray, darkGreen, gold */
// colors
var baseFontColor = "#2c2c2c";
var baseFontColorOpacityLight = "rgba(44, 44, 44, 0.4)"; // #2c2c2c
var baseFontColorOpacityDark = "rgba(44, 44, 44, 0.8)"; // #2c2c2c
var baseFontColorTransparent = "rgba(50,50,50,0.1)"; // #323232
var black = "#000";
var white = "#fff";
var blue = "#21125e"; // #21125e
var blueOverlay = "rgba(33,18,94,0.15)"; // #21125e
var blueOverlayDark = "rgba(33,18,94,0.25)"; // #21125e
var red = "#c34c3e";
var redLight = "#f5f1f2";
var redHover = "#af382a";
var redActive = "#a52e20";
var redLightExtra = "#f1e3e1";
var blueDark = "#3b5a68";
var blueDarkActive = "#31505e";
var blueLight = "#4f6e7c";
var blueLightOpacitySemi = "rgba(79, 110, 124, 0.5)"; // #4f6e7c
var blueLightOpacityLight = "rgba(79, 110, 124, 0.1)"; // #4f6e7c
var borderGray = "#cfd7de"; // Only from strip element ?
var gray = "#7d7d7d";
var graySemi = "#839098";
var grayMedium = "#c4c4c4";
var grayDark = "#323232";
var graySoft = "#e2e3e4";
var grayLight = "#f5f1f2";
var green = "#3ed256";
var rose = "#c22d74";
var turquoise = "#13bebb";
var turquoiseDark = "#06a09e";
var turquoiseLight = "rgba(6, 132, 123, 0.25)"; // #06847b
var turquoiseTransparent = "rgba(6, 132, 123, 0.1)"; // #06847b
var tabelGray = "#eaeaea";
var darkGreen = "#06847b";
var gold = "#ca9c66";
// theme colors
var theme = {
    activeMenuOption: darkGreen,
    baseFont: baseFontColor,
    baseFontColorTransparent: baseFontColorTransparent,
    baseFontColorOpacityDark: baseFontColorOpacityDark,
    black: black,
    borderGray: borderGray,
    blueLight: blueLight,
    blueLightOpacityLight: blueLightOpacityLight,
    grayDark: grayDark,
    disabled: gray,
    divider: grayLight,
    dividerDark: grayMedium,
    error: rose,
    baseFontColorOpacityLight: baseFontColorOpacityLight,
    graySemi: graySemi,
    blueLightOpacitySemi: blueLightOpacitySemi,
    graySoft: graySoft,
    hoverLightBackground: turquoiseLight,
    redHover: redHover,
    light: grayLight,
    lightFont: gray,
    listBullet: darkGreen,
    overlay: baseFontColorOpacityDark,
    primary: red,
    primaryDark: redHover,
    primaryDarkest: redActive,
    primaryLight: turquoiseLight,
    primaryTransparent: turquoiseTransparent,
    red: red,
    redLight: redLight,
    secondary: blueLight,
    secondaryDark: blueDark,
    secondaryDarkest: blueDarkActive,
    secondaryLight: blueLight,
    secondaryOverlay: blueOverlay,
    secondaryOverlayDark: blueOverlayDark,
    success: green,
    tabTitle: darkGreen,
    tableDivider: tabelGray,
    tabsBorder: baseFontColorTransparent,
    thumbnailBorder: darkGreen,
    white: white,
    gold: gold
};
// typography
var baseFontFamily = "'Sofia', Arial, Helvetica, sans-serif";
var thinFontFamily = "'Sofia thin', Arial, Helvetica, sans-serif";
var boldFontFamily = "'Sofia bold', Arial, Helvetica, sans-serif";
var extraFontFamily = "'Inter', Arial, Helvetica, sans-serif";
var boldFontWeight = 600;
var extraBoldFontWeight = 800;
var baseLineHeight = "1.25rem"; // 20px
var h1LineHeight = 1;
var h1FontSize = "3rem"; // 48px
var h2FontSize = "2.44rem"; // 39px
var h3FontSize = "1.953rem"; // 31px
var h4FontSize = "1.563rem"; // 25px
var h5FontSize = "1.25rem"; // 20px
var baseFontSize = "1rem"; // 16px
var smallFontSize = "0.875rem"; // 14px
var labelFontSize = "0.75rem"; // 12px
var ultraBigFont = "6rem"; // 96px
// spacing
var spacer = 1; // rem
var fieldSpacer = "1.25rem";
// breakpoints
var xLargeScreen = 1919;
var largeScreen = 1599;
var mediumScreen = 1279;
var smMediumScreen = 992;
var smallScreen = 767;
var xSmallScreen = 540;
var smallestScreen = 340;


/***/ }),

/***/ 23042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZL": function() { return /* reexport */ GlobalStyle; },
  "uH": function() { return /* reexport */ defaultTheme; },
  "BC": function() { return /* reexport */ media/* media */.B; },
  "zo": function() { return /* reexport */ styled; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/@next/globalStyles/themes.ts



var defaultTheme = {
    breakpoints: {
        smMediumScreen: "992px",
        smallScreen: "767px",
        xSmallScreen: "540px",
        mediumScreen: "1279px",
        largeScreen: "1599px",
        xLargeScreen: "1919px"
    },
    button: {
        animation: {
            transition: "0.3s"
        },
        colors: {
            primary: {
                activeBackground: constants/* theme.primaryDarkest */.rS.primaryDarkest,
                background: constants/* theme.primary */.rS.primary,
                color: constants/* white */.ix,
                hoverBackground: constants/* theme.primaryDark */.rS.primaryDark,
                hoverColor: constants/* white */.ix
            },
            secondary: {
                activeBackground: constants/* theme.secondaryDarkest */.rS.secondaryDarkest,
                background: constants/* theme.secondary */.rS.secondary,
                color: constants/* white */.ix,
                hoverBackground: constants/* theme.secondaryDark */.rS.secondaryDark,
                hoverColor: constants/* white */.ix
            }
        },
        padding: {
            lg: "1.25rem 2.5em",
            md: "0.9rem 2rem",
            sm: "0.9rem 1rem"
        },
        typography: {
            fontSize: "1.125rem",
            fontWeight: "600",
            lineHeight: "1.25rem",
            smallFontSize: "0.8rem",
            textTransform: "uppercase",
            baseFontFamily: constants/* baseFontFamily */.Gl,
            boldFontFamily: constants/* boldFontFamily */.NV
        }
    },
    carousel: {
        carouselControlPadding: "0.2rem 0.5rem",
        carouselControlShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.25)"
    },
    chip: {
        colors: {
            primary: {
                activeBackground: constants/* theme.primaryTransparent */.rS.primaryTransparent,
                background: constants/* theme.primaryLight */.rS.primaryLight,
                color: constants/* theme.primaryDark */.rS.primaryDark,
                hoverBackground: "none",
                hoverColor: constants/* theme.primaryDark */.rS.primaryDark
            },
            secondary: {
                activeBackground: constants/* theme.primaryTransparent */.rS.primaryTransparent,
                background: constants/* theme.secondaryLight */.rS.secondaryLight,
                color: constants/* theme.secondaryDark */.rS.secondaryDark,
                hoverBackground: "none",
                hoverColor: constants/* theme.secondaryDark */.rS.secondaryDark
            }
        },
        typography: {
            fontSize: "1rem",
            smallFontSize: "0.75rem"
        }
    },
    colors: (0,_object_spread/* default */.Z)({}, constants/* theme */.rS),
    container: {
        width: 1140,
        paddingLeft: 44
    },
    dropdown: {
        backgroundColor: constants/* theme.white */.rS.white,
        boxShadow: "0px 6px 10px 0px rgba(0, 0, 0, 0.15)"
    },
    grid: {
        containerWidth: 1140
    },
    iconButton: {
        backgroundColor: constants/* theme.white */.rS.white,
        hoverBackgroundColor: constants/* theme.secondary */.rS.secondary,
        hoverForegroundColor: constants/* theme.white */.rS.white,
        size: 36
    },
    input: {
        border: constants/* grayDark */.hU,
        labelColor: constants/* grayDark */.hU,
        /**
     * 12px in default theme
     */ labelFontSize: "0.75rem",
        selectMenuShadow: "0px 6px 10px 0px rgba(0, 0, 0, 0.15)"
    },
    link: {
        base: {
            color: constants/* gray */.MA,
            hoverColor: constants/* grayMedium */.kt
        },
        secondary: {
            color: constants/* blue */.iN,
            hoverColor: constants/* blueLight */.GH
        }
    },
    popover: {
        borderWidth: "1px",
        borderRadius: "0.25rem",
        borderColor: "transparent",
        arrowSize: "6px",
        shadow: "shadow",
        backgroundColor: constants/* baseFontColorOpacityDark */.fR,
        padding: "5px 9px"
    },
    message: {
        backgroundColor: constants/* white */.ix,
        contentMargin: "".concat(constants/* spacer */.OF, "rem 0 0"),
        letterSpacing: "0.5px",
        padding: "1rem 1.5rem",
        titleMargin: "0 ".concat(constants/* spacer */.OF * 1.5, "rem 0 0"),
        titleTransform: "uppercase",
        titleWeight: constants/* extraBoldFontWeight */.bD,
        width: "25rem"
    },
    modal: {
        modalMinHeight: 455,
        modalWidth: 555
    },
    productItem: {
        productItemCategoryColor: constants/* gray */.MA,
        productItemPriceFontWeight: constants/* boldFontWeight */.NW,
        productItemPriceMargin: "".concat(constants/* spacer */.OF, "rem 0 0"),
        productItemTitleFontWeight: constants/* boldFontWeight */.NW,
        productItemTitleHeight: "2.5rem",
        productItemTitleMargin: "".concat(constants/* spacer */.OF / 2, "rem 0 0"),
        productItemTitleTextTransform: "uppercase"
    },
    spacing: {
        /**
     * 30px in default theme
     */ fieldSpacer: constants/* fieldSpacer */.H8,
        /**
     * 30px in default theme
     */ gutter: "1.875rem",
        /**
     * 16px in default theme
     */ spacer: "".concat(constants/* spacer */.OF, "rem")
    },
    tile: {
        backgroundColor: constants/* grayLight */.e7,
        divisionLine: constants/* grayMedium */.kt,
        hoverBorder: constants/* blueLight */.GH
    },
    typography: {
        baseFontFamily: constants/* baseFontFamily */.Gl,
        /**
     * 16px in default theme
     */ baseFontSize: constants/* baseFontSize */.XE,
        /**
     * 20px in default theme
     */ baseLineHeight: constants/* baseLineHeight */.HA,
        boldFontFamily: constants/* boldFontFamily */.NV,
        boldFontWeight: constants/* boldFontWeight */.NW,
        extraBoldFontWeight: constants/* extraBoldFontWeight */.bD,
        extraFontFamily: constants/* extraFontFamily */.L,
        /**
     * 96px in default theme
     */ ultraBigFont: constants/* ultraBigFont */.lj,
        /**
     * 48px in default theme
     */ h1FontSize: constants/* h1FontSize */.eD,
        h1LineHeight: constants/* h1LineHeight */.Od,
        /**
     * 39px in default theme
     */ h2FontSize: constants/* h2FontSize */.p6,
        /**
     * 31px in default theme
     */ h3FontSize: constants/* h3FontSize */.HM,
        /**
     * 25px in default theme
     */ h4FontSize: constants/* h4FontSize */.Uk,
        /**
     * 20px in default theme
     */ h5FontSize: constants/* h5FontSize */.n1,
        /**
     * 14px in default theme
     */ smallFontSize: constants/* smallFontSize */.oD,
        thinFontFamily: constants/* thinFontFamily */.Vr,
        /**
     * 12px in default theme
     */ labelFontSize: constants/* labelFontSize */.tz,
        /**
     * 96px in default theme
     */ ultraBigFontSize: constants/* ultraBigFont */.lj
    }
};
var styled = styled_components_browser_esm/* default */.ZP;

// EXTERNAL MODULE: ./src/@next/globalStyles/media.ts
var media = __webpack_require__(59390);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./node_modules/styled-reset/lib/esm/index.js
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

// prettier-ignore
var esm_reset = (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n/* http://meyerweb.com/eric/tools/css/reset/\n   v5.0.1 | 20191019\n   License: none (public domain)\n*/\n\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, menu, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmain, menu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, main, menu, nav, section {\n  display: block;\n}\n/* HTML5 hidden-attribute fix for newer browsers */\n*[hidden] {\n    display: none;\n}\nbody {\n  line-height: 1;\n}\nmenu, ol, ul {\n  list-style: none;\n}\nblockquote, q {\n  quotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n"], ["\n/* http://meyerweb.com/eric/tools/css/reset/\n   v5.0.1 | 20191019\n   License: none (public domain)\n*/\n\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, menu, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmain, menu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, main, menu, nav, section {\n  display: block;\n}\n/* HTML5 hidden-attribute fix for newer browsers */\n*[hidden] {\n    display: none;\n}\nbody {\n  line-height: 1;\n}\nmenu, ol, ul {\n  list-style: none;\n}\nblockquote, q {\n  quotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n"])));
var Reset = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), esm_reset);
/* harmony default export */ var esm = (esm_reset);
var templateObject_1, templateObject_2;

;// CONCATENATED MODULE: ./src/@next/globalStyles/global.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: 80px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: 80px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: 60px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n  ",
        "\n  /* Fonts */\n\n  @font-face {\n    font-family: 'Inter';\n    src: url('/fonts/Inter-Regular.woff2') format('woff2'),\n      url('/fonts/Inter-Regular.woff') format('woff'),\n      url('/fonts/Inter-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n  }\n  @font-face {\n    font-family: 'Sofia bold';\n    src: url('/fonts/SofiaProBold.woff2') format('woff2'),\n      url('/fonts/SofiaProBold.woff') format('woff'),\n      url('/fonts/SofiaProBold.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n  }\n  @font-face {\n    font-family: 'Sofia thin';\n    src: url('/fonts/SofiaProLight.woff2') format('woff2'),\n      url('/fonts/SofiaProLight.woff') format('woff'),\n      url('/fonts/SofiaProLight.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n  }\n  @font-face {\n    font-family: 'Sofia';\n    src: url('/fonts/SofiaProRegular.woff2') format('woff2'),\n      url('/fonts/SofiaProRegular.woff') format('woff'),\n      url('/fonts/SofiaProRegular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n  }\n\n  /* Base Style */\n\n  html {\n    font-size: calc(12px + 0.290625vw);\n    box-sizing: border-box;\n    &.hidden {\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n\n  body {\n    // margin: 0;\n    // min-width: 320px;\n    font-family: ",
        ";\n    // font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n    ",
        "\n  }\n\n  input, textarea, button {\n    font-family: inherit;\n  }\n\n  header {\n    position: sticky;\n    top: 0;\n    width: 100vw;\n    background-color: #ffffff;\n    z-index: 100;\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .page-wrapper {\n    margin-top: 100px;\n    ",
        "\n    ",
        "\n    ",
        "\n    &.no-margin {\n      margin-top: 0;\n    }\n\n  }\n\n  .form-error {\n    color: ",
        ";\n  }\n\n  h1 {\n    font-size: ",
        ";\n    line-height: ",
        ";\n\n    ",
        "\n  }\n\n  h3 {\n    font-size: ",
        ";\n    line-height: 1.7rem;\n  }\n\n  h4 {\n    font-size: ",
        ";\n  }\n\n  a {\n    text-decoration: none;\n    font-weight: normal;\n    color: inherit;\n  }\n\n  p {\n    line-height: 1.5rem;\n  }\n\n  button {\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    outline: none;\n    padding: 0;\n  }\n\n  ul {\n    list-style: none;\n  }\n\n  table {\n    width: 100%;\n    margin: ",
        ";\n    font-size: ",
        ";\n\n    th {\n      color: ",
        ";\n      text-align: left;\n      padding: ",
        ";\n    }\n\n    tr {\n      color: ",
        ";\n      border-bottom: 1px solid ",
        ";\n    }\n\n    td {\n      padding: ",
        ";\n      vertical-align: middle;\n\n      img {\n        vertical-align: middle;\n        margin-right: ",
        ";\n      }\n    }\n  }\n\n  #root {\n    display: flex;\n    min-height: 100vh;\n    flex-direction: column;\n\n    & > div:first-of-type {\n      flex: 1;\n    }\n  }\n\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject5(), esm, function(props) {
    return props.theme.typography.baseFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.baseLineHeight;
}, function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return media/* media.smallScreen */.B.smallScreen(_templateObject(), function(props) {
        return props.theme.typography.smallFontSize;
    });
}, function(props) {
    return media/* media.largeScreen */.B.largeScreen(_templateObject1());
}, function(props) {
    return media/* media.mediumScreen */.B.mediumScreen(_templateObject2());
}, function(props) {
    return media/* media.smallScreen */.B.smallScreen(_templateObject3());
}, function(props) {
    return props.theme.colors.error;
}, function(props) {
    return props.theme.typography.h1FontSize;
}, function(props) {
    return props.theme.typography.h1LineHeight;
}, function(props) {
    return media/* media.xSmallScreen */.B.xSmallScreen(_templateObject4(), props.theme.typography.h2FontSize);
}, function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 3) 0");
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.lightFont;
}, function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " calc(").concat(spacing.spacer, " / 2)");
}, function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.colors.light;
}, function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " calc(").concat(spacing.spacer, " / 2)");
}, function(props) {
    return props.theme.spacing.spacer;
});

;// CONCATENATED MODULE: ./src/@next/globalStyles/index.ts





/***/ }),

/***/ 59390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ media; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52015);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38408);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        @media (max-width: ",
        "px) {\n          ",
        "\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var breakpoints = {
    smallestScreen: _constants__WEBPACK_IMPORTED_MODULE_1__/* .smallestScreen */ .im,
    smMediumScreen: _constants__WEBPACK_IMPORTED_MODULE_1__/* .smMediumScreen */ .Hj,
    smallScreen: _constants__WEBPACK_IMPORTED_MODULE_1__/* .smallScreen */ .xC,
    xSmallScreen: _constants__WEBPACK_IMPORTED_MODULE_1__/* .xSmallScreen */ .zk,
    mediumScreen: _constants__WEBPACK_IMPORTED_MODULE_1__/* .mediumScreen */ .M7,
    largeScreen: _constants__WEBPACK_IMPORTED_MODULE_1__/* .largeScreen */ .M6,
    xLargeScreen: _constants__WEBPACK_IMPORTED_MODULE_1__/* .xLargeScreen */ .hZ
};
var media = Object.keys(breakpoints).reduce(function(acc, label) {
    acc[label] = function(literals) {
        for(var _len = arguments.length, placeholders = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            placeholders[_key - 1] = arguments[_key];
        }
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), breakpoints[label], styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css.apply */ .iv.apply(void 0, [
            literals
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(placeholders))));
    };
    return acc;
}, // tslint:disable-next-line:no-object-literal-type-assertion
{});


/***/ }),

/***/ 40918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nr": function() { return /* reexport */ useDebounce; },
  "Uf": function() { return /* reexport */ useDeepEffect/* useDeepCompareMemoize */.Uf; },
  "so": function() { return /* reexport */ useHandlerWhenClickedOutside; },
  "_": function() { return /* reexport */ useLocalStorage/* useLocalStorage */._; },
  "kH": function() { return /* reexport */ useNetworkStatus; },
  "kC": function() { return /* reexport */ useNotifier; },
  "ik": function() { return /* reexport */ useRedirectToCorrectCheckoutStep; },
  "M4": function() { return /* reexport */ useScrolled; },
  "rf": function() { return /* reexport */ useUpdateEffect; }
});

// UNUSED EXPORTS: useCheckoutStepState, useDeepCompareEffectNoCheck, useDeepEffect

// EXTERNAL MODULE: ./src/@next/hooks/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(24324);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/utils/tsUtils.ts
var tsUtils = __webpack_require__(5946);
;// CONCATENATED MODULE: ./src/@next/hooks/useHandlerWhenClickedOutside.tsx


var useHandlerWhenClickedOutside = function(callback) {
    var elementRef = react.useRef(null);
    var handleClickOutside = function(e) {
        if ((0,tsUtils/* maybe */.w)(function() {
            return elementRef.current && e.target;
        }, null)) {
            if (elementRef.current.contains(e.target)) {
                return;
            }
            callback();
        }
    };
    var setElementRef = function() {
        return elementRef;
    };
    react.useEffect(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return {
        setElementRef: setElementRef
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/@next/hooks/useNetworkStatus.ts



var useNetworkStatus = function(callBack) {
    var nav = !constants/* ssrMode */.$m ? navigator : {};
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState("onLine" in nav ? nav.onLine : true), 2), online = ref[0], setOnline = ref[1];
    var updateOnlineStatus = function() {
        var status = nav.onLine;
        if (callBack) {
            callBack(status);
        }
        setOnline(nav.onLine);
    };
    react.useEffect(function() {
        addEventListener("offline", updateOnlineStatus);
        addEventListener("online", updateOnlineStatus);
        return function() {
            removeEventListener("offline", updateOnlineStatus);
            removeEventListener("online", updateOnlineStatus);
        };
    }, []);
    return {
        online: online
    };
};

// EXTERNAL MODULE: ./src/@next/pages/CheckoutPage/utils.tsx
var utils = __webpack_require__(23312);
;// CONCATENATED MODULE: ./src/@next/hooks/useCheckoutStepState.ts


var useCheckoutStepState = function(items, checkout, checkoutGateway) {
    var isShippingRequiredForProducts = (0,utils/* checkIfShippingRequiredForProducts */.n6)(items);
    var getMaxPossibleStep = function() {
        if (!(checkout === null || checkout === void 0 ? void 0 : checkout.id) && items) {
            // we are creating checkout during address set up
            return utils/* CheckoutStep.Address */.pN.Address;
        }
        var isShippingAddressSet = !isShippingRequiredForProducts || !!(checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress);
        var isBillingAddressSet = !!(checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress);
        var isShippingMethodSet = !isShippingRequiredForProducts || !!(checkout === null || checkout === void 0 ? void 0 : checkout.shippingMethod);
        var isPaymentMethodSet = !!checkoutGateway;
        if (!isShippingAddressSet || !isBillingAddressSet) {
            return utils/* CheckoutStep.Address */.pN.Address;
        }
        if (!isShippingMethodSet) {
            return utils/* CheckoutStep.Address */.pN.Address;
        }
        if (!isPaymentMethodSet) {
            return utils/* CheckoutStep.Payment */.pN.Payment;
        }
        return utils/* CheckoutStep.Payment */.pN.Payment;
    };
    var getRecommendedStep = function(newMaxPossibleStep) {
        var isPaymentRecreateRequired = newMaxPossibleStep > utils/* CheckoutStep.Address */.pN.Address;
        if (isPaymentRecreateRequired && isShippingRequiredForProducts) {
            return utils/* CheckoutStep.Address */.pN.Address;
        }
        if (isPaymentRecreateRequired) {
            return utils/* CheckoutStep.Payment */.pN.Payment;
        }
        return newMaxPossibleStep;
    };
    var ref = (0,react.useState)(getMaxPossibleStep()), maxPossibleStep = ref[0], setMaxPossibleStep = ref[1];
    var ref1 = (0,react.useState)(getRecommendedStep(maxPossibleStep)), recommendedStep = ref1[0], setRecommendedStep = ref1[1];
    (0,react.useEffect)(function() {
        var newMaxPossibleStep = getMaxPossibleStep();
        var newRecommendedStep = getRecommendedStep(newMaxPossibleStep);
        if (maxPossibleStep !== newMaxPossibleStep) {
            setMaxPossibleStep(newMaxPossibleStep);
        }
        if (recommendedStep !== newRecommendedStep) {
            setRecommendedStep(newRecommendedStep);
        }
    }, [
        checkout,
        items
    ]);
    return {
        recommendedStep: recommendedStep,
        maxPossibleStep: maxPossibleStep
    };
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@sdk/providers/CheckoutProvider.tsx
var CheckoutProvider = __webpack_require__(45327);
;// CONCATENATED MODULE: ./src/@next/hooks/useRedirectToCorrectCheckoutStep.ts





var useRedirectToCorrectCheckoutStep = function(checkoutLoaded) {
    var ref = (0,router.useRouter)(), pathname = ref.pathname, replace = ref.replace;
    var ref1 = (0,CheckoutProvider/* useCheckout */.Mg)(), checkout = ref1.checkout, checkoutGateway = ref1.checkoutGateway;
    var ref2 = checkout || {}, items = ref2.lines;
    var ref3 = useCheckoutStepState(items, checkout, checkoutGateway), recommendedStep = ref3.recommendedStep, maxPossibleStep = ref3.maxPossibleStep;
    (0,react.useEffect)(function() {
        var ref;
        var stepFromPath = (ref = utils/* CHECKOUT_STEPS.find */.Z6.find(function(param) {
            var link = param.link;
            return link === pathname;
        })) === null || ref === void 0 ? void 0 : ref.step;
        var isShippingRequired = (0,utils/* checkIfShippingRequiredForProducts */.n6)(items);
        var isIncorrectStep = !stepFromPath || stepFromPath > maxPossibleStep || pathname === utils/* CHECKOUT_STEPS.1.link */.Z6[1].link && !isShippingRequired;
        var getStepLink = function() {
            var ref;
            return ((ref = utils/* CHECKOUT_STEPS.find */.Z6.find(function(stepObj) {
                return stepObj.step === recommendedStep;
            })) === null || ref === void 0 ? void 0 : ref.link) || utils/* CHECKOUT_STEPS.0.link */.Z6[0].link;
        };
        if (checkoutLoaded && isIncorrectStep) {
            replace(getStepLink());
        }
    }, [
        pathname,
        checkoutLoaded
    ]);
};

;// CONCATENATED MODULE: ./src/@next/hooks/useScrolled.tsx

function useScrolled(thresholdTop, thresholdBottom) {
    var ref = (0,react.useState)(false), isScrolled = ref[0], setIsScrolled = ref[1];
    var ref1 = (0,react.useState)(false), isScrolledToBottom = ref1[0], setIsScrolledToBottom = ref1[1];
    (0,react.useEffect)(function() {
        var scrollHandler = function(e) {
            var _scrollingElement = e.target.scrollingElement, scrollHeight = _scrollingElement.scrollHeight, scrollTop = _scrollingElement.scrollTop, clientHeight = _scrollingElement.clientHeight;
            if (scrollTop > thresholdTop) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
            if (scrollHeight - scrollTop - thresholdBottom < clientHeight) {
                setIsScrolledToBottom(true);
            } else {
                setIsScrolledToBottom(false);
            }
        };
        document.addEventListener("scroll", scrollHandler);
        return function() {
            document.removeEventListener("scroll", scrollHandler);
        };
    }, [
        thresholdBottom,
        thresholdTop
    ]);
    return [
        isScrolled,
        isScrolledToBottom
    ];
}

// EXTERNAL MODULE: ./src/@next/hooks/useDeepEffect.ts
var useDeepEffect = __webpack_require__(49813);
;// CONCATENATED MODULE: ./src/@next/hooks/useFirstRenderState.ts

/**
 * Returns "true" if component is just mounted (first render), else "false".
 */ var useFirstRenderState = function() {
    var isFirstRenderRef = (0,react.useRef)(true);
    if (isFirstRenderRef.current) {
        isFirstRenderRef.current = false;
        return true;
    }
    return isFirstRenderRef.current;
};
/* harmony default export */ var hooks_useFirstRenderState = (useFirstRenderState);

;// CONCATENATED MODULE: ./src/@next/hooks/useUpdateEffect.ts


/**
 * Run an effect only on updates.
 * Skip the first effect execution that occurrs after initial mount.
 */ var useUpdateEffect = function(effect, deps) {
    var isFirstRender = hooks_useFirstRenderState();
    (0,useDeepEffect/* useDeepEffect */.Hu)(function() {
        if (!isFirstRender) {
            return effect();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

// EXTERNAL MODULE: ./src/@next/components/organisms/Toastr/index.ts + 4 modules
var Toastr = __webpack_require__(96231);
;// CONCATENATED MODULE: ./src/@next/hooks/useNotifier.ts


function useNotifier() {
    var toastrContext = (0,react.useContext)(Toastr/* ToastrContext */.zH);
    return toastrContext;
}

;// CONCATENATED MODULE: ./src/@next/hooks/useIsomorphicLayoutEffect.ts

var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;

;// CONCATENATED MODULE: ./src/@next/hooks/useDebounce.ts


var useDebounce = function(value, delay) {
    var ref = (0,react.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    useIsomorphicLayoutEffect(function() {
        var timer = setTimeout(function() {
            return setDebouncedValue(value);
        }, delay || 500);
        return function() {
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};

;// CONCATENATED MODULE: ./src/@next/hooks/index.ts












/***/ }),

/***/ 49813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hu": function() { return /* binding */ useDeepEffect; },
/* harmony export */   "Uf": function() { return /* binding */ useDeepCompareMemoize; }
/* harmony export */ });
/* unused harmony export useDeepCompareEffectNoCheck */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);



function isPrimitive(val) {
    return val == null || /^[sbn]/.test(typeof val === "undefined" ? "undefined" : _type_of(val));
}
function checkDeps(deps) {
    if (!deps || !deps.length) {
        throw new Error("useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.");
    }
    if (deps.every(isPrimitive)) {
        throw new Error("useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.");
    }
}
/**
 * @param value the value to be memoized (usually a dependency list)
 * @returns a memoized version of the value as long as it remains deeply equal
 */ function useDeepCompareMemoize(value) {
    var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value);
    var signalRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(0);
    if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(value, ref.current)) {
        ref.current = value;
        signalRef.current += 1;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        return ref.current;
    }, [
        signalRef.current
    ]);
}
function useDeepEffect(callback, dependencies) {
    if (false) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(callback, useDeepCompareMemoize(dependencies));
}
function useDeepCompareEffectNoCheck(callback, dependencies) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useEffect(callback, useDeepCompareMemoize(dependencies));
}


/***/ }),

/***/ 24324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useLocalStorage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useLocalStorage(key, initialValue) {
    var sync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).sync;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        var result;
        try {
            var item = window.localStorage.getItem(key);
            result = item ? JSON.parse(item) : initialValue;
        } catch (e) {
            result = initialValue;
        }
        return result;
    }), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = function(valueOrCb) {
        setStoredValue(valueOrCb);
        var valueToStore = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(valueOrCb, Function) ? valueOrCb(storedValue) : valueOrCb;
        try {
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (e) {
            console.warn("Could not save ".concat(key, " to localStorage"));
        }
    };
    var onStorage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        if (event.key !== key) return;
        try {
            var item = event.newValue;
            if (item) {
                setStoredValue(JSON.parse(item));
            }
        } catch (e) {
            console.warn("Could not update value for ".concat(key));
        }
    }, [
        key
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (sync) {
            window.addEventListener("storage", onStorage);
            return function() {
                window.removeEventListener("storage", onStorage);
            };
        }
        return undefined;
    }, [
        onStorage,
        sync
    ]);
    return [
        storedValue,
        setValue
    ];
}


/***/ }),

/***/ 15996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ useMediaQuery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/hooks/useMediaQuery/mockDocument.ts
/* eslint-disable @typescript-eslint/no-empty-function */ var doc = {
    body: {
        classList: {
            add: function add() {},
            remove: function remove() {}
        }
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
        blur: function blur() {},
        nodeName: ""
    },
    querySelector: function querySelector() {
        return null;
    },
    querySelectorAll: function querySelectorAll() {
        return [];
    },
    getElementById: function getElementById() {
        return null;
    },
    createEvent: function createEvent() {
        return {
            initEvent: function initEvent() {}
        };
    },
    createElement: function createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function setAttribute() {},
            getElementsByTagName: function getElementsByTagName() {
                return [];
            }
        };
    }
};
var ssrDocument = doc;

;// CONCATENATED MODULE: ./src/@next/hooks/useMediaQuery/mockWindow.ts
/* eslint-disable @typescript-eslint/no-empty-function */ 
var noop = function() {};
var win = {
    document: ssrDocument,
    navigator: {
        userAgent: ""
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: noop,
    removeEventListener: noop,
    getComputedStyle: function getComputedStyle() {
        return {
            getPropertyValue: function getPropertyValue() {
                return "";
            }
        };
    },
    matchMedia: function matchMedia() {
        return {
            matches: false,
            addListener: noop,
            removeListener: noop
        };
    },
    requestAnimationFrame: function requestAnimationFrame(callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    },
    setTimeout: function() {
        return 0;
    },
    clearTimeout: noop,
    setInterval: function() {
        return 0;
    },
    clearInterval: noop
};
var ssrWindow = win;

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/@next/hooks/useMediaQuery/useMediaQuery.ts






var mockEnv = {
    window: ssrWindow,
    document: ssrDocument
};
/**
 * React hook that tracks state of a CSS media query
 *
 * @param query the media query to match
 * @param options the media query options { fallback, ssr }
 *
 * @see Docs https://chakra-ui.com/docs/hooks/use-media-query
 */ function useMediaQuery(query) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _ssr = options.ssr, ssr = _ssr === void 0 ? true : _ssr, fallback = options.fallback;
    var env = !constants/* ssrMode */.$m ? {
        window: window,
        document: document
    } : mockEnv;
    var queries = Array.isArray(query) ? query : [
        query
    ];
    var fallbackValues = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    fallbackValues = fallbackValues.filter(function(v) {
        return v != null;
    });
    var ref = (0,react.useState)(function() {
        return queries.map(function(query, index) {
            return {
                media: query,
                matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query).matches
            };
        });
    }), value = ref[0], setValue = ref[1];
    (0,react.useEffect)(function() {
        setValue(queries.map(function(query) {
            return {
                media: query,
                matches: env.window.matchMedia(query).matches
            };
        }));
        var mql = queries.map(function(query) {
            return env.window.matchMedia(query);
        });
        var handler = function(evt) {
            setValue(function(prev) {
                return prev.slice().map(function(item) {
                    if (item.media === evt.media) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        matches: evt.matches
                    });
                    return item;
                });
            });
        };
        mql.forEach(function(mql) {
            if (typeof mql.addListener === "function") {
                mql.addListener(handler);
            } else {
                mql.addEventListener("change", handler);
            }
        });
        return function() {
            mql.forEach(function(mql) {
                if (typeof mql.removeListener === "function") {
                    mql.removeListener(handler);
                } else {
                    mql.removeEventListener("change", handler);
                }
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        env.window
    ]);
    return value.map(function(item) {
        return item.matches;
    });
}

;// CONCATENATED MODULE: ./src/@next/hooks/useMediaQuery/index.ts



/***/ }),

/***/ 87134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Returns the previous value stored in state.
 */ function usePrevious(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}


/***/ }),

/***/ 72827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createSafeContext() {
    var useContext = function useContext() {
        var value = react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
        if (value === undefined) {
            throw new Error("useContext must be inside a Provider with a value");
        }
        return value;
    };
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
    return [
        useContext,
        context.Provider
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (createSafeContext);


/***/ }),

/***/ 23312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lu": function() { return /* binding */ DEFAULT_PAYMENT_METHODS; },
/* harmony export */   "M1": function() { return /* binding */ getCurrentStep; },
/* harmony export */   "Z6": function() { return /* binding */ CHECKOUT_STEPS; },
/* harmony export */   "kw": function() { return /* binding */ getAvailableSteps; },
/* harmony export */   "n6": function() { return /* binding */ checkIfShippingRequiredForProducts; },
/* harmony export */   "pN": function() { return /* binding */ CheckoutStep; },
/* harmony export */   "yb": function() { return /* binding */ prepareCartSummaryProducts; }
/* harmony export */ });
/* unused harmony exports getContinueButtonText, stepSubmitSuccessHandler */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var _temp_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72110);
/* harmony import */ var _paths__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4032);







var checkIfShippingRequiredForProducts = function(items) {
    return items === null || items === void 0 ? void 0 : items.some(function(param) {
        var variant = param.variant;
        var ref;
        return (ref = variant.product) === null || ref === void 0 ? void 0 : ref.productType.isShippingRequired;
    });
};
var CheckoutStep;
(function(CheckoutStep) {
    CheckoutStep[CheckoutStep["Address"] = 1] = "Address";
    CheckoutStep[CheckoutStep[// Shipping = 1,
    "Payment"] = 2] = "Payment";
    CheckoutStep[CheckoutStep["PaymentConfirm"] = 3] = "PaymentConfirm";
})(CheckoutStep || (CheckoutStep = {}));
var CHECKOUT_STEPS = [
    {
        index: 0,
        link: _paths__WEBPACK_IMPORTED_MODULE_3__/* .paths.checkoutAddress */ .H.checkoutAddress,
        name: "Address",
        nextActionName: "Continue to Payment",
        onlyIfShippingRequired: false,
        step: CheckoutStep.Address
    },
    // {
    //   index: 0,
    //   link: paths.checkoutShipping,
    //   name: 'Shipping',
    //   nextActionName: 'Continue to Payment',
    //   onlyIfShippingRequired: true,
    //   step: CheckoutStep.Shipping,
    // },
    {
        index: 1,
        link: _paths__WEBPACK_IMPORTED_MODULE_3__/* .paths.checkoutPayment */ .H.checkoutPayment,
        name: "Payment",
        nextActionName: "Place order",
        onlyIfShippingRequired: false,
        step: CheckoutStep.Payment
    },
    {
        index: 2,
        link: _paths__WEBPACK_IMPORTED_MODULE_3__/* .paths.checkoutPaymentConfirm */ .H.checkoutPaymentConfirm,
        name: "Payment confirm",
        onlyIfShippingRequired: false,
        step: CheckoutStep.PaymentConfirm,
        withoutOwnView: true
    }, 
];
// export const DEFAULT_PAYMENT_METHODS = 'mirumee.payments.dummy';
// export const DEFAULT_PAYMENT_METHODS = 'saleor.payments.paypal';
// export const DEFAULT_PAYMENT_METHODS = 'saleor.payments.przelewy24';
// export const DEFAULT_PAYMENT_METHODS = 'saleor.payments.blik';
// export const DEFAULT_PAYMENT_METHODS = 'saleor.payments.klarna';
var DEFAULT_PAYMENT_METHODS = "saleor.payments.stripe";
var prepareCartSummaryProducts = function(items) {
    return items === null || items === void 0 ? void 0 : items.map(function(param) {
        var id = param.id, variant = param.variant, totalPrice = param.totalPrice, quantity = param.quantity;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return {
            id: id || "",
            name: ((ref = variant.product) === null || ref === void 0 ? void 0 : ref.name) || "",
            price: {
                gross: {
                    amount: (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.gross.amount) || 0,
                    currency: (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.gross.currency) || ""
                },
                net: {
                    amount: (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.net.amount) || 0,
                    currency: (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.net.currency) || ""
                }
            },
            quantity: quantity,
            sku: variant.sku || "",
            thumbnail: {
                alt: ((ref1 = variant.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.alt) || undefined,
                url: (ref3 = variant.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.thumbnail) === null || ref4 === void 0 ? void 0 : ref4.url,
                url2x: (ref5 = variant.product) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.thumbnail2x) === null || ref6 === void 0 ? void 0 : ref6.url
            },
            title: (variant.product || {}).name
        };
    });
};
var _obj;
var continueButtonTextMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, CheckoutStep.Address, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .checkoutMessages.addressNextActionName */ .hX.addressNextActionName))), // [CheckoutStep.Shipping]: (
//   <FormattedMessage {...checkoutMessages.shippingNextActionName} />
// ),
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, CheckoutStep.Payment, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .checkoutMessages.paymentNextActionName */ .hX.paymentNextActionName))), _obj);
var getContinueButtonText = function(step) {
    return continueButtonTextMap[step];
};
var getAvailableSteps = function(items) {
    var isShippingRequired = checkIfShippingRequiredForProducts(items);
    var stepsWithViews = CHECKOUT_STEPS.filter(function(param) {
        var withoutOwnView = param.withoutOwnView;
        return !withoutOwnView;
    });
    return isShippingRequired ? stepsWithViews : stepsWithViews.filter(function(param) {
        var onlyIfShippingRequired = param.onlyIfShippingRequired;
        return !onlyIfShippingRequired;
    });
};
var getCurrentStep = function(pathname, steps) {
    var activeStepIndex = function() {
        var matchingStepIndex = steps.findIndex(function(param) {
            var link = param.link;
            return link === pathname;
        });
        // return matchingStepIndex !== -1 ? matchingStepIndex : steps.length - 1;
        return matchingStepIndex !== -1 ? matchingStepIndex : 0;
    }();
    var activeStep = steps[activeStepIndex];
    return {
        activeStepIndex: activeStepIndex,
        activeStep: activeStep
    };
};
var stepSubmitSuccessHandler = function(push, steps, activeStepIndex) {
    return function(currentStep, data) {
        if (currentStep === CheckoutStep.Payment) {
            push({
                pathname: paths.orderFinalized,
                query: data
            }, /**
         * Passing orderFinalized path as an `as` param makes query data hidden and
         * behaves simillar to history push state.
         */ paths.orderFinalized);
        } else {
            push(steps[activeStepIndex + 1].link);
        }
    };
};


/***/ }),

/***/ 62823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tn": function() { return /* binding */ decodeKey; },
  "HI": function() { return /* binding */ generateKey; },
  "Gn": function() { return /* binding */ generatePath; },
  "lV": function() { return /* binding */ slugify; }
});

// UNUSED EXPORTS: generateCategoryUrl, generateCollectionUrl, generateGuestOrderDetailsUrl, generatePageUrl, invariant

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./node_modules/js-base64/base64.mjs
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */
const version = '3.7.5';
/**
 * @deprecated use lowercase `version`.
 */
const VERSION = version;
const _hasatob = typeof atob === 'function';
const _hasbtoa = typeof btoa === 'function';
const _hasBuffer = typeof Buffer === 'function';
const _TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
const _TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
const b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const b64chs = Array.prototype.slice.call(b64ch);
const b64tab = ((a) => {
    let tab = {};
    a.forEach((c, i) => tab[c] = i);
    return tab;
})(b64chs);
const b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const _fromCC = String.fromCharCode.bind(String);
const _U8Afrom = typeof Uint8Array.from === 'function'
    ? Uint8Array.from.bind(Uint8Array)
    : (it) => new Uint8Array(Array.prototype.slice.call(it, 0));
const _mkUriSafe = (src) => src
    .replace(/=/g, '').replace(/[+\/]/g, (m0) => m0 == '+' ? '-' : '_');
const _tidyB64 = (s) => s.replace(/[^A-Za-z0-9\+\/]/g, '');
/**
 * polyfill version of `btoa`
 */
const btoaPolyfill = (bin) => {
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = '';
    const pad = bin.length % 3;
    for (let i = 0; i < bin.length;) {
        if ((c0 = bin.charCodeAt(i++)) > 255 ||
            (c1 = bin.charCodeAt(i++)) > 255 ||
            (c2 = bin.charCodeAt(i++)) > 255)
            throw new TypeError('invalid character found');
        u32 = (c0 << 16) | (c1 << 8) | c2;
        asc += b64chs[u32 >> 18 & 63]
            + b64chs[u32 >> 12 & 63]
            + b64chs[u32 >> 6 & 63]
            + b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */
const _btoa = _hasbtoa ? (bin) => btoa(bin)
    : _hasBuffer ? (bin) => Buffer.from(bin, 'binary').toString('base64')
        : btoaPolyfill;
const _fromUint8Array = _hasBuffer
    ? (u8a) => Buffer.from(u8a).toString('base64')
    : (u8a) => {
        // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
        const maxargs = 0x1000;
        let strs = [];
        for (let i = 0, l = u8a.length; i < l; i += maxargs) {
            strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
        }
        return _btoa(strs.join(''));
    };
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */
const fromUint8Array = (u8a, urlsafe = false) => urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const cb_utob = (c) => {
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c
            : cc < 0x800 ? (_fromCC(0xc0 | (cc >>> 6))
                + _fromCC(0x80 | (cc & 0x3f)))
                : (_fromCC(0xe0 | ((cc >>> 12) & 0x0f))
                    + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
                    + _fromCC(0x80 | (cc & 0x3f)));
    }
    else {
        var cc = 0x10000
            + (c.charCodeAt(0) - 0xD800) * 0x400
            + (c.charCodeAt(1) - 0xDC00);
        return (_fromCC(0xf0 | ((cc >>> 18) & 0x07))
            + _fromCC(0x80 | ((cc >>> 12) & 0x3f))
            + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
            + _fromCC(0x80 | (cc & 0x3f)));
    }
};
const re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */
const utob = (u) => u.replace(re_utob, cb_utob);
//
const _encode = _hasBuffer
    ? (s) => Buffer.from(s, 'utf8').toString('base64')
    : _TE
        ? (s) => _fromUint8Array(_TE.encode(s))
        : (s) => _btoa(utob(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */
const encode = (src, urlsafe = false) => urlsafe
    ? _mkUriSafe(_encode(src))
    : _encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */
const base64_encodeURI = (src) => encode(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const cb_btou = (cccc) => {
    switch (cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                | ((0x3f & cccc.charCodeAt(1)) << 12)
                | ((0x3f & cccc.charCodeAt(2)) << 6)
                | (0x3f & cccc.charCodeAt(3)), offset = cp - 0x10000;
            return (_fromCC((offset >>> 10) + 0xD800)
                + _fromCC((offset & 0x3FF) + 0xDC00));
        case 3:
            return _fromCC(((0x0f & cccc.charCodeAt(0)) << 12)
                | ((0x3f & cccc.charCodeAt(1)) << 6)
                | (0x3f & cccc.charCodeAt(2)));
        default:
            return _fromCC(((0x1f & cccc.charCodeAt(0)) << 6)
                | (0x3f & cccc.charCodeAt(1)));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */
const btou = (b) => b.replace(re_btou, cb_btou);
/**
 * polyfill version of `atob`
 */
const atobPolyfill = (asc) => {
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!b64re.test(asc))
        throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    let u24, bin = '', r1, r2;
    for (let i = 0; i < asc.length;) {
        u24 = b64tab[asc.charAt(i++)] << 18
            | b64tab[asc.charAt(i++)] << 12
            | (r1 = b64tab[asc.charAt(i++)]) << 6
            | (r2 = b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? _fromCC(u24 >> 16 & 255)
            : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255)
                : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */
const _atob = _hasatob ? (asc) => atob(_tidyB64(asc))
    : _hasBuffer ? (asc) => Buffer.from(asc, 'base64').toString('binary')
        : atobPolyfill;
//
const _toUint8Array = _hasBuffer
    ? (a) => _U8Afrom(Buffer.from(a, 'base64'))
    : (a) => _U8Afrom(_atob(a).split('').map(c => c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */
const toUint8Array = (a) => _toUint8Array(_unURI(a));
//
const _decode = _hasBuffer
    ? (a) => Buffer.from(a, 'base64').toString('utf8')
    : _TD
        ? (a) => _TD.decode(_toUint8Array(a))
        : (a) => btou(_atob(a));
const _unURI = (a) => _tidyB64(a.replace(/[-_]/g, (m0) => m0 == '-' ? '+' : '/'));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */
const decode = (src) => _decode(_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */
const isValid = (src) => {
    if (typeof src !== 'string')
        return false;
    const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const _noEnum = (v) => {
    return {
        value: v, enumerable: false, writable: true, configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */
const extendString = function () {
    const _add = (name, body) => Object.defineProperty(String.prototype, name, _noEnum(body));
    _add('fromBase64', function () { return decode(this); });
    _add('toBase64', function (urlsafe) { return encode(this, urlsafe); });
    _add('toBase64URI', function () { return encode(this, true); });
    _add('toBase64URL', function () { return encode(this, true); });
    _add('toUint8Array', function () { return toUint8Array(this); });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */
const extendUint8Array = function () {
    const _add = (name, body) => Object.defineProperty(Uint8Array.prototype, name, _noEnum(body));
    _add('toBase64', function (urlsafe) { return fromUint8Array(this, urlsafe); });
    _add('toBase64URI', function () { return fromUint8Array(this, true); });
    _add('toBase64URL', function () { return fromUint8Array(this, true); });
};
/**
 * extend Builtin prototypes with relevant methods
 */
const extendBuiltins = () => {
    extendString();
    extendUint8Array();
};
const gBase64 = {
    version: version,
    VERSION: VERSION,
    atob: _atob,
    atobPolyfill: atobPolyfill,
    btoa: _btoa,
    btoaPolyfill: btoaPolyfill,
    fromBase64: decode,
    toBase64: encode,
    encode: encode,
    encodeURI: base64_encodeURI,
    encodeURL: base64_encodeURI,
    utob: utob,
    btou: btou,
    decode: decode,
    isValid: isValid,
    fromUint8Array: fromUint8Array,
    toUint8Array: toUint8Array,
    extendString: extendString,
    extendUint8Array: extendUint8Array,
    extendBuiltins: extendBuiltins,
};
// makecjs:CUT //




















// and finally,


;// CONCATENATED MODULE: ./src/@next/utils/core.ts
// Rework this functionality once slugs are in use
/* eslint-disable @typescript-eslint/ban-ts-comment, no-useless-escape */ /* @ts-ignore */ 

var slugify = function(text) {
    return text.toString().toLowerCase().trim().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-");
}; // Replace multiple - with single -
var decodeKey = function(graphqlId, schema) {
    // This is temporary solution, we will use slugs in the future
    var rawId = gBase64.decode(graphqlId);
    var regexp = /(\w+):(\d+)/;
    var ref = (0,_sliced_to_array/* default */.Z)(regexp.exec(rawId), 3), expectedSchema = ref[1], id = ref[2];
    if (schema && schema !== expectedSchema) {
        throw new Error("Schema is not correct");
    }
    return id;
};
var generateKey = function(id, schema) {
    return(// This is temporary solution, we will use slugs in the future
    gBase64.encode("".concat(schema, ":").concat(id)));
};
var generateCategoryUrl = function(id, name) {
    return "/category/".concat(slugify(name), "/").concat(generateKey(id, "Category"), "/");
};
var generateCollectionUrl = function(id, name) {
    return "/collection/".concat(slugify(name), "/").concat(generateKey(id, "Collection"), "/");
};
var generatePageUrl = function(slug) {
    return "/page/".concat(slug, "/");
};
var generateGuestOrderDetailsUrl = function(token) {
    return "/order-history/".concat(token, "/");
};
function invariant(cond, message) {
    if (!cond) throw new Error(message);
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/generate-path
 */ function generatePath(path) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return path.replace(/\[(\w+)\]/g, function(_, key) {
        invariant(params[key] != null, 'Missing "'.concat(key, '" param'));
        return params[key];
    }).replace(/\/*\*$/, function(_) {
        return params["*"] == null ? "" : params["*"].replace(/^\/*/, "/");
    });
}


/***/ }),

/***/ 29521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ NON_FIELD_ERROR; },
/* harmony export */   "g": function() { return /* binding */ groupErrorsByFields; }
/* harmony export */ });
var NON_FIELD_ERROR = "nonFieldError";
function groupErrorsByFields(errors) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return errors.reduce(function(o, error) {
        var key = error.field && keys.includes(error.field) ? error.field : NON_FIELD_ERROR;
        (o[key] = o[key] || []).push(error);
        return o;
    }, {});
}


/***/ }),

/***/ 96896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ filterNotEmptyArrayItems; },
/* harmony export */   "rh": function() { return /* binding */ convertToAttributeScalar; },
/* harmony export */   "wY": function() { return /* binding */ maybe; }
/* harmony export */ });
/* unused harmony exports getValueOrEmpty, removeEmptyProps */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);


function maybe(exp, d) {
    try {
        var result = exp();
        return result === undefined ? d : result;
    } catch (e) {
        return d;
    }
}
var convertToAttributeScalar = function(attributes) {
    return Object.entries(attributes).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return value.map(function(attribute) {
            return {
                slug: key,
                value: attribute
            };
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(curr));
    }, []);
};
function filterNotEmptyArrayItems(value) {
    return value !== null && value !== undefined;
}
var getValueOrEmpty = function(value) {
    return value === undefined || value === null ? "" : value;
};
var removeEmptyProps = function(obj) {
    var newObj = {};
    Object.keys(obj).forEach(function(prop) {
        if (obj[prop] && obj[prop] !== "") {
            newObj[prop] = obj[prop];
        }
    });
    return newObj;
};


/***/ }),

/***/ 8044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lE": function() { return /* binding */ LOCALES; },
  "j3": function() { return /* binding */ localeToFlag; },
  "Ux": function() { return /* binding */ localeToPrismicQuery; },
  "KK": function() { return /* binding */ localeToSaleorQuery; }
});

// UNUSED EXPORTS: localeToEnum, localeToPrismic, prismicToLocale

;// CONCATENATED MODULE: ./src/images/languages/frIcon.svg
var frIcon_namespaceObject = __webpack_require__.p + "static/images/frIcon.svg";
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/@next/utils/regions.ts
// import deIcon from '../../images/languages/deIcon.svg';
// import enIcon from '../../images/languages/enIcon.svg';
// import plIcon from '../../images/languages/plIcon.svg';
// import daIcon from '../../images/languages/daIcon.svg';
// import svIcon from '../../images/languages/svIcon.svg';
// import noIcon from '../../images/languages/noIcon.svg';
// import itIcon from '../../images/languages/itIcon.svg';
// import esIcon from '../../images/languages/esIcon.svg';

// import nlIcon from '../../images/languages/nlIcon.svg';

var LOCALES = [
    /* {
    slug: 'en',
    code: 'EN' as LanguageCodeEnum,
    cms: 'en-us',
    icon: enIcon,
    name: 'English',
  },
  {
    slug: 'de',
    code: 'DE' as LanguageCodeEnum,
    cms: 'de-de',
    icon: deIcon,
    name: 'Deutsch',
  },
  {
    slug: 'pl',
    code: 'PL' as LanguageCodeEnum,
    cms: 'pl',
    icon: plIcon,
    name: 'Polski',
  }, */ {
        slug: "fr",
        code: "FR",
        cms: "fr-fr",
        icon: frIcon_namespaceObject,
        name: "Francais"
    }
];
var localeToEnum = function(localeSlug) {
    var ref, ref1;
    var chosenLocale = (ref = LOCALES.find(function(param) {
        var slug = param.slug;
        return slug === localeSlug;
    })) === null || ref === void 0 ? void 0 : ref.code;
    if (chosenLocale) {
        return chosenLocale;
    }
    return ((ref1 = LOCALES.find(function(param) {
        var slug = param.slug;
        return slug === constants/* defaultLocale */.al;
    })) === null || ref1 === void 0 ? void 0 : ref1.code) || "FR";
};
var localeToPrismic = function(localeSlug) {
    var ref, ref1;
    var chosenLocale = (ref = LOCALES.find(function(param) {
        var slug = param.slug;
        return slug === localeSlug;
    })) === null || ref === void 0 ? void 0 : ref.cms;
    if (chosenLocale) {
        return chosenLocale;
    }
    return ((ref1 = LOCALES.find(function(param) {
        var slug = param.slug;
        return slug === constants/* defaultLocale */.al;
    })) === null || ref1 === void 0 ? void 0 : ref1.slug) || "fr-fr";
};
var localeToFlag = function(localeSlug) {
    var ref, ref1;
    var chosenLocale = (ref = LOCALES.find(function(param) {
        var slug = param.slug;
        return slug === localeSlug;
    })) === null || ref === void 0 ? void 0 : ref.icon;
    if (chosenLocale) {
        return chosenLocale;
    }
    return ((ref1 = LOCALES.find(function(param) {
        var slug = param.slug;
        return slug === constants/* defaultLocale */.al;
    })) === null || ref1 === void 0 ? void 0 : ref1.icon) || frIcon_namespaceObject;
};
var prismicToLocale = function(localeSlug) {
    var ref;
    var chosenLocale = (ref = LOCALES.find(function(param) {
        var cms = param.cms;
        return cms === localeSlug;
    })) === null || ref === void 0 ? void 0 : ref.slug;
    if (chosenLocale) {
        return chosenLocale;
    }
    return "fr";
};
var localeToSaleorQuery = function(localeSlug) {
    return {
        languageCode: localeToEnum(localeSlug || constants/* defaultLocale */.al)
    };
};
var localeToPrismicQuery = function(localeSlug) {
    return {
        lang: localeToPrismic(localeSlug || constants/* defaultLocale */.al)
    };
};


/***/ }),

/***/ 71454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getBackgroundColor; },
/* harmony export */   "z": function() { return /* binding */ getContentWindowHeight; }
/* harmony export */ });
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73935);
/* eslint-disable react/no-find-dom-node */ 
var getContentWindowHeight = function() {
    var headerRef = document.getElementById("header");
    var footerRef = document.getElementById("footer");
    var headerHeight = headerRef ? headerRef.offsetHeight : 0;
    var footerHeight = footerRef ? footerRef.offsetHeight : 0;
    return window.innerHeight - headerHeight - footerHeight;
};
var DEFAULT_BACKGROUND_COLOR = "#fff";
/**
 * Get the element background color.
 * If no background color is provided then the default is rgba(0, 0, 0, 0)
 * in this case the default color to cover is white (#fff)
 * @param ref Reference to the element to check.
 */ var getBackgroundColor = function(ref) {
    var el = react_dom__WEBPACK_IMPORTED_MODULE_0__.findDOMNode(ref);
    if (el && el.parentElement) {
        if (el.nodeName === "BODY") {
            return DEFAULT_BACKGROUND_COLOR;
        }
        var bgColor = window.getComputedStyle(el.parentElement, null).backgroundColor;
        if (bgColor && bgColor !== "rgba(0, 0, 0, 0)") {
            return bgColor;
        }
        return getBackgroundColor(el.parentElement);
    }
    return DEFAULT_BACKGROUND_COLOR;
};


/***/ }),

/***/ 69665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ translate; }
/* harmony export */ });
function translate(obj, key) {
    var ref;
    // TODO: better types
    // @ts-ignore
    return ((ref = obj.translation) === null || ref === void 0 ? void 0 : ref[key]) || obj[key];
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (translate)));


/***/ }),

/***/ 5946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ maybe; }
/* harmony export */ });
var maybe = function(exp, d) {
    try {
        var result = exp();
        return result === undefined ? d : result;
    } catch (e) {
        return d;
    }
};


/***/ }),

/***/ 47233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ usePrismicLayout; },
/* harmony export */   "U": function() { return /* binding */ PrismicLayoutContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var PrismicLayoutContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    layout: null
});
var usePrismicLayout = function() {
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PrismicLayoutContext);
    if (!result) {
        throw new Error("Context used outside of its Provider!");
    }
    return result;
};


/***/ }),

/***/ 41490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Epv": function() { return /* binding */ usePrismicWishlistPageQuery; },
/* harmony export */   "JWf": function() { return /* binding */ usePrismicLayoutQuery; },
/* harmony export */   "p7S": function() { return /* binding */ usePrismicProductPageQuery; },
/* harmony export */   "yqh": function() { return /* binding */ usePrismicProductImagesQueryLazyQuery; }
/* harmony export */ });
/* unused harmony exports ArchitectBodyArchitectReviewsFragmentDoc, ArchitectBodyBenefitsProgramFragmentDoc, ExternalLinkFragmentDoc, DocumentLinkFragmentDoc, FileLinkFragmentDoc, LinkableFragmentDoc, ArchitectBodyConsultToolboxFragmentDoc, ArchitectBodyFranchiseContactFragmentDoc, ArchitectBodyInspirationFragmentDoc, ArchitectBodyInstagramPostsFragmentDoc, ArchitectBodyShowroomFragmentDoc, MetaBaseFragmentDoc, BlogHomeIconBannerFragmentDoc, BlogHomeBodyFragmentDoc, BlogPostBodyAccordeonFragmentDoc, BlogPostBodyContentPhotoPhotoFragmentDoc, BlogPostBodyContentPhotoPhoto_50FragmentDoc, BlogPostBodyContentPhotoTextFragmentDoc, BlogPostBodyContentPhotoText_30_60FragmentDoc, BlogPostBodyContentTextPhoto_60_30FragmentDoc, BlogPostBodyContentTextText_50FragmentDoc, BlogPostBodyDownloadFilesFragmentDoc, BlogPostBodyExcerptFragmentDoc, BlogPostBodyFormEmbdedFragmentDoc, BlogPostBodyHeroImgFragmentDoc, BlogPostBodyHtmlEmbdedFragmentDoc, BlogPostBodyIconBannerFragmentDoc, BlogPostBodyIconCtaFragmentDoc, BlogPostBodyImageCardFragmentDoc, BlogPostBodyImageCtaFragmentDoc, BlogPostBodyLinkButtonFragmentDoc, BlogPostBodyMediaSliderFragmentDoc, BlogPostBodyOurPartnersFragmentDoc, BlogPostBodyQuoteFragmentDoc, BlogPostBodyRelatedProductsFragmentDoc, BlogPostBodyRichtextFragmentDoc, BlogPostBodyTagImageFragmentDoc, BlogPostCardFragmentDoc, MetaDetailsFragmentDoc, BlogPostTagFragmentDoc, BlogPostFragmentDoc, CategoryHeaderFragmentDoc, CategoryBannerFragmentDoc, CategoryFragmentDoc, ContactsFragmentDoc, HomepageBodyBenefitsFragmentDoc, CategorySliceFragmentDoc, HomepageBodyCollectionsFragmentDoc, HomepageBodyCtaFragmentDoc, HomepageBodyImageCardFragmentDoc, HomepageBodyImageCtaFragmentDoc, HomepageBodyInspirationFragmentDoc, HomepageBodyInstagramPostsFragmentDoc, HomepageBodyLinkButtonFragmentDoc, HomepageBodyReviewsFragmentDoc, HomepageBodyTrustedFragmentDoc, InstagramPostsFragmentDoc, InstagramFragmentDoc, LayoutHeaderNaviguationFragmentDoc, LayoutFooterSocialFragmentDoc, LayoutContactFragmentDoc, LayoutFooterNaviguationFragmentDoc, LayoutModalFragmentDoc, LayoutFragmentDoc, PageBodyAccordionFragmentDoc, PageBodyContentPhotoText_30_60FragmentDoc, PageBodyContentTextPhoto_60_30FragmentDoc, PageBodyContentTextText_50FragmentDoc, PageBodyContentPhotoPhotoFragmentDoc, PageBodyContentPhotoPhoto_50FragmentDoc, PageBodyContentPhotoTextFragmentDoc, PageBodyDownloadFilesFragmentDoc, PageBodyExcerptFragmentDoc, PageBodyFormEmbdedFragmentDoc, PageBodyHeroImgFragmentDoc, PageBodyHtmlEmbdedFragmentDoc, PageBodyIconBannerFragmentDoc, PageBodyIconCtaFragmentDoc, PageBodyImageCardFragmentDoc, PageBodyImageCtaFragmentDoc, PageBodyLinkButtonFragmentDoc, PageBodyMediaSliderFragmentDoc, PageBodyOurPartnersFragmentDoc, PageBodyQuoteFragmentDoc, PageBodyRelatedProductsFragmentDoc, PageBodyRichtextFragmentDoc, PageBodyTagImageFragmentDoc, PageLinkBlogPostFragmentDoc, PageLinkPageFragmentDoc, ProjectCategoryFragmentDoc, ProjectCategoryListFragmentDoc, ProjectTagFragmentDoc, PageLinkProjectFragmentDoc, ProductAttributesBodyTabsFragmentDoc, ProductAttributesFragmentDoc, ProductBodyLabeledIconsFragmentDoc, ProductBodyInspirationFragmentDoc, ProductBodyProductFeaturesFragmentDoc, ProductBodyProductDetailsFragmentDoc, ProductBodyColorSampleFragmentDoc, ProductBodyInstagramPostsFragmentDoc, ProductBodyFragmentDoc, ProductMediaFragmentDoc, ProjectBodyRelatedProductsFragmentDoc, ProjectBodyLinkedProductsFragmentDoc, ProjectCardFragmentDoc, ProjectMediaFragmentDoc, ProjectColorFragmentDoc, ProjectWidthFragmentDoc, ProjectDetailsFragmentDoc, WishlistBodyColorSampleFragmentDoc, PrismicAllBlogPostsQueryDocument, usePrismicAllBlogPostsQuery, usePrismicAllBlogPostsQueryLazyQuery, PrismicAllProjectsQueryDocument, usePrismicAllProjectsQuery, usePrismicAllProjectsQueryLazyQuery, PrismicArchitectQueryDocument, usePrismicArchitectQuery, usePrismicArchitectQueryLazyQuery, PrismicBlogPageQueryDocument, usePrismicBlogPageQuery, usePrismicBlogPageQueryLazyQuery, PrismicBlogPathsDocument, usePrismicBlogPathsQuery, usePrismicBlogPathsLazyQuery, PrismicCategoryQueryDocument, usePrismicCategoryQuery, usePrismicCategoryQueryLazyQuery, PrismicContactsQueryDocument, usePrismicContactsQuery, usePrismicContactsQueryLazyQuery, PrismicDefaultSeoQueryDocument, usePrismicDefaultSeoQuery, usePrismicDefaultSeoQueryLazyQuery, PrismicHomePageQueryDocument, usePrismicHomePageQuery, usePrismicHomePageQueryLazyQuery, PrismicLayoutQueryDocument, usePrismicLayoutQueryLazyQuery, PrismicPagePathsDocument, usePrismicPagePathsQuery, usePrismicPagePathsLazyQuery, PrismicPageQueryDocument, usePrismicPageQuery, usePrismicPageQueryLazyQuery, PrismicProductImagesQueryDocument, usePrismicProductImagesQuery, PrismicProductPageQueryDocument, usePrismicProductPageQueryLazyQuery, PrismicProductQueryDocument, usePrismicProductQuery, usePrismicProductQueryLazyQuery, PrismicProjectFilterQueryDocument, usePrismicProjectFilterQuery, usePrismicProjectFilterQueryLazyQuery, PrismicProjectPathsDocument, usePrismicProjectPathsQuery, usePrismicProjectPathsLazyQuery, PrismicProjectQueryDocument, usePrismicProjectQuery, usePrismicProjectQueryLazyQuery, PrismicRealisationQueryDocument, usePrismicRealisationQuery, usePrismicRealisationQueryLazyQuery, PrismicReviewsQueryDocument, usePrismicReviewsQuery, usePrismicReviewsQueryLazyQuery, PrismicWishlistPageQueryDocument, usePrismicWishlistPageQueryLazyQuery */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22865);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37887);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73359);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_regions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8044);
/* harmony import */ var _prismic_prismic_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93092);
/* tslint:disable */ /* eslint-disable */ /* THIS FILE IS GENERATED WITH `npm run codegen-prismic` */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ArchitectBodyArchitectReviewsFragment on ArchitectBodyArchitectreviews {\n  type\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ArchitectBodyBenefitsProgramFragment on ArchitectBodyBenefitsprogram {\n  type\n  primary {\n    title\n    btn_text\n  }\n  fields {\n    title\n    description\n    image\n  }\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ExternalLinkFragment on _ExternalLink {\n  _linkType\n  __typename\n  url\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment DocumentLinkFragment on _Document {\n  __typename\n  _meta {\n    type\n    id\n    uid\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment FileLinkFragment on _FileLink {\n  name\n  url\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment LinkableFragment on _Linkable {\n  ...ExternalLinkFragment\n  ...DocumentLinkFragment\n  ...FileLinkFragment\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ArchitectBodyConsultToolboxFragment on ArchitectBodyConsulttoolbox {\n  type\n  primary {\n    title\n    description\n  }\n  fields {\n    title1\n    icon\n    link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ArchitectBodyFranchiseContactFragment on ArchitectBodyFranchisecontact {\n  type\n  fields {\n    title\n    btn_text\n  }\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ArchitectBodyInspirationFragment on ArchitectBodyInspiration {\n  type\n  label\n  fields {\n    image\n  }\n}\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ArchitectBodyInstagramPostsFragment on ArchitectBodyInstagram_posts {\n  type\n  label\n  primary {\n    htitle: title_2\n    user_name\n    text\n  }\n  fields {\n    instagram_link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ArchitectBodyShowroomFragment on ArchitectBodyShowroom {\n  type\n  primary {\n    title\n    list_title\n    partner_list_title\n  }\n  fields {\n    location\n    name\n    address\n    web\n    is_partner\n  }\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment MetaBaseFragment on Meta {\n  id\n  uid\n  type\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogHomeIconBannerFragment on Blog_homeBody1Iconbanner {\n  label\n  type\n  primary {\n    title\n  }\n  fields {\n    img\n    title\n    link {\n      _linkType\n      ... on Page {\n        _meta {\n          ...MetaBaseFragment\n        }\n      }\n      ... on Blog_post {\n        _meta {\n          ...MetaBaseFragment\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogHomeBodyFragment on Blog_homeBody1 {\n  __typename\n  ... on Blog_homeBody1Iconbanner {\n    label\n    type\n    primary {\n      title\n    }\n    fields {\n      img\n      title\n      link {\n        _linkType\n        ... on Page {\n          _meta {\n            ...MetaBaseFragment\n          }\n        }\n        ... on Blog_post {\n          _meta {\n            ...MetaBaseFragment\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyAccordeonFragment on Blog_postBodyAccordeon {\n  type\n  fields {\n    title\n    rich_text\n  }\n}\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyContentPhotoPhotoFragment on Blog_postBodyContent_photo_photo {\n  type\n  fields {\n    content_photo\n    photo_link\n  }\n}\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyContentPhotoPhoto_50Fragment on Blog_postBodyContent_photo_photo_50 {\n  type\n  fields {\n    content_photo_left\n    content_photo_right\n    photo_left_link\n    photo_right_link\n  }\n}\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyContentPhotoTextFragment on Blog_postBodyContent_photo_text {\n  type\n  label\n  primary {\n    content_photo\n    content_text\n    photo_link\n  }\n}\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyContentPhotoText_30_60Fragment on Blog_postBodyContent_photo_text_30_60 {\n  type\n  fields {\n    content_photo\n    content_text\n    photo_link\n  }\n}\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyContentTextPhoto_60_30Fragment on Blog_postBodyContent_text_photo_60_30 {\n  type\n  fields {\n    content_photo\n    content_text\n    photo_link\n  }\n}\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyContentTextText_50Fragment on Blog_postBodyContent_text_text_50 {\n  type\n  fields {\n    content_text_left\n    content_text_right\n  }\n}\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyDownloadFilesFragment on Blog_postBodyDownloadfiles {\n  type\n  label\n  fields {\n    filelink {\n      ... on _ExternalLink {\n        url\n      }\n      ... on _FileLink {\n        url\n        size\n      }\n    }\n    filetitle\n    filedescription\n    filecategory\n  }\n}\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyExcerptFragment on Blog_postBodyExcerpt {\n  type\n  primary {\n    text\n  }\n}\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyFormEmbdedFragment on Blog_postBodyFormembded {\n  type\n  primary {\n    embded_link {\n      ... on _ExternalLink {\n        url\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyHeroImgFragment on Blog_postBodyHeroimg {\n  type\n  primary {\n    img\n    hero_image_link\n  }\n}\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyHtmlEmbdedFragment on Blog_postBodyHtmlembded {\n  type\n  primary {\n    html\n  }\n}\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyIconBannerFragment on Blog_postBodyIconbanner {\n  type\n  primary {\n    title\n  }\n  fields {\n    img\n    title\n    link {\n      _linkType\n      ... on Page {\n        _meta {\n          ...MetaBaseFragment\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyIconCtaFragment on Blog_postBodyIconcta {\n  type\n  fields {\n    title\n    link {\n      ... on _FileLink {\n        name\n        url\n      }\n    }\n    img\n  }\n}\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyImageCardFragment on Blog_postBodyImagecard {\n  type\n  label\n  primary {\n    header_title\n  }\n  fields {\n    card_image\n    card_title\n    card_content\n    card_btn_label\n    card_btn_link {\n      ...LinkableFragment\n    }\n    card_centered\n  }\n}\n    ",
        ""
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyImageCtaFragment on Blog_postBodyImagecta {\n  type\n  label\n  primary {\n    bgcolor\n    content_photo\n    content_text\n    button_link {\n      ...LinkableFragment\n    }\n    button_label\n  }\n}\n    ",
        ""
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyLinkButtonFragment on Blog_postBodyLinkbutton {\n  type\n  label\n  primary {\n    button_label\n    button_link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyMediaSliderFragment on Blog_postBodyMediaslider {\n  type\n  fields {\n    media_type\n    media {\n      ... on _FileLink {\n        name\n        url\n      }\n      ... on _ImageLink {\n        name\n        url\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyOurPartnersFragment on Blog_postBodyOurpartners {\n  type\n  label\n  primary {\n    ... on Blog_postBodyOurpartnersPrimary {\n      our_partners_title\n    }\n  }\n  fields {\n    ... on Blog_postBodyOurpartnersFields {\n      logo_image\n    }\n  }\n}\n    "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyQuoteFragment on Blog_postBodyQuote {\n  type\n  primary {\n    quote\n  }\n}\n    "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyRelatedProductsFragment on Blog_postBodyRelatedproducts {\n  type\n  primary {\n    slicetitle\n  }\n  fields {\n    productid\n  }\n}\n    "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyRichtextFragment on Blog_postBodyRichtext {\n  type\n  primary {\n    rich_text\n    classes\n  }\n}\n    "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostBodyTagImageFragment on Blog_postBodyTagimage {\n  type\n  primary {\n    subtitle\n  }\n  fields {\n    img\n    imgmobile\n    image_width\n    image_height\n    tag_image_link\n  }\n}\n    "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostCardFragment on Blog_post {\n  _linkType\n  title\n  preview_description\n  image\n  tags {\n    tag {\n      _linkType\n      ... on Tag {\n        _linkType\n        name\n      }\n    }\n  }\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment MetaDetailsFragment on Meta {\n  ...MetaBaseFragment\n  tags\n  lang\n  alternateLanguages {\n    id\n    uid\n    type\n    lang\n  }\n  firstPublicationDate\n  lastPublicationDate\n}\n    ",
        ""
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostTagFragment on Blog_postTags {\n  tag {\n    _linkType\n    ... on Tag {\n      _linkType\n      name\n    }\n  }\n}\n    "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BlogPostFragment on Blog_post {\n  title\n  image\n  preview_description\n  hide_for_blog_index_nav\n  meta_title\n  meta_description\n  canonical_url\n  isfeatured\n  _linkType\n  _meta {\n    ...MetaDetailsFragment\n  }\n  category {\n    _linkType\n    __typename\n    ... on Category {\n      name\n    }\n  }\n  tags {\n    ...BlogPostTagFragment\n  }\n  image\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment CategoryHeaderFragment on Category {\n  name\n  excerpt\n}\n    "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment CategoryBannerFragment on CategoryBanners {\n  image: banner_image\n  title: banner_title\n  color: banner_title_color\n  label: banner_label\n  link: banner_link {\n    ...LinkableFragment\n  }\n  offset: banner_offset\n  overlay: banner_overlay\n}\n    ",
        ""
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment CategoryFragment on Category {\n  ...CategoryHeaderFragment\n  banners {\n    ...CategoryBannerFragment\n  }\n  meta_title\n  meta_image\n  meta_description\n  _meta {\n    ...MetaDetailsFragment\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ContactsFragment on Contacts {\n  meta_title\n  meta_description\n  title\n  description\n  contacts_title\n  form_title\n  address_title\n  address\n  registration_details\n}\n    "
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyBenefitsFragment on HomepageBodyBenefits {\n  type\n  label\n  fields {\n    img_default\n    img_shade\n    img_hover\n    title\n    text\n    more_text\n  }\n}\n    "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment CategorySliceFragment on Category {\n  name\n  items {\n    item_image\n    item_title\n    item_text\n    item_link {\n      ...LinkableFragment\n    }\n  }\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyCollectionsFragment on HomepageBodyCollections {\n  type\n  label\n  primary {\n    title\n    link {\n      ...LinkableFragment\n    }\n  }\n  fields {\n    category {\n      ...CategorySliceFragment\n    }\n    title\n    text\n    image\n    link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyCtaFragment on HomepageBodyCta {\n  type\n  label\n  primary {\n    title\n    text\n    button_label\n    button_link {\n      ...LinkableFragment\n    }\n    video\n    image\n  }\n}\n    ",
        ""
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyImageCardFragment on HomepageBodyImagecard {\n  type\n  label\n  primary {\n    header_title\n  }\n  fields {\n    card_image\n    card_title\n    card_content\n    card_btn_label\n    card_btn_link {\n      ...LinkableFragment\n    }\n    card_centered\n  }\n}\n    ",
        ""
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyImageCtaFragment on HomepageBodyImagecta {\n  type\n  label\n  primary {\n    bgcolor\n    content_photo\n    content_text\n    button_link {\n      ...LinkableFragment\n    }\n    button_label\n  }\n}\n    ",
        ""
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyInspirationFragment on HomepageBodyInspiration {\n  type\n  label\n  fields {\n    image\n    link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyInstagramPostsFragment on HomepageBodyInstagram_posts {\n  type\n  label\n  primary {\n    htitle: title\n    user_name\n    text\n  }\n  fields {\n    instagram_link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyLinkButtonFragment on HomepageBodyLinkbutton {\n  type\n  label\n  primary {\n    button_label\n    button_link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyReviewsFragment on HomepageBodyReviews {\n  type\n}\n    "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment HomepageBodyTrustedFragment on HomepageBodyTrusted {\n  type\n  label\n  fields {\n    image\n    text\n  }\n}\n    "
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment InstagramPostsFragment on InstagramPosts {\n  image\n  user_avatar\n  post_title\n  post_user_name\n  instagram_link {\n    ...LinkableFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment InstagramFragment on Instagram {\n  title\n  user_name\n  text\n  posts {\n    ...InstagramPostsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment LayoutHeaderNaviguationFragment on LayoutHeader_navigationNav_item {\n  type\n  label\n  primary {\n    label\n    link {\n      ...LinkableFragment\n    }\n  }\n  fields {\n    label\n    image\n    link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment LayoutFooterSocialFragment on LayoutFooter_social {\n  footer_social_type\n  footer_social_link {\n    ...LinkableFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment LayoutContactFragment on LayoutContact {\n  type\n  link {\n    ...LinkableFragment\n  }\n  label\n  show_in_nav\n}\n    ",
        ""
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment LayoutFooterNaviguationFragment on LayoutFooter_navigationNav_group {\n  type\n  primary {\n    title\n  }\n  fields {\n    label\n    link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment LayoutModalFragment on LayoutModals {\n  id\n  title\n  text\n  content\n}\n    "
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment LayoutFragment on Layout {\n  header_message\n  header_navigation {\n    ...LayoutHeaderNaviguationFragment\n  }\n  header_navigation_all_types_image\n  footer_contact_title\n  footer_contact_text\n  footer_social {\n    ...LayoutFooterSocialFragment\n  }\n  footer_trust_box\n  footer_copyright\n  footer_terms\n  contact {\n    ...LayoutContactFragment\n  }\n  footer_navigation {\n    ...LayoutFooterNaviguationFragment\n  }\n  gdrp_text\n  region_title\n  region_description\n  regions {\n    region_title\n    flag\n    link {\n      ...LinkableFragment\n    }\n  }\n  modals {\n    ...LayoutModalFragment\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyAccordionFragment on PageBodyAccordion {\n  type\n  fields {\n    title\n    rich_text\n  }\n}\n    "
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyContentPhotoText_30_60Fragment on PageBodyContent_photo_text_30_60 {\n  type\n  fields {\n    content_photo\n    content_text\n    photo_link\n  }\n}\n    "
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyContentTextPhoto_60_30Fragment on PageBodyContent_text_photo_60_30 {\n  type\n  fields {\n    content_photo\n    content_text\n    photo_link\n  }\n}\n    "
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyContentTextText_50Fragment on PageBodyContent_text_text_50 {\n  type\n  fields {\n    content_text_left\n    content_text_right\n  }\n}\n    "
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyContentPhotoPhotoFragment on PageBodyContent_photo_photo {\n  type\n  fields {\n    content_photo\n    photo_link\n  }\n}\n    "
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyContentPhotoPhoto_50Fragment on PageBodyContent_photo_photo_50 {\n  type\n  fields {\n    content_photo_left\n    content_photo_right\n    photo_left_link\n    photo_right_link\n  }\n}\n    "
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyContentPhotoTextFragment on PageBodyContent_photo_text {\n  type\n  label\n  primary {\n    content_photo\n    content_text\n    photo_link\n  }\n}\n    "
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyDownloadFilesFragment on PageBodyDownloadfiles {\n  type\n  label\n  fields {\n    filelink {\n      ... on _ExternalLink {\n        url\n      }\n      ... on _FileLink {\n        url\n        size\n      }\n    }\n    filelogo\n    filetitle\n    filedescription\n    filecategory\n  }\n}\n    "
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyExcerptFragment on PageBodyExcerpt {\n  type\n  primary {\n    text\n  }\n}\n    "
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyFormEmbdedFragment on PageBodyFormembded {\n  type\n  primary {\n    embded_link {\n      ... on _ExternalLink {\n        url\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyHeroImgFragment on PageBodyHeroimg {\n  type\n  primary {\n    img\n  }\n}\n    "
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyHtmlEmbdedFragment on PageBodyHtmlembded {\n  type\n  primary {\n    html\n  }\n}\n    "
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyIconBannerFragment on PageBodyIconbanner {\n  type\n  primary {\n    title\n  }\n  fields {\n    img\n    title\n    link {\n      _linkType\n      ... on Page {\n        _meta {\n          ...MetaBaseFragment\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyIconCtaFragment on PageBodyIconcta {\n  type\n  fields {\n    title\n    link {\n      ...LinkableFragment\n    }\n    img\n  }\n}\n    ",
        ""
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyImageCardFragment on PageBodyImagecard {\n  type\n  label\n  primary {\n    header_title\n  }\n  fields {\n    card_image\n    card_title\n    card_content\n    card_btn_label\n    card_btn_link {\n      ...LinkableFragment\n    }\n    card_centered\n  }\n}\n    ",
        ""
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyImageCtaFragment on PageBodyImagecta {\n  type\n  label\n  primary {\n    bgcolor\n    content_photo\n    content_text\n    button_link {\n      ...LinkableFragment\n    }\n    button_label\n  }\n}\n    ",
        ""
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyLinkButtonFragment on PageBodyLinkbutton {\n  type\n  label\n  primary {\n    button_label\n    button_link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyMediaSliderFragment on PageBodyMediaslider {\n  type\n  fields {\n    media_type\n    media {\n      ... on _FileLink {\n        name\n        url\n      }\n      ... on _ImageLink {\n        name\n        url\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyOurPartnersFragment on PageBodyOurpartners {\n  label\n  type\n  primary {\n    our_partners_title\n  }\n  fields {\n    logo_image\n  }\n}\n    "
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyQuoteFragment on PageBodyQuote {\n  type\n  primary {\n    quote\n  }\n}\n    "
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyRelatedProductsFragment on PageBodyRelatedproducts {\n  type\n  primary {\n    slicetitle\n  }\n  fields {\n    productid\n  }\n}\n    "
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyRichtextFragment on PageBodyRichtext {\n  type\n  primary {\n    rich_text\n    classes\n  }\n}\n    "
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageBodyTagImageFragment on PageBodyTagimage {\n  type\n  primary {\n    subtitle\n  }\n  fields {\n    img\n    imgmobile\n  }\n}\n    "
    ]);
    _templateObject86 = function _templateObject86() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageLinkBlogPostFragment on Blog_post {\n  image\n  title\n  tags {\n    tag {\n      ... on Tag {\n        name\n      }\n    }\n  }\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject87 = function _templateObject87() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageLinkPageFragment on Page {\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject88 = function _templateObject88() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectCategoryFragment on Projectcategory {\n  name\n  image\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject89 = function _templateObject89() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectCategoryListFragment on ProjectCategory_list {\n  category {\n    ...ProjectCategoryFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject90 = function _templateObject90() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectTagFragment on Projecttag {\n  name\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject91 = function _templateObject91() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment PageLinkProjectFragment on Project {\n  image\n  title\n  category_list {\n    ...ProjectCategoryListFragment\n  }\n  tag_list {\n    ... on ProjectTag_list {\n      tag_item {\n        ...ProjectTagFragment\n      }\n    }\n  }\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject92 = function _templateObject92() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductAttributesBodyTabsFragment on ProductattributesBodyTabs {\n  primary {\n    tab_title\n    tab_message\n  }\n  fields {\n    tab_image\n    tab_name\n    tab_icon\n    tab_content\n    tab_footer\n  }\n}\n    "
    ]);
    _templateObject93 = function _templateObject93() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductAttributesFragment on Productattributes {\n  title\n  message\n  header\n  body {\n    ...ProductAttributesBodyTabsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject94 = function _templateObject94() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductBodyLabeledIconsFragment on ProductBodyLabeled_icons {\n  type\n  label\n  fields {\n    icon\n    label\n    type\n  }\n}\n    "
    ]);
    _templateObject95 = function _templateObject95() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductBodyInspirationFragment on ProductBodyInspiration {\n  type\n  label\n  fields {\n    image\n  }\n}\n    "
    ]);
    _templateObject96 = function _templateObject96() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductBodyProductFeaturesFragment on ProductBodyProduct_features {\n  type\n  label\n  primary {\n    title\n    icon\n    subtitle\n    text\n  }\n  fields {\n    image\n    video\n    sub_title\n    text\n  }\n}\n    "
    ]);
    _templateObject97 = function _templateObject97() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductBodyProductDetailsFragment on ProductBodyProduct_details {\n  type\n  label\n  primary {\n    title\n  }\n  fields {\n    title\n    subtitle\n    rich_text\n    rich_text_2\n  }\n}\n    "
    ]);
    _templateObject98 = function _templateObject98() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductBodyColorSampleFragment on ProductBodyColor_sample {\n  type\n  label\n  primary {\n    title\n    text\n    cta_label\n    cta_link {\n      ...LinkableFragment\n    }\n  }\n  fields {\n    color\n  }\n}\n    ",
        ""
    ]);
    _templateObject99 = function _templateObject99() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductBodyInstagramPostsFragment on ProductBodyInstagram_posts {\n  type\n  label\n  primary {\n    htitle: title\n    user_name\n    text\n  }\n  fields {\n    instagram_link {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject100 = function _templateObject100() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductBodyFragment on ProductBody {\n  ...ProductBodyLabeledIconsFragment\n  ...ProductBodyInspirationFragment\n  ...ProductBodyProductFeaturesFragment\n  ...ProductBodyProductDetailsFragment\n  ...ProductBodyColorSampleFragment\n  ...ProductBodyInstagramPostsFragment\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject101 = function _templateObject101() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductMediaFragment on ProductMedia {\n  image\n  video\n}\n    "
    ]);
    _templateObject102 = function _templateObject102() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectBodyRelatedProductsFragment on ProjectBodyRelatedproducts {\n  type\n  primary {\n    slicetitle\n  }\n  fields {\n    productid\n  }\n}\n    "
    ]);
    _templateObject103 = function _templateObject103() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectBodyLinkedProductsFragment on ProjectBodyLinkedproducts {\n  type\n  primary {\n    slicetitle\n  }\n  fields {\n    productname\n    productprice\n    productimage\n    productcategory\n    productlink {\n      ...LinkableFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject104 = function _templateObject104() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectCardFragment on Project {\n  meta_title\n  meta_description\n  meta_image\n  title\n  description\n  image\n  sort_order\n  creation_date\n  category_list {\n    ...ProjectCategoryListFragment\n  }\n  tag_list {\n    ... on ProjectTag_list {\n      tag_item {\n        ...ProjectTagFragment\n      }\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject105 = function _templateObject105() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectMediaFragment on ProjectMedia {\n  image: image1\n  top\n  left\n  text\n  link {\n    ...LinkableFragment\n  }\n  video\n}\n    ",
        ""
    ]);
    _templateObject106 = function _templateObject106() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectColorFragment on Projectcolor {\n  name\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject107 = function _templateObject107() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectWidthFragment on Projectwidth {\n  width\n  _meta {\n    ...MetaBaseFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject108 = function _templateObject108() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProjectDetailsFragment on Project {\n  meta_title\n  meta_description\n  meta_image\n  title\n  description\n  handle_style\n  handle_color\n  height\n  glass_type\n  door_size\n  image\n  interior_designer_link\n  interior_designer_view_name\n  product_link\n  product_view_name\n  sort_order\n  creation_date\n  media {\n    ...ProjectMediaFragment\n  }\n  category_list {\n    ...ProjectCategoryListFragment\n  }\n  color {\n    ...ProjectColorFragment\n  }\n  width {\n    ...ProjectWidthFragment\n  }\n  tag_list {\n    ... on ProjectTag_list {\n      tag_item {\n        ...ProjectTagFragment\n      }\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject109 = function _templateObject109() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment WishlistBodyColorSampleFragment on WishlistBodyColor_sample {\n  type\n  label\n  primary {\n    title\n    text\n    cta_label\n    cta_link {\n      ...LinkableFragment\n    }\n  }\n  fields {\n    color\n  }\n}\n    ",
        ""
    ]);
    _templateObject110 = function _templateObject110() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicAllBlogPostsQuery($lang: String = "en-us") {\n  allBlog_posts(lang: $lang, sortBy: meta_firstPublicationDate_DESC) {\n    edges {\n      node {\n        ...BlogPostFragment\n      }\n    }\n    totalCount\n  }\n  allTags(lang: $lang) {\n    edges {\n      node {\n        name\n        _linkType\n      }\n    }\n  }\n  allBlog_homes(lang: $lang) {\n    edges {\n      node {\n        title\n        meta_title\n        meta_description\n        canonical_url\n        showitemsperpage\n        body1 {\n          __typename\n          ...BlogHomeIconBannerFragment\n        }\n      }\n    }\n  }\n}\n    ',
        "\n",
        ""
    ]);
    _templateObject111 = function _templateObject111() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicAllProjectsQuery($lang: String = "en-us") {\n  allProjects(lang: $lang, first: 1000, sortBy: sort_order_DESC) {\n    edges {\n      node {\n        ...ProjectCardFragment\n        _meta {\n          ...MetaBaseFragment\n        }\n      }\n    }\n  }\n}\n    ',
        "\n",
        ""
    ]);
    _templateObject112 = function _templateObject112() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicArchitectQuery($lang: String = "en-us") {\n  architect(uid: "architect", lang: $lang) {\n    meta_title\n    meta_description\n    meta_image\n    title\n    description\n    btn_text\n    body {\n      ...ArchitectBodyInspirationFragment\n      ...ArchitectBodyBenefitsProgramFragment\n      ...ArchitectBodyArchitectReviewsFragment\n      ...ArchitectBodyShowroomFragment\n      ...ArchitectBodyFranchiseContactFragment\n      ...ArchitectBodyConsultToolboxFragment\n      ...ArchitectBodyInstagramPostsFragment\n    }\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject113 = function _templateObject113() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicBlogPageQuery($uid: String!, $lang: String = "en-us") {\n  blog_post(uid: $uid, lang: $lang) {\n    title\n    meta_title\n    meta_description\n    meta_image\n    tags {\n      tag {\n        _linkType\n        ... on Tag {\n          _linkType\n          name\n        }\n      }\n    }\n    you_may_also_like {\n      link_to_post {\n        _linkType\n        ...BlogPostCardFragment\n      }\n    }\n    body {\n      ...BlogPostBodyIconBannerFragment\n      ...BlogPostBodyHeroImgFragment\n      ...BlogPostBodyExcerptFragment\n      ...BlogPostBodyRichtextFragment\n      ...BlogPostBodyTagImageFragment\n      ...BlogPostBodyQuoteFragment\n      ...BlogPostBodyMediaSliderFragment\n      ...BlogPostBodyIconCtaFragment\n      ...BlogPostBodyContentTextPhoto_60_30Fragment\n      ...BlogPostBodyContentPhotoText_30_60Fragment\n      ...BlogPostBodyContentTextText_50Fragment\n      ...BlogPostBodyContentPhotoPhoto_50Fragment\n      ...BlogPostBodyContentPhotoPhotoFragment\n      ...BlogPostBodyContentPhotoTextFragment\n      ...BlogPostBodyFormEmbdedFragment\n      ...BlogPostBodyAccordeonFragment\n      ...BlogPostBodyLinkButtonFragment\n      ...BlogPostBodyOurPartnersFragment\n      ...BlogPostBodyDownloadFilesFragment\n      ...BlogPostBodyHtmlEmbdedFragment\n      ...BlogPostBodyRelatedProductsFragment\n      ...BlogPostBodyImageCtaFragment\n      ...BlogPostBodyImageCardFragment\n    }\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject114 = function _templateObject114() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query prismicBlogPaths($lang: String) {\n  allBlog_posts(lang: $lang, sortBy: meta_firstPublicationDate_DESC) {\n    edges {\n      node {\n        _meta {\n          id\n          uid\n          lang\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject115 = function _templateObject115() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicCategoryQuery($uid: String!, $lang: String = "en-us") {\n  category(uid: $uid, lang: $lang) {\n    ...CategoryFragment\n  }\n}\n    ',
        ""
    ]);
    _templateObject116 = function _templateObject116() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicContactsQuery($lang: String = "en-us") {\n  contacts(uid: "contacts", lang: $lang) {\n    ...ContactsFragment\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        "\n",
        ""
    ]);
    _templateObject117 = function _templateObject117() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicDefaultSeoQuery($lang: String = "en-us") {\n  defaultseo(uid: "defaultseo", lang: $lang) {\n    site_name\n    title\n    description\n    image\n  }\n}\n    '
    ]);
    _templateObject118 = function _templateObject118() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicHomePageQuery($lang: String = "en-us") {\n  homepage(uid: "homepage", lang: $lang) {\n    hero {\n      image\n      banner_title\n      text\n      button_label\n      button_link {\n        ...LinkableFragment\n      }\n    }\n    body {\n      ...HomepageBodyTrustedFragment\n      ...HomepageBodyInspirationFragment\n      ...HomepageBodyBenefitsFragment\n      ...HomepageBodyCollectionsFragment\n      ...HomepageBodyReviewsFragment\n      ...HomepageBodyInstagramPostsFragment\n      ...HomepageBodyCtaFragment\n      ...HomepageBodyImageCtaFragment\n      ...HomepageBodyImageCardFragment\n      ...HomepageBodyLinkButtonFragment\n    }\n    meta_title\n    meta_description\n    meta_image\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject119 = function _templateObject119() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicLayoutQuery($lang: String = "en-us") {\n  layout(uid: "layout", lang: $lang) {\n    ...LayoutFragment\n  }\n}\n    ',
        ""
    ]);
    _templateObject120 = function _templateObject120() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query prismicPagePaths($lang: String) {\n  allPages(lang: $lang, first: 1000) {\n    edges {\n      node {\n        _meta {\n          id\n          uid\n          lang\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject121 = function _templateObject121() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicPageQuery($uid: String!, $lang: String = "en-us") {\n  page(uid: $uid, lang: $lang) {\n    showbreadcrumbs\n    body {\n      ...PageBodyIconBannerFragment\n      ...PageBodyHeroImgFragment\n      ...PageBodyExcerptFragment\n      ...PageBodyRichtextFragment\n      ...PageBodyTagImageFragment\n      ...PageBodyQuoteFragment\n      ...PageBodyMediaSliderFragment\n      ...PageBodyIconCtaFragment\n      ...PageBodyContentTextPhoto_60_30Fragment\n      ...PageBodyContentPhotoText_30_60Fragment\n      ...PageBodyContentTextText_50Fragment\n      ...PageBodyContentPhotoPhoto_50Fragment\n      ...PageBodyContentPhotoTextFragment\n      ...PageBodyContentPhotoPhotoFragment\n      ...PageBodyFormEmbdedFragment\n      ...PageBodyAccordionFragment\n      ...PageBodyLinkButtonFragment\n      ...PageBodyOurPartnersFragment\n      ...PageBodyDownloadFilesFragment\n      ...PageBodyHtmlEmbdedFragment\n      ...PageBodyRelatedProductsFragment\n      ...PageBodyImageCtaFragment\n      ...PageBodyImageCardFragment\n    }\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject122 = function _templateObject122() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicProductImagesQuery($productUids: [String!], $lang: String = "en-us") {\n  allProductimagess(uid_in: $productUids, lang: $lang) {\n    edges {\n      node {\n        images {\n          image\n        }\n        _meta {\n          ...MetaDetailsFragment\n        }\n      }\n    }\n  }\n}\n    ',
        ""
    ]);
    _templateObject123 = function _templateObject123() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicProductPageQuery($productUid: String!, $lang: String = "en-us") {\n  product(uid: $productUid, lang: $lang) {\n    attributes {\n      attribute_slug\n      attribute_content {\n        ...ProductAttributesFragment\n      }\n    }\n    media {\n      ...ProductMediaFragment\n    }\n    body {\n      ...ProductBodyFragment\n    }\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject124 = function _templateObject124() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicProductQuery($uid: String!, $lang: String = "en-us") {\n  product(uid: $uid, lang: $lang) {\n    body {\n      ...ProductBodyInspirationFragment\n    }\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        "\n",
        ""
    ]);
    _templateObject125 = function _templateObject125() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicProjectFilterQuery($lang: String = "en-us") {\n  allProjectcategorys(lang: $lang) {\n    edges {\n      node {\n        ...ProjectCategoryFragment\n      }\n    }\n  }\n  allProjecttags(lang: $lang) {\n    edges {\n      node {\n        ...ProjectTagFragment\n      }\n    }\n  }\n}\n    ',
        "\n",
        ""
    ]);
    _templateObject126 = function _templateObject126() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query prismicProjectPaths($lang: String) {\n  allProjects(lang: $lang, first: 1000, sortBy: sort_order_DESC) {\n    edges {\n      node {\n        _meta {\n          id\n          uid\n          lang\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject127 = function _templateObject127() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicProjectQuery($uid: String!, $lang: String = "en-us") {\n  project(uid: $uid, lang: $lang) {\n    ...ProjectDetailsFragment\n    _meta {\n      ...MetaDetailsFragment\n    }\n    body {\n      ...ProjectBodyRelatedProductsFragment\n      ...ProjectBodyLinkedProductsFragment\n    }\n  }\n}\n    ',
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject128 = function _templateObject128() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicRealisationQuery($lang: String = "en-us") {\n  realisation(uid: "realisation", lang: $lang) {\n    meta_title\n    meta_description\n    meta_image\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        ""
    ]);
    _templateObject129 = function _templateObject129() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicReviewsQuery($lang: String = "en-us") {\n  reviews(uid: "reviews", lang: $lang) {\n    meta_title\n    meta_description\n    meta_image\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        ""
    ]);
    _templateObject130 = function _templateObject130() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PrismicWishlistPageQuery($lang: String = "en-us") {\n  wishlist(uid: "wishlist", lang: $lang) {\n    body {\n      ...WishlistBodyColorSampleFragment\n    }\n    _meta {\n      ...MetaDetailsFragment\n    }\n  }\n}\n    ',
        "\n",
        ""
    ]);
    _templateObject131 = function _templateObject131() {
        return data;
    };
    return data;
}





var defaultOptions = {};
var ArchitectBodyArchitectReviewsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject());
var ArchitectBodyBenefitsProgramFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject1());
var ExternalLinkFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject2());
var DocumentLinkFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject3());
var FileLinkFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject4());
var LinkableFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject5(), ExternalLinkFragmentDoc, DocumentLinkFragmentDoc, FileLinkFragmentDoc);
var ArchitectBodyConsultToolboxFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject6(), LinkableFragmentDoc);
var ArchitectBodyFranchiseContactFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject7());
var ArchitectBodyInspirationFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject8());
var ArchitectBodyInstagramPostsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject9(), LinkableFragmentDoc);
var ArchitectBodyShowroomFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject10());
var MetaBaseFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject11());
var BlogHomeIconBannerFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject12(), MetaBaseFragmentDoc);
var BlogHomeBodyFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject13(), MetaBaseFragmentDoc);
var BlogPostBodyAccordeonFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject14());
var BlogPostBodyContentPhotoPhotoFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject15());
var BlogPostBodyContentPhotoPhoto_50FragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject16());
var BlogPostBodyContentPhotoTextFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject17());
var BlogPostBodyContentPhotoText_30_60FragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject18());
var BlogPostBodyContentTextPhoto_60_30FragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject19());
var BlogPostBodyContentTextText_50FragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject20());
var BlogPostBodyDownloadFilesFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject21());
var BlogPostBodyExcerptFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject22());
var BlogPostBodyFormEmbdedFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject23());
var BlogPostBodyHeroImgFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject24());
var BlogPostBodyHtmlEmbdedFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject25());
var BlogPostBodyIconBannerFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject26(), MetaBaseFragmentDoc);
var BlogPostBodyIconCtaFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject27());
var BlogPostBodyImageCardFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject28(), LinkableFragmentDoc);
var BlogPostBodyImageCtaFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject29(), LinkableFragmentDoc);
var BlogPostBodyLinkButtonFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject30(), LinkableFragmentDoc);
var BlogPostBodyMediaSliderFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject31());
var BlogPostBodyOurPartnersFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject32());
var BlogPostBodyQuoteFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject33());
var BlogPostBodyRelatedProductsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject34());
var BlogPostBodyRichtextFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject35());
var BlogPostBodyTagImageFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject36());
var BlogPostCardFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject37(), MetaBaseFragmentDoc);
var MetaDetailsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject38(), MetaBaseFragmentDoc);
var BlogPostTagFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject39());
var BlogPostFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject40(), MetaDetailsFragmentDoc, BlogPostTagFragmentDoc);
var CategoryHeaderFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject41());
var CategoryBannerFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject42(), LinkableFragmentDoc);
var CategoryFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject43(), CategoryHeaderFragmentDoc, CategoryBannerFragmentDoc, MetaDetailsFragmentDoc);
var ContactsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject44());
var HomepageBodyBenefitsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject45());
var CategorySliceFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject46(), LinkableFragmentDoc, MetaBaseFragmentDoc);
var HomepageBodyCollectionsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject47(), LinkableFragmentDoc, CategorySliceFragmentDoc);
var HomepageBodyCtaFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject48(), LinkableFragmentDoc);
var HomepageBodyImageCardFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject49(), LinkableFragmentDoc);
var HomepageBodyImageCtaFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject50(), LinkableFragmentDoc);
var HomepageBodyInspirationFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject51(), LinkableFragmentDoc);
var HomepageBodyInstagramPostsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject52(), LinkableFragmentDoc);
var HomepageBodyLinkButtonFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject53(), LinkableFragmentDoc);
var HomepageBodyReviewsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject54());
var HomepageBodyTrustedFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject55());
var InstagramPostsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject56(), LinkableFragmentDoc);
var InstagramFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject57(), InstagramPostsFragmentDoc);
var LayoutHeaderNaviguationFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject58(), LinkableFragmentDoc);
var LayoutFooterSocialFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject59(), LinkableFragmentDoc);
var LayoutContactFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject60(), LinkableFragmentDoc);
var LayoutFooterNaviguationFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject61(), LinkableFragmentDoc);
var LayoutModalFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject62());
var LayoutFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject63(), LayoutHeaderNaviguationFragmentDoc, LayoutFooterSocialFragmentDoc, LayoutContactFragmentDoc, LayoutFooterNaviguationFragmentDoc, LinkableFragmentDoc, LayoutModalFragmentDoc);
var PageBodyAccordionFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject64());
var PageBodyContentPhotoText_30_60FragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject65());
var PageBodyContentTextPhoto_60_30FragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject66());
var PageBodyContentTextText_50FragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject67());
var PageBodyContentPhotoPhotoFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject68());
var PageBodyContentPhotoPhoto_50FragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject69());
var PageBodyContentPhotoTextFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject70());
var PageBodyDownloadFilesFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject71());
var PageBodyExcerptFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject72());
var PageBodyFormEmbdedFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject73());
var PageBodyHeroImgFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject74());
var PageBodyHtmlEmbdedFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject75());
var PageBodyIconBannerFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject76(), MetaBaseFragmentDoc);
var PageBodyIconCtaFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject77(), LinkableFragmentDoc);
var PageBodyImageCardFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject78(), LinkableFragmentDoc);
var PageBodyImageCtaFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject79(), LinkableFragmentDoc);
var PageBodyLinkButtonFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject80(), LinkableFragmentDoc);
var PageBodyMediaSliderFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject81());
var PageBodyOurPartnersFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject82());
var PageBodyQuoteFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject83());
var PageBodyRelatedProductsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject84());
var PageBodyRichtextFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject85());
var PageBodyTagImageFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject86());
var PageLinkBlogPostFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject87(), MetaBaseFragmentDoc);
var PageLinkPageFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject88(), MetaBaseFragmentDoc);
var ProjectCategoryFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject89(), MetaBaseFragmentDoc);
var ProjectCategoryListFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject90(), ProjectCategoryFragmentDoc);
var ProjectTagFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject91(), MetaBaseFragmentDoc);
var PageLinkProjectFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject92(), ProjectCategoryListFragmentDoc, ProjectTagFragmentDoc, MetaBaseFragmentDoc);
var ProductAttributesBodyTabsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject93());
var ProductAttributesFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject94(), ProductAttributesBodyTabsFragmentDoc);
var ProductBodyLabeledIconsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject95());
var ProductBodyInspirationFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject96());
var ProductBodyProductFeaturesFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject97());
var ProductBodyProductDetailsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject98());
var ProductBodyColorSampleFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject99(), LinkableFragmentDoc);
var ProductBodyInstagramPostsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject100(), LinkableFragmentDoc);
var ProductBodyFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject101(), ProductBodyLabeledIconsFragmentDoc, ProductBodyInspirationFragmentDoc, ProductBodyProductFeaturesFragmentDoc, ProductBodyProductDetailsFragmentDoc, ProductBodyColorSampleFragmentDoc, ProductBodyInstagramPostsFragmentDoc);
var ProductMediaFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject102());
var ProjectBodyRelatedProductsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject103());
var ProjectBodyLinkedProductsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject104(), LinkableFragmentDoc);
var ProjectCardFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject105(), ProjectCategoryListFragmentDoc, ProjectTagFragmentDoc);
var ProjectMediaFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject106(), LinkableFragmentDoc);
var ProjectColorFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject107(), MetaBaseFragmentDoc);
var ProjectWidthFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject108(), MetaBaseFragmentDoc);
var ProjectDetailsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject109(), ProjectMediaFragmentDoc, ProjectCategoryListFragmentDoc, ProjectColorFragmentDoc, ProjectWidthFragmentDoc, ProjectTagFragmentDoc);
var WishlistBodyColorSampleFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject110(), LinkableFragmentDoc);
var PrismicAllBlogPostsQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject111(), BlogPostFragmentDoc, BlogHomeIconBannerFragmentDoc);
/**
 * __usePrismicAllBlogPostsQuery__
 *
 * To run a query within a React component, call `usePrismicAllBlogPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicAllBlogPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicAllBlogPostsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicAllBlogPostsQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicAllBlogPostsQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicAllBlogPostsQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicAllBlogPostsQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicAllProjectsQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject112(), ProjectCardFragmentDoc, MetaBaseFragmentDoc);
/**
 * __usePrismicAllProjectsQuery__
 *
 * To run a query within a React component, call `usePrismicAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicAllProjectsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicAllProjectsQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicAllProjectsQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicAllProjectsQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicAllProjectsQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicArchitectQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject113(), ArchitectBodyInspirationFragmentDoc, ArchitectBodyBenefitsProgramFragmentDoc, ArchitectBodyArchitectReviewsFragmentDoc, ArchitectBodyShowroomFragmentDoc, ArchitectBodyFranchiseContactFragmentDoc, ArchitectBodyConsultToolboxFragmentDoc, ArchitectBodyInstagramPostsFragmentDoc, MetaDetailsFragmentDoc);
/**
 * __usePrismicArchitectQuery__
 *
 * To run a query within a React component, call `usePrismicArchitectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicArchitectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicArchitectQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicArchitectQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicArchitectQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicArchitectQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicArchitectQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicBlogPageQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject114(), BlogPostCardFragmentDoc, BlogPostBodyIconBannerFragmentDoc, BlogPostBodyHeroImgFragmentDoc, BlogPostBodyExcerptFragmentDoc, BlogPostBodyRichtextFragmentDoc, BlogPostBodyTagImageFragmentDoc, BlogPostBodyQuoteFragmentDoc, BlogPostBodyMediaSliderFragmentDoc, BlogPostBodyIconCtaFragmentDoc, BlogPostBodyContentTextPhoto_60_30FragmentDoc, BlogPostBodyContentPhotoText_30_60FragmentDoc, BlogPostBodyContentTextText_50FragmentDoc, BlogPostBodyContentPhotoPhoto_50FragmentDoc, BlogPostBodyContentPhotoPhotoFragmentDoc, BlogPostBodyContentPhotoTextFragmentDoc, BlogPostBodyFormEmbdedFragmentDoc, BlogPostBodyAccordeonFragmentDoc, BlogPostBodyLinkButtonFragmentDoc, BlogPostBodyOurPartnersFragmentDoc, BlogPostBodyDownloadFilesFragmentDoc, BlogPostBodyHtmlEmbdedFragmentDoc, BlogPostBodyRelatedProductsFragmentDoc, BlogPostBodyImageCtaFragmentDoc, BlogPostBodyImageCardFragmentDoc, MetaDetailsFragmentDoc);
/**
 * __usePrismicBlogPageQuery__
 *
 * To run a query within a React component, call `usePrismicBlogPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicBlogPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicBlogPageQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicBlogPageQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicBlogPageQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicBlogPageQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicBlogPageQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicBlogPathsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject115());
/**
 * __usePrismicBlogPathsQuery__
 *
 * To run a query within a React component, call `usePrismicBlogPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicBlogPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicBlogPathsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicBlogPathsQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicBlogPathsDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicBlogPathsLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicBlogPathsDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicCategoryQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject116(), CategoryFragmentDoc);
/**
 * __usePrismicCategoryQuery__
 *
 * To run a query within a React component, call `usePrismicCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicCategoryQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicCategoryQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicCategoryQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicCategoryQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicCategoryQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicContactsQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject117(), ContactsFragmentDoc, MetaDetailsFragmentDoc);
/**
 * __usePrismicContactsQuery__
 *
 * To run a query within a React component, call `usePrismicContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicContactsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicContactsQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicContactsQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicContactsQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicContactsQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicDefaultSeoQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject118());
/**
 * __usePrismicDefaultSeoQuery__
 *
 * To run a query within a React component, call `usePrismicDefaultSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicDefaultSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicDefaultSeoQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicDefaultSeoQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicDefaultSeoQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicDefaultSeoQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicDefaultSeoQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicHomePageQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject119(), LinkableFragmentDoc, HomepageBodyTrustedFragmentDoc, HomepageBodyInspirationFragmentDoc, HomepageBodyBenefitsFragmentDoc, HomepageBodyCollectionsFragmentDoc, HomepageBodyReviewsFragmentDoc, HomepageBodyInstagramPostsFragmentDoc, HomepageBodyCtaFragmentDoc, HomepageBodyImageCtaFragmentDoc, HomepageBodyImageCardFragmentDoc, HomepageBodyLinkButtonFragmentDoc, MetaDetailsFragmentDoc);
/**
 * __usePrismicHomePageQuery__
 *
 * To run a query within a React component, call `usePrismicHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicHomePageQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicHomePageQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicHomePageQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicHomePageQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicHomePageQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicLayoutQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject120(), LayoutFragmentDoc);
/**
 * __usePrismicLayoutQuery__
 *
 * To run a query within a React component, call `usePrismicLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicLayoutQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicLayoutQuery(baseOptions) {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var prismicOptions = {
        client: _prismic_prismic_config__WEBPACK_IMPORTED_MODULE_3__/* .prismicApolloClient */ .ck
    };
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultOptions, prismicOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a(PrismicLayoutQueryDocument, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        fetchPolicy: "cache-and-network",
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options === null || options === void 0 ? void 0 : options.variables, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_2__/* .localeToPrismicQuery */ .Ux)(locale))
    }));
}
function usePrismicLayoutQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicLayoutQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicPagePathsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject121());
/**
 * __usePrismicPagePathsQuery__
 *
 * To run a query within a React component, call `usePrismicPagePathsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicPagePathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicPagePathsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicPagePathsQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicPagePathsDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicPagePathsLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicPagePathsDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicPageQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject122(), PageBodyIconBannerFragmentDoc, PageBodyHeroImgFragmentDoc, PageBodyExcerptFragmentDoc, PageBodyRichtextFragmentDoc, PageBodyTagImageFragmentDoc, PageBodyQuoteFragmentDoc, PageBodyMediaSliderFragmentDoc, PageBodyIconCtaFragmentDoc, PageBodyContentTextPhoto_60_30FragmentDoc, PageBodyContentPhotoText_30_60FragmentDoc, PageBodyContentTextText_50FragmentDoc, PageBodyContentPhotoPhoto_50FragmentDoc, PageBodyContentPhotoTextFragmentDoc, PageBodyContentPhotoPhotoFragmentDoc, PageBodyFormEmbdedFragmentDoc, PageBodyAccordionFragmentDoc, PageBodyLinkButtonFragmentDoc, PageBodyOurPartnersFragmentDoc, PageBodyDownloadFilesFragmentDoc, PageBodyHtmlEmbdedFragmentDoc, PageBodyRelatedProductsFragmentDoc, PageBodyImageCtaFragmentDoc, PageBodyImageCardFragmentDoc, MetaDetailsFragmentDoc);
/**
 * __usePrismicPageQuery__
 *
 * To run a query within a React component, call `usePrismicPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicPageQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicPageQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicPageQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicPageQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicPageQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicProductImagesQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject123(), MetaDetailsFragmentDoc);
/**
 * __usePrismicProductImagesQuery__
 *
 * To run a query within a React component, call `usePrismicProductImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicProductImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicProductImagesQuery({
 *   variables: {
 *      productUids: // value for 'productUids'
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicProductImagesQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicProductImagesQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicProductImagesQueryLazyQuery(baseOptions) {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var prismicOptions = {
        client: _prismic_prismic_config__WEBPACK_IMPORTED_MODULE_3__/* .prismicApolloClient */ .ck
    };
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultOptions, prismicOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useLazyQuery */ .t(PrismicProductImagesQueryDocument, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        fetchPolicy: "cache-and-network",
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options === null || options === void 0 ? void 0 : options.variables, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_2__/* .localeToPrismicQuery */ .Ux)(locale))
    }));
}
var PrismicProductPageQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject124(), ProductAttributesFragmentDoc, ProductMediaFragmentDoc, ProductBodyFragmentDoc, MetaDetailsFragmentDoc);
/**
 * __usePrismicProductPageQuery__
 *
 * To run a query within a React component, call `usePrismicProductPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicProductPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicProductPageQuery({
 *   variables: {
 *      productUid: // value for 'productUid'
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicProductPageQuery(baseOptions) {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var prismicOptions = {
        client: _prismic_prismic_config__WEBPACK_IMPORTED_MODULE_3__/* .prismicApolloClient */ .ck
    };
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultOptions, prismicOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a(PrismicProductPageQueryDocument, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        fetchPolicy: "cache-and-network",
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options === null || options === void 0 ? void 0 : options.variables, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_2__/* .localeToPrismicQuery */ .Ux)(locale))
    }));
}
function usePrismicProductPageQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicProductPageQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicProductQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject125(), ProductBodyInspirationFragmentDoc, MetaDetailsFragmentDoc);
/**
 * __usePrismicProductQuery__
 *
 * To run a query within a React component, call `usePrismicProductQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicProductQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicProductQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicProductQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicProductQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicProductQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicProjectFilterQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject126(), ProjectCategoryFragmentDoc, ProjectTagFragmentDoc);
/**
 * __usePrismicProjectFilterQuery__
 *
 * To run a query within a React component, call `usePrismicProjectFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicProjectFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicProjectFilterQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicProjectFilterQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicProjectFilterQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicProjectFilterQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicProjectFilterQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicProjectPathsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject127());
/**
 * __usePrismicProjectPathsQuery__
 *
 * To run a query within a React component, call `usePrismicProjectPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicProjectPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicProjectPathsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicProjectPathsQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicProjectPathsDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicProjectPathsLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicProjectPathsDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicProjectQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject128(), ProjectDetailsFragmentDoc, MetaDetailsFragmentDoc, ProjectBodyRelatedProductsFragmentDoc, ProjectBodyLinkedProductsFragmentDoc);
/**
 * __usePrismicProjectQuery__
 *
 * To run a query within a React component, call `usePrismicProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicProjectQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicProjectQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicProjectQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicProjectQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicProjectQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicRealisationQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject129(), MetaDetailsFragmentDoc);
/**
 * __usePrismicRealisationQuery__
 *
 * To run a query within a React component, call `usePrismicRealisationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicRealisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicRealisationQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicRealisationQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicRealisationQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicRealisationQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicRealisationQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicReviewsQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject130(), MetaDetailsFragmentDoc);
/**
 * __usePrismicReviewsQuery__
 *
 * To run a query within a React component, call `usePrismicReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicReviewsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicReviewsQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useQuery(PrismicReviewsQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
function usePrismicReviewsQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicReviewsQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}
var PrismicWishlistPageQueryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject131(), WishlistBodyColorSampleFragmentDoc, MetaDetailsFragmentDoc);
/**
 * __usePrismicWishlistPageQuery__
 *
 * To run a query within a React component, call `usePrismicWishlistPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrismicWishlistPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismicWishlistPageQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */ function usePrismicWishlistPageQuery(baseOptions) {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var prismicOptions = {
        client: _prismic_prismic_config__WEBPACK_IMPORTED_MODULE_3__/* .prismicApolloClient */ .ck
    };
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultOptions, prismicOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a(PrismicWishlistPageQueryDocument, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        fetchPolicy: "cache-and-network",
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options === null || options === void 0 ? void 0 : options.variables, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_2__/* .localeToPrismicQuery */ .Ux)(locale))
    }));
}
function usePrismicWishlistPageQueryLazyQuery(baseOptions) {
    var locale = useRouter().locale;
    var prismicOptions = {
        client: prismicApolloClient
    };
    var options = _object_spread({}, defaultOptions, prismicOptions, baseOptions);
    return Apollo.useLazyQuery(PrismicWishlistPageQueryDocument, _object_spread_props(_object_spread({}, options), {
        fetchPolicy: "cache-and-network",
        variables: _object_spread({}, options === null || options === void 0 ? void 0 : options.variables, localeToPrismicQuery(locale))
    }));
}


/***/ }),

/***/ 93092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gE": function() { return /* binding */ imageResolver; },
  "kG": function() { return /* binding */ linkResolver; },
  "ck": function() { return /* binding */ prismicApolloClient; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(48702);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 8 modules
var ApolloClient = __webpack_require__(65075);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(55598);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/error/index.js



function onError(errorHandler) {
    return new ApolloLink/* ApolloLink */.i(function (operation, forward) {
        return new zen_observable_ts_module/* Observable */.y(function (observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function (result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward,
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function (networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError &&
                                networkError.result &&
                                networkError.result.errors,
                            forward: forward,
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer),
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function () {
                        if (!retriedResult) {
                            observer.complete.bind(observer)();
                        }
                    },
                });
            }
            catch (e) {
                errorHandler({ networkError: e, operation: operation, forward: forward });
                observer.error(e);
            }
            return function () {
                if (sub)
                    sub.unsubscribe();
                if (retriedSub)
                    sub.unsubscribe();
            };
        });
    });
}
var ErrorLink = (function (_super) {
    (0,tslib_es6.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = onError(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}(ApolloLink/* ApolloLink */.i));

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/createHttpLink.js
var createHttpLink = __webpack_require__(34747);
;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/errors/PrismicError.js
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PrismicError extends Error {
  constructor(message = "An invalid API response was returned", url, response) {
    super(message);
    __publicField(this, "url");
    __publicField(this, "response");
    this.url = url;
    this.response = response;
  }
}

//# sourceMappingURL=PrismicError.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/getRepositoryName.js

const getRepositoryName = (repositoryEndpoint) => {
  try {
    return new URL(repositoryEndpoint).hostname.split(".")[0];
  } catch {
    throw new PrismicError(`An invalid Prismic Rest API V2 endpoint was provided: ${repositoryEndpoint}`, void 0, void 0);
  }
};

//# sourceMappingURL=getRepositoryName.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/isRepositoryName.js
const isRepositoryName = (input) => {
  return /^[a-zA-Z0-9][-a-zA-Z0-9]{2,}[a-zA-Z0-9]$/.test(input);
};

//# sourceMappingURL=isRepositoryName.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/getGraphQLEndpoint.js


const getGraphQLEndpoint = (repositoryName) => {
  if (isRepositoryName(repositoryName)) {
    return `https://${repositoryName}.cdn.prismic.io/graphql`;
  } else {
    throw new PrismicError(`An invalid Prismic repository name was given: ${repositoryName}`, void 0, void 0);
  }
};

//# sourceMappingURL=getGraphQLEndpoint.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/getRepositoryEndpoint.js


const getRepositoryEndpoint = (repositoryName) => {
  if (isRepositoryName(repositoryName)) {
    return `https://${repositoryName}.cdn.prismic.io/api/v2`;
  } else {
    throw new PrismicError(`An invalid Prismic repository name was given: ${repositoryName}`, void 0, void 0);
  }
};

//# sourceMappingURL=getRepositoryEndpoint.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/castArray.js
const castArray = (a) => {
  return Array.isArray(a) ? a : [a];
};

//# sourceMappingURL=castArray.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/appendFilters.js

const appendFilters = (objWithFilters = {}, filters) => {
  return {
    ...objWithFilters,
    filters: [...objWithFilters.filters || [], ...castArray(filters)]
  };
};

//# sourceMappingURL=appendFilters.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/castThunk.js
const castThunk = (a) => {
  return typeof a === "function" ? a : () => a;
};

//# sourceMappingURL=castThunk.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/filter.js
const formatValue = (value) => {
  if (Array.isArray(value)) {
    return `[${value.map(formatValue).join(", ")}]`;
  }
  if (typeof value === "string") {
    return `"${value}"`;
  }
  if (value instanceof Date) {
    return `${value.getTime()}`;
  }
  return `${value}`;
};
const pathWithArgsFilter = (name) => {
  const fn = (path, ...args) => {
    const formattedArgs = args.map(formatValue).join(", ");
    const joiner = path && args.length ? ", " : "";
    return `[${name}(${path}${joiner}${formattedArgs})]`;
  };
  return fn;
};
const pathFilter = (name) => {
  const filterFn = pathWithArgsFilter(name);
  const fn = (path) => {
    return filterFn(path);
  };
  return fn;
};
const argsFilter = (name) => {
  const filterFn = pathWithArgsFilter(name);
  const fn = (...args) => {
    return filterFn("", ...args);
  };
  return fn;
};
const filter = {
  /**
   * The `at` filter checks that the path matches the described value exactly.
   * It takes a single value for a field or an array (only for tags).
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#at}
   */
  at: pathWithArgsFilter("at"),
  /**
   * The `not` filter checks that the path doesn't match the provided value
   * exactly. It takes a single value for a field or an array (only for tags).
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#not}
   */
  not: pathWithArgsFilter("not"),
  /**
   * The `any` filter takes an array of values. It works exactly the same way as
   * the `at` operator, but checks whether the fragment matches any of the
   * values in the array.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#any}
   */
  any: pathWithArgsFilter("any"),
  /**
   * The `in` filter is used specifically to retrieve an array of documents by
   * their IDs or UIDs. This filter is much more efficient at this than the any
   * filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#in}
   */
  in: pathWithArgsFilter("in"),
  /**
   * The `fulltext` filter provides two capabilities:
   *
   * 1. Checking if a certain string is anywhere inside a document (this is what
   *    you should use to make your project's search engine feature)
   * 2. Checking if the string is contained inside a specific custom type’s Rich
   *    Text or Key Text fragment.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#fulltext}
   */
  fulltext: pathWithArgsFilter("fulltext"),
  /**
   * The `has` filter checks whether a fragment has a value. It will return all
   * the documents of the specified type that contain a value for the specified
   * field.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#has}
   */
  has: pathFilter("has"),
  /**
   * The `missing` filter checks if a fragment doesn't have a value. It will
   * return all the documents of the specified type that do not contain a value
   * for the specified field.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#missing}
   */
  missing: pathFilter("missing"),
  /**
   * The `similar` filter takes the ID of a document, and returns a list of
   * documents with similar content. This allows you to build an automated
   * content discovery feature (for example, a "Related posts" section).
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#similar}
   */
  similar: argsFilter("similar"),
  /**
   * The `geopoint.near` filter checks that the value in the path is within the
   * radius of the given coordinates.
   *
   * This filter will only work for a geopoint field.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#geopointnear}
   */
  geopointNear: pathWithArgsFilter("geopoint.near"),
  /**
   * The `number.lt` filter checks that the value in the number field is less
   * than the value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#numberlessthan}
   */
  numberLessThan: pathWithArgsFilter("number.lt"),
  /**
   * The `number.gt` filter checks that the value in the number field is greater
   * than the value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#numbergreaterthan}
   */
  numberGreaterThan: pathWithArgsFilter("number.gt"),
  /**
   * The `number.inRange` filter checks that the value in the path is within the
   * two values passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#numberinrange}
   */
  numberInRange: pathWithArgsFilter("number.inRange"),
  /**
   * The `date.after` filter checks that the value in the path is after the date
   * value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateAfter: pathWithArgsFilter("date.after"),
  /**
   * The `date.before` filter checks that the value in the path is before the
   * date value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateBefore: pathWithArgsFilter("date.before"),
  /**
   * The `date.between` filter checks that the value in the path is within the
   * date values passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateBetween: pathWithArgsFilter("date.between"),
  /**
   * The `date.day-of-month` filter checks that the value in the path is equal
   * to the day of the month passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateDayOfMonth: pathWithArgsFilter("date.day-of-month"),
  /**
   * The `date.day-of-month-after` filter checks that the value in the path is
   * after the day of the month passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateDayOfMonthAfter: pathWithArgsFilter("date.day-of-month-after"),
  /**
   * The `date.day-of-month-before` filter checks that the value in the path is
   * before the day of the month passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateDayOfMonthBefore: pathWithArgsFilter("date.day-of-month-before"),
  /**
   * The `date.day-of-week` filter checks that the value in the path is equal to
   * the day of the week passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateDayOfWeek: pathWithArgsFilter("date.day-of-week"),
  /**
   * The `date.day-of-week-after` filter checks that the value in the path is
   * after the day of the week passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateDayOfWeekAfter: pathWithArgsFilter("date.day-of-week-after"),
  /**
   * The date.day-of-week-before filter checks that the value in the path is
   * before the day of the week passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateDayOfWeekBefore: pathWithArgsFilter("date.day-of-week-before"),
  /**
   * The `date.month` filter checks that the value in the path occurs in the
   * month value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateMonth: pathWithArgsFilter("date.month"),
  /**
   * The `date.month-after` filter checks that the value in the path occurs in
   * any month after the value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateMonthAfter: pathWithArgsFilter("date.month-after"),
  /**
   * The `date.month-before` filter checks that the value in the path occurs in
   * any month before the value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateMonthBefore: pathWithArgsFilter("date.month-before"),
  /**
   * The `date.year` filter checks that the value in the path occurs in the year
   * value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateYear: pathWithArgsFilter("date.year"),
  /**
   * The `date.hour` filter checks that the value in the path occurs within the
   * hour value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateHour: pathWithArgsFilter("date.hour"),
  /**
   * The `date.hour-after` filter checks that the value in the path occurs after
   * the hour value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateHourAfter: pathWithArgsFilter("date.hour-after"),
  /**
   * The `date.hour-before` filter checks that the value in the path occurs
   * before the hour value passed into the filter.
   *
   * {@link https://prismic.io/docs/rest-api-technical-reference#date-filters}
   */
  dateHourBefore: pathWithArgsFilter("date.hour-before")
};

//# sourceMappingURL=filter.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/everyTagFilter.js


const everyTagFilter = (tags) => {
  return filter.at("document.tags", castArray(tags));
};

//# sourceMappingURL=everyTagFilter.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/findRef.js

const findRef = (refs, filter) => {
  const ref = refs.find((ref2) => filter(ref2));
  if (!ref) {
    throw new PrismicError("Ref could not be found.", void 0, void 0);
  }
  return ref;
};

//# sourceMappingURL=findRef.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/findMasterRef.js

const findMasterRef = (refs) => {
  return findRef(refs, (ref) => ref.isMasterRef);
};

//# sourceMappingURL=findMasterRef.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/findRefByID.js

const findRefByID = (refs, id) => {
  return findRef(refs, (ref) => ref.id === id);
};

//# sourceMappingURL=findRefByID.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/findRefByLabel.js

const findRefByLabel = (refs, label) => {
  return findRef(refs, (ref) => ref.label === label);
};

//# sourceMappingURL=findRefByLabel.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/cookie.js
const preview = "io.prismic.preview";

//# sourceMappingURL=cookie.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/getPreviewCookie.js

const readValue = (value) => {
  return value.replace(/%3B/g, ";");
};
const getPreviewCookie = (cookieJar) => {
  const cookies = cookieJar.split("; ");
  let value;
  for (const cookie of cookies) {
    const parts = cookie.split("=");
    const name = readValue(parts[0]).replace(/%3D/g, "=");
    if (name === preview) {
      value = readValue(parts.slice(1).join("="));
      break;
    }
  }
  return value;
};

//# sourceMappingURL=getPreviewCookie.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/minifyGraphQLQuery.js
const minifyGraphQLQuery = (query) => {
  return query.replace(/(\n| )*( |{|})(\n| )*/gm, (_chars, _spaces, brackets) => brackets);
};

//# sourceMappingURL=minifyGraphQLQuery.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/someTagsFilter.js


const someTagsFilter = (tags) => {
  return filter.any("document.tags", castArray(tags));
};

//# sourceMappingURL=someTagsFilter.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/lib/typeFilter.js

const typeFilter = (documentType) => {
  return filter.at("document.type", documentType);
};

//# sourceMappingURL=typeFilter.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/errors/ForbiddenError.js

class ForbiddenError extends PrismicError {
}

//# sourceMappingURL=ForbiddenError.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/errors/NotFoundError.js

class NotFoundError extends PrismicError {
}

//# sourceMappingURL=NotFoundError.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/errors/ParsingError.js

class ParsingError extends PrismicError {
}

//# sourceMappingURL=ParsingError.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/types/value/link.js
const LinkType = {
  Any: "Any",
  Document: "Document",
  Media: "Media",
  Web: "Web"
};

//# sourceMappingURL=link.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/helpers/documentToLinkField.js

const documentToLinkField = (prismicDocument) => {
  var _a;
  return {
    link_type: LinkType.Document,
    id: prismicDocument.id,
    uid: prismicDocument.uid || void 0,
    type: prismicDocument.type,
    tags: prismicDocument.tags,
    lang: prismicDocument.lang,
    url: prismicDocument.url == null ? void 0 : prismicDocument.url,
    slug: (_a = prismicDocument.slugs) == null ? void 0 : _a[0],
    // The REST API does not include a `data` property if the data
    // object is empty.
    //
    // A presence check for `prismicDocument.data` is done to
    // support partial documents. While `documentToLinkField` is
    // not typed to accept partial documents, passing a partial
    // document can happen in untyped projects.
    ...prismicDocument.data && Object.keys(prismicDocument.data).length > 0 ? { data: prismicDocument.data } : {}
  };
};

//# sourceMappingURL=documentToLinkField.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/helpers/asLink.js


const asLink = (linkFieldOrDocument, ...configObjectOrTuple) => {
  if (!linkFieldOrDocument) {
    return null;
  }
  const linkField = (
    // prettier-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
    // TODO: Remove the `prettier-ignore` comment when this bug is fixed.
    "link_type" in linkFieldOrDocument ? linkFieldOrDocument : documentToLinkField(linkFieldOrDocument)
  );
  const [configObjectOrLinkResolver] = configObjectOrTuple;
  let config;
  if (typeof configObjectOrLinkResolver === "function" || configObjectOrLinkResolver == null) {
    config = {
      linkResolver: configObjectOrLinkResolver
    };
  } else {
    config = { ...configObjectOrLinkResolver };
  }
  switch (linkField.link_type) {
    case LinkType.Media:
    case LinkType.Web:
      return "url" in linkField ? linkField.url : null;
    case LinkType.Document: {
      if ("id" in linkField && config.linkResolver) {
        const resolvedURL = config.linkResolver(linkField);
        if (resolvedURL != null) {
          return resolvedURL;
        }
      }
      if ("url" in linkField && linkField.url) {
        return linkField.url;
      }
      return null;
    }
    case LinkType.Any:
    default:
      return null;
  }
};

//# sourceMappingURL=asLink.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/buildQueryURL.js


const RENAMED_PARAMS = {
  accessToken: "access_token"
};
const castOrderingToString = (ordering) => {
  if (typeof ordering === "string") {
    if (false) {}
    return ordering;
  }
  return ordering.direction === "desc" ? `${ordering.field} desc` : ordering.field;
};
const buildQueryURL = (endpoint, args) => {
  const { filters, predicates, ...params } = args;
  const url = new URL(`documents/search`, `${endpoint}/`);
  if (filters) {
    if (false) {}
    for (const filter of castArray(filters)) {
      url.searchParams.append("q", `[${filter}]`);
    }
  }
  if (predicates) {
    for (const predicate of castArray(predicates)) {
      url.searchParams.append("q", `[${predicate}]`);
    }
  }
  for (const k in params) {
    const name = RENAMED_PARAMS[k] || k;
    let value = params[k];
    if (name === "orderings") {
      const scopedValue = params[name];
      if (scopedValue != null) {
        if (false) {}
        const v = castArray(scopedValue).map((ordering) => castOrderingToString(ordering)).join(",");
        value = `[${v}]`;
      }
    } else if (name === "routes") {
      if (typeof params[name] === "object") {
        value = JSON.stringify(castArray(params[name]));
      }
    }
    if (value != null) {
      url.searchParams.set(name, castArray(value).join(","));
    }
  }
  return url.toString();
};

//# sourceMappingURL=buildQueryURL.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/isRepositoryEndpoint.js
const isRepositoryEndpoint = (input) => {
  try {
    new URL(input);
    return true;
  } catch {
    return false;
  }
};

//# sourceMappingURL=isRepositoryEndpoint.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/createClient.js
var createClient_defProp = Object.defineProperty;
var createClient_defNormalProp = (obj, key, value) => key in obj ? createClient_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var createClient_publicField = (obj, key, value) => {
  createClient_defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};





















const MAX_PAGE_SIZE = 100;
const REPOSITORY_CACHE_TTL = 5e3;
const GET_ALL_QUERY_DELAY = 500;
var RefStateMode;
(function(RefStateMode2) {
  RefStateMode2["Master"] = "Master";
  RefStateMode2["ReleaseID"] = "ReleaseID";
  RefStateMode2["ReleaseLabel"] = "ReleaseLabel";
  RefStateMode2["Manual"] = "Manual";
})(RefStateMode || (RefStateMode = {}));
const createClient = (repositoryNameOrEndpoint, options) => new Client(repositoryNameOrEndpoint, options);
class Client {
  /**
   * Creates a Prismic client that can be used to query a repository.
   *
   * If used in an environment where a global `fetch` function is unavailable,
   * such as Node.js, the `fetch` option must be provided as part of the
   * `options` parameter.
   *
   * @param repositoryNameOrEndpoint - The Prismic repository name or full Rest
   *   API V2 endpoint for the repository.
   * @param options - Configuration that determines how content will be queried
   *   from the Prismic repository.
   *
   * @returns A client that can query content from the repository.
   */
  constructor(repositoryNameOrEndpoint, options = {}) {
    /**
     * The Prismic REST API V2 endpoint for the repository (use
     * `prismic.getRepositoryEndpoint` for the default endpoint).
     */
    createClient_publicField(this, "endpoint");
    /**
     * The secure token for accessing the API (only needed if your repository is
     * set to private).
     *
     * {@link https://user-guides.prismic.io/en/articles/1036153-generating-an-access-token}
     */
    createClient_publicField(this, "accessToken");
    /**
     * A list of route resolver objects that define how a document's `url` field
     * is resolved.
     *
     * {@link https://prismic.io/docs/route-resolver}
     */
    createClient_publicField(this, "routes");
    /**
     * The `brokenRoute` option allows you to define the route populated in the
     * `url` property for broken link or content relationship fields. A broken
     * link is a link or content relationship field whose linked document has been
     * unpublished or deleted.
     *
     * {@link https://prismic.io/docs/route-resolver}
     */
    createClient_publicField(this, "brokenRoute");
    /**
     * The function used to make network requests to the Prismic REST API. In
     * environments where a global `fetch` function does not exist, such as
     * Node.js, this function must be provided.
     */
    createClient_publicField(this, "fetchFn");
    createClient_publicField(this, "fetchOptions");
    /**
     * Default parameters that will be sent with each query. These parameters can
     * be overridden on each query if needed.
     */
    createClient_publicField(this, "defaultParams");
    /**
     * The client's ref mode state. This determines which ref is used during
     * queries.
     */
    createClient_publicField(this, "refState", {
      mode: RefStateMode.Master,
      autoPreviewsEnabled: true
    });
    /**
     * Cached repository value.
     */
    createClient_publicField(this, "cachedRepository");
    /**
     * Timestamp at which the cached repository data is considered stale.
     */
    createClient_publicField(this, "cachedRepositoryExpiration", 0);
    /**
     * Active `fetch()` jobs keyed by URL and AbortSignal (if it exists).
     */
    createClient_publicField(this, "fetchJobs", {});
    if (isRepositoryEndpoint(repositoryNameOrEndpoint)) {
      if (false) {}
      this.endpoint = repositoryNameOrEndpoint;
    } else {
      this.endpoint = getRepositoryEndpoint(repositoryNameOrEndpoint);
    }
    this.accessToken = options.accessToken;
    this.routes = options.routes;
    this.brokenRoute = options.brokenRoute;
    this.fetchOptions = options.fetchOptions;
    this.defaultParams = options.defaultParams;
    if (options.ref) {
      this.queryContentFromRef(options.ref);
    }
    if (typeof options.fetch === "function") {
      this.fetchFn = options.fetch;
    } else if (typeof globalThis.fetch === "function") {
      this.fetchFn = globalThis.fetch;
    } else {
      throw new PrismicError("A valid fetch implementation was not provided. In environments where fetch is not available (including Node.js), a fetch implementation must be provided via a polyfill or the `fetch` option.", void 0, void 0);
    }
    if (this.fetchFn === globalThis.fetch) {
      this.fetchFn = this.fetchFn.bind(globalThis);
    }
    this.graphQLFetch = this.graphQLFetch.bind(this);
  }
  /**
   * Enables the client to automatically query content from a preview session if
   * one is active in browser environments. This is enabled by default in the
   * browser.
   *
   * For server environments, use `enableAutoPreviewsFromReq`.
   *
   * @example
   *
   * ```ts
   * client.enableAutoPreviews();
   * ```
   *
   * @see enableAutoPreviewsFromReq
   */
  enableAutoPreviews() {
    this.refState.autoPreviewsEnabled = true;
  }
  /**
   * Enables the client to automatically query content from a preview session if
   * one is active in server environments. This is disabled by default on the
   * server.
   *
   * For browser environments, use `enableAutoPreviews`.
   *
   * @example
   *
   * ```ts
   * // In an express app
   * app.get("/", function (req, res) {
   * 	client.enableAutoPreviewsFromReq(req);
   * });
   * ```
   *
   * @param req - An HTTP server request object containing the request's
   *   cookies.
   */
  enableAutoPreviewsFromReq(req) {
    this.refState.httpRequest = req;
    this.refState.autoPreviewsEnabled = true;
  }
  /**
   * Disables the client from automatically querying content from a preview
   * session if one is active.
   *
   * Automatic preview content querying is enabled by default unless this method
   * is called.
   *
   * @example
   *
   * ```ts
   * client.disableAutoPreviews();
   * ```
   */
  disableAutoPreviews() {
    this.refState.autoPreviewsEnabled = false;
  }
  /**
   * Queries content from the Prismic repository.
   *
   * @example
   *
   * ```ts
   * const response = await client.get();
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param params - Parameters to filter, sort, and paginate results.
   *
   * @returns A paginated response containing the result of the query.
   */
  async get(params) {
    const url = await this.buildQueryURL(params);
    return await this.fetch(url, params);
  }
  /**
   * Queries content from the Prismic repository and returns only the first
   * result, if any.
   *
   * @example
   *
   * ```ts
   * const document = await client.getFirst();
   * ```
   *
   * @typeParam TDocument - Type of the Prismic document returned.
   *
   * @param params - Parameters to filter, sort, and paginate results. @returns
   *   The first result of the query, if any.
   */
  async getFirst(params) {
    var _a;
    const actualParams = { ...params };
    if (!(params && params.page) && !(params == null ? void 0 : params.pageSize)) {
      actualParams.pageSize = ((_a = this.defaultParams) == null ? void 0 : _a.pageSize) ?? 1;
    }
    const url = await this.buildQueryURL(actualParams);
    const result = await this.fetch(url, params);
    const firstResult = result.results[0];
    if (firstResult) {
      return firstResult;
    }
    throw new NotFoundError("No documents were returned", url, void 0);
  }
  /**
   * **IMPORTANT**: Avoid using `dangerouslyGetAll` as it may be slower and
   * require more resources than other methods. Prefer using other methods that
   * filter by filters such as `getAllByType`.
   *
   * Queries content from the Prismic repository and returns all matching
   * content. If no filters are provided, all documents will be fetched.
   *
   * This method may make multiple network requests to query all matching
   * content.
   *
   * @example
   *
   * ```ts
   * const response = await client.dangerouslyGetAll();
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param params - Parameters to filter, sort, and paginate results.
   *
   * @returns A list of documents matching the query.
   */
  async dangerouslyGetAll(params = {}) {
    var _a;
    const { limit = Infinity, ...actualParams } = params;
    const resolvedParams = {
      ...actualParams,
      pageSize: Math.min(limit, actualParams.pageSize || ((_a = this.defaultParams) == null ? void 0 : _a.pageSize) || MAX_PAGE_SIZE)
    };
    const documents = [];
    let latestResult;
    while ((!latestResult || latestResult.next_page) && documents.length < limit) {
      const page = latestResult ? latestResult.page + 1 : void 0;
      latestResult = await this.get({ ...resolvedParams, page });
      documents.push(...latestResult.results);
      if (latestResult.next_page) {
        await new Promise((res) => setTimeout(res, GET_ALL_QUERY_DELAY));
      }
    }
    return documents.slice(0, limit);
  }
  /**
   * Queries a document from the Prismic repository with a specific ID.
   *
   * @remarks
   * A document's UID is different from its ID. An ID is automatically generated
   * for all documents and is made available on its `id` property. A UID is
   * provided in the Prismic editor and is unique among all documents of its
   * custom type.
   *
   * @example
   *
   * ```ts
   * const document = await client.getByID("WW4bKScAAMAqmluX");
   * ```
   *
   * @typeParam TDocument- Type of the Prismic document returned.
   *
   * @param id - ID of the document.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns The document with an ID matching the `id` parameter, if a matching
   *   document exists.
   */
  async getByID(id, params) {
    return await this.getFirst(appendFilters(params, filter.at("document.id", id)));
  }
  /**
   * Queries documents from the Prismic repository with specific IDs.
   *
   * @remarks
   * A document's UID is different from its ID. An ID is automatically generated
   * for all documents and is made available on its `id` property. A UID is
   * provided in the Prismic editor and is unique among all documents of its
   * custom type.
   *
   * @example
   *
   * ```ts
   * const response = await client.getByIDs([
   * 	"WW4bKScAAMAqmluX",
   * 	"U1kTRgEAAC8A5ldS",
   * ]);
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param ids - A list of document IDs.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A paginated response containing documents with IDs matching the
   *   `ids` parameter.
   */
  async getByIDs(ids, params) {
    return await this.get(appendFilters(params, filter["in"]("document.id", ids)));
  }
  /**
   * Queries all documents from the Prismic repository with specific IDs.
   *
   * This method may make multiple network requests to query all matching
   * content.
   *
   * @remarks
   * A document's UID is different from its ID. An ID is automatically generated
   * for all documents and is made available on its `id` property. A UID is
   * provided in the Prismic editor and is unique among all documents of its
   * custom type.
   *
   * @example
   *
   * ```ts
   * const response = await client.getAllByIDs([
   * 	"WW4bKScAAMAqmluX",
   * 	"U1kTRgEAAC8A5ldS",
   * ]);
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param ids - A list of document IDs.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A list of documents with IDs matching the `ids` parameter.
   */
  async getAllByIDs(ids, params) {
    return await this.dangerouslyGetAll(appendFilters(params, filter["in"]("document.id", ids)));
  }
  /**
   * Queries a document from the Prismic repository with a specific UID and
   * custom type.
   *
   * @remarks
   * A document's UID is different from its ID. An ID is automatically generated
   * for all documents and is made available on its `id` property. A UID is
   * provided in the Prismic editor and is unique among all documents of its
   * custom type.
   *
   * @example
   *
   * ```ts
   * const document = await client.getByUID("blog_post", "my-first-post");
   * ```
   *
   * @typeParam TDocument - Type of the Prismic document returned.
   *
   * @param documentType - The API ID of the document's custom type.
   * @param uid - UID of the document.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns The document with a UID matching the `uid` parameter, if a
   *   matching document exists.
   */
  async getByUID(documentType, uid, params) {
    return await this.getFirst(appendFilters(params, [
      typeFilter(documentType),
      filter.at(`my.${documentType}.uid`, uid)
    ]));
  }
  /**
   * Queries document from the Prismic repository with specific UIDs and Custom
   * Type.
   *
   * @remarks
   * A document's UID is different from its ID. An ID is automatically generated
   * for all documents and is made available on its `id` property. A UID is
   * provided in the Prismic editor and is unique among all documents of its
   * custom type.
   *
   * @example
   *
   * ```ts
   * const document = await client.getByUIDs("blog_post", [
   * 	"my-first-post",
   * 	"my-second-post",
   * ]);
   * ```
   *
   * @typeParam TDocument - Type of the Prismic document returned.
   *
   * @param documentType - The API ID of the document's custom type.
   * @param uids - A list of document UIDs.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A paginated response containing documents with UIDs matching the
   *   `uids` parameter.
   */
  async getByUIDs(documentType, uids, params) {
    return await this.get(appendFilters(params, [
      typeFilter(documentType),
      filter["in"](`my.${documentType}.uid`, uids)
    ]));
  }
  /**
   * Queries all documents from the Prismic repository with specific UIDs and
   * custom type.
   *
   * This method may make multiple network requests to query all matching
   * content.
   *
   * @remarks
   * A document's UID is different from its ID. An ID is automatically generated
   * for all documents and is made available on its `id` property. A UID is
   * provided in the Prismic editor and is unique among all documents of its
   * custom type.
   *
   * @example
   *
   * ```ts
   * const response = await client.getAllByUIDs([
   * 	"my-first-post",
   * 	"my-second-post",
   * ]);
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param documentType - The API ID of the document's custom type.
   * @param uids - A list of document UIDs.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A list of documents with UIDs matching the `uids` parameter.
   */
  async getAllByUIDs(documentType, uids, params) {
    return await this.dangerouslyGetAll(appendFilters(params, [
      typeFilter(documentType),
      filter["in"](`my.${documentType}.uid`, uids)
    ]));
  }
  /**
   * Queries a singleton document from the Prismic repository for a specific
   * custom type.
   *
   * @remarks
   * A singleton document is one that is configured in Prismic to only allow one
   * instance. For example, a repository may be configured to contain just one
   * Settings document. This is in contrast to a repeatable custom type which
   * allows multiple instances of itself.
   *
   * @example
   *
   * ```ts
   * const document = await client.getSingle("settings");
   * ```
   *
   * @typeParam TDocument - Type of the Prismic document returned.
   *
   * @param documentType - The API ID of the singleton custom type.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns The singleton document for the custom type, if a matching document
   *   exists.
   */
  async getSingle(documentType, params) {
    return await this.getFirst(appendFilters(params, typeFilter(documentType)));
  }
  /**
   * Queries documents from the Prismic repository for a specific custom type.
   *
   * Use `getAllByType` instead if you need to query all documents for a
   * specific custom type.
   *
   * @example
   *
   * ```ts
   * const response = await client.getByType("blog_post");
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param documentType - The API ID of the custom type.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A paginated response containing documents of the custom type.
   */
  async getByType(documentType, params) {
    return await this.get(appendFilters(params, typeFilter(documentType)));
  }
  /**
   * Queries all documents from the Prismic repository for a specific Custom
   * Type.
   *
   * This method may make multiple network requests to query all matching
   * content.
   *
   * @example
   *
   * ```ts
   * const response = await client.getByType("blog_post");
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param documentType - The API ID of the custom type.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A list of all documents of the custom type.
   */
  async getAllByType(documentType, params) {
    return await this.dangerouslyGetAll(appendFilters(params, typeFilter(documentType)));
  }
  /**
   * Queries documents from the Prismic repository with a specific tag.
   *
   * Use `getAllByTag` instead if you need to query all documents with a
   * specific tag.
   *
   * @example
   *
   * ```ts
   * const response = await client.getByTag("food");
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param tag - The tag that must be included on a document.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A paginated response containing documents with the tag.
   */
  async getByTag(tag, params) {
    return await this.get(appendFilters(params, someTagsFilter(tag)));
  }
  /**
   * Queries all documents from the Prismic repository with a specific tag.
   *
   * This method may make multiple network requests to query all matching
   * content.
   *
   * @example
   *
   * ```ts
   * const response = await client.getAllByTag("food");
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param tag - The tag that must be included on a document.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A list of all documents with the tag.
   */
  async getAllByTag(tag, params) {
    return await this.dangerouslyGetAll(appendFilters(params, someTagsFilter(tag)));
  }
  /**
   * Queries documents from the Prismic repository with specific tags. A
   * document must be tagged with all of the queried tags to be included.
   *
   * @example
   *
   * ```ts
   * const response = await client.getByEveryTag(["food", "fruit"]);
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param tags - A list of tags that must be included on a document.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A paginated response containing documents with the tags.
   */
  async getByEveryTag(tags, params) {
    return await this.get(appendFilters(params, everyTagFilter(tags)));
  }
  /**
   * Queries documents from the Prismic repository with specific tags. A
   * document must be tagged with all of the queried tags to be included.
   *
   * This method may make multiple network requests to query all matching
   * content.
   *
   * @example
   *
   * ```ts
   * const response = await client.getAllByEveryTag(["food", "fruit"]);
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param tags - A list of tags that must be included on a document.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A list of all documents with the tags.
   */
  async getAllByEveryTag(tags, params) {
    return await this.dangerouslyGetAll(appendFilters(params, everyTagFilter(tags)));
  }
  /**
   * Queries documents from the Prismic repository with specific tags. A
   * document must be tagged with at least one of the queried tags to be
   * included.
   *
   * @example
   *
   * ```ts
   * const response = await client.getByEveryTag(["food", "fruit"]);
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param tags - A list of tags that must be included on a document.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A paginated response containing documents with at least one of the
   *   tags.
   */
  async getBySomeTags(tags, params) {
    return await this.get(appendFilters(params, someTagsFilter(tags)));
  }
  /**
   * Queries documents from the Prismic repository with specific tags. A
   * document must be tagged with at least one of the queried tags to be
   * included.
   *
   * This method may make multiple network requests to query all matching
   * content.
   *
   * @example
   *
   * ```ts
   * const response = await client.getAllBySomeTags(["food", "fruit"]);
   * ```
   *
   * @typeParam TDocument - Type of Prismic documents returned.
   *
   * @param tags - A list of tags that must be included on a document.
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A list of all documents with at least one of the tags.
   */
  async getAllBySomeTags(tags, params) {
    return await this.dangerouslyGetAll(appendFilters(params, someTagsFilter(tags)));
  }
  /**
   * Returns metadata about the Prismic repository, such as its refs, releases,
   * and custom types.
   *
   * @returns Repository metadata.
   */
  async getRepository(params) {
    const url = new URL(this.endpoint);
    if (this.accessToken) {
      url.searchParams.set("access_token", this.accessToken);
    }
    return await this.fetch(url.toString(), params);
  }
  /**
   * Returns a list of all refs for the Prismic repository.
   *
   * Refs are used to identify which version of the repository's content should
   * be queried. All repositories will have at least one ref pointing to the
   * latest published content called the "master ref".
   *
   * @returns A list of all refs for the Prismic repository.
   */
  async getRefs(params) {
    const repository = await this.getRepository(params);
    return repository.refs;
  }
  /**
   * Returns a ref for the Prismic repository with a matching ID.
   *
   * @param id - ID of the ref.
   *
   * @returns The ref with a matching ID, if it exists.
   */
  async getRefByID(id, params) {
    const refs = await this.getRefs(params);
    return findRefByID(refs, id);
  }
  /**
   * Returns a ref for the Prismic repository with a matching label.
   *
   * @param label - Label of the ref.
   *
   * @returns The ref with a matching label, if it exists.
   */
  async getRefByLabel(label, params) {
    const refs = await this.getRefs(params);
    return findRefByLabel(refs, label);
  }
  /**
   * Returns the master ref for the Prismic repository. The master ref points to
   * the repository's latest published content.
   *
   * @returns The repository's master ref.
   */
  async getMasterRef(params) {
    const refs = await this.getRefs(params);
    return findMasterRef(refs);
  }
  /**
   * Returns a list of all Releases for the Prismic repository. Releases are
   * used to group content changes before publishing.
   *
   * @returns A list of all Releases for the Prismic repository.
   */
  async getReleases(params) {
    const refs = await this.getRefs(params);
    return refs.filter((ref) => !ref.isMasterRef);
  }
  /**
   * Returns a Release for the Prismic repository with a matching ID.
   *
   * @param id - ID of the Release.
   *
   * @returns The Release with a matching ID, if it exists.
   */
  async getReleaseByID(id, params) {
    const releases = await this.getReleases(params);
    return findRefByID(releases, id);
  }
  /**
   * Returns a Release for the Prismic repository with a matching label.
   *
   * @param label - Label of the ref.
   *
   * @returns The ref with a matching label, if it exists.
   */
  async getReleaseByLabel(label, params) {
    const releases = await this.getReleases(params);
    return findRefByLabel(releases, label);
  }
  /**
   * Returns a list of all tags used in the Prismic repository.
   *
   * @returns A list of all tags used in the repository.
   */
  async getTags(params) {
    try {
      const tagsForm = await this.getCachedRepositoryForm("tags", params);
      const url = new URL(tagsForm.action);
      if (this.accessToken) {
        url.searchParams.set("access_token", this.accessToken);
      }
      return await this.fetch(url.toString(), params);
    } catch {
      const repository = await this.getRepository(params);
      return repository.tags;
    }
  }
  /**
   * Builds a URL used to query content from the Prismic repository.
   *
   * @param params - Parameters to filter, sort, and paginate the results.
   *
   * @returns A URL string that can be requested to query content.
   */
  async buildQueryURL({ signal, fetchOptions, ...params } = {}) {
    const ref = params.ref || await this.getResolvedRefString({ signal, fetchOptions });
    const integrationFieldsRef = params.integrationFieldsRef || (await this.getCachedRepository({ signal, fetchOptions })).integrationFieldsRef || void 0;
    return buildQueryURL(this.endpoint, {
      ...this.defaultParams,
      ...params,
      ref,
      integrationFieldsRef,
      routes: params.routes || this.routes,
      brokenRoute: params.brokenRoute || this.brokenRoute,
      accessToken: params.accessToken || this.accessToken
    });
  }
  /**
   * Determines the URL for a previewed document during an active preview
   * session. The result of this method should be used to redirect the user to
   * the document's URL.
   *
   * @example
   *
   * ```ts
   * 	const url = client.resolvePreviewURL({
   * 	linkResolver: (document) => `/${document.uid}`
   * 	defaultURL: '/'
   * 	})
   * ```
   *
   * @param args - Arguments to configure the URL resolving.
   *
   * @returns The URL for the previewed document during an active preview
   *   session. The user should be redirected to this URL.
   */
  async resolvePreviewURL(args) {
    var _a, _b;
    let documentID = args.documentID;
    let previewToken = args.previewToken;
    if (typeof globalThis.location !== "undefined") {
      const searchParams = new URLSearchParams(globalThis.location.search);
      documentID = documentID || searchParams.get("documentId");
      previewToken = previewToken || searchParams.get("token");
    } else if (this.refState.httpRequest) {
      if ("query" in this.refState.httpRequest) {
        documentID = documentID || ((_a = this.refState.httpRequest.query) == null ? void 0 : _a.documentId);
        previewToken = previewToken || ((_b = this.refState.httpRequest.query) == null ? void 0 : _b.token);
      } else if ("url" in this.refState.httpRequest && this.refState.httpRequest.url) {
        const searchParams = new URL(this.refState.httpRequest.url, "missing-host://").searchParams;
        documentID = documentID || searchParams.get("documentId");
        previewToken = previewToken || searchParams.get("token");
      }
    }
    if (documentID != null && previewToken != null) {
      const document = await this.getByID(documentID, {
        ref: previewToken,
        lang: "*",
        signal: args.signal,
        fetchOptions: args.fetchOptions
      });
      const url = asLink(document, { linkResolver: args.linkResolver });
      if (typeof url === "string") {
        return url;
      }
    }
    return args.defaultURL;
  }
  /**
   * Configures the client to query the latest published content for all future
   * queries.
   *
   * If the `ref` parameter is provided during a query, it takes priority for
   * that query.
   *
   * @example
   *
   * ```ts
   * await client.queryLatestContent();
   * const document = await client.getByID("WW4bKScAAMAqmluX");
   * ```
   */
  queryLatestContent() {
    this.refState.mode = RefStateMode.Master;
  }
  /**
   * Configures the client to query content from a specific Release identified
   * by its ID for all future queries.
   *
   * If the `ref` parameter is provided during a query, it takes priority for
   * that query.
   *
   * @example
   *
   * ```ts
   * await client.queryContentFromReleaseByID("YLB7OBAAACMA7Cpa");
   * const document = await client.getByID("WW4bKScAAMAqmluX");
   * ```
   *
   * @param releaseID - The ID of the Release.
   */
  queryContentFromReleaseByID(releaseID) {
    this.refState = {
      ...this.refState,
      mode: RefStateMode.ReleaseID,
      releaseID
    };
  }
  /**
   * Configures the client to query content from a specific Release identified
   * by its label for all future queries.
   *
   * If the `ref` parameter is provided during a query, it takes priority for
   * that query.
   *
   * @example
   *
   * ```ts
   * await client.queryContentFromReleaseByLabel("My Release");
   * const document = await client.getByID("WW4bKScAAMAqmluX");
   * ```
   *
   * @param releaseLabel - The label of the Release.
   */
  queryContentFromReleaseByLabel(releaseLabel) {
    this.refState = {
      ...this.refState,
      mode: RefStateMode.ReleaseLabel,
      releaseLabel
    };
  }
  /**
   * Configures the client to query content from a specific ref. The ref can be
   * provided as a string or a function.
   *
   * If a function is provided, the ref is fetched lazily before each query. The
   * function may also be asynchronous.
   *
   * @example
   *
   * ```ts
   * await client.queryContentFromRef("my-ref");
   * const document = await client.getByID("WW4bKScAAMAqmluX");
   * ```
   *
   * @param ref - The ref or a function that returns the ref from which to query
   *   content.
   */
  queryContentFromRef(ref) {
    this.refState = {
      ...this.refState,
      mode: RefStateMode.Manual,
      ref
    };
  }
  /**
   * A `fetch()` function to be used with GraphQL clients configured for
   * Prismic's GraphQL API. It automatically applies the necessary `prismic-ref`
   * and Authorization headers. Queries will automatically be minified by
   * removing whitespace where possible.
   *
   * @example
   *
   * ```ts
   * const graphQLClient = new ApolloClient({
   * 	link: new HttpLink({
   * 		uri: prismic.getGraphQLEndpoint(repositoryName),
   * 		// Provide `client.graphQLFetch` as the fetch implementation.
   * 		fetch: client.graphQLFetch,
   * 		// Using GET is required.
   * 		useGETForQueries: true,
   * 	}),
   * 	cache: new InMemoryCache(),
   * });
   * ```
   *
   * @param input - The `fetch()` `input` parameter. Only strings are supported.
   * @param init - The `fetch()` `init` parameter. Only plain objects are
   *   supported.
   *
   * @returns The `fetch()` Response for the request.
   *
   * @experimental
   */
  async graphQLFetch(input, init) {
    const cachedRepository = await this.getCachedRepository();
    const ref = await this.getResolvedRefString();
    const unsanitizedHeaders = {
      "Prismic-ref": ref,
      Authorization: this.accessToken ? `Token ${this.accessToken}` : "",
      // Asserting `init.headers` is a Record since popular GraphQL
      // libraries pass this as a Record. Header objects as input
      // are unsupported.
      ...init ? init.headers : {}
    };
    if (cachedRepository.integrationFieldsRef) {
      unsanitizedHeaders["Prismic-integration-field-ref"] = cachedRepository.integrationFieldsRef;
    }
    const headers = {};
    for (const key in unsanitizedHeaders) {
      if (unsanitizedHeaders[key]) {
        headers[key.toLowerCase()] = unsanitizedHeaders[key];
      }
    }
    const url = new URL(
      // Asserting `input` is a string since popular GraphQL
      // libraries pass this as a string. Request objects as
      // input are unsupported.
      input
    );
    url.searchParams.set("ref", ref);
    const query = url.searchParams.get("query");
    if (query) {
      url.searchParams.set(
        "query",
        // Compress the GraphQL query (if it exists) by
        // removing whitespace. This is done to
        // optimize the query size and avoid
        // hitting the upper limit of GET requests
        // (2048 characters).
        minifyGraphQLQuery(query)
      );
    }
    return await this.fetchFn(url.toString(), {
      ...init,
      headers
    });
  }
  /**
   * Returns a cached version of `getRepository` with a TTL.
   *
   * @returns Cached repository metadata.
   */
  async getCachedRepository(params) {
    if (!this.cachedRepository || Date.now() >= this.cachedRepositoryExpiration) {
      this.cachedRepositoryExpiration = Date.now() + REPOSITORY_CACHE_TTL;
      this.cachedRepository = await this.getRepository(params);
    }
    return this.cachedRepository;
  }
  /**
   * Returns a cached Prismic repository form. Forms are used to determine API
   * endpoints for types of repository data.
   *
   * @param name - Name of the form.
   *
   * @returns The repository form.
   *
   * @throws If a matching form cannot be found.
   */
  async getCachedRepositoryForm(name, params) {
    const cachedRepository = await this.getCachedRepository(params);
    const form = cachedRepository.forms[name];
    if (!form) {
      throw new PrismicError(`Form with name "${name}" could not be found`, void 0, void 0);
    }
    return form;
  }
  /**
   * Returns the ref needed to query based on the client's current state. This
   * method may make a network request to fetch a ref or resolve the user's ref
   * thunk.
   *
   * If auto previews are enabled, the preview ref takes priority if available.
   *
   * The following strategies are used depending on the client's state:
   *
   * - If the user called `queryLatestContent`: Use the repository's master ref.
   *   The ref is cached for 5 seconds. After 5 seconds, a new master ref is
   *   fetched.
   * - If the user called `queryContentFromReleaseByID`: Use the release's ref.
   *   The ref is cached for 5 seconds. After 5 seconds, a new ref for the
   *   release is fetched.
   * - If the user called `queryContentFromReleaseByLabel`: Use the release's ref.
   *   The ref is cached for 5 seconds. After 5 seconds, a new ref for the
   *   release is fetched.
   * - If the user called `queryContentFromRef`: Use the provided ref. Fall back
   *   to the master ref if the ref is not a string.
   *
   * @returns The ref to use during a query.
   */
  async getResolvedRefString(params) {
    var _a, _b;
    if (this.refState.autoPreviewsEnabled) {
      let previewRef;
      let cookieJar;
      if ((_a = this.refState.httpRequest) == null ? void 0 : _a.headers) {
        if ("get" in this.refState.httpRequest.headers && typeof this.refState.httpRequest.headers.get === "function") {
          cookieJar = this.refState.httpRequest.headers.get("cookie");
        } else if ("cookie" in this.refState.httpRequest.headers) {
          cookieJar = this.refState.httpRequest.headers.cookie;
        }
      } else if ((_b = globalThis.document) == null ? void 0 : _b.cookie) {
        cookieJar = globalThis.document.cookie;
      }
      if (cookieJar) {
        previewRef = getPreviewCookie(cookieJar);
      }
      if (previewRef) {
        return previewRef;
      }
    }
    const cachedRepository = await this.getCachedRepository(params);
    const refModeType = this.refState.mode;
    if (refModeType === RefStateMode.ReleaseID) {
      return findRefByID(cachedRepository.refs, this.refState.releaseID).ref;
    } else if (refModeType === RefStateMode.ReleaseLabel) {
      return findRefByLabel(cachedRepository.refs, this.refState.releaseLabel).ref;
    } else if (refModeType === RefStateMode.Manual) {
      const res = await castThunk(this.refState.ref)();
      if (typeof res === "string") {
        return res;
      }
    }
    return findMasterRef(cachedRepository.refs).ref;
  }
  /**
   * Performs a network request using the configured `fetch` function. It
   * assumes all successful responses will have a JSON content type. It also
   * normalizes unsuccessful network requests.
   *
   * @typeParam T - The JSON response.
   *
   * @param url - URL to the resource to fetch.
   * @param params - Prismic REST API parameters for the network request.
   *
   * @returns The JSON response from the network request.
   */
  async fetch(url, params = {}) {
    var _a, _b, _c, _d;
    const requestInit = {
      ...this.fetchOptions,
      ...params.fetchOptions,
      headers: {
        ...(_a = this.fetchOptions) == null ? void 0 : _a.headers,
        ...(_b = params.fetchOptions) == null ? void 0 : _b.headers
      },
      signal: ((_c = params.fetchOptions) == null ? void 0 : _c.signal) || params.signal || ((_d = this.fetchOptions) == null ? void 0 : _d.signal)
    };
    let job;
    if (this.fetchJobs[url] && this.fetchJobs[url].has(requestInit.signal)) {
      job = this.fetchJobs[url].get(requestInit.signal);
    } else {
      this.fetchJobs[url] = this.fetchJobs[url] || /* @__PURE__ */ new Map();
      job = this.fetchFn(url, requestInit).then(async (res2) => {
        let json = void 0;
        try {
          json = await res2.json();
        } catch {
        }
        return {
          status: res2.status,
          json
        };
      }).finally(() => {
        this.fetchJobs[url].delete(requestInit.signal);
        if (this.fetchJobs[url].size === 0) {
          delete this.fetchJobs[url];
        }
      });
      this.fetchJobs[url].set(requestInit.signal, job);
    }
    const res = await job;
    if (res.status !== 404 && res.json == null) {
      throw new PrismicError(void 0, url, res.json);
    }
    switch (res.status) {
      case 200: {
        return res.json;
      }
      case 400: {
        throw new ParsingError(res.json.message, url, res.json);
      }
      case 401:
      case 403: {
        throw new ForbiddenError("error" in res.json ? res.json.error : res.json.message, url, res.json);
      }
      case 404: {
        throw new NotFoundError(`Prismic repository not found. Check that "${this.endpoint}" is pointing to the correct repository.`, url, void 0);
      }
    }
    throw new PrismicError(void 0, url, res.json);
  }
}

//# sourceMappingURL=createClient.js.map

;// CONCATENATED MODULE: ./node_modules/apollo-link-prismic/dist/index.js



const createPrismicLink = (config) => {
  const {
    repositoryName: providedRepositoryName,
    fetch,
    accessToken,
    apiEndpoint: providedApiEndpoint,
    uri: providedURI,
    ...options
  } = config;
  let repositoryName = providedRepositoryName;
  if (!repositoryName && providedURI) {
    repositoryName = getRepositoryName(providedURI);
  }
  if (!repositoryName) {
    throw new Error("At least one of the following options are required for createPrismicLink(): repositoryName, uri. If a repositoryName option is not given, the uri option must be a standard, non-proxied Prismic GraphQL API URL including the repository name.");
  }
  const uri = providedURI || getGraphQLEndpoint(repositoryName);
  const apiEndpoint = providedApiEndpoint || getRepositoryEndpoint(repositoryName);
  const client = createClient(apiEndpoint, {
    fetch,
    accessToken
  });
  return (0,createHttpLink/* createHttpLink */.L)({
    uri,
    fetch: client.graphQLFetch,
    useGETForQueries: true,
    ...options
  });
};

const PrismicLink = (/* unused pure expression or super */ null && (createPrismicLink));


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
;// CONCATENATED MODULE: ./src/@prismic/graphql/prismic.possibleTypes.json
var prismic_possibleTypes_namespaceObject = JSON.parse('{"g":{"ArchitectBody":["ArchitectBodyArchitectreviews","ArchitectBodyBenefitsprogram","ArchitectBodyConsulttoolbox","ArchitectBodyFranchisecontact","ArchitectBodyInspiration","ArchitectBodyInstagram_posts","ArchitectBodyShowroom"],"BannersBody":["BannersBodyBenefit"],"Blog_homeBody1":["Blog_homeBody1Iconbanner"],"Blog_postBody":["Blog_postBodyAccordeon","Blog_postBodyContent_photo_photo","Blog_postBodyContent_photo_photo_50","Blog_postBodyContent_photo_text","Blog_postBodyContent_photo_text_30_60","Blog_postBodyContent_text_photo_60_30","Blog_postBodyContent_text_text_50","Blog_postBodyDownloadfiles","Blog_postBodyExcerpt","Blog_postBodyFormembded","Blog_postBodyHeroimg","Blog_postBodyHtmlembded","Blog_postBodyIconbanner","Blog_postBodyIconcta","Blog_postBodyImagecard","Blog_postBodyImagecta","Blog_postBodyLinkbutton","Blog_postBodyMediaslider","Blog_postBodyOurpartners","Blog_postBodyQuote","Blog_postBodyRelatedproducts","Blog_postBodyRichtext","Blog_postBodyTagimage"],"Blog_postBody1":["Blog_postBody1Facebook__open_graph_","Blog_postBody1Twitter_card"],"CartsliderBody":["CartsliderBodySlidelist"],"CategorySocial":["CategorySocialOpen_graph","CategorySocialPinterest","CategorySocialTwitter_card"],"ContactBody":["ContactBodyGallery","ContactBodySeparator","ContactBodyText_block","ContactBodyText_featured","ContactBodyVideo"],"ContactSocial":["ContactSocialOpen_graph","ContactSocialPinterest","ContactSocialTwitter_card"],"FaqBody":["FaqBodyGallery","FaqBodySeparator","FaqBodyText_block","FaqBodyText_featured","FaqBodyVideo"],"FaqSocial":["FaqSocialOpen_graph","FaqSocialPinterest","FaqSocialTwitter_card"],"HelpBody":["HelpBodyCode_snippet","HelpBodyHighlighted_text","HelpBodyImage","HelpBodyText"],"HomepageBody":["HomepageBodyBenefits","HomepageBodyCollections","HomepageBodyCta","HomepageBodyImagecard","HomepageBodyImagecta","HomepageBodyInspiration","HomepageBodyInstagram_posts","HomepageBodyLinkbutton","HomepageBodyReviews","HomepageBodyTrusted"],"HomepageSocial":["HomepageSocialOpen_graph","HomepageSocialPinterest","HomepageSocialTwitter_card"],"Landing_pageBody":["Landing_pageBodyBanner_split","Landing_pageBodyBig_bullet_item","Landing_pageBodyProduct_quote"],"Landing_pageBody1":["Landing_pageBody1Facebook__open_graph_","Landing_pageBody1Twitter_card"],"LayoutFooter_navigation":["LayoutFooter_navigationNav_group"],"LayoutHeader_navigation":["LayoutHeader_navigationNav_item"],"PageBody":["PageBodyAccordion","PageBodyContent_photo_photo","PageBodyContent_photo_photo_50","PageBodyContent_photo_text","PageBodyContent_photo_text_30_60","PageBodyContent_text_photo_60_30","PageBodyContent_text_text_50","PageBodyDownloadfiles","PageBodyExcerpt","PageBodyFormembded","PageBodyHeroimg","PageBodyHtmlembded","PageBodyIconbanner","PageBodyIconcta","PageBodyImagecard","PageBodyImagecta","PageBodyLinkbutton","PageBodyMediaslider","PageBodyOurpartners","PageBodyQuote","PageBodyRelatedproducts","PageBodyRichtext","PageBodyTagimage"],"PostBody":["PostBodyGallery","PostBodySeparator","PostBodyText_block","PostBodyText_featured","PostBodyVideo"],"PostSocial":["PostSocialOpen_graph","PostSocialPinterest","PostSocialTwitter_card"],"PrismicpageBody":["PrismicpageBodyBenefits","PrismicpageBodyColor_sample","PrismicpageBodyCta","PrismicpageBodyInspiration","PrismicpageBodyInstagram","PrismicpageBodyTrusted"],"ProductBody":["ProductBodyColor_sample","ProductBodyInspiration","ProductBodyInstagram_posts","ProductBodyLabeled_icons","ProductBodyProduct_details","ProductBodyProduct_features"],"ProductattributesBody":["ProductattributesBodyTabs"],"ProductsBody":["ProductsBodyBenefit"],"ProductsProduct_page":["ProductsProduct_pageColor_sample","ProductsProduct_pageInstagram"],"ProjectBody":["ProjectBodyLinkedproducts","ProjectBodyRelatedproducts"],"ProjectsBody":["ProjectsBodyGeneral_card","ProjectsBodyPinterest_product_pin","ProjectsBodyTwitter_card"],"SliceBody":["SliceBodyTestslice"],"WishlistBody":["WishlistBodyColor_sample"],"_Document":["Architect","Banners","Blog_category","Blog_content","Blog_home","Blog_post","Cartslider","Category","Contact","Contacts","Defaultseo","Doors","Faq","Help","Homepage","Instagram","Landing_page","Layout","Page","Pageschema_1","Pagetest","Post","Prismicpage","Product","Productattributes","Productimages","Products","Project","Projectcategory","Projectcolor","Projectdesignerlink","Projectglasstype","Projects","Projecttag","Projectwidth","Realisation","Reviews","Slice","Tag","Taxonomy","Test","Wishlist"],"_Linkable":["Architect","Banners","Blog_category","Blog_content","Blog_home","Blog_post","Cartslider","Category","Contact","Contacts","Defaultseo","Doors","Faq","Help","Homepage","Instagram","Landing_page","Layout","Page","Pageschema_1","Pagetest","Post","Prismicpage","Product","Productattributes","Productimages","Products","Project","Projectcategory","Projectcolor","Projectdesignerlink","Projectglasstype","Projects","Projecttag","Projectwidth","Realisation","Reviews","Slice","Tag","Taxonomy","Test","Wishlist","_ExternalLink","_FileLink","_ImageLink"]}}');
;// CONCATENATED MODULE: ./src/@prismic/prismic-config.ts







var onErrorLink = onError(function(param) {
    var graphQLErrors = param.graphQLErrors, networkError = param.networkError;
    if (graphQLErrors) {
        graphQLErrors.map(function(param) {
            var message = param.message, locations = param.locations, path = param.path;
            return console.error("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
        });
    }
    if (networkError) {
        console.error("[Network error]: ".concat(networkError));
    }
});
var prismicLink = createPrismicLink({
    repositoryName: constants/* prismicUri */.CZ
});
var prismic_config_link = ApolloLink/* ApolloLink.from */.i.from([
    onErrorLink,
    prismicLink
]);
var prismicApolloClient = new ApolloClient/* ApolloClient */.f({
    cache: new inMemoryCache/* InMemoryCache */.h({
        possibleTypes: prismic_possibleTypes_namespaceObject.g
    }),
    link: prismic_config_link
});
var linkResolver = function(linkable) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    if (linkable && "url" in linkable) {
        return linkable.url || "";
    }
    if (linkable && "_meta" in linkable && (linkable === null || linkable === void 0 ? void 0 : (ref = linkable._meta) === null || ref === void 0 ? void 0 : ref.type) === "contacts") {
        return paths/* paths.contacts */.H.contacts;
    }
    if (linkable && "_meta" in linkable && (linkable === null || linkable === void 0 ? void 0 : (ref1 = linkable._meta) === null || ref1 === void 0 ? void 0 : ref1.type) === "architect") {
        return paths/* paths.architect */.H.architect;
    }
    if (linkable && "_meta" in linkable && (linkable === null || linkable === void 0 ? void 0 : (ref2 = linkable._meta) === null || ref2 === void 0 ? void 0 : ref2.type) === "reviews") {
        return paths/* paths.reviews */.H.reviews;
    }
    if (linkable && "_meta" in linkable && (linkable === null || linkable === void 0 ? void 0 : (ref3 = linkable._meta) === null || ref3 === void 0 ? void 0 : ref3.type) === "blog_home") {
        return paths/* paths.blog */.H.blog;
    }
    if (linkable && "_meta" in linkable && (linkable === null || linkable === void 0 ? void 0 : (ref4 = linkable._meta) === null || ref4 === void 0 ? void 0 : ref4.type) === "blog_post" && (linkable === null || linkable === void 0 ? void 0 : (ref5 = linkable._meta) === null || ref5 === void 0 ? void 0 : ref5.uid)) {
        return (0,core/* generatePath */.Gn)(paths/* paths.blogPost */.H.blogPost, {
            slug: linkable._meta.uid
        });
    }
    if (linkable && "_meta" in linkable && (linkable === null || linkable === void 0 ? void 0 : (ref6 = linkable._meta) === null || ref6 === void 0 ? void 0 : ref6.type) === "realisation") {
        return paths/* paths.inspirations */.H.inspirations;
    }
    if (linkable && "_meta" in linkable && (linkable === null || linkable === void 0 ? void 0 : (ref7 = linkable._meta) === null || ref7 === void 0 ? void 0 : ref7.type) === "project" && (linkable === null || linkable === void 0 ? void 0 : (ref8 = linkable._meta) === null || ref8 === void 0 ? void 0 : ref8.uid)) {
        return (0,core/* generatePath */.Gn)(paths/* paths.inspirationsPost */.H.inspirationsPost, {
            slug: linkable._meta.uid
        });
    }
    if (linkable && "_meta" in linkable && (linkable === null || linkable === void 0 ? void 0 : (ref9 = linkable._meta) === null || ref9 === void 0 ? void 0 : ref9.uid)) {
        return (0,core/* generatePath */.Gn)(paths/* paths.page */.H.page, {
            slug: linkable._meta.uid
        });
    }
    return "";
};
var imageResolver = function(url) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (origin) {
        return url;
    }
    var MEDIA_BUCKET_URL = "https://images.renodoors.eu/" || 0;
    var newUrl = new URL(url || "");
    var mediaUrl = new URL(MEDIA_BUCKET_URL || "");
    newUrl.hostname = mediaUrl.hostname;
    return newUrl.href;
};


/***/ }),

/***/ 27941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useSaleorAuthContext; },
/* harmony export */   "s": function() { return /* binding */ SaleorAuthProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ts_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66128);
/* harmony import */ var _hooks_useSafeContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72827);




var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useSafeContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 2), useSaleorAuthContext = ref[0], Provider = ref[1];

var SaleorAuthProvider = function(param) {
    var children = param.children, saleorAuthClient = param.saleorAuthClient, isAuthenticating = param.isAuthenticating;
    (0,ts_invariant__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(saleorAuthClient, "Missing Saleor Auth Client - are you sure you created it using useSaleorAuthClient?");
    var signIn = saleorAuthClient.signIn, signOut = saleorAuthClient.signOut, resetPassword = saleorAuthClient.resetPassword;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: {
            isAuthenticating: isAuthenticating,
            signIn: signIn,
            signOut: signOut,
            resetPassword: resetPassword
        },
        children: children
    });
};


/***/ }),

/***/ 73134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ useAccountConfirmMutation; },
  "We": function() { return /* binding */ useAccountRegisterMutation; },
  "_l": function() { return /* binding */ useAccountUpdateMutation; },
  "O9": function() { return /* binding */ useAddCheckoutLineMutation; },
  "oi": function() { return /* binding */ useAddCheckoutPromoCodeMutation; },
  "eK": function() { return /* binding */ useAddWishlistProductVariantMutation; },
  "LY": function() { return /* binding */ useCartProductDetailsQuery; },
  "Co": function() { return /* binding */ useCartProductEstimatedShippingQuery; },
  "tj": function() { return /* binding */ useCategoryCardsQuery; },
  "xk": function() { return /* binding */ useCategoryReviewsQuery; },
  "Jt": function() { return /* binding */ useCheckoutDetailsByTokenQuery; },
  "xl": function() { return /* binding */ useCompleteCheckoutMutation; },
  "F9": function() { return /* binding */ useCreateCheckoutMutation; },
  "yV": function() { return /* binding */ useCreateCheckoutPaymentMutation; },
  "F3": function() { return /* binding */ useCreateReviewMutation; },
  "lz": function() { return /* binding */ useCreateUserAddressMutation; },
  "t4": function() { return /* binding */ useDeleteUserAddressMutation; },
  "uu": function() { return /* binding */ useGetShopQuery; },
  "TK": function() { return /* binding */ useInitializePaymentMutation; },
  "ck": function() { return /* binding */ useMainMenuQuery; },
  "Y$": function() { return /* binding */ useOrderByTokenQuery; },
  "AG": function() { return /* binding */ useOrdersByUserQuery; },
  "O": function() { return /* binding */ usePasswordChangeMutation; },
  "Gs": function() { return /* binding */ useProductCategoryDetailsQuery; },
  "J0": function() { return /* binding */ useProductListLazyQuery; },
  "te": function() { return /* binding */ useProductListQuery; },
  "uM": function() { return /* binding */ useRemoveCheckoutLineMutation; },
  "z0": function() { return /* binding */ useRemoveCheckoutPromoCodeMutation; },
  "rp": function() { return /* binding */ useRemoveWishlistProductVariantMutation; },
  "IS": function() { return /* binding */ useResetPasswordRequestMutation; },
  "_T": function() { return /* binding */ useReviewRatingQuery; },
  "_s": function() { return /* binding */ useReviewsQuery; },
  "iL": function() { return /* binding */ useSendContactUsMutation; },
  "vb": function() { return /* binding */ useSetCustomerDefaultAddressMutation; },
  "zg": function() { return /* binding */ useUpdateCheckoutBillingAddressMutation; },
  "bE": function() { return /* binding */ useUpdateCheckoutLineMutation; },
  "Jo": function() { return /* binding */ useUpdateCheckoutNoteMutation; },
  "Ou": function() { return /* binding */ useUpdateCheckoutShippingAddressMutation; },
  "KF": function() { return /* binding */ useUpdateCheckoutShippingMethodMutation; },
  "m0": function() { return /* binding */ useUpdateUserAddressMutation; },
  "pv": function() { return /* binding */ useUserDetailsQuery; },
  "TX": function() { return /* binding */ useWishlistQuery; }
});

// UNUSED EXPORTS: AccountConfirmDocument, AccountErrorFragmentDoc, AccountRegisterDocument, AccountUpdateDocument, AddCheckoutLineDocument, AddCheckoutPromoCodeDocument, AddWishlistProductVariantDocument, AddressDetailsFragmentDoc, AttributeBaseFragmentDoc, AttributeFragmentDoc, AttributeValueDetailsFragmentDoc, AttributeValueFragmentDoc, CartProductDetailsDocument, CartProductEstimatedShippingDocument, CategoryBaseFragmentDoc, CategoryCardFragmentDoc, CategoryCardsDocument, CategoryReviewsDocument, CheckoutDetailsByTokenDocument, CheckoutDetailsFragmentDoc, CheckoutErrorFragmentDoc, CheckoutLineFragmentDoc, CollectionBaseFragmentDoc, CollectionDetailsDocument, CollectionDetailsFragmentDoc, CollectionPathsDocument, CompleteCheckoutDocument, CreateCheckoutDocument, CreateCheckoutPaymentDocument, CreateReviewDocument, CreateUserAddressDocument, DeleteUserAddressDocument, GetShopDocument, ImageFragmentDoc, InitializePaymentDocument, MainMenuDocument, MainMenuItemFragmentDoc, OrderBaseFragmentDoc, OrderByTokenDocument, OrderDetailsFragmentDoc, OrderLineFragmentDoc, OrdersByUserDocument, PasswordChangeDocument, PaymentErrorFragmentDoc, PaymentFragmentDoc, PaymentGatewayFragmentDoc, PriceFragmentDoc, ProductBaseFragmentDoc, ProductCardFragmentDoc, ProductCategoryDetailsDocument, ProductCheckoutFragmentDoc, ProductDefaultAttributesFragmentDoc, ProductDetailsDocument, ProductDetailsFragmentDoc, ProductListDocument, ProductMinimalFragmentDoc, ProductPathsDocument, ProductPricingFragmentDoc, ProductTypeBaseFragmentDoc, ProductTypeFragmentDoc, ProductVariantCardFragmentDoc, ProductVariantCheckoutFragmentDoc, ProductVariantDetailsFragmentDoc, ProductVariantWishlistFragmentDoc, RemoveCheckoutLineDocument, RemoveCheckoutPromoCodeDocument, RemoveWishlistProductVariantDocument, ResetPasswordRequestDocument, ReviewBaseFragmentDoc, ReviewDetailsFragmentDoc, ReviewImageFragmentDoc, ReviewRatingDocument, ReviewsDocument, SelectedAttributeFragmentDoc, SelectedAttributeValueFragmentDoc, SendContactUsDocument, SetCustomerDefaultAddressDocument, ShippingMethodFragmentDoc, UpdateCheckoutBillingAddressDocument, UpdateCheckoutLineDocument, UpdateCheckoutNoteDocument, UpdateCheckoutShippingAddressDocument, UpdateCheckoutShippingMethodDocument, UpdateUserAddressDocument, UserDetailsDocument, UserFragmentDoc, WishlistDocument, WishlistErrorFragmentDoc, WishlistItemFragmentDoc, WishlistItemProductAttributeFragmentDoc, useCartProductDetailsLazyQuery, useCartProductEstimatedShippingLazyQuery, useCategoryCardsLazyQuery, useCategoryReviewsLazyQuery, useCheckoutDetailsByTokenLazyQuery, useCollectionDetailsLazyQuery, useCollectionDetailsQuery, useCollectionPathsLazyQuery, useCollectionPathsQuery, useGetShopLazyQuery, useMainMenuLazyQuery, useOrderByTokenLazyQuery, useOrdersByUserLazyQuery, useProductCategoryDetailsLazyQuery, useProductDetailsLazyQuery, useProductDetailsQuery, useProductPathsLazyQuery, useProductPathsQuery, useReviewRatingLazyQuery, useReviewsLazyQuery, useUserDetailsLazyQuery, useWishlistLazyQuery

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 9 modules
var lib = __webpack_require__(22865);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/index.js
var equality_lib = __webpack_require__(30020);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(14692);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js







function useMutation(mutation, options) {
    var client = (0,useApolloClient/* useApolloClient */.x)(options === null || options === void 0 ? void 0 : options.client);
    (0,parser/* verifyDocumentType */.Vp)(mutation, parser/* DocumentType.Mutation */.n_.Mutation);
    var _a = (0,react.useState)({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = (0,react.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = (0,react.useCallback)(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { mutation: mutation });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,mergeOptions/* mergeOptions */.J)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new client_errors/* ApolloError */.cA({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,equality_lib/* equal */.D)(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            var onCompleted = executeOptions.onCompleted || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted);
            onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(response.data, clientOptions);
            return response;
        }).catch(function (error) {
            var _a;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,equality_lib/* equal */.D)(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = (0,react.useCallback)(function () {
        if (ref.current.isMounted) {
            setResult({ called: false, loading: false, client: client });
        }
    }, []);
    (0,react.useEffect)(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib_es6.__assign)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
;// CONCATENATED MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx
/* tslint:disable */ /* eslint-disable */ /* THIS FILE IS GENERATED WITH `npm run codegen-saleor` */ 

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment AccountErrorFragment on AccountError {\n  code\n  field\n  message\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment AttributeBaseFragment on Attribute {\n  id\n  name\n  translation(languageCode: $languageCode) {\n    name\n  }\n  slug\n  inputType\n  choiceType\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment AttributeValueFragment on AttributeValue {\n  id\n  name\n  translation(languageCode: $languageCode) {\n    name\n  }\n  slug\n  value: name\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment AttributeFragment on Attribute {\n  ...AttributeBaseFragment\n  values {\n    ...AttributeValueFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment CategoryBaseFragment on Category {\n  id\n  name\n  slug\n  translation(languageCode: $languageCode) {\n    name\n  }\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ImageFragment on Image {\n  url\n  alt\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment CategoryCardFragment on Category {\n  ...CategoryBaseFragment\n  backgroundImage {\n    ...ImageFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment AddressDetailsFragment on Address {\n  id\n  firstName\n  lastName\n  companyName\n  streetAddress1\n  streetAddress2\n  city\n  postalCode\n  country {\n    code\n    country\n  }\n  countryArea\n  phone\n  isDefaultBillingAddress\n  isDefaultShippingAddress\n  vatNumber\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ShippingMethodFragment on ShippingMethod {\n  id\n  name\n  translation(languageCode: $languageCode) {\n    name\n  }\n  price {\n    currency\n    amount\n  }\n}\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PriceFragment on TaxedMoney {\n  gross {\n    amount\n    currency\n  }\n  net {\n    amount\n    currency\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment AttributeValueDetailsFragment on AttributeValue {\n  ...AttributeValueFragment\n  image {\n    ...ImageFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment SelectedAttributeFragment on SelectedAttribute {\n  attribute {\n    ...AttributeBaseFragment\n  }\n  values {\n    ...AttributeValueDetailsFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductBaseFragment on Product {\n  id\n  name\n  slug\n  translation(languageCode: $languageCode) {\n    name\n  }\n  thumbnail {\n    ...ImageFragment\n  }\n  thumbnail2x: thumbnail(size: 510) {\n    url\n  }\n}\n    ",
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductCheckoutFragment on Product {\n  ...ProductBaseFragment\n  attributes {\n    ...SelectedAttributeFragment\n  }\n  category {\n    ...CategoryBaseFragment\n  }\n  productType {\n    id\n    isShippingRequired\n    slug\n    name\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment SelectedAttributeValueFragment on SelectedAttributeValue {\n  attribute {\n    id\n    name\n    slug\n    translation(languageCode: $languageCode) {\n      name\n    }\n    values {\n      name\n      slug\n      translation(languageCode: $languageCode) {\n        name\n      }\n    }\n  }\n  values\n}\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment CheckoutLineFragment on CheckoutLine {\n  id\n  selectedProductAttributes\n  quantity\n  variant {\n    id\n    name\n    translation(languageCode: $languageCode) {\n      name\n    }\n    sku\n    quantityAvailable\n    isAvailable\n    pricing {\n      onSale\n      priceUndiscounted {\n        ...PriceFragment\n      }\n      price {\n        ...PriceFragment\n      }\n    }\n    id\n    attributes {\n      ...SelectedAttributeFragment\n    }\n    product {\n      ...ProductCheckoutFragment\n    }\n  }\n  totalPrice {\n    currency\n    ...PriceFragment\n  }\n  productAttributes {\n    ...SelectedAttributeValueFragment\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PaymentGatewayFragment on PaymentGateway {\n  id\n  name\n  config {\n    field\n    value\n  }\n  currencies\n}\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment CheckoutDetailsFragment on Checkout {\n  id\n  token\n  email\n  billingAddress {\n    ...AddressDetailsFragment\n  }\n  shippingAddress {\n    ...AddressDetailsFragment\n  }\n  availableShippingMethods {\n    ...ShippingMethodFragment\n  }\n  shippingMethod {\n    ...ShippingMethodFragment\n  }\n  isShippingRequired\n  lines {\n    ...CheckoutLineFragment\n  }\n  subtotalPrice {\n    ...PriceFragment\n  }\n  totalPrice {\n    ...PriceFragment\n  }\n  shippingPrice {\n    ...PriceFragment\n  }\n  discount {\n    amount\n    currency\n  }\n  discountName\n  translatedDiscountName\n  voucherCode\n  note\n  deliveryNote\n  availablePaymentGateways {\n    ...PaymentGatewayFragment\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment CheckoutErrorFragment on CheckoutError {\n  code\n  field\n  message\n}\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment CollectionBaseFragment on Collection {\n  id\n  name\n  slug\n  translation(languageCode: $languageCode) {\n    name\n  }\n}\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment CollectionDetailsFragment on Collection {\n  id\n  ...CollectionBaseFragment\n  seoTitle\n  seoDescription\n  description\n  backgroundImage {\n    ...ImageFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MainMenuItemFragment on MenuItem {\n  id\n  name\n  url\n  translation(languageCode: $languageCode) {\n    name\n  }\n  category {\n    id\n    name\n    backgroundImage {\n      url\n    }\n    translation(languageCode: $languageCode) {\n      name\n    }\n  }\n  collection {\n    id\n    name\n    backgroundImage {\n      url\n    }\n    translation(languageCode: $languageCode) {\n      name\n    }\n  }\n  page {\n    slug\n  }\n  parent {\n    id\n  }\n}\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment OrderBaseFragment on Order {\n  id\n  token\n  created\n  number\n  status\n  total {\n    currency\n    ...PriceFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment OrderLineFragment on OrderLine {\n  id\n  productName\n  selectedProductAttributes\n  quantity\n  variant {\n    id\n    attributes {\n      ...SelectedAttributeFragment\n    }\n    product {\n      ...ProductBaseFragment\n    }\n  }\n  unitPrice {\n    currency\n    ...PriceFragment\n  }\n  totalPrice {\n    currency\n    ...PriceFragment\n  }\n  thumbnail {\n    ...ImageFragment\n  }\n  thumbnail2x: thumbnail(size: 510) {\n    ...ImageFragment\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment OrderDetailsFragment on Order {\n  id\n  userEmail\n  token\n  number\n  statusDisplay\n  status\n  paymentStatusDisplay\n  paymentStatus\n  billingAddress {\n    ...AddressDetailsFragment\n  }\n  shippingAddress {\n    ...AddressDetailsFragment\n  }\n  created\n  lines {\n    ...OrderLineFragment\n  }\n  subtotal {\n    ...PriceFragment\n  }\n  total {\n    ...PriceFragment\n  }\n  shippingPrice {\n    ...PriceFragment\n  }\n  discount {\n    amount\n    currency\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PaymentErrorFragment on PaymentError {\n  code\n  field\n  message\n}\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PaymentFragment on Payment {\n  id\n  gateway\n  token\n  creditCard {\n    brand\n    firstDigits\n    lastDigits\n    expMonth\n    expYear\n  }\n  total {\n    amount\n    currency\n  }\n}\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductPricingFragment on Product {\n  pricing {\n    onSale\n    priceRangeUndiscounted {\n      start {\n        ...PriceFragment\n      }\n      stop {\n        ...PriceFragment\n      }\n    }\n    priceRange {\n      start {\n        ...PriceFragment\n      }\n      stop {\n        ...PriceFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductDefaultAttributesFragment on Product {\n  defaultAttributes {\n    id\n    attributeType\n    attribute {\n      id\n      name\n      slug\n    }\n    defaultValue {\n      id\n      name\n    }\n  }\n}\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductVariantCardFragment on ProductVariant {\n  id\n  attributes {\n    attribute {\n      id\n      name\n      slug\n    }\n    values {\n      id\n      name\n      slug\n    }\n  }\n  pricing {\n    price {\n      gross {\n        amount\n        currency\n      }\n      net {\n        amount\n        currency\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductTypeBaseFragment on ProductType {\n  name\n  slug\n  shippingMax\n  shippingMin\n  shippingDateType\n  estimatedShipping\n  hasVariants\n  isPriceFormula\n  priceFormula\n}\n    "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductCardFragment on Product {\n  ...ProductBaseFragment\n  ...ProductPricingFragment\n  ...ProductDefaultAttributesFragment\n  defaultVariant {\n    ...ProductVariantCardFragment\n  }\n  category {\n    ...CategoryBaseFragment\n  }\n  productType {\n    ...ProductTypeBaseFragment\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductVariantDetailsFragment on ProductVariant {\n  id\n  isAvailable\n  quantityAvailable(countryCode: $countryCode)\n  images {\n    id\n    url\n    alt\n  }\n  pricing {\n    onSale\n    priceUndiscounted {\n      ...PriceFragment\n    }\n    price {\n      ...PriceFragment\n    }\n  }\n  attributes {\n    ...SelectedAttributeFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ReviewImageFragment on ReviewImage {\n  url\n  alt\n}\n    "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ReviewBaseFragment on Review {\n  id\n  avatar\n  title\n  fullName\n  description\n  rating\n  createdAt\n  publicationDate\n  thumbnail {\n    url\n    alt\n  }\n  product {\n    id\n    name\n    slug\n    translation(languageCode: $languageCode) {\n      name\n    }\n    images {\n      id\n      url\n      alt\n    }\n  }\n  category {\n    ...CategoryBaseFragment\n  }\n  images {\n    ...ReviewImageFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductDetailsFragment on Product {\n  ...ProductBaseFragment\n  seoDescription\n  seoTitle\n  descriptionJson\n  translation(languageCode: $languageCode) {\n    seoTitle\n    seoDescription\n  }\n  ...ProductPricingFragment\n  ...ProductDefaultAttributesFragment\n  category {\n    ...CategoryBaseFragment\n  }\n  images {\n    id\n    url\n    alt\n  }\n  attributes {\n    ...SelectedAttributeFragment\n  }\n  variants {\n    ...ProductVariantDetailsFragment\n  }\n  productType {\n    ...ProductTypeBaseFragment\n  }\n  reviews(first: 5) {\n    edges {\n      node {\n        ...ReviewBaseFragment\n      }\n    }\n  }\n  isAvailable\n  isAvailableForPurchase\n  availableForPurchase\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductMinimalFragment on Product {\n  id\n  name\n  slug\n  translation(languageCode: $languageCode) {\n    name\n  }\n}\n    "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductTypeFragment on ProductType {\n  name\n  slug\n  shippingMax\n  shippingMin\n  shippingDateType\n  estimatedShipping\n  variantAttributes {\n    id\n    name\n    slug\n    translation(languageCode: $languageCode) {\n      name\n    }\n    values {\n      name\n      translation(languageCode: $languageCode) {\n        name\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductVariantCheckoutFragment on ProductVariant {\n  id\n  sku\n  name\n  translation(languageCode: $languageCode) {\n    name\n  }\n  isAvailable\n  quantityAvailable(countryCode: $countryCode)\n  images {\n    id\n    url\n    alt\n  }\n  pricing {\n    onSale\n    priceUndiscounted {\n      ...PriceFragment\n    }\n    price {\n      ...PriceFragment\n    }\n  }\n  attributes {\n    ...SelectedAttributeFragment\n  }\n  product {\n    ...ProductCheckoutFragment\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ReviewDetailsFragment on Review {\n  ...ReviewBaseFragment\n  email\n  isPublished\n  isIncentivised\n}\n    ",
        ""
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment UserFragment on User {\n  id\n  email\n  firstName\n  lastName\n  isStaff\n  defaultShippingAddress {\n    ...AddressDetailsFragment\n  }\n  defaultBillingAddress {\n    ...AddressDetailsFragment\n  }\n  addresses {\n    ...AddressDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment WishlistErrorFragment on WishlistError {\n  code\n  field\n  message\n}\n    "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductVariantWishlistFragment on ProductVariant {\n  id\n  isAvailable\n  images {\n    id\n    url\n    alt\n  }\n  pricing {\n    onSale\n    priceUndiscounted {\n      ...PriceFragment\n    }\n    price {\n      ...PriceFragment\n    }\n  }\n  attributes {\n    ...SelectedAttributeFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment WishlistItemProductAttributeFragment on SelectedAttributeValue {\n  attribute {\n    id\n    name\n    slug\n    translation(languageCode: $languageCode) {\n      name\n    }\n    values {\n      name\n      translation(languageCode: $languageCode) {\n        name\n      }\n    }\n  }\n  values\n}\n    "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment WishlistItemFragment on WishlistItem {\n  variant {\n    product {\n      ...ProductBaseFragment\n      category {\n        ...CategoryBaseFragment\n      }\n      attributes {\n        ...SelectedAttributeFragment\n      }\n      productType {\n        name\n        slug\n      }\n    }\n    ...ProductVariantWishlistFragment\n  }\n  productAttributes {\n    ...WishlistItemProductAttributeFragment\n  }\n}\n    ",
        "\n",
        "\n",
        "\n",
        "\n",
        ""
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AccountConfirm($email: String!, $token: String!) {\n  confirmAccount(email: $email, token: $token) {\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AccountRegister($email: String!, $password: String!, $redirectUrl: String!) {\n  accountRegister(\n    input: {email: $email, password: $password, redirectUrl: $redirectUrl}\n  ) {\n    accountErrors {\n      field\n      message\n      code\n    }\n    requiresConfirmation\n  }\n}\n    "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AccountUpdate($input: AccountInput!) {\n  accountUpdate(input: $input) {\n    user {\n      ...UserFragment\n    }\n    accountErrors {\n      field\n      message\n      code\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AddCheckoutLine($checkoutId: ID!, $lines: [CheckoutLineInput]!, $languageCode: LanguageCodeEnum!) {\n  checkoutLinesAdd(checkoutId: $checkoutId, lines: $lines) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AddCheckoutPromoCode($checkoutId: ID!, $promoCode: String!, $languageCode: LanguageCodeEnum!) {\n  checkoutAddPromoCode(checkoutId: $checkoutId, promoCode: $promoCode) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n    }\n    checkoutErrors {\n      ...CheckoutErrorFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AddWishlistProductVariant($email: String, $variantId: ID!, $productAttributes: [SelectedAttributeValueInput], $languageCode: LanguageCodeEnum!) {\n  wishlistAddVariant(\n    email: $email\n    variantId: $variantId\n    productAttributes: $productAttributes\n  ) {\n    wishlist {\n      ...WishlistItemFragment\n    }\n    errors {\n      field\n      message\n    }\n    wishlistErrors {\n      code\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CompleteCheckout($checkoutId: ID!, $languageCode: LanguageCodeEnum!) {\n  checkoutComplete(checkoutId: $checkoutId) {\n    errors {\n      field\n      message\n    }\n    order {\n      ...OrderDetailsFragment\n    }\n    confirmationNeeded\n    confirmationData\n  }\n}\n    ",
        ""
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateCheckout($checkoutInput: CheckoutCreateInput!, $languageCode: LanguageCodeEnum!) {\n  checkoutCreate(input: $checkoutInput) {\n    errors {\n      field\n      message\n    }\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateCheckoutPayment($checkoutId: ID!, $paymentInput: PaymentInput!, $languageCode: LanguageCodeEnum!) {\n  checkoutPaymentCreate(checkoutId: $checkoutId, input: $paymentInput) {\n    errors {\n      field\n      message\n    }\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    payment {\n      ...PaymentFragment\n    }\n    paymentErrors {\n      ...PaymentErrorFragment\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateReview($input: ReviewInput!) {\n  reviewCreate(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateUserAddress($input: AddressInput!) {\n  accountAddressCreate(input: $input) {\n    user {\n      ...UserFragment\n    }\n    accountErrors {\n      field\n      message\n      code\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation DeleteUserAddress($addressId: ID!) {\n  accountAddressDelete(id: $addressId) {\n    user {\n      ...UserFragment\n    }\n    accountErrors {\n      field\n      message\n      code\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation InitializePayment($checkoutId: ID!, $gateway: String!, $paymentData: JSONString) {\n  paymentInitialize(\n    checkoutId: $checkoutId\n    gateway: $gateway\n    paymentData: $paymentData\n  ) {\n    initializedPayment {\n      gateway\n      name\n      data\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation PasswordChange($newPassword: String!, $oldPassword: String!) {\n  passwordChange(newPassword: $newPassword, oldPassword: $oldPassword) {\n    accountErrors {\n      field\n      message\n      code\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    "
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveCheckoutLine($checkoutId: ID!, $lineId: ID!, $languageCode: LanguageCodeEnum!) {\n  checkoutLineDelete(checkoutId: $checkoutId, lineId: $lineId) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveCheckoutPromoCode($checkoutId: ID!, $promoCode: String!, $languageCode: LanguageCodeEnum!) {\n  checkoutRemovePromoCode(checkoutId: $checkoutId, promoCode: $promoCode) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n    }\n    checkoutErrors {\n      ...CheckoutErrorFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveWishlistProductVariant($email: String, $variantId: ID!, $productAttributes: [SelectedAttributeValueInput], $languageCode: LanguageCodeEnum!) {\n  wishlistRemoveVariant(\n    email: $email\n    variantId: $variantId\n    productAttributes: $productAttributes\n  ) {\n    wishlist {\n      ...WishlistItemFragment\n    }\n    errors {\n      field\n      message\n    }\n    wishlistErrors {\n      code\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation ResetPasswordRequest($email: String!, $redirectUrl: String!) {\n  requestPasswordReset(email: $email, redirectUrl: $redirectUrl) {\n    accountErrors {\n      field\n      message\n      code\n    }\n  }\n}\n    "
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SendContactUs($subject: String!, $message: String!, $email: String!) {\n  sendContactUs(subject: $subject, message: $message, customerEmail: $email) {\n    errors {\n      field\n      message\n    }\n    shopErrors {\n      field\n      message\n      code\n    }\n  }\n}\n    "
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SetCustomerDefaultAddress($id: ID!, $type: AddressTypeEnum!) {\n  accountSetDefaultAddress(id: $id, type: $type) {\n    user {\n      ...UserFragment\n    }\n    accountErrors {\n      field\n      message\n      code\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCheckoutBillingAddress($checkoutId: ID!, $billingAddress: AddressInput!, $languageCode: LanguageCodeEnum!) {\n  checkoutBillingAddressUpdate(\n    checkoutId: $checkoutId\n    billingAddress: $billingAddress\n  ) {\n    errors {\n      field\n      message\n    }\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCheckoutLine($checkoutId: ID!, $lines: [CheckoutLineInput]!, $languageCode: LanguageCodeEnum!) {\n  checkoutLinesUpdate(checkoutId: $checkoutId, lines: $lines) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCheckoutNote($checkoutId: ID!, $note: String, $deliveryNote: String, $languageCode: LanguageCodeEnum!) {\n  checkoutUpdateNote(\n    checkoutId: $checkoutId\n    note: $note\n    deliveryNote: $deliveryNote\n  ) {\n    errors {\n      field\n      message\n    }\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCheckoutShippingAddress($checkoutId: ID!, $shippingAddress: AddressInput!, $email: String!, $languageCode: LanguageCodeEnum!) {\n  checkoutEmailUpdate(checkoutId: $checkoutId, email: $email) {\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n  checkoutShippingAddressUpdate(\n    checkoutId: $checkoutId\n    shippingAddress: $shippingAddress\n  ) {\n    errors {\n      field\n      message\n    }\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCheckoutShippingMethod($checkoutId: ID!, $shippingMethodId: ID!, $languageCode: LanguageCodeEnum!) {\n  checkoutShippingMethodUpdate(\n    checkoutId: $checkoutId\n    shippingMethodId: $shippingMethodId\n  ) {\n    errors {\n      field\n      message\n    }\n    checkout {\n      ...CheckoutDetailsFragment\n    }\n    checkoutErrors {\n      ...CheckoutErrorFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateUserAddress($input: AddressInput!, $id: ID!) {\n  accountAddressUpdate(input: $input, id: $id) {\n    user {\n      ...UserFragment\n    }\n    accountErrors {\n      field\n      message\n      code\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query CartProductDetails($id: ID!, $languageCode: LanguageCodeEnum!) {\n  product(id: $id) {\n    category {\n      ...CategoryBaseFragment\n    }\n    attributes {\n      ...SelectedAttributeFragment\n    }\n    productType {\n      ...ProductTypeFragment\n    }\n    isAvailable\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query CartProductEstimatedShipping($id: ID!, $languageCode: LanguageCodeEnum!) {\n  product(id: $id) {\n    productType {\n      ...ProductTypeFragment\n    }\n    isAvailable\n  }\n}\n    ",
        ""
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query CategoryCards($languageCode: LanguageCodeEnum!) {\n  categories(first: 100) {\n    edges {\n      node {\n        ...CategoryCardFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query CategoryReviews($slug: String!, $after: String, $pageSize: Int, $hasImages: Boolean, $languageCode: LanguageCodeEnum!) {\n  category(slug: $slug) {\n    reviews(after: $after, first: $pageSize, filter: {hasImages: $hasImages}) {\n      edges {\n        node {\n          ...ReviewDetailsFragment\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query CheckoutDetailsByToken($token: UUID!, $languageCode: LanguageCodeEnum!) {\n  checkout(token: $token) {\n    ...CheckoutDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query CollectionDetails($id: ID!, $languageCode: LanguageCodeEnum!) {\n  collection(id: $id) {\n    ...CollectionDetailsFragment\n  }\n  attributes(\n    filter: {inCollection: $id, filterableInStorefront: true}\n    first: 100\n  ) {\n    edges {\n      node {\n        ...AttributeFragment\n      }\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query CollectionPaths($languageCode: LanguageCodeEnum!) {\n  collections(first: 20) {\n    edges {\n      node {\n        id\n        name\n        translation(languageCode: $languageCode) {\n          name\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetShop($languageCode: LanguageCodeEnum) {\n  shop {\n    name\n    description\n    displayGrossPrices\n    defaultCountry {\n      code\n      country\n    }\n    countries(languageCode: $languageCode) {\n      country\n      code\n    }\n    geolocalization {\n      country {\n        code\n        country\n      }\n    }\n    availablePaymentGateways {\n      id\n      name\n    }\n  }\n}\n    "
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    query MainMenu($languageCode: LanguageCodeEnum!) {\n  menu(slug: "navbar") {\n    items {\n      ...MainMenuItemFragment\n      children {\n        ...MainMenuItemFragment\n        children {\n          ...MainMenuItemFragment\n        }\n      }\n    }\n  }\n}\n    ',
        ""
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query OrderByToken($token: UUID!, $languageCode: LanguageCodeEnum!) {\n  orderByToken(token: $token) {\n    ...OrderDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query OrdersByUser($perPage: Int!, $after: String, $languageCode: LanguageCodeEnum!) {\n  me {\n    id\n    orders(first: $perPage, after: $after) {\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n      edges {\n        node {\n          ...OrderDetailsFragment\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ProductCategoryDetails($id: ID!, $languageCode: LanguageCodeEnum!) {\n  category(id: $id) {\n    ...CategoryBaseFragment\n    products(first: 5) {\n      edges {\n        node {\n          ...ProductCardFragment\n        }\n      }\n    }\n    reviews(first: 10) {\n      edges {\n        node {\n          ...ReviewBaseFragment\n        }\n      }\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ProductDetails($id: ID!, $countryCode: CountryCode, $languageCode: LanguageCodeEnum!) {\n  product(id: $id) {\n    ...ProductDetailsFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ProductList($after: String, $first: Int!, $sortBy: ProductOrder, $filter: ProductFilterInput, $languageCode: LanguageCodeEnum!) {\n  products(after: $after, first: $first, sortBy: $sortBy, filter: $filter) {\n    totalCount\n    edges {\n      node {\n        ...ProductCardFragment\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ProductPaths {\n  products(first: 100) {\n    edges {\n      cursor\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ReviewRating {\n  reviewRating {\n    rating\n    count\n  }\n}\n    "
    ]);
    _templateObject86 = function _templateObject86() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query Reviews($after: String, $pageSize: Int, $hasImages: Boolean, $languageCode: LanguageCodeEnum!) {\n  reviews(after: $after, first: $pageSize, filter: {hasImages: $hasImages}) {\n    edges {\n      node {\n        ...ReviewDetailsFragment\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject87 = function _templateObject87() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query UserDetails {\n  user: me {\n    ...UserFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject88 = function _templateObject88() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query Wishlist($after: String, $first: Int, $languageCode: LanguageCodeEnum!) {\n  wishlist {\n    id\n    items(after: $after, first: $first) {\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n      edges {\n        node {\n          ...WishlistItemFragment\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject89 = function _templateObject89() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var AccountErrorFragmentDoc = (0,lib/* gql */.Ps)(_templateObject());
var AttributeBaseFragmentDoc = (0,lib/* gql */.Ps)(_templateObject1());
var AttributeValueFragmentDoc = (0,lib/* gql */.Ps)(_templateObject2());
var AttributeFragmentDoc = (0,lib/* gql */.Ps)(_templateObject3(), AttributeBaseFragmentDoc, AttributeValueFragmentDoc);
var CategoryBaseFragmentDoc = (0,lib/* gql */.Ps)(_templateObject4());
var ImageFragmentDoc = (0,lib/* gql */.Ps)(_templateObject5());
var CategoryCardFragmentDoc = (0,lib/* gql */.Ps)(_templateObject6(), CategoryBaseFragmentDoc, ImageFragmentDoc);
var AddressDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject7());
var ShippingMethodFragmentDoc = (0,lib/* gql */.Ps)(_templateObject8());
var PriceFragmentDoc = (0,lib/* gql */.Ps)(_templateObject9());
var AttributeValueDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject10(), AttributeValueFragmentDoc, ImageFragmentDoc);
var SelectedAttributeFragmentDoc = (0,lib/* gql */.Ps)(_templateObject11(), AttributeBaseFragmentDoc, AttributeValueDetailsFragmentDoc);
var ProductBaseFragmentDoc = (0,lib/* gql */.Ps)(_templateObject12(), ImageFragmentDoc);
var ProductCheckoutFragmentDoc = (0,lib/* gql */.Ps)(_templateObject13(), ProductBaseFragmentDoc, SelectedAttributeFragmentDoc, CategoryBaseFragmentDoc);
var SelectedAttributeValueFragmentDoc = (0,lib/* gql */.Ps)(_templateObject14());
var CheckoutLineFragmentDoc = (0,lib/* gql */.Ps)(_templateObject15(), PriceFragmentDoc, SelectedAttributeFragmentDoc, ProductCheckoutFragmentDoc, SelectedAttributeValueFragmentDoc);
var PaymentGatewayFragmentDoc = (0,lib/* gql */.Ps)(_templateObject16());
var CheckoutDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject17(), AddressDetailsFragmentDoc, ShippingMethodFragmentDoc, CheckoutLineFragmentDoc, PriceFragmentDoc, PaymentGatewayFragmentDoc);
var CheckoutErrorFragmentDoc = (0,lib/* gql */.Ps)(_templateObject18());
var CollectionBaseFragmentDoc = (0,lib/* gql */.Ps)(_templateObject19());
var CollectionDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject20(), CollectionBaseFragmentDoc, ImageFragmentDoc);
var MainMenuItemFragmentDoc = (0,lib/* gql */.Ps)(_templateObject21());
var OrderBaseFragmentDoc = (0,lib/* gql */.Ps)(_templateObject22(), PriceFragmentDoc);
var OrderLineFragmentDoc = (0,lib/* gql */.Ps)(_templateObject23(), SelectedAttributeFragmentDoc, ProductBaseFragmentDoc, PriceFragmentDoc, ImageFragmentDoc);
var OrderDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject24(), AddressDetailsFragmentDoc, OrderLineFragmentDoc, PriceFragmentDoc);
var PaymentErrorFragmentDoc = (0,lib/* gql */.Ps)(_templateObject25());
var PaymentFragmentDoc = (0,lib/* gql */.Ps)(_templateObject26());
var ProductPricingFragmentDoc = (0,lib/* gql */.Ps)(_templateObject27(), PriceFragmentDoc);
var ProductDefaultAttributesFragmentDoc = (0,lib/* gql */.Ps)(_templateObject28());
var ProductVariantCardFragmentDoc = (0,lib/* gql */.Ps)(_templateObject29());
var ProductTypeBaseFragmentDoc = (0,lib/* gql */.Ps)(_templateObject30());
var ProductCardFragmentDoc = (0,lib/* gql */.Ps)(_templateObject31(), ProductBaseFragmentDoc, ProductPricingFragmentDoc, ProductDefaultAttributesFragmentDoc, ProductVariantCardFragmentDoc, CategoryBaseFragmentDoc, ProductTypeBaseFragmentDoc);
var ProductVariantDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject32(), PriceFragmentDoc, SelectedAttributeFragmentDoc);
var ReviewImageFragmentDoc = (0,lib/* gql */.Ps)(_templateObject33());
var ReviewBaseFragmentDoc = (0,lib/* gql */.Ps)(_templateObject34(), CategoryBaseFragmentDoc, ReviewImageFragmentDoc);
var ProductDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject35(), ProductBaseFragmentDoc, ProductPricingFragmentDoc, ProductDefaultAttributesFragmentDoc, CategoryBaseFragmentDoc, SelectedAttributeFragmentDoc, ProductVariantDetailsFragmentDoc, ProductTypeBaseFragmentDoc, ReviewBaseFragmentDoc);
var ProductMinimalFragmentDoc = (0,lib/* gql */.Ps)(_templateObject36());
var ProductTypeFragmentDoc = (0,lib/* gql */.Ps)(_templateObject37());
var ProductVariantCheckoutFragmentDoc = (0,lib/* gql */.Ps)(_templateObject38(), PriceFragmentDoc, SelectedAttributeFragmentDoc, ProductCheckoutFragmentDoc);
var ReviewDetailsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject39(), ReviewBaseFragmentDoc);
var UserFragmentDoc = (0,lib/* gql */.Ps)(_templateObject40(), AddressDetailsFragmentDoc);
var WishlistErrorFragmentDoc = (0,lib/* gql */.Ps)(_templateObject41());
var ProductVariantWishlistFragmentDoc = (0,lib/* gql */.Ps)(_templateObject42(), PriceFragmentDoc, SelectedAttributeFragmentDoc);
var WishlistItemProductAttributeFragmentDoc = (0,lib/* gql */.Ps)(_templateObject43());
var WishlistItemFragmentDoc = (0,lib/* gql */.Ps)(_templateObject44(), ProductBaseFragmentDoc, CategoryBaseFragmentDoc, SelectedAttributeFragmentDoc, ProductVariantWishlistFragmentDoc, WishlistItemProductAttributeFragmentDoc);
var AccountConfirmDocument = (0,lib/* gql */.Ps)(_templateObject45());
/**
 * __useAccountConfirmMutation__
 *
 * To run a mutation, you first call `useAccountConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountConfirmMutation, { data, loading, error }] = useAccountConfirmMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */ function useAccountConfirmMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(AccountConfirmDocument, options);
}
var AccountRegisterDocument = (0,lib/* gql */.Ps)(_templateObject46());
/**
 * __useAccountRegisterMutation__
 *
 * To run a mutation, you first call `useAccountRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRegisterMutation, { data, loading, error }] = useAccountRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */ function useAccountRegisterMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(AccountRegisterDocument, options);
}
var AccountUpdateDocument = (0,lib/* gql */.Ps)(_templateObject47(), UserFragmentDoc);
/**
 * __useAccountUpdateMutation__
 *
 * To run a mutation, you first call `useAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateMutation, { data, loading, error }] = useAccountUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useAccountUpdateMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(AccountUpdateDocument, options);
}
var AddCheckoutLineDocument = (0,lib/* gql */.Ps)(_templateObject48(), CheckoutDetailsFragmentDoc);
/**
 * __useAddCheckoutLineMutation__
 *
 * To run a mutation, you first call `useAddCheckoutLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCheckoutLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCheckoutLineMutation, { data, loading, error }] = useAddCheckoutLineMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lines: // value for 'lines'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useAddCheckoutLineMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(AddCheckoutLineDocument, options);
}
var AddCheckoutPromoCodeDocument = (0,lib/* gql */.Ps)(_templateObject49(), CheckoutDetailsFragmentDoc, CheckoutErrorFragmentDoc);
/**
 * __useAddCheckoutPromoCodeMutation__
 *
 * To run a mutation, you first call `useAddCheckoutPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCheckoutPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCheckoutPromoCodeMutation, { data, loading, error }] = useAddCheckoutPromoCodeMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      promoCode: // value for 'promoCode'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useAddCheckoutPromoCodeMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(AddCheckoutPromoCodeDocument, options);
}
var AddWishlistProductVariantDocument = (0,lib/* gql */.Ps)(_templateObject50(), WishlistItemFragmentDoc);
/**
 * __useAddWishlistProductVariantMutation__
 *
 * To run a mutation, you first call `useAddWishlistProductVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWishlistProductVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWishlistProductVariantMutation, { data, loading, error }] = useAddWishlistProductVariantMutation({
 *   variables: {
 *      email: // value for 'email'
 *      variantId: // value for 'variantId'
 *      productAttributes: // value for 'productAttributes'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useAddWishlistProductVariantMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(AddWishlistProductVariantDocument, options);
}
var CompleteCheckoutDocument = (0,lib/* gql */.Ps)(_templateObject51(), OrderDetailsFragmentDoc);
/**
 * __useCompleteCheckoutMutation__
 *
 * To run a mutation, you first call `useCompleteCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCheckoutMutation, { data, loading, error }] = useCompleteCheckoutMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCompleteCheckoutMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(CompleteCheckoutDocument, options);
}
var CreateCheckoutDocument = (0,lib/* gql */.Ps)(_templateObject52(), CheckoutDetailsFragmentDoc);
/**
 * __useCreateCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutMutation, { data, loading, error }] = useCreateCheckoutMutation({
 *   variables: {
 *      checkoutInput: // value for 'checkoutInput'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCreateCheckoutMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(CreateCheckoutDocument, options);
}
var CreateCheckoutPaymentDocument = (0,lib/* gql */.Ps)(_templateObject53(), CheckoutDetailsFragmentDoc, PaymentFragmentDoc, PaymentErrorFragmentDoc);
/**
 * __useCreateCheckoutPaymentMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutPaymentMutation, { data, loading, error }] = useCreateCheckoutPaymentMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      paymentInput: // value for 'paymentInput'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCreateCheckoutPaymentMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(CreateCheckoutPaymentDocument, options);
}
var CreateReviewDocument = (0,lib/* gql */.Ps)(_templateObject54());
/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useCreateReviewMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(CreateReviewDocument, options);
}
var CreateUserAddressDocument = (0,lib/* gql */.Ps)(_templateObject55(), UserFragmentDoc);
/**
 * __useCreateUserAddressMutation__
 *
 * To run a mutation, you first call `useCreateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAddressMutation, { data, loading, error }] = useCreateUserAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useCreateUserAddressMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(CreateUserAddressDocument, options);
}
var DeleteUserAddressDocument = (0,lib/* gql */.Ps)(_templateObject56(), UserFragmentDoc);
/**
 * __useDeleteUserAddressMutation__
 *
 * To run a mutation, you first call `useDeleteUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAddressMutation, { data, loading, error }] = useDeleteUserAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */ function useDeleteUserAddressMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(DeleteUserAddressDocument, options);
}
var InitializePaymentDocument = (0,lib/* gql */.Ps)(_templateObject57());
/**
 * __useInitializePaymentMutation__
 *
 * To run a mutation, you first call `useInitializePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializePaymentMutation, { data, loading, error }] = useInitializePaymentMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      gateway: // value for 'gateway'
 *      paymentData: // value for 'paymentData'
 *   },
 * });
 */ function useInitializePaymentMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(InitializePaymentDocument, options);
}
var PasswordChangeDocument = (0,lib/* gql */.Ps)(_templateObject58());
/**
 * __usePasswordChangeMutation__
 *
 * To run a mutation, you first call `usePasswordChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordChangeMutation, { data, loading, error }] = usePasswordChangeMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */ function usePasswordChangeMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(PasswordChangeDocument, options);
}
var RemoveCheckoutLineDocument = (0,lib/* gql */.Ps)(_templateObject59(), CheckoutDetailsFragmentDoc);
/**
 * __useRemoveCheckoutLineMutation__
 *
 * To run a mutation, you first call `useRemoveCheckoutLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCheckoutLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCheckoutLineMutation, { data, loading, error }] = useRemoveCheckoutLineMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineId: // value for 'lineId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useRemoveCheckoutLineMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(RemoveCheckoutLineDocument, options);
}
var RemoveCheckoutPromoCodeDocument = (0,lib/* gql */.Ps)(_templateObject60(), CheckoutDetailsFragmentDoc, CheckoutErrorFragmentDoc);
/**
 * __useRemoveCheckoutPromoCodeMutation__
 *
 * To run a mutation, you first call `useRemoveCheckoutPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCheckoutPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCheckoutPromoCodeMutation, { data, loading, error }] = useRemoveCheckoutPromoCodeMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      promoCode: // value for 'promoCode'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useRemoveCheckoutPromoCodeMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(RemoveCheckoutPromoCodeDocument, options);
}
var RemoveWishlistProductVariantDocument = (0,lib/* gql */.Ps)(_templateObject61(), WishlistItemFragmentDoc);
/**
 * __useRemoveWishlistProductVariantMutation__
 *
 * To run a mutation, you first call `useRemoveWishlistProductVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWishlistProductVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWishlistProductVariantMutation, { data, loading, error }] = useRemoveWishlistProductVariantMutation({
 *   variables: {
 *      email: // value for 'email'
 *      variantId: // value for 'variantId'
 *      productAttributes: // value for 'productAttributes'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useRemoveWishlistProductVariantMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(RemoveWishlistProductVariantDocument, options);
}
var ResetPasswordRequestDocument = (0,lib/* gql */.Ps)(_templateObject62());
/**
 * __useResetPasswordRequestMutation__
 *
 * To run a mutation, you first call `useResetPasswordRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordRequestMutation, { data, loading, error }] = useResetPasswordRequestMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */ function useResetPasswordRequestMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(ResetPasswordRequestDocument, options);
}
var SendContactUsDocument = (0,lib/* gql */.Ps)(_templateObject63());
/**
 * __useSendContactUsMutation__
 *
 * To run a mutation, you first call `useSendContactUsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactUsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactUsMutation, { data, loading, error }] = useSendContactUsMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *      email: // value for 'email'
 *   },
 * });
 */ function useSendContactUsMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(SendContactUsDocument, options);
}
var SetCustomerDefaultAddressDocument = (0,lib/* gql */.Ps)(_templateObject64(), UserFragmentDoc);
/**
 * __useSetCustomerDefaultAddressMutation__
 *
 * To run a mutation, you first call `useSetCustomerDefaultAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomerDefaultAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomerDefaultAddressMutation, { data, loading, error }] = useSetCustomerDefaultAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */ function useSetCustomerDefaultAddressMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(SetCustomerDefaultAddressDocument, options);
}
var UpdateCheckoutBillingAddressDocument = (0,lib/* gql */.Ps)(_templateObject65(), CheckoutDetailsFragmentDoc);
/**
 * __useUpdateCheckoutBillingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutBillingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutBillingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutBillingAddressMutation, { data, loading, error }] = useUpdateCheckoutBillingAddressMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      billingAddress: // value for 'billingAddress'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useUpdateCheckoutBillingAddressMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(UpdateCheckoutBillingAddressDocument, options);
}
var UpdateCheckoutLineDocument = (0,lib/* gql */.Ps)(_templateObject66(), CheckoutDetailsFragmentDoc);
/**
 * __useUpdateCheckoutLineMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutLineMutation, { data, loading, error }] = useUpdateCheckoutLineMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lines: // value for 'lines'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useUpdateCheckoutLineMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(UpdateCheckoutLineDocument, options);
}
var UpdateCheckoutNoteDocument = (0,lib/* gql */.Ps)(_templateObject67(), CheckoutDetailsFragmentDoc);
/**
 * __useUpdateCheckoutNoteMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutNoteMutation, { data, loading, error }] = useUpdateCheckoutNoteMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      note: // value for 'note'
 *      deliveryNote: // value for 'deliveryNote'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useUpdateCheckoutNoteMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(UpdateCheckoutNoteDocument, options);
}
var UpdateCheckoutShippingAddressDocument = (0,lib/* gql */.Ps)(_templateObject68(), CheckoutDetailsFragmentDoc);
/**
 * __useUpdateCheckoutShippingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutShippingAddressMutation, { data, loading, error }] = useUpdateCheckoutShippingAddressMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      shippingAddress: // value for 'shippingAddress'
 *      email: // value for 'email'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useUpdateCheckoutShippingAddressMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(UpdateCheckoutShippingAddressDocument, options);
}
var UpdateCheckoutShippingMethodDocument = (0,lib/* gql */.Ps)(_templateObject69(), CheckoutDetailsFragmentDoc, CheckoutErrorFragmentDoc);
/**
 * __useUpdateCheckoutShippingMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutShippingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutShippingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutShippingMethodMutation, { data, loading, error }] = useUpdateCheckoutShippingMethodMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      shippingMethodId: // value for 'shippingMethodId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useUpdateCheckoutShippingMethodMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(UpdateCheckoutShippingMethodDocument, options);
}
var UpdateUserAddressDocument = (0,lib/* gql */.Ps)(_templateObject70(), UserFragmentDoc);
/**
 * __useUpdateUserAddressMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressMutation, { data, loading, error }] = useUpdateUserAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */ function useUpdateUserAddressMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation(UpdateUserAddressDocument, options);
}
var CartProductDetailsDocument = (0,lib/* gql */.Ps)(_templateObject71(), CategoryBaseFragmentDoc, SelectedAttributeFragmentDoc, ProductTypeFragmentDoc);
/**
 * __useCartProductDetailsQuery__
 *
 * To run a query within a React component, call `useCartProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartProductDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCartProductDetailsQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(CartProductDetailsDocument, options);
}
function useCartProductDetailsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CartProductDetailsDocument, options);
}
var CartProductEstimatedShippingDocument = (0,lib/* gql */.Ps)(_templateObject72(), ProductTypeFragmentDoc);
/**
 * __useCartProductEstimatedShippingQuery__
 *
 * To run a query within a React component, call `useCartProductEstimatedShippingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartProductEstimatedShippingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartProductEstimatedShippingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCartProductEstimatedShippingQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(CartProductEstimatedShippingDocument, options);
}
function useCartProductEstimatedShippingLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CartProductEstimatedShippingDocument, options);
}
var CategoryCardsDocument = (0,lib/* gql */.Ps)(_templateObject73(), CategoryCardFragmentDoc);
/**
 * __useCategoryCardsQuery__
 *
 * To run a query within a React component, call `useCategoryCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryCardsQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCategoryCardsQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(CategoryCardsDocument, options);
}
function useCategoryCardsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CategoryCardsDocument, options);
}
var CategoryReviewsDocument = (0,lib/* gql */.Ps)(_templateObject74(), ReviewDetailsFragmentDoc);
/**
 * __useCategoryReviewsQuery__
 *
 * To run a query within a React component, call `useCategoryReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryReviewsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      after: // value for 'after'
 *      pageSize: // value for 'pageSize'
 *      hasImages: // value for 'hasImages'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCategoryReviewsQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(CategoryReviewsDocument, options);
}
function useCategoryReviewsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CategoryReviewsDocument, options);
}
var CheckoutDetailsByTokenDocument = (0,lib/* gql */.Ps)(_templateObject75(), CheckoutDetailsFragmentDoc);
/**
 * __useCheckoutDetailsByTokenQuery__
 *
 * To run a query within a React component, call `useCheckoutDetailsByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutDetailsByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutDetailsByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCheckoutDetailsByTokenQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(CheckoutDetailsByTokenDocument, options);
}
function useCheckoutDetailsByTokenLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CheckoutDetailsByTokenDocument, options);
}
var CollectionDetailsDocument = (0,lib/* gql */.Ps)(_templateObject76(), CollectionDetailsFragmentDoc, AttributeFragmentDoc);
/**
 * __useCollectionDetailsQuery__
 *
 * To run a query within a React component, call `useCollectionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCollectionDetailsQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CollectionDetailsDocument, options);
}
function useCollectionDetailsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CollectionDetailsDocument, options);
}
var CollectionPathsDocument = (0,lib/* gql */.Ps)(_templateObject77());
/**
 * __useCollectionPathsQuery__
 *
 * To run a query within a React component, call `useCollectionPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionPathsQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useCollectionPathsQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CollectionPathsDocument, options);
}
function useCollectionPathsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CollectionPathsDocument, options);
}
var GetShopDocument = (0,lib/* gql */.Ps)(_templateObject78());
/**
 * __useGetShopQuery__
 *
 * To run a query within a React component, call `useGetShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useGetShopQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(GetShopDocument, options);
}
function useGetShopLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetShopDocument, options);
}
var MainMenuDocument = (0,lib/* gql */.Ps)(_templateObject79(), MainMenuItemFragmentDoc);
/**
 * __useMainMenuQuery__
 *
 * To run a query within a React component, call `useMainMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainMenuQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useMainMenuQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(MainMenuDocument, options);
}
function useMainMenuLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(MainMenuDocument, options);
}
var OrderByTokenDocument = (0,lib/* gql */.Ps)(_templateObject80(), OrderDetailsFragmentDoc);
/**
 * __useOrderByTokenQuery__
 *
 * To run a query within a React component, call `useOrderByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useOrderByTokenQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(OrderByTokenDocument, options);
}
function useOrderByTokenLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(OrderByTokenDocument, options);
}
var OrdersByUserDocument = (0,lib/* gql */.Ps)(_templateObject81(), OrderDetailsFragmentDoc);
/**
 * __useOrdersByUserQuery__
 *
 * To run a query within a React component, call `useOrdersByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersByUserQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      after: // value for 'after'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useOrdersByUserQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(OrdersByUserDocument, options);
}
function useOrdersByUserLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(OrdersByUserDocument, options);
}
var ProductCategoryDetailsDocument = (0,lib/* gql */.Ps)(_templateObject82(), CategoryBaseFragmentDoc, ProductCardFragmentDoc, ReviewBaseFragmentDoc);
/**
 * __useProductCategoryDetailsQuery__
 *
 * To run a query within a React component, call `useProductCategoryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoryDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useProductCategoryDetailsQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(ProductCategoryDetailsDocument, options);
}
function useProductCategoryDetailsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductCategoryDetailsDocument, options);
}
var ProductDetailsDocument = (0,lib/* gql */.Ps)(_templateObject83(), ProductDetailsFragmentDoc);
/**
 * __useProductDetailsQuery__
 *
 * To run a query within a React component, call `useProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      countryCode: // value for 'countryCode'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useProductDetailsQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ProductDetailsDocument, options);
}
function useProductDetailsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductDetailsDocument, options);
}
var ProductListDocument = (0,lib/* gql */.Ps)(_templateObject84(), ProductCardFragmentDoc);
/**
 * __useProductListQuery__
 *
 * To run a query within a React component, call `useProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useProductListQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(ProductListDocument, options);
}
function useProductListLazyQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useLazyQuery/* useLazyQuery */.t(ProductListDocument, options);
}
var ProductPathsDocument = (0,lib/* gql */.Ps)(_templateObject85());
/**
 * __useProductPathsQuery__
 *
 * To run a query within a React component, call `useProductPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPathsQuery({
 *   variables: {
 *   },
 * });
 */ function useProductPathsQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ProductPathsDocument, options);
}
function useProductPathsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductPathsDocument, options);
}
var ReviewRatingDocument = (0,lib/* gql */.Ps)(_templateObject86());
/**
 * __useReviewRatingQuery__
 *
 * To run a query within a React component, call `useReviewRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewRatingQuery({
 *   variables: {
 *   },
 * });
 */ function useReviewRatingQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(ReviewRatingDocument, options);
}
function useReviewRatingLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ReviewRatingDocument, options);
}
var ReviewsDocument = (0,lib/* gql */.Ps)(_templateObject87(), ReviewDetailsFragmentDoc);
/**
 * __useReviewsQuery__
 *
 * To run a query within a React component, call `useReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      pageSize: // value for 'pageSize'
 *      hasImages: // value for 'hasImages'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useReviewsQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(ReviewsDocument, options);
}
function useReviewsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ReviewsDocument, options);
}
var UserDetailsDocument = (0,lib/* gql */.Ps)(_templateObject88(), UserFragmentDoc);
/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */ function useUserDetailsQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(UserDetailsDocument, options);
}
function useUserDetailsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(UserDetailsDocument, options);
}
var WishlistDocument = (0,lib/* gql */.Ps)(_templateObject89(), WishlistItemFragmentDoc);
/**
 * __useWishlistQuery__
 *
 * To run a query within a React component, call `useWishlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWishlistQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */ function useWishlistQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(WishlistDocument, options);
}
function useWishlistLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(WishlistDocument, options);
}


/***/ }),

/***/ 52046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ CountryCode; },
/* harmony export */   "HI": function() { return /* binding */ ShippingDateTypeEnum; },
/* harmony export */   "O$": function() { return /* binding */ AttributeChoiceTypeEnum; },
/* harmony export */   "m3": function() { return /* binding */ AddressTypeEnum; },
/* harmony export */   "zA": function() { return /* binding */ ReviewAvatarEnum; }
/* harmony export */ });
/* unused harmony exports AccountErrorCode, AppErrorCode, AppSortField, AppTypeEnum, AttributeChoicesSortField, AttributeInputTypeEnum, AttributeSortField, AttributeTypeEnum, AttributeValueType, AuthorizationKeyType, CartErrorCode, CategorySortField, CheckoutErrorCode, CheckoutSortField, CollectionPublished, CollectionSortField, ConfigurationTypeFieldEnum, CustomerEventsEnum, DefaultAttributeValueAttributeType, DiscountErrorCode, DiscountStatusEnum, DiscountValueTypeEnum, ExportErrorCode, ExportEventsEnum, ExportFileSortField, ExportScope, FileTypesEnum, FulfillmentStatus, GiftCardErrorCode, InvoiceErrorCode, JobStatusEnum, LanguageCodeEnum, MenuErrorCode, MenuItemsSortField, MenuSortField, MetadataErrorCode, NavigationType, OrderAction, OrderDirection, OrderErrorCode, OrderEventsEmailsEnum, OrderEventsEnum, OrderSortField, OrderStatus, OrderStatusFilter, PageErrorCode, PageSortField, PaymentChargeStatusEnum, PaymentErrorCode, PermissionEnum, PermissionGroupErrorCode, PermissionGroupSortField, PluginErrorCode, PluginSortField, ProductErrorCode, ProductFieldEnum, ProductOrderField, ProductTypeConfigurable, ProductTypeEnum, ProductTypeSortField, ReportingPeriod, ReviewErrorCode, SaleSortField, SaleTypeEnum, ServiceAccountSortField, ShippingErrorCode, ShippingMethodTypeEnum, ShopErrorCode, StaffMemberStatus, StockAvailability, StockErrorCode, TaxRateType, TransactionError, TransactionKind, TranslatableKinds, TranslationErrorCode, UserSortField, VoucherDiscountType, VoucherSortField, VoucherTypeEnum, WarehouseErrorCode, WarehouseSortField, WebhookErrorCode, WebhookEventTypeEnum, WebhookSampleEventTypeEnum, WebhookSortField, WeightUnitsEnum, WishlistErrorCode */
/* tslint:disable */ /* eslint-disable */ /* THIS FILE IS GENERATED WITH `npm run codegen-saleor` */ var AccountErrorCode;
(function(AccountErrorCode) {
    AccountErrorCode["ACTIVATE_OWN_ACCOUNT"] = "ACTIVATE_OWN_ACCOUNT";
    AccountErrorCode["ACTIVATE_SUPERUSER_ACCOUNT"] = "ACTIVATE_SUPERUSER_ACCOUNT";
    AccountErrorCode["DEACTIVATE_OWN_ACCOUNT"] = "DEACTIVATE_OWN_ACCOUNT";
    AccountErrorCode["DEACTIVATE_SUPERUSER_ACCOUNT"] = "DEACTIVATE_SUPERUSER_ACCOUNT";
    AccountErrorCode["DELETE_NON_STAFF_USER"] = "DELETE_NON_STAFF_USER";
    AccountErrorCode["DELETE_OWN_ACCOUNT"] = "DELETE_OWN_ACCOUNT";
    AccountErrorCode["DELETE_STAFF_ACCOUNT"] = "DELETE_STAFF_ACCOUNT";
    AccountErrorCode["DELETE_SUPERUSER_ACCOUNT"] = "DELETE_SUPERUSER_ACCOUNT";
    AccountErrorCode["DUPLICATED_INPUT_ITEM"] = "DUPLICATED_INPUT_ITEM";
    AccountErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    AccountErrorCode["INVALID"] = "INVALID";
    AccountErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    AccountErrorCode["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    AccountErrorCode["JWT_DECODE_ERROR"] = "JWT_DECODE_ERROR";
    AccountErrorCode["JWT_INVALID_CSRF_TOKEN"] = "JWT_INVALID_CSRF_TOKEN";
    AccountErrorCode["JWT_INVALID_TOKEN"] = "JWT_INVALID_TOKEN";
    AccountErrorCode["JWT_MISSING_TOKEN"] = "JWT_MISSING_TOKEN";
    AccountErrorCode["JWT_SIGNATURE_EXPIRED"] = "JWT_SIGNATURE_EXPIRED";
    AccountErrorCode["LEFT_NOT_MANAGEABLE_PERMISSION"] = "LEFT_NOT_MANAGEABLE_PERMISSION";
    AccountErrorCode["NOT_FOUND"] = "NOT_FOUND";
    AccountErrorCode["OUT_OF_SCOPE_GROUP"] = "OUT_OF_SCOPE_GROUP";
    AccountErrorCode["OUT_OF_SCOPE_PERMISSION"] = "OUT_OF_SCOPE_PERMISSION";
    AccountErrorCode["OUT_OF_SCOPE_SERVICE_ACCOUNT"] = "OUT_OF_SCOPE_SERVICE_ACCOUNT";
    AccountErrorCode["OUT_OF_SCOPE_USER"] = "OUT_OF_SCOPE_USER";
    AccountErrorCode["PASSWORD_ENTIRELY_NUMERIC"] = "PASSWORD_ENTIRELY_NUMERIC";
    AccountErrorCode["PASSWORD_TOO_COMMON"] = "PASSWORD_TOO_COMMON";
    AccountErrorCode["PASSWORD_TOO_SHORT"] = "PASSWORD_TOO_SHORT";
    AccountErrorCode["PASSWORD_TOO_SIMILAR"] = "PASSWORD_TOO_SIMILAR";
    AccountErrorCode["REQUIRED"] = "REQUIRED";
    AccountErrorCode["UNIQUE"] = "UNIQUE";
})(AccountErrorCode || (AccountErrorCode = {}));
var AddressTypeEnum;
(function(AddressTypeEnum) {
    AddressTypeEnum["BILLING"] = "BILLING";
    AddressTypeEnum["SHIPPING"] = "SHIPPING";
})(AddressTypeEnum || (AddressTypeEnum = {}));
var AppErrorCode;
(function(AppErrorCode) {
    AppErrorCode["FORBIDDEN"] = "FORBIDDEN";
    AppErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    AppErrorCode["INVALID"] = "INVALID";
    AppErrorCode["INVALID_MANIFEST_FORMAT"] = "INVALID_MANIFEST_FORMAT";
    AppErrorCode["INVALID_PERMISSION"] = "INVALID_PERMISSION";
    AppErrorCode["INVALID_STATUS"] = "INVALID_STATUS";
    AppErrorCode["INVALID_URL_FORMAT"] = "INVALID_URL_FORMAT";
    AppErrorCode["MANIFEST_URL_CANT_CONNECT"] = "MANIFEST_URL_CANT_CONNECT";
    AppErrorCode["NOT_FOUND"] = "NOT_FOUND";
    AppErrorCode["OUT_OF_SCOPE_APP"] = "OUT_OF_SCOPE_APP";
    AppErrorCode["OUT_OF_SCOPE_PERMISSION"] = "OUT_OF_SCOPE_PERMISSION";
    AppErrorCode["REQUIRED"] = "REQUIRED";
    AppErrorCode["UNIQUE"] = "UNIQUE";
})(AppErrorCode || (AppErrorCode = {}));
var AppSortField;
(function(AppSortField) {
    AppSortField[/** Sort apps by creation date. */ "CREATION_DATE"] = "CREATION_DATE";
    AppSortField[/** Sort apps by name. */ "NAME"] = "NAME";
})(AppSortField || (AppSortField = {}));
var AppTypeEnum;
(function(AppTypeEnum) {
    AppTypeEnum["LOCAL"] = "LOCAL";
    AppTypeEnum["THIRDPARTY"] = "THIRDPARTY";
})(AppTypeEnum || (AppTypeEnum = {}));
var AttributeChoiceTypeEnum;
(function(AttributeChoiceTypeEnum) {
    AttributeChoiceTypeEnum["DROPDOWN"] = "DROPDOWN";
    AttributeChoiceTypeEnum["MULTISELECT"] = "MULTISELECT";
    AttributeChoiceTypeEnum["SLIDER"] = "SLIDER";
    AttributeChoiceTypeEnum["SWATCH"] = "SWATCH";
    AttributeChoiceTypeEnum["TOGGLE"] = "TOGGLE";
})(AttributeChoiceTypeEnum || (AttributeChoiceTypeEnum = {}));
var AttributeChoicesSortField;
(function(AttributeChoicesSortField) {
    AttributeChoicesSortField[/** Sort attribute choice by name. */ "NAME"] = "NAME";
    AttributeChoicesSortField[/** Sort attribute choice by slug. */ "SLUG"] = "SLUG";
})(AttributeChoicesSortField || (AttributeChoicesSortField = {}));
var AttributeInputTypeEnum;
(function(AttributeInputTypeEnum) {
    AttributeInputTypeEnum["DROPDOWN"] = "DROPDOWN";
    AttributeInputTypeEnum["MULTISELECT"] = "MULTISELECT";
})(AttributeInputTypeEnum || (AttributeInputTypeEnum = {}));
var AttributeSortField;
(function(AttributeSortField) {
    AttributeSortField[/** Sort attributes based on whether they can be displayed or not in a product grid. */ "AVAILABLE_IN_GRID"] = "AVAILABLE_IN_GRID";
    AttributeSortField[/** Sort attributes by the filterable in dashboard flag */ "FILTERABLE_IN_DASHBOARD"] = "FILTERABLE_IN_DASHBOARD";
    AttributeSortField[/** Sort attributes by the filterable in storefront flag */ "FILTERABLE_IN_STOREFRONT"] = "FILTERABLE_IN_STOREFRONT";
    AttributeSortField[/** Sort attributes by the variant only flag */ "IS_VARIANT_ONLY"] = "IS_VARIANT_ONLY";
    AttributeSortField[/** Sort attributes by name */ "NAME"] = "NAME";
    AttributeSortField[/** Sort attributes by slug */ "SLUG"] = "SLUG";
    AttributeSortField[/** Sort attributes by their position in storefront */ "STOREFRONT_SEARCH_POSITION"] = "STOREFRONT_SEARCH_POSITION";
    AttributeSortField[/** Sort attributes by the value required flag */ "VALUE_REQUIRED"] = "VALUE_REQUIRED";
    AttributeSortField[/** Sort attributes by visibility in the storefront */ "VISIBLE_IN_STOREFRONT"] = "VISIBLE_IN_STOREFRONT";
})(AttributeSortField || (AttributeSortField = {}));
var AttributeTypeEnum;
(function(AttributeTypeEnum) {
    AttributeTypeEnum["PRODUCT"] = "PRODUCT";
    AttributeTypeEnum["TAG"] = "TAG";
    AttributeTypeEnum["VARIANT"] = "VARIANT";
})(AttributeTypeEnum || (AttributeTypeEnum = {}));
var AttributeValueType;
(function(AttributeValueType) {
    AttributeValueType["COLOR"] = "COLOR";
    AttributeValueType["GRADIENT"] = "GRADIENT";
    AttributeValueType["STRING"] = "STRING";
    AttributeValueType["URL"] = "URL";
})(AttributeValueType || (AttributeValueType = {}));
var AuthorizationKeyType;
(function(AuthorizationKeyType) {
    AuthorizationKeyType["FACEBOOK"] = "FACEBOOK";
    AuthorizationKeyType["GOOGLE_OAUTH2"] = "GOOGLE_OAUTH2";
})(AuthorizationKeyType || (AuthorizationKeyType = {}));
var CartErrorCode;
(function(CartErrorCode) {
    CartErrorCode["VOUCHER_NOT_APPLICABLE"] = "VOUCHER_NOT_APPLICABLE";
})(CartErrorCode || (CartErrorCode = {}));
var CategorySortField;
(function(CategorySortField) {
    CategorySortField[/** Sort categories by name. */ "NAME"] = "NAME";
    CategorySortField[/** Sort categories by product count. */ "PRODUCT_COUNT"] = "PRODUCT_COUNT";
    CategorySortField[/** Sort categories by subcategory count. */ "SUBCATEGORY_COUNT"] = "SUBCATEGORY_COUNT";
})(CategorySortField || (CategorySortField = {}));
var CheckoutErrorCode;
(function(CheckoutErrorCode) {
    CheckoutErrorCode["BILLING_ADDRESS_NOT_SET"] = "BILLING_ADDRESS_NOT_SET";
    CheckoutErrorCode["CHECKOUT_NOT_FULLY_PAID"] = "CHECKOUT_NOT_FULLY_PAID";
    CheckoutErrorCode["DELIVERY_METHOD_NOT_APPLICABLE"] = "DELIVERY_METHOD_NOT_APPLICABLE";
    CheckoutErrorCode["EMAIL_NOT_SET"] = "EMAIL_NOT_SET";
    CheckoutErrorCode["GIFT_CARD_NOT_APPLICABLE"] = "GIFT_CARD_NOT_APPLICABLE";
    CheckoutErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    CheckoutErrorCode["INSUFFICIENT_STOCK"] = "INSUFFICIENT_STOCK";
    CheckoutErrorCode["INVALID"] = "INVALID";
    CheckoutErrorCode["INVALID_SHIPPING_METHOD"] = "INVALID_SHIPPING_METHOD";
    CheckoutErrorCode["NOT_FOUND"] = "NOT_FOUND";
    CheckoutErrorCode["NO_LINES"] = "NO_LINES";
    CheckoutErrorCode["PAYMENT_ERROR"] = "PAYMENT_ERROR";
    CheckoutErrorCode["PRODUCT_NOT_PUBLISHED"] = "PRODUCT_NOT_PUBLISHED";
    CheckoutErrorCode["PRODUCT_UNAVAILABLE_FOR_PURCHASE"] = "PRODUCT_UNAVAILABLE_FOR_PURCHASE";
    CheckoutErrorCode["QUANTITY_GREATER_THAN_LIMIT"] = "QUANTITY_GREATER_THAN_LIMIT";
    CheckoutErrorCode["REQUIRED"] = "REQUIRED";
    CheckoutErrorCode["SHIPPING_ADDRESS_NOT_SET"] = "SHIPPING_ADDRESS_NOT_SET";
    CheckoutErrorCode["SHIPPING_METHOD_NOT_APPLICABLE"] = "SHIPPING_METHOD_NOT_APPLICABLE";
    CheckoutErrorCode["SHIPPING_METHOD_NOT_SET"] = "SHIPPING_METHOD_NOT_SET";
    CheckoutErrorCode["SHIPPING_NOT_REQUIRED"] = "SHIPPING_NOT_REQUIRED";
    CheckoutErrorCode["TAX_ERROR"] = "TAX_ERROR";
    CheckoutErrorCode["UNIQUE"] = "UNIQUE";
    CheckoutErrorCode["VOUCHER_NOT_APPLICABLE"] = "VOUCHER_NOT_APPLICABLE";
    CheckoutErrorCode["ZERO_QUANTITY"] = "ZERO_QUANTITY";
})(CheckoutErrorCode || (CheckoutErrorCode = {}));
var CheckoutSortField;
(function(CheckoutSortField) {
    CheckoutSortField[/** Sort checkouts by creation date. */ "CREATION_DATE"] = "CREATION_DATE";
    CheckoutSortField[/** Sort checkouts by token. */ "TOKEN"] = "TOKEN";
    CheckoutSortField[/** Sort checkouts by update date. */ "UPDATE_DATE"] = "UPDATE_DATE";
})(CheckoutSortField || (CheckoutSortField = {}));
var CollectionPublished;
(function(CollectionPublished) {
    CollectionPublished["HIDDEN"] = "HIDDEN";
    CollectionPublished["PUBLISHED"] = "PUBLISHED";
})(CollectionPublished || (CollectionPublished = {}));
var CollectionSortField;
(function(CollectionSortField) {
    CollectionSortField[/** Sort collections by availability. */ "AVAILABILITY"] = "AVAILABILITY";
    CollectionSortField[/** Sort collections by name. */ "NAME"] = "NAME";
    CollectionSortField[/** Sort collections by product count. */ "PRODUCT_COUNT"] = "PRODUCT_COUNT";
    CollectionSortField[/** Sort collections by publication date. */ "PUBLICATION_DATE"] = "PUBLICATION_DATE";
})(CollectionSortField || (CollectionSortField = {}));
var ConfigurationTypeFieldEnum;
(function(ConfigurationTypeFieldEnum) {
    ConfigurationTypeFieldEnum["BOOLEAN"] = "BOOLEAN";
    ConfigurationTypeFieldEnum["MULTILINE"] = "MULTILINE";
    ConfigurationTypeFieldEnum["OUTPUT"] = "OUTPUT";
    ConfigurationTypeFieldEnum["PASSWORD"] = "PASSWORD";
    ConfigurationTypeFieldEnum["SECRET"] = "SECRET";
    ConfigurationTypeFieldEnum["SECRETMULTILINE"] = "SECRETMULTILINE";
    ConfigurationTypeFieldEnum["STRING"] = "STRING";
})(ConfigurationTypeFieldEnum || (ConfigurationTypeFieldEnum = {}));
var CountryCode;
(function(CountryCode) {
    CountryCode["AD"] = "AD";
    CountryCode["AE"] = "AE";
    CountryCode["AF"] = "AF";
    CountryCode["AG"] = "AG";
    CountryCode["AI"] = "AI";
    CountryCode["AL"] = "AL";
    CountryCode["AM"] = "AM";
    CountryCode["AO"] = "AO";
    CountryCode["AQ"] = "AQ";
    CountryCode["AR"] = "AR";
    CountryCode["AS"] = "AS";
    CountryCode["AT"] = "AT";
    CountryCode["AU"] = "AU";
    CountryCode["AW"] = "AW";
    CountryCode["AX"] = "AX";
    CountryCode["AZ"] = "AZ";
    CountryCode["BA"] = "BA";
    CountryCode["BB"] = "BB";
    CountryCode["BD"] = "BD";
    CountryCode["BE"] = "BE";
    CountryCode["BF"] = "BF";
    CountryCode["BG"] = "BG";
    CountryCode["BH"] = "BH";
    CountryCode["BI"] = "BI";
    CountryCode["BJ"] = "BJ";
    CountryCode["BL"] = "BL";
    CountryCode["BM"] = "BM";
    CountryCode["BN"] = "BN";
    CountryCode["BO"] = "BO";
    CountryCode["BQ"] = "BQ";
    CountryCode["BR"] = "BR";
    CountryCode["BS"] = "BS";
    CountryCode["BT"] = "BT";
    CountryCode["BV"] = "BV";
    CountryCode["BW"] = "BW";
    CountryCode["BY"] = "BY";
    CountryCode["BZ"] = "BZ";
    CountryCode["CA"] = "CA";
    CountryCode["CC"] = "CC";
    CountryCode["CD"] = "CD";
    CountryCode["CF"] = "CF";
    CountryCode["CG"] = "CG";
    CountryCode["CH"] = "CH";
    CountryCode["CI"] = "CI";
    CountryCode["CK"] = "CK";
    CountryCode["CL"] = "CL";
    CountryCode["CM"] = "CM";
    CountryCode["CN"] = "CN";
    CountryCode["CO"] = "CO";
    CountryCode["CR"] = "CR";
    CountryCode["CU"] = "CU";
    CountryCode["CV"] = "CV";
    CountryCode["CW"] = "CW";
    CountryCode["CX"] = "CX";
    CountryCode["CY"] = "CY";
    CountryCode["CZ"] = "CZ";
    CountryCode["DE"] = "DE";
    CountryCode["DJ"] = "DJ";
    CountryCode["DK"] = "DK";
    CountryCode["DM"] = "DM";
    CountryCode["DO"] = "DO";
    CountryCode["DZ"] = "DZ";
    CountryCode["EC"] = "EC";
    CountryCode["EE"] = "EE";
    CountryCode["EG"] = "EG";
    CountryCode["EH"] = "EH";
    CountryCode["ER"] = "ER";
    CountryCode["ES"] = "ES";
    CountryCode["ET"] = "ET";
    CountryCode["FI"] = "FI";
    CountryCode["FJ"] = "FJ";
    CountryCode["FK"] = "FK";
    CountryCode["FM"] = "FM";
    CountryCode["FO"] = "FO";
    CountryCode["FR"] = "FR";
    CountryCode["GA"] = "GA";
    CountryCode["GB"] = "GB";
    CountryCode["GD"] = "GD";
    CountryCode["GE"] = "GE";
    CountryCode["GF"] = "GF";
    CountryCode["GG"] = "GG";
    CountryCode["GH"] = "GH";
    CountryCode["GI"] = "GI";
    CountryCode["GL"] = "GL";
    CountryCode["GM"] = "GM";
    CountryCode["GN"] = "GN";
    CountryCode["GP"] = "GP";
    CountryCode["GQ"] = "GQ";
    CountryCode["GR"] = "GR";
    CountryCode["GS"] = "GS";
    CountryCode["GT"] = "GT";
    CountryCode["GU"] = "GU";
    CountryCode["GW"] = "GW";
    CountryCode["GY"] = "GY";
    CountryCode["HK"] = "HK";
    CountryCode["HM"] = "HM";
    CountryCode["HN"] = "HN";
    CountryCode["HR"] = "HR";
    CountryCode["HT"] = "HT";
    CountryCode["HU"] = "HU";
    CountryCode["ID"] = "ID";
    CountryCode["IE"] = "IE";
    CountryCode["IL"] = "IL";
    CountryCode["IM"] = "IM";
    CountryCode["IN"] = "IN";
    CountryCode["IO"] = "IO";
    CountryCode["IQ"] = "IQ";
    CountryCode["IR"] = "IR";
    CountryCode["IS"] = "IS";
    CountryCode["IT"] = "IT";
    CountryCode["JE"] = "JE";
    CountryCode["JM"] = "JM";
    CountryCode["JO"] = "JO";
    CountryCode["JP"] = "JP";
    CountryCode["KE"] = "KE";
    CountryCode["KG"] = "KG";
    CountryCode["KH"] = "KH";
    CountryCode["KI"] = "KI";
    CountryCode["KM"] = "KM";
    CountryCode["KN"] = "KN";
    CountryCode["KP"] = "KP";
    CountryCode["KR"] = "KR";
    CountryCode["KW"] = "KW";
    CountryCode["KY"] = "KY";
    CountryCode["KZ"] = "KZ";
    CountryCode["LA"] = "LA";
    CountryCode["LB"] = "LB";
    CountryCode["LC"] = "LC";
    CountryCode["LI"] = "LI";
    CountryCode["LK"] = "LK";
    CountryCode["LR"] = "LR";
    CountryCode["LS"] = "LS";
    CountryCode["LT"] = "LT";
    CountryCode["LU"] = "LU";
    CountryCode["LV"] = "LV";
    CountryCode["LY"] = "LY";
    CountryCode["MA"] = "MA";
    CountryCode["MC"] = "MC";
    CountryCode["MD"] = "MD";
    CountryCode["ME"] = "ME";
    CountryCode["MF"] = "MF";
    CountryCode["MG"] = "MG";
    CountryCode["MH"] = "MH";
    CountryCode["MK"] = "MK";
    CountryCode["ML"] = "ML";
    CountryCode["MM"] = "MM";
    CountryCode["MN"] = "MN";
    CountryCode["MO"] = "MO";
    CountryCode["MP"] = "MP";
    CountryCode["MQ"] = "MQ";
    CountryCode["MR"] = "MR";
    CountryCode["MS"] = "MS";
    CountryCode["MT"] = "MT";
    CountryCode["MU"] = "MU";
    CountryCode["MV"] = "MV";
    CountryCode["MW"] = "MW";
    CountryCode["MX"] = "MX";
    CountryCode["MY"] = "MY";
    CountryCode["MZ"] = "MZ";
    CountryCode["NA"] = "NA";
    CountryCode["NC"] = "NC";
    CountryCode["NE"] = "NE";
    CountryCode["NF"] = "NF";
    CountryCode["NG"] = "NG";
    CountryCode["NI"] = "NI";
    CountryCode["NL"] = "NL";
    CountryCode["NO"] = "NO";
    CountryCode["NP"] = "NP";
    CountryCode["NR"] = "NR";
    CountryCode["NU"] = "NU";
    CountryCode["NZ"] = "NZ";
    CountryCode["OM"] = "OM";
    CountryCode["PA"] = "PA";
    CountryCode["PE"] = "PE";
    CountryCode["PF"] = "PF";
    CountryCode["PG"] = "PG";
    CountryCode["PH"] = "PH";
    CountryCode["PK"] = "PK";
    CountryCode["PL"] = "PL";
    CountryCode["PM"] = "PM";
    CountryCode["PN"] = "PN";
    CountryCode["PR"] = "PR";
    CountryCode["PS"] = "PS";
    CountryCode["PT"] = "PT";
    CountryCode["PW"] = "PW";
    CountryCode["PY"] = "PY";
    CountryCode["QA"] = "QA";
    CountryCode["RE"] = "RE";
    CountryCode["RO"] = "RO";
    CountryCode["RS"] = "RS";
    CountryCode["RU"] = "RU";
    CountryCode["RW"] = "RW";
    CountryCode["SA"] = "SA";
    CountryCode["SB"] = "SB";
    CountryCode["SC"] = "SC";
    CountryCode["SD"] = "SD";
    CountryCode["SE"] = "SE";
    CountryCode["SG"] = "SG";
    CountryCode["SH"] = "SH";
    CountryCode["SI"] = "SI";
    CountryCode["SJ"] = "SJ";
    CountryCode["SK"] = "SK";
    CountryCode["SL"] = "SL";
    CountryCode["SM"] = "SM";
    CountryCode["SN"] = "SN";
    CountryCode["SO"] = "SO";
    CountryCode["SR"] = "SR";
    CountryCode["SS"] = "SS";
    CountryCode["ST"] = "ST";
    CountryCode["SV"] = "SV";
    CountryCode["SX"] = "SX";
    CountryCode["SY"] = "SY";
    CountryCode["SZ"] = "SZ";
    CountryCode["TC"] = "TC";
    CountryCode["TD"] = "TD";
    CountryCode["TF"] = "TF";
    CountryCode["TG"] = "TG";
    CountryCode["TH"] = "TH";
    CountryCode["TJ"] = "TJ";
    CountryCode["TK"] = "TK";
    CountryCode["TL"] = "TL";
    CountryCode["TM"] = "TM";
    CountryCode["TN"] = "TN";
    CountryCode["TO"] = "TO";
    CountryCode["TR"] = "TR";
    CountryCode["TT"] = "TT";
    CountryCode["TV"] = "TV";
    CountryCode["TW"] = "TW";
    CountryCode["TZ"] = "TZ";
    CountryCode["UA"] = "UA";
    CountryCode["UG"] = "UG";
    CountryCode["UM"] = "UM";
    CountryCode["US"] = "US";
    CountryCode["UY"] = "UY";
    CountryCode["UZ"] = "UZ";
    CountryCode["VA"] = "VA";
    CountryCode["VC"] = "VC";
    CountryCode["VE"] = "VE";
    CountryCode["VG"] = "VG";
    CountryCode["VI"] = "VI";
    CountryCode["VN"] = "VN";
    CountryCode["VU"] = "VU";
    CountryCode["WF"] = "WF";
    CountryCode["WS"] = "WS";
    CountryCode["YE"] = "YE";
    CountryCode["YT"] = "YT";
    CountryCode["ZA"] = "ZA";
    CountryCode["ZM"] = "ZM";
    CountryCode["ZW"] = "ZW";
})(CountryCode || (CountryCode = {}));
var CustomerEventsEnum;
(function(CustomerEventsEnum) {
    CustomerEventsEnum["ACCOUNT_CREATED"] = "ACCOUNT_CREATED";
    CustomerEventsEnum["CUSTOMER_DELETED"] = "CUSTOMER_DELETED";
    CustomerEventsEnum["DIGITAL_LINK_DOWNLOADED"] = "DIGITAL_LINK_DOWNLOADED";
    CustomerEventsEnum["EMAIL_ASSIGNED"] = "EMAIL_ASSIGNED";
    CustomerEventsEnum["EMAIL_CHANGED"] = "EMAIL_CHANGED";
    CustomerEventsEnum["EMAIL_CHANGED_REQUEST"] = "EMAIL_CHANGED_REQUEST";
    CustomerEventsEnum["NAME_ASSIGNED"] = "NAME_ASSIGNED";
    CustomerEventsEnum["NOTE_ADDED"] = "NOTE_ADDED";
    CustomerEventsEnum["NOTE_ADDED_TO_ORDER"] = "NOTE_ADDED_TO_ORDER";
    CustomerEventsEnum["PASSWORD_CHANGED"] = "PASSWORD_CHANGED";
    CustomerEventsEnum["PASSWORD_RESET"] = "PASSWORD_RESET";
    CustomerEventsEnum["PASSWORD_RESET_LINK_SENT"] = "PASSWORD_RESET_LINK_SENT";
    CustomerEventsEnum["PLACED_ORDER"] = "PLACED_ORDER";
})(CustomerEventsEnum || (CustomerEventsEnum = {}));
var DefaultAttributeValueAttributeType;
(function(DefaultAttributeValueAttributeType) {
    DefaultAttributeValueAttributeType[/** PRODUCT */ "PRODUCT"] = "PRODUCT";
    DefaultAttributeValueAttributeType[/** VARIANT */ "VARIANT"] = "VARIANT";
})(DefaultAttributeValueAttributeType || (DefaultAttributeValueAttributeType = {}));
var DiscountErrorCode;
(function(DiscountErrorCode) {
    DiscountErrorCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    DiscountErrorCode["CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT"] = "CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT";
    DiscountErrorCode["DUPLICATED_INPUT_ITEM"] = "DUPLICATED_INPUT_ITEM";
    DiscountErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    DiscountErrorCode["INVALID"] = "INVALID";
    DiscountErrorCode["NOT_FOUND"] = "NOT_FOUND";
    DiscountErrorCode["REQUIRED"] = "REQUIRED";
    DiscountErrorCode["UNIQUE"] = "UNIQUE";
})(DiscountErrorCode || (DiscountErrorCode = {}));
var DiscountStatusEnum;
(function(DiscountStatusEnum) {
    DiscountStatusEnum["ACTIVE"] = "ACTIVE";
    DiscountStatusEnum["EXPIRED"] = "EXPIRED";
    DiscountStatusEnum["SCHEDULED"] = "SCHEDULED";
})(DiscountStatusEnum || (DiscountStatusEnum = {}));
var DiscountValueTypeEnum;
(function(DiscountValueTypeEnum) {
    DiscountValueTypeEnum["FIXED"] = "FIXED";
    DiscountValueTypeEnum["PERCENTAGE"] = "PERCENTAGE";
})(DiscountValueTypeEnum || (DiscountValueTypeEnum = {}));
var ExportErrorCode;
(function(ExportErrorCode) {
    ExportErrorCode["INVALID"] = "INVALID";
    ExportErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ExportErrorCode["REQUIRED"] = "REQUIRED";
})(ExportErrorCode || (ExportErrorCode = {}));
var ExportEventsEnum;
(function(ExportEventsEnum) {
    ExportEventsEnum["EXPORTED_FILE_SENT"] = "EXPORTED_FILE_SENT";
    ExportEventsEnum["EXPORT_DELETED"] = "EXPORT_DELETED";
    ExportEventsEnum["EXPORT_FAILED"] = "EXPORT_FAILED";
    ExportEventsEnum["EXPORT_FAILED_INFO_SENT"] = "EXPORT_FAILED_INFO_SENT";
    ExportEventsEnum["EXPORT_PENDING"] = "EXPORT_PENDING";
    ExportEventsEnum["EXPORT_SUCCESS"] = "EXPORT_SUCCESS";
})(ExportEventsEnum || (ExportEventsEnum = {}));
var ExportFileSortField;
(function(ExportFileSortField) {
    ExportFileSortField[/** Sort export file by created at. */ "CREATED_AT"] = "CREATED_AT";
    ExportFileSortField[/** Sort export file by status. */ "STATUS"] = "STATUS";
    ExportFileSortField[/** Sort export file by updated at. */ "UPDATED_AT"] = "UPDATED_AT";
})(ExportFileSortField || (ExportFileSortField = {}));
var ExportScope;
(function(ExportScope) {
    ExportScope[/** Export all products. */ "ALL"] = "ALL";
    ExportScope[/** Export the filtered products. */ "FILTER"] = "FILTER";
    ExportScope[/** Export products with given ids. */ "IDS"] = "IDS";
})(ExportScope || (ExportScope = {}));
var FileTypesEnum;
(function(FileTypesEnum) {
    FileTypesEnum["CSV"] = "CSV";
    FileTypesEnum["XLSX"] = "XLSX";
})(FileTypesEnum || (FileTypesEnum = {}));
var FulfillmentStatus;
(function(FulfillmentStatus) {
    FulfillmentStatus[/** Canceled */ "CANCELED"] = "CANCELED";
    FulfillmentStatus[/** Fulfilled */ "FULFILLED"] = "FULFILLED";
})(FulfillmentStatus || (FulfillmentStatus = {}));
var GiftCardErrorCode;
(function(GiftCardErrorCode) {
    GiftCardErrorCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    GiftCardErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    GiftCardErrorCode["INVALID"] = "INVALID";
    GiftCardErrorCode["NOT_FOUND"] = "NOT_FOUND";
    GiftCardErrorCode["REQUIRED"] = "REQUIRED";
    GiftCardErrorCode["UNIQUE"] = "UNIQUE";
})(GiftCardErrorCode || (GiftCardErrorCode = {}));
var InvoiceErrorCode;
(function(InvoiceErrorCode) {
    InvoiceErrorCode["EMAIL_NOT_SET"] = "EMAIL_NOT_SET";
    InvoiceErrorCode["INVALID_STATUS"] = "INVALID_STATUS";
    InvoiceErrorCode["NOT_FOUND"] = "NOT_FOUND";
    InvoiceErrorCode["NOT_READY"] = "NOT_READY";
    InvoiceErrorCode["NUMBER_NOT_SET"] = "NUMBER_NOT_SET";
    InvoiceErrorCode["REQUIRED"] = "REQUIRED";
    InvoiceErrorCode["URL_NOT_SET"] = "URL_NOT_SET";
})(InvoiceErrorCode || (InvoiceErrorCode = {}));
var JobStatusEnum;
(function(JobStatusEnum) {
    JobStatusEnum["DELETED"] = "DELETED";
    JobStatusEnum["FAILED"] = "FAILED";
    JobStatusEnum["PENDING"] = "PENDING";
    JobStatusEnum["SUCCESS"] = "SUCCESS";
})(JobStatusEnum || (JobStatusEnum = {}));
var LanguageCodeEnum;
(function(LanguageCodeEnum) {
    LanguageCodeEnum["AR"] = "AR";
    LanguageCodeEnum["AZ"] = "AZ";
    LanguageCodeEnum["BG"] = "BG";
    LanguageCodeEnum["BN"] = "BN";
    LanguageCodeEnum["CA"] = "CA";
    LanguageCodeEnum["CS"] = "CS";
    LanguageCodeEnum["DA"] = "DA";
    LanguageCodeEnum["DE"] = "DE";
    LanguageCodeEnum["EL"] = "EL";
    LanguageCodeEnum["EN"] = "EN";
    LanguageCodeEnum["ES"] = "ES";
    LanguageCodeEnum["ES_CO"] = "ES_CO";
    LanguageCodeEnum["ET"] = "ET";
    LanguageCodeEnum["FA"] = "FA";
    LanguageCodeEnum["FI"] = "FI";
    LanguageCodeEnum["FR"] = "FR";
    LanguageCodeEnum["HI"] = "HI";
    LanguageCodeEnum["HU"] = "HU";
    LanguageCodeEnum["HY"] = "HY";
    LanguageCodeEnum["ID"] = "ID";
    LanguageCodeEnum["IS"] = "IS";
    LanguageCodeEnum["IT"] = "IT";
    LanguageCodeEnum["JA"] = "JA";
    LanguageCodeEnum["KA"] = "KA";
    LanguageCodeEnum["KM"] = "KM";
    LanguageCodeEnum["KO"] = "KO";
    LanguageCodeEnum["LT"] = "LT";
    LanguageCodeEnum["MN"] = "MN";
    LanguageCodeEnum["MY"] = "MY";
    LanguageCodeEnum["NB"] = "NB";
    LanguageCodeEnum["NL"] = "NL";
    LanguageCodeEnum["PL"] = "PL";
    LanguageCodeEnum["PT"] = "PT";
    LanguageCodeEnum["PT_BR"] = "PT_BR";
    LanguageCodeEnum["RO"] = "RO";
    LanguageCodeEnum["RU"] = "RU";
    LanguageCodeEnum["SK"] = "SK";
    LanguageCodeEnum["SL"] = "SL";
    LanguageCodeEnum["SQ"] = "SQ";
    LanguageCodeEnum["SR"] = "SR";
    LanguageCodeEnum["SV"] = "SV";
    LanguageCodeEnum["SW"] = "SW";
    LanguageCodeEnum["TA"] = "TA";
    LanguageCodeEnum["TH"] = "TH";
    LanguageCodeEnum["TR"] = "TR";
    LanguageCodeEnum["UK"] = "UK";
    LanguageCodeEnum["VI"] = "VI";
    LanguageCodeEnum["ZH_HANS"] = "ZH_HANS";
    LanguageCodeEnum["ZH_HANT"] = "ZH_HANT";
})(LanguageCodeEnum || (LanguageCodeEnum = {}));
var MenuErrorCode;
(function(MenuErrorCode) {
    MenuErrorCode["CANNOT_ASSIGN_NODE"] = "CANNOT_ASSIGN_NODE";
    MenuErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    MenuErrorCode["INVALID"] = "INVALID";
    MenuErrorCode["INVALID_MENU_ITEM"] = "INVALID_MENU_ITEM";
    MenuErrorCode["NOT_FOUND"] = "NOT_FOUND";
    MenuErrorCode["NO_MENU_ITEM_PROVIDED"] = "NO_MENU_ITEM_PROVIDED";
    MenuErrorCode["REQUIRED"] = "REQUIRED";
    MenuErrorCode["TOO_MANY_MENU_ITEMS"] = "TOO_MANY_MENU_ITEMS";
    MenuErrorCode["UNIQUE"] = "UNIQUE";
})(MenuErrorCode || (MenuErrorCode = {}));
var MenuItemsSortField;
(function(MenuItemsSortField) {
    MenuItemsSortField[/** Sort menu items by name. */ "NAME"] = "NAME";
})(MenuItemsSortField || (MenuItemsSortField = {}));
var MenuSortField;
(function(MenuSortField) {
    MenuSortField[/** Sort menus by items count. */ "ITEMS_COUNT"] = "ITEMS_COUNT";
    MenuSortField[/** Sort menus by name. */ "NAME"] = "NAME";
})(MenuSortField || (MenuSortField = {}));
var MetadataErrorCode;
(function(MetadataErrorCode) {
    MetadataErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    MetadataErrorCode["INVALID"] = "INVALID";
    MetadataErrorCode["NOT_FOUND"] = "NOT_FOUND";
    MetadataErrorCode["REQUIRED"] = "REQUIRED";
})(MetadataErrorCode || (MetadataErrorCode = {}));
var NavigationType;
(function(NavigationType) {
    NavigationType[/** Main storefront navigation. */ "MAIN"] = "MAIN";
    NavigationType[/** Secondary storefront navigation. */ "SECONDARY"] = "SECONDARY";
})(NavigationType || (NavigationType = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction[/** Represents the capture action. */ "CAPTURE"] = "CAPTURE";
    OrderAction[/** Represents a mark-as-paid action. */ "MARK_AS_PAID"] = "MARK_AS_PAID";
    OrderAction[/** Represents a refund action. */ "REFUND"] = "REFUND";
    OrderAction[/** Represents a void action. */ "VOID"] = "VOID";
})(OrderAction || (OrderAction = {}));
var OrderDirection;
(function(OrderDirection) {
    OrderDirection[/** Specifies an ascending sort order. */ "ASC"] = "ASC";
    OrderDirection[/** Specifies a descending sort order. */ "DESC"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
var OrderErrorCode;
(function(OrderErrorCode) {
    OrderErrorCode["BILLING_ADDRESS_NOT_SET"] = "BILLING_ADDRESS_NOT_SET";
    OrderErrorCode["CANNOT_CANCEL_FULFILLMENT"] = "CANNOT_CANCEL_FULFILLMENT";
    OrderErrorCode["CANNOT_CANCEL_ORDER"] = "CANNOT_CANCEL_ORDER";
    OrderErrorCode["CANNOT_DELETE"] = "CANNOT_DELETE";
    OrderErrorCode["CANNOT_REFUND"] = "CANNOT_REFUND";
    OrderErrorCode["CAPTURE_INACTIVE_PAYMENT"] = "CAPTURE_INACTIVE_PAYMENT";
    OrderErrorCode["DUPLICATED_INPUT_ITEM"] = "DUPLICATED_INPUT_ITEM";
    OrderErrorCode["FULFILL_ORDER_LINE"] = "FULFILL_ORDER_LINE";
    OrderErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    OrderErrorCode["INSUFFICIENT_STOCK"] = "INSUFFICIENT_STOCK";
    OrderErrorCode["INVALID"] = "INVALID";
    OrderErrorCode["NOT_EDITABLE"] = "NOT_EDITABLE";
    OrderErrorCode["NOT_FOUND"] = "NOT_FOUND";
    OrderErrorCode["ORDER_NO_SHIPPING_ADDRESS"] = "ORDER_NO_SHIPPING_ADDRESS";
    OrderErrorCode["PAYMENT_ERROR"] = "PAYMENT_ERROR";
    OrderErrorCode["PAYMENT_MISSING"] = "PAYMENT_MISSING";
    OrderErrorCode["PRODUCT_NOT_PUBLISHED"] = "PRODUCT_NOT_PUBLISHED";
    OrderErrorCode["PRODUCT_UNAVAILABLE_FOR_PURCHASE"] = "PRODUCT_UNAVAILABLE_FOR_PURCHASE";
    OrderErrorCode["REQUIRED"] = "REQUIRED";
    OrderErrorCode["SHIPPING_METHOD_NOT_APPLICABLE"] = "SHIPPING_METHOD_NOT_APPLICABLE";
    OrderErrorCode["SHIPPING_METHOD_REQUIRED"] = "SHIPPING_METHOD_REQUIRED";
    OrderErrorCode["TAX_ERROR"] = "TAX_ERROR";
    OrderErrorCode["UNIQUE"] = "UNIQUE";
    OrderErrorCode["VOID_INACTIVE_PAYMENT"] = "VOID_INACTIVE_PAYMENT";
    OrderErrorCode["ZERO_QUANTITY"] = "ZERO_QUANTITY";
})(OrderErrorCode || (OrderErrorCode = {}));
var OrderEventsEmailsEnum;
(function(OrderEventsEmailsEnum) {
    OrderEventsEmailsEnum["DIGITAL_LINKS"] = "DIGITAL_LINKS";
    OrderEventsEmailsEnum["FULFILLMENT_CONFIRMATION"] = "FULFILLMENT_CONFIRMATION";
    OrderEventsEmailsEnum["ORDER_CANCEL"] = "ORDER_CANCEL";
    OrderEventsEmailsEnum["ORDER_CONFIRMATION"] = "ORDER_CONFIRMATION";
    OrderEventsEmailsEnum["ORDER_REFUND"] = "ORDER_REFUND";
    OrderEventsEmailsEnum["PAYMENT_CONFIRMATION"] = "PAYMENT_CONFIRMATION";
    OrderEventsEmailsEnum["SHIPPING_CONFIRMATION"] = "SHIPPING_CONFIRMATION";
    OrderEventsEmailsEnum["TRACKING_UPDATED"] = "TRACKING_UPDATED";
})(OrderEventsEmailsEnum || (OrderEventsEmailsEnum = {}));
var OrderEventsEnum;
(function(OrderEventsEnum) {
    OrderEventsEnum["CANCELED"] = "CANCELED";
    OrderEventsEnum["DRAFT_ADDED_PRODUCTS"] = "DRAFT_ADDED_PRODUCTS";
    OrderEventsEnum["DRAFT_CREATED"] = "DRAFT_CREATED";
    OrderEventsEnum["DRAFT_REMOVED_PRODUCTS"] = "DRAFT_REMOVED_PRODUCTS";
    OrderEventsEnum["EMAIL_SENT"] = "EMAIL_SENT";
    OrderEventsEnum["EXTERNAL_SERVICE_NOTIFICATION"] = "EXTERNAL_SERVICE_NOTIFICATION";
    OrderEventsEnum["FULFILLMENT_CANCELED"] = "FULFILLMENT_CANCELED";
    OrderEventsEnum["FULFILLMENT_FULFILLED_ITEMS"] = "FULFILLMENT_FULFILLED_ITEMS";
    OrderEventsEnum["FULFILLMENT_RESTOCKED_ITEMS"] = "FULFILLMENT_RESTOCKED_ITEMS";
    OrderEventsEnum["INVOICE_GENERATED"] = "INVOICE_GENERATED";
    OrderEventsEnum["INVOICE_REQUESTED"] = "INVOICE_REQUESTED";
    OrderEventsEnum["INVOICE_SENT"] = "INVOICE_SENT";
    OrderEventsEnum["INVOICE_UPDATED"] = "INVOICE_UPDATED";
    OrderEventsEnum["NOTE_ADDED"] = "NOTE_ADDED";
    OrderEventsEnum["ORDER_FULLY_PAID"] = "ORDER_FULLY_PAID";
    OrderEventsEnum["ORDER_MARKED_AS_PAID"] = "ORDER_MARKED_AS_PAID";
    OrderEventsEnum["OTHER"] = "OTHER";
    OrderEventsEnum["OVERSOLD_ITEMS"] = "OVERSOLD_ITEMS";
    OrderEventsEnum["PAYMENT_AUTHORIZED"] = "PAYMENT_AUTHORIZED";
    OrderEventsEnum["PAYMENT_CAPTURED"] = "PAYMENT_CAPTURED";
    OrderEventsEnum["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    OrderEventsEnum["PAYMENT_REFUNDED"] = "PAYMENT_REFUNDED";
    OrderEventsEnum["PAYMENT_VOIDED"] = "PAYMENT_VOIDED";
    OrderEventsEnum["PLACED"] = "PLACED";
    OrderEventsEnum["PLACED_FROM_DRAFT"] = "PLACED_FROM_DRAFT";
    OrderEventsEnum["TRACKING_UPDATED"] = "TRACKING_UPDATED";
    OrderEventsEnum["UPDATED_ADDRESS"] = "UPDATED_ADDRESS";
})(OrderEventsEnum || (OrderEventsEnum = {}));
var OrderSortField;
(function(OrderSortField) {
    OrderSortField[/** Sort orders by creation date. */ "CREATION_DATE"] = "CREATION_DATE";
    OrderSortField[/** Sort orders by customer. */ "CUSTOMER"] = "CUSTOMER";
    OrderSortField[/** Sort orders by fulfillment status. */ "FULFILLMENT_STATUS"] = "FULFILLMENT_STATUS";
    OrderSortField[/** Sort orders by number. */ "NUMBER"] = "NUMBER";
    OrderSortField[/** Sort orders by payment. */ "PAYMENT"] = "PAYMENT";
    OrderSortField[/** Sort orders by total. */ "TOTAL"] = "TOTAL";
})(OrderSortField || (OrderSortField = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus[/** Canceled */ "CANCELED"] = "CANCELED";
    OrderStatus[/** Draft */ "DRAFT"] = "DRAFT";
    OrderStatus[/** Fulfilled */ "FULFILLED"] = "FULFILLED";
    OrderStatus[/** Partially fulfilled */ "PARTIALLY_FULFILLED"] = "PARTIALLY_FULFILLED";
    OrderStatus[/** Unfulfilled */ "UNFULFILLED"] = "UNFULFILLED";
})(OrderStatus || (OrderStatus = {}));
var OrderStatusFilter;
(function(OrderStatusFilter) {
    OrderStatusFilter["CANCELED"] = "CANCELED";
    OrderStatusFilter["FULFILLED"] = "FULFILLED";
    OrderStatusFilter["PARTIALLY_FULFILLED"] = "PARTIALLY_FULFILLED";
    OrderStatusFilter["READY_TO_CAPTURE"] = "READY_TO_CAPTURE";
    OrderStatusFilter["READY_TO_FULFILL"] = "READY_TO_FULFILL";
    OrderStatusFilter["UNFULFILLED"] = "UNFULFILLED";
})(OrderStatusFilter || (OrderStatusFilter = {}));
var PageErrorCode;
(function(PageErrorCode) {
    PageErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    PageErrorCode["INVALID"] = "INVALID";
    PageErrorCode["NOT_FOUND"] = "NOT_FOUND";
    PageErrorCode["REQUIRED"] = "REQUIRED";
    PageErrorCode["UNIQUE"] = "UNIQUE";
})(PageErrorCode || (PageErrorCode = {}));
var PageSortField;
(function(PageSortField) {
    PageSortField[/** Sort pages by creation date. */ "CREATION_DATE"] = "CREATION_DATE";
    PageSortField[/** Sort pages by publication date. */ "PUBLICATION_DATE"] = "PUBLICATION_DATE";
    PageSortField[/** Sort pages by slug. */ "SLUG"] = "SLUG";
    PageSortField[/** Sort pages by title. */ "TITLE"] = "TITLE";
    PageSortField[/** Sort pages by visibility. */ "VISIBILITY"] = "VISIBILITY";
})(PageSortField || (PageSortField = {}));
var PaymentChargeStatusEnum;
(function(PaymentChargeStatusEnum) {
    PaymentChargeStatusEnum["CANCELLED"] = "CANCELLED";
    PaymentChargeStatusEnum["FULLY_CHARGED"] = "FULLY_CHARGED";
    PaymentChargeStatusEnum["FULLY_REFUNDED"] = "FULLY_REFUNDED";
    PaymentChargeStatusEnum["NOT_CHARGED"] = "NOT_CHARGED";
    PaymentChargeStatusEnum["PARTIALLY_CHARGED"] = "PARTIALLY_CHARGED";
    PaymentChargeStatusEnum["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    PaymentChargeStatusEnum["PENDING"] = "PENDING";
    PaymentChargeStatusEnum["REFUSED"] = "REFUSED";
})(PaymentChargeStatusEnum || (PaymentChargeStatusEnum = {}));
var PaymentErrorCode;
(function(PaymentErrorCode) {
    PaymentErrorCode["BILLING_ADDRESS_NOT_SET"] = "BILLING_ADDRESS_NOT_SET";
    PaymentErrorCode["CHECKOUT_EMAIL_NOT_SET"] = "CHECKOUT_EMAIL_NOT_SET";
    PaymentErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    PaymentErrorCode["INVALID"] = "INVALID";
    PaymentErrorCode["INVALID_SHIPPING_METHOD"] = "INVALID_SHIPPING_METHOD";
    PaymentErrorCode["NOT_FOUND"] = "NOT_FOUND";
    PaymentErrorCode["NOT_SUPPORTED_GATEWAY"] = "NOT_SUPPORTED_GATEWAY";
    PaymentErrorCode["NO_CHECKOUT_LINES"] = "NO_CHECKOUT_LINES";
    PaymentErrorCode["PARTIAL_PAYMENT_NOT_ALLOWED"] = "PARTIAL_PAYMENT_NOT_ALLOWED";
    PaymentErrorCode["PAYMENT_ERROR"] = "PAYMENT_ERROR";
    PaymentErrorCode["REQUIRED"] = "REQUIRED";
    PaymentErrorCode["SHIPPING_ADDRESS_NOT_SET"] = "SHIPPING_ADDRESS_NOT_SET";
    PaymentErrorCode["SHIPPING_METHOD_NOT_SET"] = "SHIPPING_METHOD_NOT_SET";
    PaymentErrorCode["UNIQUE"] = "UNIQUE";
})(PaymentErrorCode || (PaymentErrorCode = {}));
var PermissionEnum;
(function(PermissionEnum) {
    PermissionEnum["MANAGE_APPS"] = "MANAGE_APPS";
    PermissionEnum["MANAGE_CHECKOUTS"] = "MANAGE_CHECKOUTS";
    PermissionEnum["MANAGE_DISCOUNTS"] = "MANAGE_DISCOUNTS";
    PermissionEnum["MANAGE_GIFT_CARD"] = "MANAGE_GIFT_CARD";
    PermissionEnum["MANAGE_MENUS"] = "MANAGE_MENUS";
    PermissionEnum["MANAGE_ORDERS"] = "MANAGE_ORDERS";
    PermissionEnum["MANAGE_PAGES"] = "MANAGE_PAGES";
    PermissionEnum["MANAGE_PLUGINS"] = "MANAGE_PLUGINS";
    PermissionEnum["MANAGE_PRODUCTS"] = "MANAGE_PRODUCTS";
    PermissionEnum["MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES"] = "MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES";
    PermissionEnum["MANAGE_REVIEWS"] = "MANAGE_REVIEWS";
    PermissionEnum["MANAGE_SERVICE_ACCOUNTS"] = "MANAGE_SERVICE_ACCOUNTS";
    PermissionEnum["MANAGE_SETTINGS"] = "MANAGE_SETTINGS";
    PermissionEnum["MANAGE_SHIPPING"] = "MANAGE_SHIPPING";
    PermissionEnum["MANAGE_STAFF"] = "MANAGE_STAFF";
    PermissionEnum["MANAGE_TRANSLATIONS"] = "MANAGE_TRANSLATIONS";
    PermissionEnum["MANAGE_USERS"] = "MANAGE_USERS";
})(PermissionEnum || (PermissionEnum = {}));
var PermissionGroupErrorCode;
(function(PermissionGroupErrorCode) {
    PermissionGroupErrorCode["ASSIGN_NON_STAFF_MEMBER"] = "ASSIGN_NON_STAFF_MEMBER";
    PermissionGroupErrorCode["CANNOT_REMOVE_FROM_LAST_GROUP"] = "CANNOT_REMOVE_FROM_LAST_GROUP";
    PermissionGroupErrorCode["DUPLICATED_INPUT_ITEM"] = "DUPLICATED_INPUT_ITEM";
    PermissionGroupErrorCode["LEFT_NOT_MANAGEABLE_PERMISSION"] = "LEFT_NOT_MANAGEABLE_PERMISSION";
    PermissionGroupErrorCode["OUT_OF_SCOPE_PERMISSION"] = "OUT_OF_SCOPE_PERMISSION";
    PermissionGroupErrorCode["OUT_OF_SCOPE_USER"] = "OUT_OF_SCOPE_USER";
    PermissionGroupErrorCode["REQUIRED"] = "REQUIRED";
    PermissionGroupErrorCode["UNIQUE"] = "UNIQUE";
})(PermissionGroupErrorCode || (PermissionGroupErrorCode = {}));
var PermissionGroupSortField;
(function(PermissionGroupSortField) {
    PermissionGroupSortField[/** Sort permission group accounts by name. */ "NAME"] = "NAME";
})(PermissionGroupSortField || (PermissionGroupSortField = {}));
var PluginErrorCode;
(function(PluginErrorCode) {
    PluginErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    PluginErrorCode["INVALID"] = "INVALID";
    PluginErrorCode["NOT_FOUND"] = "NOT_FOUND";
    PluginErrorCode["PLUGIN_MISCONFIGURED"] = "PLUGIN_MISCONFIGURED";
    PluginErrorCode["REQUIRED"] = "REQUIRED";
    PluginErrorCode["UNIQUE"] = "UNIQUE";
})(PluginErrorCode || (PluginErrorCode = {}));
var PluginSortField;
(function(PluginSortField) {
    PluginSortField["IS_ACTIVE"] = "IS_ACTIVE";
    PluginSortField["NAME"] = "NAME";
})(PluginSortField || (PluginSortField = {}));
var ProductErrorCode;
(function(ProductErrorCode) {
    ProductErrorCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    ProductErrorCode["ATTRIBUTE_ALREADY_ASSIGNED"] = "ATTRIBUTE_ALREADY_ASSIGNED";
    ProductErrorCode["ATTRIBUTE_CANNOT_BE_ASSIGNED"] = "ATTRIBUTE_CANNOT_BE_ASSIGNED";
    ProductErrorCode["ATTRIBUTE_VARIANTS_DISABLED"] = "ATTRIBUTE_VARIANTS_DISABLED";
    ProductErrorCode["DUPLICATED_INPUT_ITEM"] = "DUPLICATED_INPUT_ITEM";
    ProductErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    ProductErrorCode["INVALID"] = "INVALID";
    ProductErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ProductErrorCode["NOT_PRODUCTS_IMAGE"] = "NOT_PRODUCTS_IMAGE";
    ProductErrorCode["NOT_PRODUCTS_VARIANT"] = "NOT_PRODUCTS_VARIANT";
    ProductErrorCode["REQUIRED"] = "REQUIRED";
    ProductErrorCode["UNIQUE"] = "UNIQUE";
    ProductErrorCode["VARIANT_NO_DIGITAL_CONTENT"] = "VARIANT_NO_DIGITAL_CONTENT";
})(ProductErrorCode || (ProductErrorCode = {}));
var ProductFieldEnum;
(function(ProductFieldEnum) {
    ProductFieldEnum["AVAILABLE_FOR_PURCHASE"] = "AVAILABLE_FOR_PURCHASE";
    ProductFieldEnum["CATEGORY"] = "CATEGORY";
    ProductFieldEnum["CHARGE_TAXES"] = "CHARGE_TAXES";
    ProductFieldEnum["COLLECTIONS"] = "COLLECTIONS";
    ProductFieldEnum["COST_PRICE"] = "COST_PRICE";
    ProductFieldEnum["DESCRIPTION"] = "DESCRIPTION";
    ProductFieldEnum["NAME"] = "NAME";
    ProductFieldEnum["PRODUCT_IMAGES"] = "PRODUCT_IMAGES";
    ProductFieldEnum["PRODUCT_TYPE"] = "PRODUCT_TYPE";
    ProductFieldEnum["PRODUCT_WEIGHT"] = "PRODUCT_WEIGHT";
    ProductFieldEnum["SEARCHABLE"] = "SEARCHABLE";
    ProductFieldEnum["VARIANT_IMAGES"] = "VARIANT_IMAGES";
    ProductFieldEnum["VARIANT_PRICE"] = "VARIANT_PRICE";
    ProductFieldEnum["VARIANT_SKU"] = "VARIANT_SKU";
    ProductFieldEnum["VARIANT_WEIGHT"] = "VARIANT_WEIGHT";
    ProductFieldEnum["VISIBLE"] = "VISIBLE";
})(ProductFieldEnum || (ProductFieldEnum = {}));
var ProductOrderField;
(function(ProductOrderField) {
    ProductOrderField[/** Sort products by collection. Note: This option is available only for the `Collection.products` query. */ "COLLECTION"] = "COLLECTION";
    ProductOrderField[/** Sort products by update date. */ "DATE"] = "DATE";
    ProductOrderField[/** Sort products by a minimal price of a product's variant. */ "MINIMAL_PRICE"] = "MINIMAL_PRICE";
    ProductOrderField[/** Sort products by name. */ "NAME"] = "NAME";
    ProductOrderField[/** Sort products by price. */ "PRICE"] = "PRICE";
    ProductOrderField[/** Sort products by publication date. */ "PUBLICATION_DATE"] = "PUBLICATION_DATE";
    ProductOrderField[/** Sort products by publication status. */ "PUBLISHED"] = "PUBLISHED";
    ProductOrderField[/** Sort products by type. */ "TYPE"] = "TYPE";
})(ProductOrderField || (ProductOrderField = {}));
var ProductTypeConfigurable;
(function(ProductTypeConfigurable) {
    ProductTypeConfigurable["CONFIGURABLE"] = "CONFIGURABLE";
    ProductTypeConfigurable["SIMPLE"] = "SIMPLE";
})(ProductTypeConfigurable || (ProductTypeConfigurable = {}));
var ProductTypeEnum;
(function(ProductTypeEnum) {
    ProductTypeEnum["DIGITAL"] = "DIGITAL";
    ProductTypeEnum["SHIPPABLE"] = "SHIPPABLE";
})(ProductTypeEnum || (ProductTypeEnum = {}));
var ProductTypeSortField;
(function(ProductTypeSortField) {
    ProductTypeSortField[/** Sort products by type. */ "DIGITAL"] = "DIGITAL";
    ProductTypeSortField[/** Sort products by name. */ "NAME"] = "NAME";
    ProductTypeSortField[/** Sort products by shipping. */ "SHIPPING_REQUIRED"] = "SHIPPING_REQUIRED";
})(ProductTypeSortField || (ProductTypeSortField = {}));
var ReportingPeriod;
(function(ReportingPeriod) {
    ReportingPeriod["THIS_MONTH"] = "THIS_MONTH";
    ReportingPeriod["TODAY"] = "TODAY";
})(ReportingPeriod || (ReportingPeriod = {}));
var ReviewAvatarEnum;
(function(ReviewAvatarEnum) {
    ReviewAvatarEnum["AVATAR_0"] = "AVATAR_0";
    ReviewAvatarEnum["AVATAR_1"] = "AVATAR_1";
    ReviewAvatarEnum["AVATAR_2"] = "AVATAR_2";
    ReviewAvatarEnum["AVATAR_3"] = "AVATAR_3";
    ReviewAvatarEnum["AVATAR_4"] = "AVATAR_4";
    ReviewAvatarEnum["AVATAR_5"] = "AVATAR_5";
    ReviewAvatarEnum["AVATAR_6"] = "AVATAR_6";
    ReviewAvatarEnum["AVATAR_7"] = "AVATAR_7";
    ReviewAvatarEnum["AVATAR_8"] = "AVATAR_8";
    ReviewAvatarEnum["AVATAR_9"] = "AVATAR_9";
})(ReviewAvatarEnum || (ReviewAvatarEnum = {}));
var ReviewErrorCode;
(function(ReviewErrorCode) {
    ReviewErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    ReviewErrorCode["INVALID"] = "INVALID";
    ReviewErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ReviewErrorCode["NOT_REVIEWS_IMAGE"] = "NOT_REVIEWS_IMAGE";
    ReviewErrorCode["REQUIRED"] = "REQUIRED";
    ReviewErrorCode["UNIQUE"] = "UNIQUE";
})(ReviewErrorCode || (ReviewErrorCode = {}));
var SaleSortField;
(function(SaleSortField) {
    SaleSortField[/** Sort sales by created at. */ "CREATED_AT"] = "CREATED_AT";
    SaleSortField[/** Sort sales by end date. */ "END_DATE"] = "END_DATE";
    SaleSortField[/** Sort sales by last modified at. */ "LAST_MODIFIED_AT"] = "LAST_MODIFIED_AT";
    SaleSortField[/** Sort sales by name. */ "NAME"] = "NAME";
    SaleSortField[/** Sort sales by start date. */ "START_DATE"] = "START_DATE";
    SaleSortField[/** Sort sales by type. */ "TYPE"] = "TYPE";
    SaleSortField[/** Sort sales by value. */ "VALUE"] = "VALUE";
})(SaleSortField || (SaleSortField = {}));
var SaleTypeEnum;
(function(SaleTypeEnum) {
    SaleTypeEnum["FIXED"] = "FIXED";
    SaleTypeEnum["PERCENTAGE"] = "PERCENTAGE";
})(SaleTypeEnum || (SaleTypeEnum = {}));
var ServiceAccountSortField;
(function(ServiceAccountSortField) {
    ServiceAccountSortField[/** Sort service accounts by creation date. */ "CREATION_DATE"] = "CREATION_DATE";
    ServiceAccountSortField[/** Sort service accounts by name. */ "NAME"] = "NAME";
})(ServiceAccountSortField || (ServiceAccountSortField = {}));
var ShippingDateTypeEnum;
(function(ShippingDateTypeEnum) {
    ShippingDateTypeEnum["DAYS"] = "DAYS";
    ShippingDateTypeEnum["WEEKS"] = "WEEKS";
})(ShippingDateTypeEnum || (ShippingDateTypeEnum = {}));
var ShippingErrorCode;
(function(ShippingErrorCode) {
    ShippingErrorCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    ShippingErrorCode["DUPLICATED_INPUT_ITEM"] = "DUPLICATED_INPUT_ITEM";
    ShippingErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    ShippingErrorCode["INVALID"] = "INVALID";
    ShippingErrorCode["MAX_LESS_THAN_MIN"] = "MAX_LESS_THAN_MIN";
    ShippingErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ShippingErrorCode["REQUIRED"] = "REQUIRED";
    ShippingErrorCode["UNIQUE"] = "UNIQUE";
})(ShippingErrorCode || (ShippingErrorCode = {}));
var ShippingMethodTypeEnum;
(function(ShippingMethodTypeEnum) {
    ShippingMethodTypeEnum["PRICE"] = "PRICE";
    ShippingMethodTypeEnum["WEIGHT"] = "WEIGHT";
})(ShippingMethodTypeEnum || (ShippingMethodTypeEnum = {}));
var ShopErrorCode;
(function(ShopErrorCode) {
    ShopErrorCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    ShopErrorCode["CANNOT_FETCH_TAX_RATES"] = "CANNOT_FETCH_TAX_RATES";
    ShopErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    ShopErrorCode["INVALID"] = "INVALID";
    ShopErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ShopErrorCode["REQUIRED"] = "REQUIRED";
    ShopErrorCode["UNIQUE"] = "UNIQUE";
})(ShopErrorCode || (ShopErrorCode = {}));
var StaffMemberStatus;
(function(StaffMemberStatus) {
    StaffMemberStatus["ACTIVE"] = "ACTIVE";
    StaffMemberStatus["DEACTIVATED"] = "DEACTIVATED";
})(StaffMemberStatus || (StaffMemberStatus = {}));
var StockAvailability;
(function(StockAvailability) {
    StockAvailability["IN_STOCK"] = "IN_STOCK";
    StockAvailability["OUT_OF_STOCK"] = "OUT_OF_STOCK";
})(StockAvailability || (StockAvailability = {}));
var StockErrorCode;
(function(StockErrorCode) {
    StockErrorCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    StockErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    StockErrorCode["INVALID"] = "INVALID";
    StockErrorCode["NOT_FOUND"] = "NOT_FOUND";
    StockErrorCode["REQUIRED"] = "REQUIRED";
    StockErrorCode["UNIQUE"] = "UNIQUE";
})(StockErrorCode || (StockErrorCode = {}));
var TaxRateType;
(function(TaxRateType) {
    TaxRateType["ACCOMMODATION"] = "ACCOMMODATION";
    TaxRateType["ADMISSION_TO_CULTURAL_EVENTS"] = "ADMISSION_TO_CULTURAL_EVENTS";
    TaxRateType["ADMISSION_TO_ENTERTAINMENT_EVENTS"] = "ADMISSION_TO_ENTERTAINMENT_EVENTS";
    TaxRateType["ADMISSION_TO_SPORTING_EVENTS"] = "ADMISSION_TO_SPORTING_EVENTS";
    TaxRateType["ADVERTISING"] = "ADVERTISING";
    TaxRateType["AGRICULTURAL_SUPPLIES"] = "AGRICULTURAL_SUPPLIES";
    TaxRateType["BABY_FOODSTUFFS"] = "BABY_FOODSTUFFS";
    TaxRateType["BIKES"] = "BIKES";
    TaxRateType["BOOKS"] = "BOOKS";
    TaxRateType["CHILDRENS_CLOTHING"] = "CHILDRENS_CLOTHING";
    TaxRateType["DOMESTIC_FUEL"] = "DOMESTIC_FUEL";
    TaxRateType["DOMESTIC_SERVICES"] = "DOMESTIC_SERVICES";
    TaxRateType["E_BOOKS"] = "E_BOOKS";
    TaxRateType["FOODSTUFFS"] = "FOODSTUFFS";
    TaxRateType["HOTELS"] = "HOTELS";
    TaxRateType["MEDICAL"] = "MEDICAL";
    TaxRateType["NEWSPAPERS"] = "NEWSPAPERS";
    TaxRateType["PASSENGER_TRANSPORT"] = "PASSENGER_TRANSPORT";
    TaxRateType["PHARMACEUTICALS"] = "PHARMACEUTICALS";
    TaxRateType["PROPERTY_RENOVATIONS"] = "PROPERTY_RENOVATIONS";
    TaxRateType["RESTAURANTS"] = "RESTAURANTS";
    TaxRateType["SOCIAL_HOUSING"] = "SOCIAL_HOUSING";
    TaxRateType["STANDARD"] = "STANDARD";
    TaxRateType["WATER"] = "WATER";
    TaxRateType["WINE"] = "WINE";
})(TaxRateType || (TaxRateType = {}));
var TransactionError;
(function(TransactionError) {
    TransactionError[/** declined */ "TRANSACTIONERROR_DECLINED"] = "TRANSACTIONERROR_DECLINED";
    TransactionError[/** expired */ "TRANSACTIONERROR_EXPIRED"] = "TRANSACTIONERROR_EXPIRED";
    TransactionError[/** incorrect_address */ "TRANSACTIONERROR_INCORRECT_ADDRESS"] = "TRANSACTIONERROR_INCORRECT_ADDRESS";
    TransactionError[/** incorrect_cvv */ "TRANSACTIONERROR_INCORRECT_CVV"] = "TRANSACTIONERROR_INCORRECT_CVV";
    TransactionError[/** incorrect_number */ "TRANSACTIONERROR_INCORRECT_NUMBER"] = "TRANSACTIONERROR_INCORRECT_NUMBER";
    TransactionError[/** incorrect_zip */ "TRANSACTIONERROR_INCORRECT_ZIP"] = "TRANSACTIONERROR_INCORRECT_ZIP";
    TransactionError[/** invalid_cvv */ "TRANSACTIONERROR_INVALID_CVV"] = "TRANSACTIONERROR_INVALID_CVV";
    TransactionError[/** invalid_expiry_date */ "TRANSACTIONERROR_INVALID_EXPIRY_DATE"] = "TRANSACTIONERROR_INVALID_EXPIRY_DATE";
    TransactionError[/** invalid_number */ "TRANSACTIONERROR_INVALID_NUMBER"] = "TRANSACTIONERROR_INVALID_NUMBER";
    TransactionError[/** processing_error */ "TRANSACTIONERROR_PROCESSING_ERROR"] = "TRANSACTIONERROR_PROCESSING_ERROR";
})(TransactionError || (TransactionError = {}));
var TransactionKind;
(function(TransactionKind) {
    TransactionKind[/** Action to confirm */ "ACTION_TO_CONFIRM"] = "ACTION_TO_CONFIRM";
    TransactionKind[/** Authorization */ "AUTH"] = "AUTH";
    TransactionKind[/** Cancel */ "CANCEL"] = "CANCEL";
    TransactionKind[/** Capture */ "CAPTURE"] = "CAPTURE";
    TransactionKind[/** Confirm */ "CONFIRM"] = "CONFIRM";
    TransactionKind[/** Pending */ "PENDING"] = "PENDING";
    TransactionKind[/** Refund */ "REFUND"] = "REFUND";
    TransactionKind[/** Refund in progress */ "REFUND_ONGOING"] = "REFUND_ONGOING";
    TransactionKind[/** Void */ "VOID"] = "VOID";
})(TransactionKind || (TransactionKind = {}));
var TranslatableKinds;
(function(TranslatableKinds) {
    TranslatableKinds["ATTRIBUTE"] = "ATTRIBUTE";
    TranslatableKinds["ATTRIBUTE_VALUE"] = "ATTRIBUTE_VALUE";
    TranslatableKinds["CATEGORY"] = "CATEGORY";
    TranslatableKinds["COLLECTION"] = "COLLECTION";
    TranslatableKinds["MENU_ITEM"] = "MENU_ITEM";
    TranslatableKinds["PAGE"] = "PAGE";
    TranslatableKinds["PRODUCT"] = "PRODUCT";
    TranslatableKinds["SALE"] = "SALE";
    TranslatableKinds["SHIPPING_METHOD"] = "SHIPPING_METHOD";
    TranslatableKinds["VARIANT"] = "VARIANT";
    TranslatableKinds["VOUCHER"] = "VOUCHER";
})(TranslatableKinds || (TranslatableKinds = {}));
var TranslationErrorCode;
(function(TranslationErrorCode) {
    TranslationErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    TranslationErrorCode["NOT_FOUND"] = "NOT_FOUND";
    TranslationErrorCode["REQUIRED"] = "REQUIRED";
})(TranslationErrorCode || (TranslationErrorCode = {}));
var UserSortField;
(function(UserSortField) {
    UserSortField[/** Sort users by email. */ "EMAIL"] = "EMAIL";
    UserSortField[/** Sort users by first name. */ "FIRST_NAME"] = "FIRST_NAME";
    UserSortField[/** Sort users by last name. */ "LAST_NAME"] = "LAST_NAME";
    UserSortField[/** Sort users by order count. */ "ORDER_COUNT"] = "ORDER_COUNT";
})(UserSortField || (UserSortField = {}));
var VoucherDiscountType;
(function(VoucherDiscountType) {
    VoucherDiscountType["FIXED"] = "FIXED";
    VoucherDiscountType["PERCENTAGE"] = "PERCENTAGE";
    VoucherDiscountType["SHIPPING"] = "SHIPPING";
})(VoucherDiscountType || (VoucherDiscountType = {}));
var VoucherSortField;
(function(VoucherSortField) {
    VoucherSortField[/** Sort vouchers by code. */ "CODE"] = "CODE";
    VoucherSortField[/** Sort vouchers by end date. */ "END_DATE"] = "END_DATE";
    VoucherSortField[/** Sort vouchers by minimum spent amount. */ "MINIMUM_SPENT_AMOUNT"] = "MINIMUM_SPENT_AMOUNT";
    VoucherSortField[/** Sort vouchers by start date. */ "START_DATE"] = "START_DATE";
    VoucherSortField[/** Sort vouchers by type. */ "TYPE"] = "TYPE";
    VoucherSortField[/** Sort vouchers by usage limit. */ "USAGE_LIMIT"] = "USAGE_LIMIT";
    VoucherSortField[/** Sort vouchers by value. */ "VALUE"] = "VALUE";
})(VoucherSortField || (VoucherSortField = {}));
var VoucherTypeEnum;
(function(VoucherTypeEnum) {
    VoucherTypeEnum["ENTIRE_ORDER"] = "ENTIRE_ORDER";
    VoucherTypeEnum["SHIPPING"] = "SHIPPING";
    VoucherTypeEnum["SPECIFIC_PRODUCT"] = "SPECIFIC_PRODUCT";
})(VoucherTypeEnum || (VoucherTypeEnum = {}));
var WarehouseErrorCode;
(function(WarehouseErrorCode) {
    WarehouseErrorCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    WarehouseErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    WarehouseErrorCode["INVALID"] = "INVALID";
    WarehouseErrorCode["NOT_FOUND"] = "NOT_FOUND";
    WarehouseErrorCode["REQUIRED"] = "REQUIRED";
    WarehouseErrorCode["UNIQUE"] = "UNIQUE";
})(WarehouseErrorCode || (WarehouseErrorCode = {}));
var WarehouseSortField;
(function(WarehouseSortField) {
    WarehouseSortField[/** Sort warehouses by name. */ "NAME"] = "NAME";
})(WarehouseSortField || (WarehouseSortField = {}));
var WebhookErrorCode;
(function(WebhookErrorCode) {
    WebhookErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    WebhookErrorCode["INVALID"] = "INVALID";
    WebhookErrorCode["NOT_FOUND"] = "NOT_FOUND";
    WebhookErrorCode["REQUIRED"] = "REQUIRED";
    WebhookErrorCode["UNIQUE"] = "UNIQUE";
})(WebhookErrorCode || (WebhookErrorCode = {}));
var WebhookEventTypeEnum;
(function(WebhookEventTypeEnum) {
    WebhookEventTypeEnum["ANY_EVENTS"] = "ANY_EVENTS";
    WebhookEventTypeEnum["CHECKOUT_CREATED"] = "CHECKOUT_CREATED";
    WebhookEventTypeEnum["CHECKOUT_QUANTITY_CHANGED"] = "CHECKOUT_QUANTITY_CHANGED";
    WebhookEventTypeEnum["CHECKOUT_UPDATED"] = "CHECKOUT_UPDATED";
    WebhookEventTypeEnum["CUSTOMER_CREATED"] = "CUSTOMER_CREATED";
    WebhookEventTypeEnum["FULFILLMENT_CREATED"] = "FULFILLMENT_CREATED";
    WebhookEventTypeEnum["INVOICE_DELETED"] = "INVOICE_DELETED";
    WebhookEventTypeEnum["INVOICE_REQUESTED"] = "INVOICE_REQUESTED";
    WebhookEventTypeEnum["INVOICE_SENT"] = "INVOICE_SENT";
    WebhookEventTypeEnum["ORDER_CANCELLED"] = "ORDER_CANCELLED";
    WebhookEventTypeEnum["ORDER_CREATED"] = "ORDER_CREATED";
    WebhookEventTypeEnum["ORDER_FULFILLED"] = "ORDER_FULFILLED";
    WebhookEventTypeEnum["ORDER_FULLY_PAID"] = "ORDER_FULLY_PAID";
    WebhookEventTypeEnum["ORDER_UPDATED"] = "ORDER_UPDATED";
    WebhookEventTypeEnum["PRODUCT_CREATED"] = "PRODUCT_CREATED";
    WebhookEventTypeEnum["PRODUCT_UPDATED"] = "PRODUCT_UPDATED";
    WebhookEventTypeEnum["WISHLIST_CREATED"] = "WISHLIST_CREATED";
    WebhookEventTypeEnum["WISHLIST_REMOVED"] = "WISHLIST_REMOVED";
})(WebhookEventTypeEnum || (WebhookEventTypeEnum = {}));
var WebhookSampleEventTypeEnum;
(function(WebhookSampleEventTypeEnum) {
    WebhookSampleEventTypeEnum["CHECKOUT_CREATED"] = "CHECKOUT_CREATED";
    WebhookSampleEventTypeEnum["CHECKOUT_QUANTITY_CHANGED"] = "CHECKOUT_QUANTITY_CHANGED";
    WebhookSampleEventTypeEnum["CHECKOUT_UPDATED"] = "CHECKOUT_UPDATED";
    WebhookSampleEventTypeEnum["CUSTOMER_CREATED"] = "CUSTOMER_CREATED";
    WebhookSampleEventTypeEnum["FULFILLMENT_CREATED"] = "FULFILLMENT_CREATED";
    WebhookSampleEventTypeEnum["INVOICE_DELETED"] = "INVOICE_DELETED";
    WebhookSampleEventTypeEnum["INVOICE_REQUESTED"] = "INVOICE_REQUESTED";
    WebhookSampleEventTypeEnum["INVOICE_SENT"] = "INVOICE_SENT";
    WebhookSampleEventTypeEnum["ORDER_CANCELLED"] = "ORDER_CANCELLED";
    WebhookSampleEventTypeEnum["ORDER_CREATED"] = "ORDER_CREATED";
    WebhookSampleEventTypeEnum["ORDER_FULFILLED"] = "ORDER_FULFILLED";
    WebhookSampleEventTypeEnum["ORDER_FULLY_PAID"] = "ORDER_FULLY_PAID";
    WebhookSampleEventTypeEnum["ORDER_UPDATED"] = "ORDER_UPDATED";
    WebhookSampleEventTypeEnum["PRODUCT_CREATED"] = "PRODUCT_CREATED";
    WebhookSampleEventTypeEnum["PRODUCT_UPDATED"] = "PRODUCT_UPDATED";
    WebhookSampleEventTypeEnum["WISHLIST_CREATED"] = "WISHLIST_CREATED";
    WebhookSampleEventTypeEnum["WISHLIST_REMOVED"] = "WISHLIST_REMOVED";
})(WebhookSampleEventTypeEnum || (WebhookSampleEventTypeEnum = {}));
var WebhookSortField;
(function(WebhookSortField) {
    WebhookSortField[/** Sort webhooks by service account. */ "APP"] = "APP";
    WebhookSortField[/** Sort webhooks by name. */ "NAME"] = "NAME";
    WebhookSortField[/** Sort webhooks by service account. */ "SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
    WebhookSortField[/** Sort webhooks by target url. */ "TARGET_URL"] = "TARGET_URL";
})(WebhookSortField || (WebhookSortField = {}));
var WeightUnitsEnum;
(function(WeightUnitsEnum) {
    WeightUnitsEnum["G"] = "G";
    WeightUnitsEnum["KG"] = "KG";
    WeightUnitsEnum["LB"] = "LB";
    WeightUnitsEnum["OZ"] = "OZ";
})(WeightUnitsEnum || (WeightUnitsEnum = {}));
var WishlistErrorCode;
(function(WishlistErrorCode) {
    WishlistErrorCode["GRAPHQL_ERROR"] = "GRAPHQL_ERROR";
    WishlistErrorCode["INVALID"] = "INVALID";
    WishlistErrorCode["NOT_FOUND"] = "NOT_FOUND";
    WishlistErrorCode["REQUIRED"] = "REQUIRED";
    WishlistErrorCode["UNIQUE"] = "UNIQUE";
})(WishlistErrorCode || (WishlistErrorCode = {}));


/***/ }),

/***/ 7006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useUser; }
/* harmony export */ });
/* harmony import */ var _sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73134);

var useUser = function() {
    var ref = (0,_sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_0__/* .useUserDetailsQuery */ .pv)({
        skip: "object" === "undefined"
    }), data = ref.data, loading = ref.loading;
    var user = data === null || data === void 0 ? void 0 : data.user;
    var authenticated = !!(user === null || user === void 0 ? void 0 : user.id);
    var loaded = !loading;
    return {
        user: user,
        loading: loading,
        loaded: loaded,
        authenticated: authenticated
    };
};


/***/ }),

/***/ 9212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useWishlist; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73134);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_regions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8044);




var useWishlist = function() {
    var ref;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var ref1 = (0,_sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_0__/* .useWishlistQuery */ .TX)({
        // fetchPolicy: 'no-cache',
        errorPolicy: "ignore",
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            first: 100
        }, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_2__/* .localeToSaleorQuery */ .KK)(locale)),
        skip: "object" === "undefined"
    }), data = ref1.data, loading = ref1.loading;
    var items = data === null || data === void 0 ? void 0 : (ref = data.wishlist) === null || ref === void 0 ? void 0 : ref.items.edges.map(function(param) {
        var node = param.node;
        return node;
    });
    return {
        items: items,
        loading: loading
    };
};


/***/ }),

/***/ 45327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mg": function() { return /* binding */ useCheckout; },
/* harmony export */   "oo": function() { return /* binding */ CheckoutProvider; }
/* harmony export */ });
/* unused harmony exports CHECKOUT_TOKEN, CHECKOUT_GATEWAY, Provider */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24324);
/* harmony import */ var _utils_regions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8044);
/* harmony import */ var _hooks_useSafeContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72827);
/* harmony import */ var _sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73134);
/* harmony import */ var _pages_CheckoutPage_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23312);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60120);












var CHECKOUT_TOKEN = "saleor_checkout_token";
var CHECKOUT_GATEWAY = "saleor_checkout_gateway";
var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks_useSafeContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), 2);
var useCheckout = ref[0], Provider = ref[1];
function CheckoutProvider(param) {
    var children = param.children;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var locale = (ref = router.query.locale) === null || ref === void 0 ? void 0 : ref.toString();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_2__/* .useLocalStorage */ ._)(CHECKOUT_TOKEN, "", {
        sync: true
    }), 2), checkoutToken = ref1[0], setCheckoutToken = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_2__/* .useLocalStorage */ ._)(CHECKOUT_GATEWAY, _pages_CheckoutPage_utils__WEBPACK_IMPORTED_MODULE_6__/* .DEFAULT_PAYMENT_METHODS */ .Lu, {
        sync: true
    }), 2), checkoutGateway = ref2[0], setCheckoutGateway = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_5__/* .useAddCheckoutLineMutation */ .O9)(), 1), addCheckoutLineMutation = ref3[0];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_5__/* .useCreateCheckoutMutation */ .F9)(), 1), createCheckoutMutation = ref4[0];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_5__/* .useRemoveCheckoutLineMutation */ .uM)(), 1), removeCheckoutLineMutation = ref5[0];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_5__/* .useUpdateCheckoutLineMutation */ .bE)(), 1), updateCheckoutLineMutation = ref6[0];
    var ref7 = (0,_sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_5__/* .useCheckoutDetailsByTokenQuery */ .Jt)({
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            token: checkoutToken
        }, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_3__/* .localeToSaleorQuery */ .KK)(locale)),
        skip: !checkoutToken || "object" === "undefined"
    }), data = ref7.data, loading = ref7.loading, checkoutError = ref7.error;
    var resetCheckoutToken = function() {
        return setCheckoutToken("");
    };
    var addItem = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(variantId, quantity, productAttributes) {
            var ref, ref1, ref2, ref3, ref4, checkoutId, ref5, ref6, ref7, addToCartData, ref8, createCheckoutData, ref9, ref10;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        checkoutId = data === null || data === void 0 ? void 0 : (ref = data.checkout) === null || ref === void 0 ? void 0 : ref.id;
                        if (!checkoutId) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            addCheckoutLineMutation({
                                variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                    checkoutId: checkoutId,
                                    lines: [
                                        {
                                            productAttributes: productAttributes || [],
                                            quantity: quantity,
                                            variantId: variantId
                                        }
                                    ]
                                }, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_3__/* .localeToSaleorQuery */ .KK)(locale))
                            })
                        ];
                    case 1:
                        ref7 = _state.sent(), addToCartData = ref7.data;
                        return [
                            2,
                            {
                                data: addToCartData === null || addToCartData === void 0 ? void 0 : (ref5 = addToCartData.checkoutLinesAdd) === null || ref5 === void 0 ? void 0 : ref5.checkout,
                                error: addToCartData === null || addToCartData === void 0 ? void 0 : (ref6 = addToCartData.checkoutLinesAdd) === null || ref6 === void 0 ? void 0 : ref6.errors
                            }
                        ];
                    case 2:
                        return [
                            4,
                            createCheckoutMutation({
                                variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                    checkoutInput: {
                                        lines: [
                                            {
                                                productAttributes: productAttributes || [],
                                                quantity: quantity,
                                                variantId: variantId
                                            }
                                        ]
                                    }
                                }, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_3__/* .localeToSaleorQuery */ .KK)(locale))
                            })
                        ];
                    case 3:
                        ref8 = _state.sent(), createCheckoutData = ref8.data;
                        if (createCheckoutData === null || createCheckoutData === void 0 ? void 0 : (ref1 = createCheckoutData.checkoutCreate) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.checkout) === null || ref2 === void 0 ? void 0 : ref2.token) {
                            ;
                            setCheckoutToken(createCheckoutData === null || createCheckoutData === void 0 ? void 0 : (ref9 = createCheckoutData.checkoutCreate) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.checkout) === null || ref10 === void 0 ? void 0 : ref10.token);
                        }
                        return [
                            2,
                            {
                                data: createCheckoutData === null || createCheckoutData === void 0 ? void 0 : (ref3 = createCheckoutData.checkoutCreate) === null || ref3 === void 0 ? void 0 : ref3.checkout,
                                error: createCheckoutData === null || createCheckoutData === void 0 ? void 0 : (ref4 = createCheckoutData.checkoutCreate) === null || ref4 === void 0 ? void 0 : ref4.errors
                            }
                        ];
                }
            });
        });
        return function addItem(variantId, quantity, productAttributes) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeItem = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(variantId, productAttributes) {
            var ref, ref1, checkoutId, lines, ref2, existingLine;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        checkoutId = data === null || data === void 0 ? void 0 : (ref = data.checkout) === null || ref === void 0 ? void 0 : ref.id;
                        lines = (data === null || data === void 0 ? void 0 : (ref1 = data.checkout) === null || ref1 === void 0 ? void 0 : ref1.lines) || [];
                        ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .extractExistingLine */ .E)(lines, variantId, productAttributes), 1), existingLine = ref2[0];
                        if (!(existingLine && checkoutId)) return [
                            3,
                            2
                        ];
                        // const { data, error } = removeCheckoutLineMutation({
                        return [
                            4,
                            removeCheckoutLineMutation({
                                variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                    checkoutId: checkoutId,
                                    lineId: existingLine.id
                                }, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_3__/* .localeToSaleorQuery */ .KK)(locale))
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        // return {
        //   error: new Error('The item do not exist in the current cart.'),
        // };
        });
        return function removeItem(variantId, productAttributes) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateItem = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(variantId, quantity, productAttributes) {
            var ref, ref1, checkoutId, lines, alteredLines;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        checkoutId = data === null || data === void 0 ? void 0 : (ref = data.checkout) === null || ref === void 0 ? void 0 : ref.id;
                        lines = data === null || data === void 0 ? void 0 : (ref1 = data.checkout) === null || ref1 === void 0 ? void 0 : ref1.lines;
                        if (!(checkoutId && lines)) return [
                            3,
                            2
                        ];
                        alteredLines = {
                            productAttributes: productAttributes === null || productAttributes === void 0 ? void 0 : productAttributes.map(function(attr) {
                                return {
                                    attributeId: attr.attribute.id,
                                    values: attr.values
                                };
                            }),
                            quantity: quantity,
                            variantId: variantId
                        };
                        // const { data, error } = await updateCheckoutLineMutation({
                        return [
                            4,
                            updateCheckoutLineMutation({
                                variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                    checkoutId: checkoutId,
                                    lines: [
                                        alteredLines
                                    ]
                                }, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_3__/* .localeToSaleorQuery */ .KK)(locale))
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        // return {
        //   error: new Error('The current cart is empty.'),
        // };
        });
        return function updateItem(variantId, quantity, productAttributes) {
            return _ref.apply(this, arguments);
        };
    }();
    var providerValues = {
        checkoutToken: checkoutToken,
        checkoutGateway: checkoutGateway,
        setCheckoutToken: setCheckoutToken,
        setCheckoutGateway: setCheckoutGateway,
        resetCheckoutToken: resetCheckoutToken,
        checkout: data === null || data === void 0 ? void 0 : data.checkout,
        loading: loading,
        checkoutError: checkoutError,
        addItem: addItem,
        removeItem: removeItem,
        updateItem: updateItem
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: providerValues,
        children: children
    });
}


/***/ }),

/***/ 60120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ extractExistingLine; },
/* harmony export */   "o": function() { return /* binding */ compareAttributes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__);




function compareAttributes(productAttributes, selectedProductAttributes) {
    if (productAttributes.length !== selectedProductAttributes.length) {
        return false;
    }
    var productAttributesNormalized = productAttributes.reduce(function(acc, cur) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, cur.attribute.id, cur.values));
    }, {});
    var selectedProductAttributesNormalized = selectedProductAttributes.reduce(function(acc, cur) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, cur.attributeId, cur.values));
    }, {});
    return lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(productAttributesNormalized, selectedProductAttributesNormalized);
}
function extractExistingLine(lines, variantId, productAttributes) {
    var found;
    var alteredLines = [];
    lines.forEach(function(line) {
        if (line.variant.id === variantId && lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(line.productAttributes, productAttributes)) {
            found = line;
        } else {
            alteredLines.push(line);
        }
    });
    return [
        found,
        alteredLines
    ];
}


/***/ }),

/***/ 42660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$m": function() { return /* binding */ ssrMode; },
/* harmony export */   "CZ": function() { return /* binding */ prismicUri; },
/* harmony export */   "G9": function() { return /* binding */ API_URI; },
/* harmony export */   "JW": function() { return /* binding */ apiUrl; },
/* harmony export */   "OE": function() { return /* binding */ subscribeNotification; },
/* harmony export */   "Oj": function() { return /* binding */ analyticsDataPlaneUrl; },
/* harmony export */   "UW": function() { return /* binding */ mediaUri; },
/* harmony export */   "aX": function() { return /* binding */ prismicUrl; },
/* harmony export */   "al": function() { return /* binding */ defaultLocale; }
/* harmony export */ });
/* unused harmony exports apiMountUri, analyticsWriteKey, analyticsHJID, analyticsHJSV, analyticsGTM, serviceWorkerTimeout, exportMode, incrementalStaticRegenerationRevalidate, staticPathsFetchBatch, staticPathsFallback */
/* provided dependency */ var process = __webpack_require__(83454);
var apiUrl = "https://renodoors-fr.stellate.sh/";
var API_URI = "https://renodoors-fr.stellate.sh/";
var apiMountUri = (/* unused pure expression or super */ null && ("/" || 0));
var prismicUri = "renodoors" || 0;
var prismicUrl = "https://".concat(prismicUri, ".cdn.prismic.io/graphql");
var mediaUri = "https://images.renodoors.eu/";
var analyticsDataPlaneUrl = "https://renotuerenhgdv.dataplane.rudderstack.com";
var analyticsWriteKey = (/* unused pure expression or super */ null && ("2FkuadId1ghxHF9ePT7aTZKfgdG"));
var analyticsHJID = (/* unused pure expression or super */ null && ("1877571"));
var analyticsHJSV = (/* unused pure expression or super */ null && ("6"));
var analyticsGTM = (/* unused pure expression or super */ null && ("GTM-KTDGPMC"));
var serviceWorkerTimeout = parseInt(process.env.SERVICE_WORKER_TIMEOUT, 10) || 60 * 1000;
var subscribeNotification = "true" === "true";
var defaultLocale = ("FR" || 0).toUpperCase();
var ssrMode = "object" === "undefined";
var exportMode = process.env.NEXT_EXPORT === "true";
var incrementalStaticRegenerationRevalidate = parseInt(process.env.INCREMENTAL_STATIC_REGENERATION_REVALIDATE, 10);
var staticPathsFetchBatch = 50;
// export const staticPathsFallback = (
//   exportMode ? false : process.env.NEXT_PUBLIC_STATIC_PATHS_FALLBACK
// ) as boolean | 'blocking';
var staticPathsFallback = "blocking";


/***/ }),

/***/ 42443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eI": function() { return /* binding */ BLIK_GATEWAY; },
  "NM": function() { return /* binding */ DUMMY_GATEWAY; },
  "AH": function() { return /* binding */ KLARNA_GATEWAY; },
  "Iu": function() { return /* binding */ P24_GATEWAY; },
  "Jg": function() { return /* binding */ PAYPAL_GATEWAY; },
  "aA": function() { return /* binding */ PROVIDERS; },
  "TJ": function() { return /* binding */ REVIEWS_PER_PAGE; },
  "OM": function() { return /* binding */ REVIEW_AVATARS; },
  "cT": function() { return /* binding */ STRIPE_GATEWAY; }
});

// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedTypes.tsx
var generatedTypes = __webpack_require__(52046);
;// CONCATENATED MODULE: ./src/images/pg-blik.svg
var pg_blik_namespaceObject = __webpack_require__.p + "static/images/pg-blik.svg";
;// CONCATENATED MODULE: ./src/images/pg-card.svg
var pg_card_namespaceObject = __webpack_require__.p + "static/images/pg-card.svg";
;// CONCATENATED MODULE: ./src/images/pg-klarna.svg
var pg_klarna_namespaceObject = __webpack_require__.p + "static/images/pg-klarna.svg";
;// CONCATENATED MODULE: ./src/images/pg-p24.svg
var pg_p24_namespaceObject = __webpack_require__.p + "static/images/pg-p24.svg";
;// CONCATENATED MODULE: ./src/images/pg-paypal.svg
var pg_paypal_namespaceObject = __webpack_require__.p + "static/images/pg-paypal.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-0.svg
var user_avatar_0_namespaceObject = __webpack_require__.p + "static/images/user-avatar-0.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-1.svg
var user_avatar_1_namespaceObject = __webpack_require__.p + "static/images/user-avatar-1.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-2.svg
var user_avatar_2_namespaceObject = __webpack_require__.p + "static/images/user-avatar-2.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-3.svg
var user_avatar_3_namespaceObject = __webpack_require__.p + "static/images/user-avatar-3.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-4.svg
var user_avatar_4_namespaceObject = __webpack_require__.p + "static/images/user-avatar-4.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-5.svg
var user_avatar_5_namespaceObject = __webpack_require__.p + "static/images/user-avatar-5.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-6.svg
var user_avatar_6_namespaceObject = __webpack_require__.p + "static/images/user-avatar-6.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-7.svg
var user_avatar_7_namespaceObject = __webpack_require__.p + "static/images/user-avatar-7.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-8.svg
var user_avatar_8_namespaceObject = __webpack_require__.p + "static/images/user-avatar-8.svg";
;// CONCATENATED MODULE: ./src/images/reviews/user-avatar-9.svg
var user_avatar_9_namespaceObject = __webpack_require__.p + "static/images/user-avatar-9.svg";
;// CONCATENATED MODULE: ./src/core/config.ts
/* eslint-disable global-require */ 















var REVIEWS_PER_PAGE = 10;
var REVIEW_AVATARS = new Map([
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_0 */.zA.AVATAR_0,
        user_avatar_0_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_1 */.zA.AVATAR_1,
        user_avatar_1_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_2 */.zA.AVATAR_2,
        user_avatar_2_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_3 */.zA.AVATAR_3,
        user_avatar_3_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_4 */.zA.AVATAR_4,
        user_avatar_4_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_5 */.zA.AVATAR_5,
        user_avatar_5_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_6 */.zA.AVATAR_6,
        user_avatar_6_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_7 */.zA.AVATAR_7,
        user_avatar_7_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_8 */.zA.AVATAR_8,
        user_avatar_8_namespaceObject
    ],
    [
        generatedTypes/* ReviewAvatarEnum.AVATAR_9 */.zA.AVATAR_9,
        user_avatar_9_namespaceObject
    ]
]);
var DUMMY_GATEWAY = "mirumee.payments.dummy";
var KLARNA_GATEWAY = "saleor.payments.klarna";
var P24_GATEWAY = "saleor.payments.przelewy24";
var BLIK_GATEWAY = "saleor.payments.blik";
var PAYPAL_GATEWAY = "saleor.payments.paypal";
var STRIPE_GATEWAY = "saleor.payments.stripe";
var PROVIDERS = {
    "mirumee.payments.dummy": {
        id: DUMMY_GATEWAY,
        icon: pg_card_namespaceObject,
        label: "Dummy"
    },
    "saleor.payments.klarna": {
        id: KLARNA_GATEWAY,
        icon: pg_klarna_namespaceObject,
        label: "Klarna"
    },
    "saleor.payments.przelewy24": {
        id: P24_GATEWAY,
        icon: pg_p24_namespaceObject,
        label: "Przelewy24"
    },
    "saleor.payments.blik": {
        id: BLIK_GATEWAY,
        icon: pg_blik_namespaceObject,
        label: "Blik"
    },
    "saleor.payments.paypal": {
        id: PAYPAL_GATEWAY,
        icon: pg_paypal_namespaceObject,
        label: "Paypal"
    },
    "saleor.payments.stripe": {
        id: STRIPE_GATEWAY,
        icon: pg_card_namespaceObject,
        label: "Visa|Mastercard"
    }
};


/***/ }),

/***/ 72110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ errorCommonMsg; },
/* harmony export */   "OV": function() { return /* binding */ realizationMsg; },
/* harmony export */   "a4": function() { return /* binding */ validationCommonMsg; },
/* harmony export */   "hX": function() { return /* binding */ checkoutMessages; },
/* harmony export */   "i4": function() { return /* binding */ commonMessages; }
/* harmony export */ });
/* unused harmony export prodListHeaderCommonMsg */
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54490);

var commonMessages = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    account: {
        defaultMessage: "Account",
        id: "TwyMau"
    },
    accept: {
        defaultMessage: "I accept",
        id: "+fnRDB"
    },
    add: {
        defaultMessage: "Add",
        id: "2/2yg+"
    },
    addAddress: {
        defaultMessage: "Add address",
        id: "v0xaYB"
    },
    addressBook: {
        defaultMessage: "Address book",
        id: "5zZZ90"
    },
    allTopics: {
        defaultMessage: "All topics",
        id: "V4mLb8"
    },
    addToCart: {
        defaultMessage: "add to cart",
        id: "n34Hfs"
    },
    cancel: {
        defaultMessage: "Cancel",
        id: "47FYwb"
    },
    category: {
        defaultMessage: "Category",
        id: "ccXLVi"
    },
    charactersLeft: {
        defaultMessage: "characters left",
        id: "SbzsQf"
    },
    checkout: {
        defaultMessage: "Checkout",
        id: "BJ2TKX"
    },
    clearFilterHeader: {
        defaultMessage: "CLEAR FILTERS",
        id: "FGJNIh"
    },
    collection: {
        defaultMessage: "collection",
        id: "FjIE73"
    },
    collectionCapitalized: {
        defaultMessage: "Collection",
        id: "phAZoj"
    },
    congratulations: {
        defaultMessage: "Congratulations!",
        id: "lOzDTt"
    },
    contactUs: {
        defaultMessage: "contact us",
        id: "cZ6IMP"
    },
    days: {
        defaultMessage: "days",
        id: "Bc20la"
    },
    delete: {
        defaultMessage: "Delete",
        id: "K3r6DQ"
    },
    download: {
        defaultMessage: "Download",
        id: "5q3qC0"
    },
    eMail: {
        defaultMessage: "Email Address",
        id: "xxQxLE"
    },
    editAddress: {
        defaultMessage: "Edit address",
        id: "ex+q9+"
    },
    filterHeader: {
        defaultMessage: "FILTERS",
        id: "uqEtJ1"
    },
    firstName: {
        defaultMessage: "First Name",
        id: "Q6wcZ5"
    },
    free: {
        defaultMessage: "Free",
        id: "tf1lIh"
    },
    from: {
        defaultMessage: "from",
        id: "G9uF7o"
    },
    itemsMinMax: {
        defaultMessage: "Please, choose between {minItems} and {maxItems} items to continue",
        id: "AI4rYj"
    },
    itemsSelected: {
        defaultMessage: "{selectedNumber} items selected",
        id: "2aCfIz"
    },
    lastName: {
        defaultMessage: "Last Name",
        id: "aheQdn"
    },
    less: {
        defaultMessage: "Less",
        id: "mFYgAX"
    },
    loading: {
        defaultMessage: "Loading",
        id: "iFsDVR"
    },
    loadMore: {
        defaultMessage: "Load more",
        id: "00LcfG"
    },
    logOut: {
        defaultMessage: "Log Out",
        id: "H0JBH6"
    },
    lowStock: {
        defaultMessage: "Low stock",
        id: "2xjjlC"
    },
    maxQtyIs: {
        defaultMessage: "Maximum quantity is {maxQuantity}",
        id: "XkwMjW"
    },
    more: {
        defaultMessage: "More",
        id: "I5NMJ8"
    },
    myAccount: {
        defaultMessage: "My Account",
        id: "2bGejb"
    },
    noItemsAvailable: {
        defaultMessage: "No items available",
        id: "nJCVT0"
    },
    noPurchaseAvailable: {
        defaultMessage: "Not available for purchase",
        id: "KorORN"
    },
    purchaseAvailableOn: {
        defaultMessage: "Will become available for purchase on {date} at {time}",
        id: "jvgIPx"
    },
    orderHistory: {
        defaultMessage: "Order history",
        id: "vQt5XU"
    },
    outOfStock: {
        defaultMessage: "Out of stock",
        id: "WHgdsk"
    },
    password: {
        defaultMessage: "Password",
        id: "5sg7KC"
    },
    phone: {
        defaultMessage: "Phone",
        id: "O95R3Z"
    },
    phoneNumber: {
        defaultMessage: "Phone number: {phone}",
        id: "WmzATS"
    },
    price: {
        defaultMessage: "Price",
        id: "b1zuN9"
    },
    priceRange: {
        defaultMessage: "Price range",
        id: "+kMQfn"
    },
    products: {
        defaultMessage: "Products",
        id: "7NFfmz"
    },
    promoCode: {
        defaultMessage: "Promo code",
        id: "/J2mVO"
    },
    quantity: {
        defaultMessage: "Quantity",
        id: "qVGRIE"
    },
    readOn: {
        defaultMessage: "Read on",
        id: "tQk32X"
    },
    ReadMore: {
        defaultMessage: "Read more",
        id: "S++WdB"
    },
    register: {
        defaultMessage: "Register",
        id: "deEeEI"
    },
    subscribe: {
        defaultMessage: "Subscribe & Get 50€",
        id: "pssNG/"
    },
    reviewCount: {
        defaultMessage: "based on {count} reviews",
        id: "F3lCaN"
    },
    save: {
        defaultMessage: "Save",
        id: "jvo0vs"
    },
    saveProject: {
        defaultMessage: "Save project",
        id: "+Di5s8"
    },
    search: {
        defaultMessage: "search",
        id: "qyQ7t4"
    },
    seeAllArticles: {
        defaultMessage: "See all articles",
        id: "fWc2Mv"
    },
    SeeAndFeelTheDifference: {
        defaultMessage: "See and feel the difference",
        id: "Z161uL"
    },
    send: {
        defaultMessage: "Send",
        id: "9WRlF4"
    },
    shipping: {
        defaultMessage: "Shipping",
        id: "PRlD0A"
    },
    shortEmail: {
        defaultMessage: "Email",
        id: "sy+pv5"
    },
    showEmail: {
        defaultMessage: "Email: {email}",
        id: "uPNlBw"
    },
    showMore: {
        defaultMessage: "Show more",
        id: "aWpBzj"
    },
    signIn: {
        defaultMessage: "Sign in",
        id: "SQJto2"
    },
    sku: {
        defaultMessage: "SKU",
        id: "k4brJy"
    },
    smallEmail: {
        defaultMessage: "email",
        id: "yUVl6+"
    },
    status: {
        defaultMessage: "Status",
        id: "tzMNF3"
    },
    subject: {
        defaultMessage: "Subject",
        id: "LLtKhp"
    },
    subtotal: {
        defaultMessage: "Subtotal",
        id: "L8seEc"
    },
    success: {
        defaultMessage: "Success!",
        id: "UIDXdt"
    },
    termsOfService: {
        defaultMessage: "Terms of Service",
        id: "32rBNK"
    },
    to: {
        defaultMessage: "to",
        id: "NLeFGn"
    },
    total: {
        defaultMessage: "Total",
        id: "MJ2jZQ"
    },
    totalPrice: {
        defaultMessage: "Total Price:",
        id: "73BD0e"
    },
    variant: {
        defaultMessage: "Variant",
        id: "OK5+Fh"
    },
    view: {
        defaultMessage: "View",
        id: "FgydNe"
    },
    viewAllPhotos: {
        defaultMessage: "View all photos",
        id: "JNOr9z"
    },
    weeks: {
        defaultMessage: "weeks",
        id: "umNSDp"
    },
    youMayAlsoLike: {
        defaultMessage: "You may also like",
        id: "CQHqS0"
    },
    yourEmailAddress: {
        defaultMessage: "Your email address",
        id: "tRxNl9"
    },
    yourMessage: {
        defaultMessage: "Your message...",
        id: "VC3tEU"
    }
});
var checkoutMessages = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    addNewAddress: {
        defaultMessage: "Add new address",
        id: "cQiUt4"
    },
    addressNextActionName: {
        defaultMessage: "Continue to Shipping",
        id: "bsM94i"
    },
    billingAddress: {
        defaultMessage: "BILLING ADDRESS",
        id: "itE2ni"
    },
    continueShopping: {
        defaultMessage: "CONTINUE SHOPPING",
        id: "VsSdhk"
    },
    paymentMethod: {
        defaultMessage: "PAYMENT METHOD",
        id: "tlBXu3"
    },
    paymentNextActionName: {
        defaultMessage: "Place order",
        id: "JItzoH"
    },
    reviewNextActionName: {
        defaultMessage: "Continue to Review",
        id: "BS3FlI"
    },
    reviewOrder: {
        defaultMessage: "REVIEW ORDER",
        id: "hHQcs/"
    },
    shippingAddress: {
        defaultMessage: "Shipping Address",
        id: "DP5VOH"
    },
    shippingMethod: {
        defaultMessage: "SHIPPING METHOD",
        id: "RvuE8K"
    },
    shippingNextActionName: {
        defaultMessage: "Continue to Payment",
        id: "0g/1TG"
    },
    stepNameAddress: {
        defaultMessage: "Address",
        id: "e6Ph5+"
    },
    stepNamePayment: {
        defaultMessage: "Payment",
        id: "NmK6zy"
    },
    stepNameReview: {
        defaultMessage: "Review",
        id: "R+J5ox"
    },
    stepNameShipping: {
        defaultMessage: "Shipping",
        id: "PRlD0A"
    }
});
var prodListHeaderCommonMsg = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    sortOptionsClear: {
        defaultMessage: "Clear...",
        id: "xCzQG8"
    },
    sortOptionsName: {
        defaultMessage: "Name Increasing",
        id: "n8Z9ys"
    },
    sortOptionsNameDsc: {
        defaultMessage: "Name Decreasing",
        id: "yLRtkC"
    },
    sortOptionsPrice: {
        defaultMessage: "Price Low-High",
        id: "x2/i6X"
    },
    sortOptionsPriceDsc: {
        defaultMessage: "Price High-Low",
        id: "n6M10I"
    },
    sortOptionsUpdatedAt: {
        defaultMessage: "Last updated Ascending",
        id: "WCcbn6"
    },
    sortOptionsUpdatedAtDsc: {
        defaultMessage: "Last updated Descending",
        id: "x/OgEF"
    }
});
var validationCommonMsg = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    confirmPassword: {
        defaultMessage: "Passwords do not match",
        id: "7Chrsf"
    },
    passwordRetype: {
        defaultMessage: "Please retype password",
        id: "3vU0+B"
    },
    passwordRetypeMatch: {
        defaultMessage: "Retyped password does not match",
        id: "gcnw6w"
    },
    passwordShort: {
        defaultMessage: "Password is to short!",
        id: "6PIQNP"
    },
    required: {
        defaultMessage: "Required field",
        id: "a/4SMm"
    },
    invalidEmail: {
        defaultMessage: "The email is invalid!",
        id: "ywpJuM"
    }
});
var errorCommonMsg = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    choose_payment: {
        defaultMessage: "Please choose payment method.",
        id: "LkCowx"
    },
    provide_billing_address: {
        defaultMessage: "Please provide billing address.",
        id: "jHKLNU"
    },
    provide_email_address: {
        defaultMessage: "Please provide email address.",
        id: "YM709/"
    },
    provide_shipping_address: {
        defaultMessage: "Please provide shipping address.",
        id: "1KGwKk"
    }
});
var realizationMsg = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    clear_filter: {
        defaultMessage: "Clear filter",
        id: "OhgOkH"
    },
    category: {
        defaultMessage: "Style",
        id: "7mL9QE"
    },
    colors: {
        defaultMessage: "Colors",
        id: "U+dGE5"
    },
    tags: {
        defaultMessage: "Room",
        id: "2Ml/7i"
    },
    width: {
        defaultMessage: "Width",
        id: "5IP7AP"
    }
});


/***/ }),

/***/ 4032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ paths; }
/* harmony export */ });
var baseUrl = "/";
var accountBaseUrl = "".concat(baseUrl, "account/");
var checkoutBaseUrl = "".concat(baseUrl, "checkout/");
var paths = {
    /**
   * Hone
   */ home: baseUrl,
    /**
   * Login
   */ accountConfirm: "".concat(baseUrl, "account-confirm"),
    login: "".concat(baseUrl, "login"),
    passwordReset: "".concat(baseUrl, "reset-password"),
    /**
   * Shopping
   */ cart: "".concat(baseUrl, "cart"),
    category: "".concat(baseUrl, "category/[slug]/[id]/"),
    collection: "".concat(baseUrl, "collection/[slug]/[id]/"),
    guestOrderDetail: "".concat(baseUrl, "order-history/[token]"),
    orderFinalized: "".concat(baseUrl, "order-finalized"),
    product: "".concat(baseUrl, "product/[slug]/[id]/"),
    reviews: "".concat(baseUrl, "reviews/"),
    reviewDetail: "".concat(baseUrl, "reviews//[slug]"),
    search: "".concat(baseUrl, "search"),
    wishlist: "".concat(baseUrl, "wishlist"),
    /**
   * Pages
   */ architect: "".concat(baseUrl, "architect/"),
    blog: "".concat(baseUrl, "blog/"),
    blogPost: "".concat(baseUrl, "blog/[slug]"),
    contacts: "".concat(baseUrl, "contacts/"),
    inspirations: "".concat(baseUrl, "inspirations/"),
    inspirationsPost: "".concat(baseUrl, "inspirations/[slug]"),
    page: "".concat(baseUrl, "page/[slug]"),
    /**
   * Checkout
   */ checkout: checkoutBaseUrl,
    checkoutAddress: "".concat(checkoutBaseUrl, "address"),
    checkoutPayment: "".concat(checkoutBaseUrl, "payment"),
    checkoutPaymentConfirm: "".concat(checkoutBaseUrl, "payment-confirm"),
    checkoutReview: "".concat(checkoutBaseUrl, "review"),
    checkoutShipping: "".concat(checkoutBaseUrl, "shipping"),
    /**
   * Account section
   */ account: accountBaseUrl,
    accountAddressBook: "".concat(accountBaseUrl, "address-book"),
    // FIXME: User order should be accessible via order id
    accountOrderDetail: "".concat(accountBaseUrl, "order-history/[token]"),
    accountOrderHistory: "".concat(accountBaseUrl, "order-history")
};


/***/ }),

/***/ 43065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ CONFIGURATOR_PRODUCT_TYPES; },
/* harmony export */   "q": function() { return /* binding */ SAMPLE_PRODUCT_TYPES; }
/* harmony export */ });
var SAMPLE_PRODUCT_TYPES = [
    "sample-rustical",
    "sample-minimalist",
    "sample-color-oil",
    "sample-color-paint", 
];
var CONFIGURATOR_PRODUCT_TYPES = [
    "atelier-style",
    "barndoor-style-1",
    "barndoor-style-2",
    "dot-style",
    "industrial-style",
    "loft-style",
    "minimalist-style",
    "modern-style",
    "rattan-style",
    "rustic-style-1",
    "rustic-style-2",
    "wardrobe-style",
    "elegance-style",
    "mirror-style", 
];


/***/ }),

/***/ 18222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mv": function() { return /* reexport */ generateProductImageWithAttributes; },
  "pT": function() { return /* reexport */ generateProductUrlWithAttributes; },
  "O4": function() { return /* reexport */ getDefaultValues; },
  "pg": function() { return /* reexport */ getProductAttributes; },
  "ME": function() { return /* reexport */ getSelectedProductAttributes; }
});

// NAMESPACE OBJECT: ./node_modules/query-string/base.js
var base_namespaceObject = {};
__webpack_require__.r(base_namespaceObject);
__webpack_require__.d(base_namespaceObject, {
  "exclude": function() { return exclude; },
  "extract": function() { return extract; },
  "parse": function() { return parse; },
  "parseUrl": function() { return parseUrl; },
  "pick": function() { return pick; },
  "stringify": function() { return stringify; },
  "stringifyUrl": function() { return stringifyUrl; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/views/Product/utils/attributes.ts
/* eslint-disable no-console */ 




//
var getProductVariantsAttributes = function(productVariants) {
    var variantsAttributes = {};
    productVariants.forEach(function(productVariant) {
        productVariant.attributes.forEach(function(productVariantAttribute) {
            var productVariantAttributeId = productVariantAttribute.attribute.id;
            var variantsAttributeExists = productVariantAttributeId in variantsAttributes;
            if (variantsAttributeExists) {
                var variantsAttributeValueExists = variantsAttributes[productVariantAttributeId].values.map(function(node) {
                    return node.id;
                }).includes(productVariantAttribute.values[0].id);
                if (!variantsAttributeValueExists) {
                    variantsAttributes[productVariantAttributeId].values.push(productVariantAttribute.values[0]);
                }
            } else {
                variantsAttributes[productVariantAttributeId] = {
                    attribute: productVariantAttribute.attribute,
                    values: [
                        productVariantAttribute.values[0]
                    ]
                };
            }
        });
    });
    return variantsAttributes;
};
//
var getProductAttributes = function(product) {
    var productVariantsAttributes = getProductVariantsAttributes(product.variants);
    return (0,_to_consumable_array/* default */.Z)(product.attributes).concat((0,_to_consumable_array/* default */.Z)(Object.values(productVariantsAttributes)));
};
//
var getSelectedProductAttributes = function(attributesFormData, productAttributes) {
    return Object.entries(attributesFormData).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], value = _param[1];
        var ref;
        var attribute = (ref = productAttributes.find(function(item) {
            return item.attribute.slug === slug;
        })) === null || ref === void 0 ? void 0 : ref.attribute;
        return attribute ? {
            attributeId: attribute.id,
            values: Array.isArray(value) ? value : [
                value
            ]
        } : null;
    }).filter(function(x) {
        return !!x;
    });
};
//
var getDefaultProductAttributes = function(defaultAttributes) {
    return defaultAttributes.reduce(function(obj, item) {
        var ref;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, obj), (0,_define_property/* default */.Z)({}, item.attribute.slug, (ref = item.defaultValue) === null || ref === void 0 ? void 0 : ref.name));
    }, {});
};
//
var getTrackValues = function(width, configuration) {
    var multiplier = configuration === "configuration-single" ? 1 : 2;
    return {
        defaultValue: String(Number(width) * 2 * multiplier),
        maxValue: String(Number(width) * 3 * multiplier),
        minValue: String(Number(width) * 1.5 * multiplier)
    };
};
//
var getDefaultValues = function(product, queryParam) {
    var defaultValues = (0,_object_spread/* default */.Z)({}, getDefaultProductAttributes(product.defaultAttributes), queryParam);
    if (defaultValues.width && !defaultValues.track) {
        var ref = getTrackValues(defaultValues.width, defaultValues.configuration), defaultTrackValue = ref.defaultValue;
        defaultValues.track = String(defaultTrackValue);
    }
    return defaultValues;
};

// EXTERNAL MODULE: ./src/images/no-photo.svg
var no_photo = __webpack_require__(83171);
// EXTERNAL MODULE: ./src/@next/utils/translations.ts
var translations = __webpack_require__(69665);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__(35937);
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);
;// CONCATENATED MODULE: ./node_modules/decode-uri-component/index.js
const token = '%[a-f0-9]{2}';
const singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
const multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	const left = components.slice(0, split);
	const right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch {
		let tokens = input.match(singleMatcher) || [];

		for (let i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	const replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD',
	};

	let match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch {
			const result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	const entries = Object.keys(replaceMap);

	for (const key of entries) {
		// Replace all decoded components
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

function decodeUriComponent(encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
}

;// CONCATENATED MODULE: ./node_modules/split-on-first/index.js
function splitOnFirst(string, separator) {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (string === '' || separator === '') {
		return [];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
}

;// CONCATENATED MODULE: ./node_modules/filter-obj/index.js
function includeKeys(object, predicate) {
	const result = {};

	if (Array.isArray(predicate)) {
		for (const key of predicate) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor?.enumerable) {
				Object.defineProperty(result, key, descriptor);
			}
		}
	} else {
		// `Reflect.ownKeys()` is required to retrieve symbol properties
		for (const key of Reflect.ownKeys(object)) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor.enumerable) {
				const value = object[key];
				if (predicate(key, value, object)) {
					Object.defineProperty(result, key, descriptor);
				}
			}
		}
	}

	return result;
}

function excludeKeys(object, predicate) {
	if (Array.isArray(predicate)) {
		const set = new Set(predicate);
		return includeKeys(object, key => !set.has(key));
	}

	return includeKeys(object, (key, value, object) => !predicate(key, value, object));
}

;// CONCATENATED MODULE: ./node_modules/query-string/base.js




const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index': {
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result, [encode(key, options), '[', index, ']'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join(''),
				];
			};
		}

		case 'bracket': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), '[]'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[]=', encode(value, options)].join(''),
				];
			};
		}

		case 'colon-list-separator': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), ':list='].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), ':list=', encode(value, options)].join(''),
				];
			};
		}

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator'
				? '[]='
				: '=';

			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default: {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						encode(key, options),
					];
				}

				return [
					...result,
					[encode(key, options), '=', encode(value, options)].join(''),
				];
			};
		}
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index': {
			return (key, value, accumulator) => {
				result = /\[(\d*)]$/.exec(key);

				key = key.replace(/\[\d*]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};
		}

		case 'bracket': {
			return (key, value, accumulator) => {
				result = /(\[])$/.exec(key);
				key = key.replace(/\[]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'colon-list-separator': {
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'comma':
		case 'separator': {
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && base_decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? base_decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => base_decode(item, options)) : (value === null ? value : base_decode(value, options));
				accumulator[key] = newValue;
			};
		}

		case 'bracket-separator': {
			return (key, value, accumulator) => {
				const isArray = /(\[])$/.test(key);
				key = key.replace(/\[]$/, '');

				if (!isArray) {
					accumulator[key] = value ? base_decode(value, options) : value;
					return;
				}

				const arrayValue = value === null
					? []
					: value.split(options.arrayFormatSeparator).map(item => base_decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [...accumulator[key], ...arrayValue];
			};
		}

		default: {
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [...[accumulator[key]].flat(), value];
			};
		}
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function base_decode(value, options) {
	if (options.decode) {
		return decodeUriComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parse(query, options) {
	options = {
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false,
		...options,
	};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const returnValue = Object.create(null);

	if (typeof query !== 'string') {
		return returnValue;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return returnValue;
	}

	for (const parameter of query.split('&')) {
		if (parameter === '') {
			continue;
		}

		const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;

		let [key, value] = splitOnFirst(parameter_, '=');

		if (key === undefined) {
			key = parameter_;
		}

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : (['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : base_decode(value, options));
		formatter(base_decode(key, options), value, returnValue);
	}

	for (const [key, value] of Object.entries(returnValue)) {
		if (typeof value === 'object' && value !== null) {
			for (const [key2, value2] of Object.entries(value)) {
				value[key2] = parseValue(value2, options);
			}
		} else {
			returnValue[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return returnValue;
	}

	// TODO: Remove the use of `reduce`.
	// eslint-disable-next-line unicorn/no-array-reduce
	return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
		const value = returnValue[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

function stringify(object, options) {
	if (!object) {
		return '';
	}

	options = {encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',', ...options};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key]))
		|| (options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const [key, value] of Object.entries(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = value;
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
}

function parseUrl(url, options) {
	options = {
		decode: true,
		...options,
	};

	let [url_, hash] = splitOnFirst(url, '#');

	if (url_ === undefined) {
		url_ = url;
	}

	return {
		url: url_?.split('?')?.[0] ?? '',
		query: parse(extract(url), options),
		...(options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: base_decode(hash, options)} : {}),
	};
}

function stringifyUrl(object, options) {
	options = {
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true,
		...options,
	};

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = extract(object.url);

	const query = {
		...parse(queryFromUrl, {sort: false}),
		...object.query,
	};

	let queryString = stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		const urlObjectForFragmentEncode = new URL(url);
		urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
		hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
}

function pick(input, filter, options) {
	options = {
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false,
		...options,
	};

	const {url, query, fragmentIdentifier} = parseUrl(input, options);

	return stringifyUrl({
		url,
		query: includeKeys(query, filter),
		fragmentIdentifier,
	}, options);
}

function exclude(input, filter, options) {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return pick(input, exclusionFilter, options);
}

;// CONCATENATED MODULE: ./node_modules/query-string/index.js


/* harmony default export */ var query_string = (base_namespaceObject);

// EXTERNAL MODULE: ./src/views/Product/types.ts
var types = __webpack_require__(43065);
;// CONCATENATED MODULE: ./src/views/Product/utils/urls.ts
/* eslint-disable no-console */ 






var generateProductUrlWithAttributes = function(product, attributes) {
    var productUrl = (0,core/* generatePath */.Gn)(paths/* paths.product */.H.product, {
        slug: (0,core/* slugify */.lV)((0,translations/* translate */.I)(product, "name")),
        id: (0,core/* decodeKey */.Tn)(product.id, "Product")
    });
    var filteredAttributes = pickBy_default()(attributes);
    if (Object.values(filteredAttributes).length) {
        return "".concat(window.location.origin).concat(productUrl, "?").concat(query_string.stringify(filteredAttributes));
    }
    return "".concat(window.location.origin).concat(productUrl);
};
var generateProductImageWithAttributes = function(product, attributes) {
    var isConfiguratorType = types/* CONFIGURATOR_PRODUCT_TYPES.includes */.d.includes(product.productType.slug);
    var filteredAttributes = pickBy_default()(attributes);
    if (isConfiguratorType && Object.values(filteredAttributes).length) {
        return "".concat("https://images.renodoors.eu/", "render/").concat(product.productType.slug, "/?").concat(query_string.stringify(filteredAttributes));
    }
    var thumbnail = product.thumbnail;
    return thumbnail ? product.thumbnail.url : no_photo;
};

;// CONCATENATED MODULE: ./src/views/Product/utils/index.ts




/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 11987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(17673)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 61608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(98461)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 94092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dP": function() { return /* binding */ dep; },
  "re": function() { return /* binding */ wrap; }
});

// UNUSED EXPORTS: KeyTrie, asyncFromGen, bindContext, defaultMakeCacheKey, noContext, setTimeout

;// CONCATENATED MODULE: ./node_modules/optimism/node_modules/@wry/trie/lib/trie.esm.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function () { return Object.create(null); };
// Useful for processing arguments objects as well as arrays.
var _a = Array.prototype, forEach = _a.forEach, slice = _a.slice;
var Trie = /** @class */ (function () {
    function Trie(weakness, makeData) {
        if (weakness === void 0) { weakness = true; }
        if (makeData === void 0) { makeData = defaultMakeData; }
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function (array) {
        var node = this;
        forEach.call(array, function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = this.makeData(slice.call(array)));
    };
    Trie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


//# sourceMappingURL=trie.esm.js.map

// EXTERNAL MODULE: ./node_modules/@wry/context/lib/index.js + 1 modules
var lib = __webpack_require__(70093);
;// CONCATENATED MODULE: ./node_modules/optimism/lib/bundle.esm.js





function defaultDispose() { }
var Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function (key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    };
    Cache.prototype.set = function (key, value) {
        var node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new lib/* Slot */.g7();

var bundle_esm_a;
var bundle_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
var 
// This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
toArray = (bundle_esm_a = Array.from, bundle_esm_a === void 0 ? function (collection) {
    var array = [];
    collection.forEach(function (item) { return array.push(item); });
    return array;
} : bundle_esm_a);
function maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function () {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function (args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, function (parent, child) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function () {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function (dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function () {
        var _this = this;
        if (this.deps) {
            toArray(this.deps).forEach(function (dep) { return dep.delete(_this); });
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = toArray(child.parents);
        for (var i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    var parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

var EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true, // Fully remove parent Entry from LRU cache and computation graph
};
function dep(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) {
                depsByKey.set(key, dep_1 = new Set);
            }
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = (entryMethodName &&
                bundle_esm_hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            toArray(dep).forEach(function (entry) { return entry[m_1](); });
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

function makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new Trie(typeof WeakMap === "function");
    return function () {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var defaultMakeCacheKey = makeDefaultMakeCacheKeyFunction();
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey ||
        makeDefaultMakeCacheKeyFunction();
    var optimistic = function () {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function () { return cache.delete(key); };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false,
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),

/***/ 51068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "compile": function() { return /* binding */ compile; },
/* harmony export */   "match": function() { return /* binding */ match; },
/* harmony export */   "parse": function() { return /* binding */ parse; },
/* harmony export */   "pathToRegexp": function() { return /* binding */ pathToRegexp; },
/* harmony export */   "regexpToFunction": function() { return /* binding */ regexpToFunction; },
/* harmony export */   "tokensToFunction": function() { return /* binding */ tokensToFunction; },
/* harmony export */   "tokensToRegexp": function() { return /* binding */ tokensToRegexp; }
/* harmony export */ });
/**
 * Tokenize input string.
 */
function lexer(str) {
    var tokens = [];
    var i = 0;
    while (i < str.length) {
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({ type: "MODIFIER", index: i, value: str[i++] });
            continue;
        }
        if (char === "\\") {
            tokens.push({ type: "ESCAPED_CHAR", index: i++, value: str[i++] });
            continue;
        }
        if (char === "{") {
            tokens.push({ type: "OPEN", index: i, value: str[i++] });
            continue;
        }
        if (char === "}") {
            tokens.push({ type: "CLOSE", index: i, value: str[i++] });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while (j < str.length) {
                var code = str.charCodeAt(j);
                if (
                // `0-9`
                (code >= 48 && code <= 57) ||
                    // `A-Z`
                    (code >= 65 && code <= 90) ||
                    // `a-z`
                    (code >= 97 && code <= 122) ||
                    // `_`
                    code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name)
                throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({ type: "NAME", index: i, value: name });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") {
                throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            }
            while (j < str.length) {
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                }
                else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") {
                        throw new TypeError("Capturing groups are not allowed at ".concat(j));
                    }
                }
                pattern += str[j++];
            }
            if (count)
                throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern)
                throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({ type: "PATTERN", index: i, value: pattern });
            i = j;
            continue;
        }
        tokens.push({ type: "CHAR", index: i, value: str[i++] });
    }
    tokens.push({ type: "END", index: i, value: "" });
    return tokens;
}
/**
 * Parse a string for the raw tokens.
 */
function parse(str, options) {
    if (options === void 0) { options = {}; }
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat(escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function (type) {
        if (i < tokens.length && tokens[i].type === type)
            return tokens[i++].value;
    };
    var mustConsume = function (type) {
        var value = tryConsume(type);
        if (value !== undefined)
            return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function () {
        var result = "";
        var value;
        while ((value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))) {
            result += value;
        }
        return result;
    };
    while (i < tokens.length) {
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || "",
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || "",
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
/**
 * Compile a string to a template function for the path.
 */
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
    if (options === void 0) { options = {}; }
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function (x) { return x; } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function (token) {
        if (typeof token === "object") {
            return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
        }
    });
    return function (data) {
        var path = "";
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) {
                    throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                }
                if (value.length === 0) {
                    if (optional)
                        continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for (var j = 0; j < value.length; j++) {
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) {
                        throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    }
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) {
                    throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                }
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional)
                continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
/**
 * Create path match function from `path-to-regexp` spec.
 */
function match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
/**
 * Create a path match function from `path-to-regexp` output.
 */
function regexpToFunction(re, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.decode, decode = _a === void 0 ? function (x) { return x; } : _a;
    return function (pathname) {
        var m = re.exec(pathname);
        if (!m)
            return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function (i) {
            if (m[i] === undefined)
                return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") {
                params[key.name] = m[i].split(key.prefix + key.suffix).map(function (value) {
                    return decode(value, key);
                });
            }
            else {
                params[key.name] = decode(m[i], key);
            }
        };
        for (var i = 1; i < m.length; i++) {
            _loop_1(i);
        }
        return { path: path, index: index, params: params };
    };
}
/**
 * Escape a regular expression string.
 */
function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */
function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */
function regexpToRegexp(path, keys) {
    if (!keys)
        return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while (execResult) {
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: "",
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */
function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function (path) { return pathToRegexp(path, keys, options).source; });
    return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
}
/**
 * Create a path regexp from string input.
 */
function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 */
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function (x) { return x; } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat(escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        if (typeof token === "string") {
            route += escapeString(encode(token));
        }
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys)
                    keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    }
                    else {
                        route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                    }
                }
                else {
                    if (token.modifier === "+" || token.modifier === "*") {
                        route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                    }
                    else {
                        route += "(".concat(token.pattern, ")").concat(token.modifier);
                    }
                }
            }
            else {
                route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
            }
        }
    }
    if (end) {
        if (!strict)
            route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    }
    else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string"
            ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1
            : endToken === undefined;
        if (!strict) {
            route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        }
        if (!isEndDelimited) {
            route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
        }
    }
    return new RegExp(route, flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp)
        return regexpToRegexp(path, keys);
    if (Array.isArray(path))
        return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 62587:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 12361:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).filter(Boolean).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 17673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(62587);
exports.encode = exports.stringify = __webpack_require__(12361);


/***/ }),

/***/ 54490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ji": function() { return /* binding */ FormattedDate; },
  "vU": function() { return /* binding */ defineMessages; }
});

// UNUSED EXPORTS: FormattedDateParts, FormattedDateTimeRange, FormattedDisplayName, FormattedList, FormattedListParts, FormattedMessage, FormattedNumber, FormattedNumberParts, FormattedPlural, FormattedRelativeTime, FormattedTime, FormattedTimeParts, IntlContext, IntlProvider, InvalidConfigError, MessageFormatError, MissingDataError, MissingTranslationError, RawIntlProvider, ReactIntlError, ReactIntlErrorCode, UnsupportedFormatterError, createIntl, createIntlCache, defineMessage, injectIntl, useIntl

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var components_useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/createFormattedComponent.js



var DisplayName;
(function (DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function (DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function (props) {
    var intl = (0,components_useIntl/* default */.Z)();
    var value = props.value, children = props.children, formatProps = (0,tslib_es6.__rest)(props, ["value", "children"]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
var FormattedListParts = function (props) {
    var intl = useIntl();
    var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6.__rest)(props, ["value", "children"]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate'
            ? intl.formatDateToParts(date, formatProps)
            : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6.__rest)(props
        // TODO: fix TS type definition for localeMatcher upstream
        , ["value", "children"]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') {
            return children(formattedValue);
        }
        var Text = intl.textComponent || react.Fragment;
        return react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

;// CONCATENATED MODULE: ./node_modules/react-intl/lib/index.js










function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
var FormattedDate = createFormattedComponent('formatDate');
var FormattedTime = createFormattedComponent('formatTime');
var FormattedNumber = createFormattedComponent('formatNumber');
var FormattedList = createFormattedComponent('formatList');
var FormattedDisplayName = createFormattedComponent('formatDisplayName');
var FormattedDateParts = createFormattedDateTimePartsComponent('formatDate');
var FormattedTimeParts = createFormattedDateTimePartsComponent('formatTime');



/***/ }),

/***/ 74806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_y": function() { return /* binding */ Context; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);




function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__
    ? window.__REACT_INTL_CONTEXT__ ||
        (window.__REACT_INTL_CONTEXT__ = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null))
    : react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
        var _a;
        if (enforceContext) {
            invariantIntlContext(intl);
        }
        var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
        return (React.createElement(WrappedComponent, __assign({}, props, intlProp, { ref: forwardRef ? props.forwardedRef : null })));
    })); };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) {
        return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, __assign({}, props, { forwardedRef: ref }))); }), WrappedComponent);
    }
    return hoistNonReactStatics(WithIntl, WrappedComponent);
}


/***/ }),

/***/ 44012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 86896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ }),

/***/ 680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "dt": function() { return /* binding */ assignUniqueKeysToParts; },
/* harmony export */   "lq": function() { return /* binding */ invariantIntlContext; },
/* harmony export */   "wU": function() { return /* binding */ shallowEqual; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25687);
/* harmony import */ var _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82644);




function invariantIntlContext(intl) {
    (0,_formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_INTL_CONFIG */ .Z0), { textComponent: react__WEBPACK_IMPORTED_MODULE_0__.Fragment });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] ||
            !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 98547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ ReactSVG; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/content-type/index.js
var content_type = __webpack_require__(37811);
;// CONCATENATED MODULE: ./node_modules/@tanem/svg-injector/dist/svg-injector.esm.js



var cache = new Map();

var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};

var isLocal = function isLocal() {
  return window.location.protocol === 'file:';
};

var makeAjaxRequest = function makeAjaxRequest(url, httpRequestWithCredentials, callback) {
  var httpRequest = new XMLHttpRequest();
  httpRequest.onreadystatechange = function () {
    try {
      if (!/\.svg/i.test(url) && httpRequest.readyState === 2) {
        var contentType = httpRequest.getResponseHeader('Content-Type');
        if (!contentType) {
          throw new Error('Content type not found');
        }
        var type = (0,content_type/* parse */.Q)(contentType).type;
        if (!(type === 'image/svg+xml' || type === 'text/plain')) {
          throw new Error("Invalid content type: ".concat(type));
        }
      }
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 404 || httpRequest.responseXML === null) {
          throw new Error(isLocal() ? 'Note: SVG injection ajax calls do not work locally without ' + 'adjusting security settings in your browser. Or consider ' + 'using a local webserver.' : 'Unable to load SVG file: ' + url);
        }
        if (httpRequest.status === 200 || isLocal() && httpRequest.status === 0) {
          callback(null, httpRequest);
        } else {
          throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
        }
      }
    } catch (error) {
      httpRequest.abort();
      if (error instanceof Error) {
        callback(error, httpRequest);
      } else {
        throw error;
      }
    }
  };
  httpRequest.open('GET', url);
  httpRequest.withCredentials = httpRequestWithCredentials;
  if (httpRequest.overrideMimeType) {
    httpRequest.overrideMimeType('text/xml');
  }
  httpRequest.send();
};

var requestQueue = {};
var queueRequest = function queueRequest(url, callback) {
  requestQueue[url] = requestQueue[url] || [];
  requestQueue[url].push(callback);
};
var processRequestQueue = function processRequestQueue(url) {
  var _loop_1 = function _loop_1(i, len) {
    setTimeout(function () {
      if (Array.isArray(requestQueue[url])) {
        var cacheValue = cache.get(url);
        var callback = requestQueue[url][i];
        if (cacheValue instanceof SVGSVGElement) {
          callback(null, cloneSvg(cacheValue));
        }
        if (cacheValue instanceof Error) {
          callback(cacheValue);
        }
        if (i === requestQueue[url].length - 1) {
          delete requestQueue[url];
        }
      }
    }, 0);
  };
  for (var i = 0, len = requestQueue[url].length; i < len; i++) {
    _loop_1(i);
  }
};

var loadSvgCached = function loadSvgCached(url, httpRequestWithCredentials, callback) {
  if (cache.has(url)) {
    var cacheValue = cache.get(url);
    if (cacheValue === undefined) {
      queueRequest(url, callback);
      return;
    }
    if (cacheValue instanceof SVGSVGElement) {
      callback(null, cloneSvg(cacheValue));
      return;
    }
  }
  cache.set(url, undefined);
  queueRequest(url, callback);
  makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
    var _a;
    if (error) {
      cache.set(url, error);
    } else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
      cache.set(url, httpRequest.responseXML.documentElement);
    }
    processRequestQueue(url);
  });
};

var loadSvgUncached = function loadSvgUncached(url, httpRequestWithCredentials, callback) {
  makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
    var _a;
    if (error) {
      callback(error);
    } else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
      callback(null, httpRequest.responseXML.documentElement);
    }
  });
};

var idCounter = 0;
var uniqueId = function uniqueId() {
  return ++idCounter;
};

var injectedElements = [];
var ranScripts = {};
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';
var injectElement = function injectElement(el, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, callback) {
  var elUrl = el.getAttribute('data-src') || el.getAttribute('src');
  if (!elUrl) {
    callback(new Error('Invalid data-src or src attribute'));
    return;
  }
  if (injectedElements.indexOf(el) !== -1) {
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    return;
  }
  injectedElements.push(el);
  el.setAttribute('src', '');
  var loadSvg = cacheRequests ? loadSvgCached : loadSvgUncached;
  loadSvg(elUrl, httpRequestWithCredentials, function (error, svg) {
    if (!svg) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(error);
      return;
    }
    var elId = el.getAttribute('id');
    if (elId) {
      svg.setAttribute('id', elId);
    }
    var elTitle = el.getAttribute('title');
    if (elTitle) {
      svg.setAttribute('title', elTitle);
    }
    var elWidth = el.getAttribute('width');
    if (elWidth) {
      svg.setAttribute('width', elWidth);
    }
    var elHeight = el.getAttribute('height');
    if (elHeight) {
      svg.setAttribute('height', elHeight);
    }
    var mergedClasses = Array.from(new Set((0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], (svg.getAttribute('class') || '').split(' '), true), ['injected-svg'], false), (el.getAttribute('class') || '').split(' '), true))).join(' ').trim();
    svg.setAttribute('class', mergedClasses);
    var elStyle = el.getAttribute('style');
    if (elStyle) {
      svg.setAttribute('style', elStyle);
    }
    svg.setAttribute('data-src', elUrl);
    var elData = [].filter.call(el.attributes, function (at) {
      return /^data-\w[\w-]*$/.test(at.name);
    });
    Array.prototype.forEach.call(elData, function (dataAttr) {
      if (dataAttr.name && dataAttr.value) {
        svg.setAttribute(dataAttr.name, dataAttr.value);
      }
    });
    if (renumerateIRIElements) {
      var iriElementsAndProperties_1 = {
        clipPath: ['clip-path'],
        'color-profile': ['color-profile'],
        cursor: ['cursor'],
        filter: ['filter'],
        linearGradient: ['fill', 'stroke'],
        marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
        mask: ['mask'],
        path: [],
        pattern: ['fill', 'stroke'],
        radialGradient: ['fill', 'stroke']
      };
      var element_1;
      var elements_1;
      var properties_1;
      var currentId_1;
      var newId_1;
      Object.keys(iriElementsAndProperties_1).forEach(function (key) {
        element_1 = key;
        properties_1 = iriElementsAndProperties_1[key];
        elements_1 = svg.querySelectorAll(element_1 + '[id]');
        var _loop_1 = function _loop_1(a, elementsLen) {
          currentId_1 = elements_1[a].id;
          newId_1 = currentId_1 + '-' + uniqueId();
          var referencingElements;
          Array.prototype.forEach.call(properties_1, function (property) {
            referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId_1 + '"]');
            for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
              var attrValue = referencingElements[b].getAttribute(property);
              if (attrValue && !attrValue.match(new RegExp('url\\("?#' + currentId_1 + '"?\\)'))) {
                continue;
              }
              referencingElements[b].setAttribute(property, 'url(#' + newId_1 + ')');
            }
          });
          var allLinks = svg.querySelectorAll('[*|href]');
          var links = [];
          for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
            var href = allLinks[c].getAttributeNS(xlinkNamespace, 'href');
            if (href && href.toString() === '#' + elements_1[a].id) {
              links.push(allLinks[c]);
            }
          }
          for (var d = 0, linksLen = links.length; d < linksLen; d++) {
            links[d].setAttributeNS(xlinkNamespace, 'href', '#' + newId_1);
          }
          elements_1[a].id = newId_1;
        };
        for (var a = 0, elementsLen = elements_1.length; a < elementsLen; a++) {
          _loop_1(a);
        }
      });
    }
    svg.removeAttribute('xmlns:a');
    var scripts = svg.querySelectorAll('script');
    var scriptsToEval = [];
    var script;
    var scriptType;
    for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
      scriptType = scripts[i].getAttribute('type');
      if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript' || scriptType === 'text/javascript') {
        script = scripts[i].innerText || scripts[i].textContent;
        if (script) {
          scriptsToEval.push(script);
        }
        svg.removeChild(scripts[i]);
      }
    }
    if (scriptsToEval.length > 0 && (evalScripts === 'always' || evalScripts === 'once' && !ranScripts[elUrl])) {
      for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
        new Function(scriptsToEval[l])(window);
      }
      ranScripts[elUrl] = true;
    }
    var styleTags = svg.querySelectorAll('style');
    Array.prototype.forEach.call(styleTags, function (styleTag) {
      styleTag.textContent += '';
    });
    svg.setAttribute('xmlns', svgNamespace);
    svg.setAttribute('xmlns:xlink', xlinkNamespace);
    beforeEach(svg);
    if (!el.parentNode) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(new Error('Parent node is null'));
      return;
    }
    el.parentNode.replaceChild(svg, el);
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    callback(null, svg);
  });
};

var SVGInjector = function SVGInjector(elements, _a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.afterAll,
    afterAll = _c === void 0 ? function () {
      return undefined;
    } : _c,
    _d = _b.afterEach,
    afterEach = _d === void 0 ? function () {
      return undefined;
    } : _d,
    _e = _b.beforeEach,
    beforeEach = _e === void 0 ? function () {
      return undefined;
    } : _e,
    _f = _b.cacheRequests,
    cacheRequests = _f === void 0 ? true : _f,
    _g = _b.evalScripts,
    evalScripts = _g === void 0 ? 'never' : _g,
    _h = _b.httpRequestWithCredentials,
    httpRequestWithCredentials = _h === void 0 ? false : _h,
    _j = _b.renumerateIRIElements,
    renumerateIRIElements = _j === void 0 ? true : _j;
  if (elements && 'length' in elements) {
    var elementsLoaded_1 = 0;
    for (var i = 0, j = elements.length; i < j; i++) {
      injectElement(elements[i], evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
        afterEach(error, svg);
        if (elements && 'length' in elements && elements.length === ++elementsLoaded_1) {
          afterAll(elementsLoaded_1);
        }
      });
    }
  } else if (elements) {
    injectElement(elements, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
      afterEach(error, svg);
      afterAll(1);
      elements = null;
    });
  } else {
    afterAll(0);
  }
};


//# sourceMappingURL=svg-injector.esm.js.map

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-svg/dist/react-svg.esm.js







// Hat-tip: https://github.com/mui/material-ui/tree/master/packages/mui-utils/src.
var ownerWindow = function ownerWindow(node) {
  var doc = (node == null ? void 0 : node.ownerDocument) || document;
  return doc.defaultView || window;
};

// Hat-tip: https://github.com/developit/preact-compat/blob/master/src/index.js#L402.
var shallowDiffers = function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) {
      return true;
    }
  }
  for (var _i in b) {
    if (a[_i] !== b[_i]) {
      return true;
    }
  }
  return false;
};

var _excluded = ["afterInjection", "beforeInjection", "desc", "evalScripts", "fallback", "httpRequestWithCredentials", "loading", "renumerateIRIElements", "src", "title", "useRequestCache", "wrapper"];
var react_svg_esm_svgNamespace = 'http://www.w3.org/2000/svg';
var react_svg_esm_xlinkNamespace = 'http://www.w3.org/1999/xlink';
var ReactSVG = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(ReactSVG, _React$Component);
  function ReactSVG() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.initialState = {
      hasError: false,
      isLoading: true
    };
    _this.state = _this.initialState;
    _this._isMounted = false;
    _this.reactWrapper = void 0;
    _this.nonReactWrapper = void 0;
    _this.refCallback = function (reactWrapper) {
      _this.reactWrapper = reactWrapper;
    };
    return _this;
  }
  var _proto = ReactSVG.prototype;
  _proto.renderSVG = function renderSVG() {
    var _this2 = this;
    /* istanbul ignore else */
    if (this.reactWrapper instanceof ownerWindow(this.reactWrapper).Node) {
      var _this$props = this.props,
        desc = _this$props.desc,
        evalScripts = _this$props.evalScripts,
        httpRequestWithCredentials = _this$props.httpRequestWithCredentials,
        renumerateIRIElements = _this$props.renumerateIRIElements,
        src = _this$props.src,
        title = _this$props.title,
        useRequestCache = _this$props.useRequestCache;
      /* eslint-disable @typescript-eslint/no-non-null-assertion */
      var onError = this.props.onError;
      var beforeInjection = this.props.beforeInjection;
      var afterInjection = this.props.afterInjection;
      var wrapper = this.props.wrapper;
      var nonReactWrapper;
      var nonReactTarget;
      if (wrapper === 'svg') {
        nonReactWrapper = document.createElementNS(react_svg_esm_svgNamespace, wrapper);
        nonReactWrapper.setAttribute('xmlns', react_svg_esm_svgNamespace);
        nonReactWrapper.setAttribute('xmlns:xlink', react_svg_esm_xlinkNamespace);
        nonReactTarget = document.createElementNS(react_svg_esm_svgNamespace, wrapper);
      } else {
        nonReactWrapper = document.createElement(wrapper);
        nonReactTarget = document.createElement(wrapper);
      }
      nonReactWrapper.appendChild(nonReactTarget);
      nonReactTarget.dataset.src = src;
      this.nonReactWrapper = this.reactWrapper.appendChild(nonReactWrapper);
      var handleError = function handleError(error) {
        _this2.removeSVG();
        if (!_this2._isMounted) {
          onError(error);
          return;
        }
        _this2.setState(function () {
          return {
            hasError: true,
            isLoading: false
          };
        }, function () {
          onError(error);
        });
      };
      var afterEach = function afterEach(error, svg) {
        if (error) {
          handleError(error);
          return;
        }
        // TODO (Tane): It'd be better to cleanly unsubscribe from SVGInjector
        // callbacks instead of tracking a property like this.
        if (_this2._isMounted) {
          _this2.setState(function () {
            return {
              isLoading: false
            };
          }, function () {
            try {
              afterInjection(svg);
            } catch (afterInjectionError) {
              handleError(afterInjectionError);
            }
          });
        }
      };
      var beforeEach = function beforeEach(svg) {
        svg.setAttribute('role', 'img');
        if (desc) {
          var originalDesc = svg.querySelector(':scope > desc');
          if (originalDesc) {
            svg.removeChild(originalDesc);
          }
          var newDesc = document.createElement('desc');
          newDesc.innerHTML = desc;
          svg.prepend(newDesc);
        }
        if (title) {
          var originalTitle = svg.querySelector(':scope > title');
          if (originalTitle) {
            svg.removeChild(originalTitle);
          }
          var newTitle = document.createElement('title');
          newTitle.innerHTML = title;
          svg.prepend(newTitle);
        }
        try {
          beforeInjection(svg);
        } catch (error) {
          handleError(error);
        }
      };
      SVGInjector(nonReactTarget, {
        afterEach: afterEach,
        beforeEach: beforeEach,
        cacheRequests: useRequestCache,
        evalScripts: evalScripts,
        httpRequestWithCredentials: httpRequestWithCredentials,
        renumerateIRIElements: renumerateIRIElements
      });
    }
  };
  _proto.removeSVG = function removeSVG() {
    var _this$nonReactWrapper;
    if ((_this$nonReactWrapper = this.nonReactWrapper) != null && _this$nonReactWrapper.parentNode) {
      this.nonReactWrapper.parentNode.removeChild(this.nonReactWrapper);
      this.nonReactWrapper = null;
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.renderSVG();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;
    if (shallowDiffers((0,esm_extends/* default */.Z)({}, prevProps), this.props)) {
      this.setState(function () {
        return _this3.initialState;
      }, function () {
        _this3.removeSVG();
        _this3.renderSVG();
      });
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this.removeSVG();
  };
  _proto.render = function render() {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    var _this$props2 = this.props;
      _this$props2.afterInjection;
      _this$props2.beforeInjection;
      _this$props2.desc;
      _this$props2.evalScripts;
      var Fallback = _this$props2.fallback;
      _this$props2.httpRequestWithCredentials;
      var Loading = _this$props2.loading;
      _this$props2.renumerateIRIElements;
      _this$props2.src;
      _this$props2.title;
      _this$props2.useRequestCache;
      var wrapper = _this$props2.wrapper,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props2, _excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var Wrapper = wrapper;
    return /*#__PURE__*/react.createElement(Wrapper, (0,esm_extends/* default */.Z)({}, rest, {
      ref: this.refCallback
    }, wrapper === 'svg' ? {
      xmlns: react_svg_esm_svgNamespace,
      xmlnsXlink: react_svg_esm_xlinkNamespace
    } : {}), this.state.isLoading && Loading && /*#__PURE__*/react.createElement(Loading, null), this.state.hasError && Fallback && /*#__PURE__*/react.createElement(Fallback, null));
  };
  return ReactSVG;
}(react.Component);
ReactSVG.defaultProps = {
  afterInjection: function afterInjection() {
    return undefined;
  },
  beforeInjection: function beforeInjection() {
    return undefined;
  },
  desc: '',
  evalScripts: 'never',
  fallback: null,
  httpRequestWithCredentials: false,
  loading: null,
  onError: function onError() {
    return undefined;
  },
  renumerateIRIElements: true,
  title: '',
  useRequestCache: true,
  wrapper: 'div'
};
ReactSVG.propTypes = {
  afterInjection: prop_types.func,
  beforeInjection: prop_types.func,
  desc: prop_types.string,
  evalScripts: prop_types.oneOf(['always', 'once', 'never']),
  fallback: prop_types.oneOfType([prop_types.func, prop_types.object, prop_types.string]),
  httpRequestWithCredentials: prop_types.bool,
  loading: prop_types.oneOfType([prop_types.func, prop_types.object, prop_types.string]),
  onError: prop_types.func,
  renumerateIRIElements: prop_types.bool,
  src: prop_types.string.isRequired,
  title: prop_types.string,
  useRequestCache: prop_types.bool,
  wrapper: prop_types.oneOf(['div', 'span', 'svg'])
} ;


//# sourceMappingURL=react-svg.esm.js.map


/***/ }),

/***/ 26273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 96774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 52015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ni": function() { return /* binding */ Me; },
  "f6": function() { return /* binding */ Le; },
  "vJ": function() { return /* binding */ $e; },
  "iv": function() { return /* binding */ Ae; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ We; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, __PRIVATE__, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(96774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/styled-components/node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(83454);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=(0,react.useContext)(Me),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,isPropValid,b):!_||isPropValid(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=(0,react.useContext)(Me),d=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=r.forwardRef((function(t,n){var o=s(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,r.createElement(e,y({},t,{theme:a,ref:n}))}));return m(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return s(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 21602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/account-created.svg";

/***/ }),

/***/ 45809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/check.svg";

/***/ }),

/***/ 76380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/whatsapp-widget.svg";

/***/ }),

/***/ 80345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/garbage.svg";

/***/ }),

/***/ 25280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/heart.svg";

/***/ }),

/***/ 17722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/logo-mobile.svg";

/***/ }),

/***/ 91937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/logo.svg";

/***/ }),

/***/ 97278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/mail-send.svg";

/***/ }),

/***/ 83171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/no-photo.svg";

/***/ }),

/***/ 79378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/sign-in.svg";

/***/ }),

/***/ 63232:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/images/x.svg";

/***/ }),

/***/ 11294:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ApolloCache; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94092);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23361);



var ApolloCache = (function () {
    function ApolloCache() {
        this.getFragmentDoc = (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .wrap */ .re)(_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getFragmentQueryDocument */ .Yk);
    }
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic :
            options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function () { return updateResult = options.update(_this); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { rootId: options.id || 'ROOT_QUERY', optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map

/***/ }),

/***/ 75727:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MissingFieldError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);

var MissingFieldError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

//# sourceMappingURL=common.js.map

/***/ }),

/***/ 49641:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ TypeOrFieldNameRegExp; },
/* harmony export */   "E_": function() { return /* binding */ fieldNameFromStoreName; },
/* harmony export */   "Is": function() { return /* binding */ extractFragmentContext; },
/* harmony export */   "RC": function() { return /* binding */ selectionSetMatchesResult; },
/* harmony export */   "RI": function() { return /* binding */ hasOwn; },
/* harmony export */   "ig": function() { return /* binding */ makeProcessedFieldsMerger; },
/* harmony export */   "j": function() { return /* binding */ storeValueIsStoreObject; },
/* harmony export */   "jS": function() { return /* binding */ normalizeConfig; },
/* harmony export */   "jp": function() { return /* binding */ getTypenameFromStoreObject; },
/* harmony export */   "lg": function() { return /* binding */ shouldCanonizeResults; },
/* harmony export */   "uG": function() { return /* binding */ defaultDataIdFromObject; }
/* harmony export */ });
/* unused harmony export isNullish */
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53712);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51761);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13154);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21436);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19065);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(182);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23361);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36765);

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}

function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id } :
                    !isNullish(_id) ? { _id: _id } :
                        void 0;
        }
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat((typeof id === "number" ||
                typeof id === "string") ? id : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false,
};
function normalizeConfig(config) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isReference */ .Yk)(objectOrReference)
        ? store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(result)) {
        return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .k)(result)
            ? result.every(function (item) { return selectionSetMatchesResult(selectionSet, item, variables); })
            : selectionSet.selections.every(function (field) {
                if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isField */ .My)(field) && (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .shouldInclude */ .LZ)(field, variables)) {
                    var key = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .resultKeyNameFromField */ .u2)(field);
                    return hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables));
                }
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value) &&
        !(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isReference */ .Yk)(value) &&
        !(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .k)(value);
}
function makeProcessedFieldsMerger() {
    return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .DeepMerger */ .w0;
}
function extractFragmentContext(document, fragments) {
    var fragmentMap = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .createFragmentMap */ .F)((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_7__/* .getFragmentDefinitions */ .kU)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 55598:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ InMemoryCache; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(48964);
// EXTERNAL MODULE: ./node_modules/optimism/lib/bundle.esm.js + 1 modules
var bundle_esm = __webpack_require__(94092);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/index.js
var lib = __webpack_require__(30020);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/core/cache.js
var cache = __webpack_require__(11294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/core/types/common.js
var common = __webpack_require__(75727);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(76487);
// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(53712);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(19065);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/fragments.js
var fragments = __webpack_require__(23361);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(10542);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(13154);
// EXTERNAL MODULE: ./node_modules/@wry/trie/lib/index.js
var trie_lib = __webpack_require__(75028);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/helpers.js
var helpers = __webpack_require__(49641);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/entityStore.js







var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function (objectOrReference, storeFieldName) { return (0,maybeDeepFreeze/* maybeDeepFreeze */.J)((0,storeUtils/* isReference */.Yk)(objectOrReference)
            ? _this.get(objectOrReference.__ref, storeFieldName)
            : objectOrReference && objectOrReference[storeFieldName]); };
        this.canRead = function (objOrRef) {
            return (0,storeUtils/* isReference */.Yk)(objOrRef)
                ? _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return (0,storeUtils/* makeReference */.kQ)(objOrIdOrRef);
            }
            if ((0,storeUtils/* isReference */.Yk)(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0,storeUtils/* makeReference */.kQ)(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (helpers/* hasOwn.call */.RI.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && helpers/* hasOwn.call */.RI.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            helpers/* hasOwn.call */.RI.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (helpers/* hasOwn.call */.RI.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        if ((0,storeUtils/* isReference */.Yk)(older))
            older = older.__ref;
        if ((0,storeUtils/* isReference */.Yk)(newer))
            newer = newer.__ref;
        var existing = typeof older === "string"
            ? this.lookup(dataId = older)
            : older;
        var incoming = typeof newer === "string"
            ? this.lookup(dataId = newer)
            : newer;
        if (!incoming)
            return;
        __DEV__ ? (0,globals/* invariant */.kG)(typeof dataId === "string", "store.merge expects a string ID") : (0,globals/* invariant */.kG)(typeof dataId === "string", 1);
        var merged = new mergeDeep/* DeepMerger */.w0(storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) { return _this.group.dirty(dataId, fieldName); });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: storeUtils/* isReference */.Yk,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) { return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                    fieldName: fieldNameOrOptions,
                    from: from || (0,storeUtils/* makeReference */.kQ)(dataId),
                } : fieldNameOrOptions, { store: _this }); },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function"
                    ? fields
                    : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE :
                        modify((0,maybeDeepFreeze/* maybeDeepFreeze */.J)(fieldValue), (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) }));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args
                ? this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (helpers/* hasOwn.call */.RI.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!helpers/* hasOwn.call */.RI.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && helpers/* hasOwn.call */.RI.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6.__rest)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (helpers/* hasOwn.call */.RI.call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!helpers/* hasOwn.call */.RI.call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            workSet_1.forEach(function (obj) {
                if ((0,storeUtils/* isReference */.Yk)(obj)) {
                    found_1[obj.__ref] = true;
                }
                if ((0,objects/* isNonNullObject */.s)(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        if ((0,objects/* isNonNullObject */.s)(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());

var CacheGroup = (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? (0,bundle_esm/* dep */.dP)() : null;
        this.keyMaker = new trie_lib/* Trie */.B(canUse/* canUseWeakMap */.mr);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
            if (fieldName !== storeFieldName) {
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    var Root = (function (_super) {
        (0,tslib_es6.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new trie_lib/* Trie */.B(canUse/* canUseWeakMap */.mr);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
var Layer = (function (_super) {
    (0,tslib_es6.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!(0,lib/* equal */.D)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        if (parent === this.parent)
            return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return helpers/* hasOwn.call */.RI.call(this.data, dataId) ? (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}(EntityStore));
var Stump = (function (_super) {
    (0,tslib_es6.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        return this;
    };
    Stump.prototype.merge = function () {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0,lib/* equal */.D)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/object-canon.js
var object_canon = __webpack_require__(80900);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/readFromStore.js









;
function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults,
    ];
}
var StoreReader = (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.config = (0,compact/* compact */.o)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0,helpers/* shouldCanonizeResults */.lg)(config),
        });
        this.canon = config.canon || new object_canon/* ObjectCanon */.h;
        this.executeSelectionSet = (0,bundle_esm/* wrap */.re)(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, other), { result: _this.canon.admit(other.result) });
                }
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: execSelectionSetKeyArgs,
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, (0,storeUtils/* isReference */.Yk)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            }
        });
        this.executeSubSelectedArray = (0,bundle_esm/* wrap */.re)(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            }
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new object_canon/* ObjectCanon */.h;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getQueryDefinition */.iW)(query))), variables);
        var rootRef = (0,storeUtils/* makeReference */.kQ)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0,getFromAST/* getMainDefinition */.p$)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0,tslib_es6.__assign)({ store: store, query: query, policies: policies, variables: variables, varString: (0,object_canon/* canonicalStringify */.B)(variables), canonizeResults: canonizeResults }, (0,helpers/* extractFragmentContext */.Is)(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            missing = [new common/* MissingFieldError */.y(firstMissing(execResult.missing), execResult.missing, query, variables)];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0,storeUtils/* isReference */.Yk)(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            if (!(0,directives/* shouldInclude */.LZ)(selection, variables))
                return;
            if ((0,storeUtils/* isField */.My)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = (0,storeUtils/* resultKeyNameFromField */.u2)(selection);
                if (fieldValue === void 0) {
                    if (!transform/* addTypenameToDocument.added */.Gw.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0,storeUtils/* isReference */.Yk)(objectOrReference)
                                ? objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if ((0,arrays/* isArray */.k)(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: (0,storeUtils/* isReference */.Yk)(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                    throw __DEV__ ? new globals/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new globals/* InvariantError */.ej(5);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = (0,mergeDeep/* mergeDeepArray */.bw)(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults
            ? this.canon.admit(finalResult)
            : (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(finalResult);
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            if (item === null) {
                return null;
            }
            if ((0,arrays/* isArray */.k)(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: (0,storeUtils/* isReference */.Yk)(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (__DEV__) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());

function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if ((0,objects/* isNonNullObject */.s)(value)) {
                __DEV__ ? (0,globals/* invariant */.kG)(!(0,storeUtils/* isReference */.Yk)(value), "Missing selection set for object of type ".concat((0,helpers/* getTypenameFromStoreObject */.jp)(store, value), " returned for query field ").concat(field.name.value)) : (0,globals/* invariant */.kG)(!(0,storeUtils/* isReference */.Yk)(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep = __webpack_require__(79487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/makeUniqueId.js
var makeUniqueId = __webpack_require__(60897);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/stringifyForDisplay.js

function stringifyForDisplay(value) {
    var undefId = (0,makeUniqueId/* makeUniqueId */.X)("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(66438);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/key-extractor.js



var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
        var extract = function (from, key) { return context.readField(key, from); };
        var keyObject = context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
            var extracted = extractKeyPath(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 &&
                object !== context.storeObject &&
                helpers/* hasOwn.call */.RI.call(object, schemaKeyPath[0])) {
                extracted = extractKeyPath(object, schemaKeyPath, extractKey);
            }
            __DEV__ ? (0,globals/* invariant */.kG)(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : (0,globals/* invariant */.kG)(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function (args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = collectSpecifierPaths(specifier, function (keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0,arrays/* isNonEmptyArray */.O)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                    var directiveArgs = d && (0,storeUtils/* argumentsObjectFromField */.NC)(d, variables);
                    return directiveArgs && extractKeyPath(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && helpers/* hasOwn.call */.RI.call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return extractKeyPath(variables, varKeyPath);
                }
                return;
            }
            if (args) {
                return extractKeyPath(args, keyPath);
            }
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") {
            fieldName += ":" + suffix;
        }
        return fieldName;
    });
}
function collectSpecifierPaths(specifier, extractor) {
    var merger = new mergeDeep/* DeepMerger */.w0;
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if ((0,arrays/* isArray */.k)(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!(0,arrays/* isArray */.k)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return (0,arrays/* isArray */.k)(obj)
            ? obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) { return extractKeyPath(value, path); });
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/policies.js







storeUtils/* getStoreKeyName.setStringify */.PT.setStringify(object_canon/* canonicalStringify */.B);
function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args :
        spec.field ? (0,storeUtils/* argumentsObjectFromField */.NC)(spec.field, spec.variables) : null;
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6.__assign)({ dataIdFromObject: helpers/* defaultDataIdFromObject */.uG }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename ||
            ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, partialContext), { typename: typename, storeObject: storeObject, readField: partialContext && partialContext.readField || function () {
                var options = normalizeReadFieldOptions(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables,
                });
            } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, object), storeObject), context);
            if ((0,arrays/* isArray */.k)(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6.__rest)(_a, ["queryType", "mutationType", "subscriptionType"]);
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (helpers/* hasOwn.call */.RI.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge :
                    merge === true ? mergeTrueFn :
                        merge === false ? mergeFalseFn :
                            existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn =
            keyFields === false ? nullKeyFieldsFn :
                (0,arrays/* isArray */.k)(keyFields) ? keyFieldsFnFromSpecifier(keyFields) :
                    typeof keyFields === "function" ? keyFields :
                        existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        keyArgs === false ? simpleKeyArgsFn :
                            (0,arrays/* isArray */.k)(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) :
                                typeof keyArgs === "function" ? keyArgs :
                                    existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? (0,globals/* invariant */.kG)(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : (0,globals/* invariant */.kG)(!old || old === which, 3);
            if (old)
                delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(helpers/* TypeOrFieldNameRegExp */.$O);
                if (!match || match[0] !== subtype) {
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!helpers/* hasOwn.call */.RI.call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) {
                supertypes.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6.__rest)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || (createIfMissing && (fieldPolicies[fieldName] = Object.create(null)));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, supertypeSet = new Set());
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes &&
            this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            __DEV__ && globals/* invariant.warn */.kG.warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        }
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    i === workQueue_1.length - 1 &&
                    (0,helpers/* selectionSetMatchesResult */.RC)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if ((0,arrays/* isArray */.k)(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName = fieldSpec.field
                ? (0,storeUtils/* storeKeyNameFromField */.vf)(fieldSpec.field, fieldSpec.variables)
                : (0,storeUtils/* getStoreKeyName */.PT)(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        if (storeFieldName === false) {
            return fieldName;
        }
        return fieldName === (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName)
            ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0,storeUtils/* isReference */.Yk)(objectOrReference)
                ? objectOrReference.__ref
                : objectOrReference, storeFieldName));
            return reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, read, [existing, readOptions]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            return incoming;
        }
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, { typename: typename, fieldName: field.name.value, field: field, variables: context.variables }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: storeUtils/* isReference */.Yk,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = (0,tslib_es6.__assign)({}, fieldNameOrOptions);
        if (!helpers/* hasOwn.call */.RI.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (__DEV__ && options.from === void 0) {
        __DEV__ && globals/* invariant.warn */.kG.warn("Undefined 'from' passed to readField with arguments ".concat(stringifyForDisplay(Array.from(readFieldArgs))));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0,arrays/* isArray */.k)(existing) || (0,arrays/* isArray */.k)(incoming)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Cannot automatically merge arrays") : new globals/* InvariantError */.ej(4);
        }
        if ((0,objects/* isNonNullObject */.s)(existing) &&
            (0,objects/* isNonNullObject */.s)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if ((0,storeUtils/* isReference */.Yk)(existing) &&
                (0,helpers/* storeValueIsStoreObject */.j)(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0,helpers/* storeValueIsStoreObject */.j)(existing) &&
                (0,storeUtils/* isReference */.Yk)(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0,helpers/* storeValueIsStoreObject */.j)(existing) &&
                (0,helpers/* storeValueIsStoreObject */.j)(incoming)) {
                return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, existing), incoming);
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/writeToStore.js









;
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, flavored = (context.clientOnly === clientOnly &&
            context.deferred === deferred) ? context : (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { clientOnly: clientOnly, deferred: deferred }));
    }
    return flavored;
}
var StoreWriter = (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0,getFromAST/* getOperationDefinition */.$H)(query);
        var merger = (0,helpers/* makeProcessedFieldsMerger */.ig)();
        variables = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (0,getFromAST/* getDefaultValues */.O4)(operationDefinition)), variables);
        var context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: (0,object_canon/* canonicalStringify */.B)(variables) }, (0,helpers/* extractFragmentContext */.Is)(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map, clientOnly: false, deferred: false, flavors: new Map });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map },
            context: context,
        });
        if (!(0,storeUtils/* isReference */.Yk)(ref)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Could not identify object ".concat(JSON.stringify(result))) : new globals/* InvariantError */.ej(7);
        }
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0,storeUtils/* isReference */.Yk)(applied)) {
                    return;
                }
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[(0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if ((0,storeUtils/* isReference */.Yk)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet
                    ? getContextFlavor(context, false, false)
                    : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet &&
                    ((0,storeUtils/* isReference */.Yk)(incomingValue) ||
                        (0,helpers/* storeValueIsStoreObject */.j)(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (__DEV__ &&
                !context.clientOnly &&
                !context.deferred &&
                !transform/* addTypenameToDocument.added */.Gw.added(field) &&
                !policies.getReadFunction(typename, field.name.value)) {
                __DEV__ && globals/* invariant.error */.kG.error("Missing field '".concat((0,storeUtils/* resultKeyNameFromField */.u2)(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
            }
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) {
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            return __DEV__ ? (0,cloneDeep/* cloneDeep */.X)(value) : value;
        }
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new trie_lib/* Trie */.B(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!(0,directives/* shouldInclude */.LZ)(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) &&
                    (0,arrays/* isNonEmptyArray */.O)(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = (0,storeUtils/* argumentsObjectFromField */.NC)(dir, context.variables);
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                        }
                    });
                }
                if ((0,storeUtils/* isField */.My)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                        throw __DEV__ ? new globals/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new globals/* InvariantError */.ej(8);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0,storeUtils/* isReference */.Yk)(incoming)) {
            var e_1 = (!(0,arrays/* isArray */.k)(incoming) &&
                ((0,storeUtils/* isReference */.Yk)(existing) || (0,helpers/* storeValueIsStoreObject */.j)(existing))) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [(0,storeUtils/* isReference */.Yk)(e_1) ? e_1.__ref : e_1];
            }
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return (0,arrays/* isArray */.k)(from)
                    ? (typeof name === "number" ? from[name] : void 0)
                    : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,globals/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                incoming = ((0,arrays/* isArray */.k)(i_1) ? i_1.slice(0) : (0,tslib_es6.__assign)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map :
        left.map.size ? left.map : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    if ((0,storeUtils/* isReference */.Yk)(existing))
        return;
    if ((0,lib/* equal */.D)(existing, incoming))
        return;
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    if (!(0,arrays/* isArray */.k)(existing) &&
        !(0,arrays/* isArray */.k)(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" &&
                !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    __DEV__ && globals/* invariant.warn */.kG.warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nThis could cause additional (usually avoidable) network requests to fetch data that were otherwise cached.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length
        ? "either ensure all objects of type " +
            childTypenames.join(" and ") + " have an ID or a custom merge function, or "
        : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}
//# sourceMappingURL=writeToStore.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js















var InMemoryCache = (function (_super) {
    (0,tslib_es6.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = reactiveVars/* makeVar */.QS;
        _this.txCount = 0;
        _this.config = (0,helpers/* normalizeConfig */.jS)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        var rootStore = this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new StoreWriter(this, this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0,helpers/* shouldCanonizeResults */.lg)(this.config),
            canon: resetResultIdentities
                ? void 0
                : previousReader && previousReader.canon,
            fragments: fragments,
        }), fragments);
        this.maybeBroadcastWatch = (0,bundle_esm/* wrap */.re)(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, (0,object_canon/* canonicalStringify */.B)({ optimistic: optimistic, id: id, variables: variables }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group,
        ]).forEach(function (group) { return group.resetCaching(); });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null;
        }
        catch (e) {
            if (e instanceof common/* MissingFieldError */.y) {
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (helpers/* hasOwn.call */.RI.call(options, "id") && !options.id) {
            return false;
        }
        var store = options.optimistic
            ? this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            (0,reactiveVars/* recallCache */._v)(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            if (_this.watches.delete(watch) && !_this.watches.size) {
                (0,reactiveVars/* forgetCache */.li)(_this);
            }
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        object_canon/* canonicalStringify.reset */.B.reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function (object) {
        if ((0,storeUtils/* isReference */.Yk)(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            __DEV__ && globals/* invariant.warn */.kG.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (helpers/* hasOwn.call */.RI.call(options, "id")) {
                return false;
            }
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        object_canon/* canonicalStringify.reset */.B.reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            (0,reactiveVars/* forgetCache */.li)(this);
        }
        else {
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return updateResult = update(_this);
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            this.broadcastWatches((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            perform(this.data);
        }
        else {
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || (optimisticId !== null),
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0,transform/* addTypenameToDocument */.Gw)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.transformForLink = function (document) {
        var fragments = this.config.fragments;
        return fragments
            ? fragments.transform(document)
            : document;
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic &&
                typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                return;
            }
        }
        if (!lastDiff || !(0,lib/* equal */.D)(lastDiff.result, diff.result)) {
            c.callback(c.lastDiff = diff, lastDiff);
        }
    };
    return InMemoryCache;
}(cache/* ApolloCache */.R));

//# sourceMappingURL=inMemoryCache.js.map

/***/ }),

/***/ 80900:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ canonicalStringify; },
/* harmony export */   "h": function() { return /* binding */ ObjectCanon; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var _wry_trie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75028);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13154);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30320);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21436);





function shallowCopy(value) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
        return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .k)(value)
            ? value.slice(0)
            : (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
var ObjectCanon = (function () {
    function ObjectCanon() {
        this.known = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakSet */ .sy ? WeakSet : Set)();
        this.pool = new _wry_trie__WEBPACK_IMPORTED_MODULE_1__/* .Trie */ .B(_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakMap */ .mr);
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, node.keys = { sorted: keys, json: json });
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

var canonicalStringify = Object.assign(function (value) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
        if (stringifyCanon === void 0) {
            resetCanonicalStringify();
        }
        var canonical = stringifyCanon.admit(value);
        var json = stringifyCache.get(canonical);
        if (json === void 0) {
            stringifyCache.set(canonical, json = JSON.stringify(canonical));
        }
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: resetCanonicalStringify,
});
var stringifyCanon;
var stringifyCache;
function resetCanonicalStringify() {
    stringifyCanon = new ObjectCanon;
    stringifyCache = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakMap */ .mr ? WeakMap : Map)();
}
//# sourceMappingURL=object-canon.js.map

/***/ }),

/***/ 66438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ makeVar; },
/* harmony export */   "_v": function() { return /* binding */ recallCache; },
/* harmony export */   "ab": function() { return /* binding */ cacheSlot; },
/* harmony export */   "li": function() { return /* binding */ forgetCache; }
/* harmony export */ });
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94092);
/* harmony import */ var _wry_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70093);


var cacheSlot = new _wry_context__WEBPACK_IMPORTED_MODULE_1__/* .Slot */ .g7();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, info = {
            vars: new Set,
            dep: (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .dep */ .dP)(),
        });
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    getCacheInfo(cache).dep.dirty(rv);
                    broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map

/***/ }),

/***/ 65075:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ApolloClient; }
});

// UNUSED EXPORTS: mergeOptions

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(48964);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(48702);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/execute.js
var execute = __webpack_require__(47037);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/version.js
var version = '3.7.17';
//# sourceMappingURL=version.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/HttpLink.js
var HttpLink = __webpack_require__(72198);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/index.js
var lib = __webpack_require__(30020);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/incrementalResult.js
var incrementalResult = __webpack_require__(37280);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/object-canon.js
var object_canon = __webpack_require__(80900);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/asyncMap.js

function asyncMap(observable, mapFn, catchFn) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, delegate) {
            if (examiner) {
                return function (arg) {
                    ++activeCallbackCount;
                    var both = function () { return examiner(arg); };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) {
                        --activeCallbackCount;
                        next && next.call(observer, result);
                        if (completed) {
                            handler.complete();
                        }
                    }, function (error) {
                        --activeCallbackCount;
                        throw error;
                    }).catch(function (caught) {
                        error && error.call(observer, caught);
                    });
                };
            }
            else {
                return function (arg) { return delegate && delegate.call(observer, arg); };
            }
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function () {
                completed = true;
                if (!activeCallbackCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/errorHandling.js


function graphQLResultHasError(result) {
    var errors = getGraphQLErrorsFromResult(result);
    return (0,arrays/* isNonEmptyArray */.O)(errors);
}
function getGraphQLErrorsFromResult(result) {
    var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors)
        ? result.errors.slice(0)
        : [];
    if ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) &&
        (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
        result.incremental.forEach(function (incrementalResult) {
            if (incrementalResult.errors) {
                graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
            }
        });
    }
    return graphQLErrors;
}
//# sourceMappingURL=errorHandling.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(76487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(19065);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(13154);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/makeUniqueId.js
var makeUniqueId = __webpack_require__(60897);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/observables/iteration.js
var iteration = __webpack_require__(18263);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/observables/subclassing.js
var subclassing = __webpack_require__(86403);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/Concast.js




function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var Concast = (function (_super) {
    (0,tslib_es6.__extends)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    (0,iteration/* iterateObserversSafely */.p)(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0,iteration/* iterateObserversSafely */.p)(_this.observers, "error", error);
                }
            },
            complete: function () {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    var value = sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest &&
                            _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        (0,iteration/* iterateObserversSafely */.p)(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return _this.sub = obs.subscribe(_this.handlers); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function (_) { });
        if (typeof sources === "function") {
            sources = [new zen_observable_ts_module/* Observable */.y(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            if (this.sub === null &&
                nextOrError === "next" &&
                observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) &&
            this.observers.size < 1) {
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(zen_observable_ts_module/* Observable */.y));

(0,subclassing/* fixObservableSubclass */.D)(Concast);
//# sourceMappingURL=Concast.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ObservableQuery.js
var ObservableQuery = __webpack_require__(44780);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(1644);
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
;// CONCATENATED MODULE: ./node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}
function isExecutableDefinitionNode(node) {
  return node.kind === Kind.OPERATION_DEFINITION || node.kind === Kind.FRAGMENT_DEFINITION;
}
function isSelectionNode(node) {
  return node.kind === kinds/* Kind.FIELD */.h.FIELD || node.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD || node.kind === kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT;
}
function isValueNode(node) {
  return node.kind === Kind.VARIABLE || node.kind === Kind.INT || node.kind === Kind.FLOAT || node.kind === Kind.STRING || node.kind === Kind.BOOLEAN || node.kind === Kind.NULL || node.kind === Kind.ENUM || node.kind === Kind.LIST || node.kind === Kind.OBJECT;
}
function isTypeNode(node) {
  return node.kind === Kind.NAMED_TYPE || node.kind === Kind.LIST_TYPE || node.kind === Kind.NON_NULL_TYPE;
}
function isTypeSystemDefinitionNode(node) {
  return node.kind === Kind.SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === Kind.DIRECTIVE_DEFINITION;
}
function isTypeDefinitionNode(node) {
  return node.kind === Kind.SCALAR_TYPE_DEFINITION || node.kind === Kind.OBJECT_TYPE_DEFINITION || node.kind === Kind.INTERFACE_TYPE_DEFINITION || node.kind === Kind.UNION_TYPE_DEFINITION || node.kind === Kind.ENUM_TYPE_DEFINITION || node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION;
}
function isTypeSystemExtensionNode(node) {
  return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return node.kind === Kind.SCALAR_TYPE_EXTENSION || node.kind === Kind.OBJECT_TYPE_EXTENSION || node.kind === Kind.INTERFACE_TYPE_EXTENSION || node.kind === Kind.UNION_TYPE_EXTENSION || node.kind === Kind.ENUM_TYPE_EXTENSION || node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION;
}

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/fragments.js
var graphql_fragments = __webpack_require__(23361);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(66438);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/LocalState.js





var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if ((0,directives/* hasDirectives */.FS)(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return (0,transform/* removeClientSetsFromDocument */.ob)(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { cache: cache, getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, variables), data.exportedVariables)); })];
                }
                return [2, (0,tslib_es6.__assign)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        (0,visitor/* visit */.Vn)(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return visitor/* BREAK */.$_;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: (0,transform/* buildQueryFromSelectionSet */.aL)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0,tslib_es6.__generator)(this, function (_b) {
                mainDefinition = (0,getFromAST/* getMainDefinition */.p$)(document);
                fragments = (0,getFromAST/* getFragmentDefinitions */.kU)(document);
                fragmentMap = (0,graphql_fragments/* createFragmentMap */.F)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation
                    ? definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                isClientFieldDescendant = false;
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6.__generator)(this, function (_a) {
                        if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) {
                            return [2];
                        }
                        if (!(0,directives/* shouldInclude */.LZ)(selection, variables)) {
                            return [2];
                        }
                        if ((0,storeUtils/* isField */.My)(selection)) {
                            return [2, this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[(0,storeUtils/* resultKeyNameFromField */.u2)(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if ((0,storeUtils/* isInlineFragment */.Ao)(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                            __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(selection.name.value)) : (0,globals/* invariant */.kG)(fragment, 11);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return (0,mergeDeep/* mergeDeepArray */.bw)(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                if (!rootValue) {
                    return [2, null];
                }
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, resolve, [
                                rootValue,
                                (0,storeUtils/* argumentsObjectFromField */.NC)(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        var _a, _b;
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function (d) { return d.name.value === 'client'; })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
            }
        }));
    };
    LocalState.prototype.collectSelectionsToResolve = function (mainDefinition, fragmentMap) {
        var isSingleASTNode = function (node) { return !Array.isArray(node); };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0,visitor/* visit */.Vn)(definitionNode, {
                    Directive: function (node, _, __, ___, ancestors) {
                        if (node.name.value === 'client') {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                        }
                    },
                    FragmentSpread: function (spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(spread.name.value)) : (0,globals/* invariant */.kG)(fragment, 12);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function (selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/QueryInfo.js







;
var destructiveMethodCounts = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var QueryInfo = (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading;
        if (this.variables &&
            this.networkStatus !== core_networkStatus/* NetworkStatus.loading */.I.loading &&
            !(0,lib/* equal */.D)(this.variables, query.variables)) {
            networkStatus = core_networkStatus/* NetworkStatus.setVariables */.I.setVariables;
        }
        if (!(0,lib/* equal */.D)(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function (variables) {
        if (variables === void 0) { variables = this.variables; }
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0,lib/* equal */.D)(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions(),
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty &&
            !(0,lib/* equal */.D)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    oq["observe"]();
                }
                else {
                    (0,ObservableQuery/* reobserveCacheFirst */.vj)(oq);
                }
            });
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if ((0,core_networkStatus/* isNetworkRequestInFlight */.O)(this.networkStatus) &&
            this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" &&
                fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch ||
            !(0,lib/* equal */.D)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            (0,lib/* equal */.D)(variables, lastWrite.variables) &&
            (0,lib/* equal */.D)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new mergeDeep/* DeepMerger */.w0();
        var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors)
            ? result.errors.slice(0)
            : [];
        this.reset();
        if ('incremental' in result && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
            var mergedData = (0,incrementalResult/* mergeIncrementalData */.mT)(this.getDiff().result, result);
            result.data = mergedData;
        }
        else if ('hasNext' in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === 'no-cache') {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        if (_this.lastDiff &&
                            _this.lastDiff.diff.complete) {
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    if (!_this.stopped) {
                        _this.updateWatch(options.variables);
                    }
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return this.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" ||
        errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/QueryManager.js














var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('QueryManager stopped while query was in flight') : new globals/* InvariantError */.ej(14));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return (0,tslib_es6.__generator)(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        __DEV__ ? (0,globals/* invariant */.kG)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : (0,globals/* invariant */.kG)(mutation, 15);
                        __DEV__ ? (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', 16);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_j.sent());
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { optimisticResponse: optimisticResponse }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                        throw new client_errors/* ApolloError */.cA({
                                            graphQLErrors: getGraphQLErrorsFromResult(result),
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0,tslib_es6.__assign)({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === 'ignore' &&
                                        graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        if (!('hasNext' in storeResult) || storeResult.hasNext === false) {
                                            resolve(storeResult);
                                        }
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof client_errors/* ApolloError */.cA ? err : new client_errors/* ApolloError */.cA({
                                            networkError: err,
                                        }));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            if (!(0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result)) {
                cacheWrites.push({
                    result: result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables,
                });
            }
            if ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    query: this.transform(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true,
                });
                var mergedData = void 0;
                if (diff.result) {
                    mergedData = (0,incrementalResult/* mergeIncrementalData */.mT)(diff.result, result);
                }
                if (typeof mergedData !== 'undefined') {
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: 'ROOT_MUTATION',
                        query: mutation.document,
                        variables: mutation.variables,
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: document && (0,getFromAST/* getOperationName */.rY)(document) || void 0,
                            queryVariables: variables,
                        });
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            mutation.refetchQueries ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    var update = mutation.update;
                    var isFinalResult = !(0,incrementalResult/* isExecutionPatchResult */.M0)(result) ||
                        ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) && !result.hasNext);
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete) {
                                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { data: diff.result });
                                if ('incremental' in result) {
                                    delete result.incremental;
                                }
                                if ('hasNext' in result) {
                                    delete result.hasNext;
                                }
                            }
                        }
                        if (isFinalResult) {
                            update(cache, result, {
                                context: mutation.context,
                                variables: mutation.variables,
                            });
                        }
                    }
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) {
                        cache.modify({
                            id: 'ROOT_MUTATION',
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function"
            ? optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                __DEV__ && globals/* invariant.error */.kG.error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = (0,transform/* removeConnectionDirectiveFromDocument */.Fo)(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0,directives/* hasClientExports */.mj)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getOperationDefinition */.$H)(transformed)),
                asQuery: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, transformed), { definitions: transformed.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, def), { operation: "query" });
                        }
                        return def;
                    }) })
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { variables: this.getVariables(options.query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery/* ObservableQuery */.ue({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        __DEV__ ? (0,globals/* invariant */.kG)(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.') : (0,globals/* invariant */.kG)(options.query, 17);
        __DEV__ ? (0,globals/* invariant */.kG)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : (0,globals/* invariant */.kG)(options.query.kind === 'Document', 18);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.returnPartialData, 19);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.pollInterval, 20);
        return this.fetchQuery(queryId, options).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('Store reset while query was in flight (not completed in link chain)') : new globals/* InvariantError */.ej(21));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                queryInfo.networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if ((0,storeUtils/* isDocumentNode */.JW)(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc).document, false);
                }
                else if ((0,objects/* isNonNullObject */.s)(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                var queryId = (0,makeUniqueId/* makeUniqueId */.X)("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery/* ObservableQuery */.ue({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: "network-only" }),
                });
                (0,globals/* invariant */.kG)(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (__DEV__ && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    __DEV__ && globals/* invariant.warn */.kG.warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" &&
                    fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== 'no-cache') {
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: 'ROOT_SUBSCRIPTION',
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                var hasErrors = graphQLResultHasError(result);
                var hasProtocolErrors = (0,client_errors/* graphQLResultHasProtocolErrors */.ls)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) {
                        errors.graphQLErrors = result.errors;
                    }
                    if (hasProtocolErrors) {
                        errors.protocolErrors = result.extensions[client_errors/* PROTOCOL_ERRORS_SYMBOL */.YG];
                    }
                    throw new client_errors/* ApolloError */.cA(errors);
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new zen_observable_ts_module/* Observable */.y(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0,getFromAST/* getOperationName */.rY)(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = (0,object_canon/* canonicalStringify */.B)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new Concast([
                        (0,execute/* execute */.h)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function () {
                        if (byVariables_1.delete(varJson_1) &&
                            byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(serverQuery);
                        }
                    });
                }
            }
            else {
                observable = new Concast([
                    (0,execute/* execute */.h)(link, operation)
                ]);
            }
        }
        else {
            observable = new Concast([
                zen_observable_ts_module/* Observable.of */.y.of({ data: {} })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = getGraphQLErrorsFromResult(result);
            var hasErrors = graphQLErrors.length > 0;
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    throw queryInfo.markError(new client_errors/* ApolloError */.cA({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: core_networkStatus/* NetworkStatus.ready */.I.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
            }
            return aqr;
        }, function (networkError) {
            var error = (0,client_errors/* isApolloError */.MS)(networkError)
                ? networkError
                : new client_errors/* ApolloError */.cA({ networkError: networkError });
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast;
    };
    QueryManager.prototype.fetchConcastWithInfo = function (queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading; }
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" &&
                sourcesWithInfo.sources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return sourcesWithInfo;
        };
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast, containsDataFromLink;
        if (this.transform(normalized.query).hasClientExports) {
            concast = new Concast(this.localState
                .addExportedVariables(normalized.query, normalized.variables, normalized.context)
                .then(fromVariables).then(function (sourcesWithInfo) { return sourcesWithInfo.sources; }));
            containsDataFromLink = true;
        }
        else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new Concast(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink,
        };
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0,makeUniqueId/* makeUniqueId */.X)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map;
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                optimistic: optimistic && removeOptimistic || false,
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo &&
                        watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                result = oq.refetch();
                            }
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset();
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(variables); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading; }
            var data = diff.result;
            if (__DEV__ &&
                !returnPartialData &&
                !(0,lib/* equal */.D)(data, {})) {
                (0,ObservableQuery/* logMissingFieldErrors */.DC)(diff.missing);
            }
            var fromData = function (data) { return zen_observable_ts_module/* Observable.of */.y.of((0,tslib_es6.__assign)({ data: data, loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true }))); };
            if (data && _this.transform(query).hasForcedResolvers) {
                return _this.localState.runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                }).then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            if (errorPolicy === 'none' &&
                networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch &&
                Array.isArray(diff.missing)) {
                return fromData(void 0);
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 :
            (networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch &&
                refetchWritePolicy !== "merge") ? 1
                : 2;
        var resultsFromLink = function () { return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
            variables: variables,
            context: context,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
        }); };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return { fromLink: false, sources: [resultsFromCache(diff, queryInfo.markReady())] };
                }
                if (returnPartialData || shouldNotify) {
                    return { fromLink: true, sources: [resultsFromCache(diff), resultsFromLink()] };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return { fromLink: true, sources: [resultsFromCache(diff), resultsFromLink()] };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-only":
                return { fromLink: false, sources: [resultsFromCache(readCache(), queryInfo.markReady())] };
            case "network-only":
                if (shouldNotify) {
                    return { fromLink: true, sources: [resultsFromCache(readCache()), resultsFromLink()] };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "no-cache":
                if (shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [
                            resultsFromCache(queryInfo.getDiff()),
                            resultsFromLink(),
                        ],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "standby":
                return { fromLink: false, sources: [] };
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/ApolloClient.js







var hasSuggestedDevtools = false;


var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' &&
            !window.__APOLLO_CLIENT__ &&
            __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link = uri
                ? new HttpLink/* HttpLink */.u({ uri: uri, credentials: credentials, headers: headers })
                : ApolloLink/* ApolloLink.empty */.i.empty();
        }
        if (!cache) {
            throw __DEV__ ? new globals/* InvariantError */.ej("To initialize Apollo Client, you must specify a 'cache' property " +
                "in the options object. \n" +
                "For more information, please visit: https://go.apollo.dev/c/docs") : new globals/* InvariantError */.ej(9);
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && connectToDevTools && __DEV__) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self &&
                !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) {
                        url = "https://chrome.google.com/webstore/detail/" +
                            "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    }
                    else if (ua.indexOf("Firefox/") > -1) {
                        url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                }
                if (url) {
                    __DEV__ && globals/* invariant.log */.kG.log("Download the Apollo DevTools for a better development " +
                        "experience: " + url);
                }
            }
        }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.getQueryStore(),
                            mutations: _this.queryManager.mutationStore || {},
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            } : void 0,
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.query, options);
        }
        __DEV__ ? (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.') : (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return (0,execute/* execute */.h)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: false,
        }); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: true,
        }); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function (error) {
            __DEV__ && globals/* invariant.debug */.kG.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

//# sourceMappingURL=ApolloClient.js.map

/***/ }),

/***/ 44780:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DC": function() { return /* binding */ logMissingFieldErrors; },
/* harmony export */   "ue": function() { return /* binding */ ObservableQuery; },
/* harmony export */   "vj": function() { return /* binding */ reobserveCacheFirst; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30020);
/* harmony import */ var _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1644);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36765);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79487);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21436);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53712);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18263);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48216);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86403);





var assign = Object.assign, hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            if (first) {
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? (fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy) : _f;
        _this.options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { initialFetchPolicy: initialFetchPolicy, fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .getOperationDefinition */ .$H)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function () {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.ready */ .I.ready;
        var result = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, lastResult), { loading: (0,_networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .isNetworkRequestInFlight */ .O)(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (skipCacheDataFor(fetchPolicy) ||
            this.queryManager.transform(this.options.query).hasForcedResolvers) {
        }
        else if (this.waitForOwnResult) {
            this.queryInfo['updateWatch']();
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if ((0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                delete result.partial;
                if (diff.complete &&
                    result.networkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.loading */ .I.loading &&
                    (fetchPolicy === 'cache-first' ||
                        fetchPolicy === 'cache-only')) {
                    result.networkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.ready */ .I.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (__DEV__ &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult, variables) {
        return (!this.last ||
            !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.last.result, newResult) ||
            (variables && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.last.variables, variables)));
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || (0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0,
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === 'no-cache') {
            reobserveOptions.fetchPolicy = 'no-cache';
        }
        else {
            reobserveOptions.fetchPolicy = 'network-only';
        }
        if (__DEV__ && variables && hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .getQueryDefinition */ .iW)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
            }
        }
        if (variables && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.options.variables, variables)) {
            reobserveOptions.variables = this.options.variables = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.refetch */ .I.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, (fetchMoreOptions.query ? fetchMoreOptions : (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.options), { query: this.query }), fetchMoreOptions), { variables: (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.options.variables), fetchMoreOptions.variables) }))), { fetchPolicy: "no-cache" });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore).then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) { return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables,
                        }); });
                    }
                    else {
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        }).finally(function () {
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function (variables) {
        if ((0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.variables, variables)) {
            return this.observers.size
                ? this.result()
                : Promise.resolve();
        }
        this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.setVariables */ .I.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") {
            }
            else if (typeof options.nextFetchPolicy === "function") {
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager['fetchConcastWithInfo'](this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo &&
            pollingInfo.interval === pollInterval) {
            return;
        }
        __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(pollInterval, 'Attempted to start a polling query without a polling interval.') : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(pollInterval, 13);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (!(0,_networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .isNetworkRequestInFlight */ .O)(_this.queryInfo.networkStatus)) {
                    _this.reobserve({
                        fetchPolicy: _this.options.initialFetchPolicy === 'no-cache' ? 'no-cache' : 'network-only',
                    }, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.poll */ .I.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
            ;
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        this.last = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.last), { result: this.queryManager.assumeImmutableResults
                ? newResult
                : (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .cloneDeep */ .X)(newResult), variables: variables });
        if (!(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isNonEmptyArray */ .O)(newResult.errors)) {
            delete this.last.error;
        }
        return this.last;
    };
    ObservableQuery.prototype.reobserveAsConcast = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.refetch */ .I.refetch ||
            newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore ||
            newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.poll */ .I.poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_7__/* .compact */ .o)(this.options, newOptions || {});
        var options = useDisposableConcast
            ? mergedOptions
            : assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions &&
                newOptions.variables &&
                !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(newOptions.variables, oldVariables) &&
                options.fetchPolicy !== "standby" &&
                options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.setVariables */ .I.setVariables;
                }
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function () {
            if (_this.concast === concast) {
                _this.waitForOwnResult = false;
            }
        };
        var variables = options.variables && (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function (result) {
                finishWaitingForOwnResult();
                _this.reportResult(result, variables);
            },
            error: function (error) {
                finishWaitingForOwnResult();
                _this.reportError(error, variables);
            },
        };
        if (!useDisposableConcast && fromLink) {
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.observe = function () {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result, variables)) {
            if (lastError || !result.partial || this.options.returnPartialData) {
                this.updateLastResult(result, variables);
            }
            (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .iterateObserversSafely */ .p)(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        var errorResult = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.error */ .I.error, loading: false });
        this.updateLastResult(errorResult, variables);
        (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .iterateObserversSafely */ .p)(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}(_utilities_index_js__WEBPACK_IMPORTED_MODULE_9__/* .Observable */ .y));

(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_10__/* .fixObservableSubclass */ .D)(ObservableQuery);
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" ||
        fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            nextFetchPolicy: function () {
                this.nextFetchPolicy = nextFetchPolicy;
                if (typeof nextFetchPolicy === "function") {
                    return nextFetchPolicy.apply(this, arguments);
                }
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error('Unhandled error', error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (__DEV__ && missing) {
        __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.debug */ .kG.debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
    }
}
function skipCacheDataFor(fetchPolicy) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}
//# sourceMappingURL=ObservableQuery.js.map

/***/ }),

/***/ 42451:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ApolloCache": function() { return /* reexport */ cache/* ApolloCache */.R; },
  "ApolloClient": function() { return /* reexport */ ApolloClient/* ApolloClient */.f; },
  "ApolloError": function() { return /* reexport */ errors/* ApolloError */.cA; },
  "ApolloLink": function() { return /* reexport */ ApolloLink/* ApolloLink */.i; },
  "Cache": function() { return /* reexport */ Cache; },
  "HttpLink": function() { return /* reexport */ http.HttpLink; },
  "InMemoryCache": function() { return /* reexport */ inMemoryCache/* InMemoryCache */.h; },
  "MissingFieldError": function() { return /* reexport */ common/* MissingFieldError */.y; },
  "NetworkStatus": function() { return /* reexport */ networkStatus/* NetworkStatus */.I; },
  "Observable": function() { return /* reexport */ zen_observable_ts_module/* Observable */.y; },
  "ObservableQuery": function() { return /* reexport */ ObservableQuery/* ObservableQuery */.ue; },
  "checkFetcher": function() { return /* reexport */ http.checkFetcher; },
  "concat": function() { return /* reexport */ concat; },
  "createHttpLink": function() { return /* reexport */ http.createHttpLink; },
  "createSignalIfSupported": function() { return /* reexport */ http.createSignalIfSupported; },
  "defaultDataIdFromObject": function() { return /* reexport */ helpers/* defaultDataIdFromObject */.uG; },
  "defaultPrinter": function() { return /* reexport */ http.defaultPrinter; },
  "disableExperimentalFragmentVariables": function() { return /* reexport */ lib/* disableExperimentalFragmentVariables */.J9; },
  "disableFragmentWarnings": function() { return /* reexport */ lib/* disableFragmentWarnings */._t; },
  "empty": function() { return /* reexport */ empty; },
  "enableExperimentalFragmentVariables": function() { return /* reexport */ lib/* enableExperimentalFragmentVariables */.wO; },
  "execute": function() { return /* reexport */ execute/* execute */.h; },
  "fallbackHttpConfig": function() { return /* reexport */ http.fallbackHttpConfig; },
  "from": function() { return /* reexport */ from; },
  "fromError": function() { return /* reexport */ fromError/* fromError */.Q; },
  "fromPromise": function() { return /* reexport */ fromPromise; },
  "gql": function() { return /* reexport */ lib/* gql */.Ps; },
  "isApolloError": function() { return /* reexport */ errors/* isApolloError */.MS; },
  "isReference": function() { return /* reexport */ storeUtils/* isReference */.Yk; },
  "makeReference": function() { return /* reexport */ storeUtils/* makeReference */.kQ; },
  "makeVar": function() { return /* reexport */ reactiveVars/* makeVar */.QS; },
  "mergeOptions": function() { return /* reexport */ mergeOptions/* mergeOptions */.J; },
  "parseAndCheckHttpResponse": function() { return /* reexport */ http.parseAndCheckHttpResponse; },
  "resetCaches": function() { return /* reexport */ lib/* resetCaches */.HW; },
  "rewriteURIForGET": function() { return /* reexport */ http.rewriteURIForGET; },
  "selectHttpOptionsAndBody": function() { return /* reexport */ http.selectHttpOptionsAndBody; },
  "selectHttpOptionsAndBodyInternal": function() { return /* reexport */ http.selectHttpOptionsAndBodyInternal; },
  "selectURI": function() { return /* reexport */ http.selectURI; },
  "serializeFetchParameter": function() { return /* reexport */ http.serializeFetchParameter; },
  "setLogVerbosity": function() { return /* reexport */ invariant/* setVerbosity */.U6; },
  "split": function() { return /* reexport */ split; },
  "throwServerError": function() { return /* reexport */ throwServerError/* throwServerError */.P; },
  "toPromise": function() { return /* reexport */ toPromise; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(48964);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 8 modules
var ApolloClient = __webpack_require__(65075);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ObservableQuery.js
var ObservableQuery = __webpack_require__(44780);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(1644);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/core/types/Cache.js
var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/core/cache.js
var cache = __webpack_require__(11294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(55598);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/core/types/common.js
var common = __webpack_require__(75727);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/helpers.js
var helpers = __webpack_require__(49641);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(66438);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(48702);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/empty.js

var empty = ApolloLink/* ApolloLink.empty */.i.empty;
//# sourceMappingURL=empty.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/from.js

var from = ApolloLink/* ApolloLink.from */.i.from;
//# sourceMappingURL=from.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/split.js

var split = ApolloLink/* ApolloLink.split */.i.split;
//# sourceMappingURL=split.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/concat.js

var concat = ApolloLink/* ApolloLink.concat */.i.concat;
//# sourceMappingURL=concat.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/execute.js
var execute = __webpack_require__(47037);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/index.js








//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/index.js
var http = __webpack_require__(85645);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/toPromise.js

function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    __DEV__ && globals/* invariant.warn */.kG.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
//# sourceMappingURL=toPromise.js.map
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/fromPromise.js

function fromPromise(promise) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
//# sourceMappingURL=fromPromise.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/utils/fromError.js
var fromError = __webpack_require__(16261);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = __webpack_require__(12782);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(66128);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 9 modules
var lib = __webpack_require__(22865);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/index.js














(0,invariant/* setVerbosity */.U6)(globals/* DEV */.Rk ? "log" : "silent");

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1644:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "O": function() { return /* binding */ isNetworkRequestInFlight; }
/* harmony export */ });
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),

/***/ 30990:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ isApolloError; },
/* harmony export */   "YG": function() { return /* binding */ PROTOCOL_ERRORS_SYMBOL; },
/* harmony export */   "cA": function() { return /* binding */ ApolloError; },
/* harmony export */   "ls": function() { return /* binding */ graphQLResultHasProtocolErrors; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13154);



var PROTOCOL_ERRORS_SYMBOL = Symbol();
function graphQLResultHasProtocolErrors(result) {
    if (result.extensions) {
        return Array.isArray(result.extensions[PROTOCOL_ERRORS_SYMBOL]);
    }
    return false;
}
function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var errors = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError)
        errors.push(err.networkError);
    return errors
        .map(function (err) { return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(err) && err.message || 'Error message not found.'; })
        .join('\n');
};
var ApolloError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = 'ApolloError';
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 48702:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ ApolloLink; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(48964);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6.__assign)({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6.__assign)({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? (0,getFromAST/* getOperationName */.rY)(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw __DEV__ ? new globals/* InvariantError */.ej("illegal argument: ".concat(key)) : new globals/* InvariantError */.ej(27);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js




function passthrough(op, forward) {
    return (forward ? forward(op) : zen_observable_ts_module/* Observable.of */.y.of());
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var LinkError = (function (_super) {
    (0,tslib_es6.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return zen_observable_ts_module/* Observable.of */.y.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation)
                    ? leftLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation)
                    ? leftLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || zen_observable_ts_module/* Observable.of */.y.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            __DEV__ && globals/* invariant.warn */.kG.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts_module/* Observable.of */.y.of(); }) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || zen_observable_ts_module/* Observable.of */.y.of();
                }) || zen_observable_ts_module/* Observable.of */.y.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw __DEV__ ? new globals/* InvariantError */.ej('request is not implemented') : new globals/* InvariantError */.ej(22);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map

/***/ }),

/***/ 47037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ execute; }
/* harmony export */ });
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48702);

var execute = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.execute */ .i.execute;
//# sourceMappingURL=execute.js.map

/***/ }),

/***/ 72198:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ HttpLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48702);
/* harmony import */ var _createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34747);



var HttpLink = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, (0,_createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__/* .createHttpLink */ .L)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_2__/* .ApolloLink */ .i));

//# sourceMappingURL=HttpLink.js.map

/***/ }),

/***/ 23178:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ checkFetcher; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        throw __DEV__ ? new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(23);
    }
};
//# sourceMappingURL=checkFetcher.js.map

/***/ }),

/***/ 34747:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ createHttpLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77304);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48702);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19065);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48216);
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15049);
/* harmony import */ var _selectURI_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11037);
/* harmony import */ var _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93227);
/* harmony import */ var _checkFetcher_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23178);
/* harmony import */ var _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58995);
/* harmony import */ var _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77388);
/* harmony import */ var _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88663);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16261);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36765);















var backupFetch = (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultPrinter */ .sb : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (__DEV__) {
        (0,_checkFetcher_js__WEBPACK_IMPORTED_MODULE_3__/* .checkFetcher */ .U)(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new _core_index_js__WEBPACK_IMPORTED_MODULE_4__/* .ApolloLink */ .i(function (operation) {
        var chosenURI = (0,_selectURI_js__WEBPACK_IMPORTED_MODULE_5__/* .selectURI */ .r)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = (0,_selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .selectHttpOptionsAndBodyInternal */ .ve)(operation, print, _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .fallbackHttpConfig */ .SC, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0,graphql__WEBPACK_IMPORTED_MODULE_6__/* .visit */ .Vn)(operation.query, {
                Variable: function (node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') {
                        unusedNames_1.delete(node.name.value);
                    }
                },
            });
            if (unusedNames_1.size) {
                body.variables = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, body.variables);
                unusedNames_1.forEach(function (name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = (0,_createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_7__/* .createSignalIfSupported */ .$)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        var definitionIsSubscription = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'subscription';
        };
        var isSubscription = definitionIsSubscription((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .getMainDefinition */ .p$)(operation.query));
        var hasDefer = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_9__/* .hasDirectives */ .FS)(['defer'], operation.query);
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            if (isSubscription && hasDefer) {
                __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn("Multipart-subscriptions do not support @defer");
            }
            if (isSubscription) {
                acceptHeader += 'boundary=graphql;subscriptionSpec=1.0,application/json';
            }
            else if (hasDefer) {
                acceptHeader += 'deferSpec=20220824,application/json';
            }
            options.headers.accept = acceptHeader;
        }
        if (options.method === 'GET') {
            var _d = (0,_rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_10__/* .rewriteURIForGET */ .H)(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_11__/* .fromError */ .Q)(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_12__/* .serializeFetchParameter */ .g)(body, 'Payload');
            }
            catch (parseError) {
                return (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_11__/* .fromError */ .Q)(parseError);
            }
        }
        return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_13__/* .Observable */ .y(function (observer) {
            var currentFetch = preferredFetch || (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return fetch; }) || backupFetch;
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_14__/* .readMultipartBody */ .TF)(response, observer);
                }
                else {
                    return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_14__/* .readJsonBody */ .Wm)(response, operation, observer);
                }
            })
                .catch(function (err) { return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_14__/* .handleError */ .S3)(err, observer); });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map

/***/ }),

/***/ 77388:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ createSignalIfSupported; }
/* harmony export */ });
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map

/***/ }),

/***/ 85645:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HttpLink": function() { return /* reexport safe */ _HttpLink_js__WEBPACK_IMPORTED_MODULE_8__.u; },
/* harmony export */   "checkFetcher": function() { return /* reexport safe */ _checkFetcher_js__WEBPACK_IMPORTED_MODULE_4__.U; },
/* harmony export */   "createHttpLink": function() { return /* reexport safe */ _createHttpLink_js__WEBPACK_IMPORTED_MODULE_7__.L; },
/* harmony export */   "createSignalIfSupported": function() { return /* reexport safe */ _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_5__.$; },
/* harmony export */   "defaultPrinter": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.sb; },
/* harmony export */   "fallbackHttpConfig": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.SC; },
/* harmony export */   "parseAndCheckHttpResponse": function() { return /* reexport safe */ _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_1__.dO; },
/* harmony export */   "rewriteURIForGET": function() { return /* reexport safe */ _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__.H; },
/* harmony export */   "selectHttpOptionsAndBody": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.E4; },
/* harmony export */   "selectHttpOptionsAndBodyInternal": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.ve; },
/* harmony export */   "selectURI": function() { return /* reexport safe */ _selectURI_js__WEBPACK_IMPORTED_MODULE_6__.r; },
/* harmony export */   "serializeFetchParameter": function() { return /* reexport safe */ _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_2__.g; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93227);
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15049);
/* harmony import */ var _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58995);
/* harmony import */ var _checkFetcher_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23178);
/* harmony import */ var _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77388);
/* harmony import */ var _selectURI_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11037);
/* harmony import */ var _createHttpLink_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34747);
/* harmony import */ var _HttpLink_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72198);
/* harmony import */ var _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88663);










//# sourceMappingURL=index.js.map

/***/ }),

/***/ 93227:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S3": function() { return /* binding */ handleError; },
  "dO": function() { return /* binding */ parseAndCheckHttpResponse; },
  "Wm": function() { return /* binding */ readJsonBody; },
  "TF": function() { return /* binding */ readMultipartBody; }
});

// UNUSED EXPORTS: parseHeaders, parseJsonBody

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/responseIterator.js

function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUse/* canUseAsyncIteratorSymbol */.DN &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
//# sourceMappingURL=responseIterator.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/async.js
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/nodeStream.js

function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=nodeStream.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/promise.js

function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=promise.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/reader.js

function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=reader.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/responseIterator.js





function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
//# sourceMappingURL=responseIterator.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = __webpack_require__(12782);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/incrementalResult.js
var incrementalResult = __webpack_require__(37280);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js





var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, observer) {
    var _a, _b, _c, _d, _e;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _f, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _g, _h;
        return (0,tslib_es6.__generator)(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter))
                        ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _j.label = 1;
                case 1:
                    if (!running) return [3, 3];
                    return [4, iterator.next()];
                case 2:
                    _f = _j.sent(), value = _f.value, done = _f.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while (bi > -1) {
                        message = void 0;
                        _g = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _g[0], buffer = _g[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = parseHeaders(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 &&
                            contentType_1.toLowerCase().indexOf("application/json") === -1) {
                            throw new Error("Unsupported patch content type: application/json is required.");
                        }
                        body = message.slice(i);
                        if (body) {
                            try {
                                result = parseJsonBody(response, body);
                                if (Object.keys(result).length > 1 ||
                                    "data" in result ||
                                    "incremental" in result ||
                                    "errors" in result ||
                                    "payload" in result) {
                                    if ((0,incrementalResult/* isApolloPayloadResult */.yU)(result)) {
                                        next = {};
                                        if ("payload" in result) {
                                            next = (0,tslib_es6.__assign)({}, result.payload);
                                        }
                                        if ("errors" in result) {
                                            next = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, next), { extensions: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ("extensions" in next ? next.extensions : null)), (_h = {}, _h[errors/* PROTOCOL_ERRORS_SYMBOL */.YG] = result.errors, _h)) });
                                        }
                                        (_b = observer.next) === null || _b === void 0 ? void 0 : _b.call(observer, next);
                                    }
                                    else {
                                        (_c = observer.next) === null || _c === void 0 ? void 0 : _c.call(observer, result);
                                    }
                                }
                                else if (Object.keys(result).length === 1 &&
                                    "hasNext" in result &&
                                    !result.hasNext) {
                                    (_d = observer.complete) === null || _d === void 0 ? void 0 : _d.call(observer);
                                }
                            }
                            catch (err) {
                                handleError(err, observer);
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3, 1];
                case 3:
                    (_e = observer.complete) === null || _e === void 0 ? void 0 : _e.call(observer);
                    return [2];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        (0,throwServerError/* throwServerError */.P)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    var _a, _b;
    if (err.name === "AbortError")
        return;
    if (err.result && err.result.errors && err.result.data) {
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, err.result);
    }
    (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, err);
}
function readJsonBody(response, operation, observer) {
    parseAndCheckHttpResponse(operation)(response)
        .then(function (result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 ? void 0 : _b.call(observer);
    })
        .catch(function (err) { return handleError(err, observer); });
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (response.status >= 300) {
                (0,throwServerError/* throwServerError */.P)(response, result, "Response not successful: Received status code ".concat(response.status));
            }
            if (!Array.isArray(result) &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "data") &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "errors")) {
                (0,throwServerError/* throwServerError */.P)(response, result, "Server response was missing for query '".concat(Array.isArray(operations)
                    ? operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map

/***/ }),

/***/ 88663:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ rewriteURIForGET; }
/* harmony export */ });
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15049);

function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__/* .serializeFetchParameter */ .g)(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__/* .serializeFetchParameter */ .g)(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map

/***/ }),

/***/ 58995:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sb": function() { return /* binding */ defaultPrinter; },
  "SC": function() { return /* binding */ fallbackHttpConfig; },
  "E4": function() { return /* binding */ selectHttpOptionsAndBody; },
  "ve": function() { return /* binding */ selectHttpOptionsAndBodyInternal; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/printer.mjs


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap('', alias, ': ') + name;
    var argsLine = prefix + wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0,blockString/* printBlockString */.LZ)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}

;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js


;
var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, (0,tslib_es6.__spreadArray)([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), config.options), { headers: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, http), config.http);
    });
    if (options.headers) {
        options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    }
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = printer(query, print);
    return {
        options: options,
        body: body,
    };
}
;
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = { originalName: name, value: headers[name] };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map

/***/ }),

/***/ 11037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ selectURI; }
/* harmony export */ });
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=selectURI.js.map

/***/ }),

/***/ 15049:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ serializeFetchParameter; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = __DEV__ ? new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(24);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map

/***/ }),

/***/ 16261:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ fromError; }
/* harmony export */ });
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48216);

function fromError(errorValue) {
    return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map

/***/ }),

/***/ 12782:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throwServerError; }
/* harmony export */ });
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map

/***/ }),

/***/ 85317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getApolloContext; }
/* harmony export */ });
/* unused harmony export resetApolloContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30320);


var contextKey = _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
function getApolloContext() {
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext[contextKey];
    if (!context) {
        Object.defineProperty(react__WEBPACK_IMPORTED_MODULE_0__.createContext, contextKey, {
            value: context = react__WEBPACK_IMPORTED_MODULE_0__.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}

//# sourceMappingURL=ApolloContext.js.map

/***/ }),

/***/ 66252:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useApolloClient; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85317);



function useApolloClient(override) {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)((0,_context_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getApolloContext */ .K)());
    var client = override || context.client;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 32);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map

/***/ }),

/***/ 73359:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useLazyQuery; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14012);
/* harmony import */ var _useQuery_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37887);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66252);





var EAGER_METHODS = [
    'refetch',
    'reobserve',
    'fetchMore',
    'updateQuery',
    'startPolling',
    'subscribeToMore',
];
function useLazyQuery(query, options) {
    var _a;
    var execOptionsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var optionsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var queryRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var merged = execOptionsRef.current ? (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .mergeOptions */ .J)(options, execOptionsRef.current) : options;
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    optionsRef.current = merged;
    queryRef.current = document;
    var internalState = (0,_useQuery_js__WEBPACK_IMPORTED_MODULE_2__/* .useInternalState */ .A)((0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_3__/* .useApolloClient */ .x)(options && options.client), document);
    var useQueryResult = internalState.useQuery((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, merged), { skip: !execOptionsRef.current }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy ||
        internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current,
    });
    var eagerMethods = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var eagerMethods = {};
        var _loop_1 = function (key) {
            var method = result[key];
            eagerMethods[key] = function () {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    internalState.forceUpdate();
                }
                return method.apply(this, arguments);
            };
        };
        for (var _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++) {
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (executeOptions) {
        execOptionsRef.current = executeOptions ? (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, executeOptions), { fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy }) : {
            fetchPolicy: initialFetchPolicy,
        };
        var options = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .mergeOptions */ .J)(optionsRef.current, (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({ query: queryRef.current }, execOptionsRef.current));
        var promise = internalState
            .executeQuery((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, options), { skip: false }))
            .then(function (queryResult) { return Object.assign(queryResult, eagerMethods); });
        promise.catch(function () { });
        return promise;
    }, []);
    return [execute, result];
}
//# sourceMappingURL=useLazyQuery.js.map

/***/ }),

/***/ 37887:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ useInternalState; },
  "a": function() { return /* binding */ useQuery; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(48964);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useSyncExternalStore.js



var didWarnUncachedGetSnapshot = false;
var uSESKey = "useSyncExternalStore";
var realHook = react_namespaceObject[uSESKey];
var useSyncExternalStore = realHook || (function (subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (__DEV__ &&
        !didWarnUncachedGetSnapshot &&
        value !== getSnapshot()) {
        didWarnUncachedGetSnapshot = true;
        __DEV__ && globals/* invariant.error */.kG.error('The result of getSnapshot should be cached to avoid an infinite loop');
    }
    var _a = react.useState({ inst: { value: value, getSnapshot: getSnapshot } }), inst = _a[0].inst, forceUpdate = _a[1];
    if (canUse/* canUseLayoutEffect */.JC) {
        react.useLayoutEffect(function () {
            Object.assign(inst, { value: value, getSnapshot: getSnapshot });
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        }, [subscribe, value, getSnapshot]);
    }
    else {
        Object.assign(inst, { value: value, getSnapshot: getSnapshot });
    }
    react.useEffect(function () {
        if (checkIfSnapshotChanged(inst)) {
            forceUpdate({ inst: inst });
        }
        return subscribe(function handleStoreChange() {
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        });
    }, [subscribe]);
    return value;
});
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    }
    catch (_b) {
        return true;
    }
}
//# sourceMappingURL=useSyncExternalStore.js.map
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/index.js
var lib = __webpack_require__(30020);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js
var ApolloContext = __webpack_require__(85317);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(1644);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(14692);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(10542);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(53712);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js












var useQuery_hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState((0,useApolloClient/* useApolloClient */.x)(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = (0,react.useRef)();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query, stateRef.current);
    }
    var state = stateRef.current;
    var _a = (0,react.useState)(0), _tick = _a[0], setTick = _a[1];
    state.forceUpdate = function () {
        setTick(function (tick) { return tick + 1; });
    };
    return state;
}
var InternalState = (function () {
    function InternalState(client, query, previous) {
        this.client = client;
        this.query = query;
        this.ssrDisabledResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.loading */.I.loading,
        });
        this.skipStandbyResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.ready */.I.ready,
        });
        this.toQueryResultCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        (0,parser/* verifyDocumentType */.Vp)(query, parser/* DocumentType.Query */.n_.Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) {
            this.previousData = previousData;
        }
    }
    InternalState.prototype.forceUpdate = function () {
        __DEV__ && globals/* invariant.warn */.kG.warn("Calling default no-op implementation of InternalState#forceUpdate");
    };
    InternalState.prototype.executeQuery = function (options) {
        var _this = this;
        var _a;
        if (options.query) {
            Object.assign(this, { query: options.query });
        }
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function (resolve) {
            var result;
            concast.subscribe({
                next: function (value) {
                    result = value;
                },
                error: function () {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function () {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        this.renderPromises = (0,react.useContext)((0,ApolloContext/* getApolloContext */.K)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = useSyncExternalStore((0,react.useCallback)(function () {
            if (_this.renderPromises) {
                return function () { };
            }
            var onNext = function () {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    (0,lib/* equal */.D)(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                }
                finally {
                    obsQuery["last"] = last;
                }
                if (!useQuery_hasOwnProperty.call(error, 'graphQLErrors')) {
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !(0,lib/* equal */.D)(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: networkStatus/* NetworkStatus.error */.I.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function () { return setTimeout(function () { return subscription.unsubscribe(); }); };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0,lib/* equal */.D)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false &&
            !this.queryHookOptions.skip) {
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === 'standby') {
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.getObsQueryOptions = function () {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) {
            toMerge.push(this.queryHookOptions.defaultOptions);
        }
        toMerge.push((0,compact/* compact */.o)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce(mergeOptions/* mergeOptions */.J);
    };
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        var _b;
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, otherOptions = (0,tslib_es6.__rest)(_a, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
        var watchQueryOptions = Object.assign(otherOptions, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === 'network-only' ||
                watchQueryOptions.fetchPolicy === 'cache-and-network')) {
            watchQueryOptions.fetchPolicy = 'cache-first';
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: 'standby',
            });
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy =
                ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) ||
                    this.getDefaultFetchPolicy();
        }
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function () {
        var _a, _b;
        return (((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
            "cache-first");
    };
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        var obsQuery = this.observable =
            this.renderPromises
                && this.renderPromises.getSSRObservable(this.watchQueryOptions)
                || this.observable
                || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = (0,react.useMemo)(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false ||
            this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) {
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            Promise.resolve().then(function () {
                if (error_1) {
                    _this.onError(error_1);
                }
                else if (result.data) {
                    _this.onCompleted(result.data);
                }
            }).catch(function (error) {
                __DEV__ && globals/* invariant.warn */.kG.warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function (result) {
        return (0,arrays/* isNonEmptyArray */.O)(result.errors)
            ? new errors/* ApolloError */.cA({ graphQLErrors: result.errors })
            : result.error;
    };
    InternalState.prototype.getCurrentResult = function () {
        if (!this.result) {
            this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0,tslib_es6.__rest)(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, queryResult = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData }));
        if (!queryResult.error && (0,arrays/* isNonEmptyArray */.O)(result.errors)) {
            queryResult.error = new errors/* ApolloError */.cA({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== 'cache-only') {
            Object.assign(result, {
                loading: true,
                networkStatus: networkStatus/* NetworkStatus.refetch */.I.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());
//# sourceMappingURL=useQuery.js.map

/***/ }),

/***/ 14692:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vp": function() { return /* binding */ verifyDocumentType; },
/* harmony export */   "n_": function() { return /* binding */ DocumentType; }
/* harmony export */ });
/* unused harmony exports operationName, parser */
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, 33);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 34);
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, 35);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, 36);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operation.type === type, 37);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21436:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ isNonEmptyArray; },
/* harmony export */   "k": function() { return /* binding */ isArray; }
/* harmony export */ });
var isArray = Array.isArray;
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 30320:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ canUseAsyncIteratorSymbol; },
/* harmony export */   "JC": function() { return /* binding */ canUseLayoutEffect; },
/* harmony export */   "aS": function() { return /* binding */ canUseSymbol; },
/* harmony export */   "mr": function() { return /* binding */ canUseWeakMap; },
/* harmony export */   "sy": function() { return /* binding */ canUseWeakSet; }
/* harmony export */ });
/* unused harmony export canUseDOM */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);

var canUseWeakMap = typeof WeakMap === 'function' &&
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.product; }) !== 'ReactNative';
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return window.document.createElement; }) === "function";
var usingJSDOM = (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
var canUseLayoutEffect = canUseDOM && !usingJSDOM;
//# sourceMappingURL=canUse.js.map

/***/ }),

/***/ 79487:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ cloneDeep; }
/* harmony export */ });
var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),

/***/ 53712:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ compact; }
/* harmony export */ });
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map

/***/ }),

/***/ 37280:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* binding */ isExecutionPatchIncrementalResult; },
/* harmony export */   "M0": function() { return /* binding */ isExecutionPatchResult; },
/* harmony export */   "mT": function() { return /* binding */ mergeIncrementalData; },
/* harmony export */   "yU": function() { return /* binding */ isApolloPayloadResult; }
/* harmony export */ });
/* unused harmony export isExecutionPatchInitialResult */
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13154);
/* harmony import */ var _arrays_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21436);
/* harmony import */ var _mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(182);



function isExecutionPatchIncrementalResult(value) {
    return "incremental" in value;
}
function isExecutionPatchInitialResult(value) {
    return "hasNext" in value && "data" in value;
}
function isExecutionPatchResult(value) {
    return (isExecutionPatchIncrementalResult(value) ||
        isExecutionPatchInitialResult(value));
}
function isApolloPayloadResult(value) {
    return (0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(value) && "payload" in value;
}
function mergeIncrementalData(prevResult, result) {
    var mergedData = prevResult;
    var merger = new _mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__/* .DeepMerger */ .w0();
    if (isExecutionPatchIncrementalResult(result) &&
        (0,_arrays_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonEmptyArray */ .O)(result.incremental)) {
        result.incremental.forEach(function (_a) {
            var data = _a.data, path = _a.path;
            for (var i = path.length - 1; i >= 0; --i) {
                var key = path[i];
                var isNumericKey = !isNaN(+key);
                var parent_1 = isNumericKey ? [] : {};
                parent_1[key] = data;
                data = parent_1;
            }
            mergedData = merger.merge(mergedData, data);
        });
    }
    return mergedData;
}
//# sourceMappingURL=incrementalResult.js.map

/***/ }),

/***/ 60897:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ makeUniqueId; }
/* harmony export */ });
var prefixCounts = new Map();
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map

/***/ }),

/***/ 10542:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ maybeDeepFreeze; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13154);


function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (__DEV__) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),

/***/ 182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ mergeDeep; },
/* harmony export */   "bw": function() { return /* binding */ mergeDeepArray; },
/* harmony export */   "w0": function() { return /* binding */ DeepMerger; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13154);


var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = _objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(source) && (0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([target, source, sourceKey], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map

/***/ }),

/***/ 14012:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mergeOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _compact_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53712);


function mergeOptions(defaults, options) {
    return (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaults, options, options.variables && {
        variables: (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, (defaults && defaults.variables)), options.variables),
    });
}
//# sourceMappingURL=mergeOptions.js.map

/***/ }),

/***/ 13154:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isNonNullObject; }
/* harmony export */ });
function isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}
//# sourceMappingURL=objects.js.map

/***/ }),

/***/ 48964:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Rk": function() { return /* reexport */ DEV; },
  "ej": function() { return /* reexport */ invariant/* InvariantError */.ej; },
  "kG": function() { return /* reexport */ invariant/* invariant */.kG; },
  "wY": function() { return /* reexport */ maybe; }
});

// UNUSED EXPORTS: checkDEV, global

// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(66128);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || maybe(function () { return maybe.constructor("return this")(); }));
//# sourceMappingURL=global.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/DEV.js


var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
    try {
        return Boolean(__DEV__);
    }
    catch (_a) {
        Object.defineProperty(globals_global, GLOBAL_KEY, {
            value: maybe(function () { return "production"; }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true,
        });
        return globals_global[GLOBAL_KEY];
    }
}
/* harmony default export */ var DEV = (getDEV());
//# sourceMappingURL=DEV.js.map
;// CONCATENATED MODULE: ./node_modules/ts-invariant/process/index.js
/* provided dependency */ var process = __webpack_require__(83454);
function process_maybe(thunk) {
  try { return thunk() } catch (_) {}
}

var safeGlobal = (
  process_maybe(function() { return globalThis }) ||
  process_maybe(function() { return window }) ||
  process_maybe(function() { return self }) ||
  process_maybe(function() { return global }) ||
  // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  process_maybe(function() { return process_maybe.constructor("return this")() })
);

var needToRemove = false;

function install() {
  if (safeGlobal &&
      !process_maybe(function() { return "production" }) &&
      !process_maybe(function() { return process })) {
    Object.defineProperty(safeGlobal, "process", {
      value: {
        env: {
          // This default needs to be "production" instead of "development", to
          // avoid the problem https://github.com/graphql/graphql-js/pull/2894
          // will eventually solve, once merged and released.
          NODE_ENV: "production",
        },
      },
      // Let anyone else change global.process as they see fit, but hide it from
      // Object.keys(global) enumeration.
      configurable: true,
      enumerable: false,
      writable: true,
    });
    needToRemove = true;
  }
}

// Call install() at least once, when this module is imported.
install();

function remove() {
  if (needToRemove) {
    delete safeGlobal.process;
    needToRemove = false;
  }
}

// EXTERNAL MODULE: ./node_modules/graphql/language/source.mjs + 2 modules
var source = __webpack_require__(56887);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/fix-graphql.js


function removeTemporaryGlobals() {
    return typeof source/* Source */.H === "function" ? remove() : remove();
}
//# sourceMappingURL=fix-graphql.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/index.js



function checkDEV() {
    __DEV__ ? (0,invariant/* invariant */.kG)("boolean" === typeof DEV, DEV) : (0,invariant/* invariant */.kG)("boolean" === typeof DEV, 39);
}

removeTemporaryGlobals();



checkDEV();
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 19065:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ hasDirectives; },
/* harmony export */   "LZ": function() { return /* binding */ shouldInclude; },
/* harmony export */   "mj": function() { return /* binding */ hasClientExports; }
/* harmony export */ });
/* unused harmony exports getDirectiveNames, hasAnyDirectives, hasAllDirectives, getInclusionDirectives */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77304);


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(evaledValue !== void 0, 40);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    visit(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
var hasAnyDirectives = function (names, root) { return hasDirectives(names, root, false); };
var hasAllDirectives = function (names, root) { return hasDirectives(names, root, true); };
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .visit */ .Vn)(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) &&
                (!all || !nameSet.size)) {
                return graphql__WEBPACK_IMPORTED_MODULE_1__/* .BREAK */ .$_;
            }
        },
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(['client', 'export'], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(directiveArguments && directiveArguments.length === 1, 41);
            var ifArgument = directiveArguments[0];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifArgument.name && ifArgument.name.value === 'if', 42);
            var ifValue = ifArgument.value;
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 43);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map

/***/ }),

/***/ 23361:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ createFragmentMap; },
/* harmony export */   "Yk": function() { return /* binding */ getFragmentQueryDocument; },
/* harmony export */   "hi": function() { return /* binding */ getFragmentFromSelection; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);


function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(44);
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragments.length === 1, 45);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, document), { definitions: (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread': {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragment, "No fragment named ".concat(fragmentName)) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragment, 46);
            return fragment || null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 36765:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ getOperationDefinition; },
/* harmony export */   "A$": function() { return /* binding */ checkDocument; },
/* harmony export */   "O4": function() { return /* binding */ getDefaultValues; },
/* harmony export */   "iW": function() { return /* binding */ getQueryDefinition; },
/* harmony export */   "kU": function() { return /* binding */ getFragmentDefinitions; },
/* harmony export */   "p$": function() { return /* binding */ getMainDefinition; },
/* harmony export */   "pD": function() { return /* binding */ getFragmentDefinition; },
/* harmony export */   "rY": function() { return /* binding */ getOperationName; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51761);


function checkDocument(doc) {
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc && doc.kind === 'Document', 47);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(48);
        }
        return definition;
    });
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operations.length <= 1, 49);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && !!definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queryDef && queryDef.operation === 'query', 50);
    return queryDef;
}
function getFragmentDefinition(doc) {
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.kind === 'Document', 51);
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.definitions.length <= 1, 52);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragmentDef.kind === 'FragmentDefinition', 53);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(54);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                (0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .valueToObjectRepresentation */ .vb)(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),

/***/ 51761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": function() { return /* binding */ isInlineFragment; },
/* harmony export */   "JW": function() { return /* binding */ isDocumentNode; },
/* harmony export */   "My": function() { return /* binding */ isField; },
/* harmony export */   "NC": function() { return /* binding */ argumentsObjectFromField; },
/* harmony export */   "PT": function() { return /* binding */ getStoreKeyName; },
/* harmony export */   "Yk": function() { return /* binding */ isReference; },
/* harmony export */   "kQ": function() { return /* binding */ makeReference; },
/* harmony export */   "qw": function() { return /* binding */ getTypenameFromResult; },
/* harmony export */   "u2": function() { return /* binding */ resultKeyNameFromField; },
/* harmony export */   "vb": function() { return /* binding */ valueToObjectRepresentation; },
/* harmony export */   "vf": function() { return /* binding */ storeKeyNameFromField; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var _common_objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13154);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23361);



function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function isDocumentNode(value) {
    return ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(55);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat(stringify(filteredArgs_1), ")");
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(stringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = stringify;
        stringify = s;
        return previous;
    },
});
var stringify = function defaultStringify(value) {
    return JSON.stringify(value, stringifyReplacer);
};
function stringifyReplacer(_key, value) {
    if ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) && !Array.isArray(value)) {
        value = Object.keys(value).sort().reduce(function (copy, key) {
            copy[key] = value[key];
            return copy;
        }, {});
    }
    return value;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    var fragments;
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (isField(selection)) {
            if (selection.name.value === '__typename') {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else if (fragments) {
            fragments.push(selection);
        }
        else {
            fragments = [selection];
        }
    }
    if (typeof result.__typename === 'string') {
        return result.__typename;
    }
    if (fragments) {
        for (var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++) {
            var selection = fragments_1[_b];
            var typename = getTypenameFromResult(result, (0,_fragments_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentFromSelection */ .hi)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') {
                return typename;
            }
        }
    }
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),

/***/ 76487:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ removeConnectionDirectiveFromDocument; },
/* harmony export */   "Gw": function() { return /* binding */ addTypenameToDocument; },
/* harmony export */   "aL": function() { return /* binding */ buildQueryFromSelectionSet; },
/* harmony export */   "ob": function() { return /* binding */ removeClientSetsFromDocument; }
/* harmony export */ });
/* unused harmony exports removeDirectivesFromDocument, removeArgumentsFromDocument, removeFragmentSpreadFromDocument */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48964);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97359);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77304);
/* harmony import */ var _getFromAST_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36765);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51761);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23361);
/* harmony import */ var _common_arrays_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21436);







var TYPENAME_FIELD = {
    kind: graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FIELD */ .h.FIELD,
    name: {
        kind: graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.NAME */ .h.NAME,
        value: '__typename',
    },
};
function isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function (selection) { return selection.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_SPREAD */ .h.FRAGMENT_SPREAD &&
        isEmpty(fragmentMap[selection.name.value], fragmentMap); });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty((0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getOperationDefinition */ .$H)(doc) || (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentDefinition */ .pD)(doc), (0,_fragments_js__WEBPACK_IMPORTED_MODULE_3__/* .createFragmentMap */ .F)((0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentDefinitions */ .kU)(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    var nameSet = new Set();
    var tests = [];
    directives.forEach(function (directive) {
        if (directive.name) {
            nameSet.add(directive.name);
        }
        else if (directive.test) {
            tests.push(directive.test);
        }
    });
    return function (directive) { return (nameSet.has(directive.name.value) ||
        tests.some(function (test) { return test(directive); })); };
}
function makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) { key = defaultKey; }
        var inUse = map.get(key);
        if (!inUse) {
            map.set(key, inUse = {
                variables: new Set,
                fragmentSpreads: new Set,
            });
        }
        return inUse;
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var getInUseByOperationName = makeInUseGetterFunction("");
    var getInUseByFragmentName = makeInUseGetterFunction("");
    var getInUse = function (ancestors) {
        for (var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p) {
            if ((0,_common_arrays_js__WEBPACK_IMPORTED_MODULE_4__/* .isArray */ .k)(ancestor))
                continue;
            if (ancestor.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
                return getInUseByOperationName(ancestor.name && ancestor.name.value);
            }
            if (ancestor.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION) {
                return getInUseByFragmentName(ancestor.name.value);
            }
        }
        __DEV__ && _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error("Could not find operation or fragment");
        return null;
    };
    var operationCount = 0;
    for (var i = doc.definitions.length - 1; i >= 0; --i) {
        if (doc.definitions[i].kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
            ++operationCount;
        }
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var hasRemoveDirective = directives.some(function (directive) { return directive.remove; });
    var shouldRemoveField = function (nodeDirectives) { return (hasRemoveDirective &&
        nodeDirectives &&
        nodeDirectives.some(directiveMatcher)); };
    var originalFragmentDefsByPath = new Map();
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function (node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        },
    };
    var docWithoutDirectiveSubtrees = (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(doc, {
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function () {
                return false;
            },
        },
        Variable: {
            enter: function (node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.variables.add(node.name.value);
                }
            },
        },
        FragmentSpread: {
            enter: function (node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.fragmentSpreads.add(node.name.value);
                }
            },
        },
        FragmentDefinition: {
            enter: function (node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function (node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) {
                    return node;
                }
                if (operationCount > 0 &&
                    node.selectionSet.selections.every(function (selection) { return (selection.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FIELD */ .h.FIELD &&
                        selection.name.value === '__typename'); })) {
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
        Directive: {
            leave: function (node) {
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
    });
    if (!firstVisitMadeChanges) {
        return doc;
    }
    var populateTransitiveVars = function (inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) {
                inUse.fragmentSpreads.forEach(function (childFragmentName) {
                    populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function (varName) {
                        inUse.transitiveVars.add(varName);
                    });
                });
            }
        }
        return inUse;
    };
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function (def) {
        if (def.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
            populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function (childFragmentName) {
                allFragmentNamesUsed.add(childFragmentName);
            });
        }
        else if (def.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION &&
            operationCount === 0 &&
            !getInUseByFragmentName(def.name.value).removed) {
            allFragmentNamesUsed.add(def.name.value);
        }
    });
    allFragmentNamesUsed.forEach(function (fragmentName) {
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function (childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function (fragmentName) { return !!(!allFragmentNamesUsed.has(fragmentName) ||
        getInUseByFragmentName(fragmentName).removed); };
    var enterVisitor = {
        enter: function (node) {
            if (fragmentWillBeRemoved(node.name.value)) {
                return null;
            }
        },
    };
    return nullIfDocIsEmpty((0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(docWithoutDirectiveSubtrees, {
        FragmentSpread: enterVisitor,
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function (node) {
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    if (usedVariableNames_1.size < node.variableDefinitions.length) {
                        return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) { return usedVariableNames_1.has(varDef.variable.name.value); }) });
                    }
                }
            },
        },
    }));
}
var addTypenameToDocument = Object.assign(function (doc) {
    return (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return ((0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .isField */ .My)(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if ((0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .isField */ .My)(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { selections: (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__spreadArray)([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                __DEV__ && _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .checkDocument */ .A$)(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === Kind.VARIABLE &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(visit(doc, {
        OperationDefinition: {
            enter: function (node) {
                return __assign(__assign({}, node), { variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) : [] });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(visit(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function buildQueryFromSelectionSet(document) {
    var definition = (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getMainDefinition */ .p$)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .checkDocument */ .A$)(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map

/***/ }),

/***/ 18263:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ iterateObserversSafely; }
/* harmony export */ });
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map

/***/ }),

/***/ 86403:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ fixObservableSubclass; }
/* harmony export */ });
/* harmony import */ var _Observable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48216);
/* harmony import */ var _common_canUse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30320);


function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: _Observable_js__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y });
    }
    if (_common_canUse_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 32716:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ RichTextNodeType; }
/* harmony export */ });
const RichTextNodeType = {
  heading1: "heading1",
  heading2: "heading2",
  heading3: "heading3",
  heading4: "heading4",
  heading5: "heading5",
  heading6: "heading6",
  paragraph: "paragraph",
  preformatted: "preformatted",
  strong: "strong",
  em: "em",
  listItem: "list-item",
  oListItem: "o-list-item",
  list: "group-list-item",
  oList: "group-o-list-item",
  image: "image",
  embed: "embed",
  hyperlink: "hyperlink",
  label: "label",
  span: "span"
};

//# sourceMappingURL=richText.js.map


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 88029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 70093:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g7": function() { return /* reexport */ Slot; }
});

// UNUSED EXPORTS: asyncFromGen, bind, noContext, setTimeout, wrapYieldingFiberMethods

;// CONCATENATED MODULE: ./node_modules/@wry/context/lib/slot.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const MISSING_VALUE = {};
let idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const makeSlotClass = () => class Slot {
    constructor() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    hasValue() {
        for (let context = currentContext; context; context = context.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    }
    getValue() {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    }
    withValue(value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        const slots = {
            __proto__: null,
            [this.id]: value,
        };
        const parent = currentContext;
        currentContext = { parent, slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    }
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    static bind(callback) {
        const context = currentContext;
        return function () {
            const saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    }
    // Immediately run a callback function without any captured context.
    static noContext(callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            const saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    }
};
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const globalKey = "@wry/context:Slot";
const host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(() => globalThis) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(() => global) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const globalHost = host;
const Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());
//# sourceMappingURL=slot.js.map
;// CONCATENATED MODULE: ./node_modules/@wry/context/lib/index.js


const { bind, noContext } = Slot;
// Like global.setTimeout, except the callback runs with captured context.

function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        const gen = genFn.apply(this, arguments);
        const boundNext = bind(gen.next);
        const boundThrow = bind(gen.throw);
        return new Promise((resolve, reject) => {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            const invokeNext = (value) => invoke(boundNext, value);
            const invokeThrow = (error) => invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method) => {
            const fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 30020:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ equal; }
/* harmony export */ });
const { toString, hasOwnProperty } = Object.prototype;
const fnToStr = Function.prototype.toString;
const previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
// Allow default imports as well.
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (equal)));
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = toString.call(a);
    const bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            const aKeys = definedKeys(a);
            const bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            const keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (let k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (let k = 0; k < keyCount; ++k) {
                const key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            const aIterator = a.entries();
            const isMap = aTag === '[object Map]';
            while (true) {
                const info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                const [aKey, aValue] = info.value;
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            let len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            const aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
const nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 75028:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Trie; }
/* harmony export */ });
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, key => node = node.getChildTrie(key));
        return hasOwnProperty.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = this.weakness && isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
}
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 90512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (clsx)));

/***/ }),

/***/ 25821:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ inspect; }
/* harmony export */ });
/* harmony import */ var _nodejsCustomInspectSymbol_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45695);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable flowtype/no-weak-types */

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 45695:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ __webpack_exports__["Z"] = (nodejsCustomInspectSymbol);


/***/ }),

/***/ 29749:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ye": function() { return /* binding */ Location; },
  "WU": function() { return /* binding */ Token; },
  "UG": function() { return /* binding */ isNode; }
});

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
var nodejsCustomInspectSymbol = __webpack_require__(45695);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/defineInspect.mjs


/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || invariant(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (nodejsCustomInspectSymbol/* default */.Z) {
    classObject.prototype[nodejsCustomInspectSymbol/* default */.Z] = fn;
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/ast.mjs


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */


/***/ }),

/***/ 87392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "W7": function() { return /* binding */ dedentBlockStringValue; }
/* harmony export */ });
/* unused harmony export getBlockStringIndentation */
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),

/***/ 97359:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */


/***/ }),

/***/ 56887:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Source; },
  "T": function() { return /* binding */ isSource; }
});

// EXTERNAL MODULE: ./node_modules/graphql/polyfills/symbols.mjs
var symbols = __webpack_require__(99763);
// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/instanceOf.mjs
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
/* harmony default export */ var instanceOf = ( true ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
0);

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || devAssert(0, "Body must be a string. Received: ".concat((0,inspect/* default */.Z)(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || devAssert(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  _createClass(Source, [{
    key: symbols/* SYMBOL_TO_STRING_TAG */.YF,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return instanceOf(source, Source);
}


/***/ }),

/***/ 77304:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports QueryDocumentKeys, visitInParallel, getVisitFn */
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25821);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29749);


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!(0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node)) {
        throw new Error("Invalid AST Node: ".concat((0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}


/***/ }),

/***/ 99763:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YF": function() { return /* binding */ SYMBOL_TO_STRING_TAG; }
/* harmony export */ });
/* unused harmony exports SYMBOL_ITERATOR, SYMBOL_ASYNC_ITERATOR */
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';


/***/ }),

/***/ 87536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gc": function() { return /* binding */ useFormContext; },
/* harmony export */   "Qr": function() { return /* binding */ Controller; },
/* harmony export */   "RV": function() { return /* binding */ FormProvider; },
/* harmony export */   "cI": function() { return /* binding */ useForm; },
/* harmony export */   "qo": function() { return /* binding */ useWatch; }
/* harmony export */ });
/* unused harmony exports Form, appendErrors, get, set, useController, useFieldArray, useFormState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    copy[key] = cloneObject(data[key]);
                }
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (object, path, defaultValue) => {
    if (!path || !isObject(object)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object
        ? isUndefined(object[path])
            ? defaultValue
            : object[path]
        : result;
};

var isBoolean = (value) => typeof value === 'boolean';

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => !name ||
    !signalName ||
    name === signalName ||
    convertToArrayPayload(name).some((currentName) => currentName &&
        (exact
            ? currentName === signalName
            : currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._formState);
    const _mounted = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
    const _localProxyFormState = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._getWatch(name, defaultValue));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._removeUnmounted());
    return value;
}

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

var set = (object, path, value) => {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control.register(name, {
        ...props.rules,
        value,
        ...(isBoolean(props.disabled) ? { disabled: props.disabled } : {}),
    }));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value);
            if (isUndefined(get(control._formValues, name))) {
                set(control._formValues, name, value);
            }
        }
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (get(control._fields, name)) {
            control._updateDisabledField({
                disabled,
                fields: control._fields,
                name,
                value: get(control._fields, name)._f.value,
            });
        }
    }, [disabled, name, control]);
    return {
        field: {
            name,
            value,
            ...(isBoolean(disabled) || formState.disabled
                ? { disabled: formState.disabled || disabled }
                : {}),
            onChange: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */
function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = React.useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = async (event) => {
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data) => {
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            }
            catch (_a) { }
            for (const name of control._names.mount) {
                formData.append(name, get(data, name));
            }
            if (onSubmit) {
                await onSubmit({
                    data,
                    event,
                    method,
                    formData,
                    formDataJson,
                });
            }
            if (action) {
                try {
                    const shouldStringifySubmissionData = [
                        headers && headers['Content-Type'],
                        encType,
                    ].some((value) => value && value.includes('json'));
                    const response = await fetch(action, {
                        method,
                        headers: {
                            ...headers,
                            ...(encType ? { 'Content-Type': encType } : {}),
                        },
                        body: shouldStringifySubmissionData ? formDataJson : formData,
                    });
                    if (response &&
                        (validateStatus
                            ? !validateStatus(response.status)
                            : response.status < 200 || response.status >= 300)) {
                        hasError = true;
                        onError && onError({ response });
                        type = String(response.status);
                    }
                    else {
                        onSuccess && onSuccess({ response });
                    }
                }
                catch (error) {
                    hasError = true;
                    onError && onError({ error });
                }
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false,
            });
            props.control.setError('root.server', {
                type,
            });
        }
    };
    React.useEffect(() => {
        setMounted(true);
    }, []);
    return render ? (React.createElement(React.Fragment, null, render({
        submit,
    }))) : (React.createElement("form", { noValidate: mounted, action: action, method: method, encType: encType, onSubmit: submit, ...rest }, children));
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
                    break;
                }
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
                    break;
                }
                else {
                    iterateFieldsByAction(currentField, action);
                }
            }
            else if (isObject(currentField)) {
                iterateFieldsByAction(currentField, action);
            }
        }
    }
};

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

var appendAt = (data, value) => [
    ...data,
    ...convertToArrayPayload(value),
];

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

var prependAt = (data, value) => [
    ...convertToArrayPayload(value),
    ...convertToArrayPayload(data),
];

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    [data[indexA], data[indexB]] = [data[indexB], data[indexA]];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName, }) => {
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._state.action = false;
        isWatched(name, control._names) &&
            control._subjects.state.next({
                ...control._formState,
            });
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError
                        ? (!error && existingError.type) ||
                            (error &&
                                (existingError.type !== error.type ||
                                    existingError.message !== error.message))
                        : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                if (field && field._f) {
                    validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.values.next({
            name,
            values: { ...control._formValues },
        });
        control._names.focus &&
            iterateFieldsByAction(control._fields, (ref, key) => {
                if (control._names.focus &&
                    key.startsWith(control._names.focus) &&
                    ref.focus) {
                    ref.focus();
                    return 1;
                }
                return;
            });
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend, [updateValues, name, control]),
        append: React.useCallback(append, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

var createSubject = () => {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
};

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false,
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values)
        ? cloneObject(_options.defaultValues || _options.values) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const _setErrors = (errors) => {
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        const disabledField = !!(get(_fields, name) && get(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField ||
                    (_proxyFormState.dirtyFields &&
                        isPreviousDirty !== !isCurrentFieldPristine);
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema(names);
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.values.next({
                            name,
                            values: { ..._formValues },
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: { ..._formValues },
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState });
        _subjects.values.next({
            name,
            values: { ..._formValues },
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue) => {
            isFieldValueUpdated =
                Number.isNaN(fieldValue) ||
                    fieldValue === get(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.values.next({
                    name,
                    type: event.type,
                    values: { ..._formValues },
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            }
            else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key) => {
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_state.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.values.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: { ..._formValues },
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields, value, }) => {
        if (isBoolean(disabled)) {
            const inputValue = disabled
                ? undefined
                : isUndefined(value)
                    ? getFieldValue(field ? field._f : get(fields, name)._f)
                    : value;
            set(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        if (field) {
            _updateDisabledField({
                field,
                disabled: options.disabled,
                name,
                value: options.value,
            });
        }
        else {
            updateValidAndValue(name, true, options.value);
        }
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.progressive
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled) => {
        if (isBoolean(disabled)) {
            _subjects.state.next({ disabled });
            iterateFieldsByAction(_fields, (ref, name) => {
                let requiredDisabledState = disabled;
                const currentField = get(_fields, name);
                if (currentField && isBoolean(currentField._f.disabled)) {
                    requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                }
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            await onValid(fieldValues, e);
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors),
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, cloneObject(get(_defaultValues, name)));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, cloneObject(get(_defaultValues, name)))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneObject(values);
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.values.next({
                values: { ...values },
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful
                ? _formState.isSubmitSuccessful
                : false,
            isSubmitting: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _disableForm,
            _subjects,
            _proxyFormState,
            _setErrors,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const _values = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) {
                control._subjects.state.next({
                    isDirty,
                });
            }
        }
    }, [control, formState.isDirty]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state) => ({ ...state }));
        }
        else {
            control._resetDefaultValues();
        }
    }, [props.values, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.errors) {
            control._setErrors(props.errors);
        }
    }, [props.errors, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ }),

/***/ 66128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U6": function() { return /* binding */ setVerbosity; },
/* harmony export */   "ej": function() { return /* binding */ InvariantError; },
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* harmony default export */ __webpack_exports__["ZP"] = (invariant);
//# sourceMappingURL=invariant.js.map

/***/ }),

/***/ 48216:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ Observable; }
/* harmony export */ });
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);